import { jsxs as I, jsx as u, Fragment as ko } from "react/jsx-runtime";
import * as Z from "react";
import R, { useCallback as me, createContext as tn, useMemo as Se, createElement as F, useContext as Xe, useRef as de, useEffect as Ce, useState as we, useLayoutEffect as i2, Children as ir, cloneElement as cd, useReducer as My, forwardRef as Y, isValidElement as ya, Fragment as ur, useImperativeHandle as $y } from "react";
import * as ud from "react-dom";
import _a, { flushSync as s2, createPortal as l2 } from "react-dom";
function K() {
  return K = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K.apply(this, arguments);
}
function Py(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Hs(...e) {
  return (t) => e.forEach(
    (n) => Py(n, t)
  );
}
function De(...e) {
  return me(Hs(...e), e);
}
function Ty(e, t) {
  const n = /* @__PURE__ */ tn(t);
  function r(a) {
    const { children: i, ...s } = a, l = Se(
      () => s,
      Object.values(s)
    );
    return /* @__PURE__ */ F(n.Provider, {
      value: l
    }, i);
  }
  function o(a) {
    const i = Xe(n);
    if (i)
      return i;
    if (t !== void 0)
      return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [
    r,
    o
  ];
}
function gt(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = /* @__PURE__ */ tn(i), l = n.length;
    n = [
      ...n,
      i
    ];
    function c(f) {
      const { scope: p, children: m, ...h } = f, g = (p == null ? void 0 : p[e][l]) || s, x = Se(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ F(g.Provider, {
        value: x
      }, m);
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][l]) || s, h = Xe(m);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return c.displayName = a + "Provider", [
      c,
      d
    ];
  }
  const o = () => {
    const a = n.map((i) => /* @__PURE__ */ tn(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return Se(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    Oy(o, ...t)
  ];
}
function Oy(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(a) {
      const i = r.reduce((s, { useScope: l, scopeName: c }) => {
        const f = l(a)[`__scope${c}`];
        return {
          ...s,
          ...f
        };
      }, {});
      return Se(
        () => ({
          [`__scope${t.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function ve(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function lt(e) {
  const t = de(e);
  return Ce(() => {
    t.current = e;
  }), Se(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function wt({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Ny({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = lt(n), l = me((c) => {
    if (a) {
      const f = typeof c == "function" ? c(e) : c;
      f !== e && s(f);
    } else
      o(c);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    l
  ];
}
function Ny({ defaultProp: e, onChange: t }) {
  const n = we(e), [r] = n, o = de(r), a = lt(t);
  return Ce(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function Us(e) {
  const t = de({
    value: e,
    previous: e
  });
  return Se(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const Mt = globalThis != null && globalThis.document ? i2 : () => {
};
function dd(e) {
  const [t, n] = we(void 0);
  return Mt(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({
          width: i,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
function ky(e, t) {
  return My((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Bt = (e) => {
  const { present: t, children: n } = e, r = Dy(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : ir.only(n), a = De(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ cd(o, {
    ref: a
  }) : null;
};
Bt.displayName = "Presence";
function Dy(e) {
  const [t, n] = we(), r = de({}), o = de(e), a = de("none"), i = e ? "mounted" : "unmounted", [s, l] = ky(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ce(() => {
    const c = yi(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [
    s
  ]), Mt(() => {
    const c = r.current, d = o.current;
    if (d !== e) {
      const p = a.current, m = yi(c);
      e ? l("MOUNT") : m === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(d && p !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), Mt(() => {
    if (t) {
      const c = (f) => {
        const m = yi(r.current).includes(f.animationName);
        f.target === t && m && s2(
          () => l("ANIMATION_END")
        );
      }, d = (f) => {
        f.target === t && (a.current = yi(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: me((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function yi(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const $n = /* @__PURE__ */ Y((e, t) => {
  const { children: n, ...r } = e, o = ir.toArray(n), a = o.find(Fy);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? ir.count(i) > 1 ? ir.only(null) : /* @__PURE__ */ ya(i) ? i.props.children : null : l);
    return /* @__PURE__ */ F(Fc, K({}, r, {
      ref: t
    }), /* @__PURE__ */ ya(i) ? /* @__PURE__ */ cd(i, void 0, s) : null);
  }
  return /* @__PURE__ */ F(Fc, K({}, r, {
    ref: t
  }), n);
});
$n.displayName = "Slot";
const Fc = /* @__PURE__ */ Y((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ ya(n) ? /* @__PURE__ */ cd(n, {
    ...Ry(r, n.props),
    ref: t ? Hs(t, n.ref) : n.ref
  }) : ir.count(n) > 1 ? ir.only(null) : null;
});
Fc.displayName = "SlotClone";
const fd = ({ children: e }) => /* @__PURE__ */ F(ur, null, e);
function Fy(e) {
  return /* @__PURE__ */ ya(e) && e.type === fd;
}
function Ry(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...a
    } : r === "className" && (n[r] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const _y = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ee = _y.reduce((e, t) => {
  const n = /* @__PURE__ */ Y((r, o) => {
    const { asChild: a, ...i } = r, s = a ? $n : t;
    return Ce(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ F(s, K({}, i, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function os(e, t) {
  e && s2(
    () => e.dispatchEvent(t)
  );
}
const c2 = "Checkbox", [Iy, ZV] = gt(c2), [Ly, By] = Iy(c2), zy = /* @__PURE__ */ Y((e, t) => {
  const { __scopeCheckbox: n, name: r, checked: o, defaultChecked: a, required: i, disabled: s, value: l = "on", onCheckedChange: c, ...d } = e, [f, p] = we(null), m = De(
    t,
    (v) => p(v)
  ), h = de(!1), g = f ? !!f.closest("form") : !0, [x = !1, y] = wt({
    prop: o,
    defaultProp: a,
    onChange: c
  }), b = de(x);
  return Ce(() => {
    const v = f == null ? void 0 : f.form;
    if (v) {
      const A = () => y(b.current);
      return v.addEventListener("reset", A), () => v.removeEventListener("reset", A);
    }
  }, [
    f,
    y
  ]), /* @__PURE__ */ F(Ly, {
    scope: n,
    state: x,
    disabled: s
  }, /* @__PURE__ */ F(Ee.button, K({
    type: "button",
    role: "checkbox",
    "aria-checked": Nr(x) ? "mixed" : x,
    "aria-required": i,
    "data-state": u2(x),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: l
  }, d, {
    ref: m,
    onKeyDown: ve(e.onKeyDown, (v) => {
      v.key === "Enter" && v.preventDefault();
    }),
    onClick: ve(e.onClick, (v) => {
      y(
        (A) => Nr(A) ? !0 : !A
      ), g && (h.current = v.isPropagationStopped(), h.current || v.stopPropagation());
    })
  })), g && /* @__PURE__ */ F(Vy, {
    control: f,
    bubbles: !h.current,
    name: r,
    value: l,
    checked: x,
    required: i,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), Wy = "CheckboxIndicator", jy = /* @__PURE__ */ Y((e, t) => {
  const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = By(Wy, n);
  return /* @__PURE__ */ F(Bt, {
    present: r || Nr(a.state) || a.state === !0
  }, /* @__PURE__ */ F(Ee.span, K({
    "data-state": u2(a.state),
    "data-disabled": a.disabled ? "" : void 0
  }, o, {
    ref: t,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), Vy = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = de(null), i = Us(n), s = dd(t);
  return Ce(() => {
    const l = a.current, c = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (i !== n && f) {
      const p = new Event("click", {
        bubbles: r
      });
      l.indeterminate = Nr(n), f.call(l, Nr(n) ? !1 : n), l.dispatchEvent(p);
    }
  }, [
    i,
    n,
    r
  ]), /* @__PURE__ */ F("input", K({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: Nr(n) ? !1 : n
  }, o, {
    tabIndex: -1,
    ref: a,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Nr(e) {
  return e === "indeterminate";
}
function u2(e) {
  return Nr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const d2 = zy, Hy = jy;
function f2(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = f2(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function p2() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = f2(e)) && (r && (r += " "), r += t);
  return r;
}
function Uy() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = h2(t)) && (r && (r += " "), r += n);
  return r;
}
function h2(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = h2(e[r])) && (n && (n += " "), n += t);
  return n;
}
var pd = "-";
function Yy(e) {
  var t = Xy(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function a(s) {
    var l = s.split(pd);
    return l[0] === "" && l.length !== 1 && l.shift(), m2(l, t) || Gy(s);
  }
  function i(s, l) {
    var c = n[s] || [];
    return l && o[s] ? [].concat(c, o[s]) : c;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: i
  };
}
function m2(e, t) {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), o = r ? m2(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length !== 0) {
    var a = e.join(pd);
    return (i = t.validators.find(function(s) {
      var l = s.validator;
      return l(a);
    })) == null ? void 0 : i.classGroupId;
  }
}
var V0 = /^\[(.+)\]$/;
function Gy(e) {
  if (V0.test(e)) {
    var t = V0.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function Xy(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = Ky(Object.entries(e.classGroups), n);
  return o.forEach(function(a) {
    var i = a[0], s = a[1];
    Rc(s, r, i, t);
  }), r;
}
function Rc(e, t, n, r) {
  e.forEach(function(o) {
    if (typeof o == "string") {
      var a = o === "" ? t : H0(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (qy(o)) {
        Rc(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(i) {
      var s = i[0], l = i[1];
      Rc(l, H0(t, s), n, r);
    });
  });
}
function H0(e, t) {
  var n = e;
  return t.split(pd).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function qy(e) {
  return e.isThemeGetter;
}
function Ky(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], o = n[1], a = o.map(function(i) {
      return typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(function(s) {
        var l = s[0], c = s[1];
        return [t + l, c];
      })) : i;
    });
    return [r, a];
  }) : e;
}
function Qy(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(a, i) {
    n.set(a, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set: function(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}
var g2 = "!";
function Zy(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], o = t.length;
  return function(i) {
    for (var s = [], l = 0, c = 0, d, f = 0; f < i.length; f++) {
      var p = i[f];
      if (l === 0) {
        if (p === r && (n || i.slice(f, f + o) === t)) {
          s.push(i.slice(c, f)), c = f + o;
          continue;
        }
        if (p === "/") {
          d = f;
          continue;
        }
      }
      p === "[" ? l++ : p === "]" && l--;
    }
    var m = s.length === 0 ? i : i.substring(c), h = m.startsWith(g2), g = h ? m.substring(1) : m, x = d && d > c ? d - c : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: g,
      maybePostfixModifierPosition: x
    };
  };
}
function Jy(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var o = r[0] === "[";
    o ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function eb(e) {
  return {
    cache: Qy(e.cacheSize),
    splitModifiers: Zy(e),
    ...Yy(e)
  };
}
var tb = /\s+/;
function nb(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, o = t.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return e.trim().split(tb).map(function(i) {
    var s = n(i), l = s.modifiers, c = s.hasImportantModifier, d = s.baseClassName, f = s.maybePostfixModifierPosition, p = r(f ? d.substring(0, f) : d), m = !!f;
    if (!p) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (p = r(d), !p)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      m = !1;
    }
    var h = Jy(l).join(":"), g = c ? h + g2 : h;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: p,
      originalClassName: i,
      hasPostfixModifier: m
    };
  }).reverse().filter(function(i) {
    if (!i.isTailwindClass)
      return !0;
    var s = i.modifierId, l = i.classGroupId, c = i.hasPostfixModifier, d = s + l;
    return a.has(d) ? !1 : (a.add(d), o(l, c).forEach(function(f) {
      return a.add(s + f);
    }), !0);
  }).reverse().map(function(i) {
    return i.originalClassName;
  }).join(" ");
}
function rb() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o, a, i = s;
  function s(c) {
    var d = t[0], f = t.slice(1), p = f.reduce(function(m, h) {
      return h(m);
    }, d());
    return r = eb(p), o = r.cache.get, a = r.cache.set, i = l, l(c);
  }
  function l(c) {
    var d = o(c);
    if (d)
      return d;
    var f = nb(c, r);
    return a(c, f), f;
  }
  return function() {
    return i(Uy.apply(null, arguments));
  };
}
function Je(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var v2 = /^\[(?:([a-z-]+):)?(.+)\]$/i, ob = /^\d+\/\d+$/, ab = /* @__PURE__ */ new Set(["px", "full", "screen"]), ib = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, sb = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, lb = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function sn(e) {
  return Tr(e) || ab.has(e) || ob.test(e) || _c(e);
}
function _c(e) {
  return jr(e, "length", hb);
}
function cb(e) {
  return jr(e, "size", y2);
}
function ub(e) {
  return jr(e, "position", y2);
}
function db(e) {
  return jr(e, "url", mb);
}
function bi(e) {
  return jr(e, "number", Tr);
}
function Tr(e) {
  return !Number.isNaN(Number(e));
}
function fb(e) {
  return e.endsWith("%") && Tr(e.slice(0, -1));
}
function Qo(e) {
  return U0(e) || jr(e, "number", U0);
}
function _e(e) {
  return v2.test(e);
}
function Zo() {
  return !0;
}
function Zn(e) {
  return ib.test(e);
}
function pb(e) {
  return jr(e, "", gb);
}
function jr(e, t, n) {
  var r = v2.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function hb(e) {
  return sb.test(e);
}
function y2() {
  return !1;
}
function mb(e) {
  return e.startsWith("url(");
}
function U0(e) {
  return Number.isInteger(Number(e));
}
function gb(e) {
  return lb.test(e);
}
function vb() {
  var e = Je("colors"), t = Je("spacing"), n = Je("blur"), r = Je("brightness"), o = Je("borderColor"), a = Je("borderRadius"), i = Je("borderSpacing"), s = Je("borderWidth"), l = Je("contrast"), c = Je("grayscale"), d = Je("hueRotate"), f = Je("invert"), p = Je("gap"), m = Je("gradientColorStops"), h = Je("gradientColorStopPositions"), g = Je("inset"), x = Je("margin"), y = Je("opacity"), b = Je("padding"), v = Je("saturate"), A = Je("scale"), w = Je("sepia"), M = Je("skew"), $ = Je("space"), P = Je("translate"), E = function() {
    return ["auto", "contain", "none"];
  }, T = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, B = function() {
    return ["auto", _e, t];
  }, j = function() {
    return [_e, t];
  }, V = function() {
    return ["", sn];
  }, W = function() {
    return ["auto", Tr, _e];
  }, S = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, _ = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, U = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, z = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, N = function() {
    return ["", "0", _e];
  }, O = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, k = function() {
    return [Tr, bi];
  }, Q = function() {
    return [Tr, _e];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Zo],
      spacing: [sn],
      blur: ["none", "", Zn, _e],
      brightness: k(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Zn, _e],
      borderSpacing: j(),
      borderWidth: V(),
      contrast: k(),
      grayscale: N(),
      hueRotate: Q(),
      invert: N(),
      gap: j(),
      gradientColorStops: [e],
      gradientColorStopPositions: [fb, _c],
      inset: B(),
      margin: B(),
      opacity: k(),
      padding: j(),
      saturate: k(),
      scale: k(),
      sepia: N(),
      skew: Q(),
      space: j(),
      translate: j()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", _e]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Zn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": O()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": O()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(S(), [_e])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Qo]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: B()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", _e]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: N()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: N()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Qo]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Zo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Qo]
        }, _e]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": W()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": W()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Zo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Qo]
        }, _e]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": W()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": W()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", _e]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", _e]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(z())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(z(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(z(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [x]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [x]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [x]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [x]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [x]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [x]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [x]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [x]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [x]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [$]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [$]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", _e, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", _e, sn]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Zn]
        }, Zn, _e]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [_e, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", _e, sn]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [_e, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Zn, _c]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", bi]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Zo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", _e]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Tr, bi]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", _e, sn]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", _e]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", _e]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(_(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", sn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", _e, sn]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: j()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", _e]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", _e]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(S(), [ub])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", cb]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, db]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(_(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: _()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(_())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [_e, sn]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [sn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: V()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [sn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Zn, pb]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Zo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": U()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Zn, _e]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [v]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [w]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [v]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [w]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", _e]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Q()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", _e]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Q()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", _e]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [A]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [A]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [A]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Qo, _e]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [P]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [P]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", _e]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", _e]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": j()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": j()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": j()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": j()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": j()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": j()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": j()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": j()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": j()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": j()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": j()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": j()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": j()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": j()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": j()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": j()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": j()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": j()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", _e]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [sn, bi]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var yb = /* @__PURE__ */ rb(vb);
function le(...e) {
  return yb(p2(e));
}
const bb = (e) => e.charAt(0).toUpperCase() + e.slice(1), xb = (e) => typeof e == "number" && e > 1 ? "s" : "", Y0 = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, G0 = p2, nt = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return G0(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((c) => {
    const d = n == null ? void 0 : n[c], f = a == null ? void 0 : a[c];
    if (d === null)
      return null;
    const p = Y0(d) || Y0(f);
    return o[c][p];
  }), s = n && Object.entries(n).reduce((c, d) => {
    let [f, p] = d;
    return p === void 0 || (c[f] = p), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, d) => {
    let { class: f, className: p, ...m } = d;
    return Object.entries(m).every((h) => {
      let [g, x] = h;
      return Array.isArray(x) ? x.includes({
        ...a,
        ...s
      }[g]) : {
        ...a,
        ...s
      }[g] === x;
    }) ? [
      ...c,
      f,
      p
    ] : c;
  }, []);
  return G0(e, i, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, wb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u("path", { fill: "currentColor", d: "M10.667 5.333a1.333 1.333 0 1 1 2.666 0v13.334a1.333 1.333 0 0 1-2.666 0z" }),
  /* @__PURE__ */ u("path", { fill: "currentColor", d: "M5.333 13.333a1.333 1.333 0 1 1 0-2.666h13.334a1.333 1.333 0 0 1 0 2.666z" })
] }), JV = wb, Ab = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u("rect", { width: 15, height: 13, x: 4.5, y: 6.5, stroke: "currentColor", rx: 0.5 }),
  /* @__PURE__ */ u("path", { stroke: "currentColor", d: "M5 9.5h14.5M8 6V4M16 6V4" }),
  /* @__PURE__ */ u("path", { fill: "currentColor", stroke: "currentColor", d: "M7.5 12.5h2v2h-2z" })
] }), eH = Ab, Cb = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    d: "m8.795 15.875-3.47-3.47a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 1 0-1.41-1.41z"
  }
) }), Ys = Cb, Sb = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m3.88-11.71L10 14.17l-1.88-1.88a.996.996 0 1 0-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7a.996.996 0 0 0 0-1.41c-.39-.39-1.03-.39-1.42 0"
  }
) }), Eb = Sb, Mb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.01 14.5a.785.785 0 0 1-.566-.244l-3.2-3.326A.848.848 0 0 1 8 10.339a.85.85 0 0 1 .234-.595.785.785 0 0 1 .573-.244c.215.002.42.093.568.254l3.2 3.326c.15.156.235.368.235.588 0 .22-.085.432-.235.588a.785.785 0 0 1-.565.244"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.01 14.5a.785.785 0 0 1-.566-.244.849.849 0 0 1-.234-.588c0-.22.084-.431.234-.587l3.2-3.327a.779.779 0 0 1 .768-.204.817.817 0 0 1 .56.582.855.855 0 0 1-.197.798l-3.2 3.326a.785.785 0 0 1-.565.244"
    }
  )
] }), Ia = Mb, $b = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M9.5 12.01c0-.212.088-.416.244-.566l3.326-3.2A.848.848 0 0 1 13.661 8a.85.85 0 0 1 .596.234.785.785 0 0 1 .243.573.787.787 0 0 1-.254.568l-3.326 3.2a.849.849 0 0 1-.588.235.848.848 0 0 1-.588-.235.785.785 0 0 1-.244-.565"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M9.5 12.01c0-.212.088-.416.244-.566a.848.848 0 0 1 .588-.234c.22 0 .431.084.587.234l3.327 3.2c.204.203.282.495.204.768a.817.817 0 0 1-.582.56.855.855 0 0 1-.798-.197l-3.326-3.2a.785.785 0 0 1-.244-.565"
    }
  )
] }), tH = $b, Pb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 28 28", ...e, children: [
  /* @__PURE__ */ u("rect", { width: 27, height: 27, x: -0.5, y: 0.5, stroke: "currentColor", rx: 13.5, transform: "matrix(-1 0 0 1 27 0)" }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M11.5 13.99c0 .212.088.416.244.566l3.326 3.2a.847.847 0 0 0 .591.244.85.85 0 0 0 .595-.234.785.785 0 0 0 .244-.573.787.787 0 0 0-.254-.569l-3.326-3.2a.848.848 0 0 0-.588-.234.849.849 0 0 0-.588.235.785.785 0 0 0-.244.565"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M11.5 13.99c0 .212.088.416.243.566.156.15.368.234.588.234.221 0 .433-.084.588-.234l3.327-3.2a.779.779 0 0 0 .204-.768.816.816 0 0 0-.582-.56.855.855 0 0 0-.798.197l-3.326 3.2a.785.785 0 0 0-.244.565"
    }
  )
] }), Tb = Pb, Ob = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M14.5 11.99a.785.785 0 0 1-.244.566l-3.326 3.2a.847.847 0 0 1-.591.244.85.85 0 0 1-.595-.234.785.785 0 0 1-.244-.573.786.786 0 0 1 .254-.569l3.326-3.2a.848.848 0 0 1 .588-.234c.22 0 .432.085.588.235.156.15.244.353.244.565"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M14.5 11.99a.785.785 0 0 1-.243.566.849.849 0 0 1-.588.234.848.848 0 0 1-.588-.234l-3.327-3.2c-.204-.203-.282-.495-.204-.767a.817.817 0 0 1 .582-.56.855.855 0 0 1 .798.196l3.326 3.2c.156.15.244.353.244.565"
    }
  )
] }), hd = Ob, Nb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 28 28", ...e, children: [
  /* @__PURE__ */ u("rect", { width: 27, height: 27, x: 0.5, y: 0.5, stroke: "currentColor", rx: 13.5 }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M16.5 13.99a.785.785 0 0 1-.244.566l-3.326 3.2a.847.847 0 0 1-.591.244.85.85 0 0 1-.596-.234.785.785 0 0 1-.243-.573.787.787 0 0 1 .254-.569l3.326-3.2a.848.848 0 0 1 .588-.234c.22 0 .432.085.588.235.156.15.244.353.244.565"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M16.5 13.99a.785.785 0 0 1-.244.566.849.849 0 0 1-.588.234.848.848 0 0 1-.587-.234l-3.327-3.2a.779.779 0 0 1-.204-.768.817.817 0 0 1 .582-.56.855.855 0 0 1 .798.197l3.326 3.2c.156.15.244.353.244.565"
    }
  )
] }), kb = Nb, Db = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M11.99 9.5c.212 0 .416.088.566.244l3.2 3.326a.848.848 0 0 1 .244.591.85.85 0 0 1-.234.596.785.785 0 0 1-.573.243.787.787 0 0 1-.569-.254l-3.2-3.326a.849.849 0 0 1-.234-.588c0-.22.085-.432.235-.588a.785.785 0 0 1 .565-.244"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M11.99 9.5c.212 0 .416.088.566.244.15.156.234.367.234.588 0 .22-.084.431-.234.587l-3.2 3.327c-.203.204-.495.282-.767.204a.817.817 0 0 1-.56-.582.855.855 0 0 1 .196-.798l3.2-3.326a.785.785 0 0 1 .565-.244"
    }
  )
] }), Fb = Db, Rb = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    d: "M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12 5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
  }
) }), _b = Rb, Ib = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M5.235 12.012c0-.265.115-.52.318-.707l4.345-4c.202-.193.48-.303.772-.305.291-.002.571.103.777.293.206.19.32.447.318.716a.964.964 0 0 1-.331.71l-4.345 4c-.203.188-.48.293-.768.293-.288 0-.564-.105-.768-.293a.961.961 0 0 1-.318-.707"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M5.235 12.012c0-.265.115-.52.318-.707.204-.187.48-.292.768-.292.288 0 .564.105.768.293l4.345 4a.945.945 0 0 1 .266.959c-.102.34-.39.606-.76.7-.37.093-.766 0-1.042-.246l-4.345-4a.961.961 0 0 1-.318-.707M12.235 12.012c0-.265.114-.52.318-.707l4.345-4c.202-.193.48-.303.771-.305.292-.002.572.103.778.293a.96.96 0 0 1 .318.716.964.964 0 0 1-.331.71l-4.345 4c-.204.188-.48.293-.768.293-.288 0-.564-.105-.768-.293a.962.962 0 0 1-.318-.707"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.235 12.012c0-.265.114-.52.318-.707.204-.187.48-.292.768-.292.288 0 .564.105.768.293l4.344 4c.267.253.368.618.267.959-.102.34-.39.606-.76.7-.37.093-.767 0-1.042-.246l-4.345-4a.962.962 0 0 1-.318-.707"
    }
  )
] }), Lb = Ib, Bb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u("rect", { width: 10, height: 1.6, x: 7, y: 8, fill: "currentColor", rx: 0.8 }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M9 12a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H9.8A.8.8 0 0 1 9 12M11 15.2a.8.8 0 0 1 .8-.8h.4a.8.8 0 0 1 0 1.6h-.4a.8.8 0 0 1-.8-.8"
    }
  )
] }), zb = Bb, Wb = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 25", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.002 6.209a1.44 1.44 0 0 1 1.131-.55h3.734c.527 0 .91.274 1.13.55.196.244.336.575.336.916v.09h3.2c.31 0 .726.077 1.057.409.332.331.41.747.41 1.057v9.867H4V8.68c0-.31.078-.726.41-1.057.331-.332.747-.41 1.057-.41h3.2v-.089c0-.34.14-.672.335-.916m-.335 3.005H6v2.667h2.667zm2 2.667V9.214h2.666v2.667zm-2 2H6v2.667h2.667zm2 2.667V13.88h2.666v2.667zm4.666 0H18V13.88h-2.667zm0-4.667H18V9.214h-2.667z",
    clipRule: "evenodd"
  }
) }), nH = Wb, jb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: 1.5,
      d: "M12.286 4.68A3.847 3.847 0 0 0 9.36 5.707 3.884 3.884 0 0 0 8.127 8.54c0 .872.287 1.698.83 2.389.395.503.95 1.105 1.284 1.664l.004.655c0 .215.175.39.391.39l2.89-.041a.392.392 0 0 0 .39-.391l-.004-.622c.353-.585.773-1.199 1.131-1.654.571-.722.865-1.63.826-2.554-.08-1.935-1.653-3.559-3.583-3.697Z"
    }
  ),
  /* @__PURE__ */ u("path", { stroke: "currentColor", strokeWidth: 0.613, d: "M9.935 15.962h4.288v.613H9.935z" }),
  /* @__PURE__ */ u("path", { stroke: "currentColor", d: "M11.354 18.606h1.45v.225h-1.45z" })
] }), rH = jb, Vb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.015 17c-.319 0-.624-.124-.849-.343l-4.8-4.686A1.158 1.158 0 0 1 6 11.139a1.158 1.158 0 0 1 .351-.84c.228-.221.538-.345.86-.342.321.003.629.131.852.357l4.8 4.686a1.157 1.157 0 0 1 0 1.657c-.225.22-.53.343-.848.343"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.015 17c-.318 0-.623-.124-.849-.343a1.157 1.157 0 0 1-.35-.828c0-.311.125-.609.35-.829l4.8-4.685a1.22 1.22 0 0 1 1.151-.288c.41.11.728.421.84.82.112.4 0 .826-.294 1.124l-4.8 4.686c-.225.22-.53.343-.848.343"
    }
  ),
  /* @__PURE__ */ u("rect", { width: 2, height: 16, x: 20, y: 18, fill: "currentColor", rx: 1, transform: "rotate(90 20 18)" }),
  /* @__PURE__ */ u("path", { fill: "currentColor", d: "M11 5a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0z" })
] }), oH = Vb, Hb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8c.4 0 .8-.03 1.19-.09-.02-.02-.02-.04-.03-.06l-.62-1.88c-.17.02-.36.03-.54.03-3.31 0-6-2.68-6-6s2.69-6 6-6 6 2.69 6 6c0 .18-.01.37-.03.54l1.88.62s.04 0 .06.03c.06-.39.09-.79.09-1.19 0-4.41-3.58-8-8-8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 10a2 2 0 0 1 1.81 1.15l2.18.73A3.992 3.992 0 0 0 12 8c-2.17 0-4 1.79-4 4s1.73 3.93 3.88 3.99l-.72-2.17A2.012 2.012 0 0 1 10 12c0-1.1.9-2 2-2",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "m19.97 18.37-2.63-2.62 2.03-1.07.07-.03s.07-.04.07-.11a.12.12 0 0 0-.09-.11l-.17-.06-7.08-2.36a.137.137 0 0 0-.13.03c-.05.05-.04.1-.03.12l2.42 7.28s.08.07.11.07c.07 0 .09-.03.11-.07l1.1-2.1 2.62 2.63s.13.04.17 0l1.45-1.45s.02-.11-.02-.15"
    }
  )
] }), aH = Hb, Ub = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1m-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m1-3h-2v-2h2z"
  }
) }), X0 = Ub, Yb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      d: "M4.5 12c0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5-4.14 0-7.5-3.36-7.5-7.5Z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.008 14a.628.628 0 0 1-.453-.195l-2.56-2.661a.68.68 0 0 1-.008-.95.628.628 0 0 1 .458-.194.63.63 0 0 1 .455.203l2.56 2.661a.679.679 0 0 1 0 .94.628.628 0 0 1-.452.196"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.008 14a.628.628 0 0 1-.453-.195.679.679 0 0 1-.187-.47c0-.177.067-.346.187-.47l2.56-2.662a.623.623 0 0 1 .614-.163c.218.062.388.239.448.466.06.226 0 .469-.157.638l-2.56 2.66a.628.628 0 0 1-.453.196"
    }
  )
] }), iH = Yb, Gb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      d: "M12 19.5c-4.14 0-7.5-3.36-7.5-7.5 0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5Z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M14 11.992c0 .17-.07.333-.195.453l-2.661 2.56a.68.68 0 0 1-.95.008.628.628 0 0 1-.194-.458.63.63 0 0 1 .203-.455l2.661-2.56a.679.679 0 0 1 .47-.188c.177 0 .346.068.471.188s.195.283.195.452"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M14 11.992c0 .17-.07.333-.195.453a.679.679 0 0 1-.47.187.679.679 0 0 1-.47-.187l-2.662-2.56c-.163-.163-.225-.396-.163-.614a.653.653 0 0 1 .466-.448c.226-.06.469 0 .638.157l2.661 2.56c.125.12.195.283.195.452"
    }
  )
] }), Xb = Gb, qb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M7 18.916v-6.172c0-.226-.22-.218-.44-.218H4.416c-.22 0-.415.161-.415.387v6.119c0 .226.195.426.415.426H6.56c.22-.023.44-.317.44-.542"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: 2,
      d: "m13.705 9.075-.436 1.314h5.309c.061.013.17.053.257.131a.44.44 0 0 1 .109.15c.022.048.044.12.053.223l-1.536 7.629c-.063.288-.326.478-.548.478h-4.781c-.343 0-.69-.028-1.037-.07h-.001l-1.059-.13-.04-.009-.205-.04a455.54 455.54 0 0 0-1.175-.233l.02-5.488A2.04 2.04 0 0 1 8.659 13a4.456 4.456 0 0 0 1.333-1.323 2.996 2.996 0 0 0 .09-.153l3.85-6.209.012-.02.012-.021a.717.717 0 0 1 .117-.16c.12-.111.3-.14.433-.086a.505.505 0 0 1 .272.372l.005.028v.036a1.15 1.15 0 0 1-.009.044l-.007.037-.01.046-.011.062-.227.74v.004L14.034 8l-.002.008-.003.008-.147.521zm1.034-3.294v-.017zm-6 7.123z"
    }
  )
] }), sH = qb, Kb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ I("g", { stroke: "currentColor", strokeWidth: 1.1, clipPath: "url(#a)", children: [
    /* @__PURE__ */ u("path", { d: "M12 14.44a2.442 2.442 0 1 1 0-4.883 2.442 2.442 0 0 1 0 4.884Zm0-3.906a1.466 1.466 0 1 0 0 2.93 1.466 1.466 0 0 0 0-2.93Z" }),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "currentColor",
        d: "M12 19a6.653 6.653 0 0 1-1.393-.143.483.483 0 0 1-.39-.43l-.17-1.752-1.302 1.127a.488.488 0 0 1-.58.032 6.784 6.784 0 0 1-1.954-1.953.488.488 0 0 1 0-.58l1.114-1.348-1.752-.15a.502.502 0 0 1-.436-.39 7.163 7.163 0 0 1 0-2.788.501.501 0 0 1 .436-.39l1.752-.19-1.127-1.302a.488.488 0 0 1 0-.58A6.785 6.785 0 0 1 8.152 6.21a.488.488 0 0 1 .58 0l1.315 1.113.15-1.752a.482.482 0 0 1 .39-.43 6.928 6.928 0 0 1 2.788 0 .482.482 0 0 1 .39.43l.19 1.752 1.302-1.126a.488.488 0 0 1 .58 0A6.785 6.785 0 0 1 17.79 8.15a.488.488 0 0 1-.033.58l-1.081 1.315 1.752.15a.502.502 0 0 1 .436.391c.183.92.183 1.867 0 2.787a.502.502 0 0 1-.436.391l-1.752.189 1.126 1.302a.488.488 0 0 1 .033.58 6.785 6.785 0 0 1-1.954 1.954.49.49 0 0 1-.58-.033l-1.347-1.081-.15 1.752a.482.482 0 0 1-.39.43A6.657 6.657 0 0 1 12 19Zm-.84-1.036a6.047 6.047 0 0 0 1.681 0l.15-1.7a.495.495 0 0 1 .319-.41c.162-.058.32-.126.475-.201a.488.488 0 0 1 .528.058l1.302 1.1c.451-.34.852-.74 1.192-1.19l-1.094-1.303a.488.488 0 0 1-.065-.534c.077-.152.144-.31.202-.47a.494.494 0 0 1 .41-.318l1.7-.15a6.046 6.046 0 0 0 0-1.68l-1.7-.15a.495.495 0 0 1-.41-.32 4.246 4.246 0 0 0-.202-.468.489.489 0 0 1 .065-.534l1.094-1.303A6.072 6.072 0 0 0 15.615 7.2l-1.302 1.094a.476.476 0 0 1-.528.065 4.96 4.96 0 0 0-.482-.215.494.494 0 0 1-.319-.41l-.15-1.7a6.048 6.048 0 0 0-1.68 0l-.15 1.7a.494.494 0 0 1-.319.41c-.162.059-.32.126-.475.202a.475.475 0 0 1-.527-.065L8.38 7.187c-.45.34-.852.74-1.192 1.191l1.094 1.303a.489.489 0 0 1 .066.534 4.236 4.236 0 0 0-.202.469.494.494 0 0 1-.41.319l-1.7.15a6.048 6.048 0 0 0 0 1.68l1.7.15a.495.495 0 0 1 .41.319c.057.16.125.316.202.469a.49.49 0 0 1-.066.534l-1.094 1.302c.34.45.741.852 1.192 1.192l1.303-1.1a.487.487 0 0 1 .527-.06c.155.076.313.144.475.203a.496.496 0 0 1 .32.41z"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "a", children: /* @__PURE__ */ u("path", { fill: "currentColor", d: "M4 4h16v16H4z" }) }) })
] }), lH = Kb, Qb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 25 25", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M18.086 12.399h-2.128l-.305.304c0 .202.102.507.102.81a4.066 4.066 0 0 1-4.054 4.055 4.066 4.066 0 0 1-4.054-4.055A4.066 4.066 0 0 1 11.7 9.46c.405 0 .71.102 1.013.102V7.128c-.304-.101-.608-.101-1.013-.101-3.548 0-6.487 2.94-6.487 6.487S8.154 20 11.701 20s6.486-2.94 6.486-6.486c0-.406 0-.71-.101-1.115"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "m20.214 9.155-2.23 2.23h-2.432l-3.344 3.345c-.406.405-1.115.405-1.622 0-.507-.406-.405-1.115 0-1.622l3.243-3.243V7.23L16.06 5v4.155z"
    }
  )
] }), cH = Qb, Zb = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m-1-4h2v2h-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47"
  }
) }), uH = Zb, Jb = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 25", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: 2,
      d: "M18.366 9.542c.392.266.634.72.634 1.214v7.294c0 .391-.152.762-.417 1.033-.265.27-.618.417-.983.417H6.4c-.364 0-.718-.148-.983-.417A1.477 1.477 0 0 1 5 18.05v-7.293c0-.496.243-.95.633-1.215h.001l5.6-3.805a1.365 1.365 0 0 1 1.533 0z"
    }
  ),
  /* @__PURE__ */ u("path", { stroke: "currentColor", strokeWidth: 2, d: "M10 15.5a2 2 0 1 1 4 0v4h-4z" })
] }), dH = Jb, e6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12.002 10.884c.411 0 .744.333.744.744v4.093a.744.744 0 1 1-1.488 0v-4.093c0-.411.333-.744.744-.744M12 9.395a.93.93 0 1 0 0-1.86.93.93 0 0 0 0 1.86"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-6.512a6.512 6.512 0 1 0 0 13.024 6.512 6.512 0 0 0 0-13.024",
      clipRule: "evenodd"
    }
  )
] }), La = e6, t6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M6.806 5.747h10a1 1 0 0 1 1 1v2a1 1 0 1 0 2 0v-3a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3a1 1 0 1 0 0-2h-2a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M10.806 8.747a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2h-3a1 1 0 0 1-1-1M7.806 13.747a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.806 8.747a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m17.477 15.1-1.853 1.854L14.27 15.6l.707-.707.647.646 1.146-1.146z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.806 13.747h-4v4h4zm-5-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z",
      clipRule: "evenodd"
    }
  )
] }), fH = t6, n6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u("g", { fill: "currentColor", clipPath: "url(#a)", children: /* @__PURE__ */ u("path", { d: "M12 8.5c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5M12 13.5c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5M12 18.5c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5" }) }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "a", children: /* @__PURE__ */ u("path", { fill: "currentColor", d: "M10.5 5.5h3v13h-3z" }) }) })
] }), r6 = n6, o6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      d: "M6.5 12.417c0-.785.636-1.42 1.42-1.42.14 0 .264.086.312.216l2.685 7.325c.256.698 1.242.705 1.507.01l2.818-7.378-.467-.178.467.178a.27.27 0 0 1 .253-.174c.885 0 1.603.717 1.603 1.602v5.575c0 .734-.595 1.328-1.328 1.328H7.828A1.328 1.328 0 0 1 6.5 18.173z"
    }
  ),
  /* @__PURE__ */ u("path", { fill: "currentColor", d: "m10.714 13.142 1.143 3.429L13 13.142l-1.143-1.714z" }),
  /* @__PURE__ */ u("circle", { cx: 11.857, cy: 7.429, r: 2.929, stroke: "currentColor" })
] }), pH = o6, a6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 25", ...e, children: [
  /* @__PURE__ */ u("circle", { cx: 11.994, cy: 7.429, r: 2.729, stroke: "currentColor", strokeWidth: 1.4 }),
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: 1.4,
      d: "M6.895 12.778c0-.674.547-1.22 1.22-1.22.056 0 .105.034.124.085l2.686 7.325c.32.872 1.55.88 1.881.013l2.819-7.378-.647-.247.646.247a.07.07 0 0 1 .066-.046c.775 0 1.403.628 1.403 1.403v5.574c0 .623-.505 1.128-1.128 1.128H8.023a1.128 1.128 0 0 1-1.128-1.128z"
    }
  ),
  /* @__PURE__ */ u("path", { fill: "currentColor", d: "m10.91 13.142 1.142 3.429 1.143-3.429-1.143-1.714z" })
] }), hH = a6, i6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M18.5 4h-6c-.83 0-1.5.67-1.5 1.5V6h4.5A2.5 2.5 0 0 1 18 8.5V11h.5c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M15.5 7h-6C8.67 7 8 7.67 8 8.5v1.94c.77 0 1.46.31 2 .8V9h5v3h-1.09c-.66 0-1.3.27-1.77.73l-.15.15V12H10.6c.28.48.44 1.03.44 1.63 0 .6-.17 1.16-.45 1.64.1.08.21.15.33.2.19.08.38.11.58.11.39 0 .77-.15 1.06-.44l1-1a.51.51 0 0 1 .35-.15h1.59c.83 0 1.5-.67 1.5-1.5V8.5c0-.83-.67-1.5-1.5-1.5"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M12 20H4v-1.15c0-.36.15-.69.46-.99.26-.26.62-.48 1.07-.67.91-.39 1.9-.53 2.48-.53.58 0 1.56.14 2.48.53.45.19.81.42 1.07.67.3.3.46.63.46.99V20zm-4-4.17c-1.13 0-2.05-.98-2.05-2.19s.92-2.19 2.05-2.19 2.05.98 2.05 2.19-.92 2.19-2.05 2.19"
    }
  )
] }), mH = i6, s6 = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12c0 .223-.01.444-.027.662l-1.322-.203a6.667 6.667 0 1 0-6.192 6.192l.203 1.322A8 8 0 1 1 20 12m-8 4h.051l-.206-1.338a2.667 2.667 0 1 1 2.817-2.817l1.338.206V12a4 4 0 1 0-4 4m0-4 2.781 8 .657-4.01a.673.673 0 0 1 .555-.557L20 14.777z",
    clipRule: "evenodd"
  }
) }), l6 = s6, c6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 25", ...e, children: [
  /* @__PURE__ */ u("g", { fill: "currentColor", clipPath: "url(#a)", children: /* @__PURE__ */ u("path", { d: "M12 9c.825 0 1.5-.675 1.5-1.5S12.825 6 12 6s-1.5.675-1.5 1.5S11.175 9 12 9M12 14c.825 0 1.5-.675 1.5-1.5S12.825 11 12 11s-1.5.675-1.5 1.5.675 1.5 1.5 1.5M12 19c.825 0 1.5-.675 1.5-1.5S12.825 16 12 16s-1.5.675-1.5 1.5.675 1.5 1.5 1.5" }) }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "a", children: /* @__PURE__ */ u("path", { fill: "currentColor", d: "M10.5 6h3v13h-3z" }) }) })
] }), u6 = c6, d6 = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 10.125c.775 0 1.625-.719 1.625-1.875 0-1.156-.85-1.875-1.625-1.875s-1.625.719-1.625 1.875c0 1.156.85 1.875 1.625 1.875m-5.107 7.438c-.018.037-.018.052-.018.062h10.25c0-.01 0-.025-.018-.062a.945.945 0 0 0-.19-.244c-.247-.245-.673-.522-1.279-.782-1.221-.524-2.72-.787-3.638-.787-.919 0-2.417.263-3.638.787-.607.26-1.032.537-1.278.782a.947.947 0 0 0-.19.244M5 19.5v-1.875c0-2.496 4.66-3.75 7-3.75s7 1.254 7 3.75V19.5zM15.5 8.25c0 2.068-1.57 3.75-3.5 3.75s-3.5-1.682-3.5-3.75S10.07 4.5 12 4.5s3.5 1.682 3.5 3.75",
    clipRule: "evenodd"
  }
) }), gH = d6, f6 = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.163 9.285a.522.522 0 0 0 0 .89l7.41 4.357a.47.47 0 0 0 .48 0l7.41-4.356a.522.522 0 0 0 0-.89l-7.41-4.357a.47.47 0 0 0-.48 0zm2.538.22a.261.261 0 0 0 .001.448l4.877 2.777a.47.47 0 0 0 .468 0l4.873-2.777c.17-.096.17-.35.002-.448L12.049 6.69a.47.47 0 0 0-.473 0zM4.287 14.56a.582.582 0 0 1-.107-.895.525.525 0 0 1 .65-.086l6.874 4.144a.47.47 0 0 0 .482.004l7.14-4.157a.523.523 0 0 1 .641.09.58.58 0 0 1-.113.896l-7.741 4.537a.326.326 0 0 1-.336-.003zm-.247-3.307a.685.685 0 0 0 .147 1.031l7.364 4.475a.341.341 0 0 0 .35.003l7.817-4.551a.635.635 0 0 0 .185-.914.576.576 0 0 0-.764-.168l-7.008 4.108a.448.448 0 0 1-.46-.002l-6.845-4.107a.619.619 0 0 0-.786.125",
    clipRule: "evenodd"
  }
) }), vH = f6, p6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "m13.31 6.739.773.92c1.612-.761 4.274-1.413 6.525.028-2.691-.103-4.726 1.861-4.847 1.973l.773.92-4.02.103z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m12.825 6.441.35-1.75H6.159c-.351 0-.745.053-1.051.289-.318.244-.5.65-.5 1.264v8.803c0 .52.083.928.353 1.198.27.27.68.354 1.198.354h1.156l-.008 1.409.002.066c.004.199.01.412.053.596.047.197.144.386.347.508l.008.006.01.004c.168.08.35.12.532.12.315 0 .611-.121.851-.329l2.54-2.38h6.022c.52 0 .928-.084 1.198-.354.27-.27.354-.679.354-1.198V10.77l-1.75.159v3.132a.79.79 0 0 1-.79.79h-5.113c-.314 0-.61.122-.85.33l-1.655 1.46v-1.79H7.147a.79.79 0 0 1-.79-.79V7.23a.79.79 0 0 1 .79-.79z",
      clipRule: "evenodd"
    }
  )
] }), yH = p6, h6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: 2,
      d: "M5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M15.912 11.342a.295.295 0 0 0-.139-.497l-2.33-.351c-.056 0-.083-.03-.111-.088L12.25 8.154c-.111-.205-.389-.205-.472 0l-1.054 2.222c-.028.059-.056.088-.111.088l-2.386.351c-.222.03-.306.322-.14.497l1.693 1.726a.23.23 0 0 1 .056.146L9.42 15.67c-.028.234.194.41.388.293l2.081-1.17c.056-.03.083-.03.139 0l2.136 1.17c.195.117.416-.059.389-.293l-.389-2.456c0-.06 0-.088.056-.147z"
    }
  )
] }), bH = h6, m6 = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 10H4V8a1 1 0 0 1 1-1h4V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h4a1 1 0 0 1 1 1zm0 1H4v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-2 2v5H6v-5zm-6-5a1 1 0 1 1 0-2 1 1 0 0 1 0 2",
    clipRule: "evenodd"
  }
) }), xH = m6, g6 = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    d: "m19.783 18.616-2.986-2.955c2.266-2.822 2.053-6.976-.533-9.558A7.103 7.103 0 0 0 11.198 4c-1.92 0-3.732.745-5.092 2.103A7.099 7.099 0 0 0 4 11.188c0 1.943.747 3.727 2.106 5.085 1.36 1.331 3.146 2.103 5.092 2.103 1.627 0 3.226-.56 4.48-1.57l2.959 2.954c.16.16.346.24.56.24.213 0 .426-.08.56-.24.32-.32.32-.825.026-1.144m-2.986-7.428a5.47 5.47 0 0 1-1.653 3.94c-1.066 1.038-2.453 1.65-3.946 1.65a5.486 5.486 0 0 1-3.945-1.65c-1.04-1.065-1.653-2.45-1.653-3.94a5.47 5.47 0 0 1 1.652-3.94c1.067-1.039 2.427-1.65 3.946-1.65 1.493 0 2.906.585 3.946 1.65s1.653 2.422 1.653 3.94"
  }
) }), v6 = g6, y6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      d: "M17.822 4.654v1.162c-1.667.437-4.042 1.608-4.813 4.074 1.928-1.749 4.654-1.558 4.813-1.55V9.5l3.04-2.421z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.914 5.309c-.946.006-2.256.422-3.398 1.309a6.62 6.62 0 0 1 1.855-1.015c.568-.198 1.11-.294 1.564-.294v.294c-.874 0-2.133.389-3.239 1.247l-.08.062H7.12a.36.36 0 0 0-.36.36v7.198c0 .2.16.36.36.36h2.257v1.605l1.428-1.261c.249-.216.559-.344.89-.344h5.241a.36.36 0 0 0 .36-.36v-3.358l1.898-1.78v5.793c0 .507-.08.939-.373 1.23-.291.292-.723.373-1.23.373h-5.78l-2.427 2.274a1.358 1.358 0 0 1-.89.344c-.19 0-.382-.043-.56-.127l-.013-.006-.012-.008a.847.847 0 0 1-.382-.555c-.045-.19-.05-.405-.055-.594l-.001-.071.007-1.257H6.464c-.507 0-.939-.08-1.23-.373-.292-.291-.373-.723-.373-1.23V6.618c0-.614.184-1.042.524-1.304.324-.249.733-.3 1.08-.3h10.47v.295z",
      clipRule: "evenodd"
    }
  )
] }), wH = y6, b6 = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    d: "M4.325 11.305a.953.953 0 0 0-.325.707c0 .265.117.52.325.707l4.435 4c.282.246.686.339 1.064.245.377-.093.672-.359.776-.7a.933.933 0 0 0-.272-.959l-3.651-3.293 3.651-3.293a.956.956 0 0 0 .339-.71.952.952 0 0 0-.325-.716A1.175 1.175 0 0 0 9.548 7a1.17 1.17 0 0 0-.788.305zM19.675 12.695a.953.953 0 0 0 .325-.707.953.953 0 0 0-.325-.707l-4.435-4a1.195 1.195 0 0 0-1.064-.245c-.377.093-.672.36-.776.7-.104.34 0 .705.272.959l3.651 3.293-3.651 3.293a.956.956 0 0 0-.338.71.952.952 0 0 0 .324.716c.21.19.497.295.794.293a1.17 1.17 0 0 0 .788-.305z"
  }
) }), x6 = b6, w6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u("rect", { width: 15, height: 15, x: 4.5, y: 4.041, stroke: "currentColor", rx: 1.5 }),
  /* @__PURE__ */ u("path", { stroke: "currentColor", strokeLinecap: "round", d: "M9 16v-6M12 16V8M15 15.541v-3" })
] }), A6 = w6, C6 = (e) => /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u(
  "path",
  {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M17.8 16.5c0-.461-.066-.889-.185-1.284.095.043.188.088.278.135.876.455 1.107.88 1.107 1.149v.5h-1.2zM11.4 9c0 1.168-.872 2-1.8 2s-1.8-.832-1.8-2c0-1.168.872-2 1.8-2s1.8.832 1.8 2ZM5 16.5c0-.158.066-.354.315-.6.258-.256.66-.508 1.177-.73 1.04-.446 2.306-.67 3.108-.67s2.068.224 3.108.67c.517.222.919.474 1.177.73.249.246.315.442.315.6v.5H5zM16.2 9c0 1.056-.712 1.837-1.535 1.977A5.972 5.972 0 0 0 15 9c0-.692-.118-1.36-.335-1.977.823.14 1.535.921 1.535 1.977Z"
  }
) }), AH = C6, S6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 23 23", ...e, children: [
  /* @__PURE__ */ u("rect", { width: 10, height: 1.6, x: 5, y: 9, fill: "#004F67", rx: 0.8 }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#004F67",
      d: "M7 13a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H7.8A.8.8 0 0 1 7 13M9 16.2a.8.8 0 0 1 .8-.8h.4a.8.8 0 0 1 0 1.6h-.4a.8.8 0 0 1-.8-.8"
    }
  ),
  /* @__PURE__ */ u("circle", { cx: 15, cy: 9, r: 3.5, fill: "#5CC461", stroke: "#F5F7F9" }),
  /* @__PURE__ */ u("path", { fill: "#fff", d: "m13.457 9.043 1.172 1.301 2.414-2.301L16.5 7.5l-1.871 1.758L14 8.5z" })
] }), E6 = S6, M6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 36 36", ...e, children: [
  /* @__PURE__ */ I("g", { filter: "url(#a)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#008EF0",
        d: "M26.464 18.342a1.54 1.54 0 0 1-1.539 1.543 1.54 1.54 0 0 1-1.538-1.543 1.54 1.54 0 0 1 1.538-1.542c.85 0 1.54.69 1.54 1.542M15.919 10.404a2.311 2.311 0 0 1-3.303-2.088 2.311 2.311 0 0 1 2.307-2.314 2.311 2.311 0 0 1 2.083 3.311l2.904 2.911a1.54 1.54 0 0 1 1.937 1.49 1.54 1.54 0 0 1-1.538 1.543 1.54 1.54 0 0 1-1.487-1.942z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#FFC200",
        d: "M12.606 13.708a1.54 1.54 0 0 1-1.539 1.542 1.54 1.54 0 0 1-1.538-1.542 1.54 1.54 0 0 1 1.538-1.543c.85 0 1.54.69 1.54 1.543M16.323 19.777a1.54 1.54 0 0 1-1.937-1.49 1.54 1.54 0 0 1 1.538-1.543 1.54 1.54 0 0 1 1.487 1.943l2.904 2.91a2.311 2.311 0 0 1 3.303 2.088 2.311 2.311 0 0 1-2.308 2.315 2.311 2.311 0 0 1-2.308-2.314c0-.357.08-.696.225-.998z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#EC3B64",
        d: "M17.234 22.967a1.54 1.54 0 0 1-1.54 1.543 1.54 1.54 0 0 1-1.538-1.543 1.54 1.54 0 0 1 1.539-1.542c.85 0 1.538.69 1.538 1.542M28.005 12.94a2.311 2.311 0 0 1-3.296 2.092l-2.91 2.916a1.54 1.54 0 0 1-1.489 1.934 1.54 1.54 0 0 1-1.538-1.542 1.54 1.54 0 0 1 1.946-1.488l2.899-2.907a2.31 2.31 0 0 1-.229-1.005 2.311 2.311 0 0 1 2.309-2.313 2.311 2.311 0 0 1 2.308 2.313"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#5CC461",
        d: "M21.844 9.083a1.54 1.54 0 0 1-1.539 1.542 1.54 1.54 0 0 1-1.538-1.542 1.54 1.54 0 0 1 1.538-1.543c.85 0 1.54.69 1.54 1.543M17.228 13.71a1.54 1.54 0 0 1-1.929 1.493L12.39 18.12c.142.3.221.636.221.99a2.311 2.311 0 0 1-2.308 2.314 2.311 2.311 0 0 1-2.308-2.314 2.311 2.311 0 0 1 3.31-2.084l2.9-2.906a1.54 1.54 0 0 1 1.484-1.95c.85-.001 1.539.69 1.539 1.541"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ I("filter", { id: "a", width: 40, height: 40, x: -2, y: -2, colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ u("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ u("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
    /* @__PURE__ */ u("feOffset", { dy: 2 }),
    /* @__PURE__ */ u("feGaussianBlur", { stdDeviation: 4 }),
    /* @__PURE__ */ u("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ u("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
    /* @__PURE__ */ u("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_864_105" }),
    /* @__PURE__ */ u("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_864_105", result: "shape" })
  ] }) })
] }), $6 = M6, P6 = (e) => /* @__PURE__ */ I(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ u("path", { fill: "#FD812D", d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16" }),
      /* @__PURE__ */ u(
        "mask",
        {
          id: "a",
          width: 16,
          height: 16,
          x: 4,
          y: 4,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ u("path", { fill: "#fff", d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16" })
        }
      ),
      /* @__PURE__ */ I("g", { mask: "url(#a)", children: [
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#008EF0",
            d: "M10.658 8.786a12.64 12.64 0 0 1 1.575-1.523l-.726-.428c-.091.331-.47.587-.637.884-.193.343-.285.787.05 1.069a.454.454 0 0 0 .453.062c.448-.183.693-.742 1.172-.866l-.474-.63c-.217.383-.784 1.192-.059 1.422.532.169.888-.478 1.34-.62l-.591-.6.002-.01c-.4.427.319.983.716.559a.583.583 0 0 0 .117-.19c.152-.39-.217-.718-.591-.6-.197.061-.37.168-.535.292-.08.061-.156.13-.236.191l-.081.061c-.126.068-.11.08.048.034l.295.174-.034-.052.088.342c.018-.184.265-.486.355-.646.16-.282-.152-.713-.473-.63a2.048 2.048 0 0 0-.795.389c-.19.152-.39.447-.613.539l.453.061-.043-.036.171.303c-.036-.203.272-.462.388-.6.197-.234.33-.476.412-.77.109-.392-.44-.66-.726-.428-.628.51-1.21 1.076-1.74 1.686-.385.443.334 1 .717.56z"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "url(#b)",
            d: "M17.66 8.122c-.216-.237-.6-.173-.867-.074-.35.128-.66.29-1.037.33a5.463 5.463 0 0 1-.98.003 9.124 9.124 0 0 1-.684-.076 6.743 6.743 0 0 0-1.4-.265 7.9 7.9 0 0 0-2.812.273c-.21.03-.422.053-.634.068a5.397 5.397 0 0 1-.981-.003c-.377-.04-.685-.202-1.037-.33-.268-.099-.65-.163-.867.074-.33.363.032.992.108 1.388.087.462.172.93.144 1.404 0 0-.124 1.04-.057 1.764L7 17.504a6.131 6.131 0 0 0 3.367 4.924l1.022.51c.4.2.868.2 1.268 0l1.022-.51a6.133 6.133 0 0 0 3.367-4.924l.445-4.826c.067-.72-.083-1.764-.083-1.764-.029-.473.056-.941.144-1.404.075-.396.436-1.025.107-1.388"
          }
        ),
        /* @__PURE__ */ u("path", { fill: "url(#c)", d: "m8.343 16.095 2.635 1.334-1.826 2.113-1.342-1.65z" }),
        /* @__PURE__ */ u("path", { fill: "url(#d)", d: "m15.404 18.715-2.308-1.841 2.216-1.698.98 1.888z" }),
        /* @__PURE__ */ u("path", { fill: "url(#e)", d: "M5.647 12.07h12.702v13.276H5.647z", opacity: 0.55 }),
        /* @__PURE__ */ u("path", { fill: "url(#f)", d: "M5.432 5.611h12.917v11.554H5.432z", opacity: 0.67 }),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "url(#g)",
            d: "M14.742 18.776c0 2.02-1.647 3.87-2.731 3.971-.78.074-2.731-1.952-2.731-3.971 0-2.02 1.223-3.252 2.731-3.252 1.509 0 2.731 1.232 2.731 3.252"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "url(#h)",
            d: "M17.098 14.22c.813 1.83 1.267 4.682.045 6.418-.467.663-1.19 1.159-2.02 1.167-.722.008-1.456-.335-1.817-.977-.152-.268-.415-.694-.21-.881.49-.45.675-.556.942-.844.604-.55 1.253-1.695 1.394-2.739"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "url(#i)",
            d: "M8.567 16.792c.269.722.711 1.644 1.316 2.193.266.288.451.395.943.844.204.188-.059.614-.21.882-.362.642-1.097.985-1.818.977-.83-.01-1.553-.505-2.02-1.168-1.223-1.735-.796-4.812.018-6.643"
          }
        ),
        /* @__PURE__ */ I(
          "g",
          {
            opacity: 0.3,
            style: {
              mixBlendMode: "multiply"
            },
            children: [
              /* @__PURE__ */ u(
                "path",
                {
                  fill: "#008EF0",
                  d: "m18.779 11.152-.005-.358a.406.406 0 0 0-.312-.368c-.634-.138-2.266-.386-4.436.091 0 0-1.072.318-2.002.325l-.053.009c-.93.011-2.008-.284-2.008-.284-2.178-.434-3.807-.153-4.437-.002a.406.406 0 0 0-.305.373l.002.359c0 .159.054.313.148.438.142.189.268.395.36.615.09.214.067.457.101.683.2 1.313.86 1.814.86 1.814s.4.478 2.02.483c.606.001 1.116-.135 1.503-.35l.015-.008a2.74 2.74 0 0 0 1.27-1.618l.164-.553a.362.362 0 0 1 .368-.264v-.009a.363.363 0 0 1 .337.258l.175.55a2.735 2.735 0 0 0 1.3 1.592l.014.008c.392.207.904.333 1.51.319 1.619-.037 2.01-.523 2.01-.523s.65-.514.827-1.83c.03-.227.002-.47.087-.685.088-.222.21-.43.349-.623a.738.738 0 0 0 .14-.44z",
                  style: {
                    mixBlendMode: "multiply"
                  }
                }
              ),
              /* @__PURE__ */ u(
                "path",
                {
                  fill: "#008EF0",
                  d: "M6.43 12.16s-.017-1.096.78-1.173c.797-.078 2.539-.13 3.238.17.699.3.726.703.656 1.357-.084.776-.569 1.883-1.792 1.978-1.21.093-2.209.048-2.541-.72-.376-.867-.343-1.61-.343-1.61zM17.59 12.04s-.005-1.096-.803-1.157c-.798-.062-2.541-.079-3.234.234-.694.313-.714.718-.63 1.37.099.774.603 1.872 1.827 1.941 1.225.07 2.21.004 2.528-.77.359-.875.312-1.618.312-1.618z"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#008EF0",
            d: "M14.312 13.69c.453-.049.765-.601.696-1.233-.07-.632-.493-1.104-.946-1.055-.453.05-.764.602-.695 1.234.069.632.492 1.104.945 1.055"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#008EF0",
            d: "M14.632 12.148c.2 0 .361-.168.361-.375a.369.369 0 0 0-.361-.375c-.2 0-.362.168-.362.375s.162.375.362.375M10.655 12.636c.069-.632-.243-1.185-.696-1.234-.453-.05-.876.422-.945 1.054-.07.632.242 1.185.695 1.234.453.05.876-.422.946-1.054"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#008EF0",
            d: "M10.385 12.148c.2 0 .362-.168.362-.375a.369.369 0 0 0-.362-.375c-.2 0-.361.168-.361.375s.162.375.361.375"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#FD812D",
            stroke: "#FD812D",
            strokeMiterlimit: 10,
            strokeWidth: 3.62,
            d: "m11.51 12.947.489-1.381.512 1.38-.47 1.292c-.01.03-.05.03-.061 0z"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#000",
            d: "m19.034 10.76-.005-.359a.41.41 0 0 0-.324-.367c-.657-.139-2.352-.386-4.604.09 0 0-1.112.318-2.077.325l-.055.01c-.966.01-2.084-.285-2.084-.285-2.26-.433-3.949-.153-4.604-.002a.41.41 0 0 0-.316.374l.002.358c0 .16.056.313.153.438.148.19.278.395.374.615.093.214.068.457.104.683.208 1.313.893 1.814.893 1.814s.415.478 2.095.483c.63.002 1.159-.134 1.561-.35l.015-.007a2.76 2.76 0 0 0 1.318-1.619l.17-.553a.374.374 0 0 1 .383-.263v-.01a.376.376 0 0 1 .35.258l.181.55a2.76 2.76 0 0 0 1.349 1.592l.015.008c.406.208.938.334 1.567.32 1.68-.038 2.085-.524 2.085-.524s.675-.514.857-1.83c.032-.227.002-.469.091-.685.092-.222.218-.43.362-.622a.72.72 0 0 0 .145-.441z"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#84C3F7",
            d: "M6.22 11.86s-.017-1.096.81-1.174c.826-.077 2.635-.129 3.36.17.725.3.754.704.68 1.357-.088.776-.59 1.883-1.86 1.978-1.255.093-2.292.048-2.636-.719-.39-.868-.355-1.611-.355-1.611zM17.799 11.74s-.005-1.096-.834-1.158c-.828-.062-2.636-.078-3.356.235-.72.313-.74.717-.654 1.37.103.774.627 1.871 1.897 1.94 1.257.07 2.293.004 2.622-.77.373-.875.324-1.617.324-1.617z"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#000",
            d: "M15.119 12.097a1.521 1.521 0 0 0-.113-.415.374.374 0 1 1-.498-.556.677.677 0 0 0-.38-.067c-.47.058-.786.616-.708 1.248.078.63.52 1.095.99 1.037.47-.058.786-.616.708-1.248zM10.278 11.8a.375.375 0 0 1-.174-.675.632.632 0 0 0-.212-.065c-.469-.059-.912.406-.99 1.037-.078.631.239 1.19.708 1.248.47.058.912-.407.99-1.038a1.454 1.454 0 0 0-.043-.584.374.374 0 0 1-.28.079z"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#FD812D",
            fillRule: "evenodd",
            d: "m12.124 18.774-.414-.415a.233.233 0 1 1 .16-.16l.415.414a.346.346 0 1 1-.16.16m-1.022-1.183a.232.232 0 1 1-.33-.328.232.232 0 0 1 .33.328",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#5CC461",
            fillRule: "evenodd",
            d: "m11.005 17.91.414-.414a.233.233 0 1 1 .161.16l-.414.415a.346.346 0 1 1-.16-.16m1.182-1.022a.233.233 0 1 1 .33-.33.233.233 0 0 1-.33.33",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#008EF0",
            fillRule: "evenodd",
            d: "m11.876 16.791.414.414a.233.233 0 1 1-.161.16l-.414-.413a.346.346 0 1 1 .16-.16m1.022 1.182a.233.233 0 1 1 .33.33.233.233 0 0 1-.33-.33",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            fill: "#FF1A61",
            fillRule: "evenodd",
            d: "M11.81 18.68a.232.232 0 1 1-.327.33.232.232 0 0 1 .328-.33m1.183-1.022-.414.414a.233.233 0 1 1-.16-.16l.414-.415a.346.346 0 1 1 .16.16z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ I("defs", { children: [
        /* @__PURE__ */ I("linearGradient", { id: "b", x1: 12.011, x2: 12.011, y1: 23.089, y2: 7.959, gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ u("stop", { offset: 0.38, stopColor: "#84C3F7" }),
          /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#7EC1F7" }),
          /* @__PURE__ */ u("stop", { offset: 0.5, stopColor: "#6FBEFA" }),
          /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#56B9FE" }),
          /* @__PURE__ */ u("stop", { offset: 0.58, stopColor: "#52B9FF" }),
          /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
        ] }),
        /* @__PURE__ */ I("linearGradient", { id: "c", x1: 10.523, x2: 8.052, y1: 16.692, y2: 18.256, gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ u("stop", { stopColor: "#84C3F7", stopOpacity: 0 }),
          /* @__PURE__ */ u("stop", { offset: 0.1, stopColor: "#81C1F7", stopOpacity: 0.02 }),
          /* @__PURE__ */ u("stop", { offset: 0.22, stopColor: "#79BFF7", stopOpacity: 0.08 }),
          /* @__PURE__ */ u("stop", { offset: 0.36, stopColor: "#6CBAF8", stopOpacity: 0.18 }),
          /* @__PURE__ */ u("stop", { offset: 0.51, stopColor: "#5AB3F9", stopOpacity: 0.32 }),
          /* @__PURE__ */ u("stop", { offset: 0.66, stopColor: "#43AAFA", stopOpacity: 0.49 }),
          /* @__PURE__ */ u("stop", { offset: 0.81, stopColor: "#26A0FC", stopOpacity: 0.71 }),
          /* @__PURE__ */ u("stop", { offset: 0.97, stopColor: "#0594FE", stopOpacity: 0.96 }),
          /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
        ] }),
        /* @__PURE__ */ I("linearGradient", { id: "d", x1: 14.829, x2: 14.396, y1: 16.361, y2: 18.306, gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ u("stop", { stopColor: "#84C3F7", stopOpacity: 0 }),
          /* @__PURE__ */ u("stop", { offset: 0.1, stopColor: "#81C1F7", stopOpacity: 0.02 }),
          /* @__PURE__ */ u("stop", { offset: 0.22, stopColor: "#79BFF7", stopOpacity: 0.08 }),
          /* @__PURE__ */ u("stop", { offset: 0.36, stopColor: "#6CBAF8", stopOpacity: 0.18 }),
          /* @__PURE__ */ u("stop", { offset: 0.51, stopColor: "#5AB3F9", stopOpacity: 0.32 }),
          /* @__PURE__ */ u("stop", { offset: 0.66, stopColor: "#43AAFA", stopOpacity: 0.49 }),
          /* @__PURE__ */ u("stop", { offset: 0.81, stopColor: "#26A0FC", stopOpacity: 0.71 }),
          /* @__PURE__ */ u("stop", { offset: 0.97, stopColor: "#0594FE", stopOpacity: 0.96 }),
          /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
        ] }),
        /* @__PURE__ */ I("linearGradient", { id: "g", x1: 12.011, x2: 12.011, y1: 22.75, y2: 15.524, gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ u("stop", { stopColor: "#88C5F7" }),
          /* @__PURE__ */ u("stop", { offset: 0.07, stopColor: "#A8D4F9" }),
          /* @__PURE__ */ u("stop", { offset: 0.14, stopColor: "#C3E2FB" }),
          /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#D9ECFC" }),
          /* @__PURE__ */ u("stop", { offset: 0.3, stopColor: "#EAF5FD" }),
          /* @__PURE__ */ u("stop", { offset: 0.41, stopColor: "#F6FAFE" }),
          /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#FDFEFE" }),
          /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#fff" })
        ] }),
        /* @__PURE__ */ I("linearGradient", { id: "h", x1: 15.458, x2: 15.458, y1: 14.219, y2: 21.805, gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ u("stop", { stopColor: "#84C3F7" }),
          /* @__PURE__ */ u("stop", { offset: 0.12, stopColor: "#7EC1F7" }),
          /* @__PURE__ */ u("stop", { offset: 0.27, stopColor: "#6FBEFA" }),
          /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#56B9FE" }),
          /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#52B9FF" }),
          /* @__PURE__ */ u("stop", { offset: 0.56, stopColor: "#4CB6FF" }),
          /* @__PURE__ */ u("stop", { offset: 0.69, stopColor: "#3DAFFF" }),
          /* @__PURE__ */ u("stop", { offset: 0.84, stopColor: "#24A3FF" }),
          /* @__PURE__ */ u("stop", { offset: 0.99, stopColor: "#0293FF" }),
          /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
        ] }),
        /* @__PURE__ */ I("linearGradient", { id: "i", x1: 8.458, x2: 8.458, y1: 13.876, y2: 21.688, gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ u("stop", { stopColor: "#84C3F7" }),
          /* @__PURE__ */ u("stop", { offset: 0.12, stopColor: "#7EC1F7" }),
          /* @__PURE__ */ u("stop", { offset: 0.27, stopColor: "#6FBEFA" }),
          /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#56B9FE" }),
          /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#52B9FF" }),
          /* @__PURE__ */ u("stop", { offset: 0.56, stopColor: "#4CB6FF" }),
          /* @__PURE__ */ u("stop", { offset: 0.69, stopColor: "#3DAFFF" }),
          /* @__PURE__ */ u("stop", { offset: 0.84, stopColor: "#24A3FF" }),
          /* @__PURE__ */ u("stop", { offset: 0.99, stopColor: "#0293FF" }),
          /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
        ] }),
        /* @__PURE__ */ u("pattern", { id: "e", width: 1, height: 1, patternContentUnits: "objectBoundingBox", children: /* @__PURE__ */ u("use", { xlinkHref: "#j", transform: "scale(.00565 .0054)" }) }),
        /* @__PURE__ */ u("pattern", { id: "f", width: 1, height: 1, patternContentUnits: "objectBoundingBox", children: /* @__PURE__ */ u("use", { xlinkHref: "#k", transform: "scale(.00556 .00621)" }) }),
        /* @__PURE__ */ u(
          "image",
          {
            xlinkHref: "data:image/png;base64,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",
            id: "j",
            width: 177,
            height: 185
          }
        ),
        /* @__PURE__ */ u(
          "image",
          {
            xlinkHref: "data:image/png;base64,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",
            id: "k",
            width: 180,
            height: 161
          }
        )
      ] })
    ]
  }
), CH = P6, T6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008EF0",
      d: "M11.03 8.667c.426-.482.889-.922 1.392-1.325l-.641-.371c-.081.287-.415.51-.564.769-.17.298-.25.684.045.93.108.09.271.105.4.053.396-.159.613-.645 1.035-.753l-.418-.548c-.191.333-.693 1.037-.052 1.238.47.147.784-.417 1.184-.54l-.523-.522.002-.01c-.353.373.283.856.633.487a.5.5 0 0 0 .103-.165c.134-.339-.192-.625-.522-.522a1.562 1.562 0 0 0-.472.255c-.071.053-.138.112-.21.166l-.07.052c-.111.06-.097.07.041.03l.261.15-.03-.044.078.297c.016-.16.235-.422.314-.56.14-.246-.134-.621-.418-.55a1.82 1.82 0 0 0-.703.339c-.168.132-.344.39-.54.469l.4.053-.039-.031.152.263c-.032-.177.24-.402.343-.522.173-.204.29-.414.363-.67.096-.34-.388-.575-.64-.372-.555.444-1.069.935-1.538 1.467-.34.385.295.87.633.486z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#a)",
      d: "M17.068 8.082c-.19-.196-.529-.142-.766-.061-.31.106-.583.238-.915.272-.288.03-.58.022-.867.002a9.035 9.035 0 0 1-.604-.062 6.346 6.346 0 0 0-1.236-.22 7.466 7.466 0 0 0-2.485.226 8.987 8.987 0 0 1-.56.056c-.288.02-.58.027-.867-.002-.333-.034-.605-.167-.916-.272-.236-.081-.575-.135-.766.061-.29.299.029.818.095 1.144.078.38.153.767.128 1.156 0 0-.11.858-.05 1.453l.392 3.977c.141 1.43.926 2.721 2.13 3.57a2.69 2.69 0 0 0 1.55.487h1.516c.555 0 1.097-.17 1.548-.487 1.206-.849 1.99-2.14 2.131-3.57l.393-3.977c.059-.593-.073-1.453-.073-1.453-.026-.39.05-.775.127-1.156.066-.326.386-.845.095-1.144"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#b)",
      d: "M11.375 19.869c-.795-.494-1.711-1.644-1.711-2.823 0-1.564 1.08-2.518 2.413-2.518 1.332 0 2.413.954 2.413 2.518 0 1.172-.817 2.316-1.63 2.814"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#c)",
      d: "M14.637 12.462c-.212 1.73.144 4.218 1.627 5.35.566.432 1.306.659 2.01.454.61-.178 1.141-.65 1.28-1.276.059-.262.17-.684-.05-.787-.532-.248-.716-.29-1.015-.461-.654-.302-1.499-1.09-1.888-1.922"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#d)",
      d: "M9.455 12.413c.249 1.726-.054 4.22-1.512 5.382-.557.444-1.292.686-2 .497-.614-.165-1.155-.627-1.307-1.25-.064-.26-.185-.68.034-.788.526-.259.71-.304 1.005-.482.647-.315 1.475-1.12 1.846-1.96"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008EF0",
      d: "m18.056 10.725-.005-.312a.355.355 0 0 0-.275-.32c-.56-.12-2.003-.335-3.92.08 0 0-.946.275-1.768.282l-.047.008c-.822.01-1.774-.247-1.774-.247-1.924-.377-3.362-.133-3.92-.002a.355.355 0 0 0-.27.325l.003.312c0 .139.047.272.13.381.127.165.237.344.319.535.08.186.058.397.088.594.178 1.142.76 1.578.76 1.578s.354.416 1.784.42c.536.001.986-.117 1.329-.304l.012-.008c.541-.298.94-.807 1.122-1.407l.145-.482a.32.32 0 0 1 .326-.23v-.007a.32.32 0 0 1 .297.223l.155.479a2.387 2.387 0 0 0 1.148 1.385l.012.006c.346.18.8.29 1.335.278 1.43-.032 1.775-.455 1.775-.455s.574-.447.73-1.592c.027-.198.001-.408.077-.596.078-.193.185-.374.308-.541a.634.634 0 0 0 .124-.384z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008EF0",
      d: "M7.147 11.604s-.014-.954.69-1.022c.703-.067 2.243-.112 2.86.148.618.26.642.612.58 1.18-.075.676-.503 1.64-1.583 1.721-1.08.083-1.952.042-2.245-.626-.332-.755-.302-1.401-.302-1.401M17.005 11.498s-.004-.954-.709-1.007c-.705-.054-2.245-.069-2.857.204-.613.272-.63.624-.557 1.192.087.673.533 1.628 1.615 1.689 1.07.06 1.952.003 2.233-.67.317-.761.275-1.408.275-1.408z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008EF0",
      d: "M14.11 12.934c.4-.044.676-.524.615-1.073-.062-.55-.435-.96-.835-.917-.4.042-.676.523-.614 1.073.06.55.434.96.834.917z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008EF0",
      d: "M14.391 11.591c.176 0 .32-.146.32-.326a.323.323 0 0 0-.32-.327.323.323 0 0 0-.319.327c0 .18.143.326.32.326M10.877 12.016c.06-.55-.214-1.03-.614-1.073-.4-.044-.774.367-.835.917-.061.55.214 1.03.614 1.073.4.043.774-.368.835-.917"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008EF0",
      d: "M10.64 11.591c.177 0 .32-.146.32-.326a.323.323 0 0 0-.32-.326.323.323 0 0 0-.319.326c0 .18.143.326.32.326"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFC200",
      stroke: "#FFC200",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      d: "m11.634 12.286.432-1.201.453 1.201-.415 1.124c-.01.025-.045.025-.054 0z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#333",
      d: "m18.282 10.383-.004-.311a.359.359 0 0 0-.287-.32c-.58-.12-2.077-.336-4.066.079 0 0-.983.276-1.836.282l-.048.008c-.853.01-1.84-.247-1.84-.247-1.997-.377-3.49-.133-4.068-.002a.36.36 0 0 0-.28.326l.002.311c0 .139.049.273.136.382.13.164.245.343.33.535.082.186.06.396.091.593.184 1.143.789 1.578.789 1.578s.367.416 1.85.42c.557.002 1.024-.117 1.38-.304l.013-.007a2.41 2.41 0 0 0 1.163-1.408l.151-.481a.331.331 0 0 1 .338-.23v-.008a.33.33 0 0 1 .309.224l.16.478c.2.596.624 1.097 1.191 1.385l.013.006c.359.18.829.29 1.384.278 1.484-.032 1.843-.455 1.843-.455s.596-.447.757-1.592c.028-.197.002-.408.08-.596.082-.193.193-.374.32-.54a.62.62 0 0 0 .129-.385z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#E5F8FF",
      d: "M6.961 11.342s-.014-.954.716-1.021c.73-.068 2.327-.113 2.968.148.641.26.666.612.601 1.18-.077.675-.521 1.639-1.642 1.72-1.108.082-2.025.043-2.33-.625-.343-.755-.313-1.402-.313-1.402zM17.19 11.237s-.004-.954-.736-1.008c-.73-.054-2.33-.068-2.965.204-.635.273-.654.624-.577 1.192.09.674.553 1.628 1.675 1.69 1.11.06 2.026.002 2.317-.67.33-.762.286-1.408.286-1.408z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M9.882 11.909a.609.609 0 0 1-.509.475.612.612 0 0 1-.698-.506M15.283 11.909a.61.61 0 0 1-.51.475.612.612 0 0 1-.698-.506"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFC200",
      fillRule: "evenodd",
      d: "m12.177 17.356-.366-.36a.208.208 0 0 1-.202-.052.2.2 0 0 1 0-.287c.08-.079.211-.079.292 0a.2.2 0 0 1 .052.2l.366.36a.31.31 0 0 1 .35.058c.12.117.12.308 0 .426a.31.31 0 0 1-.433 0 .299.299 0 0 1-.06-.345m-.903-1.029c-.08.08-.21.08-.291 0a.2.2 0 0 1 0-.287c.08-.079.21-.079.29 0a.2.2 0 0 1 0 .287",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#5CC461",
      fillRule: "evenodd",
      d: "m11.188 16.605.365-.36a.2.2 0 0 1 .053-.2c.08-.078.21-.078.291 0a.2.2 0 0 1 0 .288.208.208 0 0 1-.202.051l-.365.36a.298.298 0 0 1-.06.345.31.31 0 0 1-.432 0 .298.298 0 0 1 0-.426.31.31 0 0 1 .35-.058m1.045-.89a.2.2 0 0 1 0-.286c.08-.08.21-.08.29 0a.2.2 0 0 1 0 .287c-.08.079-.21.079-.29 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008EF0",
      fillRule: "evenodd",
      d: "m11.957 15.631.365.36a.208.208 0 0 1 .202.052.2.2 0 0 1 0 .287c-.08.079-.21.079-.291 0a.2.2 0 0 1-.053-.2l-.365-.36a.31.31 0 0 1-.35-.057.299.299 0 0 1 0-.427.31.31 0 0 1 .433 0 .299.299 0 0 1 .059.345m.903 1.029c.08-.08.21-.08.29 0a.2.2 0 0 1 0 .287c-.08.079-.21.079-.29 0a.2.2 0 0 1 0-.287",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#EC3B64",
      fillRule: "evenodd",
      d: "M11.9 17.274a.2.2 0 0 1 0 .287c-.08.079-.21.079-.291 0a.2.2 0 0 1 0-.287c.08-.08.21-.08.29 0m1.045-.89-.366.36a.2.2 0 0 1-.052.2c-.08.079-.211.079-.292 0a.2.2 0 0 1 0-.287.207.207 0 0 1 .202-.052l.366-.36a.298.298 0 0 1 .06-.345.31.31 0 0 1 .432 0c.12.117.12.309 0 .426a.31.31 0 0 1-.35.059",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#333",
      d: "M15.707 19.04a.155.155 0 0 0 .013-.241.987.987 0 0 0-1.234-.069.951.951 0 0 0-.31 1.179.16.16 0 0 0 .237.061zM8.56 19.04a.155.155 0 0 1-.014-.241.987.987 0 0 1 1.235-.069.95.95 0 0 1 .31 1.179.16.16 0 0 1-.238.061z"
    }
  ),
  /* @__PURE__ */ I("defs", { children: [
    /* @__PURE__ */ I("linearGradient", { id: "a", x1: 12.077, x2: 12.077, y1: 19.869, y2: 7.948, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.38, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.5, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.58, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "b", x1: 12.077, x2: 12.077, y1: 19.869, y2: 14.528, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#88C5F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.07, stopColor: "#A8D4F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.14, stopColor: "#C3E2FB" }),
      /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#D9ECFC" }),
      /* @__PURE__ */ u("stop", { offset: 0.3, stopColor: "#EAF5FD" }),
      /* @__PURE__ */ u("stop", { offset: 0.41, stopColor: "#F6FAFE" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#FDFEFE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#fff" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "c", x1: 16.022, x2: 17.936, y1: 12.043, y2: 18.368, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.12, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.27, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.56, stopColor: "#4CB6FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.69, stopColor: "#3DAFFF" }),
      /* @__PURE__ */ u("stop", { offset: 0.84, stopColor: "#24A3FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.99, stopColor: "#0293FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "d", x1: 8.061, x2: 6.28, y1: 12.023, y2: 18.386, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.12, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.27, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.56, stopColor: "#4CB6FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.69, stopColor: "#3DAFFF" }),
      /* @__PURE__ */ u("stop", { offset: 0.84, stopColor: "#24A3FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.99, stopColor: "#0293FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] })
  ] })
] }), SH = T6, O6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 48 44", ...e, children: [
  /* @__PURE__ */ I("g", { opacity: 0.4, children: [
    /* @__PURE__ */ u(
      "path",
      {
        fill: "url(#a)",
        d: "M23.119 19.062c-8.55 5.422-13.56.812-15.865-2.573-.755-1.109-1.287 1.167-2.305.263-1.854-1.647-2.759-2.205-3.065-.79-.304 1.4-.34 2.837-.52 4.255-.22 1.739-.555 2.83-.376 4.574.303 2.94 1.937 4.752 4.262 6.478 4.214 3.129 13.741 2.353 16.717-4.502"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#0092FF",
        d: "M26.272 5.689a30.506 30.506 0 0 1 3.746-3.716L28.292.93c-.22.807-1.118 1.43-1.518 2.157-.46.836-.676 1.919.12 2.608.293.253.73.296 1.078.15 1.067-.445 1.649-1.81 2.786-2.111l-1.125-1.539c-.515.935-1.865 2.91-.14 3.472 1.264.412 2.111-1.167 3.186-1.515l-1.406-1.463.006-.024c-.951 1.043.76 2.399 1.705 1.364.124-.136.21-.29.276-.464.362-.949-.516-1.75-1.406-1.463-.467.151-.88.412-1.27.715-.192.15-.37.316-.562.465-.064.05-.128.1-.192.148-.298.167-.26.194.114.082l.701.425-.08-.125.21.834c.042-.448.631-1.186.844-1.574.38-.688-.36-1.74-1.126-1.539-.708.188-1.316.477-1.89.948-.452.371-.926 1.093-1.457 1.315l1.078.151-.102-.088.408.738c-.085-.495.647-1.127.923-1.465a4.89 4.89 0 0 0 .977-1.879C30.69.3 29.386-.357 28.705.21a33.79 33.79 0 0 0-4.139 4.115c-.914 1.08.794 2.44 1.705 1.364z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "url(#b)",
        d: "M42.015 19.655s4.68 1.227 5.811 4.638c.544 1.642-.28 3.316-1.197 4.582-.731 1.012-1.594 1.78-2.504 2.59-.263.234-.585.651-.517 1.052.068.402.499.57.688.9.462.803-.511 1.594-1.076 1.694-.972.17-1.888-.574-2.602-1.332-1-1.062-1.617-2.562-1.928-4.003-.603-2.794.074-4.26.074-4.26"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "url(#c)",
        d: "M44.502 4.889c-.478-.609-1.397-.505-2.047-.303-.852.264-1.609.614-2.509.66-.776.042-1.56-.025-2.328-.13a22.734 22.734 0 0 1-1.612-.28 15.618 15.618 0 0 0-3.285-.84c-2.222-.317-4.559-.238-6.717.272-.505.043-1.01.07-1.516.078-.776.013-1.561-.012-2.328-.143-.889-.153-1.598-.588-2.413-.95-.622-.276-1.522-.488-2.069.062-.833.837-.068 2.42.053 3.396.141 1.137.275 2.29.138 3.437 0 0-.445 2.518-.392 4.288l.356 11.817c.156 5.173 2.909 9.887 7.28 12.46l2.354 1.387c.918.541 2.033.606 3.009.177l2.502-1.102c4.646-2.043 7.94-6.402 8.707-11.521l1.757-11.694c.262-1.745.059-4.307.059-4.307 0-1.155.27-2.284.546-3.398.236-.954 1.185-2.436.456-3.365z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "url(#d)",
        d: "M36.568 30.566c-.408 4.909-4.689 9.103-7.281 9.151-1.863.034-6.084-5.248-5.676-10.156.408-4.91 3.558-7.68 7.136-7.401 3.578.278 6.23 3.497 5.822 8.407z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#FFBD00",
        fillRule: "evenodd",
        d: "m30.285 30.055-.984-1.01a.544.544 0 0 1-.543-.145.58.58 0 0 1 0-.804.545.545 0 0 1 .784 0 .578.578 0 0 1 .14.557l.985 1.009a.809.809 0 0 1 .943.163.862.862 0 0 1 0 1.196.81.81 0 0 1-1.166 0 .864.864 0 0 1-.16-.968m-2.43-2.884a.545.545 0 0 1-.784 0 .58.58 0 0 1 0-.804.545.545 0 0 1 .784 0 .58.58 0 0 1 0 .804",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#17C553",
        fillRule: "evenodd",
        d: "m27.625 27.948.984-1.01a.578.578 0 0 1 .14-.557.545.545 0 0 1 .785 0 .58.58 0 0 1 0 .804.544.544 0 0 1-.543.145l-.984 1.01a.864.864 0 0 1-.159.968.81.81 0 0 1-1.166 0 .862.862 0 0 1 0-1.197.809.809 0 0 1 .943-.163m2.813-2.493a.58.58 0 0 1 0-.804.545.545 0 0 1 .784 0 .58.58 0 0 1 0 .804.545.545 0 0 1-.784 0",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#008FF6",
        fillRule: "evenodd",
        d: "m29.693 25.217.984 1.009a.544.544 0 0 1 .543.145.58.58 0 0 1 0 .804.545.545 0 0 1-.784 0 .578.578 0 0 1-.141-.557l-.984-1.009a.809.809 0 0 1-.943-.163.862.862 0 0 1 0-1.197.81.81 0 0 1 1.166 0 .864.864 0 0 1 .159.968m2.43 2.886a.545.545 0 0 1 .784 0 .58.58 0 0 1 0 .804.545.545 0 0 1-.784 0 .58.58 0 0 1 0-.804",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#FF1A61",
        fillRule: "evenodd",
        d: "M29.54 29.826a.58.58 0 0 1 0 .803.545.545 0 0 1-.784 0 .58.58 0 0 1 0-.803.545.545 0 0 1 .784 0m2.812-2.494-.984 1.009a.578.578 0 0 1-.14.557.545.545 0 0 1-.785 0 .58.58 0 0 1 0-.804.544.544 0 0 1 .543-.145l.984-1.01a.864.864 0 0 1 .16-.968.81.81 0 0 1 1.165 0 .862.862 0 0 1 0 1.197.809.809 0 0 1-.943.163z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "url(#e)",
        d: "M9.996 16.31c1.006 1.092.988 3.402 1.173 4.833.64 4.959-.828 6.475-5.244 8.444-1.697.757-2.974.042-3.8-1.456C.988 26.077.242 23.837.068 21.473c-.1-1.355-.108-2.727.092-4.073.099-.67.25-1.335.476-1.973.187-.53.519-1.047.607-1.61.192-1.224-.316-2.938.831-3.795.658-.49 1.62-.418 2.308-.029 1.182.669.891 2.372 1.328 3.48.838 2.125 2.815 1.324 4.226 2.774z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#1A1A1A",
        d: "M28.612 43.677a.506.506 0 0 0 .486-.61c-.277-1.431-1.508-2.511-2.985-2.511-1.477 0-2.709 1.08-2.985 2.511a.506.506 0 0 0 .486.61zM36.363 41.605a.374.374 0 0 0 .359-.451c-.204-1.058-1.114-1.856-2.206-1.856-1.092 0-2.002.798-2.206 1.856a.374.374 0 0 0 .36.45z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#0092FF",
        d: "m46.281 12.01.035-.834a.942.942 0 0 0-.682-.893c-1.462-.397-5.917-1.24-11.044-.386 0 0-2.544.612-4.717.519l-.125.015c-2.173-.083-4.65-.899-4.65-.899-5.031-1.267-7.959-1.017-9.452-.74a.955.955 0 0 0-.76.835l-.041.835c-.019.371.085.736.29 1.039.308.456.573.95.761 1.475.182.508.095 1.07.147 1.601.3 3.082 1.775 4.327 1.775 4.327s1.339 1.12 3.914 1.38c1.41.144 2.454.014 3.387-.442l.034-.017c1.473-.727 2.605-2.037 3.172-3.619l.455-1.269a.852.852 0 0 1 .894-.57v-.023a.844.844 0 0 1 .753.64l.338 1.301c.421 1.622 1.43 3.019 2.83 3.863l.033.02c.888.529 2.068.883 3.486.923 3.783.105 5.435-.908 5.435-.908s1.584-1.121 2.163-4.167c.1-.525.064-1.092.292-1.583.235-.506.545-.978.894-1.408.232-.285.368-.641.384-1.012v-.002z",
        opacity: 0.3
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#0092FF",
        d: "M16.532 12.713s.097-2.557 2.033-2.636c1.936-.08 5.214.23 6.868 1.018 1.653.787 1.67 1.731 1.418 3.246-.299 1.798-1.607 4.315-4.575 4.379-2.935.063-4.407-.38-5.115-2.209-.8-2.07-.629-3.797-.629-3.797zM43.285 14.144s.123-2.556-1.798-2.8c-1.922-.247-6.833-.585-8.548.056-1.715.641-1.813 1.582-1.693 3.112.143 1.816 1.229 4.437 4.18 4.756 2.92.316 6.042.367 6.905-1.395.975-1.994.953-3.73.953-3.73"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#FFBD00",
        stroke: "#FFBD00",
        strokeMiterlimit: 10,
        strokeWidth: 4,
        d: "m28.254 14.752 1.277-2.077 1.813 1.763-3.021 4.355c-.037.06-.13.04-.14-.03l-.306-2.207a2.725 2.725 0 0 1 .378-1.804z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#1A1A1A",
        d: "m46.319 11.298.032-.835a.956.956 0 0 0-.71-.896c-1.514-.403-6.13-1.266-11.435-.432 0 0-2.63.602-4.88.5l-.13.015c-2.25-.093-4.818-.919-4.818-.919-5.213-1.287-7.558-.978-9.102-.706a.957.957 0 0 0-.784.832l-.04.835c-.016.371.092.737.305 1.041.32.458.598.954.795 1.479.19.51.103 1.072.158 1.603.323 3.084 1.855 4.336 1.855 4.336s.706 1.053 3.373 1.324c1.46.149 2.54.023 3.505-.43l.034-.016a6.436 6.436 0 0 0 3.27-3.608l.465-1.267a.875.875 0 0 1 .925-.567.853.853 0 0 1 .782.62l.355 1.304a6.437 6.437 0 0 0 2.945 3.876l.034.02c.921.533 2.145.892 3.612.938 3.917.12 5.623-.885 5.623-.885s1.635-1.115 2.223-4.16c.1-.525.062-1.091.296-1.582a6.7 6.7 0 0 1 .919-1.405c.239-.285.377-.64.392-1.011z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#84C3F7",
        d: "M17.142 12.069s.109-2.555 1.938-2.647c1.831-.09 4.93.197 6.489.973 1.557.775 1.567 1.72 1.32 3.235-.296 1.797-1.547 4.32-4.355 4.404-2.776.082-4.164-.35-4.822-2.175-.744-2.063-.57-3.791-.57-3.791zM43.322 13.43s.124-2.555-1.798-2.8c-1.922-.246-6.833-.584-8.548.057-1.715.641-1.813 1.582-1.693 3.112.143 1.816 1.23 4.437 4.18 4.756 2.92.316 6.042.367 6.905-1.395.976-1.994.954-3.73.954-3.73"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#1A1A1A",
        d: "M39.244 15.192a3.5 3.5 0 0 0-.163-.99.876.876 0 1 1-1.023-1.409 1.577 1.577 0 0 0-.867-.244c-1.102.024-1.97 1.246-1.938 2.729.032 1.483.952 2.666 2.053 2.642 1.102-.024 1.97-1.246 1.938-2.729M23.553 13.417a.874.874 0 0 1-.436-1.57 1.501 1.501 0 0 0-.5-.14c-1.097-.111-2.108.995-2.258 2.47-.15 1.476.618 2.763 1.715 2.875 1.097.111 2.108-.995 2.258-2.47a3.4 3.4 0 0 0-.131-1.363.87.87 0 0 1-.65.199z"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        fill: "#FFBD00",
        d: "m28.567 14.28-.366 4.432c-.052.059-.16.02-.164-.057l-.125-2.47c-.036-.702.196-1.374.655-1.905"
      }
    )
  ] }),
  /* @__PURE__ */ I("defs", { children: [
    /* @__PURE__ */ I("linearGradient", { id: "a", x1: 21.267, x2: 2.816, y1: 15.743, y2: 28.188, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#84C3F7", stopOpacity: 0 }),
      /* @__PURE__ */ u("stop", { offset: 0.16, stopColor: "#84C3F7", stopOpacity: 0.05 }),
      /* @__PURE__ */ u("stop", { offset: 0.17, stopColor: "#83C3F7", stopOpacity: 0.19 }),
      /* @__PURE__ */ u("stop", { offset: 0.19, stopColor: "#83C3F7", stopOpacity: 0.4 }),
      /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#83C3F7", stopOpacity: 0.58 }),
      /* @__PURE__ */ u("stop", { offset: 0.23, stopColor: "#83C3F7", stopOpacity: 0.73 }),
      /* @__PURE__ */ u("stop", { offset: 0.25, stopColor: "#83C3F7", stopOpacity: 0.83 }),
      /* @__PURE__ */ u("stop", { offset: 0.27, stopColor: "#83C3F7", stopOpacity: 0.89 }),
      /* @__PURE__ */ u("stop", { offset: 0.28, stopColor: "#83C3F7", stopOpacity: 0.91 }),
      /* @__PURE__ */ u("stop", { offset: 0.35, stopColor: "#83C3F7", stopOpacity: 0.95 }),
      /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#83C3F7", stopOpacity: 0.99 }),
      /* @__PURE__ */ u("stop", { offset: 0.6, stopColor: "#83C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.64, stopColor: "#6AB9F8" }),
      /* @__PURE__ */ u("stop", { offset: 0.72, stopColor: "#44ABFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.79, stopColor: "#26A0FC" }),
      /* @__PURE__ */ u("stop", { offset: 0.86, stopColor: "#1198FD" }),
      /* @__PURE__ */ u("stop", { offset: 0.93, stopColor: "#0493FE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "b", x1: 46.735, x2: 38.67, y1: 29.262, y2: 25.791, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#0092FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.03, stopColor: "#0594FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.23, stopColor: "#2FA8FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.39, stopColor: "#48B4FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.48, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.77, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.79, stopColor: "#84C3F7", stopOpacity: 0.98 }),
      /* @__PURE__ */ u("stop", { offset: 0.82, stopColor: "#84C3F7", stopOpacity: 0.92 }),
      /* @__PURE__ */ u("stop", { offset: 0.85, stopColor: "#84C3F7", stopOpacity: 0.82 }),
      /* @__PURE__ */ u("stop", { offset: 0.89, stopColor: "#84C3F7", stopOpacity: 0.67 }),
      /* @__PURE__ */ u("stop", { offset: 0.92, stopColor: "#84C3F7", stopOpacity: 0.49 }),
      /* @__PURE__ */ u("stop", { offset: 0.96, stopColor: "#84C3F7", stopOpacity: 0.27 }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#84C3F7", stopOpacity: 0 })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "c", x1: 28.931, x2: 31.114, y1: 40.551, y2: 3.697, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.38, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.5, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.58, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "d", x1: 29.313, x2: 30.725, y1: 39.724, y2: 22.158, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#88C5F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.07, stopColor: "#A8D4F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.14, stopColor: "#C3E2FB" }),
      /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#D9ECFC" }),
      /* @__PURE__ */ u("stop", { offset: 0.3, stopColor: "#EAF5FD" }),
      /* @__PURE__ */ u("stop", { offset: 0.41, stopColor: "#F6FAFE" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#FDFEFE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#fff" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "e", x1: 10.059, x2: -0.962, y1: 25.958, y2: 14.934, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#99CDF8" }),
      /* @__PURE__ */ u("stop", { offset: 0.1, stopColor: "#93CBF8" }),
      /* @__PURE__ */ u("stop", { offset: 0.22, stopColor: "#84C7F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.35, stopColor: "#6BBFFC" }),
      /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#51B8FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.5, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.6, stopColor: "#4CB6FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.72, stopColor: "#3DAFFF" }),
      /* @__PURE__ */ u("stop", { offset: 0.85, stopColor: "#24A3FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.99, stopColor: "#0293FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] })
  ] })
] }), EH = O6, N6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 40 40", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#17C553",
      d: "M7.974 29.64a.55.55 0 0 0 .555-.547.55.55 0 0 0-.555-.546.55.55 0 0 0-.554.546.55.55 0 0 0 .554.547"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#009CFC",
      d: "M21.949 9.275a25.431 25.431 0 0 0-2.892-3.33l1.547-.716c.123.676.837 1.255 1.12 1.882.326.719.426 1.62-.304 2.119-.268.184-.644.184-.928.039-.871-.45-1.26-1.61-2.203-1.945l1.076-1.167c.365.803 1.358 2.522-.151 2.846-1.106.236-1.703-1.12-2.589-1.488l1.308-1.084-.003-.02c.728.926-.832 1.899-1.554.979a1.154 1.154 0 0 1-.198-.4c-.234-.804.575-1.39 1.308-1.084.384.16.716.405 1.022.683.152.138.291.287.442.425l.152.137c.24.159.206.179-.103.057l-.63.292.079-.096-.244.664c0-.368-.443-1.018-.594-1.352-.269-.592.443-1.393 1.076-1.167.587.209 1.081.493 1.532.923.356.338.702.965 1.135 1.188l-.927.038.093-.063c-.135.19-.27.38-.403.57.11-.397-.462-.97-.67-1.268a3.945 3.945 0 0 1-.685-1.611c-.145-.8 1.013-1.233 1.547-.716a28.2 28.2 0 0 1 3.195 3.686c.692.954-.865 1.93-1.554.98z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#a)",
      d: "M22.505 23.745c3.38.889 7.884.94 10.989-.827 2.192-1.247 3.102-3.756 2.099-6.099-.365-.85-1.619-2.645-2.768-2.392-.508.112-.691.654-.929 1.043a7.15 7.15 0 0 1-1.152 1.436c-1.727 1.648-2.748 1.536-4.134 2.308"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#b)",
      d: "M8.756 6.68c1.335-1.415 2.983.406 4.193.89.464.185.886.044 1.36.012.579-.039 1.158-.08 1.733-.152 1.618-.205 3.314.329 4.876.72.366.035.734.06 1.1.072a9.196 9.196 0 0 0 1.694-.08c.647-.1 1.167-.408 1.762-.66.455-.194 1.112-.337 1.503.065.597.613.024 1.749-.074 2.453-.114.82-.224 1.652-.137 2.482 0 0-.562 1.692-.62 2.97-.142.404.123.34.607 2.77.437 2.188.766 4.47.229 7.47-.67 3.736-2.771 6.427-6.4 8.483a2.408 2.408 0 0 1-2.187.097l-1.807-.822c-3.352-1.525-6.802-4.864-7.307-8.57l-.312-9.623c-.172-1.263.018-2.575.018-2.575.012-.834-.172-2.106-.36-2.913-.183-.784-.483-2.019-.076-2.797.059-.111.127-.207.206-.291z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#c)",
      d: "M11.872 15.693c1.453 3.56 2.417 8.87.234 12.242-.9 1.392-2.452 2.457-4.173 2.405-1.922-.056-3.39-1.587-3.892-3.324-.178-.615.246-1.008.728-1.291 1.2-.705 2.395-1.362 3.168-2.548.777-1.191 1.351-2.508 1.809-3.848"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "M20.953 36a.312.312 0 0 1-.308-.372 1.92 1.92 0 0 1 1.89-1.528 1.92 1.92 0 0 1 1.889 1.528.312.312 0 0 1-.308.372zM11.957 34.019a.308.308 0 0 1-.169-.45 1.938 1.938 0 0 1 2.29-.84c.885.3 1.405 1.171 1.284 2.052a.314.314 0 0 1-.414.252z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#d)",
      d: "M24.501 23.815a5.984 5.984 0 0 0-.432-.778c-2.213-3.35-7.355-2.696-8.99.853-1.556 3.381.595 7.845 3.687 9.58.915.514 1.706-.084 2.484-.586 1.697-1.096 3.169-2.85 3.68-4.83.355-1.369.178-2.93-.428-4.238z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFBD00",
      fillRule: "evenodd",
      d: "m20.961 26.342-.691-.682a.393.393 0 0 1-.383-.099.38.38 0 0 1 0-.543.394.394 0 0 1 .552 0 .382.382 0 0 1 .1.377l.69.681a.587.587 0 0 1 .664.11.566.566 0 0 1 0 .81.585.585 0 0 1-.82 0 .566.566 0 0 1-.112-.654m-1.708-1.95a.394.394 0 0 1-.552 0 .38.38 0 0 1 0-.544.394.394 0 0 1 .552 0 .38.38 0 0 1 0 .543",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#17C553",
      fillRule: "evenodd",
      d: "m19.091 24.917.691-.682a.382.382 0 0 1 .1-.377.393.393 0 0 1 .551 0 .38.38 0 0 1 0 .543.395.395 0 0 1-.382.098l-.691.683a.567.567 0 0 1-.112.654.585.585 0 0 1-.82 0 .566.566 0 0 1 0-.81.586.586 0 0 1 .663-.11m1.977-1.685a.38.38 0 0 1 0-.544.393.393 0 0 1 .552 0 .38.38 0 0 1 0 .544.393.393 0 0 1-.552 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008FF6",
      fillRule: "evenodd",
      d: "m20.544 23.072.692.682a.394.394 0 0 1 .382.098.38.38 0 0 1 0 .544.394.394 0 0 1-.551 0 .382.382 0 0 1-.1-.377l-.691-.682a.586.586 0 0 1-.664-.11.566.566 0 0 1 0-.81.585.585 0 0 1 .82 0c.18.177.217.442.112.655m1.709 1.95a.393.393 0 0 1 .55 0 .38.38 0 0 1 0 .543.393.393 0 0 1-.55 0 .38.38 0 0 1 0-.543",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FF1A61",
      fillRule: "evenodd",
      d: "M20.437 26.187a.38.38 0 0 1 0 .543.393.393 0 0 1-.551 0 .38.38 0 0 1 0-.543.393.393 0 0 1 .551 0m1.977-1.685-.691.682a.382.382 0 0 1-.1.377.394.394 0 0 1-.551 0 .38.38 0 0 1 0-.543.394.394 0 0 1 .382-.099l.692-.682a.567.567 0 0 1 .111-.654.585.585 0 0 1 .82 0 .566.566 0 0 1 0 .81.587.587 0 0 1-.663.11z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#0092FF",
      d: "m6.673 13.646-.027-.631a.713.713 0 0 1 .522-.675c1.12-.3 4.532-.937 8.46-.291 0 0 1.947.462 3.611.392l.096.011c1.665-.062 3.563-.679 3.563-.679 3.852-.957 6.095-.768 7.238-.559a.725.725 0 0 1 .583.63l.031.632c.014.28-.065.555-.222.784-.236.345-.44.719-.584 1.114-.139.384-.072.81-.112 1.21-.23 2.328-1.36 3.269-1.36 3.269s-1.025.846-2.997 1.043c-1.08.108-1.88.01-2.594-.335l-.026-.013c-1.128-.549-1.995-1.538-2.43-2.733l-.348-.959a.653.653 0 0 0-.685-.43v-.018a.644.644 0 0 0-.577.483l-.259.984c-.322 1.225-1.094 2.28-2.167 2.917-.008.006-.017.01-.025.015-.68.4-1.584.667-2.67.698-2.897.079-4.163-.686-4.163-.686s-1.213-.847-1.657-3.148c-.076-.396-.049-.824-.223-1.196a5.124 5.124 0 0 0-.685-1.064 1.291 1.291 0 0 1-.294-.764z",
      opacity: 0.3
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#0092FF",
      d: "M29.458 14.177s-.075-1.932-1.557-1.992c-1.483-.06-3.994.175-5.26.77-1.266.594-1.28 1.308-1.086 2.452.229 1.358 1.23 3.26 3.504 3.308 2.247.047 3.375-.287 3.917-1.669.613-1.563.482-2.869.482-2.869zM8.968 15.257s-.095-1.93 1.377-2.116c1.472-.186 5.233-.441 6.547.043 1.313.484 1.388 1.195 1.296 2.35-.11 1.373-.941 3.353-3.202 3.594-2.235.238-4.626.277-5.287-1.054-.748-1.506-.731-2.817-.731-2.817"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFBD00",
      stroke: "#FFBD00",
      strokeMiterlimit: 10,
      strokeWidth: 6.88,
      d: "m20.48 15.717-.978-1.056-1.389.818 2.314 3.29c.029.045.099.03.107-.023l.235-1.667a2.035 2.035 0 0 0-.29-1.362z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "m6.644 13.108-.025-.631c.01-.32.23-.595.544-.677 1.16-.304 4.696-.956 8.758-.326 0 0 2.015.455 3.738.378l.099.011c1.724-.07 3.69-.694 3.69-.694 3.993-.973 5.79-.739 6.972-.533a.727.727 0 0 1 .6.628l.03.63c.013.28-.07.557-.233.787-.245.346-.458.72-.608 1.117-.147.385-.08.81-.122 1.21-.247 2.331-1.42 3.277-1.42 3.277s-.541.795-2.584 1c-1.119.112-1.946.017-2.684-.324l-.027-.013a4.887 4.887 0 0 1-2.503-2.725l-.357-.958a.671.671 0 0 0-.708-.428.651.651 0 0 0-.6.469l-.271.985a4.87 4.87 0 0 1-2.256 2.927c-.008.006-.018.01-.026.015-.705.403-1.643.674-2.766.709-3 .09-4.307-.669-4.307-.669s-1.252-.842-1.702-3.142c-.078-.396-.048-.825-.227-1.195a5.05 5.05 0 0 0-.704-1.062 1.259 1.259 0 0 1-.3-.763z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#84C3F7",
      d: "M28.991 13.69s-.083-1.93-1.485-2c-1.401-.07-3.776.149-4.969.735-1.193.585-1.2 1.3-1.01 2.443.225 1.359 1.184 3.265 3.334 3.328 2.126.061 3.19-.265 3.694-1.643.57-1.56.436-2.864.436-2.864zM8.94 14.719s-.095-1.93 1.377-2.116c1.472-.186 5.233-.44 6.546.043 1.314.484 1.389 1.195 1.297 2.35-.11 1.373-.941 3.353-3.202 3.594-2.235.238-4.627.277-5.288-1.054-.747-1.506-.73-2.817-.73-2.817"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "M14.68 14.877c.007-.265.05-.518.126-.748.115.1.265.164.43.167a.658.658 0 0 0 .353-1.231 1.22 1.22 0 0 1 .665-.185c.844.018 1.508.941 1.484 2.062-.025 1.12-.73 2.014-1.573 1.996-.844-.018-1.509-.941-1.484-2.061M25.83 13.474a.663.663 0 0 0 .599-.724.66.66 0 0 0-.265-.462c.12-.056.248-.093.383-.105.84-.084 1.614.751 1.729 1.866.115 1.115-.473 2.087-1.314 2.172-.84.083-1.614-.752-1.729-1.867-.037-.368.001-.72.1-1.03.134.11.31.17.498.15z"
    }
  ),
  /* @__PURE__ */ u("path", { fill: "#FFBD00", d: "m20.24 15.36.28 3.348c.04.044.123.016.126-.043l.096-1.867a2.009 2.009 0 0 0-.502-1.439" }),
  /* @__PURE__ */ I("defs", { children: [
    /* @__PURE__ */ I("linearGradient", { id: "a", x1: 25.78, x2: 35.787, y1: 18.277, y2: 22.167, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.16, stopColor: "#83C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.22, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.32, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.56, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.58, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "b", x1: 18.991, x2: 17.725, y1: 34.509, y2: 5.805, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.44, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.52, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.62, stopColor: "#6FBBF8" }),
      /* @__PURE__ */ u("stop", { offset: 0.74, stopColor: "#56B2F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.86, stopColor: "#33A5FB" }),
      /* @__PURE__ */ u("stop", { offset: 0.98, stopColor: "#0794FE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "c", x1: 6.939, x2: 12.398, y1: 19.77, y2: 29.357, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.29, stopColor: "#83C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.36, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.46, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.58, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.72, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.74, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "d", x1: 19.836, x2: 19.836, y1: 33.667, y2: 20.846, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#88C5F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.07, stopColor: "#A8D4F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.14, stopColor: "#C3E2FB" }),
      /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#D9ECFC" }),
      /* @__PURE__ */ u("stop", { offset: 0.3, stopColor: "#EAF5FD" }),
      /* @__PURE__ */ u("stop", { offset: 0.41, stopColor: "#F6FAFE" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#FDFEFE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#fff" })
    ] })
  ] })
] }), MH = N6, k6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 56 56", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#009CFC",
      d: "M26.449 16.466a33.758 33.758 0 0 0-3.825-4.427l2.046-.952c.163.899 1.107 1.67 1.482 2.502.43.956.562 2.155-.403 2.818-.354.244-.85.245-1.226.051-1.153-.596-1.666-2.14-2.913-2.585l1.422-1.553c.482 1.069 1.796 3.355-.2 3.785-1.462.314-2.251-1.489-3.423-1.979l1.73-1.441-.004-.027c.962 1.232-1.1 2.526-2.055 1.302a1.542 1.542 0 0 1-.262-.532c-.309-1.068.76-1.847 1.73-1.441.508.213.946.54 1.351.909.2.183.385.381.584.564.067.06.134.12.2.182.318.212.273.238-.135.076l-.832.388.103-.127-.322.883c0-.49-.586-1.354-.786-1.797-.355-.788.586-1.852 1.423-1.553.777.278 1.43.656 2.026 1.227.47.45.928 1.284 1.5 1.58l-1.225.051.123-.084-.534.759c.147-.528-.61-1.291-.886-1.687a5.261 5.261 0 0 1-.905-2.142c-.192-1.063 1.34-1.64 2.046-.952 1.549 1.51 2.96 3.15 4.224 4.902.916 1.268-1.143 2.565-2.054 1.302z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#a)",
      d: "M28.44 36.165c4.945 1.307 11.532 1.383 16.073-1.217 3.206-1.834 4.537-5.523 3.07-8.969-.532-1.251-2.367-3.89-4.048-3.518-.742.165-1.01.961-1.358 1.534a10.51 10.51 0 0 1-1.686 2.113c-2.525 2.423-5.415 3.093-8.035 3.632"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#b)",
      d: "M9.004 13.017c1.766-1.883 3.944.54 5.545 1.182.613.246 1.17.059 1.798.016a38.847 38.847 0 0 0 2.29-.201c2.14-.274 4.383.436 6.449.956.484.048.97.08 1.455.096.746.023 1.5.01 2.239-.106.855-.134 1.543-.542 2.33-.878.602-.257 1.47-.447 1.987.087.79.816.032 2.325-.098 3.261-.15 1.09-.296 2.196-.181 3.3 0 0-.742 2.25-.818 3.95-.189.536.162.453.802 3.683.577 2.909 1.012 5.942.301 9.933-.885 4.966-3.663 8.544-8.462 11.278a3.169 3.169 0 0 1-2.891.128l-2.39-1.093c-4.432-2.027-8.994-6.467-9.661-11.395l-.412-12.793c-.228-1.68.023-3.425.023-3.425.015-1.108-.228-2.8-.477-3.873-.24-1.042-.638-2.684-.1-3.72.078-.147.169-.274.273-.386z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "M25.132 52a.414.414 0 0 1-.407-.494 2.543 2.543 0 0 1 2.498-2.033c1.237 0 2.268.874 2.498 2.033a.414.414 0 0 1-.407.494zM16.768 52a.414.414 0 0 1-.407-.494 2.543 2.543 0 0 1 2.498-2.033c1.236 0 2.267.874 2.498 2.033a.414.414 0 0 1-.407.494h-4.183z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#c)",
      d: "M29.824 35.8a7.935 7.935 0 0 0-.572-1.035c-2.926-4.454-9.725-3.585-11.886 1.134-2.059 4.496.786 10.43 4.875 12.738 1.21.683 2.255-.112 3.283-.78 2.244-1.457 4.19-3.789 4.868-6.42.469-1.822.235-3.898-.567-5.637z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFBD00",
      fillRule: "evenodd",
      d: "m25.143 39.159-.915-.907a.517.517 0 0 1-.505-.13.508.508 0 0 1 0-.724c.201-.2.528-.2.73 0a.51.51 0 0 1 .13.501l.915.907a.772.772 0 0 1 .877.147c.3.297.3.778 0 1.075a.771.771 0 0 1-1.084 0 .756.756 0 0 1-.148-.87m-2.26-2.593c-.2.2-.527.2-.729 0a.508.508 0 0 1 0-.724c.202-.2.528-.2.73 0 .201.2.201.524 0 .724",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#17C553",
      fillRule: "evenodd",
      d: "m22.67 37.264.914-.907a.51.51 0 0 1 .131-.5c.202-.2.528-.2.73 0 .201.2.201.523 0 .721a.52.52 0 0 1-.506.131l-.914.907a.756.756 0 0 1-.148.87.77.77 0 0 1-1.084 0 .756.756 0 0 1 0-1.076.772.772 0 0 1 .877-.147m2.614-2.24a.508.508 0 0 1 0-.723c.201-.2.528-.2.73 0 .2.2.2.523 0 .723-.202.2-.529.2-.73 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008FF6",
      fillRule: "evenodd",
      d: "m24.592 34.811.914.907a.52.52 0 0 1 .506.13c.201.2.201.524 0 .723-.202.2-.528.2-.73 0a.51.51 0 0 1-.131-.5l-.915-.907a.772.772 0 0 1-.876-.147.755.755 0 0 1 0-1.076.77.77 0 0 1 1.084 0 .756.756 0 0 1 .148.87m2.259 2.593c.201-.2.527-.2.728 0 .201.2.201.523 0 .722-.201.2-.528.2-.728 0a.507.507 0 0 1 0-.722",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FF1A61",
      fillRule: "evenodd",
      d: "M24.45 38.953c.201.2.201.523 0 .722-.201.2-.527.2-.729 0a.507.507 0 0 1 0-.722c.201-.2.527-.2.729 0m2.614-2.241-.914.907a.51.51 0 0 1-.131.5c-.202.2-.528.2-.73 0a.507.507 0 0 1 0-.721.52.52 0 0 1 .506-.13l.914-.907a.756.756 0 0 1 .148-.87.77.77 0 0 1 1.084 0c.3.297.3.778 0 1.075a.772.772 0 0 1-.876.147z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#0092FF",
      d: "m6.25 22.278-.036-.839a.947.947 0 0 1 .69-.897c1.481-.398 5.993-1.246 11.186-.387 0 0 2.576.614 4.776.52l.127.016c2.201-.083 4.71-.903 4.71-.903 5.095-1.272 8.06-1.021 9.571-.743.408.075.72.417.77.838l.042.839c.018.373-.086.74-.294 1.043a6.703 6.703 0 0 0-.771 1.482c-.184.51-.096 1.075-.149 1.609-.303 3.095-1.797 4.345-1.797 4.345s-1.356 1.125-3.963 1.387c-1.43.144-2.486.013-3.431-.445l-.035-.017c-1.491-.73-2.637-2.046-3.211-3.635l-.461-1.274a.863.863 0 0 0-.906-.573v-.022a.853.853 0 0 0-.763.641l-.342 1.308c-.426 1.629-1.447 3.032-2.866 3.88-.01.006-.022.012-.033.02-.9.53-2.094.886-3.53.926-3.831.106-5.504-.912-5.504-.912s-1.604-1.125-2.191-4.184c-.102-.527-.065-1.097-.296-1.591a6.814 6.814 0 0 0-.905-1.414 1.723 1.723 0 0 1-.39-1.016v-.002z",
      opacity: 0.3
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#0092FF",
      d: "M36.377 22.984s-.098-2.568-2.058-2.648c-1.96-.079-5.28.233-6.956 1.023-1.673.79-1.69 1.74-1.436 3.26.303 1.806 1.628 4.334 4.634 4.398 2.972.064 4.462-.38 5.18-2.218.81-2.079.636-3.814.636-3.814zM9.284 24.42s-.125-2.567 1.821-2.813c1.946-.247 6.92-.587 8.657.057 1.736.644 1.835 1.589 1.714 3.125-.145 1.825-1.245 4.457-4.234 4.778-2.956.317-6.118.368-6.992-1.401-.988-2.003-.966-3.746-.966-3.746"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFBD00",
      stroke: "#FFBD00",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      d: "m24.506 25.031-1.293-1.086-1.837.771 3.06 4.374c.038.06.131.04.141-.03l.311-2.217a2.718 2.718 0 0 0-.383-1.812z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "m6.211 21.563-.033-.839a.961.961 0 0 1 .719-.9c1.534-.404 6.209-1.271 11.58-.434 0 0 2.665.605 4.943.503l.13.015c2.28-.094 4.881-.923 4.881-.923 5.279-1.294 7.654-.982 9.218-.71a.965.965 0 0 1 .793.836l.04.839c.017.372-.092.74-.308 1.045-.325.46-.605.958-.805 1.486-.193.512-.104 1.076-.16 1.61-.327 3.098-1.88 4.355-1.88 4.355s-.714 1.057-3.415 1.33c-1.479.15-2.573.023-3.549-.431l-.035-.017a6.485 6.485 0 0 1-3.31-3.624l-.472-1.273a.887.887 0 0 0-.937-.57c-.371.026-.692.26-.792.624l-.36 1.31a6.471 6.471 0 0 1-2.982 3.892l-.035.02c-.932.536-2.172.896-3.657.942-3.967.12-5.695-.889-5.695-.889s-1.655-1.12-2.25-4.177c-.103-.527-.063-1.097-.3-1.59a6.716 6.716 0 0 0-.93-1.411 1.679 1.679 0 0 1-.399-1.015z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#84C3F7",
      d: "M35.76 22.336s-.11-2.566-1.964-2.658c-1.854-.092-4.993.197-6.57.977-1.578.778-1.588 1.727-1.337 3.249.299 1.805 1.566 4.34 4.41 4.423 2.81.083 4.217-.351 4.883-2.184.754-2.073.578-3.808.578-3.808zM9.247 23.705s-.126-2.567 1.82-2.813c1.947-.247 6.92-.587 8.657.057 1.736.644 1.836 1.589 1.714 3.125-.145 1.825-1.244 4.457-4.233 4.778-2.956.317-6.118.368-6.992-1.401-.989-2.003-.966-3.746-.966-3.746"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "M16.757 22.67c-.043-.35-.033-.69.02-1.008a.886.886 0 0 0 1.367-.84.88.88 0 0 0-.545-.706c.242-.2.523-.33.834-.368 1.108-.135 2.155.955 2.338 2.434.183 1.48-.567 2.788-1.676 2.923-1.107.134-2.154-.955-2.338-2.434zM31.628 20.7a.878.878 0 0 0 .645-1.066.877.877 0 0 0-.435-.557c.145-.096.306-.169.48-.212 1.083-.268 2.257.686 2.62 2.132.365 1.446-.219 2.835-1.302 3.104-1.084.268-2.257-.686-2.62-2.132a3.393 3.393 0 0 1-.067-1.374c.196.12.438.165.68.105"
    }
  ),
  /* @__PURE__ */ u("path", { fill: "#FFBD00", d: "m24.189 24.556.37 4.452c.053.06.162.021.166-.057l.127-2.482a2.68 2.68 0 0 0-.663-1.913" }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#d)",
      d: "M10.061 30.392s-4.739 1.233-5.885 4.659c-.55 1.649.285 3.33 1.212 4.602.741 1.017 1.615 1.787 2.537 2.602.266.234.592.653.523 1.056-.069.404-.505.573-.697.904-.467.806.518 1.6 1.09 1.701.984.172 1.912-.576 2.635-1.338 1.012-1.066 1.638-2.573 1.953-4.02.61-2.807-.075-4.278-.075-4.278"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FD812D",
      d: "M49.36 11.312c0-2.591-2.116-4.691-4.728-4.692-2.612 0-4.73 2.099-4.73 4.689 0 1.246.499 2.441 1.388 3.322a4.478 4.478 0 0 1 1.367 3.175v.12h3.948v-.12a4.309 4.309 0 0 1 1.31-3.12 4.656 4.656 0 0 0 1.446-3.375h-.001z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#fff",
      d: "M45.786 13.01c-.387 0-.7.312-.7.695v.183h-.91v-.183a.698.698 0 0 0-.7-.695c-.388 0-.702.312-.702.695 0 .384.314.695.701.695h.184v3.952c0 .142.116.256.259.256a.257.257 0 0 0 .258-.256V14.4h.91v3.952c0 .142.114.256.257.256a.257.257 0 0 0 .258-.256V14.4h.185c.387 0 .7-.311.7-.695a.698.698 0 0 0-.7-.695m-2.495.695a.184.184 0 0 1 .369 0v.183h-.185a.184.184 0 0 1-.184-.183m2.495.183h-.184v-.183a.184.184 0 0 1 .369 0c0 .1-.084.183-.185.183"
    }
  ),
  /* @__PURE__ */ u("path", { fill: "#84C3F7", d: "M42.656 19.893h3.948v.311a.881.881 0 0 1-.885.878H43.54a.881.881 0 0 1-.885-.878z" }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008FF6",
      d: "M42.538 19.377h4.186c.244 0 .442.197.442.44a.441.441 0 0 1-.442.438h-4.186a.441.441 0 0 1-.443-.439c0-.242.199-.439.443-.439"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#84C3F7",
      d: "M42.538 18.493h4.186c.244 0 .442.196.442.438a.441.441 0 0 1-.442.44h-4.186a.441.441 0 0 1-.443-.44c0-.242.199-.438.443-.438"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008FF6",
      d: "M42.538 17.608h4.186c.244 0 .442.197.442.439a.441.441 0 0 1-.442.438h-4.186a.441.441 0 0 1-.443-.438c0-.242.199-.44.443-.44"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FD812D",
      d: "M44.63 5.682a.257.257 0 0 1-.258-.256v-1.17c0-.142.115-.256.258-.256.143 0 .258.114.258.256v1.17a.257.257 0 0 1-.258.256M41.666 6.47a.259.259 0 0 1-.224-.128l-.59-1.013a.256.256 0 0 1 .092-.351.26.26 0 0 1 .355.094l.59 1.014a.255.255 0 0 1-.222.383zM39.494 8.624a.26.26 0 0 1-.129-.035l-1.022-.585a.256.256 0 1 1 .256-.446s.002 0 .003.002l1.021.585a.256.256 0 0 1-.13.479M38.699 11.565h-1.18a.257.257 0 0 1-.258-.256c0-.142.115-.256.258-.256h1.18c.142 0 .258.114.258.256a.257.257 0 0 1-.258.256M38.472 15.092a.256.256 0 0 1-.129-.478l1.022-.585a.259.259 0 0 1 .352.096.254.254 0 0 1-.094.348l-1.021.585a.265.265 0 0 1-.129.034zM47.595 6.47a.258.258 0 0 1-.224-.383l.59-1.013a.26.26 0 0 1 .353-.097c.124.07.167.226.097.35 0 0 0 .002-.002.003l-.59 1.013a.259.259 0 0 1-.224.129zM49.767 8.624a.257.257 0 0 1-.13-.478l1.022-.586a.26.26 0 0 1 .354.092c.071.121.03.279-.093.35 0 0-.002 0-.003.002l-1.021.586a.265.265 0 0 1-.129.034M51.742 11.565h-1.18a.257.257 0 0 1-.258-.256c0-.142.116-.256.258-.256h1.18c.143 0 .258.114.258.256a.257.257 0 0 1-.258.256M50.79 15.092a.259.259 0 0 1-.13-.034l-1.021-.585a.255.255 0 0 1-.09-.352.26.26 0 0 1 .349-.092l1.022.585c.123.07.166.227.094.35a.26.26 0 0 1-.224.128z"
    }
  ),
  /* @__PURE__ */ I("defs", { children: [
    /* @__PURE__ */ I("linearGradient", { id: "a", x1: 33.226, x2: 47.882, y1: 28.121, y2: 33.787, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.16, stopColor: "#83C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.22, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.32, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.56, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.58, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "b", x1: 22.537, x2: 20.845, y1: 50.017, y2: 11.853, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.44, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.52, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.62, stopColor: "#6FBBF8" }),
      /* @__PURE__ */ u("stop", { offset: 0.74, stopColor: "#56B2F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.86, stopColor: "#33A5FB" }),
      /* @__PURE__ */ u("stop", { offset: 0.98, stopColor: "#0794FE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "c", x1: 23.655, x2: 23.655, y1: 48.899, y2: 31.851, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#88C5F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.07, stopColor: "#A8D4F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.14, stopColor: "#C3E2FB" }),
      /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#D9ECFC" }),
      /* @__PURE__ */ u("stop", { offset: 0.3, stopColor: "#EAF5FD" }),
      /* @__PURE__ */ u("stop", { offset: 0.41, stopColor: "#F6FAFE" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#FDFEFE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#fff" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "d", x1: 5.279, x2: 13.425, y1: 40.043, y2: 36.508, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#0092FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.03, stopColor: "#0594FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.23, stopColor: "#2FA8FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.39, stopColor: "#48B4FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.48, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.77, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.79, stopColor: "#84C3F7", stopOpacity: 0.98 }),
      /* @__PURE__ */ u("stop", { offset: 0.82, stopColor: "#84C3F7", stopOpacity: 0.92 }),
      /* @__PURE__ */ u("stop", { offset: 0.85, stopColor: "#84C3F7", stopOpacity: 0.82 }),
      /* @__PURE__ */ u("stop", { offset: 0.89, stopColor: "#84C3F7", stopOpacity: 0.67 }),
      /* @__PURE__ */ u("stop", { offset: 0.92, stopColor: "#84C3F7", stopOpacity: 0.49 }),
      /* @__PURE__ */ u("stop", { offset: 0.96, stopColor: "#84C3F7", stopOpacity: 0.27 }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#84C3F7", stopOpacity: 0 })
    ] })
  ] })
] }), $H = k6, D6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 48 44", ...e, children: [
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#a)",
      d: "M23.119 19.062c-8.55 5.422-13.56.812-15.865-2.573-.755-1.109-1.287 1.167-2.305.263-1.854-1.647-2.759-2.205-3.065-.79-.304 1.4-.34 2.837-.52 4.255-.22 1.739-.555 2.83-.376 4.574.303 2.94 1.937 4.752 4.262 6.478 4.214 3.129 13.741 2.353 16.717-4.502"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#0092FF",
      d: "M26.272 5.689a30.506 30.506 0 0 1 3.746-3.716L28.292.93c-.22.807-1.118 1.43-1.518 2.157-.46.836-.676 1.919.12 2.608.293.253.73.296 1.078.15 1.067-.445 1.649-1.81 2.786-2.111l-1.125-1.539c-.515.935-1.865 2.91-.14 3.472 1.264.412 2.111-1.167 3.186-1.515l-1.406-1.463.006-.024c-.951 1.043.76 2.399 1.705 1.364.124-.136.21-.29.276-.464.362-.949-.516-1.75-1.406-1.463-.467.151-.88.412-1.27.715-.192.15-.37.316-.562.465-.064.05-.128.1-.192.148-.298.167-.26.194.114.082l.701.425-.08-.125.21.834c.042-.448.631-1.186.844-1.574.38-.688-.36-1.74-1.126-1.539-.708.188-1.316.477-1.89.948-.452.371-.926 1.093-1.457 1.315l1.078.151-.102-.088.408.738c-.085-.495.647-1.127.923-1.465a4.89 4.89 0 0 0 .977-1.879C30.69.3 29.386-.357 28.705.21a33.79 33.79 0 0 0-4.139 4.115c-.914 1.08.794 2.44 1.705 1.364z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#b)",
      d: "M42.015 19.655s4.68 1.227 5.811 4.638c.544 1.642-.28 3.316-1.197 4.582-.731 1.012-1.594 1.78-2.504 2.59-.263.234-.585.651-.517 1.052.068.402.499.57.688.9.462.803-.511 1.594-1.076 1.694-.972.17-1.888-.574-2.602-1.332-1-1.062-1.617-2.562-1.928-4.003-.603-2.794.074-4.26.074-4.26"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#c)",
      d: "M44.502 4.889c-.478-.609-1.397-.505-2.047-.303-.852.264-1.609.614-2.509.66-.776.042-1.56-.025-2.328-.13a22.734 22.734 0 0 1-1.612-.28 15.618 15.618 0 0 0-3.285-.84c-2.222-.317-4.559-.238-6.717.272-.505.043-1.01.07-1.516.078-.776.013-1.561-.012-2.328-.143-.889-.153-1.598-.588-2.413-.95-.622-.276-1.522-.488-2.069.062-.833.837-.068 2.42.053 3.396.141 1.137.275 2.29.138 3.437 0 0-.445 2.518-.392 4.288l.356 11.817c.156 5.173 2.909 9.887 7.28 12.46l2.354 1.387c.918.541 2.033.606 3.009.177l2.502-1.102c4.646-2.043 7.94-6.402 8.707-11.521l1.757-11.694c.262-1.745.059-4.307.059-4.307 0-1.155.27-2.284.546-3.398.236-.954 1.185-2.436.456-3.365z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#d)",
      d: "M36.568 30.566c-.408 4.909-4.689 9.103-7.281 9.151-1.863.034-6.084-5.248-5.676-10.156.408-4.91 3.558-7.68 7.136-7.401 3.578.278 6.23 3.497 5.822 8.407z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFBD00",
      fillRule: "evenodd",
      d: "m30.285 30.055-.984-1.01a.544.544 0 0 1-.543-.145.58.58 0 0 1 0-.804.545.545 0 0 1 .784 0 .578.578 0 0 1 .14.557l.985 1.009a.809.809 0 0 1 .943.163.862.862 0 0 1 0 1.196.81.81 0 0 1-1.166 0 .864.864 0 0 1-.16-.968m-2.43-2.884a.545.545 0 0 1-.784 0 .58.58 0 0 1 0-.804.545.545 0 0 1 .784 0 .58.58 0 0 1 0 .804",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#17C553",
      fillRule: "evenodd",
      d: "m27.625 27.948.984-1.01a.578.578 0 0 1 .14-.557.545.545 0 0 1 .785 0 .58.58 0 0 1 0 .804.544.544 0 0 1-.543.145l-.984 1.01a.864.864 0 0 1-.159.968.81.81 0 0 1-1.166 0 .862.862 0 0 1 0-1.197.809.809 0 0 1 .943-.163m2.813-2.493a.58.58 0 0 1 0-.804.545.545 0 0 1 .784 0 .58.58 0 0 1 0 .804.545.545 0 0 1-.784 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#008FF6",
      fillRule: "evenodd",
      d: "m29.693 25.217.984 1.009a.544.544 0 0 1 .543.145.58.58 0 0 1 0 .804.545.545 0 0 1-.784 0 .578.578 0 0 1-.141-.557l-.984-1.009a.809.809 0 0 1-.943-.163.862.862 0 0 1 0-1.197.81.81 0 0 1 1.166 0 .864.864 0 0 1 .159.968m2.43 2.886a.545.545 0 0 1 .784 0 .58.58 0 0 1 0 .804.545.545 0 0 1-.784 0 .58.58 0 0 1 0-.804",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FF1A61",
      fillRule: "evenodd",
      d: "M29.54 29.826a.58.58 0 0 1 0 .803.545.545 0 0 1-.784 0 .58.58 0 0 1 0-.803.545.545 0 0 1 .784 0m2.812-2.494-.984 1.009a.578.578 0 0 1-.14.557.545.545 0 0 1-.785 0 .58.58 0 0 1 0-.804.544.544 0 0 1 .543-.145l.984-1.01a.864.864 0 0 1 .16-.968.81.81 0 0 1 1.165 0 .862.862 0 0 1 0 1.197.809.809 0 0 1-.943.163z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "url(#e)",
      d: "M9.996 16.31c1.006 1.092.988 3.402 1.173 4.833.64 4.959-.828 6.475-5.244 8.444-1.697.757-2.974.042-3.8-1.456C.988 26.077.242 23.837.068 21.473c-.1-1.355-.108-2.727.092-4.073.099-.67.25-1.335.476-1.973.187-.53.519-1.047.607-1.61.192-1.224-.316-2.938.831-3.795.658-.49 1.62-.418 2.308-.029 1.182.669.891 2.372 1.328 3.48.838 2.125 2.815 1.324 4.226 2.774z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "M28.612 43.677a.506.506 0 0 0 .486-.61c-.277-1.431-1.508-2.511-2.985-2.511-1.477 0-2.709 1.08-2.985 2.511a.506.506 0 0 0 .486.61zM36.363 41.605a.374.374 0 0 0 .359-.451c-.204-1.058-1.114-1.856-2.206-1.856-1.092 0-2.002.798-2.206 1.856a.374.374 0 0 0 .36.45z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#0092FF",
      d: "m46.281 12.01.035-.834a.942.942 0 0 0-.682-.893c-1.462-.397-5.917-1.24-11.044-.386 0 0-2.544.612-4.717.519l-.125.015c-2.173-.083-4.65-.899-4.65-.899-5.031-1.267-7.959-1.017-9.452-.74a.955.955 0 0 0-.76.835l-.041.835c-.019.371.085.736.29 1.039.308.456.573.95.761 1.475.182.508.095 1.07.147 1.601.3 3.082 1.775 4.327 1.775 4.327s1.339 1.12 3.914 1.38c1.41.144 2.454.014 3.387-.442l.034-.017c1.473-.727 2.605-2.037 3.172-3.619l.455-1.269a.852.852 0 0 1 .894-.57v-.023a.844.844 0 0 1 .753.64l.338 1.301c.421 1.622 1.43 3.019 2.83 3.863l.033.02c.888.529 2.068.883 3.486.923 3.783.105 5.435-.908 5.435-.908s1.584-1.121 2.163-4.167c.1-.525.064-1.092.292-1.583.235-.506.545-.978.894-1.408.232-.285.368-.641.384-1.012v-.002z",
      opacity: 0.3
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#0092FF",
      d: "M16.532 12.713s.097-2.557 2.033-2.636c1.936-.08 5.214.23 6.868 1.018 1.653.787 1.67 1.731 1.418 3.246-.299 1.798-1.607 4.315-4.575 4.379-2.935.063-4.407-.38-5.115-2.209-.8-2.07-.629-3.797-.629-3.797zM43.285 14.144s.123-2.556-1.798-2.8c-1.922-.247-6.833-.585-8.548.056-1.715.641-1.813 1.582-1.693 3.112.143 1.816 1.229 4.437 4.18 4.756 2.92.316 6.042.367 6.905-1.395.975-1.994.953-3.73.953-3.73"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFBD00",
      stroke: "#FFBD00",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      d: "m28.254 14.752 1.277-2.077 1.813 1.763-3.021 4.355c-.037.06-.13.04-.14-.03l-.306-2.207a2.725 2.725 0 0 1 .378-1.804z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "m46.319 11.298.032-.835a.956.956 0 0 0-.71-.896c-1.514-.403-6.13-1.266-11.435-.432 0 0-2.63.602-4.88.5l-.13.015c-2.25-.093-4.818-.919-4.818-.919-5.213-1.287-7.558-.978-9.102-.706a.957.957 0 0 0-.784.832l-.04.835c-.016.371.092.737.305 1.041.32.458.598.954.795 1.479.19.51.103 1.072.158 1.603.323 3.084 1.855 4.336 1.855 4.336s.706 1.053 3.373 1.324c1.46.149 2.54.023 3.505-.43l.034-.016a6.436 6.436 0 0 0 3.27-3.608l.465-1.267a.875.875 0 0 1 .925-.567.853.853 0 0 1 .782.62l.355 1.304a6.437 6.437 0 0 0 2.945 3.876l.034.02c.921.533 2.145.892 3.612.938 3.917.12 5.623-.885 5.623-.885s1.635-1.115 2.223-4.16c.1-.525.062-1.091.296-1.582a6.7 6.7 0 0 1 .919-1.405c.239-.285.377-.64.392-1.011z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#84C3F7",
      d: "M17.142 12.069s.109-2.555 1.938-2.647c1.831-.09 4.93.197 6.489.973 1.557.775 1.567 1.72 1.32 3.235-.296 1.797-1.547 4.32-4.355 4.404-2.776.082-4.164-.35-4.822-2.175-.744-2.063-.57-3.791-.57-3.791zM43.322 13.43s.124-2.555-1.798-2.8c-1.922-.246-6.833-.584-8.548.057-1.715.641-1.813 1.582-1.693 3.112.143 1.816 1.23 4.437 4.18 4.756 2.92.316 6.042.367 6.905-1.395.976-1.994.954-3.73.954-3.73"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#1A1A1A",
      d: "M39.244 15.192a3.5 3.5 0 0 0-.163-.99.876.876 0 1 1-1.023-1.409 1.577 1.577 0 0 0-.867-.244c-1.102.024-1.97 1.246-1.938 2.729.032 1.483.952 2.666 2.053 2.642 1.102-.024 1.97-1.246 1.938-2.729M23.553 13.417a.874.874 0 0 1-.436-1.57 1.501 1.501 0 0 0-.5-.14c-1.097-.111-2.108.995-2.258 2.47-.15 1.476.618 2.763 1.715 2.875 1.097.111 2.108-.995 2.258-2.47a3.4 3.4 0 0 0-.131-1.363.87.87 0 0 1-.65.199z"
    }
  ),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#FFBD00",
      d: "m28.567 14.28-.366 4.432c-.052.059-.16.02-.164-.057l-.125-2.47c-.036-.702.196-1.374.655-1.905"
    }
  ),
  /* @__PURE__ */ I("defs", { children: [
    /* @__PURE__ */ I("linearGradient", { id: "a", x1: 21.267, x2: 2.816, y1: 15.743, y2: 28.188, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#84C3F7", stopOpacity: 0 }),
      /* @__PURE__ */ u("stop", { offset: 0.16, stopColor: "#84C3F7", stopOpacity: 0.05 }),
      /* @__PURE__ */ u("stop", { offset: 0.17, stopColor: "#83C3F7", stopOpacity: 0.19 }),
      /* @__PURE__ */ u("stop", { offset: 0.19, stopColor: "#83C3F7", stopOpacity: 0.4 }),
      /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#83C3F7", stopOpacity: 0.58 }),
      /* @__PURE__ */ u("stop", { offset: 0.23, stopColor: "#83C3F7", stopOpacity: 0.73 }),
      /* @__PURE__ */ u("stop", { offset: 0.25, stopColor: "#83C3F7", stopOpacity: 0.83 }),
      /* @__PURE__ */ u("stop", { offset: 0.27, stopColor: "#83C3F7", stopOpacity: 0.89 }),
      /* @__PURE__ */ u("stop", { offset: 0.28, stopColor: "#83C3F7", stopOpacity: 0.91 }),
      /* @__PURE__ */ u("stop", { offset: 0.35, stopColor: "#83C3F7", stopOpacity: 0.95 }),
      /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#83C3F7", stopOpacity: 0.99 }),
      /* @__PURE__ */ u("stop", { offset: 0.6, stopColor: "#83C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.64, stopColor: "#6AB9F8" }),
      /* @__PURE__ */ u("stop", { offset: 0.72, stopColor: "#44ABFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.79, stopColor: "#26A0FC" }),
      /* @__PURE__ */ u("stop", { offset: 0.86, stopColor: "#1198FD" }),
      /* @__PURE__ */ u("stop", { offset: 0.93, stopColor: "#0493FE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "b", x1: 46.735, x2: 38.67, y1: 29.262, y2: 25.791, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#0092FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.03, stopColor: "#0594FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.23, stopColor: "#2FA8FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.39, stopColor: "#48B4FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.48, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.77, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.79, stopColor: "#84C3F7", stopOpacity: 0.98 }),
      /* @__PURE__ */ u("stop", { offset: 0.82, stopColor: "#84C3F7", stopOpacity: 0.92 }),
      /* @__PURE__ */ u("stop", { offset: 0.85, stopColor: "#84C3F7", stopOpacity: 0.82 }),
      /* @__PURE__ */ u("stop", { offset: 0.89, stopColor: "#84C3F7", stopOpacity: 0.67 }),
      /* @__PURE__ */ u("stop", { offset: 0.92, stopColor: "#84C3F7", stopOpacity: 0.49 }),
      /* @__PURE__ */ u("stop", { offset: 0.96, stopColor: "#84C3F7", stopOpacity: 0.27 }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#84C3F7", stopOpacity: 0 })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "c", x1: 28.931, x2: 31.114, y1: 40.551, y2: 3.697, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { offset: 0.38, stopColor: "#84C3F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.43, stopColor: "#7EC1F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.5, stopColor: "#6FBEFA" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#56B9FE" }),
      /* @__PURE__ */ u("stop", { offset: 0.58, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "d", x1: 29.313, x2: 30.725, y1: 39.724, y2: 22.158, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#88C5F7" }),
      /* @__PURE__ */ u("stop", { offset: 0.07, stopColor: "#A8D4F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.14, stopColor: "#C3E2FB" }),
      /* @__PURE__ */ u("stop", { offset: 0.21, stopColor: "#D9ECFC" }),
      /* @__PURE__ */ u("stop", { offset: 0.3, stopColor: "#EAF5FD" }),
      /* @__PURE__ */ u("stop", { offset: 0.41, stopColor: "#F6FAFE" }),
      /* @__PURE__ */ u("stop", { offset: 0.57, stopColor: "#FDFEFE" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#fff" })
    ] }),
    /* @__PURE__ */ I("linearGradient", { id: "e", x1: 10.059, x2: -0.962, y1: 25.958, y2: 14.934, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u("stop", { stopColor: "#99CDF8" }),
      /* @__PURE__ */ u("stop", { offset: 0.1, stopColor: "#93CBF8" }),
      /* @__PURE__ */ u("stop", { offset: 0.22, stopColor: "#84C7F9" }),
      /* @__PURE__ */ u("stop", { offset: 0.35, stopColor: "#6BBFFC" }),
      /* @__PURE__ */ u("stop", { offset: 0.45, stopColor: "#51B8FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.5, stopColor: "#52B9FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.6, stopColor: "#4CB6FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.72, stopColor: "#3DAFFF" }),
      /* @__PURE__ */ u("stop", { offset: 0.85, stopColor: "#24A3FF" }),
      /* @__PURE__ */ u("stop", { offset: 0.99, stopColor: "#0293FF" }),
      /* @__PURE__ */ u("stop", { offset: 1, stopColor: "#0092FF" })
    ] })
  ] })
] }), PH = D6, F6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 12 12", ...e, children: [
  /* @__PURE__ */ u("path", { fill: "#FFE1D9", d: "M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6" }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#C62C02",
      stroke: "#C62C02",
      strokeWidth: 0.25,
      d: "m2.719 7.743.007.026.01.034c.004.01.01.02.015.029l.013.026c.01.017.023.034.037.048l.01.01c.012.01.023.021.036.03.007.006.016.01.024.014l.027.016.031.01.025.008A.282.282 0 0 0 3.01 8h2.388c.166 0 .3-.143.3-.32 0-.177-.134-.32-.3-.32H3.735l2.127-2.285 1.225 1.104h.001c.007.008.015.013.022.02l.025.022.022.012.03.017.024.007c.01.004.02.008.032.01l.027.003.03.003.03-.003c.01 0 .018 0 .027-.003.011-.002.022-.006.033-.01l.023-.007.03-.017.022-.012.025-.022c.007-.007.015-.012.022-.02L9 4.791a.335.335 0 0 0 0-.453.29.29 0 0 0-.213-.093.29.29 0 0 0-.212.094L7.3 5.5 6.075 4.395l-.031-.027c-.006-.004-.01-.01-.017-.014-.01-.007-.02-.012-.031-.018l-.02-.011-.037-.012c-.007-.001-.013-.004-.02-.006a.289.289 0 0 0-.114 0c-.01.002-.019.006-.028.01-.01.002-.019.004-.027.008-.01.004-.017.01-.026.014l-.027.015-.018.016c-.01.008-.02.015-.029.025l-2.337 2.51V5.32c0-.177-.134-.32-.3-.32-.166 0-.3.143-.3.32v2.36c0 .021.002.042.006.063Z"
    }
  )
] }), R6 = F6, _6 = (e) => /* @__PURE__ */ I("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 12 12", ...e, children: [
  /* @__PURE__ */ u("path", { fill: "#DBF2D3", d: "M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6" }),
  /* @__PURE__ */ u(
    "path",
    {
      fill: "#666",
      stroke: "#44812F",
      strokeWidth: 0.25,
      d: "m9.281 4.502-.007-.026-.01-.034c-.004-.01-.01-.02-.015-.029l-.013-.026A.317.317 0 0 0 9.2 4.34l-.01-.01a.281.281 0 0 0-.036-.03c-.007-.006-.016-.01-.024-.014l-.027-.016-.031-.01-.025-.008a.282.282 0 0 0-.055-.005H6.603c-.166 0-.3.142-.3.319 0 .177.134.32.3.32h1.662L6.138 7.17 4.913 6.066h-.001c-.007-.008-.015-.013-.022-.02-.008-.007-.016-.015-.025-.021l-.022-.013-.03-.017-.024-.007c-.01-.004-.02-.008-.032-.01l-.027-.003-.03-.003-.03.003-.027.003c-.011.002-.022.006-.033.01l-.023.007-.03.017-.022.013c-.009.006-.017.014-.025.022l-.022.018v.001L3 7.454a.335.335 0 0 0 0 .453.29.29 0 0 0 .213.093.29.29 0 0 0 .212-.094L4.7 6.746 5.925 7.85l.031.027c.006.004.01.01.017.014.01.007.02.012.031.018l.02.011.037.012c.007.001.013.004.02.006a.29.29 0 0 0 .114 0c.01-.002.019-.006.028-.01.01-.002.019-.004.027-.008.01-.004.017-.01.026-.014l.027-.015.018-.016c.01-.008.02-.015.029-.025l2.337-2.51v1.585c0 .177.134.32.3.32.166 0 .3-.143.3-.32v-2.36a.337.337 0 0 0-.006-.063Z"
    }
  )
] }), I6 = _6, q0 = nt("", {
  variants: {
    size: {
      "x-small": 12,
      small: 16,
      default: 24,
      large: 28,
      "x-large": 48
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function Fe({ size: e, IconSVG: t, className: n }) {
  return /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ u(t, { width: q0({ size: e }), height: q0({ size: e }), className: le(n) }) });
}
const b2 = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u("span", { className: "rabbit-ds", children: /* @__PURE__ */ u(
  d2,
  {
    ref: n,
    className: le(
      "h-4 w-4 shrink-0 rounded-sm border-2 bg-transparent border-primary-focus ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-focus data-[state=checked]:text-white",
      e,
      "rabbit-ds"
    ),
    ...t,
    children: /* @__PURE__ */ u(Hy, { className: le("flex items-center justify-center text-current rabbit-ds"), children: /* @__PURE__ */ u(Fe, { IconSVG: Ys, size: "x-small" }) })
  }
) }));
b2.displayName = d2.displayName;
const md = b2, x2 = /* @__PURE__ */ Y((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...a } = e, [i = !1, s] = wt({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ F(Ee.button, K({
    type: "button",
    "aria-pressed": i,
    "data-state": i ? "on" : "off",
    "data-disabled": e.disabled ? "" : void 0
  }, a, {
    ref: t,
    onClick: ve(e.onClick, () => {
      e.disabled || s(!i);
    })
  }));
}), L6 = x2;
function TH({ icon: e, count: t, label: n, selected: r = !1, onSelectedChange: o }) {
  return /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ I(
    L6,
    {
      defaultPressed: r,
      onPressedChange: o,
      className: le(
        "px-4 py-1 rounded-full border flex-row justify-center items-center gap-1 flex hover:cursor-pointer",
        "data-[state=off]:border-gray-100 data-[state=off]:bg-gray-100 data-[state=off]:text-font-secondary",
        "data-[state=on]:border-primary-hover data-[state=on]:bg-primary/10 data-[state=on]:text-primary-hover",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
      ),
      children: [
        e ? /* @__PURE__ */ u(Fe, { IconSVG: e, size: "small" }) : null,
        /* @__PURE__ */ I("div", { className: "text-sm font-semibold", children: [
          n ? /* @__PURE__ */ u("span", { children: n }) : null,
          " ",
          t ? /* @__PURE__ */ I("span", { children: [
            "(",
            t,
            ")"
          ] }) : null
        ] })
      ]
    }
  ) });
}
const gd = Y(({ className: e, type: t, ...n }, r) => /* @__PURE__ */ I("div", { className: "rabbit-ds group relative font-sans", children: [
  /* @__PURE__ */ u(
    "input",
    {
      type: t,
      className: le(
        "peer text-sm min-w-[224px] w-full h-9 px-3 py-2.5 bg-white rounded border border-[#999999] gap-2.5 focus:outline-none hover:outline-none focus:border-primary-focus hover:border-font-primary hover:placeholder:text-font-primary disabled:pointer-events-none disabled:bg-neutral-50 disabled:border-neutral-100 disable:text-neutral-400",
        e,
        t === "search" ? "pl-8" : ""
      ),
      ref: r,
      ...n
    }
  ),
  t === "search" ? /* @__PURE__ */ u("div", { className: "pointer-events-none absolute inset-y-0 left-0 mx-2 my-auto flex h-5 w-5 items-center justify-center p-0.5 text-neutral-400 group-hover:text-[#333333] peer-focus:text-[#333333]", children: /* @__PURE__ */ u(Fe, { IconSVG: v6 }) }) : null
] }));
gd.displayName = "Input";
gd.defaultProps = {
  className: ""
};
const B6 = gd, z6 = /* @__PURE__ */ Y((e, t) => /* @__PURE__ */ F(Ee.label, K({}, e, {
  ref: t,
  onMouseDown: (n) => {
    var r;
    (r = e.onMouseDown) === null || r === void 0 || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault();
  }
}))), w2 = z6, W6 = nt("text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), A2 = Z.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ u(w2, { ref: n, className: le(W6(), e), ...t }) }));
A2.displayName = w2.displayName;
const j6 = A2, C2 = "Progress", Gs = 100, [V6, OH] = gt(C2), [H6, U6] = V6(C2), S2 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeProgress: n, value: r, max: o, getValueLabel: a = X6, ...i } = e, s = Ic(o) ? o : Gs, l = M2(r, s) ? r : null, c = as(l) ? a(l, s) : void 0;
  return /* @__PURE__ */ F(H6, {
    scope: n,
    value: l,
    max: s
  }, /* @__PURE__ */ F(Ee.div, K({
    "aria-valuemax": s,
    "aria-valuemin": 0,
    "aria-valuenow": as(l) ? l : void 0,
    "aria-valuetext": c,
    role: "progressbar",
    "data-state": E2(l, s),
    "data-value": l ?? void 0,
    "data-max": s
  }, i, {
    ref: t
  })));
});
S2.propTypes = {
  max(e, t, n) {
    const r = e[t], o = String(r);
    return r && !Ic(r) ? new Error(q6(o, n)) : null;
  },
  value(e, t, n) {
    const r = e[t], o = String(r), a = Ic(e.max) ? e.max : Gs;
    return r != null && !M2(r, a) ? new Error(K6(o, n)) : null;
  }
};
const Y6 = "ProgressIndicator", G6 = /* @__PURE__ */ Y((e, t) => {
  var n;
  const { __scopeProgress: r, ...o } = e, a = U6(Y6, r);
  return /* @__PURE__ */ F(Ee.div, K({
    "data-state": E2(a.value, a.max),
    "data-value": (n = a.value) !== null && n !== void 0 ? n : void 0,
    "data-max": a.max
  }, o, {
    ref: t
  }));
});
function X6(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function E2(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function as(e) {
  return typeof e == "number";
}
function Ic(e) {
  return as(e) && !isNaN(e) && e > 0;
}
function M2(e, t) {
  return as(e) && !isNaN(e) && e <= t && e >= 0;
}
function q6(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Gs}\`.`;
}
function K6(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Gs} if no \`max\` prop is set)
  - \`null\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
const Q6 = S2, Z6 = G6;
var ua = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Do(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Vr(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Xs = {}, qs = {};
Object.defineProperty(qs, "__esModule", { value: !0 });
qs.defaultOptions = void 0;
qs.defaultOptions = {
  lowercase: !1,
  precision: 1,
  space: !1,
  units: [
    "",
    "K",
    "M",
    "B",
    "T",
    "P",
    "E"
    // Quintillion
  ]
};
var Sn = {};
Object.defineProperty(Sn, "__esModule", { value: !0 });
Sn.getLocales = Sn.getFractionDigits = Sn.roundTo = Sn.parseValue = void 0;
function J6(e) {
  const t = parseFloat(e == null ? void 0 : e.toString());
  if (isNaN(t))
    throw new Error("Input value is not a number");
  if (t > Number.MAX_SAFE_INTEGER || t < Number.MIN_SAFE_INTEGER)
    throw new RangeError("Input value is outside of safe integer range");
  return t;
}
Sn.parseValue = J6;
function e7(e, t) {
  if (!Number.isFinite(e))
    throw new Error("Input value is not a finite number");
  if (!Number.isInteger(t) || t < 0)
    throw new Error("Precision is not a positive integer");
  return Number.isInteger(e) ? e : parseFloat(e.toFixed(t));
}
Sn.roundTo = e7;
function t7(e) {
  var t;
  if (Number.isInteger(e))
    return 0;
  const n = e.toString().split(".")[1];
  return (t = n == null ? void 0 : n.length) !== null && t !== void 0 ? t : 0;
}
Sn.getFractionDigits = t7;
function n7() {
  var e;
  return typeof navigator > "u" ? [] : Array.from((e = navigator.languages) !== null && e !== void 0 ? e : []);
}
Sn.getLocales = n7;
Object.defineProperty(Xs, "__esModule", { value: !0 });
Xs.millify = void 0;
const K0 = qs, xi = Sn, Q0 = 1e3;
function* Z0(e) {
  let t = Q0;
  for (; ; ) {
    const n = e / t;
    if (n < 1)
      return;
    yield n, t *= Q0;
  }
}
function $2(e, t) {
  var n, r;
  const o = t ? { ...K0.defaultOptions, ...t } : K0.defaultOptions;
  if (!Array.isArray(o.units) || !o.units.length)
    throw new Error("Option `units` must be a non-empty array");
  let a;
  try {
    a = xi.parseValue(e);
  } catch (h) {
    return h instanceof Error && console.warn(`WARN: ${h.message} (millify)`), String(e);
  }
  const i = a < 0 ? "-" : "";
  a = Math.abs(a);
  let s = 0;
  for (const h of Z0(a))
    a = h, s += 1;
  if (s >= o.units.length)
    return e.toString();
  let c = xi.roundTo(a, o.precision);
  for (const h of Z0(c))
    c = h, s += 1;
  const d = (n = o.units[s]) !== null && n !== void 0 ? n : "", f = o.lowercase ? d.toLowerCase() : d, p = o.space ? " " : "", m = c.toLocaleString((r = o.locales) !== null && r !== void 0 ? r : xi.getLocales(), {
    // toLocaleString needs the explicit fraction digits.
    minimumFractionDigits: xi.getFractionDigits(c)
  });
  return `${i}${m}${p}${f}`;
}
Xs.millify = $2;
var Gi = Xs.default = $2, ut = /* @__PURE__ */ ((e) => (e.CLOSED_ACHIEVED = "CLOSED_ACHIEVED", e.CLOSED_DROPPED = "CLOSED_DROPPED", e.CLOSED_NOT_ACHIEVED = "CLOSED_NOT_ACHIEVED", e.ON_TRACK = "ON_TRACK", e.OFF_TRACK = "OFF_TRACK", e.AT_RISK = "AT_RISK", e))(ut || {});
const fo = {
  [ut.ON_TRACK]: { backgroundColor: "#EAEAEA", indicatorColor: "#EFFFEA", textColor: "#44812F" },
  [ut.OFF_TRACK]: { backgroundColor: "#EAEAEA", indicatorColor: "#FFF6D3", textColor: "#8C6A00" },
  [ut.AT_RISK]: { backgroundColor: "#EAEAEA", indicatorColor: "#FFF1E4", textColor: "#C62C02" },
  [ut.CLOSED_ACHIEVED]: { backgroundColor: "#EAEAEA", indicatorColor: "#DBF2D3", textColor: "#1A5724" },
  [ut.CLOSED_DROPPED]: { backgroundColor: "#EAEAEA", indicatorColor: "#CCCCCC", textColor: "#666666" },
  [ut.CLOSED_NOT_ACHIEVED]: { backgroundColor: "#EAEAEA", indicatorColor: "#FFE1D9", textColor: "#A12402" }
}, Bl = {
  [ut.ON_TRACK]: "On-track",
  [ut.OFF_TRACK]: "Off-track",
  [ut.AT_RISK]: "At-risk",
  [ut.CLOSED_ACHIEVED]: "Closed & achieved",
  [ut.CLOSED_DROPPED]: "Closed & dropped",
  [ut.CLOSED_NOT_ACHIEVED]: "Closed & not achieved"
};
function r7({ progressInPercentage: e = 0, status: t = ut.ON_TRACK }) {
  const { backgroundColor: n, indicatorColor: r, textColor: o } = fo[t] ? fo[t] : fo[ut.ON_TRACK];
  return /* @__PURE__ */ I(
    Q6,
    {
      className: "rabbit-ds relative box-border inline-flex h-5 w-full min-w-[210px] items-start  justify-start  overflow-hidden rounded-md",
      style: {
        // Fix overflow clipping in Safari
        // https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0
        transform: "translateZ(0)",
        // Not available in tailwind
        backgroundColor: n
      },
      value: e,
      children: [
        /* @__PURE__ */ u(
          Z6,
          {
            className: "duration-[660ms] ease-[cubic-bezier(0.65,0,0.35,1)] h-full w-full transition-transform",
            style: {
              transform: `translateX(-${100 - e > 100 ? 100 : 100 - e}%)`,
              backgroundColor: r
            }
          }
        ),
        /* @__PURE__ */ u("div", { className: "absolute left-0 top-0 inline-flex items-center justify-start", children: /* @__PURE__ */ u("div", { className: "inline-flex items-center justify-start px-1 py-0.5", children: /* @__PURE__ */ u("div", { className: "text-xs font-semibold", style: { color: o }, children: Bl[t] ? Bl[t] : Bl[ut.ON_TRACK] }) }) }),
        /* @__PURE__ */ u("div", { className: "absolute right-0 top-0 inline-flex items-center justify-start px-1 py-0.5", children: /* @__PURE__ */ I("div", { className: "text-right text-xs font-semibold", style: { color: o }, children: [
          Gi(e),
          "%"
        ] }) })
      ]
    }
  );
}
function is(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
const o7 = /* @__PURE__ */ tn(void 0);
function vr(e) {
  const t = Xe(o7);
  return e || t || "ltr";
}
function Hr(e) {
  const t = e + "CollectionProvider", [n, r] = gt(t), [o, a] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), i = (m) => {
    const { scope: h, children: g } = m, x = R.useRef(null), y = R.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ R.createElement(o, {
      scope: h,
      itemMap: y,
      collectionRef: x
    }, g);
  }, s = e + "CollectionSlot", l = /* @__PURE__ */ R.forwardRef((m, h) => {
    const { scope: g, children: x } = m, y = a(s, g), b = De(h, y.collectionRef);
    return /* @__PURE__ */ R.createElement($n, {
      ref: b
    }, x);
  }), c = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ R.forwardRef((m, h) => {
    const { scope: g, children: x, ...y } = m, b = R.useRef(null), v = De(h, b), A = a(c, g);
    return R.useEffect(() => (A.itemMap.set(b, {
      ref: b,
      ...y
    }), () => void A.itemMap.delete(b))), /* @__PURE__ */ R.createElement($n, {
      [d]: "",
      ref: v
    }, x);
  });
  function p(m) {
    const h = a(e + "CollectionConsumer", m);
    return R.useCallback(() => {
      const x = h.collectionRef.current;
      if (!x)
        return [];
      const y = Array.from(x.querySelectorAll(`[${d}]`));
      return Array.from(h.itemMap.values()).sort(
        (A, w) => y.indexOf(A.ref.current) - y.indexOf(w.ref.current)
      );
    }, [
      h.collectionRef,
      h.itemMap
    ]);
  }
  return [
    {
      Provider: i,
      Slot: l,
      ItemSlot: f
    },
    p,
    r
  ];
}
const P2 = [
  "PageUp",
  "PageDown"
], T2 = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], O2 = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, Ba = "Slider", [Lc, a7, i7] = Hr(Ba), [N2, NH] = gt(Ba, [
  i7
]), [s7, Ks] = N2(Ba), l7 = /* @__PURE__ */ Y((e, t) => {
  const { name: n, min: r = 0, max: o = 100, step: a = 1, orientation: i = "horizontal", disabled: s = !1, minStepsBetweenThumbs: l = 0, defaultValue: c = [
    r
  ], value: d, onValueChange: f = () => {
  }, onValueCommit: p = () => {
  }, inverted: m = !1, ...h } = e, [g, x] = we(null), y = De(
    t,
    (W) => x(W)
  ), b = de(/* @__PURE__ */ new Set()), v = de(0), A = i === "horizontal", w = g ? !!g.closest("form") : !0, M = A ? c7 : u7, [$ = [], P] = wt({
    prop: d,
    defaultProp: c,
    onChange: (W) => {
      var S;
      (S = [
        ...b.current
      ][v.current]) === null || S === void 0 || S.focus(), f(W);
    }
  }), E = de($);
  function T(W) {
    const S = b7($, W);
    V(W, S);
  }
  function B(W) {
    V(W, v.current);
  }
  function j() {
    const W = E.current[v.current];
    $[v.current] !== W && p($);
  }
  function V(W, S, { commit: _ } = {
    commit: !1
  }) {
    const U = C7(a), z = S7(Math.round((W - r) / a) * a + r, U), N = is(z, [
      r,
      o
    ]);
    P((O = []) => {
      const k = v7(O, N, S);
      if (A7(k, l * a)) {
        v.current = k.indexOf(N);
        const Q = String(k) !== String(O);
        return Q && _ && p(k), Q ? k : O;
      } else
        return O;
    });
  }
  return /* @__PURE__ */ F(s7, {
    scope: e.__scopeSlider,
    disabled: s,
    min: r,
    max: o,
    valueIndexToChangeRef: v,
    thumbs: b.current,
    values: $,
    orientation: i
  }, /* @__PURE__ */ F(Lc.Provider, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ F(Lc.Slot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ F(M, K({
    "aria-disabled": s,
    "data-disabled": s ? "" : void 0
  }, h, {
    ref: y,
    onPointerDown: ve(h.onPointerDown, () => {
      s || (E.current = $);
    }),
    min: r,
    max: o,
    inverted: m,
    onSlideStart: s ? void 0 : T,
    onSlideMove: s ? void 0 : B,
    onSlideEnd: s ? void 0 : j,
    onHomeKeyDown: () => !s && V(r, 0, {
      commit: !0
    }),
    onEndKeyDown: () => !s && V(o, $.length - 1, {
      commit: !0
    }),
    onStepKeyDown: ({ event: W, direction: S }) => {
      if (!s) {
        const z = P2.includes(W.key) || W.shiftKey && T2.includes(W.key) ? 10 : 1, N = v.current, O = $[N], k = a * z * S;
        V(O + k, N, {
          commit: !0
        });
      }
    }
  })))), w && $.map(
    (W, S) => /* @__PURE__ */ F(g7, {
      key: S,
      name: n ? n + ($.length > 1 ? "[]" : "") : void 0,
      value: W
    })
  ));
}), [k2, D2] = N2(Ba, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), c7 = /* @__PURE__ */ Y((e, t) => {
  const { min: n, max: r, dir: o, inverted: a, onSlideStart: i, onSlideMove: s, onSlideEnd: l, onStepKeyDown: c, ...d } = e, [f, p] = we(null), m = De(
    t,
    (v) => p(v)
  ), h = de(), g = vr(o), x = g === "ltr", y = x && !a || !x && a;
  function b(v) {
    const A = h.current || f.getBoundingClientRect(), w = [
      0,
      A.width
    ], $ = vd(w, y ? [
      n,
      r
    ] : [
      r,
      n
    ]);
    return h.current = A, $(v - A.left);
  }
  return /* @__PURE__ */ F(k2, {
    scope: e.__scopeSlider,
    startEdge: y ? "left" : "right",
    endEdge: y ? "right" : "left",
    direction: y ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ F(F2, K({
    dir: g,
    "data-orientation": "horizontal"
  }, d, {
    ref: m,
    style: {
      ...d.style,
      "--radix-slider-thumb-transform": "translateX(-50%)"
    },
    onSlideStart: (v) => {
      const A = b(v.clientX);
      i == null || i(A);
    },
    onSlideMove: (v) => {
      const A = b(v.clientX);
      s == null || s(A);
    },
    onSlideEnd: () => {
      h.current = void 0, l == null || l();
    },
    onStepKeyDown: (v) => {
      const w = O2[y ? "from-left" : "from-right"].includes(v.key);
      c == null || c({
        event: v,
        direction: w ? -1 : 1
      });
    }
  })));
}), u7 = /* @__PURE__ */ Y((e, t) => {
  const { min: n, max: r, inverted: o, onSlideStart: a, onSlideMove: i, onSlideEnd: s, onStepKeyDown: l, ...c } = e, d = de(null), f = De(t, d), p = de(), m = !o;
  function h(g) {
    const x = p.current || d.current.getBoundingClientRect(), y = [
      0,
      x.height
    ], v = vd(y, m ? [
      r,
      n
    ] : [
      n,
      r
    ]);
    return p.current = x, v(g - x.top);
  }
  return /* @__PURE__ */ F(k2, {
    scope: e.__scopeSlider,
    startEdge: m ? "bottom" : "top",
    endEdge: m ? "top" : "bottom",
    size: "height",
    direction: m ? 1 : -1
  }, /* @__PURE__ */ F(F2, K({
    "data-orientation": "vertical"
  }, c, {
    ref: f,
    style: {
      ...c.style,
      "--radix-slider-thumb-transform": "translateY(50%)"
    },
    onSlideStart: (g) => {
      const x = h(g.clientY);
      a == null || a(x);
    },
    onSlideMove: (g) => {
      const x = h(g.clientY);
      i == null || i(x);
    },
    onSlideEnd: () => {
      p.current = void 0, s == null || s();
    },
    onStepKeyDown: (g) => {
      const y = O2[m ? "from-bottom" : "from-top"].includes(g.key);
      l == null || l({
        event: g,
        direction: y ? -1 : 1
      });
    }
  })));
}), F2 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSlider: n, onSlideStart: r, onSlideMove: o, onSlideEnd: a, onHomeKeyDown: i, onEndKeyDown: s, onStepKeyDown: l, ...c } = e, d = Ks(Ba, n);
  return /* @__PURE__ */ F(Ee.span, K({}, c, {
    ref: t,
    onKeyDown: ve(e.onKeyDown, (f) => {
      f.key === "Home" ? (i(f), f.preventDefault()) : f.key === "End" ? (s(f), f.preventDefault()) : P2.concat(T2).includes(f.key) && (l(f), f.preventDefault());
    }),
    onPointerDown: ve(e.onPointerDown, (f) => {
      const p = f.target;
      p.setPointerCapture(f.pointerId), f.preventDefault(), d.thumbs.has(p) ? p.focus() : r(f);
    }),
    onPointerMove: ve(e.onPointerMove, (f) => {
      f.target.hasPointerCapture(f.pointerId) && o(f);
    }),
    onPointerUp: ve(e.onPointerUp, (f) => {
      const p = f.target;
      p.hasPointerCapture(f.pointerId) && (p.releasePointerCapture(f.pointerId), a(f));
    })
  }));
}), d7 = "SliderTrack", f7 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSlider: n, ...r } = e, o = Ks(d7, n);
  return /* @__PURE__ */ F(Ee.span, K({
    "data-disabled": o.disabled ? "" : void 0,
    "data-orientation": o.orientation
  }, r, {
    ref: t
  }));
}), J0 = "SliderRange", p7 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSlider: n, ...r } = e, o = Ks(J0, n), a = D2(J0, n), i = de(null), s = De(t, i), l = o.values.length, c = o.values.map(
    (p) => R2(p, o.min, o.max)
  ), d = l > 1 ? Math.min(...c) : 0, f = 100 - Math.max(...c);
  return /* @__PURE__ */ F(Ee.span, K({
    "data-orientation": o.orientation,
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: s,
    style: {
      ...e.style,
      [a.startEdge]: d + "%",
      [a.endEdge]: f + "%"
    }
  }));
}), e1 = "SliderThumb", h7 = /* @__PURE__ */ Y((e, t) => {
  const n = a7(e.__scopeSlider), [r, o] = we(null), a = De(
    t,
    (s) => o(s)
  ), i = Se(
    () => r ? n().findIndex(
      (s) => s.ref.current === r
    ) : -1,
    [
      n,
      r
    ]
  );
  return /* @__PURE__ */ F(m7, K({}, e, {
    ref: a,
    index: i
  }));
}), m7 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSlider: n, index: r, ...o } = e, a = Ks(e1, n), i = D2(e1, n), [s, l] = we(null), c = De(
    t,
    (x) => l(x)
  ), d = dd(s), f = a.values[r], p = f === void 0 ? 0 : R2(f, a.min, a.max), m = y7(r, a.values.length), h = d == null ? void 0 : d[i.size], g = h ? x7(h, p, i.direction) : 0;
  return Ce(() => {
    if (s)
      return a.thumbs.add(s), () => {
        a.thumbs.delete(s);
      };
  }, [
    s,
    a.thumbs
  ]), /* @__PURE__ */ F("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [i.startEdge]: `calc(${p}% + ${g}px)`
    }
  }, /* @__PURE__ */ F(Lc.ItemSlot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ F(Ee.span, K({
    role: "slider",
    "aria-label": e["aria-label"] || m,
    "aria-valuemin": a.min,
    "aria-valuenow": f,
    "aria-valuemax": a.max,
    "aria-orientation": a.orientation,
    "data-orientation": a.orientation,
    "data-disabled": a.disabled ? "" : void 0,
    tabIndex: a.disabled ? void 0 : 0
  }, o, {
    ref: c,
    style: f === void 0 ? {
      display: "none"
    } : e.style,
    onFocus: ve(e.onFocus, () => {
      a.valueIndexToChangeRef.current = r;
    })
  }))));
}), g7 = (e) => {
  const { value: t, ...n } = e, r = de(null), o = Us(t);
  return Ce(() => {
    const a = r.current, i = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(i, "value").set;
    if (o !== t && l) {
      const c = new Event("input", {
        bubbles: !0
      });
      l.call(a, t), a.dispatchEvent(c);
    }
  }, [
    o,
    t
  ]), /* @__PURE__ */ F("input", K({
    style: {
      display: "none"
    }
  }, n, {
    ref: r,
    defaultValue: t
  }));
};
function v7(e = [], t, n) {
  const r = [
    ...e
  ];
  return r[n] = t, r.sort(
    (o, a) => o - a
  );
}
function R2(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return is(a, [
    0,
    100
  ]);
}
function y7(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? [
    "Minimum",
    "Maximum"
  ][e] : void 0;
}
function b7(e, t) {
  if (e.length === 1)
    return 0;
  const n = e.map(
    (o) => Math.abs(o - t)
  ), r = Math.min(...n);
  return n.indexOf(r);
}
function x7(e, t, n) {
  const r = e / 2, a = vd([
    0,
    50
  ], [
    0,
    r
  ]);
  return (r - a(t) * n) * n;
}
function w7(e) {
  return e.slice(0, -1).map(
    (t, n) => e[n + 1] - t
  );
}
function A7(e, t) {
  if (t > 0) {
    const n = w7(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function vd(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function C7(e) {
  return (String(e).split(".")[1] || "").length;
}
function S7(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
const E7 = l7, M7 = f7, $7 = p7, P7 = h7;
function kH({
  startValue: e = 0,
  targetValue: t = 100,
  achievedValue: n = 0,
  isReadOnly: r = !1,
  status: o = ut.ON_TRACK,
  onChangeEnd: a = () => {
  },
  onChange: i = () => {
  },
  onThumbClick: s = () => {
  }
}) {
  const [l, c] = we(n), [d, f] = we(n), p = de(!0), m = e > t, h = m ? t : e, g = m ? e : t, x = m ? -1 : 1;
  Ce(() => {
    n !== l && c(n);
  }, [n]), Ce(() => {
    p.current ? p.current = !1 : a(d);
  }, [d]), Ce(() => {
    i(l);
  }, [l]);
  const y = (A) => {
    c(m ? t + e - A : A);
  }, b = (A) => {
    f(m ? t + e - A : A);
  }, v = fo[o] ? fo[o] : fo[ut.ON_TRACK];
  return /* @__PURE__ */ I(
    E7,
    {
      className: "rabbit-ds relative box-border flex w-full min-w-[200px] touch-none select-none items-center",
      value: [m ? t + e - l : l],
      min: h,
      max: g,
      step: x,
      inverted: h > g,
      disabled: r,
      onValueCommit: (A) => b(A[0]),
      onValueChange: (A) => y(A[0]),
      onLostPointerCapture: () => {
        d !== l && f(l);
      },
      children: [
        /* @__PURE__ */ u(M7, { className: "relative h-7 grow rounded bg-[#EAEAEA]", children: /* @__PURE__ */ u(
          $7,
          {
            className: "absolute h-full rounded-l bg-white",
            style: { backgroundColor: v.indicatorColor }
          }
        ) }),
        /* @__PURE__ */ u(
          P7,
          {
            className: "block h-7 w-7 rounded-2xl bg-primary p-0.5 focus:outline-none ",
            "aria-label": "Volume",
            style: { pointerEvents: r ? "none" : "auto" },
            onClick: s,
            children: /* @__PURE__ */ u(Fe, { IconSVG: x6, className: "text-white" })
          }
        )
      ]
    }
  );
}
const T7 = Z["useId".toString()] || (() => {
});
let O7 = 0;
function xt(e) {
  const [t, n] = Z.useState(T7());
  return Mt(() => {
    e || n(
      (r) => r ?? String(O7++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const _2 = "Collapsible", [N7, I2] = gt(_2), [k7, yd] = N7(_2), D7 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: o, disabled: a, onOpenChange: i, ...s } = e, [l = !1, c] = wt({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ F(k7, {
    scope: n,
    disabled: a,
    contentId: xt(),
    open: l,
    onOpenToggle: me(
      () => c(
        (d) => !d
      ),
      [
        c
      ]
    )
  }, /* @__PURE__ */ F(Ee.div, K({
    "data-state": bd(l),
    "data-disabled": a ? "" : void 0
  }, s, {
    ref: t
  })));
}), F7 = "CollapsibleTrigger", R7 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, o = yd(F7, n);
  return /* @__PURE__ */ F(Ee.button, K({
    type: "button",
    "aria-controls": o.contentId,
    "aria-expanded": o.open || !1,
    "data-state": bd(o.open),
    "data-disabled": o.disabled ? "" : void 0,
    disabled: o.disabled
  }, r, {
    ref: t,
    onClick: ve(e.onClick, o.onOpenToggle)
  }));
}), L2 = "CollapsibleContent", _7 = /* @__PURE__ */ Y((e, t) => {
  const { forceMount: n, ...r } = e, o = yd(L2, e.__scopeCollapsible);
  return /* @__PURE__ */ F(
    Bt,
    {
      present: n || o.open
    },
    ({ present: a }) => /* @__PURE__ */ F(I7, K({}, r, {
      ref: t,
      present: a
    }))
  );
}), I7 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, i = yd(L2, n), [s, l] = we(r), c = de(null), d = De(t, c), f = de(0), p = f.current, m = de(0), h = m.current, g = i.open || s, x = de(g), y = de();
  return Ce(() => {
    const b = requestAnimationFrame(
      () => x.current = !1
    );
    return () => cancelAnimationFrame(b);
  }, []), Mt(() => {
    const b = c.current;
    if (b) {
      y.current = y.current || {
        transitionDuration: b.style.transitionDuration,
        animationName: b.style.animationName
      }, b.style.transitionDuration = "0s", b.style.animationName = "none";
      const v = b.getBoundingClientRect();
      f.current = v.height, m.current = v.width, x.current || (b.style.transitionDuration = y.current.transitionDuration, b.style.animationName = y.current.animationName), l(r);
    }
  }, [
    i.open,
    r
  ]), /* @__PURE__ */ F(Ee.div, K({
    "data-state": bd(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    id: i.contentId,
    hidden: !g
  }, a, {
    ref: d,
    style: {
      "--radix-collapsible-content-height": p ? `${p}px` : void 0,
      "--radix-collapsible-content-width": h ? `${h}px` : void 0,
      ...e.style
    }
  }), g && o);
});
function bd(e) {
  return e ? "open" : "closed";
}
const B2 = D7, z2 = R7, W2 = _7, L7 = nt(
  "rabbit-ds box-border inline-flex h-auto w-full flex-col items-start justify-start rounded-lg bg-white",
  {
    variants: {
      size: {
        default: "p-4",
        small: "px-3 py-2"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), Qs = Y(({ className: e, size: t, noShadow: n, ...r }, o) => /* @__PURE__ */ u("div", { ref: o, className: le(L7({ size: t }), n ? "" : "shadow-card", e), ...r }));
Qs.defaultProps = {
  noShadow: !1,
  size: "default"
};
Qs.displayName = "Card";
const B7 = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  "div",
  {
    ref: n,
    className: le("flex h-auto flex-col items-start justify-start self-stretch px-1 pb-3", e),
    ...t
  }
));
B7.displayName = "CardHeader";
const j2 = Y(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u("h3", { ref: r, className: le("text-sm font-semibold leading-5 text-font-primary", e), ...n, children: t })
);
j2.displayName = "CardTitle";
const z7 = Y(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("p", { ref: n, className: le("text-sm text-font-secondary", e), ...t })
);
z7.displayName = "CardDescription";
const V2 = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { ref: n, className: le("text-sm w-full", e), ...t }));
V2.displayName = "CardContent";
const H2 = Y(
  ({ title: e, actions: t, children: n, disabled: r = !1, ...o }, a) => /* @__PURE__ */ u(B2, { ref: a, disabled: r, ...o, className: "group", asChild: !0, children: /* @__PURE__ */ I(Qs, { children: [
    /* @__PURE__ */ I("div", { className: "flex h-8 w-full items-center justify-between", children: [
      /* @__PURE__ */ I("div", { className: "flex items-center", children: [
        !r && /* @__PURE__ */ u(z2, { className: "mr-2 bg-transparent text-primary transition-transform data-[state=open]:rotate-90", children: /* @__PURE__ */ u(Fe, { IconSVG: Xb }) }),
        /* @__PURE__ */ u(j2, { children: e })
      ] }),
      t ? /* @__PURE__ */ u("div", { className: "animate-in fade-in group-data-[state=closed]:invisible", children: t }) : null
    ] }),
    /* @__PURE__ */ u(W2, { asChild: !0, children: /* @__PURE__ */ u(V2, { className: "animate-in fade-in", children: n }) })
  ] }) })
);
H2.displayName = "CollapsibleCard";
const DH = H2, yr = "Accordion", W7 = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [xd, j7, V7] = Hr(yr), [Zs, FH] = gt(yr, [
  V7,
  I2
]), wd = I2(), U2 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { type: n, ...r } = e, o = r, a = r;
  return /* @__PURE__ */ R.createElement(xd.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ R.createElement(G7, K({}, a, {
    ref: t
  })) : /* @__PURE__ */ R.createElement(Y7, K({}, o, {
    ref: t
  })));
});
U2.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [Y2, H7] = Zs(yr), [G2, U7] = Zs(yr, {
  collapsible: !1
}), Y7 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, collapsible: a = !1, ...i } = e, [s, l] = wt({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ R.createElement(Y2, {
    scope: e.__scopeAccordion,
    value: s ? [
      s
    ] : [],
    onItemOpen: l,
    onItemClose: R.useCallback(
      () => a && l(""),
      [
        a,
        l
      ]
    )
  }, /* @__PURE__ */ R.createElement(G2, {
    scope: e.__scopeAccordion,
    collapsible: a
  }, /* @__PURE__ */ R.createElement(X2, K({}, i, {
    ref: t
  }))));
}), G7 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...a } = e, [i = [], s] = wt({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = R.useCallback(
    (d) => s(
      (f = []) => [
        ...f,
        d
      ]
    ),
    [
      s
    ]
  ), c = R.useCallback(
    (d) => s(
      (f = []) => f.filter(
        (p) => p !== d
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ R.createElement(Y2, {
    scope: e.__scopeAccordion,
    value: i,
    onItemOpen: l,
    onItemClose: c
  }, /* @__PURE__ */ R.createElement(G2, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ R.createElement(X2, K({}, a, {
    ref: t
  }))));
}), [X7, Js] = Zs(yr), X2 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: r, dir: o, orientation: a = "vertical", ...i } = e, s = R.useRef(null), l = De(s, t), c = j7(n), f = vr(o) === "ltr", p = ve(e.onKeyDown, (m) => {
    var h;
    if (!W7.includes(m.key))
      return;
    const g = m.target, x = c().filter((E) => {
      var T;
      return !((T = E.ref.current) !== null && T !== void 0 && T.disabled);
    }), y = x.findIndex(
      (E) => E.ref.current === g
    ), b = x.length;
    if (y === -1)
      return;
    m.preventDefault();
    let v = y;
    const A = 0, w = b - 1, M = () => {
      v = y + 1, v > w && (v = A);
    }, $ = () => {
      v = y - 1, v < A && (v = w);
    };
    switch (m.key) {
      case "Home":
        v = A;
        break;
      case "End":
        v = w;
        break;
      case "ArrowRight":
        a === "horizontal" && (f ? M() : $());
        break;
      case "ArrowDown":
        a === "vertical" && M();
        break;
      case "ArrowLeft":
        a === "horizontal" && (f ? $() : M());
        break;
      case "ArrowUp":
        a === "vertical" && $();
        break;
    }
    const P = v % b;
    (h = x[P].ref.current) === null || h === void 0 || h.focus();
  });
  return /* @__PURE__ */ R.createElement(X7, {
    scope: n,
    disabled: r,
    direction: o,
    orientation: a
  }, /* @__PURE__ */ R.createElement(xd.Slot, {
    scope: n
  }, /* @__PURE__ */ R.createElement(Ee.div, K({}, i, {
    "data-orientation": a,
    ref: l,
    onKeyDown: r ? void 0 : p
  }))));
}), Bc = "AccordionItem", [q7, Ad] = Zs(Bc), K7 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: r, ...o } = e, a = Js(Bc, n), i = H7(Bc, n), s = wd(n), l = xt(), c = r && i.value.includes(r) || !1, d = a.disabled || e.disabled;
  return /* @__PURE__ */ R.createElement(q7, {
    scope: n,
    open: c,
    disabled: d,
    triggerId: l
  }, /* @__PURE__ */ R.createElement(B2, K({
    "data-orientation": a.orientation,
    "data-state": q2(c)
  }, s, o, {
    ref: t,
    disabled: d,
    open: c,
    onOpenChange: (f) => {
      f ? i.onItemOpen(r) : i.onItemClose(r);
    }
  })));
}), Q7 = "AccordionHeader", Z7 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = Js(yr, n), a = Ad(Q7, n);
  return /* @__PURE__ */ R.createElement(Ee.h3, K({
    "data-orientation": o.orientation,
    "data-state": q2(a.open),
    "data-disabled": a.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), t1 = "AccordionTrigger", J7 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = Js(yr, n), a = Ad(t1, n), i = U7(t1, n), s = wd(n);
  return /* @__PURE__ */ R.createElement(xd.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ R.createElement(z2, K({
    "aria-disabled": a.open && !i.collapsible || void 0,
    "data-orientation": o.orientation,
    id: a.triggerId
  }, s, r, {
    ref: t
  })));
}), e9 = "AccordionContent", t9 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, o = Js(yr, n), a = Ad(e9, n), i = wd(n);
  return /* @__PURE__ */ R.createElement(W2, K({
    role: "region",
    "aria-labelledby": a.triggerId,
    "data-orientation": o.orientation
  }, i, r, {
    ref: t,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function q2(e) {
  return e ? "open" : "closed";
}
const K2 = U2, Q2 = K7, n9 = Z7, Z2 = J7, J2 = t9, r9 = Y(({ children: e, ...t }, n) => /* @__PURE__ */ u(K2, { ref: n, ...t, className: le("rabbit-ds", t.className), children: e })), o9 = Y(({ children: e, ...t }, n) => /* @__PURE__ */ u(Q2, { ref: n, ...t, className: le("rabbit-ds", t.className), children: e })), a9 = Y(
  ({ children: e, icon: t = hd, ...n }, r) => /* @__PURE__ */ u(n9, { className: "flex", children: /* @__PURE__ */ I(
    Z2,
    {
      ref: r,
      ...n,
      className: le("rabbit-ds flex group items-center bg-transparent", n.className),
      children: [
        t ? /* @__PURE__ */ u(Fe, { "aria-hidden": !0, className: "mx-1 group-data-[state=open]:rotate-90", IconSVG: t }) : null,
        e
      ]
    }
  ) })
), i9 = Y(({ children: e, ...t }, n) => /* @__PURE__ */ u(J2, { ref: n, ...t, className: le("rabbit-ds", t.className), children: /* @__PURE__ */ u("div", { className: "rabbit-ds pl-8", children: e }) }));
r9.displayName = K2.displayName;
o9.displayName = Q2.displayName;
a9.displayName = Z2.displayName;
i9.displayName = J2.displayName;
const s9 = nt(
  "rabbit-ds relative inline-flex w-full items-center gap-1 rounded-lg border px-4 py-3 text-sm",
  {
    variants: {
      variant: {
        default: "bg-tag-lightGray-bg text-tag-lightGray-text",
        warning: "bg-tag-yellow-bg text-tag-yellow-text",
        success: "bg-tag-lightGreen-bg text-tag-lightGreen-text",
        error: "bg-tag-red-bg text-tag-red-text"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), l9 = Y(
  ({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ u("div", { ref: r, role: "alert", className: le(s9({ variant: t }), e), ...n })
);
l9.displayName = "Alert";
const c9 = Y(
  ({ className: e, IconSVG: t, ...n }, r) => /* @__PURE__ */ u("div", { ref: r, className: le("text-sm", e), ...n, children: /* @__PURE__ */ u(Fe, { IconSVG: t }) })
);
c9.displayName = "AlertIcon";
const u9 = Y(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { ref: n, className: le("text-sm [&_p]:leading-relaxed", e), ...t })
);
u9.displayName = "AlertDescription";
function d9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = lt(e);
  Ce(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const zc = "dismissableLayer.update", f9 = "dismissableLayer.pointerDownOutside", p9 = "dismissableLayer.focusOutside";
let n1;
const h9 = /* @__PURE__ */ tn({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), za = /* @__PURE__ */ Y((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: a, onFocusOutside: i, onInteractOutside: s, onDismiss: l, ...c } = e, d = Xe(h9), [f, p] = we(null), m = (n = f == null ? void 0 : f.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, h] = we({}), g = De(
    t,
    (P) => p(P)
  ), x = Array.from(d.layers), [y] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), b = x.indexOf(y), v = f ? x.indexOf(f) : -1, A = d.layersWithOutsidePointerEventsDisabled.size > 0, w = v >= b, M = m9((P) => {
    const E = P.target, T = [
      ...d.branches
    ].some(
      (B) => B.contains(E)
    );
    !w || T || (a == null || a(P), s == null || s(P), P.defaultPrevented || l == null || l());
  }, m), $ = g9((P) => {
    const E = P.target;
    [
      ...d.branches
    ].some(
      (B) => B.contains(E)
    ) || (i == null || i(P), s == null || s(P), P.defaultPrevented || l == null || l());
  }, m);
  return d9((P) => {
    v === d.layers.size - 1 && (o == null || o(P), !P.defaultPrevented && l && (P.preventDefault(), l()));
  }, m), Ce(() => {
    if (f)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (n1 = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), r1(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = n1);
      };
  }, [
    f,
    m,
    r,
    d
  ]), Ce(() => () => {
    f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), r1());
  }, [
    f,
    d
  ]), Ce(() => {
    const P = () => h({});
    return document.addEventListener(zc, P), () => document.removeEventListener(zc, P);
  }, []), /* @__PURE__ */ F(Ee.div, K({}, c, {
    ref: g,
    style: {
      pointerEvents: A ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: ve(e.onFocusCapture, $.onFocusCapture),
    onBlurCapture: ve(e.onBlurCapture, $.onBlurCapture),
    onPointerDownCapture: ve(e.onPointerDownCapture, M.onPointerDownCapture)
  }));
});
function m9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = lt(e), r = de(!1), o = de(() => {
  });
  return Ce(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          em(f9, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
          once: !0
        })) : c();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function g9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = lt(e), r = de(!1);
  return Ce(() => {
    const o = (a) => {
      a.target && !r.current && em(p9, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function r1() {
  const e = new CustomEvent(zc);
  document.dispatchEvent(e);
}
function em(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? os(o, a) : o.dispatchEvent(a);
}
const zl = "focusScope.autoFocusOnMount", Wl = "focusScope.autoFocusOnUnmount", o1 = {
  bubbles: !1,
  cancelable: !0
}, Cd = /* @__PURE__ */ Y((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: a, ...i } = e, [s, l] = we(null), c = lt(o), d = lt(a), f = de(null), p = De(
    t,
    (g) => l(g)
  ), m = de({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Ce(() => {
    if (r) {
      let g = function(v) {
        if (m.paused || !s)
          return;
        const A = v.target;
        s.contains(A) ? f.current = A : nr(f.current, {
          select: !0
        });
      }, x = function(v) {
        if (m.paused || !s)
          return;
        const A = v.relatedTarget;
        A !== null && (s.contains(A) || nr(f.current, {
          select: !0
        }));
      }, y = function(v) {
        if (document.activeElement === document.body)
          for (const w of v)
            w.removedNodes.length > 0 && nr(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", x);
      const b = new MutationObserver(y);
      return s && b.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", x), b.disconnect();
      };
    }
  }, [
    r,
    s,
    m.paused
  ]), Ce(() => {
    if (s) {
      i1.add(m);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const y = new CustomEvent(zl, o1);
        s.addEventListener(zl, c), s.dispatchEvent(y), y.defaultPrevented || (v9(A9(tm(s)), {
          select: !0
        }), document.activeElement === g && nr(s));
      }
      return () => {
        s.removeEventListener(zl, c), setTimeout(() => {
          const y = new CustomEvent(Wl, o1);
          s.addEventListener(Wl, d), s.dispatchEvent(y), y.defaultPrevented || nr(g ?? document.body, {
            select: !0
          }), s.removeEventListener(Wl, d), i1.remove(m);
        }, 0);
      };
    }
  }, [
    s,
    c,
    d,
    m
  ]);
  const h = me((g) => {
    if (!n && !r || m.paused)
      return;
    const x = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
    if (x && y) {
      const b = g.currentTarget, [v, A] = y9(b);
      v && A ? !g.shiftKey && y === A ? (g.preventDefault(), n && nr(v, {
        select: !0
      })) : g.shiftKey && y === v && (g.preventDefault(), n && nr(A, {
        select: !0
      })) : y === b && g.preventDefault();
    }
  }, [
    n,
    r,
    m.paused
  ]);
  return /* @__PURE__ */ F(Ee.div, K({
    tabIndex: -1
  }, i, {
    ref: p,
    onKeyDown: h
  }));
});
function v9(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (nr(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function y9(e) {
  const t = tm(e), n = a1(t, e), r = a1(t.reverse(), e);
  return [
    n,
    r
  ];
}
function tm(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function a1(e, t) {
  for (const n of e)
    if (!b9(n, {
      upTo: t
    }))
      return n;
}
function b9(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function x9(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function nr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && x9(e) && t && e.select();
  }
}
const i1 = w9();
function w9() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = s1(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = s1(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function s1(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function A9(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const el = /* @__PURE__ */ Y((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ _a.createPortal(/* @__PURE__ */ F(Ee.div, K({}, o, {
    ref: t
  })), r) : null;
});
let jl = 0;
function Sd() {
  Ce(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : l1()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : l1()), jl++, () => {
      jl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), jl--;
    };
  }, []);
}
function l1() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Cn = function() {
  return Cn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Cn.apply(this, arguments);
};
function nm(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function C9(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Xi = "right-scroll-bar-position", qi = "width-before-scroll-bar", S9 = "with-scroll-bars-hidden", E9 = "--removed-body-scroll-bar-size";
function M9(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function $9(e, t) {
  var n = we(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function P9(e, t) {
  return $9(t || null, function(n) {
    return e.forEach(function(r) {
      return M9(r, n);
    });
  });
}
function T9(e) {
  return e;
}
function O9(e, t) {
  t === void 0 && (t = T9);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, r);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var l = function() {
        var d = i;
        i = [], d.forEach(a);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(d) {
          i.push(d), c();
        },
        filter: function(d) {
          return i = i.filter(d), n;
        }
      };
    }
  };
  return o;
}
function N9(e) {
  e === void 0 && (e = {});
  var t = O9(null);
  return t.options = Cn({ async: !0, ssr: !1 }, e), t;
}
var rm = function(e) {
  var t = e.sideCar, n = nm(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return Z.createElement(r, Cn({}, n));
};
rm.isSideCarExport = !0;
function k9(e, t) {
  return e.useMedium(t), rm;
}
var om = N9(), Vl = function() {
}, tl = Z.forwardRef(function(e, t) {
  var n = Z.useRef(null), r = Z.useState({
    onScrollCapture: Vl,
    onWheelCapture: Vl,
    onTouchMoveCapture: Vl
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, m = e.noIsolation, h = e.inert, g = e.allowPinchZoom, x = e.as, y = x === void 0 ? "div" : x, b = nm(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), v = p, A = P9([n, t]), w = Cn(Cn({}, b), o);
  return Z.createElement(
    Z.Fragment,
    null,
    d && Z.createElement(v, { sideCar: om, removeScrollBar: c, shards: f, noIsolation: m, inert: h, setCallbacks: a, allowPinchZoom: !!g, lockRef: n }),
    i ? Z.cloneElement(Z.Children.only(s), Cn(Cn({}, w), { ref: A })) : Z.createElement(y, Cn({}, w, { className: l, ref: A }), s)
  );
});
tl.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
tl.classNames = {
  fullWidth: qi,
  zeroRight: Xi
};
var c1, D9 = function() {
  if (c1)
    return c1;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function F9() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = D9();
  return t && e.setAttribute("nonce", t), e;
}
function R9(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function _9(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var I9 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = F9()) && (R9(t, n), _9(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, L9 = function() {
  var e = I9();
  return function(t, n) {
    Z.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, am = function() {
  var e = L9(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, B9 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Hl = function(e) {
  return parseInt(e || "", 10) || 0;
}, z9 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Hl(n), Hl(r), Hl(o)];
}, W9 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return B9;
  var t = z9(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, j9 = am(), V9 = function(e, t, n, r) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(S9, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Xi, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(qi, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Xi, " .").concat(Xi, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(qi, " .").concat(qi, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(E9, ": ").concat(s, `px;
  }
`);
}, H9 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, a = Z.useMemo(function() {
    return W9(o);
  }, [o]);
  return Z.createElement(j9, { styles: V9(a, !t, o, n ? "" : "!important") });
}, Wc = !1;
if (typeof window < "u")
  try {
    var wi = Object.defineProperty({}, "passive", {
      get: function() {
        return Wc = !0, !0;
      }
    });
    window.addEventListener("test", wi, wi), window.removeEventListener("test", wi, wi);
  } catch {
    Wc = !1;
  }
var no = Wc ? { passive: !1 } : !1, U9 = function(e) {
  return e.tagName === "TEXTAREA";
}, im = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !U9(e) && n[t] === "visible")
  );
}, Y9 = function(e) {
  return im(e, "overflowY");
}, G9 = function(e) {
  return im(e, "overflowX");
}, u1 = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = sm(e, n);
    if (r) {
      var o = lm(e, n), a = o[1], i = o[2];
      if (a > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, X9 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, q9 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, sm = function(e, t) {
  return e === "v" ? Y9(t) : G9(t);
}, lm = function(e, t) {
  return e === "v" ? X9(t) : q9(t);
}, K9 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Q9 = function(e, t, n, r, o) {
  var a = K9(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, l = t.contains(s), c = !1, d = i > 0, f = 0, p = 0;
  do {
    var m = lm(e, s), h = m[0], g = m[1], x = m[2], y = g - x - a * h;
    (h || y) && sm(e, s) && (f += y, p += h), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (o && f === 0 || !o && i > f) || !d && (o && p === 0 || !o && -i > p)) && (c = !0), c;
}, Ai = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, d1 = function(e) {
  return [e.deltaX, e.deltaY];
}, f1 = function(e) {
  return e && "current" in e ? e.current : e;
}, Z9 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, J9 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ex = 0, ro = [];
function tx(e) {
  var t = Z.useRef([]), n = Z.useRef([0, 0]), r = Z.useRef(), o = Z.useState(ex++)[0], a = Z.useState(function() {
    return am();
  })[0], i = Z.useRef(e);
  Z.useEffect(function() {
    i.current = e;
  }, [e]), Z.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = C9([e.lockRef.current], (e.shards || []).map(f1), !0).filter(Boolean);
      return g.forEach(function(x) {
        return x.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(x) {
          return x.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = Z.useCallback(function(g, x) {
    if ("touches" in g && g.touches.length === 2)
      return !i.current.allowPinchZoom;
    var y = Ai(g), b = n.current, v = "deltaX" in g ? g.deltaX : b[0] - y[0], A = "deltaY" in g ? g.deltaY : b[1] - y[1], w, M = g.target, $ = Math.abs(v) > Math.abs(A) ? "h" : "v";
    if ("touches" in g && $ === "h" && M.type === "range")
      return !1;
    var P = u1($, M);
    if (!P)
      return !0;
    if (P ? w = $ : (w = $ === "v" ? "h" : "v", P = u1($, M)), !P)
      return !1;
    if (!r.current && "changedTouches" in g && (v || A) && (r.current = w), !w)
      return !0;
    var E = r.current || w;
    return Q9(E, x, g, E === "h" ? v : A, !0);
  }, []), l = Z.useCallback(function(g) {
    var x = g;
    if (!(!ro.length || ro[ro.length - 1] !== a)) {
      var y = "deltaY" in x ? d1(x) : Ai(x), b = t.current.filter(function(w) {
        return w.name === x.type && w.target === x.target && Z9(w.delta, y);
      })[0];
      if (b && b.should) {
        x.cancelable && x.preventDefault();
        return;
      }
      if (!b) {
        var v = (i.current.shards || []).map(f1).filter(Boolean).filter(function(w) {
          return w.contains(x.target);
        }), A = v.length > 0 ? s(x, v[0]) : !i.current.noIsolation;
        A && x.cancelable && x.preventDefault();
      }
    }
  }, []), c = Z.useCallback(function(g, x, y, b) {
    var v = { name: g, delta: x, target: y, should: b };
    t.current.push(v), setTimeout(function() {
      t.current = t.current.filter(function(A) {
        return A !== v;
      });
    }, 1);
  }, []), d = Z.useCallback(function(g) {
    n.current = Ai(g), r.current = void 0;
  }, []), f = Z.useCallback(function(g) {
    c(g.type, d1(g), g.target, s(g, e.lockRef.current));
  }, []), p = Z.useCallback(function(g) {
    c(g.type, Ai(g), g.target, s(g, e.lockRef.current));
  }, []);
  Z.useEffect(function() {
    return ro.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", l, no), document.addEventListener("touchmove", l, no), document.addEventListener("touchstart", d, no), function() {
      ro = ro.filter(function(g) {
        return g !== a;
      }), document.removeEventListener("wheel", l, no), document.removeEventListener("touchmove", l, no), document.removeEventListener("touchstart", d, no);
    };
  }, []);
  var m = e.removeScrollBar, h = e.inert;
  return Z.createElement(
    Z.Fragment,
    null,
    h ? Z.createElement(a, { styles: J9(o) }) : null,
    m ? Z.createElement(H9, { gapMode: "margin" }) : null
  );
}
const nx = k9(om, tx);
var cm = Z.forwardRef(function(e, t) {
  return Z.createElement(tl, Cn({}, e, { ref: t, sideCar: nx }));
});
cm.classNames = tl.classNames;
const Ed = cm;
var rx = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, oo = /* @__PURE__ */ new WeakMap(), Ci = /* @__PURE__ */ new WeakMap(), Si = {}, Ul = 0, um = function(e) {
  return e && (e.host || um(e.parentNode));
}, ox = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = um(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, ax = function(e, t, n, r) {
  var o = ox(t, Array.isArray(e) ? e : [e]);
  Si[n] || (Si[n] = /* @__PURE__ */ new WeakMap());
  var a = Si[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(f) {
    !f || s.has(f) || (s.add(f), c(f.parentNode));
  };
  o.forEach(c);
  var d = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(p) {
      if (s.has(p))
        d(p);
      else {
        var m = p.getAttribute(r), h = m !== null && m !== "false", g = (oo.get(p) || 0) + 1, x = (a.get(p) || 0) + 1;
        oo.set(p, g), a.set(p, x), i.push(p), g === 1 && h && Ci.set(p, !0), x === 1 && p.setAttribute(n, "true"), h || p.setAttribute(r, "true");
      }
    });
  };
  return d(t), s.clear(), Ul++, function() {
    i.forEach(function(f) {
      var p = oo.get(f) - 1, m = a.get(f) - 1;
      oo.set(f, p), a.set(f, m), p || (Ci.has(f) || f.removeAttribute(r), Ci.delete(f)), m || f.removeAttribute(n);
    }), Ul--, Ul || (oo = /* @__PURE__ */ new WeakMap(), oo = /* @__PURE__ */ new WeakMap(), Ci = /* @__PURE__ */ new WeakMap(), Si = {});
  };
}, Md = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || rx(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), ax(r, o, n, "aria-hidden")) : function() {
    return null;
  };
};
const dm = "Dialog", [fm, pm] = gt(dm), [ix, yn] = fm(dm), sx = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: a, modal: i = !0 } = e, s = de(null), l = de(null), [c = !1, d] = wt({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ F(ix, {
    scope: t,
    triggerRef: s,
    contentRef: l,
    contentId: xt(),
    titleId: xt(),
    descriptionId: xt(),
    open: c,
    onOpenChange: d,
    onOpenToggle: me(
      () => d(
        (f) => !f
      ),
      [
        d
      ]
    ),
    modal: i
  }, n);
}, lx = "DialogTrigger", cx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = yn(lx, n), a = De(t, o.triggerRef);
  return /* @__PURE__ */ F(Ee.button, K({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": $d(o.open)
  }, r, {
    ref: a,
    onClick: ve(e.onClick, o.onOpenToggle)
  }));
}), hm = "DialogPortal", [ux, mm] = fm(hm, {
  forceMount: void 0
}), dx = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = yn(hm, t);
  return /* @__PURE__ */ F(ux, {
    scope: t,
    forceMount: n
  }, ir.map(
    r,
    (i) => /* @__PURE__ */ F(Bt, {
      present: n || a.open
    }, /* @__PURE__ */ F(el, {
      asChild: !0,
      container: o
    }, i))
  ));
}, jc = "DialogOverlay", fx = /* @__PURE__ */ Y((e, t) => {
  const n = mm(jc, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = yn(jc, e.__scopeDialog);
  return a.modal ? /* @__PURE__ */ F(Bt, {
    present: r || a.open
  }, /* @__PURE__ */ F(px, K({}, o, {
    ref: t
  }))) : null;
}), px = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = yn(jc, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ F(Ed, {
      as: $n,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ F(Ee.div, K({
      "data-state": $d(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), yo = "DialogContent", hx = /* @__PURE__ */ Y((e, t) => {
  const n = mm(yo, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = yn(yo, e.__scopeDialog);
  return /* @__PURE__ */ F(Bt, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ F(mx, K({}, o, {
    ref: t
  })) : /* @__PURE__ */ F(gx, K({}, o, {
    ref: t
  })));
}), mx = /* @__PURE__ */ Y((e, t) => {
  const n = yn(yo, e.__scopeDialog), r = de(null), o = De(t, n.contentRef, r);
  return Ce(() => {
    const a = r.current;
    if (a)
      return Md(a);
  }, []), /* @__PURE__ */ F(gm, K({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: ve(e.onCloseAutoFocus, (a) => {
      var i;
      a.preventDefault(), (i = n.triggerRef.current) === null || i === void 0 || i.focus();
    }),
    onPointerDownOutside: ve(e.onPointerDownOutside, (a) => {
      const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
      (i.button === 2 || s) && a.preventDefault();
    }),
    onFocusOutside: ve(
      e.onFocusOutside,
      (a) => a.preventDefault()
    )
  }));
}), gx = /* @__PURE__ */ Y((e, t) => {
  const n = yn(yo, e.__scopeDialog), r = de(!1), o = de(!1);
  return /* @__PURE__ */ F(gm, K({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (a) => {
      var i, s;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = a.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(l)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
    }
  }));
}), gm = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = yn(yo, n), l = de(null), c = De(t, l);
  return Sd(), /* @__PURE__ */ F(ur, null, /* @__PURE__ */ F(Cd, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ F(za, K({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": $d(s.open)
  }, i, {
    ref: c,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), vm = "DialogTitle", vx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = yn(vm, n);
  return /* @__PURE__ */ F(Ee.h2, K({
    id: o.titleId
  }, r, {
    ref: t
  }));
}), yx = "DialogDescription", bx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = yn(yx, n);
  return /* @__PURE__ */ F(Ee.p, K({
    id: o.descriptionId
  }, r, {
    ref: t
  }));
}), xx = "DialogClose", wx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = yn(xx, n);
  return /* @__PURE__ */ F(Ee.button, K({
    type: "button"
  }, r, {
    ref: t,
    onClick: ve(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function $d(e) {
  return e ? "open" : "closed";
}
const Ax = "DialogTitleWarning", [Cx, RH] = Ty(Ax, {
  contentName: yo,
  titleName: vm,
  docsSlug: "dialog"
}), Sx = sx, Ex = cx, Mx = dx, $x = fx, Px = hx, Tx = vx, Ox = bx, ym = wx, Nx = "AlertDialog", [kx, _H] = gt(Nx, [
  pm
]), Vn = pm(), Dx = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Vn(t);
  return /* @__PURE__ */ F(Sx, K({}, r, n, {
    modal: !0
  }));
}, Fx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Vn(n);
  return /* @__PURE__ */ F(Ex, K({}, o, r, {
    ref: t
  }));
}), Rx = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Vn(t);
  return /* @__PURE__ */ F(Mx, K({}, r, n));
}, _x = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Vn(n);
  return /* @__PURE__ */ F($x, K({}, o, r, {
    ref: t
  }));
}), bm = "AlertDialogContent", [Ix, Lx] = kx(bm), Bx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAlertDialog: n, children: r, ...o } = e, a = Vn(n), i = de(null), s = De(t, i), l = de(null);
  return /* @__PURE__ */ F(Cx, {
    contentName: bm,
    titleName: zx,
    docsSlug: "alert-dialog"
  }, /* @__PURE__ */ F(Ix, {
    scope: n,
    cancelRef: l
  }, /* @__PURE__ */ F(Px, K({
    role: "alertdialog"
  }, a, o, {
    ref: s,
    onOpenAutoFocus: ve(o.onOpenAutoFocus, (c) => {
      var d;
      c.preventDefault(), (d = l.current) === null || d === void 0 || d.focus({
        preventScroll: !0
      });
    }),
    onPointerDownOutside: (c) => c.preventDefault(),
    onInteractOutside: (c) => c.preventDefault()
  }), /* @__PURE__ */ F(fd, null, r), !1)));
}), zx = "AlertDialogTitle", Wx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Vn(n);
  return /* @__PURE__ */ F(Tx, K({}, o, r, {
    ref: t
  }));
}), jx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Vn(n);
  return /* @__PURE__ */ F(Ox, K({}, o, r, {
    ref: t
  }));
}), Vx = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Vn(n);
  return /* @__PURE__ */ F(ym, K({}, o, r, {
    ref: t
  }));
}), Hx = "AlertDialogCancel", Ux = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = Lx(Hx, n), a = Vn(n), i = De(t, o);
  return /* @__PURE__ */ F(ym, K({}, a, r, {
    ref: i
  }));
}), Yx = Dx, Gx = Fx, Xx = Rx, xm = _x, wm = Bx, qx = Vx, Kx = Ux, Am = Wx, Cm = jx, Vc = "horizontal", Qx = [
  "horizontal",
  "vertical"
], Sm = /* @__PURE__ */ Y((e, t) => {
  const { decorative: n, orientation: r = Vc, ...o } = e, a = Em(r) ? r : Vc, s = n ? {
    role: "none"
  } : {
    "aria-orientation": a === "vertical" ? a : void 0,
    role: "separator"
  };
  return /* @__PURE__ */ F(Ee.div, K({
    "data-orientation": a
  }, s, o, {
    ref: t
  }));
});
Sm.propTypes = {
  orientation(e, t, n) {
    const r = e[t], o = String(r);
    return r && !Em(r) ? new Error(Zx(o, n)) : null;
  }
};
function Zx(e, t) {
  return `Invalid prop \`orientation\` of value \`${e}\` supplied to \`${t}\`, expected one of:
  - horizontal
  - vertical

Defaulting to \`${Vc}\`.`;
}
function Em(e) {
  return Qx.includes(e);
}
const Mm = Sm, Jx = nt(
  "rabbit-ds inline-flex items-center justify-center gap-1 rounded py-2 font-sans text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        filled: "",
        outline: "",
        text: "",
        nav: "",
        transparentOutline: ""
      },
      status: {
        default: "",
        error: ""
      },
      size: {
        normal: "h-10",
        small: "h-7",
        icon: "h-10 w-10 p-2",
        smallIcon: "h-7 w-7 p-1",
        nav: "h-12 w-12"
      }
    },
    compoundVariants: [
      {
        variant: "filled",
        status: "default",
        className: "bg-primary text-white hover:bg-primary-hover focus:bg-primary-focus disabled:bg-primary-disabled"
      },
      {
        variant: "filled",
        status: "error",
        className: "bg-[#C62C02] text-white hover:bg-[#AA2602] focus:bg-[#A12402] disabled:bg-[#F6B9B9]"
      },
      {
        variant: "outline",
        status: "default",
        className: "border border-primary bg-white text-primary hover:border-primary-hover hover:text-primary-hover focus:border-primary-focus focus:text-primary-focus disabled:border-primary-focus disabled:text-primary-focus"
      },
      {
        variant: "outline",
        status: "error",
        className: "border border-[#C62C02] bg-white text-[#C62C02] hover:border-[#AA2602] hover:text-[#AA2602] focus:border-[#A12402] focus:text-[#A12402] disabled:border-[#F6B9B9] disabled:text-[#F6B9B9]"
      },
      {
        variant: "transparentOutline",
        status: "default",
        className: "border border-primary bg-transparent text-primary hover:border-primary-hover hover:text-primary-hover focus:border-primary-focus focus:text-primary-focus disabled:border-primary-focus disabled:text-primary-focus"
      },
      {
        variant: "transparentOutline",
        status: "error",
        className: "border border-[#C62C02] bg-transparent text-[#C62C02] hover:border-[#AA2602] hover:text-[#AA2602] focus:border-[#A12402] focus:text-[#A12402] disabled:border-[#F6B9B9] disabled:text-[#F6B9B9]"
      },
      {
        variant: "text",
        status: "default",
        className: "border-0 bg-transparent text-primary hover:text-primary-hover focus:text-primary-focus disabled:text-primary-focus"
      },
      {
        variant: "text",
        status: "error",
        className: "border-0 bg-white text-[#C62C02] hover:text-[#AA2602] focus:text-[#A12402] disabled:text-[#F6B9B9]"
      },
      {
        variant: "nav",
        status: "default",
        className: "group flex flex-col gap-0 rounded-full border-0 bg-card-bg-hover p-0 text-[8px] font-normal text-primary ease-linear hover:text-primary-hover focus:text-primary-focus disabled:text-primary-focus data-[state=open]:bg-[#004F67] data-[state=open]:text-white"
      },
      {
        variant: "nav",
        status: "error",
        className: "border-0 bg-white text-[#C62C02] hover:text-[#AA2602] focus:text-[#A12402] disabled:text-[#F6B9B9]"
      }
    ],
    defaultVariants: {
      variant: "filled",
      status: "default",
      size: "normal"
    }
  }
), p1 = nt("", {
  variants: {
    size: {
      normal: "default",
      small: "small",
      icon: "default",
      smallIcon: "small",
      nav: "default"
    },
    defaultVariants: {
      size: "normal"
    }
  }
}), nn = Y(
  ({
    className: e,
    variant: t,
    iconLeft: n = void 0,
    iconRight: r = void 0,
    status: o,
    size: a,
    asChild: i = !1,
    children: s,
    ...l
  }, c) => /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ I(
    i ? $n : "button",
    {
      "data-deer-btn": !0,
      className: le(
        n === void 0 ? "pl-4" : "pl-2",
        r === void 0 ? "pr-4" : "pr-2",
        Jx({ variant: t, className: e, size: a, status: o })
      ),
      ref: c,
      ...l,
      children: [
        n ? /* @__PURE__ */ u(
          Fe,
          {
            className: t === "nav" ? "ease-linear group-data-[state=closed]:rotate-0 group-data-[state=open]:rotate-45" : "",
            IconSVG: n,
            size: le(p1({ size: a }))
          }
        ) : null,
        s,
        r ? /* @__PURE__ */ u(Fe, { IconSVG: r, size: le(p1({ size: a })) }) : null
      ]
    }
  ) })
);
nn.displayName = "Button";
const ew = Yx, tw = Xx, nw = Kx, rw = qx, ow = Gx, $m = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(xm, { ref: n, className: le("bg-black/[.48] fixed inset-0", e), ...t }));
$m.displayName = xm.displayName;
const Pm = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  wm,
  {
    ref: n,
    className: le(
      "rabbit-ds box-border z-[1450] fixed left-[50%] top-[50%] max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-[8px] bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none inline-flex flex-col items-center gap-[1px]",
      e
    ),
    ...t
  }
));
Pm.displayName = wm.displayName;
const Tm = Y(({ className: e, ...t }, n) => /* @__PURE__ */ I("div", { className: "flex w-full flex-col", children: [
  /* @__PURE__ */ u("div", { className: "flex w-full flex-col items-start gap-[12px] rounded-lg bg-white p-5", children: /* @__PURE__ */ u("div", { className: "flex items-start rounded-lg ", children: /* @__PURE__ */ I(Am, { ref: n, className: le("flex items-center gap-[8px] m-0", e), ...t, children: [
    /* @__PURE__ */ u(Fe, { IconSVG: La }),
    /* @__PURE__ */ I("span", { className: "text-base font-semibold text-font-primary", children: [
      " ",
      t.children
    ] })
  ] }) }) }),
  /* @__PURE__ */ u(Mm, { className: "mx-3 h-[1px]  bg-accent" })
] }));
Tm.displayName = Am.displayName;
const Om = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Cm,
  {
    ref: n,
    className: le("w-full text-sm text-font-primary p-6 max-h-[75vh] overflow-auto", e),
    ...t,
    children: t.children
  }
));
Om.displayName = Cm.displayName;
function IH({
  isOpen: e = !1,
  title: t,
  description: n,
  cancelText: r,
  actionText: o,
  onCancel: a,
  onAction: i,
  isTriggerRequired: s,
  triggeredText: l,
  onOpenChange: c,
  className: d = ""
}) {
  const [f, p] = we(e);
  return Ce(() => {
    typeof c == "function" && c(f);
  }, [c, f]), /* @__PURE__ */ I(ew, { open: f, onOpenChange: p, children: [
    s && /* @__PURE__ */ u(ow, { children: l }),
    /* @__PURE__ */ I(tw, { children: [
      /* @__PURE__ */ u($m, {}),
      /* @__PURE__ */ I(Pm, { className: d, children: [
        /* @__PURE__ */ u(
          "button",
          {
            type: "button",
            className: "absolute left-[-14px] top-[-14px] flex h-7 w-7 items-center justify-center rounded-[50%] border border-solid border-white bg-[rgb(50,56,70)] p-0 text-[white]",
            onClick: () => p(!1),
            children: /* @__PURE__ */ u(Fe, { IconSVG: _b })
          }
        ),
        /* @__PURE__ */ u(Tm, { children: t }),
        /* @__PURE__ */ u(Om, { children: n }),
        /* @__PURE__ */ I("div", { className: "flex items-center justify-between self-stretch rounded-[8px] bg-[#F5F7F9] px-4 py-3", children: [
          /* @__PURE__ */ u(nw, { asChild: !0, children: /* @__PURE__ */ u(nn, { variant: "text", onClick: a, children: r }) }),
          /* @__PURE__ */ u(rw, { asChild: !0, children: /* @__PURE__ */ u(nn, { onClick: i, children: o }) })
        ] })
      ] })
    ] })
  ] });
}
const Nm = "Avatar", [aw, LH] = gt(Nm), [iw, km] = aw(Nm), sw = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAvatar: n, ...r } = e, [o, a] = we("idle");
  return /* @__PURE__ */ F(iw, {
    scope: n,
    imageLoadingStatus: o,
    onImageLoadingStatusChange: a
  }, /* @__PURE__ */ F(Ee.span, K({}, r, {
    ref: t
  })));
}), lw = "AvatarImage", cw = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
  }, ...a } = e, i = km(lw, n), s = fw(r), l = lt((c) => {
    o(c), i.onImageLoadingStatusChange(c);
  });
  return Mt(() => {
    s !== "idle" && l(s);
  }, [
    s,
    l
  ]), s === "loaded" ? /* @__PURE__ */ F(Ee.img, K({}, a, {
    ref: t,
    src: r
  })) : null;
}), uw = "AvatarFallback", dw = /* @__PURE__ */ Y((e, t) => {
  const { __scopeAvatar: n, delayMs: r, ...o } = e, a = km(uw, n), [i, s] = we(r === void 0);
  return Ce(() => {
    if (r !== void 0) {
      const l = window.setTimeout(
        () => s(!0),
        r
      );
      return () => window.clearTimeout(l);
    }
  }, [
    r
  ]), i && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ F(Ee.span, K({}, o, {
    ref: t
  })) : null;
});
function fw(e) {
  const [t, n] = we("idle");
  return Mt(() => {
    if (!e) {
      n("error");
      return;
    }
    let r = !0;
    const o = new window.Image(), a = (i) => () => {
      r && n(i);
    };
    return n("loading"), o.onload = a("loaded"), o.onerror = a("error"), o.src = e, () => {
      r = !1;
    };
  }, [
    e
  ]), t;
}
const Dm = sw, Fm = cw, Rm = dw, pw = nt("rabbit-ds relative flex shrink-0 overflow-hidden rounded-full bg-accent", {
  variants: {
    size: {
      xs: "h-3 w-3 text-[4px]",
      sm: "h-4 w-4 text-[6px]",
      md: "h-6 w-6 text-[10px]",
      lg: "h-8 w-8 text-xs",
      xl: "h-10 w-10 text-sm",
      profile: "h-[120px] w-[120px] text-4xl"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Hn = Z.forwardRef(({ className: e, size: t, ...n }, r) => /* @__PURE__ */ u(
  Dm,
  {
    ...n,
    ref: r,
    className: le(pw({ size: t }), "relative flex shrink-0 overflow-hidden rounded-full", e)
  }
));
Hn.displayName = Dm.displayName;
const Un = Z.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(Fm, { ref: n, ...t, className: le("aspect-square h-full w-full object-cover", e) }));
Un.displayName = Fm.displayName;
const Pd = Z.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Rm,
  {
    ref: n,
    ...t,
    className: le("flex h-full w-full items-center justify-center rounded-full font-medium text-[1em]", e)
  }
));
Pd.displayName = Rm.displayName;
const hw = (e) => e.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase(), mw = nt(
  "rabbit-ds box-border inline-flex h-auto min-h-8 w-full flex-row items-center justify-start gap-1 rounded-lg bg-white p-1 text-xs",
  {
    variants: {
      color: {
        success: "bg-success-bg text-success-primary",
        warning: "bg-warning-bg text-warning-primary"
      }
    },
    defaultVariants: {
      color: "success"
    }
  }
), _m = Y(({ className: e, color: t, icon: n, children: r, ...o }, a) => /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ I("div", { ref: a, className: le(mw({ color: t }), e), ...o, children: [
  n ? /* @__PURE__ */ u(Fe, { IconSVG: n }) : null,
  r
] }) }));
_m.defaultProps = {
  color: "success",
  icon: void 0
};
_m.displayName = "Caption";
function Ge(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function dr(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function gw(e, t) {
  const n = +Ge(e);
  return dr(e, n + t);
}
const Im = 6048e5, vw = 864e5, yw = 6e4, Ei = 43200, h1 = 1440;
let bw = {};
function Wa() {
  return bw;
}
function ba(e, t) {
  var s, l, c, d;
  const n = Wa(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = Ge(e), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function ss(e) {
  return ba(e, { weekStartsOn: 1 });
}
function Lm(e) {
  const t = Ge(e), n = t.getFullYear(), r = dr(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = ss(r), a = dr(e, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const i = ss(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function ls(e) {
  const t = Ge(e);
  return t.setHours(0, 0, 0, 0), t;
}
function cs(e) {
  const t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function xw(e, t) {
  const n = ls(e), r = ls(t), o = n.getTime() - cs(n), a = r.getTime() - cs(r);
  return Math.round((o - a) / vw);
}
function ww(e) {
  const t = Lm(e), n = dr(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), ss(n);
}
function Aw(e, t) {
  return gw(e, t * yw);
}
function Ki(e, t) {
  const n = Ge(e), r = Ge(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
function Cw(e, t) {
  const n = ls(e), r = ls(t);
  return +n == +r;
}
function Sw(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ew(e) {
  if (!Sw(e) && typeof e != "number")
    return !1;
  const t = Ge(e);
  return !isNaN(Number(t));
}
function Mw(e, t) {
  const n = Ge(e), r = Ge(t), o = n.getFullYear() - r.getFullYear(), a = n.getMonth() - r.getMonth();
  return o * 12 + a;
}
function $w(e, t) {
  return Ge(e).getTime() - Ge(t).getTime();
}
function Pw(e) {
  return e ? Math[e] : Math.trunc;
}
function Tw(e) {
  const t = Ge(e);
  return t.setHours(23, 59, 59, 999), t;
}
function Ow(e) {
  const t = Ge(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Nw(e) {
  const t = Ge(e);
  return +Tw(t) == +Ow(t);
}
function kw(e, t) {
  const n = Ge(e), r = Ge(t), o = Ki(n, r), a = Math.abs(
    Mw(n, r)
  );
  let i;
  if (a < 1)
    i = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * a);
    let s = Ki(n, r) === -o;
    Nw(Ge(e)) && a === 1 && Ki(e, r) === 1 && (s = !1), i = o * (a - Number(s));
  }
  return i === 0 ? 0 : i;
}
function Dw(e, t, n) {
  const r = $w(e, t) / 1e3;
  return Pw(n == null ? void 0 : n.roundingMethod)(r);
}
function Fw(e) {
  const t = Ge(e), n = dr(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Rw = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, _w = (e, t, n) => {
  let r;
  const o = Rw[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Yl(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Iw = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Lw = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Bw = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zw = {
  date: Yl({
    formats: Iw,
    defaultWidth: "full"
  }),
  time: Yl({
    formats: Lw,
    defaultWidth: "full"
  }),
  dateTime: Yl({
    formats: Bw,
    defaultWidth: "full"
  })
}, Ww = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, jw = (e, t, n, r) => Ww[e];
function Jo(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const Vw = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Hw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Uw = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Yw = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Gw = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Xw = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, qw = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Kw = {
  ordinalNumber: qw,
  era: Jo({
    values: Vw,
    defaultWidth: "wide"
  }),
  quarter: Jo({
    values: Hw,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Jo({
    values: Uw,
    defaultWidth: "wide"
  }),
  day: Jo({
    values: Yw,
    defaultWidth: "wide"
  }),
  dayPeriod: Jo({
    values: Gw,
    defaultWidth: "wide",
    formattingValues: Xw,
    defaultFormattingWidth: "wide"
  })
};
function ea(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? Zw(s, (f) => f.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Qw(s, (f) => f.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const d = t.slice(i.length);
    return { value: c, rest: d };
  };
}
function Qw(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Zw(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Jw(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const eA = /^(\d+)(th|st|nd|rd)?/i, tA = /\d+/i, nA = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, rA = {
  any: [/^b/i, /^(a|c)/i]
}, oA = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, aA = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, iA = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, sA = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, lA = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, cA = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, uA = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, dA = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, fA = {
  ordinalNumber: Jw({
    matchPattern: eA,
    parsePattern: tA,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ea({
    matchPatterns: nA,
    defaultMatchWidth: "wide",
    parsePatterns: rA,
    defaultParseWidth: "any"
  }),
  quarter: ea({
    matchPatterns: oA,
    defaultMatchWidth: "wide",
    parsePatterns: aA,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ea({
    matchPatterns: iA,
    defaultMatchWidth: "wide",
    parsePatterns: sA,
    defaultParseWidth: "any"
  }),
  day: ea({
    matchPatterns: lA,
    defaultMatchWidth: "wide",
    parsePatterns: cA,
    defaultParseWidth: "any"
  }),
  dayPeriod: ea({
    matchPatterns: uA,
    defaultMatchWidth: "any",
    parsePatterns: dA,
    defaultParseWidth: "any"
  })
}, Bm = {
  code: "en-US",
  formatDistance: _w,
  formatLong: zw,
  formatRelative: jw,
  localize: Kw,
  match: fA,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function pA(e) {
  const t = Ge(e);
  return xw(t, Fw(t)) + 1;
}
function hA(e) {
  const t = Ge(e), n = ss(t).getTime() - ww(t).getTime();
  return Math.round(n / Im) + 1;
}
function zm(e, t) {
  var d, f, p, m;
  const n = Ge(e), r = n.getFullYear(), o = Wa(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((m = (p = o.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = dr(e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = ba(i, t), l = dr(e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const c = ba(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function mA(e, t) {
  var s, l, c, d;
  const n = Wa(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = zm(e, t), a = dr(e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), ba(a, t);
}
function gA(e, t) {
  const n = Ge(e), r = ba(n, t).getTime() - mA(n, t).getTime();
  return Math.round(r / Im) + 1;
}
function Ye(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Jn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Ye(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Ye(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ye(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ye(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ye(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ye(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ye(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.floor(
      r * Math.pow(10, n - 3)
    );
    return Ye(o, t.length);
  }
}, ao = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, vA = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Jn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = zm(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return Ye(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Ye(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Lm(e);
    return Ye(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Ye(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Ye(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Ye(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Jn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Ye(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = gA(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Ye(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = hA(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Ye(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Jn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = pA(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Ye(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return Ye(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return Ye(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Ye(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = ao.noon : r === 0 ? o = ao.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = ao.evening : r >= 12 ? o = ao.afternoon : r >= 4 ? o = ao.morning : o = ao.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Jn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Jn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ye(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ye(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Jn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Jn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Jn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n, r) {
    const a = (r._originalDate || e).getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      case "X":
        return g1(a);
      case "XXXX":
      case "XX":
        return $r(a);
      case "XXXXX":
      case "XXX":
      default:
        return $r(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n, r) {
    const a = (r._originalDate || e).getTimezoneOffset();
    switch (t) {
      case "x":
        return g1(a);
      case "xxxx":
      case "xx":
        return $r(a);
      case "xxxxx":
      case "xxx":
      default:
        return $r(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n, r) {
    const a = (r._originalDate || e).getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + m1(a, ":");
      case "OOOO":
      default:
        return "GMT" + $r(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n, r) {
    const a = (r._originalDate || e).getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + m1(a, ":");
      case "zzzz":
      default:
        return "GMT" + $r(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n, r) {
    const o = r._originalDate || e, a = Math.floor(o.getTime() / 1e3);
    return Ye(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n, r) {
    const a = (r._originalDate || e).getTime();
    return Ye(a, t.length);
  }
};
function m1(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + Ye(a, 2);
}
function g1(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ye(Math.abs(e) / 60, 2) : $r(e, t);
}
function $r(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Ye(Math.floor(r / 60), 2), a = Ye(r % 60, 2);
  return n + o + t + a;
}
const v1 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Wm = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, yA = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return v1(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", v1(r, t)).replace("{{time}}", Wm(o, t));
}, bA = {
  p: Wm,
  P: yA
}, xA = ["D", "DD"], wA = ["YY", "YYYY"];
function AA(e) {
  return xA.indexOf(e) !== -1;
}
function CA(e) {
  return wA.indexOf(e) !== -1;
}
function y1(e, t, n) {
  if (e === "YYYY")
    throw new RangeError(
      `Use \`yyyy\` instead of \`YYYY\` (in \`${t}\`) for formatting years to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`
    );
  if (e === "YY")
    throw new RangeError(
      `Use \`yy\` instead of \`YY\` (in \`${t}\`) for formatting years to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`
    );
  if (e === "D")
    throw new RangeError(
      `Use \`d\` instead of \`D\` (in \`${t}\`) for formatting days of the month to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`
    );
  if (e === "DD")
    throw new RangeError(
      `Use \`dd\` instead of \`DD\` (in \`${t}\`) for formatting days of the month to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`
    );
}
const SA = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, EA = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, MA = /^'([^]*?)'?$/, $A = /''/g, PA = /[a-zA-Z]/;
function Gl(e, t, n) {
  var d, f, p, m, h, g, x, y;
  const r = Wa(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Bm, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (h = n == null ? void 0 : n.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((y = (x = r.locale) == null ? void 0 : x.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = Ge(e);
  if (!Ew(s))
    throw new RangeError("Invalid time value");
  const l = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o,
    _originalDate: s
  };
  return t.match(EA).map(function(b) {
    const v = b[0];
    if (v === "p" || v === "P") {
      const A = bA[v];
      return A(b, o.formatLong);
    }
    return b;
  }).join("").match(SA).map(function(b) {
    if (b === "''")
      return "'";
    const v = b[0];
    if (v === "'")
      return TA(b);
    const A = vA[v];
    if (A)
      return !(n != null && n.useAdditionalWeekYearTokens) && CA(b) && y1(b, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && AA(b) && y1(b, t, String(e)), A(
        s,
        b,
        o.localize,
        l
      );
    if (v.match(PA))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + v + "`"
      );
    return b;
  }).join("");
}
function TA(e) {
  const t = e.match(MA);
  return t ? t[1].replace($A, "'") : e;
}
function OA(e, t, n) {
  const r = Wa(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Bm, a = 2520, i = Ki(e, t);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  const s = Object.assign({}, n, {
    addSuffix: n == null ? void 0 : n.addSuffix,
    comparison: i
  });
  let l, c;
  i > 0 ? (l = Ge(t), c = Ge(e)) : (l = Ge(e), c = Ge(t));
  const d = Dw(c, l), f = (cs(c) - cs(l)) / 1e3, p = Math.round((d - f) / 60);
  let m;
  if (p < 2)
    return n != null && n.includeSeconds ? d < 5 ? o.formatDistance("lessThanXSeconds", 5, s) : d < 10 ? o.formatDistance("lessThanXSeconds", 10, s) : d < 20 ? o.formatDistance("lessThanXSeconds", 20, s) : d < 40 ? o.formatDistance("halfAMinute", 0, s) : d < 60 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", 1, s) : p === 0 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", p, s);
  if (p < 45)
    return o.formatDistance("xMinutes", p, s);
  if (p < 90)
    return o.formatDistance("aboutXHours", 1, s);
  if (p < h1) {
    const h = Math.round(p / 60);
    return o.formatDistance("aboutXHours", h, s);
  } else {
    if (p < a)
      return o.formatDistance("xDays", 1, s);
    if (p < Ei) {
      const h = Math.round(p / h1);
      return o.formatDistance("xDays", h, s);
    } else if (p < Ei * 2)
      return m = Math.round(p / Ei), o.formatDistance("aboutXMonths", m, s);
  }
  if (m = kw(c, l), m < 12) {
    const h = Math.round(p / Ei);
    return o.formatDistance("xMonths", h, s);
  } else {
    const h = m % 12, g = Math.floor(m / 12);
    return h < 3 ? o.formatDistance("aboutXYears", g, s) : h < 9 ? o.formatDistance("overXYears", g, s) : o.formatDistance("almostXYears", g + 1, s);
  }
}
function NA(e, t) {
  return OA(e, Date.now(), t);
}
function kA(e, t) {
  const n = Ge(e), r = Ge(t);
  return n.getTime() > r.getTime();
}
function jm({
  date: e,
  duration: t,
  showRelativeTime: n = !1,
  showTime: r = !1,
  dateFormat: o = "MMM dd, yyyy",
  timeFormat: a = "HH:mm",
  highlightDate: i = n,
  className: s
}) {
  const l = /* @__PURE__ */ new Date(), c = Cw(e, l) || kA(e, l);
  let d = "";
  return n ? (d = NA(e, {
    addSuffix: !0
  }), d = bb(d)) : d = Gl(e, o), /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ I("span", { className: le("text-sm", i && (c ? "text-functional-warn font-semibold" : ""), s), children: [
    d,
    r && " • ",
    r && Gl(e, a),
    r && t && ` - ${Gl(Aw(e, t), a)}`
  ] }) });
}
const DA = ["top", "right", "bottom", "left"], fr = Math.min, Yt = Math.max, us = Math.round, Mi = Math.floor, pr = (e) => ({
  x: e,
  y: e
}), FA = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, RA = {
  start: "end",
  end: "start"
};
function Hc(e, t, n) {
  return Yt(e, fr(t, n));
}
function Ln(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Bn(e) {
  return e.split("-")[0];
}
function Fo(e) {
  return e.split("-")[1];
}
function Td(e) {
  return e === "x" ? "y" : "x";
}
function Od(e) {
  return e === "y" ? "height" : "width";
}
function Ro(e) {
  return ["top", "bottom"].includes(Bn(e)) ? "y" : "x";
}
function Nd(e) {
  return Td(Ro(e));
}
function _A(e, t, n) {
  n === void 0 && (n = !1);
  const r = Fo(e), o = Nd(e), a = Od(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = ds(i)), [i, ds(i)];
}
function IA(e) {
  const t = ds(e);
  return [Uc(e), t, Uc(t)];
}
function Uc(e) {
  return e.replace(/start|end/g, (t) => RA[t]);
}
function LA(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function BA(e, t, n, r) {
  const o = Fo(e);
  let a = LA(Bn(e), n === "start", r);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(Uc)))), a;
}
function ds(e) {
  return e.replace(/left|right|bottom|top/g, (t) => FA[t]);
}
function zA(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Vm(e) {
  return typeof e != "number" ? zA(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function fs(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function b1(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Ro(t), i = Nd(t), s = Od(i), l = Bn(t), c = a === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, p = r[s] / 2 - o[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (Fo(t)) {
    case "start":
      m[i] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      m[i] += p * (n && c ? -1 : 1);
      break;
  }
  return m;
}
const WA = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = b1(c, r, l), p = r, m = {}, h = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: x,
      fn: y
    } = s[g], {
      x: b,
      y: v,
      data: A,
      reset: w
    } = await y({
      x: d,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: m,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = b ?? d, f = v ?? f, m = {
      ...m,
      [x]: {
        ...m[x],
        ...A
      }
    }, w && h <= 50) {
      h++, typeof w == "object" && (w.placement && (p = w.placement), w.rects && (c = w.rects === !0 ? await i.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : w.rects), {
        x: d,
        y: f
      } = b1(c, p, l)), g = -1;
      continue;
    }
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: o,
    middlewareData: m
  };
};
async function xa(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = Ln(t, e), h = Vm(m), x = s[p ? f === "floating" ? "reference" : "floating" : f], y = fs(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(x))) == null || n ? x : x.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), b = f === "floating" ? {
    ...i.floating,
    x: r,
    y: o
  } : i.reference, v = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), A = await (a.isElement == null ? void 0 : a.isElement(v)) ? await (a.getScale == null ? void 0 : a.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = fs(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: b,
    offsetParent: v,
    strategy: l
  }) : b);
  return {
    top: (y.top - w.top + h.top) / A.y,
    bottom: (w.bottom - y.bottom + h.bottom) / A.y,
    left: (y.left - w.left + h.left) / A.x,
    right: (w.right - y.right + h.right) / A.x
  };
}
const x1 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: d = 0
    } = Ln(e, t) || {};
    if (c == null)
      return {};
    const f = Vm(d), p = {
      x: n,
      y: r
    }, m = Nd(o), h = Od(m), g = await i.getDimensions(c), x = m === "y", y = x ? "top" : "left", b = x ? "bottom" : "right", v = x ? "clientHeight" : "clientWidth", A = a.reference[h] + a.reference[m] - p[m] - a.floating[h], w = p[m] - a.reference[m], M = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let $ = M ? M[v] : 0;
    (!$ || !await (i.isElement == null ? void 0 : i.isElement(M))) && ($ = s.floating[v] || a.floating[h]);
    const P = A / 2 - w / 2, E = $ / 2 - g[h] / 2 - 1, T = fr(f[y], E), B = fr(f[b], E), j = T, V = $ - g[h] - B, W = $ / 2 - g[h] / 2 + P, S = Hc(j, W, V), _ = !l.arrow && Fo(o) != null && W != S && a.reference[h] / 2 - (W < j ? T : B) - g[h] / 2 < 0, U = _ ? W < j ? W - j : W - V : 0;
    return {
      [m]: p[m] + U,
      data: {
        [m]: S,
        centerOffset: W - S - U,
        ..._ && {
          alignmentOffset: U
        }
      },
      reset: _
    };
  }
}), Hm = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...x
      } = Ln(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = Bn(o), b = Bn(s) === s, v = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), A = p || (b || !g ? [ds(s)] : IA(s));
      !p && h !== "none" && A.push(...BA(s, g, h, v));
      const w = [s, ...A], M = await xa(t, x), $ = [];
      let P = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && $.push(M[y]), f) {
        const j = _A(o, i, v);
        $.push(M[j[0]], M[j[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: $
      }], !$.every((j) => j <= 0)) {
        var E, T;
        const j = (((E = a.flip) == null ? void 0 : E.index) || 0) + 1, V = w[j];
        if (V)
          return {
            data: {
              index: j,
              overflows: P
            },
            reset: {
              placement: V
            }
          };
        let W = (T = P.filter((S) => S.overflows[0] <= 0).sort((S, _) => S.overflows[1] - _.overflows[1])[0]) == null ? void 0 : T.placement;
        if (!W)
          switch (m) {
            case "bestFit": {
              var B;
              const S = (B = P.map((_) => [_.placement, _.overflows.filter((U) => U > 0).reduce((U, z) => U + z, 0)]).sort((_, U) => _[1] - U[1])[0]) == null ? void 0 : B[0];
              S && (W = S);
              break;
            }
            case "initialPlacement":
              W = s;
              break;
          }
        if (o !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
function w1(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function A1(e) {
  return DA.some((t) => e[t] >= 0);
}
const Um = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Ln(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await xa(t, {
            ...o,
            elementContext: "reference"
          }), i = w1(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: A1(i)
            }
          };
        }
        case "escaped": {
          const a = await xa(t, {
            ...o,
            altBoundary: !0
          }), i = w1(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: A1(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function jA(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Bn(n), s = Fo(n), l = Ro(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, d = a && l ? -1 : 1, f = Ln(t, e);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return s && typeof h == "number" && (m = s === "end" ? h * -1 : h), l ? {
    x: m * d,
    y: p * c
  } : {
    x: p * c,
    y: m * d
  };
}
const Ym = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await jA(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, Gm = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (x) => {
            let {
              x: y,
              y: b
            } = x;
            return {
              x: y,
              y: b
            };
          }
        },
        ...l
      } = Ln(e, t), c = {
        x: n,
        y: r
      }, d = await xa(t, l), f = Ro(Bn(o)), p = Td(f);
      let m = c[p], h = c[f];
      if (a) {
        const x = p === "y" ? "top" : "left", y = p === "y" ? "bottom" : "right", b = m + d[x], v = m - d[y];
        m = Hc(b, m, v);
      }
      if (i) {
        const x = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", b = h + d[x], v = h - d[y];
        h = Hc(b, h, v);
      }
      const g = s.fn({
        ...t,
        [p]: m,
        [f]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, Xm = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Ln(e, t), d = {
        x: n,
        y: r
      }, f = Ro(o), p = Td(f);
      let m = d[p], h = d[f];
      const g = Ln(s, t), x = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const v = p === "y" ? "height" : "width", A = a.reference[p] - a.floating[v] + x.mainAxis, w = a.reference[p] + a.reference[v] - x.mainAxis;
        m < A ? m = A : m > w && (m = w);
      }
      if (c) {
        var y, b;
        const v = p === "y" ? "width" : "height", A = ["top", "left"].includes(Bn(o)), w = a.reference[f] - a.floating[v] + (A && ((y = i.offset) == null ? void 0 : y[f]) || 0) + (A ? 0 : x.crossAxis), M = a.reference[f] + a.reference[v] + (A ? 0 : ((b = i.offset) == null ? void 0 : b[f]) || 0) - (A ? x.crossAxis : 0);
        h < w ? h = w : h > M && (h = M);
      }
      return {
        [p]: m,
        [f]: h
      };
    }
  };
}, qm = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: a
      } = t, {
        apply: i = () => {
        },
        ...s
      } = Ln(e, t), l = await xa(t, s), c = Bn(n), d = Fo(n), f = Ro(n) === "y", {
        width: p,
        height: m
      } = r.floating;
      let h, g;
      c === "top" || c === "bottom" ? (h = c, g = d === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (g = c, h = d === "end" ? "top" : "bottom");
      const x = m - l[h], y = p - l[g], b = !t.middlewareData.shift;
      let v = x, A = y;
      if (f) {
        const M = p - l.left - l.right;
        A = d || b ? fr(y, M) : M;
      } else {
        const M = m - l.top - l.bottom;
        v = d || b ? fr(x, M) : M;
      }
      if (b && !d) {
        const M = Yt(l.left, 0), $ = Yt(l.right, 0), P = Yt(l.top, 0), E = Yt(l.bottom, 0);
        f ? A = p - 2 * (M !== 0 || $ !== 0 ? M + $ : Yt(l.left, l.right)) : v = m - 2 * (P !== 0 || E !== 0 ? P + E : Yt(l.top, l.bottom));
      }
      await i({
        ...t,
        availableWidth: A,
        availableHeight: v
      });
      const w = await o.getDimensions(a.floating);
      return p !== w.width || m !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function hr(e) {
  return Km(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Gt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Yn(e) {
  var t;
  return (t = (Km(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Km(e) {
  return e instanceof Node || e instanceof Gt(e).Node;
}
function zn(e) {
  return e instanceof Element || e instanceof Gt(e).Element;
}
function Pn(e) {
  return e instanceof HTMLElement || e instanceof Gt(e).HTMLElement;
}
function C1(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Gt(e).ShadowRoot;
}
function ja(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = rn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function VA(e) {
  return ["table", "td", "th"].includes(hr(e));
}
function kd(e) {
  const t = Dd(), n = rn(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function HA(e) {
  let t = bo(e);
  for (; Pn(t) && !nl(t); ) {
    if (kd(t))
      return t;
    t = bo(t);
  }
  return null;
}
function Dd() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function nl(e) {
  return ["html", "body", "#document"].includes(hr(e));
}
function rn(e) {
  return Gt(e).getComputedStyle(e);
}
function rl(e) {
  return zn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function bo(e) {
  if (hr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    C1(e) && e.host || // Fallback.
    Yn(e)
  );
  return C1(t) ? t.host : t;
}
function Qm(e) {
  const t = bo(e);
  return nl(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Pn(t) && ja(t) ? t : Qm(t);
}
function wa(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Qm(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Gt(o);
  return a ? t.concat(i, i.visualViewport || [], ja(o) ? o : [], i.frameElement && n ? wa(i.frameElement) : []) : t.concat(o, wa(o, [], n));
}
function Zm(e) {
  const t = rn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Pn(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, s = us(n) !== a || us(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function Fd(e) {
  return zn(e) ? e : e.contextElement;
}
function po(e) {
  const t = Fd(e);
  if (!Pn(t))
    return pr(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = Zm(t);
  let i = (a ? us(n.width) : n.width) / r, s = (a ? us(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const UA = /* @__PURE__ */ pr(0);
function Jm(e) {
  const t = Gt(e);
  return !Dd() || !t.visualViewport ? UA : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function YA(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Gt(e) ? !1 : t;
}
function Rr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Fd(e);
  let i = pr(1);
  t && (r ? zn(r) && (i = po(r)) : i = po(e));
  const s = YA(a, n, r) ? Jm(a) : pr(0);
  let l = (o.left + s.x) / i.x, c = (o.top + s.y) / i.y, d = o.width / i.x, f = o.height / i.y;
  if (a) {
    const p = Gt(a), m = r && zn(r) ? Gt(r) : r;
    let h = p.frameElement;
    for (; h && r && m !== p; ) {
      const g = po(h), x = h.getBoundingClientRect(), y = rn(h), b = x.left + (h.clientLeft + parseFloat(y.paddingLeft)) * g.x, v = x.top + (h.clientTop + parseFloat(y.paddingTop)) * g.y;
      l *= g.x, c *= g.y, d *= g.x, f *= g.y, l += b, c += v, h = Gt(h).frameElement;
    }
  }
  return fs({
    width: d,
    height: f,
    x: l,
    y: c
  });
}
function GA(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = Pn(n), a = Yn(n);
  if (n === a)
    return t;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = pr(1);
  const l = pr(0);
  if ((o || !o && r !== "fixed") && ((hr(n) !== "body" || ja(a)) && (i = rl(n)), Pn(n))) {
    const c = Rr(n);
    s = po(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - i.scrollLeft * s.x + l.x,
    y: t.y * s.y - i.scrollTop * s.y + l.y
  };
}
function XA(e) {
  return Array.from(e.getClientRects());
}
function eg(e) {
  return Rr(Yn(e)).left + rl(e).scrollLeft;
}
function qA(e) {
  const t = Yn(e), n = rl(e), r = e.ownerDocument.body, o = Yt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Yt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + eg(e);
  const s = -n.scrollTop;
  return rn(r).direction === "rtl" && (i += Yt(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function KA(e, t) {
  const n = Gt(e), r = Yn(e), o = n.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const c = Dd();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function QA(e, t) {
  const n = Rr(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = Pn(e) ? po(e) : pr(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, c = r * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function S1(e, t, n) {
  let r;
  if (t === "viewport")
    r = KA(e, n);
  else if (t === "document")
    r = qA(Yn(e));
  else if (zn(t))
    r = QA(t, n);
  else {
    const o = Jm(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return fs(r);
}
function tg(e, t) {
  const n = bo(e);
  return n === t || !zn(n) || nl(n) ? !1 : rn(n).position === "fixed" || tg(n, t);
}
function ZA(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = wa(e, [], !1).filter((s) => zn(s) && hr(s) !== "body"), o = null;
  const a = rn(e).position === "fixed";
  let i = a ? bo(e) : e;
  for (; zn(i) && !nl(i); ) {
    const s = rn(i), l = kd(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ja(i) && !l && tg(e, i)) ? r = r.filter((d) => d !== i) : o = s, i = bo(i);
  }
  return t.set(e, r), r;
}
function JA(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? ZA(t, this._c) : [].concat(n), r], s = i[0], l = i.reduce((c, d) => {
    const f = S1(t, d, o);
    return c.top = Yt(f.top, c.top), c.right = fr(f.right, c.right), c.bottom = fr(f.bottom, c.bottom), c.left = Yt(f.left, c.left), c;
  }, S1(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function eC(e) {
  return Zm(e);
}
function tC(e, t, n) {
  const r = Pn(t), o = Yn(t), a = n === "fixed", i = Rr(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = pr(0);
  if (r || !r && !a)
    if ((hr(t) !== "body" || ja(o)) && (s = rl(t)), r) {
      const c = Rr(t, !0, a, t);
      l.x = c.x + t.clientLeft, l.y = c.y + t.clientTop;
    } else
      o && (l.x = eg(o));
  return {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function E1(e, t) {
  return !Pn(e) || rn(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function ng(e, t) {
  const n = Gt(e);
  if (!Pn(e))
    return n;
  let r = E1(e, t);
  for (; r && VA(r) && rn(r).position === "static"; )
    r = E1(r, t);
  return r && (hr(r) === "html" || hr(r) === "body" && rn(r).position === "static" && !kd(r)) ? n : r || HA(e) || n;
}
const nC = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || ng, a = this.getDimensions;
  return {
    reference: tC(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function rC(e) {
  return rn(e).direction === "rtl";
}
const oC = {
  convertOffsetParentRelativeRectToViewportRelativeRect: GA,
  getDocumentElement: Yn,
  getClippingRect: JA,
  getOffsetParent: ng,
  getElementRects: nC,
  getClientRects: XA,
  getDimensions: eC,
  getScale: po,
  isElement: zn,
  isRTL: rC
};
function aC(e, t) {
  let n = null, r;
  const o = Yn(e);
  function a() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: c,
      top: d,
      width: f,
      height: p
    } = e.getBoundingClientRect();
    if (s || t(), !f || !p)
      return;
    const m = Mi(d), h = Mi(o.clientWidth - (c + f)), g = Mi(o.clientHeight - (d + p)), x = Mi(c), b = {
      rootMargin: -m + "px " + -h + "px " + -g + "px " + -x + "px",
      threshold: Yt(0, fr(1, l)) || 1
    };
    let v = !0;
    function A(w) {
      const M = w[0].intersectionRatio;
      if (M !== l) {
        if (!v)
          return i();
        M ? i(!1, M) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      v = !1;
    }
    try {
      n = new IntersectionObserver(A, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(A, b);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function rg(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Fd(e), d = o || a ? [...c ? wa(c) : [], ...wa(t)] : [];
  d.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const f = c && s ? aC(c, n) : null;
  let p = -1, m = null;
  i && (m = new ResizeObserver((y) => {
    let [b] = y;
    b && b.target === c && m && (m.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      m && m.observe(t);
    })), n();
  }), c && !l && m.observe(c), m.observe(t));
  let h, g = l ? Rr(e) : null;
  l && x();
  function x() {
    const y = Rr(e);
    g && (y.x !== g.x || y.y !== g.y || y.width !== g.width || y.height !== g.height) && n(), g = y, h = requestAnimationFrame(x);
  }
  return n(), () => {
    d.forEach((y) => {
      o && y.removeEventListener("scroll", n), a && y.removeEventListener("resize", n);
    }), f && f(), m && m.disconnect(), m = null, l && cancelAnimationFrame(h);
  };
}
const iC = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: oC,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return WA(e, t, {
    ...o,
    platform: a
  });
}, og = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? x1({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? x1({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var Qi = typeof document < "u" ? i2 : Ce;
function ps(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!ps(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !ps(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ag(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function M1(e, t) {
  const n = ag(e);
  return Math.round(t * n) / n;
}
function $1(e) {
  const t = Z.useRef(e);
  return Qi(() => {
    t.current = e;
  }), t;
}
function ig(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [d, f] = Z.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, m] = Z.useState(r);
  ps(p, r) || m(r);
  const [h, g] = Z.useState(null), [x, y] = Z.useState(null), b = Z.useCallback((_) => {
    _ != M.current && (M.current = _, g(_));
  }, [g]), v = Z.useCallback((_) => {
    _ !== $.current && ($.current = _, y(_));
  }, [y]), A = a || h, w = i || x, M = Z.useRef(null), $ = Z.useRef(null), P = Z.useRef(d), E = $1(l), T = $1(o), B = Z.useCallback(() => {
    if (!M.current || !$.current)
      return;
    const _ = {
      placement: t,
      strategy: n,
      middleware: p
    };
    T.current && (_.platform = T.current), iC(M.current, $.current, _).then((U) => {
      const z = {
        ...U,
        isPositioned: !0
      };
      j.current && !ps(P.current, z) && (P.current = z, ud.flushSync(() => {
        f(z);
      }));
    });
  }, [p, t, n, T]);
  Qi(() => {
    c === !1 && P.current.isPositioned && (P.current.isPositioned = !1, f((_) => ({
      ..._,
      isPositioned: !1
    })));
  }, [c]);
  const j = Z.useRef(!1);
  Qi(() => (j.current = !0, () => {
    j.current = !1;
  }), []), Qi(() => {
    if (A && (M.current = A), w && ($.current = w), A && w) {
      if (E.current)
        return E.current(A, w, B);
      B();
    }
  }, [A, w, B, E]);
  const V = Z.useMemo(() => ({
    reference: M,
    floating: $,
    setReference: b,
    setFloating: v
  }), [b, v]), W = Z.useMemo(() => ({
    reference: A,
    floating: w
  }), [A, w]), S = Z.useMemo(() => {
    const _ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return _;
    const U = M1(W.floating, d.x), z = M1(W.floating, d.y);
    return s ? {
      ..._,
      transform: "translate(" + U + "px, " + z + "px)",
      ...ag(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: U,
      top: z
    };
  }, [n, s, W.floating, d.x, d.y]);
  return Z.useMemo(() => ({
    ...d,
    update: B,
    refs: V,
    elements: W,
    floatingStyles: S
  }), [d, B, V, W, S]);
}
const sg = "Popper", [lg, _o] = gt(sg), [sC, cg] = lg(sg), lC = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = we(null);
  return /* @__PURE__ */ F(sC, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, cC = "PopperAnchor", uC = /* @__PURE__ */ Y((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, a = cg(cC, n), i = de(null), s = De(t, i);
  return Ce(() => {
    a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
  }), r ? null : /* @__PURE__ */ F(Ee.div, K({}, o, {
    ref: s
  }));
}), ug = "PopperContent", [dC, BH] = lg(ug), fC = /* @__PURE__ */ Y((e, t) => {
  var n, r, o, a, i, s, l, c;
  const { __scopePopper: d, side: f = "bottom", sideOffset: p = 0, align: m = "center", alignOffset: h = 0, arrowPadding: g = 0, avoidCollisions: x = !0, collisionBoundary: y = [], collisionPadding: b = 0, sticky: v = "partial", hideWhenDetached: A = !1, updatePositionStrategy: w = "optimized", onPlaced: M, ...$ } = e, P = cg(ug, d), [E, T] = we(null), B = De(
    t,
    (ye) => T(ye)
  ), [j, V] = we(null), W = dd(j), S = (n = W == null ? void 0 : W.width) !== null && n !== void 0 ? n : 0, _ = (r = W == null ? void 0 : W.height) !== null && r !== void 0 ? r : 0, U = f + (m !== "center" ? "-" + m : ""), z = typeof b == "number" ? b : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...b
  }, N = Array.isArray(y) ? y : [
    y
  ], O = N.length > 0, k = {
    padding: z,
    boundary: N.filter(pC),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: O
  }, { refs: Q, floatingStyles: q, placement: re, isPositioned: ae, middlewareData: oe } = ig({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: U,
    whileElementsMounted: (...ye) => rg(...ye, {
      animationFrame: w === "always"
    }),
    elements: {
      reference: P.anchor
    },
    middleware: [
      Ym({
        mainAxis: p + _,
        alignmentAxis: h
      }),
      x && Gm({
        mainAxis: !0,
        crossAxis: !1,
        limiter: v === "partial" ? Xm() : void 0,
        ...k
      }),
      x && Hm({
        ...k
      }),
      qm({
        ...k,
        apply: ({ elements: ye, rects: Me, availableWidth: Oe, availableHeight: it }) => {
          const { width: Qe, height: yt } = Me.reference, At = ye.floating.style;
          At.setProperty("--radix-popper-available-width", `${Oe}px`), At.setProperty("--radix-popper-available-height", `${it}px`), At.setProperty("--radix-popper-anchor-width", `${Qe}px`), At.setProperty("--radix-popper-anchor-height", `${yt}px`);
        }
      }),
      j && og({
        element: j,
        padding: g
      }),
      hC({
        arrowWidth: S,
        arrowHeight: _
      }),
      A && Um({
        strategy: "referenceHidden",
        ...k
      })
    ]
  }), [ee, ie] = dg(re), X = lt(M);
  Mt(() => {
    ae && (X == null || X());
  }, [
    ae,
    X
  ]);
  const J = (o = oe.arrow) === null || o === void 0 ? void 0 : o.x, pe = (a = oe.arrow) === null || a === void 0 ? void 0 : a.y, D = ((i = oe.arrow) === null || i === void 0 ? void 0 : i.centerOffset) !== 0, [ce, he] = we();
  return Mt(() => {
    E && he(window.getComputedStyle(E).zIndex);
  }, [
    E
  ]), /* @__PURE__ */ F("div", {
    ref: Q.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...q,
      transform: ae ? q.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ce,
      "--radix-popper-transform-origin": [
        (s = oe.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (l = oe.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ F(dC, {
    scope: d,
    placedSide: ee,
    onArrowChange: V,
    arrowX: J,
    arrowY: pe,
    shouldHideArrow: D
  }, /* @__PURE__ */ F(Ee.div, K({
    "data-side": ee,
    "data-align": ie
  }, $, {
    ref: B,
    style: {
      ...$.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ae ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = oe.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
});
function pC(e) {
  return e !== null;
}
const hC = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, a, i;
    const { placement: s, rects: l, middlewareData: c } = t, f = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, p = f ? 0 : e.arrowWidth, m = f ? 0 : e.arrowHeight, [h, g] = dg(s), x = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], y = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + p / 2, b = ((a = (i = c.arrow) === null || i === void 0 ? void 0 : i.y) !== null && a !== void 0 ? a : 0) + m / 2;
    let v = "", A = "";
    return h === "bottom" ? (v = f ? x : `${y}px`, A = `${-m}px`) : h === "top" ? (v = f ? x : `${y}px`, A = `${l.floating.height + m}px`) : h === "right" ? (v = `${-m}px`, A = f ? x : `${b}px`) : h === "left" && (v = `${l.floating.width + m}px`, A = f ? x : `${b}px`), {
      data: {
        x: v,
        y: A
      }
    };
  }
});
function dg(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const ol = lC, Rd = uC, _d = fC, Xl = "rovingFocusGroup.onEntryFocus", mC = {
  bubbles: !1,
  cancelable: !0
}, Id = "RovingFocusGroup", [Yc, fg, gC] = Hr(Id), [vC, Io] = gt(Id, [
  gC
]), [yC, bC] = vC(Id), xC = /* @__PURE__ */ Y((e, t) => /* @__PURE__ */ F(Yc.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ F(Yc.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ F(wC, K({}, e, {
  ref: t
}))))), wC = /* @__PURE__ */ Y((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: a, currentTabStopId: i, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: l, onEntryFocus: c, ...d } = e, f = de(null), p = De(t, f), m = vr(a), [h = null, g] = wt({
    prop: i,
    defaultProp: s,
    onChange: l
  }), [x, y] = we(!1), b = lt(c), v = fg(n), A = de(!1), [w, M] = we(0);
  return Ce(() => {
    const $ = f.current;
    if ($)
      return $.addEventListener(Xl, b), () => $.removeEventListener(Xl, b);
  }, [
    b
  ]), /* @__PURE__ */ F(yC, {
    scope: n,
    orientation: r,
    dir: m,
    loop: o,
    currentTabStopId: h,
    onItemFocus: me(
      ($) => g($),
      [
        g
      ]
    ),
    onItemShiftTab: me(
      () => y(!0),
      []
    ),
    onFocusableItemAdd: me(
      () => M(
        ($) => $ + 1
      ),
      []
    ),
    onFocusableItemRemove: me(
      () => M(
        ($) => $ - 1
      ),
      []
    )
  }, /* @__PURE__ */ F(Ee.div, K({
    tabIndex: x || w === 0 ? -1 : 0,
    "data-orientation": r
  }, d, {
    ref: p,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: ve(e.onMouseDown, () => {
      A.current = !0;
    }),
    onFocus: ve(e.onFocus, ($) => {
      const P = !A.current;
      if ($.target === $.currentTarget && P && !x) {
        const E = new CustomEvent(Xl, mC);
        if ($.currentTarget.dispatchEvent(E), !E.defaultPrevented) {
          const T = v().filter(
            (S) => S.focusable
          ), B = T.find(
            (S) => S.active
          ), j = T.find(
            (S) => S.id === h
          ), W = [
            B,
            j,
            ...T
          ].filter(Boolean).map(
            (S) => S.ref.current
          );
          pg(W);
        }
      }
      A.current = !1;
    }),
    onBlur: ve(
      e.onBlur,
      () => y(!1)
    )
  })));
}), AC = "RovingFocusGroupItem", CC = /* @__PURE__ */ Y((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: a, ...i } = e, s = xt(), l = a || s, c = bC(AC, n), d = c.currentTabStopId === l, f = fg(n), { onFocusableItemAdd: p, onFocusableItemRemove: m } = c;
  return Ce(() => {
    if (r)
      return p(), () => m();
  }, [
    r,
    p,
    m
  ]), /* @__PURE__ */ F(Yc.ItemSlot, {
    scope: n,
    id: l,
    focusable: r,
    active: o
  }, /* @__PURE__ */ F(Ee.span, K({
    tabIndex: d ? 0 : -1,
    "data-orientation": c.orientation
  }, i, {
    ref: t,
    onMouseDown: ve(e.onMouseDown, (h) => {
      r ? c.onItemFocus(l) : h.preventDefault();
    }),
    onFocus: ve(
      e.onFocus,
      () => c.onItemFocus(l)
    ),
    onKeyDown: ve(e.onKeyDown, (h) => {
      if (h.key === "Tab" && h.shiftKey) {
        c.onItemShiftTab();
        return;
      }
      if (h.target !== h.currentTarget)
        return;
      const g = MC(h, c.orientation, c.dir);
      if (g !== void 0) {
        h.preventDefault();
        let y = f().filter(
          (b) => b.focusable
        ).map(
          (b) => b.ref.current
        );
        if (g === "last")
          y.reverse();
        else if (g === "prev" || g === "next") {
          g === "prev" && y.reverse();
          const b = y.indexOf(h.currentTarget);
          y = c.loop ? $C(y, b + 1) : y.slice(b + 1);
        }
        setTimeout(
          () => pg(y)
        );
      }
    })
  })));
}), SC = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function EC(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function MC(e, t, n) {
  const r = EC(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return SC[r];
}
function pg(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function $C(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const Ld = xC, Bd = CC, Gc = [
  "Enter",
  " "
], PC = [
  "ArrowDown",
  "PageUp",
  "Home"
], hg = [
  "ArrowUp",
  "PageDown",
  "End"
], TC = [
  ...PC,
  ...hg
], OC = {
  ltr: [
    ...Gc,
    "ArrowRight"
  ],
  rtl: [
    ...Gc,
    "ArrowLeft"
  ]
}, NC = {
  ltr: [
    "ArrowLeft"
  ],
  rtl: [
    "ArrowRight"
  ]
}, al = "Menu", [Aa, kC, DC] = Hr(al), [Ur, mg] = gt(al, [
  DC,
  _o,
  Io
]), il = _o(), gg = Io(), [vg, br] = Ur(al), [FC, Va] = Ur(al), RC = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: i = !0 } = e, s = il(t), [l, c] = we(null), d = de(!1), f = lt(a), p = vr(o);
  return Ce(() => {
    const m = () => {
      d.current = !0, document.addEventListener("pointerdown", h, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", h, {
        capture: !0,
        once: !0
      });
    }, h = () => d.current = !1;
    return document.addEventListener("keydown", m, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", m, {
        capture: !0
      }), document.removeEventListener("pointerdown", h, {
        capture: !0
      }), document.removeEventListener("pointermove", h, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ F(ol, s, /* @__PURE__ */ F(vg, {
    scope: t,
    open: n,
    onOpenChange: f,
    content: l,
    onContentChange: c
  }, /* @__PURE__ */ F(FC, {
    scope: t,
    onClose: me(
      () => f(!1),
      [
        f
      ]
    ),
    isUsingKeyboardRef: d,
    dir: p,
    modal: i
  }, r)));
}, yg = /* @__PURE__ */ Y((e, t) => {
  const { __scopeMenu: n, ...r } = e, o = il(n);
  return /* @__PURE__ */ F(Rd, K({}, o, r, {
    ref: t
  }));
}), bg = "MenuPortal", [_C, xg] = Ur(bg, {
  forceMount: void 0
}), IC = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = br(bg, t);
  return /* @__PURE__ */ F(_C, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ F(Bt, {
    present: n || a.open
  }, /* @__PURE__ */ F(el, {
    asChild: !0,
    container: o
  }, r)));
}, hn = "MenuContent", [LC, zd] = Ur(hn), BC = /* @__PURE__ */ Y((e, t) => {
  const n = xg(hn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = br(hn, e.__scopeMenu), i = Va(hn, e.__scopeMenu);
  return /* @__PURE__ */ F(Aa.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ F(Bt, {
    present: r || a.open
  }, /* @__PURE__ */ F(Aa.Slot, {
    scope: e.__scopeMenu
  }, i.modal ? /* @__PURE__ */ F(zC, K({}, o, {
    ref: t
  })) : /* @__PURE__ */ F(WC, K({}, o, {
    ref: t
  })))));
}), zC = /* @__PURE__ */ Y((e, t) => {
  const n = br(hn, e.__scopeMenu), r = de(null), o = De(t, r);
  return Ce(() => {
    const a = r.current;
    if (a)
      return Md(a);
  }, []), /* @__PURE__ */ F(Wd, K({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: ve(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), WC = /* @__PURE__ */ Y((e, t) => {
  const n = br(hn, e.__scopeMenu);
  return /* @__PURE__ */ F(Wd, K({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), Wd = /* @__PURE__ */ Y((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: s, onEntryFocus: l, onEscapeKeyDown: c, onPointerDownOutside: d, onFocusOutside: f, onInteractOutside: p, onDismiss: m, disableOutsideScroll: h, ...g } = e, x = br(hn, n), y = Va(hn, n), b = il(n), v = gg(n), A = kC(n), [w, M] = we(null), $ = de(null), P = De(t, $, x.onContentChange), E = de(0), T = de(""), B = de(0), j = de(null), V = de("right"), W = de(0), S = h ? Ed : ur, _ = h ? {
    as: $n,
    allowPinchZoom: !0
  } : void 0, U = (N) => {
    var O, k;
    const Q = T.current + N, q = A().filter(
      (X) => !X.disabled
    ), re = document.activeElement, ae = (O = q.find(
      (X) => X.ref.current === re
    )) === null || O === void 0 ? void 0 : O.textValue, oe = q.map(
      (X) => X.textValue
    ), ee = iS(oe, Q, ae), ie = (k = q.find(
      (X) => X.textValue === ee
    )) === null || k === void 0 ? void 0 : k.ref.current;
    (function X(J) {
      T.current = J, window.clearTimeout(E.current), J !== "" && (E.current = window.setTimeout(
        () => X(""),
        1e3
      ));
    })(Q), ie && setTimeout(
      () => ie.focus()
    );
  };
  Ce(() => () => window.clearTimeout(E.current), []), Sd();
  const z = me((N) => {
    var O, k;
    return V.current === ((O = j.current) === null || O === void 0 ? void 0 : O.side) && lS(N, (k = j.current) === null || k === void 0 ? void 0 : k.area);
  }, []);
  return /* @__PURE__ */ F(LC, {
    scope: n,
    searchRef: T,
    onItemEnter: me((N) => {
      z(N) && N.preventDefault();
    }, [
      z
    ]),
    onItemLeave: me((N) => {
      var O;
      z(N) || ((O = $.current) === null || O === void 0 || O.focus(), M(null));
    }, [
      z
    ]),
    onTriggerLeave: me((N) => {
      z(N) && N.preventDefault();
    }, [
      z
    ]),
    pointerGraceTimerRef: B,
    onPointerGraceIntentChange: me((N) => {
      j.current = N;
    }, [])
  }, /* @__PURE__ */ F(S, _, /* @__PURE__ */ F(Cd, {
    asChild: !0,
    trapped: o,
    onMountAutoFocus: ve(a, (N) => {
      var O;
      N.preventDefault(), (O = $.current) === null || O === void 0 || O.focus();
    }),
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ F(za, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: c,
    onPointerDownOutside: d,
    onFocusOutside: f,
    onInteractOutside: p,
    onDismiss: m
  }, /* @__PURE__ */ F(Ld, K({
    asChild: !0
  }, v, {
    dir: y.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: w,
    onCurrentTabStopIdChange: M,
    onEntryFocus: ve(l, (N) => {
      y.isUsingKeyboardRef.current || N.preventDefault();
    })
  }), /* @__PURE__ */ F(_d, K({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": $g(x.open),
    "data-radix-menu-content": "",
    dir: y.dir
  }, b, g, {
    ref: P,
    style: {
      outline: "none",
      ...g.style
    },
    onKeyDown: ve(g.onKeyDown, (N) => {
      const k = N.target.closest("[data-radix-menu-content]") === N.currentTarget, Q = N.ctrlKey || N.altKey || N.metaKey, q = N.key.length === 1;
      k && (N.key === "Tab" && N.preventDefault(), !Q && q && U(N.key));
      const re = $.current;
      if (N.target !== re || !TC.includes(N.key))
        return;
      N.preventDefault();
      const oe = A().filter(
        (ee) => !ee.disabled
      ).map(
        (ee) => ee.ref.current
      );
      hg.includes(N.key) && oe.reverse(), oS(oe);
    }),
    onBlur: ve(e.onBlur, (N) => {
      N.currentTarget.contains(N.target) || (window.clearTimeout(E.current), T.current = "");
    }),
    onPointerMove: ve(e.onPointerMove, Ca((N) => {
      const O = N.target, k = W.current !== N.clientX;
      if (N.currentTarget.contains(O) && k) {
        const Q = N.clientX > W.current ? "right" : "left";
        V.current = Q, W.current = N.clientX;
      }
    }))
  })))))));
}), wg = /* @__PURE__ */ Y((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ F(Ee.div, K({
    role: "group"
  }, r, {
    ref: t
  }));
}), jC = /* @__PURE__ */ Y((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ F(Ee.div, K({}, r, {
    ref: t
  }));
}), Xc = "MenuItem", P1 = "menu.itemSelect", jd = /* @__PURE__ */ Y((e, t) => {
  const { disabled: n = !1, onSelect: r, ...o } = e, a = de(null), i = Va(Xc, e.__scopeMenu), s = zd(Xc, e.__scopeMenu), l = De(t, a), c = de(!1), d = () => {
    const f = a.current;
    if (!n && f) {
      const p = new CustomEvent(P1, {
        bubbles: !0,
        cancelable: !0
      });
      f.addEventListener(
        P1,
        (m) => r == null ? void 0 : r(m),
        {
          once: !0
        }
      ), os(f, p), p.defaultPrevented ? c.current = !1 : i.onClose();
    }
  };
  return /* @__PURE__ */ F(Ag, K({}, o, {
    ref: l,
    disabled: n,
    onClick: ve(e.onClick, d),
    onPointerDown: (f) => {
      var p;
      (p = e.onPointerDown) === null || p === void 0 || p.call(e, f), c.current = !0;
    },
    onPointerUp: ve(e.onPointerUp, (f) => {
      var p;
      c.current || (p = f.currentTarget) === null || p === void 0 || p.click();
    }),
    onKeyDown: ve(e.onKeyDown, (f) => {
      const p = s.searchRef.current !== "";
      n || p && f.key === " " || Gc.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
    })
  }));
}), Ag = /* @__PURE__ */ Y((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, i = zd(Xc, n), s = gg(n), l = de(null), c = De(t, l), [d, f] = we(!1), [p, m] = we("");
  return Ce(() => {
    const h = l.current;
    if (h) {
      var g;
      m(((g = h.textContent) !== null && g !== void 0 ? g : "").trim());
    }
  }, [
    a.children
  ]), /* @__PURE__ */ F(Aa.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: o ?? p
  }, /* @__PURE__ */ F(Bd, K({
    asChild: !0
  }, s, {
    focusable: !r
  }), /* @__PURE__ */ F(Ee.div, K({
    role: "menuitem",
    "data-highlighted": d ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, a, {
    ref: c,
    onPointerMove: ve(e.onPointerMove, Ca((h) => {
      r ? i.onItemLeave(h) : (i.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus());
    })),
    onPointerLeave: ve(e.onPointerLeave, Ca(
      (h) => i.onItemLeave(h)
    )),
    onFocus: ve(
      e.onFocus,
      () => f(!0)
    ),
    onBlur: ve(
      e.onBlur,
      () => f(!1)
    )
  }))));
}), VC = /* @__PURE__ */ Y((e, t) => {
  const { checked: n = !1, onCheckedChange: r, ...o } = e;
  return /* @__PURE__ */ F(Sg, {
    scope: e.__scopeMenu,
    checked: n
  }, /* @__PURE__ */ F(jd, K({
    role: "menuitemcheckbox",
    "aria-checked": hs(n) ? "mixed" : n
  }, o, {
    ref: t,
    "data-state": Vd(n),
    onSelect: ve(
      o.onSelect,
      () => r == null ? void 0 : r(hs(n) ? !0 : !n),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), HC = "MenuRadioGroup", [UC, YC] = Ur(HC, {
  value: void 0,
  onValueChange: () => {
  }
}), GC = /* @__PURE__ */ Y((e, t) => {
  const { value: n, onValueChange: r, ...o } = e, a = lt(r);
  return /* @__PURE__ */ F(UC, {
    scope: e.__scopeMenu,
    value: n,
    onValueChange: a
  }, /* @__PURE__ */ F(wg, K({}, o, {
    ref: t
  })));
}), XC = "MenuRadioItem", qC = /* @__PURE__ */ Y((e, t) => {
  const { value: n, ...r } = e, o = YC(XC, e.__scopeMenu), a = n === o.value;
  return /* @__PURE__ */ F(Sg, {
    scope: e.__scopeMenu,
    checked: a
  }, /* @__PURE__ */ F(jd, K({
    role: "menuitemradio",
    "aria-checked": a
  }, r, {
    ref: t,
    "data-state": Vd(a),
    onSelect: ve(r.onSelect, () => {
      var i;
      return (i = o.onValueChange) === null || i === void 0 ? void 0 : i.call(o, n);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), Cg = "MenuItemIndicator", [Sg, KC] = Ur(Cg, {
  checked: !1
}), QC = /* @__PURE__ */ Y((e, t) => {
  const { __scopeMenu: n, forceMount: r, ...o } = e, a = KC(Cg, n);
  return /* @__PURE__ */ F(Bt, {
    present: r || hs(a.checked) || a.checked === !0
  }, /* @__PURE__ */ F(Ee.span, K({}, o, {
    ref: t,
    "data-state": Vd(a.checked)
  })));
}), ZC = /* @__PURE__ */ Y((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ F(Ee.div, K({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: t
  }));
}), Eg = "MenuSub", [JC, Mg] = Ur(Eg), eS = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = br(Eg, t), i = il(t), [s, l] = we(null), [c, d] = we(null), f = lt(o);
  return Ce(() => (a.open === !1 && f(!1), () => f(!1)), [
    a.open,
    f
  ]), /* @__PURE__ */ F(ol, i, /* @__PURE__ */ F(vg, {
    scope: t,
    open: r,
    onOpenChange: f,
    content: c,
    onContentChange: d
  }, /* @__PURE__ */ F(JC, {
    scope: t,
    contentId: xt(),
    triggerId: xt(),
    trigger: s,
    onTriggerChange: l
  }, n)));
}, $i = "MenuSubTrigger", tS = /* @__PURE__ */ Y((e, t) => {
  const n = br($i, e.__scopeMenu), r = Va($i, e.__scopeMenu), o = Mg($i, e.__scopeMenu), a = zd($i, e.__scopeMenu), i = de(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = a, c = {
    __scopeMenu: e.__scopeMenu
  }, d = me(() => {
    i.current && window.clearTimeout(i.current), i.current = null;
  }, []);
  return Ce(
    () => d,
    [
      d
    ]
  ), Ce(() => {
    const f = s.current;
    return () => {
      window.clearTimeout(f), l(null);
    };
  }, [
    s,
    l
  ]), /* @__PURE__ */ F(yg, K({
    asChild: !0
  }, c), /* @__PURE__ */ F(Ag, K({
    id: o.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": n.open,
    "aria-controls": o.contentId,
    "data-state": $g(n.open)
  }, e, {
    ref: Hs(t, o.onTriggerChange),
    onClick: (f) => {
      var p;
      (p = e.onClick) === null || p === void 0 || p.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
    },
    onPointerMove: ve(e.onPointerMove, Ca((f) => {
      a.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
        n.onOpenChange(!0), d();
      }, 100));
    })),
    onPointerLeave: ve(e.onPointerLeave, Ca((f) => {
      var p;
      d();
      const m = (p = n.content) === null || p === void 0 ? void 0 : p.getBoundingClientRect();
      if (m) {
        var h;
        const g = (h = n.content) === null || h === void 0 ? void 0 : h.dataset.side, x = g === "right", y = x ? -5 : 5, b = m[x ? "left" : "right"], v = m[x ? "right" : "left"];
        a.onPointerGraceIntentChange({
          area: [
            // consistently within polygon bounds
            {
              x: f.clientX + y,
              y: f.clientY
            },
            {
              x: b,
              y: m.top
            },
            {
              x: v,
              y: m.top
            },
            {
              x: v,
              y: m.bottom
            },
            {
              x: b,
              y: m.bottom
            }
          ],
          side: g
        }), window.clearTimeout(s.current), s.current = window.setTimeout(
          () => a.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (a.onTriggerLeave(f), f.defaultPrevented)
          return;
        a.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: ve(e.onKeyDown, (f) => {
      const p = a.searchRef.current !== "";
      if (!(e.disabled || p && f.key === " ") && OC[r.dir].includes(f.key)) {
        var m;
        n.onOpenChange(!0), (m = n.content) === null || m === void 0 || m.focus(), f.preventDefault();
      }
    })
  })));
}), nS = "MenuSubContent", rS = /* @__PURE__ */ Y((e, t) => {
  const n = xg(hn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = br(hn, e.__scopeMenu), i = Va(hn, e.__scopeMenu), s = Mg(nS, e.__scopeMenu), l = de(null), c = De(t, l);
  return /* @__PURE__ */ F(Aa.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ F(Bt, {
    present: r || a.open
  }, /* @__PURE__ */ F(Aa.Slot, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ F(Wd, K({
    id: s.contentId,
    "aria-labelledby": s.triggerId
  }, o, {
    ref: c,
    align: "start",
    side: i.dir === "rtl" ? "left" : "right",
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    trapFocus: !1,
    onOpenAutoFocus: (d) => {
      var f;
      i.isUsingKeyboardRef.current && ((f = l.current) === null || f === void 0 || f.focus()), d.preventDefault();
    },
    onCloseAutoFocus: (d) => d.preventDefault(),
    onFocusOutside: ve(e.onFocusOutside, (d) => {
      d.target !== s.trigger && a.onOpenChange(!1);
    }),
    onEscapeKeyDown: ve(e.onEscapeKeyDown, (d) => {
      i.onClose(), d.preventDefault();
    }),
    onKeyDown: ve(e.onKeyDown, (d) => {
      const f = d.currentTarget.contains(d.target), p = NC[i.dir].includes(d.key);
      if (f && p) {
        var m;
        a.onOpenChange(!1), (m = s.trigger) === null || m === void 0 || m.focus(), d.preventDefault();
      }
    })
  })))));
});
function $g(e) {
  return e ? "open" : "closed";
}
function hs(e) {
  return e === "indeterminate";
}
function Vd(e) {
  return hs(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function oS(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function aS(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function iS(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (c) => c === t[0]
  ) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = aS(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter(
    (c) => c !== n
  ));
  const l = i.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function sS(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, l = t[a].y, c = t[i].x, d = t[i].y;
    l > r != d > r && n < (c - s) * (r - l) / (d - l) + s && (o = !o);
  }
  return o;
}
function lS(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return sS(n, t);
}
function Ca(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const cS = RC, uS = yg, dS = IC, fS = BC, pS = wg, hS = jC, mS = jd, gS = VC, vS = GC, yS = qC, bS = QC, xS = ZC, wS = eS, AS = tS, CS = rS, Pg = "DropdownMenu", [SS, zH] = gt(Pg, [
  mg
]), Rt = mg(), [ES, Tg] = SS(Pg), MS = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: o, defaultOpen: a, onOpenChange: i, modal: s = !0 } = e, l = Rt(t), c = de(null), [d = !1, f] = wt({
    prop: o,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ F(ES, {
    scope: t,
    triggerId: xt(),
    triggerRef: c,
    contentId: xt(),
    open: d,
    onOpenChange: f,
    onOpenToggle: me(
      () => f(
        (p) => !p
      ),
      [
        f
      ]
    ),
    modal: s
  }, /* @__PURE__ */ F(cS, K({}, l, {
    open: d,
    onOpenChange: f,
    dir: r,
    modal: s
  }), n));
}, $S = "DropdownMenuTrigger", PS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = Tg($S, n), i = Rt(n);
  return /* @__PURE__ */ F(uS, K({
    asChild: !0
  }, i), /* @__PURE__ */ F(Ee.button, K({
    type: "button",
    id: a.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": a.open,
    "aria-controls": a.open ? a.contentId : void 0,
    "data-state": a.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, o, {
    ref: Hs(t, a.triggerRef),
    onPointerDown: ve(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
    }),
    onKeyDown: ve(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), TS = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Rt(t);
  return /* @__PURE__ */ F(dS, K({}, r, n));
}, OS = "DropdownMenuContent", NS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Tg(OS, n), a = Rt(n), i = de(!1);
  return /* @__PURE__ */ F(fS, K({
    id: o.contentId,
    "aria-labelledby": o.triggerId
  }, a, r, {
    ref: t,
    onCloseAutoFocus: ve(e.onCloseAutoFocus, (s) => {
      var l;
      i.current || (l = o.triggerRef.current) === null || l === void 0 || l.focus(), i.current = !1, s.preventDefault();
    }),
    onInteractOutside: ve(e.onInteractOutside, (s) => {
      const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, d = l.button === 2 || c;
      (!o.modal || d) && (i.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), kS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(pS, K({}, o, r, {
    ref: t
  }));
}), DS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(hS, K({}, o, r, {
    ref: t
  }));
}), FS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(mS, K({}, o, r, {
    ref: t
  }));
}), RS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(gS, K({}, o, r, {
    ref: t
  }));
}), _S = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(vS, K({}, o, r, {
    ref: t
  }));
}), IS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(yS, K({}, o, r, {
    ref: t
  }));
}), LS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(bS, K({}, o, r, {
    ref: t
  }));
}), BS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(xS, K({}, o, r, {
    ref: t
  }));
}), zS = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, i = Rt(t), [s = !1, l] = wt({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ F(wS, K({}, i, {
    open: s,
    onOpenChange: l
  }), n);
}, WS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(AS, K({}, o, r, {
    ref: t
  }));
}), jS = /* @__PURE__ */ Y((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Rt(n);
  return /* @__PURE__ */ F(CS, K({}, o, r, {
    ref: t,
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), VS = MS, HS = PS, Og = TS, Ng = NS, kg = kS, Dg = DS, Fg = FS, Rg = RS, _g = _S, Ig = IS, Lg = LS, Bg = BS, US = zS, zg = WS, Wg = jS, jg = VS, Vg = HS, YS = Og, GS = US, Hg = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(_g, { ref: n, className: le("w-full", e), ...t }));
Hg.displayName = _g.displayName;
const sl = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(kg, { ref: n, className: le("w-full", e), ...t }));
sl.displayName = kg.displayName;
const Ug = Y(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ I(
  zg,
  {
    ref: r,
    className: le(
      "flex cursor-default items-center select-none p-2 bg-white rounded justify-between text-zinc-800 text-sm font-normal leading-tight focus:outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "hover:bg-card-bg-focus hover:text-primary-focus hover:cursor-pointer",
      "data-[state=checked]:bg-card-bg-focus data-[state=checked]:text-primary-focus",
      "focus:bg-card-bg-focus ",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ u("span", { className: "flex", children: t }),
      /* @__PURE__ */ u(Fe, { IconSVG: hd, size: "small" })
    ]
  }
));
Ug.displayName = zg.displayName;
const Yg = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Wg,
  {
    ref: n,
    className: le(
      "rabbit-ds z-[1510] relative min-w-[8rem] max-w-xs p-1 bg-white rounded-lg !shadow flex flex-col justify-start items-start gap-1 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Yg.displayName = Wg.displayName;
const Hd = Y(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ u(Og, { children: /* @__PURE__ */ u("div", { className: "rabbit-ds ", children: /* @__PURE__ */ u(
  Ng,
  {
    ref: r,
    sideOffset: t,
    className: le(
      "z-[1500] relative min-w-[8rem] max-w-xs p-1 bg-white rounded-lg !shadow flex flex-col justify-start items-start gap-1 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }) }));
Hd.displayName = Ng.displayName;
const Ud = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Fg,
  {
    ref: n,
    className: le(
      "relative flex flex-row w-full cursor-default select-none p-2 bg-white rounded justify-start items-start text-zinc-800 text-sm font-normal leading-tight focus:outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "hover:bg-card-bg-focus hover:text-primary-focus hover:cursor-pointer",
      "data-[state=checked]:bg-card-bg-focus data-[state=checked]:text-primary-focus",
      "focus:bg-card-bg-focus ",
      e
    ),
    ...t
  }
));
Ud.displayName = Fg.displayName;
const Gg = Y(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ I(
  Rg,
  {
    ref: o,
    className: le(
      "relative w-full flex cursor-default hover:cursor-pointer select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "data-[state=checked]:bg-card-bg-focus data-[state=checked]:text-primary-focus",
      "focus:bg-card-bg-focus ",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ u("span", { className: "absolute right-2 flex h-4 w-4 items-center justify-center", children: /* @__PURE__ */ u(Lg, { children: /* @__PURE__ */ u(Fe, { IconSVG: Ys, size: "small" }) }) }),
      t
    ]
  }
));
Gg.displayName = Rg.displayName;
const Xg = Y(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ I(
  Ig,
  {
    ref: r,
    className: le(
      "relative flex cursor-default select-none items-center hover:cursor-pointer rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "data-[state=checked]:bg-card-bg-focus data-[state=checked]:text-primary-focus",
      "focus:bg-card-bg-focus ",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ u("span", { className: "absolute right-2 flex h-4 w-4 items-center justify-center", children: /* @__PURE__ */ u(Lg, { children: /* @__PURE__ */ u(Fe, { IconSVG: Ys, size: "small" }) }) }),
      t
    ]
  }
));
Xg.displayName = Ig.displayName;
const qg = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(Dg, { ref: n, className: le("px-2 py-1.5 text-sm font-semibold", e), ...t }));
qg.displayName = Dg.displayName;
const XS = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(Bg, { ref: n, className: le("h-px w-full bg-accent", e), ...t }));
XS.displayName = Bg.displayName;
const qS = Y(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ I(
    "button",
    {
      ref: r,
      className: le(
        "group px-2.5 py-1 rounded-full border border-transparent flex-row justify-center items-center gap-1 flex hover:cursor-pointer font-semibold font-sans text-sm",
        "data-[state=closed]:bg-gray-100",
        "data-[state=open]:border-[#004F67] data-[state=open]:bg-card-bg-focus data-[state=open]:text-[#004F67] border",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
        e
      ),
      "aria-label": "dropdown-trigger",
      ...n,
      type: "button",
      children: [
        t,
        /* @__PURE__ */ u(Fe, { IconSVG: Ia, size: "small", className: "transition-all group-data-[state=open]:rotate-180" })
      ]
    }
  )
);
qS.displayName = "DropdownChip";
const Kg = tn({}), KS = () => Xe(Kg);
function QS({ isActive: e, isDisabled: t, className: n, children: r, ...o }) {
  const a = Se(() => ({ isActive: e, isDisabled: t }), [e, t]);
  return /* @__PURE__ */ u(Kg.Provider, { value: a, children: /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ u(
    "button",
    {
      "data-deer-btn": !0,
      className: le(
        "flex items-center px-3 py-1 gap-2 text-font-primary w-full cursor-pointer rounded-lg",
        "hover:text-primary-hover",
        "is-active:bg-card-bg-focus is-active:text-primary-focus",
        "is-disabled:opacity-50 is-disabled:pointer-events-none",
        n
      ),
      type: "button",
      "data-active": e,
      "data-disabled": t,
      ...o,
      children: r
    }
  ) }) });
}
function WH({ title: e, subTitle: t }) {
  const { isActive: n } = KS();
  return /* @__PURE__ */ I("div", { className: "flex flex-col items-start", children: [
    /* @__PURE__ */ u("span", { className: "text-sm is-active:font-semibold", "data-active": n, children: e }),
    /* @__PURE__ */ u("span", { className: "text-xs", children: t })
  ] });
}
const ZS = nt("", {
  variants: {
    shape: {
      default: "",
      round: "overflow-hidden rounded-full"
    },
    iconSize: {
      normal: "h-6 w-6",
      large: "h-8 w-8"
    }
  },
  defaultVariants: {
    iconSize: "normal"
  }
});
function jH({ icon: e, iconSize: t, className: n, shape: r }) {
  return /* @__PURE__ */ u("div", { className: le(ZS({ iconSize: t, shape: r }), n), children: typeof e == "string" ? /* @__PURE__ */ u("img", { src: e, alt: "" }) : /* @__PURE__ */ u(Fe, { IconSVG: e }) });
}
const JS = nt("absolute bottom-0 mx-auto rounded-sm bg-warning-primary text-3xs leading-3 text-white", {
  variants: {
    size: {
      xs: "px-0.5 text-[6px]",
      sm: "px-0.5 text-[6px]",
      md: "px-0.5 text-[8px]",
      lg: "px-1 text-[10px]",
      xl: "px-1 text-[10px]",
      profile: "translate-y-1 px-1.5 py-0.5 text-xs outline outline-2 outline-white"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Yd = Y(
  ({
    badgeLabel: e,
    size: t,
    src: n,
    userName: r = "",
    showDashedOutline: o = !1,
    className: a,
    avatarImageClassName: i,
    showUpdateButton: s,
    onFileChange: l,
    ...c
  }, d) => {
    const f = de(null);
    return /* @__PURE__ */ I("div", { className: le("rabbit-ds relative flex justify-center", a), ref: d, ...c, children: [
      /* @__PURE__ */ I(
        Hn,
        {
          size: t,
          className: le(
            o ? "group relative outline-dashed outline-2 outline-offset-4 outline-[#FFC200]" : null
          ),
          children: [
            s ? /* @__PURE__ */ I(
              "div",
              {
                onClick: () => {
                  var p;
                  f && ((p = f.current) == null || p.click());
                },
                onKeyDown: (p) => {
                  var m;
                  p.key === "Enter" && f && ((m = f.current) == null || m.click());
                },
                role: "none",
                className: "absolute inset-x-0 bottom-0 flex cursor-pointer select-none items-center justify-center bg-black/50 pb-5 pt-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100",
                children: [
                  /* @__PURE__ */ u(
                    "input",
                    {
                      ref: f,
                      id: "fileInput",
                      onChange: l,
                      type: "file",
                      accept: "image/*",
                      className: "pointer-events-none absolute h-1 w-1 opacity-0"
                    }
                  ),
                  /* @__PURE__ */ u("span", { className: "text-sm text-white", children: "Update" })
                ]
              }
            ) : null,
            /* @__PURE__ */ u(Un, { className: i, src: n }),
            /* @__PURE__ */ u(Pd, { children: hw(r) })
          ]
        }
      ),
      e ? /* @__PURE__ */ u("div", { className: le("text-center", JS({ size: t })), children: e }) : null
    ] });
  }
);
Yd.defaultProps = {
  showDashedOutline: !1,
  className: "",
  size: "md",
  src: void 0,
  badgeLabel: void 0,
  avatarImageClassName: void 0,
  showUpdateButton: !0,
  onFileChange: () => {
  }
};
Yd.displayName = "AvatarBadge";
const Qg = /* @__PURE__ */ Y((e, t) => /* @__PURE__ */ F(Ee.span, K({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), Zg = Qg, eE = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], tE = [
  " ",
  "Enter"
], ll = "Select", [cl, Gd, nE] = Hr(ll), [Lo, VH] = gt(ll, [
  nE,
  _o
]), Xd = _o(), [rE, Yr] = Lo(ll), [oE, aE] = Lo(ll), iE = (e) => {
  const { __scopeSelect: t, children: n, open: r, defaultOpen: o, onOpenChange: a, value: i, defaultValue: s, onValueChange: l, dir: c, name: d, autoComplete: f, disabled: p, required: m } = e, h = Xd(t), [g, x] = we(null), [y, b] = we(null), [v, A] = we(!1), w = vr(c), [M = !1, $] = wt({
    prop: r,
    defaultProp: o,
    onChange: a
  }), [P, E] = wt({
    prop: i,
    defaultProp: s,
    onChange: l
  }), T = de(null), B = g ? !!g.closest("form") : !0, [j, V] = we(/* @__PURE__ */ new Set()), W = Array.from(j).map(
    (S) => S.props.value
  ).join(";");
  return /* @__PURE__ */ F(ol, h, /* @__PURE__ */ F(rE, {
    required: m,
    scope: t,
    trigger: g,
    onTriggerChange: x,
    valueNode: y,
    onValueNodeChange: b,
    valueNodeHasChildren: v,
    onValueNodeHasChildrenChange: A,
    contentId: xt(),
    value: P,
    onValueChange: E,
    open: M,
    onOpenChange: $,
    dir: w,
    triggerPointerDownPosRef: T,
    disabled: p
  }, /* @__PURE__ */ F(cl.Provider, {
    scope: t
  }, /* @__PURE__ */ F(oE, {
    scope: e.__scopeSelect,
    onNativeOptionAdd: me((S) => {
      V(
        (_) => new Set(_).add(S)
      );
    }, []),
    onNativeOptionRemove: me((S) => {
      V((_) => {
        const U = new Set(_);
        return U.delete(S), U;
      });
    }, [])
  }, n)), B ? /* @__PURE__ */ F(nv, {
    key: W,
    "aria-hidden": !0,
    required: m,
    tabIndex: -1,
    name: d,
    autoComplete: f,
    value: P,
    onChange: (S) => E(S.target.value),
    disabled: p
  }, P === void 0 ? /* @__PURE__ */ F("option", {
    value: ""
  }) : null, Array.from(j)) : null));
}, sE = "SelectTrigger", lE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, disabled: r = !1, ...o } = e, a = Xd(n), i = Yr(sE, n), s = i.disabled || r, l = De(t, i.onTriggerChange), c = Gd(n), [d, f, p] = rv((h) => {
    const g = c().filter(
      (b) => !b.disabled
    ), x = g.find(
      (b) => b.value === i.value
    ), y = ov(g, h, x);
    y !== void 0 && i.onValueChange(y.value);
  }), m = () => {
    s || (i.onOpenChange(!0), p());
  };
  return /* @__PURE__ */ F(Rd, K({
    asChild: !0
  }, a), /* @__PURE__ */ F(Ee.button, K({
    type: "button",
    role: "combobox",
    "aria-controls": i.contentId,
    "aria-expanded": i.open,
    "aria-required": i.required,
    "aria-autocomplete": "none",
    dir: i.dir,
    "data-state": i.open ? "open" : "closed",
    disabled: s,
    "data-disabled": s ? "" : void 0,
    "data-placeholder": tv(i.value) ? "" : void 0
  }, o, {
    ref: l,
    onClick: ve(o.onClick, (h) => {
      h.currentTarget.focus();
    }),
    onPointerDown: ve(o.onPointerDown, (h) => {
      const g = h.target;
      g.hasPointerCapture(h.pointerId) && g.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && (m(), i.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      }, h.preventDefault());
    }),
    onKeyDown: ve(o.onKeyDown, (h) => {
      const g = d.current !== "";
      !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && f(h.key), !(g && h.key === " ") && eE.includes(h.key) && (m(), h.preventDefault());
    })
  })));
}), cE = "SelectValue", uE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, className: r, style: o, children: a, placeholder: i = "", ...s } = e, l = Yr(cE, n), { onValueNodeHasChildrenChange: c } = l, d = a !== void 0, f = De(t, l.onValueNodeChange);
  return Mt(() => {
    c(d);
  }, [
    c,
    d
  ]), /* @__PURE__ */ F(Ee.span, K({}, s, {
    ref: f,
    style: {
      pointerEvents: "none"
    }
  }), tv(l.value) ? /* @__PURE__ */ F(ur, null, i) : a);
}), dE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, children: r, ...o } = e;
  return /* @__PURE__ */ F(Ee.span, K({
    "aria-hidden": !0
  }, o, {
    ref: t
  }), r || "▼");
}), fE = (e) => /* @__PURE__ */ F(el, K({
  asChild: !0
}, e)), xo = "SelectContent", pE = /* @__PURE__ */ Y((e, t) => {
  const n = Yr(xo, e.__scopeSelect), [r, o] = we();
  if (Mt(() => {
    o(new DocumentFragment());
  }, []), !n.open) {
    const a = r;
    return a ? /* @__PURE__ */ l2(/* @__PURE__ */ F(Jg, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ F(cl.Slot, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ F("div", null, e.children))), a) : null;
  }
  return /* @__PURE__ */ F(hE, K({}, e, {
    ref: t
  }));
}), Dn = 10, [Jg, ul] = Lo(xo), hE = /* @__PURE__ */ Y((e, t) => {
  const {
    __scopeSelect: n,
    position: r = "item-aligned",
    onCloseAutoFocus: o,
    onEscapeKeyDown: a,
    onPointerDownOutside: i,
    side: s,
    sideOffset: l,
    align: c,
    alignOffset: d,
    arrowPadding: f,
    collisionBoundary: p,
    collisionPadding: m,
    sticky: h,
    hideWhenDetached: g,
    avoidCollisions: x,
    //
    ...y
  } = e, b = Yr(xo, n), [v, A] = we(null), [w, M] = we(null), $ = De(
    t,
    (ee) => A(ee)
  ), [P, E] = we(null), [T, B] = we(null), j = Gd(n), [V, W] = we(!1), S = de(!1);
  Ce(() => {
    if (v)
      return Md(v);
  }, [
    v
  ]), Sd();
  const _ = me((ee) => {
    const [ie, ...X] = j().map(
      (D) => D.ref.current
    ), [J] = X.slice(-1), pe = document.activeElement;
    for (const D of ee)
      if (D === pe || (D == null || D.scrollIntoView({
        block: "nearest"
      }), D === ie && w && (w.scrollTop = 0), D === J && w && (w.scrollTop = w.scrollHeight), D == null || D.focus(), document.activeElement !== pe))
        return;
  }, [
    j,
    w
  ]), U = me(
    () => _([
      P,
      v
    ]),
    [
      _,
      P,
      v
    ]
  );
  Ce(() => {
    V && U();
  }, [
    V,
    U
  ]);
  const { onOpenChange: z, triggerPointerDownPosRef: N } = b;
  Ce(() => {
    if (v) {
      let ee = {
        x: 0,
        y: 0
      };
      const ie = (J) => {
        var pe, D, ce, he;
        ee = {
          x: Math.abs(Math.round(J.pageX) - ((pe = (D = N.current) === null || D === void 0 ? void 0 : D.x) !== null && pe !== void 0 ? pe : 0)),
          y: Math.abs(Math.round(J.pageY) - ((ce = (he = N.current) === null || he === void 0 ? void 0 : he.y) !== null && ce !== void 0 ? ce : 0))
        };
      }, X = (J) => {
        ee.x <= 10 && ee.y <= 10 ? J.preventDefault() : v.contains(J.target) || z(!1), document.removeEventListener("pointermove", ie), N.current = null;
      };
      return N.current !== null && (document.addEventListener("pointermove", ie), document.addEventListener("pointerup", X, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", ie), document.removeEventListener("pointerup", X, {
          capture: !0
        });
      };
    }
  }, [
    v,
    z,
    N
  ]), Ce(() => {
    const ee = () => z(!1);
    return window.addEventListener("blur", ee), window.addEventListener("resize", ee), () => {
      window.removeEventListener("blur", ee), window.removeEventListener("resize", ee);
    };
  }, [
    z
  ]);
  const [O, k] = rv((ee) => {
    const ie = j().filter(
      (pe) => !pe.disabled
    ), X = ie.find(
      (pe) => pe.ref.current === document.activeElement
    ), J = ov(ie, ee, X);
    J && setTimeout(
      () => J.ref.current.focus()
    );
  }), Q = me((ee, ie, X) => {
    const J = !S.current && !X;
    (b.value !== void 0 && b.value === ie || J) && (E(ee), J && (S.current = !0));
  }, [
    b.value
  ]), q = me(
    () => v == null ? void 0 : v.focus(),
    [
      v
    ]
  ), re = me((ee, ie, X) => {
    const J = !S.current && !X;
    (b.value !== void 0 && b.value === ie || J) && B(ee);
  }, [
    b.value
  ]), ae = r === "popper" ? T1 : mE, oe = ae === T1 ? {
    side: s,
    sideOffset: l,
    align: c,
    alignOffset: d,
    arrowPadding: f,
    collisionBoundary: p,
    collisionPadding: m,
    sticky: h,
    hideWhenDetached: g,
    avoidCollisions: x
  } : {};
  return /* @__PURE__ */ F(Jg, {
    scope: n,
    content: v,
    viewport: w,
    onViewportChange: M,
    itemRefCallback: Q,
    selectedItem: P,
    onItemLeave: q,
    itemTextRefCallback: re,
    focusSelectedItem: U,
    selectedItemText: T,
    position: r,
    isPositioned: V,
    searchRef: O
  }, /* @__PURE__ */ F(Ed, {
    as: $n,
    allowPinchZoom: !0
  }, /* @__PURE__ */ F(Cd, {
    asChild: !0,
    trapped: b.open,
    onMountAutoFocus: (ee) => {
      ee.preventDefault();
    },
    onUnmountAutoFocus: ve(o, (ee) => {
      var ie;
      (ie = b.trigger) === null || ie === void 0 || ie.focus({
        preventScroll: !0
      }), ee.preventDefault();
    })
  }, /* @__PURE__ */ F(za, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: a,
    onPointerDownOutside: i,
    onFocusOutside: (ee) => ee.preventDefault(),
    onDismiss: () => b.onOpenChange(!1)
  }, /* @__PURE__ */ F(ae, K({
    role: "listbox",
    id: b.contentId,
    "data-state": b.open ? "open" : "closed",
    dir: b.dir,
    onContextMenu: (ee) => ee.preventDefault()
  }, y, oe, {
    onPlaced: () => W(!0),
    ref: $,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...y.style
    },
    onKeyDown: ve(y.onKeyDown, (ee) => {
      const ie = ee.ctrlKey || ee.altKey || ee.metaKey;
      if (ee.key === "Tab" && ee.preventDefault(), !ie && ee.key.length === 1 && k(ee.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(ee.key)) {
        let J = j().filter(
          (pe) => !pe.disabled
        ).map(
          (pe) => pe.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(ee.key) && (J = J.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(ee.key)) {
          const pe = ee.target, D = J.indexOf(pe);
          J = J.slice(D + 1);
        }
        setTimeout(
          () => _(J)
        ), ee.preventDefault();
      }
    })
  }))))));
}), mE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, a = Yr(xo, n), i = ul(xo, n), [s, l] = we(null), [c, d] = we(null), f = De(
    t,
    ($) => d($)
  ), p = Gd(n), m = de(!1), h = de(!0), { viewport: g, selectedItem: x, selectedItemText: y, focusSelectedItem: b } = i, v = me(() => {
    if (a.trigger && a.valueNode && s && c && g && x && y) {
      const $ = a.trigger.getBoundingClientRect(), P = c.getBoundingClientRect(), E = a.valueNode.getBoundingClientRect(), T = y.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const pe = T.left - P.left, D = E.left - pe, ce = $.left - D, he = $.width + ce, ye = Math.max(he, P.width), Me = window.innerWidth - Dn, Oe = is(D, [
          Dn,
          Me - ye
        ]);
        s.style.minWidth = he + "px", s.style.left = Oe + "px";
      } else {
        const pe = P.right - T.right, D = window.innerWidth - E.right - pe, ce = window.innerWidth - $.right - D, he = $.width + ce, ye = Math.max(he, P.width), Me = window.innerWidth - Dn, Oe = is(D, [
          Dn,
          Me - ye
        ]);
        s.style.minWidth = he + "px", s.style.right = Oe + "px";
      }
      const B = p(), j = window.innerHeight - Dn * 2, V = g.scrollHeight, W = window.getComputedStyle(c), S = parseInt(W.borderTopWidth, 10), _ = parseInt(W.paddingTop, 10), U = parseInt(W.borderBottomWidth, 10), z = parseInt(W.paddingBottom, 10), N = S + _ + V + z + U, O = Math.min(x.offsetHeight * 5, N), k = window.getComputedStyle(g), Q = parseInt(k.paddingTop, 10), q = parseInt(k.paddingBottom, 10), re = $.top + $.height / 2 - Dn, ae = j - re, oe = x.offsetHeight / 2, ee = x.offsetTop + oe, ie = S + _ + ee, X = N - ie;
      if (ie <= re) {
        const pe = x === B[B.length - 1].ref.current;
        s.style.bottom = "0px";
        const D = c.clientHeight - g.offsetTop - g.offsetHeight, ce = Math.max(ae, oe + (pe ? q : 0) + D + U), he = ie + ce;
        s.style.height = he + "px";
      } else {
        const pe = x === B[0].ref.current;
        s.style.top = "0px";
        const ce = Math.max(re, S + g.offsetTop + (pe ? Q : 0) + oe) + X;
        s.style.height = ce + "px", g.scrollTop = ie - re + g.offsetTop;
      }
      s.style.margin = `${Dn}px 0`, s.style.minHeight = O + "px", s.style.maxHeight = j + "px", r == null || r(), requestAnimationFrame(
        () => m.current = !0
      );
    }
  }, [
    p,
    a.trigger,
    a.valueNode,
    s,
    c,
    g,
    x,
    y,
    a.dir,
    r
  ]);
  Mt(
    () => v(),
    [
      v
    ]
  );
  const [A, w] = we();
  Mt(() => {
    c && w(window.getComputedStyle(c).zIndex);
  }, [
    c
  ]);
  const M = me(($) => {
    $ && h.current === !0 && (v(), b == null || b(), h.current = !1);
  }, [
    v,
    b
  ]);
  return /* @__PURE__ */ F(gE, {
    scope: n,
    contentWrapper: s,
    shouldExpandOnScrollRef: m,
    onScrollButtonChange: M
  }, /* @__PURE__ */ F("div", {
    ref: l,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: A
    }
  }, /* @__PURE__ */ F(Ee.div, K({}, o, {
    ref: f,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...o.style
    }
  }))));
}), T1 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, align: r = "start", collisionPadding: o = Dn, ...a } = e, i = Xd(n);
  return /* @__PURE__ */ F(_d, K({}, i, a, {
    ref: t,
    align: r,
    collisionPadding: o,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...a.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [gE, vE] = Lo(xo, {}), O1 = "SelectViewport", yE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, ...r } = e, o = ul(O1, n), a = vE(O1, n), i = De(t, o.onViewportChange), s = de(0);
  return /* @__PURE__ */ F(ur, null, /* @__PURE__ */ F("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ F(cl.Slot, {
    scope: n
  }, /* @__PURE__ */ F(Ee.div, K({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, r, {
    ref: i,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...r.style
    },
    onScroll: ve(r.onScroll, (l) => {
      const c = l.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = a;
      if (f != null && f.current && d) {
        const p = Math.abs(s.current - c.scrollTop);
        if (p > 0) {
          const m = window.innerHeight - Dn * 2, h = parseFloat(d.style.minHeight), g = parseFloat(d.style.height), x = Math.max(h, g);
          if (x < m) {
            const y = x + p, b = Math.min(m, y), v = y - b;
            d.style.height = b + "px", d.style.bottom === "0px" && (c.scrollTop = v > 0 ? v : 0, d.style.justifyContent = "flex-end");
          }
        }
      }
      s.current = c.scrollTop;
    })
  }))));
}), bE = "SelectGroup", [xE, wE] = Lo(bE), AE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, ...r } = e, o = xt();
  return /* @__PURE__ */ F(xE, {
    scope: n,
    id: o
  }, /* @__PURE__ */ F(Ee.div, K({
    role: "group",
    "aria-labelledby": o
  }, r, {
    ref: t
  })));
}), CE = "SelectLabel", SE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, ...r } = e, o = wE(CE, n);
  return /* @__PURE__ */ F(Ee.div, K({
    id: o.id
  }, r, {
    ref: t
  }));
}), qc = "SelectItem", [EE, ev] = Lo(qc), ME = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, value: r, disabled: o = !1, textValue: a, ...i } = e, s = Yr(qc, n), l = ul(qc, n), c = s.value === r, [d, f] = we(a ?? ""), [p, m] = we(!1), h = De(t, (y) => {
    var b;
    return (b = l.itemRefCallback) === null || b === void 0 ? void 0 : b.call(l, y, r, o);
  }), g = xt(), x = () => {
    o || (s.onValueChange(r), s.onOpenChange(!1));
  };
  if (r === "")
    throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  return /* @__PURE__ */ F(EE, {
    scope: n,
    value: r,
    disabled: o,
    textId: g,
    isSelected: c,
    onItemTextChange: me((y) => {
      f((b) => {
        var v;
        return b || ((v = y == null ? void 0 : y.textContent) !== null && v !== void 0 ? v : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ F(cl.ItemSlot, {
    scope: n,
    value: r,
    disabled: o,
    textValue: d
  }, /* @__PURE__ */ F(Ee.div, K({
    role: "option",
    "aria-labelledby": g,
    "data-highlighted": p ? "" : void 0,
    "aria-selected": c && p,
    "data-state": c ? "checked" : "unchecked",
    "aria-disabled": o || void 0,
    "data-disabled": o ? "" : void 0,
    tabIndex: o ? void 0 : -1
  }, i, {
    ref: h,
    onFocus: ve(
      i.onFocus,
      () => m(!0)
    ),
    onBlur: ve(
      i.onBlur,
      () => m(!1)
    ),
    onPointerUp: ve(i.onPointerUp, x),
    onPointerMove: ve(i.onPointerMove, (y) => {
      if (o) {
        var b;
        (b = l.onItemLeave) === null || b === void 0 || b.call(l);
      } else
        y.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: ve(i.onPointerLeave, (y) => {
      if (y.currentTarget === document.activeElement) {
        var b;
        (b = l.onItemLeave) === null || b === void 0 || b.call(l);
      }
    }),
    onKeyDown: ve(i.onKeyDown, (y) => {
      var b;
      ((b = l.searchRef) === null || b === void 0 ? void 0 : b.current) !== "" && y.key === " " || (tE.includes(y.key) && x(), y.key === " " && y.preventDefault());
    })
  }))));
}), Pi = "SelectItemText", $E = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, className: r, style: o, ...a } = e, i = Yr(Pi, n), s = ul(Pi, n), l = ev(Pi, n), c = aE(Pi, n), [d, f] = we(null), p = De(
    t,
    (y) => f(y),
    l.onItemTextChange,
    (y) => {
      var b;
      return (b = s.itemTextRefCallback) === null || b === void 0 ? void 0 : b.call(s, y, l.value, l.disabled);
    }
  ), m = d == null ? void 0 : d.textContent, h = Se(
    () => /* @__PURE__ */ F("option", {
      key: l.value,
      value: l.value,
      disabled: l.disabled
    }, m),
    [
      l.disabled,
      l.value,
      m
    ]
  ), { onNativeOptionAdd: g, onNativeOptionRemove: x } = c;
  return Mt(() => (g(h), () => x(h)), [
    g,
    x,
    h
  ]), /* @__PURE__ */ F(ur, null, /* @__PURE__ */ F(Ee.span, K({
    id: l.textId
  }, a, {
    ref: p
  })), l.isSelected && i.valueNode && !i.valueNodeHasChildren ? /* @__PURE__ */ l2(a.children, i.valueNode) : null);
}), PE = "SelectItemIndicator", TE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, ...r } = e;
  return ev(PE, n).isSelected ? /* @__PURE__ */ F(Ee.span, K({
    "aria-hidden": !0
  }, r, {
    ref: t
  })) : null;
}), OE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeSelect: n, ...r } = e;
  return /* @__PURE__ */ F(Ee.div, K({
    "aria-hidden": !0
  }, r, {
    ref: t
  }));
});
function tv(e) {
  return e === "" || e === void 0;
}
const nv = /* @__PURE__ */ Y((e, t) => {
  const { value: n, ...r } = e, o = de(null), a = De(t, o), i = Us(n);
  return Ce(() => {
    const s = o.current, l = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(l, "value").set;
    if (i !== n && d) {
      const f = new Event("change", {
        bubbles: !0
      });
      d.call(s, n), s.dispatchEvent(f);
    }
  }, [
    i,
    n
  ]), /* @__PURE__ */ F(Qg, {
    asChild: !0
  }, /* @__PURE__ */ F("select", K({}, r, {
    ref: a,
    defaultValue: n
  })));
});
nv.displayName = "BubbleSelect";
function rv(e) {
  const t = lt(e), n = de(""), r = de(0), o = me((i) => {
    const s = n.current + i;
    t(s), function l(c) {
      n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(
        () => l(""),
        1e3
      ));
    }(s);
  }, [
    t
  ]), a = me(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return Ce(() => () => window.clearTimeout(r.current), []), [
    n,
    o,
    a
  ];
}
function ov(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (c) => c === t[0]
  ) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = NE(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter(
    (c) => c !== n
  ));
  const l = i.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function NE(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const kE = iE, av = lE, DE = uE, FE = dE, RE = fE, iv = pE, _E = yE, IE = AE, sv = SE, lv = ME, LE = $E, BE = TE, cv = OE, HH = kE, UH = IE, YH = DE, zE = Y(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ I(
  av,
  {
    ref: r,
    className: le(
      "rabbit-ds h-10 py-2.5 rounded-tl bg-transparent text-sm rounded-tr border-b border-dashed hover:border-solid border-zinc-800 justify-between items-center gap-2 inline-flex focus:outline-none focus:border-solid disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ u(FE, { asChild: !0, children: /* @__PURE__ */ u(Fe, { IconSVG: Ia }) })
    ]
  }
) }));
zE.displayName = av.displayName;
const WE = Y(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ u(RE, { children: /* @__PURE__ */ u(
  iv,
  {
    ref: o,
    className: le(
      "relative z-[1500] rabbit-ds min-w-[8rem] max-w-xs p-1 bg-white rounded-lg !shadow flex-col justify-start items-start gap-1 inline-flex data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: /* @__PURE__ */ u(
      _E,
      {
        className: le(
          "p-1",
          n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: t
      }
    )
  }
) }));
WE.displayName = iv.displayName;
const jE = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(sv, { ref: n, className: le("py-1.5 px-2 text-sm font-semibold", e), ...t }));
jE.displayName = sv.displayName;
const VE = Y(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ I(
  lv,
  {
    ref: r,
    className: le(
      "relative flex w-full my-1 cursor-default select-none p-2 bg-white rounded flex-col hover:bg-sky-100 hover:text-sky-800 hover:cursor-pointer justify-start items-start text-zinc-800 text-sm font-normal leading-tight focus:bg-sky-100 focus:text-sky-800 data-[state=checked]:bg-sky-100 data-[state=checked]:text-sky-800 focus:outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ u("span", { className: "absolute right-2 flex h-4 w-4 items-center justify-center", children: /* @__PURE__ */ u(BE, { children: /* @__PURE__ */ u(Fe, { IconSVG: Ys, className: "text-sky-800" }) }) }),
      /* @__PURE__ */ u(LE, { children: t })
    ]
  }
));
VE.displayName = lv.displayName;
const HE = Y(({ className: e, ...t }, n) => /* @__PURE__ */ u(cv, { ref: n, className: le("-mx-1 my-1 h-px bg-muted", e), ...t }));
HE.displayName = cv.displayName;
const uv = "Tabs", [UE, GH] = gt(uv, [
  Io
]), dv = Io(), [YE, qd] = UE(uv), GE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeTabs: n, value: r, onValueChange: o, defaultValue: a, orientation: i = "horizontal", dir: s, activationMode: l = "automatic", ...c } = e, d = vr(s), [f, p] = wt({
    prop: r,
    onChange: o,
    defaultProp: a
  });
  return /* @__PURE__ */ F(YE, {
    scope: n,
    baseId: xt(),
    value: f,
    onValueChange: p,
    orientation: i,
    dir: d,
    activationMode: l
  }, /* @__PURE__ */ F(Ee.div, K({
    dir: d,
    "data-orientation": i
  }, c, {
    ref: t
  })));
}), XE = "TabsList", qE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeTabs: n, loop: r = !0, ...o } = e, a = qd(XE, n), i = dv(n);
  return /* @__PURE__ */ F(Ld, K({
    asChild: !0
  }, i, {
    orientation: a.orientation,
    dir: a.dir,
    loop: r
  }), /* @__PURE__ */ F(Ee.div, K({
    role: "tablist",
    "aria-orientation": a.orientation
  }, o, {
    ref: t
  })));
}), KE = "TabsTrigger", QE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeTabs: n, value: r, disabled: o = !1, ...a } = e, i = qd(KE, n), s = dv(n), l = fv(i.baseId, r), c = pv(i.baseId, r), d = r === i.value;
  return /* @__PURE__ */ F(Bd, K({
    asChild: !0
  }, s, {
    focusable: !o,
    active: d
  }), /* @__PURE__ */ F(Ee.button, K({
    type: "button",
    role: "tab",
    "aria-selected": d,
    "aria-controls": c,
    "data-state": d ? "active" : "inactive",
    "data-disabled": o ? "" : void 0,
    disabled: o,
    id: l
  }, a, {
    ref: t,
    onMouseDown: ve(e.onMouseDown, (f) => {
      !o && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(r) : f.preventDefault();
    }),
    onKeyDown: ve(e.onKeyDown, (f) => {
      [
        " ",
        "Enter"
      ].includes(f.key) && i.onValueChange(r);
    }),
    onFocus: ve(e.onFocus, () => {
      const f = i.activationMode !== "manual";
      !d && !o && f && i.onValueChange(r);
    })
  })));
}), ZE = "TabsContent", JE = /* @__PURE__ */ Y((e, t) => {
  const { __scopeTabs: n, value: r, forceMount: o, children: a, ...i } = e, s = qd(ZE, n), l = fv(s.baseId, r), c = pv(s.baseId, r), d = r === s.value, f = de(d);
  return Ce(() => {
    const p = requestAnimationFrame(
      () => f.current = !1
    );
    return () => cancelAnimationFrame(p);
  }, []), /* @__PURE__ */ F(
    Bt,
    {
      present: o || d
    },
    ({ present: p }) => /* @__PURE__ */ F(Ee.div, K({
      "data-state": d ? "active" : "inactive",
      "data-orientation": s.orientation,
      role: "tabpanel",
      "aria-labelledby": l,
      hidden: !p,
      id: c,
      tabIndex: 0
    }, i, {
      ref: t,
      style: {
        ...e.style,
        animationDuration: f.current ? "0s" : void 0
      }
    }), p && a)
  );
});
function fv(e, t) {
  return `${e}-trigger-${t}`;
}
function pv(e, t) {
  return `${e}-content-${t}`;
}
const hv = GE, mv = qE, gv = QE, vv = JE, yv = tn("primary"), Kd = () => Xe(yv);
function eM({ children: e, variant: t }) {
  return /* @__PURE__ */ u(yv.Provider, { value: t, children: e });
}
const tM = nt("", {
  variants: {
    variant: {
      primary: "",
      secondary: "rounded-lg bg-[#EBEFF3] p-2"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), nM = Y(({ children: e, variant: t, ...n }, r) => /* @__PURE__ */ u(eM, { variant: t, children: /* @__PURE__ */ u(hv, { ref: r, ...n, className: le("rabbit-ds", tM({ variant: t }), n.className), children: e }) })), rM = nt("", {
  variants: {
    variant: {
      primary: "flex gap-2",
      secondary: "mx-6 flex gap-5"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), oM = Y(
  ({ children: e, ...t }, n) => {
    const r = Kd();
    return /* @__PURE__ */ u(mv, { ref: n, ...t, className: le("rabbit-ds", rM({ variant: r }), t.className), children: e });
  }
), aM = nt("", {
  variants: {
    variant: {
      primary: le(
        "text-font-secondary bg-transparent px-4 py-2 text-sm font-semibold",
        "data-[state=inactive]:text-font-secondary data-[state=inactive]:border-b-2 data-[state=inactive]:border-transparent",
        "data-[state=active]:text-primary-focus data-[state=active]:border-primary-focus data-[state=active]:border-b-2"
      ),
      secondary: le(
        "text-font-primary flex bg-[#EBEFF3] px-4 py-2 text-sm font-semibold",
        "data-[state=active]:text-primary-focus data-[state=active]:rounded-t-lg data-[state=active]:bg-white data-[state=active]:shadow-[0px_-1px_2px_0px_rgba(0,0,0,0.08)]",
        "hover:rounded-t-lg hover:bg-white"
      )
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), iM = Y(({ children: e, ...t }, n) => {
  const r = Kd();
  return /* @__PURE__ */ u(
    gv,
    {
      ref: n,
      className: le("rabbit-ds", aM({ variant: r }), t.className),
      ...t,
      children: e
    }
  );
}), sM = nt("", {
  variants: {
    variant: {
      primary: "",
      secondary: "rounded-lg border-t-2 border-t-white bg-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.04)]"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), lM = Y(({ children: e, ...t }, n) => {
  const r = Kd();
  return /* @__PURE__ */ u(
    vv,
    {
      ref: n,
      ...t,
      className: le("rabbit-ds", sM({ variant: r }), t.className),
      children: e
    }
  );
});
nM.displayName = hv.displayName;
oM.displayName = mv.displayName;
iM.displayName = gv.displayName;
lM.displayName = vv.displayName;
const cM = nt("flex items-center justify-center rounded px-2 py-1", {
  variants: {
    variant: {
      default: "text-xs font-semibold",
      outlined: "bg-[#F2F2F2] text-sm text-font-primary shadow-[0px_0px_1px_0px_rgba(0,0,0,0.25)]"
    }
  }
});
function uM({ children: e, colorScheme: t = "tag-yellow", variant: n = "default", className: r }) {
  return /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ u("div", { className: le(n === "outlined" ? "" : t, cM({ variant: n }), r), children: e }) });
}
const [dl, XH] = gt("Tooltip", [
  _o
]), Qd = _o(), dM = "TooltipProvider", fM = 700, Kc = "tooltip.open", [pM, Zd] = dl(dM), hM = (e) => {
  const { __scopeTooltip: t, delayDuration: n = fM, skipDelayDuration: r = 300, disableHoverableContent: o = !1, children: a } = e, [i, s] = we(!0), l = de(!1), c = de(0);
  return Ce(() => {
    const d = c.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ F(pM, {
    scope: t,
    isOpenDelayed: i,
    delayDuration: n,
    onOpen: me(() => {
      window.clearTimeout(c.current), s(!1);
    }, []),
    onClose: me(() => {
      window.clearTimeout(c.current), c.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: l,
    onPointerInTransitChange: me((d) => {
      l.current = d;
    }, []),
    disableHoverableContent: o
  }, a);
}, Jd = "Tooltip", [mM, Ha] = dl(Jd), gM = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: o = !1, onOpenChange: a, disableHoverableContent: i, delayDuration: s } = e, l = Zd(Jd, e.__scopeTooltip), c = Qd(t), [d, f] = we(null), p = xt(), m = de(0), h = i ?? l.disableHoverableContent, g = s ?? l.delayDuration, x = de(!1), [y = !1, b] = wt({
    prop: r,
    defaultProp: o,
    onChange: ($) => {
      $ ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Kc))) : l.onClose(), a == null || a($);
    }
  }), v = Se(() => y ? x.current ? "delayed-open" : "instant-open" : "closed", [
    y
  ]), A = me(() => {
    window.clearTimeout(m.current), x.current = !1, b(!0);
  }, [
    b
  ]), w = me(() => {
    window.clearTimeout(m.current), b(!1);
  }, [
    b
  ]), M = me(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      x.current = !0, b(!0);
    }, g);
  }, [
    g,
    b
  ]);
  return Ce(() => () => window.clearTimeout(m.current), []), /* @__PURE__ */ F(ol, c, /* @__PURE__ */ F(mM, {
    scope: t,
    contentId: p,
    open: y,
    stateAttribute: v,
    trigger: d,
    onTriggerChange: f,
    onTriggerEnter: me(() => {
      l.isOpenDelayed ? M() : A();
    }, [
      l.isOpenDelayed,
      M,
      A
    ]),
    onTriggerLeave: me(() => {
      h ? w() : window.clearTimeout(m.current);
    }, [
      w,
      h
    ]),
    onOpen: A,
    onClose: w,
    disableHoverableContent: h
  }, n));
}, N1 = "TooltipTrigger", vM = /* @__PURE__ */ Y((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = Ha(N1, n), a = Zd(N1, n), i = Qd(n), s = de(null), l = De(t, s, o.onTriggerChange), c = de(!1), d = de(!1), f = me(
    () => c.current = !1,
    []
  );
  return Ce(() => () => document.removeEventListener("pointerup", f), [
    f
  ]), /* @__PURE__ */ F(Rd, K({
    asChild: !0
  }, i), /* @__PURE__ */ F(Ee.button, K({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: l,
    onPointerMove: ve(e.onPointerMove, (p) => {
      p.pointerType !== "touch" && !d.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
    }),
    onPointerLeave: ve(e.onPointerLeave, () => {
      o.onTriggerLeave(), d.current = !1;
    }),
    onPointerDown: ve(e.onPointerDown, () => {
      c.current = !0, document.addEventListener("pointerup", f, {
        once: !0
      });
    }),
    onFocus: ve(e.onFocus, () => {
      c.current || o.onOpen();
    }),
    onBlur: ve(e.onBlur, o.onClose),
    onClick: ve(e.onClick, o.onClose)
  })));
}), bv = "TooltipPortal", [yM, bM] = dl(bv, {
  forceMount: void 0
}), xM = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, a = Ha(bv, t);
  return /* @__PURE__ */ F(yM, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ F(Bt, {
    present: n || a.open
  }, /* @__PURE__ */ F(el, {
    asChild: !0,
    container: o
  }, r)));
}, Sa = "TooltipContent", wM = /* @__PURE__ */ Y((e, t) => {
  const n = bM(Sa, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, i = Ha(Sa, e.__scopeTooltip);
  return /* @__PURE__ */ F(Bt, {
    present: r || i.open
  }, i.disableHoverableContent ? /* @__PURE__ */ F(xv, K({
    side: o
  }, a, {
    ref: t
  })) : /* @__PURE__ */ F(AM, K({
    side: o
  }, a, {
    ref: t
  })));
}), AM = /* @__PURE__ */ Y((e, t) => {
  const n = Ha(Sa, e.__scopeTooltip), r = Zd(Sa, e.__scopeTooltip), o = de(null), a = De(t, o), [i, s] = we(null), { trigger: l, onClose: c } = n, d = o.current, { onPointerInTransitChange: f } = r, p = me(() => {
    s(null), f(!1);
  }, [
    f
  ]), m = me((h, g) => {
    const x = h.currentTarget, y = {
      x: h.clientX,
      y: h.clientY
    }, b = SM(y, x.getBoundingClientRect()), v = EM(y, b), A = MM(g.getBoundingClientRect()), w = PM([
      ...v,
      ...A
    ]);
    s(w), f(!0);
  }, [
    f
  ]);
  return Ce(() => () => p(), [
    p
  ]), Ce(() => {
    if (l && d) {
      const h = (x) => m(x, d), g = (x) => m(x, l);
      return l.addEventListener("pointerleave", h), d.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", h), d.removeEventListener("pointerleave", g);
      };
    }
  }, [
    l,
    d,
    m,
    p
  ]), Ce(() => {
    if (i) {
      const h = (g) => {
        const x = g.target, y = {
          x: g.clientX,
          y: g.clientY
        }, b = (l == null ? void 0 : l.contains(x)) || (d == null ? void 0 : d.contains(x)), v = !$M(y, i);
        b ? p() : v && (p(), c());
      };
      return document.addEventListener("pointermove", h), () => document.removeEventListener("pointermove", h);
    }
  }, [
    l,
    d,
    i,
    c,
    p
  ]), /* @__PURE__ */ F(xv, K({}, e, {
    ref: a
  }));
}), [CM, qH] = dl(Jd, {
  isInside: !1
}), xv = /* @__PURE__ */ Y((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": o, onEscapeKeyDown: a, onPointerDownOutside: i, ...s } = e, l = Ha(Sa, n), c = Qd(n), { onClose: d } = l;
  return Ce(() => (document.addEventListener(Kc, d), () => document.removeEventListener(Kc, d)), [
    d
  ]), Ce(() => {
    if (l.trigger) {
      const f = (p) => {
        const m = p.target;
        m != null && m.contains(l.trigger) && d();
      };
      return window.addEventListener("scroll", f, {
        capture: !0
      }), () => window.removeEventListener("scroll", f, {
        capture: !0
      });
    }
  }, [
    l.trigger,
    d
  ]), /* @__PURE__ */ F(za, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: a,
    onPointerDownOutside: i,
    onFocusOutside: (f) => f.preventDefault(),
    onDismiss: d
  }, /* @__PURE__ */ F(_d, K({
    "data-state": l.stateAttribute
  }, c, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ F(fd, null, r), /* @__PURE__ */ F(CM, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ F(Zg, {
    id: l.contentId,
    role: "tooltip"
  }, o || r))));
});
function SM(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function EM(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function MM(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    {
      x: o,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: o,
      y: r
    }
  ];
}
function $M(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, l = t[a].y, c = t[i].x, d = t[i].y;
    l > r != d > r && n < (c - s) * (r - l) / (d - l) + s && (o = !o);
  }
  return o;
}
function PM(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), TM(t);
}
function TM(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const OM = hM, NM = gM, kM = vM, DM = xM, wv = wM, Av = OM, Cv = NM, Sv = kM, Ev = DM, ef = Y(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ u(
  wv,
  {
    ref: r,
    sideOffset: t,
    className: le(
      "z-[1500] overflow-hidden p-2 bg-gray-600 max-w-xs rounded transition-opacity justify-start items-start inline-flex text-center text-white text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e,
      "rabbit-ds"
    ),
    ...n
  }
));
ef.displayName = wv.displayName;
function FM(e, { insertAt: t } = {}) {
  if (!e || typeof document > "u")
    return;
  let n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
FM(`html[dir=ltr],[data-sonner-toaster][dir=ltr]{--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}html[dir=rtl],[data-sonner-toaster][dir=rtl]{--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999}[data-sonner-toaster][data-x-position=right]{right:max(var(--offset),env(safe-area-inset-right))}[data-sonner-toaster][data-x-position=left]{left:max(var(--offset),env(safe-area-inset-left))}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translate(-50%)}[data-sonner-toaster][data-y-position=top]{top:max(var(--offset),env(safe-area-inset-top))}[data-sonner-toaster][data-y-position=bottom]{bottom:max(var(--offset),env(safe-area-inset-bottom))}[data-sonner-toast]{--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}[data-sonner-toast][data-y-position=top]{top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}[data-sonner-toast] [data-description]{font-weight:400;line-height:1.4;color:inherit}[data-sonner-toast] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast] [data-icon]>*{flex-shrink:0}[data-sonner-toast] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast] [data-button]:focus-visible{box-shadow:0 0 0 2px #0006}[data-sonner-toast] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toast][data-theme=dark] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;background:var(--gray1);color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]:focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}[data-sonner-toast] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]:before{content:"";position:absolute;left:0;right:0;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]:before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]:before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]:before{content:"";position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast]:after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y: translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y: translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]:before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount, 0px));transition:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation:swipe-out .2s ease-out forwards}@keyframes swipe-out{0%{transform:translateY(calc(var(--lift) * var(--offset) + var(--swipe-amount)));opacity:1}to{transform:translateY(calc(var(--lift) * var(--offset) + var(--swipe-amount) + var(--lift) * -100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;--mobile-offset: 16px;right:var(--mobile-offset);left:var(--mobile-offset);width:100%}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - 32px)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset)}[data-sonner-toaster][data-y-position=bottom]{bottom:20px}[data-sonner-toaster][data-y-position=top]{top:20px}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset);right:var(--mobile-offset);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-rich-colors=true] [data-sonner-toast][data-type=success],[data-rich-colors=true] [data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true] [data-sonner-toast][data-type=info],[data-rich-colors=true] [data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true] [data-sonner-toast][data-type=warning],[data-rich-colors=true] [data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true] [data-sonner-toast][data-type=error],[data-rich-colors=true] [data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
var RM = (e) => {
  switch (e) {
    case "success":
      return LM;
    case "info":
      return zM;
    case "warning":
      return BM;
    case "error":
      return WM;
    default:
      return null;
  }
}, _M = Array(12).fill(0), IM = ({ visible: e }) => R.createElement("div", { className: "sonner-loading-wrapper", "data-visible": e }, R.createElement("div", { className: "sonner-spinner" }, _M.map((t, n) => R.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${n}` })))), LM = R.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, R.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), BM = R.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, R.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), zM = R.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, R.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), WM = R.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, R.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), jM = () => {
  let [e, t] = R.useState(!1);
  return R.useEffect(() => {
    let n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
}, Qc = 1, VM = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var t;
      let { message: n, ...r } = e, o = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : Qc++, a = this.toasts.find((s) => s.id === o), i = e.dismissible === void 0 ? !0 : e.dismissible;
      return a ? this.toasts = this.toasts.map((s) => s.id === o ? (this.publish({ ...s, ...e, id: o, title: n }), { ...s, ...e, id: o, dismissible: i, title: n }) : s) : this.addToast({ title: n, ...r, dismissible: i, id: o }), o;
    }, this.dismiss = (e) => (e || this.toasts.forEach((t) => {
      this.subscribers.forEach((n) => n({ id: t.id, dismiss: !0 }));
    }), this.subscribers.forEach((t) => t({ id: e, dismiss: !0 })), e), this.message = (e, t) => this.create({ ...t, message: e }), this.error = (e, t) => this.create({ ...t, message: e, type: "error" }), this.success = (e, t) => this.create({ ...t, type: "success", message: e }), this.info = (e, t) => this.create({ ...t, type: "info", message: e }), this.warning = (e, t) => this.create({ ...t, type: "warning", message: e }), this.loading = (e, t) => this.create({ ...t, type: "loading", message: e }), this.promise = (e, t) => {
      if (!t)
        return;
      let n;
      t.loading !== void 0 && (n = this.create({ ...t, promise: e, type: "loading", message: t.loading, description: typeof t.description != "function" ? t.description : void 0 }));
      let r = e instanceof Promise ? e : e(), o = n !== void 0;
      return r.then((a) => {
        if (a && typeof a.ok == "boolean" && !a.ok) {
          o = !1;
          let i = typeof t.error == "function" ? t.error(`HTTP error! status: ${a.status}`) : t.error, s = typeof t.description == "function" ? t.description(`HTTP error! status: ${a.status}`) : t.description;
          this.create({ id: n, type: "error", message: i, description: s });
        } else if (t.success !== void 0) {
          o = !1;
          let i = typeof t.success == "function" ? t.success(a) : t.success, s = typeof t.description == "function" ? t.description(a) : t.description;
          this.create({ id: n, type: "success", message: i, description: s });
        }
      }).catch((a) => {
        if (t.error !== void 0) {
          o = !1;
          let i = typeof t.error == "function" ? t.error(a) : t.error, s = typeof t.description == "function" ? t.description(a) : t.description;
          this.create({ id: n, type: "error", message: i, description: s });
        }
      }).finally(() => {
        var a;
        o && (this.dismiss(n), n = void 0), (a = t.finally) == null || a.call(t);
      }), n;
    }, this.custom = (e, t) => {
      let n = (t == null ? void 0 : t.id) || Qc++;
      return this.create({ jsx: e(n), id: n, ...t }), n;
    }, this.subscribers = [], this.toasts = [];
  }
}, cn = new VM(), HM = (e, t) => {
  let n = (t == null ? void 0 : t.id) || Qc++;
  return cn.addToast({ title: e, ...t, id: n }), n;
}, UM = HM, KH = Object.assign(UM, { success: cn.success, info: cn.info, warning: cn.warning, error: cn.error, custom: cn.custom, message: cn.message, promise: cn.promise, dismiss: cn.dismiss, loading: cn.loading }), YM = 3, GM = "32px", XM = 4e3, qM = 356, Mv = 14, KM = 20, QM = 200;
function ZM(...e) {
  return e.filter(Boolean).join(" ");
}
var JM = (e) => {
  var t, n, r, o, a, i, s;
  let { invert: l, toast: c, unstyled: d, interacting: f, setHeights: p, visibleToasts: m, heights: h, index: g, toasts: x, expanded: y, removeToast: b, closeButton: v, style: A, cancelButtonStyle: w, actionButtonStyle: M, className: $ = "", descriptionClassName: P = "", duration: E, position: T, gap: B = Mv, loadingIcon: j, expandByDefault: V, classNames: W, icons: S, closeButtonAriaLabel: _ = "Close toast", pauseWhenPageIsHidden: U, cn: z } = e, [N, O] = R.useState(!1), [k, Q] = R.useState(!1), [q, re] = R.useState(!1), [ae, oe] = R.useState(!1), [ee, ie] = R.useState(0), [X, J] = R.useState(0), pe = R.useRef(null), D = R.useRef(null), ce = g === 0, he = g + 1 <= m, ye = c.type, Me = c.dismissible !== !1, Oe = c.className || "", it = c.descriptionClassName || "", Qe = R.useMemo(() => h.findIndex((Pe) => Pe.toastId === c.id) || 0, [h, c.id]), yt = R.useMemo(() => {
    var Pe;
    return (Pe = c.closeButton) != null ? Pe : v;
  }, [c.closeButton, v]), At = R.useMemo(() => c.duration || E || XM, [c.duration, E]), It = R.useRef(0), Be = R.useRef(0), bn = R.useRef(0), Wt = R.useRef(null), [an, dt] = T.split("-"), bt = R.useMemo(() => h.reduce((Pe, ze, qe) => qe >= Qe ? Pe : Pe + ze.height, 0), [h, Qe]), ft = jM(), jt = c.invert || l, Vt = ye === "loading";
  Be.current = R.useMemo(() => Qe * B + bt, [Qe, bt]), R.useEffect(() => {
    O(!0);
  }, []), R.useLayoutEffect(() => {
    if (!N)
      return;
    let Pe = D.current, ze = Pe.style.height;
    Pe.style.height = "auto";
    let qe = Pe.getBoundingClientRect().height;
    Pe.style.height = ze, J(qe), p((pt) => pt.find((ot) => ot.toastId === c.id) ? pt.map((ot) => ot.toastId === c.id ? { ...ot, height: qe } : ot) : [{ toastId: c.id, height: qe, position: c.position }, ...pt]);
  }, [N, c.title, c.description, p, c.id]);
  let st = R.useCallback(() => {
    Q(!0), ie(Be.current), p((Pe) => Pe.filter((ze) => ze.toastId !== c.id)), setTimeout(() => {
      b(c);
    }, QM);
  }, [c, b, p, Be]);
  R.useEffect(() => {
    if (c.promise && ye === "loading" || c.duration === 1 / 0 || c.type === "loading")
      return;
    let Pe, ze = At;
    return y || f || U && ft ? (() => {
      if (bn.current < It.current) {
        let qe = (/* @__PURE__ */ new Date()).getTime() - It.current;
        ze = ze - qe;
      }
      bn.current = (/* @__PURE__ */ new Date()).getTime();
    })() : (It.current = (/* @__PURE__ */ new Date()).getTime(), Pe = setTimeout(() => {
      var qe;
      (qe = c.onAutoClose) == null || qe.call(c, c), st();
    }, ze)), () => clearTimeout(Pe);
  }, [y, f, V, c, At, st, c.promise, ye, U, ft]), R.useEffect(() => {
    let Pe = D.current;
    if (Pe) {
      let ze = Pe.getBoundingClientRect().height;
      return J(ze), p((qe) => [{ toastId: c.id, height: ze, position: c.position }, ...qe]), () => p((qe) => qe.filter((pt) => pt.toastId !== c.id));
    }
  }, [p, c.id]), R.useEffect(() => {
    c.delete && st();
  }, [st, c.delete]);
  function qn() {
    return S != null && S.loading ? R.createElement("div", { className: "loader", "data-visible": ye === "loading" }, S.loading) : j ? R.createElement("div", { className: "sonner-loader", "data-visible": ye === "loading" }, j) : R.createElement(IM, { visible: ye === "loading" });
  }
  return R.createElement("li", { "aria-live": c.important ? "assertive" : "polite", "aria-atomic": "true", role: "status", tabIndex: 0, ref: D, className: z($, Oe, W == null ? void 0 : W.toast, (t = c == null ? void 0 : c.classNames) == null ? void 0 : t.toast, W == null ? void 0 : W.default, W == null ? void 0 : W[ye], (n = c == null ? void 0 : c.classNames) == null ? void 0 : n[ye]), "data-sonner-toast": "", "data-styled": !(c.jsx || c.unstyled || d), "data-mounted": N, "data-promise": !!c.promise, "data-removed": k, "data-visible": he, "data-y-position": an, "data-x-position": dt, "data-index": g, "data-front": ce, "data-swiping": q, "data-dismissible": Me, "data-type": ye, "data-invert": jt, "data-swipe-out": ae, "data-expanded": !!(y || V && N), style: { "--index": g, "--toasts-before": g, "--z-index": x.length - g, "--offset": `${k ? ee : Be.current}px`, "--initial-height": V ? "auto" : `${X}px`, ...A, ...c.style }, onPointerDown: (Pe) => {
    Vt || !Me || (pe.current = /* @__PURE__ */ new Date(), ie(Be.current), Pe.target.setPointerCapture(Pe.pointerId), Pe.target.tagName !== "BUTTON" && (re(!0), Wt.current = { x: Pe.clientX, y: Pe.clientY }));
  }, onPointerUp: () => {
    var Pe, ze, qe, pt;
    if (ae || !Me)
      return;
    Wt.current = null;
    let ot = Number(((Pe = D.current) == null ? void 0 : Pe.style.getPropertyValue("--swipe-amount").replace("px", "")) || 0), Ct = (/* @__PURE__ */ new Date()).getTime() - ((ze = pe.current) == null ? void 0 : ze.getTime()), xn = Math.abs(ot) / Ct;
    if (Math.abs(ot) >= KM || xn > 0.11) {
      ie(Be.current), (qe = c.onDismiss) == null || qe.call(c, c), st(), oe(!0);
      return;
    }
    (pt = D.current) == null || pt.style.setProperty("--swipe-amount", "0px"), re(!1);
  }, onPointerMove: (Pe) => {
    var ze;
    if (!Wt.current || !Me)
      return;
    let qe = Pe.clientY - Wt.current.y, pt = Pe.clientX - Wt.current.x, ot = (an === "top" ? Math.min : Math.max)(0, qe), Ct = Pe.pointerType === "touch" ? 10 : 2;
    Math.abs(ot) > Ct ? (ze = D.current) == null || ze.style.setProperty("--swipe-amount", `${qe}px`) : Math.abs(pt) > Ct && (Wt.current = null);
  } }, yt && !c.jsx ? R.createElement("button", { "aria-label": _, "data-disabled": Vt, "data-close-button": !0, onClick: Vt || !Me ? () => {
  } : () => {
    var Pe;
    st(), (Pe = c.onDismiss) == null || Pe.call(c, c);
  }, className: z(W == null ? void 0 : W.closeButton, (r = c == null ? void 0 : c.classNames) == null ? void 0 : r.closeButton) }, R.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, R.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), R.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" }))) : null, c.jsx || R.isValidElement(c.title) ? c.jsx || c.title : R.createElement(R.Fragment, null, ye || c.icon || c.promise ? R.createElement("div", { "data-icon": "" }, c.promise && c.type === "loading" && !c.icon ? c.icon || (S == null ? void 0 : S.loading) || qn() : null, c.type !== "loading" ? c.icon || (S == null ? void 0 : S[ye]) || RM(ye) : null) : null, R.createElement("div", { "data-content": "" }, R.createElement("div", { "data-title": "", className: z(W == null ? void 0 : W.title, (o = c == null ? void 0 : c.classNames) == null ? void 0 : o.title) }, c.title), c.description ? R.createElement("div", { "data-description": "", className: z(P, it, W == null ? void 0 : W.description, (a = c == null ? void 0 : c.classNames) == null ? void 0 : a.description) }, c.description) : null), c.cancel ? R.createElement("button", { "data-button": !0, "data-cancel": !0, style: c.cancelButtonStyle || w, onClick: (Pe) => {
    var ze;
    Me && (st(), (ze = c.cancel) != null && ze.onClick && c.cancel.onClick(Pe));
  }, className: z(W == null ? void 0 : W.cancelButton, (i = c == null ? void 0 : c.classNames) == null ? void 0 : i.cancelButton) }, c.cancel.label) : null, c.action ? R.createElement("button", { "data-button": "", style: c.actionButtonStyle || M, onClick: (Pe) => {
    var ze;
    (ze = c.action) == null || ze.onClick(Pe), !Pe.defaultPrevented && st();
  }, className: z(W == null ? void 0 : W.actionButton, (s = c == null ? void 0 : c.classNames) == null ? void 0 : s.actionButton) }, c.action.label) : null));
};
function k1() {
  if (typeof window > "u" || typeof document > "u")
    return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
var e$ = (e) => {
  let { invert: t, position: n = "bottom-right", hotkey: r = ["altKey", "KeyT"], expand: o, closeButton: a, className: i, offset: s, theme: l = "light", richColors: c, duration: d, style: f, visibleToasts: p = YM, toastOptions: m, dir: h = k1(), gap: g, loadingIcon: x, icons: y, containerAriaLabel: b = "Notifications", pauseWhenPageIsHidden: v, cn: A = ZM } = e, [w, M] = R.useState([]), $ = R.useMemo(() => Array.from(new Set([n].concat(w.filter((k) => k.position).map((k) => k.position)))), [w, n]), [P, E] = R.useState([]), [T, B] = R.useState(!1), [j, V] = R.useState(!1), [W, S] = R.useState(l !== "system" ? l : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), _ = R.useRef(null), U = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), z = R.useRef(null), N = R.useRef(!1), O = R.useCallback((k) => M((Q) => Q.filter(({ id: q }) => q !== k.id)), []);
  return R.useEffect(() => cn.subscribe((k) => {
    if (k.dismiss) {
      M((Q) => Q.map((q) => q.id === k.id ? { ...q, delete: !0 } : q));
      return;
    }
    setTimeout(() => {
      _a.flushSync(() => {
        M((Q) => {
          let q = Q.findIndex((re) => re.id === k.id);
          return q !== -1 ? [...Q.slice(0, q), { ...Q[q], ...k }, ...Q.slice(q + 1)] : [k, ...Q];
        });
      });
    });
  }), []), R.useEffect(() => {
    if (l !== "system") {
      S(l);
      return;
    }
    l === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? S("dark") : S("light")), typeof window < "u" && window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ({ matches: k }) => {
      S(k ? "dark" : "light");
    });
  }, [l]), R.useEffect(() => {
    w.length <= 1 && B(!1);
  }, [w]), R.useEffect(() => {
    let k = (Q) => {
      var q, re;
      r.every((ae) => Q[ae] || Q.code === ae) && (B(!0), (q = _.current) == null || q.focus()), Q.code === "Escape" && (document.activeElement === _.current || (re = _.current) != null && re.contains(document.activeElement)) && B(!1);
    };
    return document.addEventListener("keydown", k), () => document.removeEventListener("keydown", k);
  }, [r]), R.useEffect(() => {
    if (_.current)
      return () => {
        z.current && (z.current.focus({ preventScroll: !0 }), z.current = null, N.current = !1);
      };
  }, [_.current]), w.length ? R.createElement("section", { "aria-label": `${b} ${U}`, tabIndex: -1 }, $.map((k, Q) => {
    var q;
    let [re, ae] = k.split("-");
    return R.createElement("ol", { key: k, dir: h === "auto" ? k1() : h, tabIndex: -1, ref: _, className: i, "data-sonner-toaster": !0, "data-theme": W, "data-rich-colors": c, "data-y-position": re, "data-x-position": ae, style: { "--front-toast-height": `${((q = P[0]) == null ? void 0 : q.height) || 0}px`, "--offset": typeof s == "number" ? `${s}px` : s || GM, "--width": `${qM}px`, "--gap": `${Mv}px`, ...f }, onBlur: (oe) => {
      N.current && !oe.currentTarget.contains(oe.relatedTarget) && (N.current = !1, z.current && (z.current.focus({ preventScroll: !0 }), z.current = null));
    }, onFocus: (oe) => {
      oe.target instanceof HTMLElement && oe.target.dataset.dismissible === "false" || N.current || (N.current = !0, z.current = oe.relatedTarget);
    }, onMouseEnter: () => B(!0), onMouseMove: () => B(!0), onMouseLeave: () => {
      j || B(!1);
    }, onPointerDown: (oe) => {
      oe.target instanceof HTMLElement && oe.target.dataset.dismissible === "false" || V(!0);
    }, onPointerUp: () => V(!1) }, w.filter((oe) => !oe.position && Q === 0 || oe.position === k).map((oe, ee) => {
      var ie, X;
      return R.createElement(JM, { key: oe.id, icons: y, index: ee, toast: oe, duration: (ie = m == null ? void 0 : m.duration) != null ? ie : d, className: m == null ? void 0 : m.className, descriptionClassName: m == null ? void 0 : m.descriptionClassName, invert: t, visibleToasts: p, closeButton: (X = m == null ? void 0 : m.closeButton) != null ? X : a, interacting: j, position: k, style: m == null ? void 0 : m.style, unstyled: m == null ? void 0 : m.unstyled, classNames: m == null ? void 0 : m.classNames, cancelButtonStyle: m == null ? void 0 : m.cancelButtonStyle, actionButtonStyle: m == null ? void 0 : m.actionButtonStyle, removeToast: O, toasts: w.filter((J) => J.position == oe.position), heights: P.filter((J) => J.position == oe.position), setHeights: E, expandByDefault: o, gap: g, loadingIcon: x, expanded: T, pauseWhenPageIsHidden: v, cn: A });
    }));
  })) : null;
};
const QH = ({ ...e }) => /* @__PURE__ */ u(
  e$,
  {
    className: "rabbit-ds toaster group",
    visibleToasts: 6,
    position: "bottom-left",
    icons: {
      success: /* @__PURE__ */ u(Fe, { IconSVG: Eb }),
      info: /* @__PURE__ */ u(Fe, { IconSVG: La }),
      warning: /* @__PURE__ */ u(Fe, { IconSVG: X0 }),
      error: /* @__PURE__ */ u(Fe, { IconSVG: X0 }),
      loading: /* @__PURE__ */ u(Fe, { IconSVG: $6 })
    },
    toastOptions: {
      classNames: {
        error: "group-[.toaster]:bg-warning-bg group-[.toaster]:text-warning-primary",
        success: "group-[.toaster]:bg-success-bg group-[.toaster]:text-success-primary",
        warning: "group-[.toaster]:bg-warning-bg group-[.toaster]:text-warning-primary",
        info: "group-[.toaster]:text-font-primary",
        toast: "group toast group-[.toaster]:rounded group-[.toaster]:border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-font-secondary",
        actionButton: "group-[.toast]:h-7 group-[.toast]:border-0 group-[.toast]:bg-transparent group-[.toast]:text-primary group-[.toast]:hover:text-primary-hover group-[.toast]:focus:text-primary-focus group-[.toast]:disabled:text-primary-focus group-[.toast]:rounded group-[.toast]:py-2 group-[.toast]:text-sm group-[.toast]:font-semibold group-[.toast]:focus-visible:outline-none group-[.toast]:focus-visible:ring-2 group-[.toast]:focus-visible:ring-offset-2 group-[.toast]:disabled:pointer-events-none",
        cancelButton: "group-[.toast]:h-7 group-[.toast]:border-0 group-[.toast]:bg-transparent group-[.toast]:text-primary group-[.toast]:hover:text-primary-hover group-[.toast]:focus:text-primary-focus group-[.toast]:disabled:text-primary-focus group-[.toast]:rounded group-[.toast]:py-2 group-[.toast]:text-sm group-[.toast]:font-semibold group-[.toast]:focus-visible:outline-none group-[.toast]:focus-visible:ring-2 group-[.toast]:focus-visible:ring-offset-2 group-[.toast]:disabled:pointer-events-none"
      }
    },
    ...e
  }
);
var t$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const n$ = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), r$ = (e, t) => {
  const n = Y(
    ({ color: r = "currentColor", size: o = 24, strokeWidth: a = 2, absoluteStrokeWidth: i, children: s, ...l }, c) => F(
      "svg",
      {
        ref: c,
        ...t$,
        width: o,
        height: o,
        stroke: r,
        strokeWidth: i ? Number(a) * 24 / Number(o) : a,
        className: `lucide lucide-${n$(e)}`,
        ...l
      },
      [
        ...t.map(([d, f]) => F(d, f)),
        ...(Array.isArray(s) ? s : [s]) || []
      ]
    )
  );
  return n.displayName = `${e}`, n;
}, o$ = r$("MoreHorizontal", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]), a$ = Z.forwardRef(({ ...e }, t) => /* @__PURE__ */ u("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
a$.displayName = "Breadcrumb";
const i$ = Z.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "ol",
    {
      ref: n,
      className: le(
        "flex flex-wrap items-center gap-1.5 break-words font-sans text-xs text-font-secondary sm:gap-1",
        e
      ),
      ...t
    }
  )
);
i$.displayName = "BreadcrumbList";
const s$ = Z.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("li", { ref: n, className: le("inline-flex items-center gap-1.5", e), ...t })
);
s$.displayName = "BreadcrumbItem";
const l$ = Z.forwardRef(({ asChild: e, className: t, ...n }, r) => /* @__PURE__ */ u(e ? $n : "a", { ref: r, className: le("no-underline text-font-secondary", t), ...n }));
l$.displayName = "BreadcrumbLink";
const c$ = Z.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "span",
    {
      ref: n,
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: le("font-semibold text-font-primary", e),
      ...t
    }
  )
);
c$.displayName = "BreadcrumbPage";
const u$ = ({ children: e, className: t, ...n }) => /* @__PURE__ */ u(
  "li",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: le("[&>svg]:size-3.5 inline-flex text-font-secondary", t),
    ...n,
    children: e ?? /* @__PURE__ */ u(Fe, { IconSVG: hd })
  }
);
u$.displayName = "BreadcrumbSeparator";
const d$ = ({ className: e, ...t }) => /* @__PURE__ */ I(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: le("flex h-9 w-9 items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ u(o$, { className: "h-4 w-4" }),
      /* @__PURE__ */ u("span", { className: "sr-only", children: "More" })
    ]
  }
);
d$.displayName = "BreadcrumbEllipsis";
function Zt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function $v(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = Z.createContext(i), l = n.length;
    n = [...n, i];
    function c(f) {
      const { scope: p, children: m, ...h } = f, g = (p == null ? void 0 : p[e][l]) || s, x = Z.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ u(g.Provider, { value: x, children: m });
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][l]) || s, h = Z.useContext(m);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return c.displayName = a + "Provider", [c, d];
  }
  const o = () => {
    const a = n.map((i) => Z.createContext(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return Z.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, f$(o, ...t)];
}
function f$(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: l, scopeName: c }) => {
        const f = l(a)[`__scope${c}`];
        return { ...s, ...f };
      }, {});
      return Z.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Bo(e) {
  const t = Z.useRef(e);
  return Z.useEffect(() => {
    t.current = e;
  }), Z.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function p$({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = h$({ defaultProp: t, onChange: n }), a = e !== void 0, i = a ? e : r, s = Bo(n), l = Z.useCallback(
    (c) => {
      if (a) {
        const f = typeof c == "function" ? c(e) : c;
        f !== e && s(f);
      } else
        o(c);
    },
    [a, e, o, s]
  );
  return [i, l];
}
function h$({
  defaultProp: e,
  onChange: t
}) {
  const n = Z.useState(e), [r] = n, o = Z.useRef(r), a = Bo(t);
  return Z.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), n;
}
function m$(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Pv(...e) {
  return (t) => e.forEach((n) => m$(n, t));
}
function zo(...e) {
  return Z.useCallback(Pv(...e), e);
}
var Tv = Z.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = Z.Children.toArray(n), a = o.find(v$);
  if (a) {
    const i = a.props.children, s = o.map((l) => l === a ? Z.Children.count(i) > 1 ? Z.Children.only(null) : Z.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ u(Zc, { ...r, ref: t, children: Z.isValidElement(i) ? Z.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ u(Zc, { ...r, ref: t, children: n });
});
Tv.displayName = "Slot";
var Zc = Z.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (Z.isValidElement(n)) {
    const o = b$(n);
    return Z.cloneElement(n, {
      ...y$(r, n.props),
      // @ts-ignore
      ref: t ? Pv(t, o) : o
    });
  }
  return Z.Children.count(n) > 1 ? Z.Children.only(null) : null;
});
Zc.displayName = "SlotClone";
var g$ = ({ children: e }) => /* @__PURE__ */ u(ko, { children: e });
function v$(e) {
  return Z.isValidElement(e) && e.type === g$;
}
function y$(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function b$(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var x$ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Gr = x$.reduce((e, t) => {
  const n = Z.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? Tv : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function w$(e, t) {
  e && ud.flushSync(() => e.dispatchEvent(t));
}
var A$ = "Arrow", Ov = Z.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ u(
    Gr.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ u("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Ov.displayName = A$;
var C$ = Ov, wo = globalThis != null && globalThis.document ? Z.useLayoutEffect : () => {
};
function S$(e) {
  const [t, n] = Z.useState(void 0);
  return wo(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var tf = "Popper", [Nv, kv] = $v(tf), [E$, Dv] = Nv(tf), Fv = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = Z.useState(null);
  return /* @__PURE__ */ u(E$, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Fv.displayName = tf;
var Rv = "PopperAnchor", _v = Z.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = Dv(Rv, n), i = Z.useRef(null), s = zo(t, i);
    return Z.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */ u(Gr.div, { ...o, ref: s });
  }
);
_v.displayName = Rv;
var nf = "PopperContent", [M$, $$] = Nv(nf), Iv = Z.forwardRef(
  (e, t) => {
    var ee, ie, X, J, pe, D;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: h,
      ...g
    } = e, x = Dv(nf, n), [y, b] = Z.useState(null), v = zo(t, (ce) => b(ce)), [A, w] = Z.useState(null), M = S$(A), $ = (M == null ? void 0 : M.width) ?? 0, P = (M == null ? void 0 : M.height) ?? 0, E = r + (a !== "center" ? "-" + a : ""), T = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, B = Array.isArray(c) ? c : [c], j = B.length > 0, V = {
      padding: T,
      boundary: B.filter(T$),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: j
    }, { refs: W, floatingStyles: S, placement: _, isPositioned: U, middlewareData: z } = ig({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: E,
      whileElementsMounted: (...ce) => rg(...ce, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: x.anchor
      },
      middleware: [
        Ym({ mainAxis: o + P, alignmentAxis: i }),
        l && Gm({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Xm() : void 0,
          ...V
        }),
        l && Hm({ ...V }),
        qm({
          ...V,
          apply: ({ elements: ce, rects: he, availableWidth: ye, availableHeight: Me }) => {
            const { width: Oe, height: it } = he.reference, Qe = ce.floating.style;
            Qe.setProperty("--radix-popper-available-width", `${ye}px`), Qe.setProperty("--radix-popper-available-height", `${Me}px`), Qe.setProperty("--radix-popper-anchor-width", `${Oe}px`), Qe.setProperty("--radix-popper-anchor-height", `${it}px`);
          }
        }),
        A && og({ element: A, padding: s }),
        O$({ arrowWidth: $, arrowHeight: P }),
        p && Um({ strategy: "referenceHidden", ...V })
      ]
    }), [N, O] = zv(_), k = Bo(h);
    wo(() => {
      U && (k == null || k());
    }, [U, k]);
    const Q = (ee = z.arrow) == null ? void 0 : ee.x, q = (ie = z.arrow) == null ? void 0 : ie.y, re = ((X = z.arrow) == null ? void 0 : X.centerOffset) !== 0, [ae, oe] = Z.useState();
    return wo(() => {
      y && oe(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ u(
      "div",
      {
        ref: W.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...S,
          transform: U ? S.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ae,
          "--radix-popper-transform-origin": [
            (J = z.transformOrigin) == null ? void 0 : J.x,
            (pe = z.transformOrigin) == null ? void 0 : pe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((D = z.hide) == null ? void 0 : D.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ u(
          M$,
          {
            scope: n,
            placedSide: N,
            onArrowChange: w,
            arrowX: Q,
            arrowY: q,
            shouldHideArrow: re,
            children: /* @__PURE__ */ u(
              Gr.div,
              {
                "data-side": N,
                "data-align": O,
                ...g,
                ref: v,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: U ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Iv.displayName = nf;
var Lv = "PopperArrow", P$ = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Bv = Z.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = $$(Lv, r), i = P$[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ u(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ u(
          C$,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Bv.displayName = Lv;
function T$(e) {
  return e !== null;
}
var O$ = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var x, y, b;
    const { placement: n, rects: r, middlewareData: o } = t, i = ((x = o.arrow) == null ? void 0 : x.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [c, d] = zv(n), f = { start: "0%", center: "50%", end: "100%" }[d], p = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + s / 2, m = (((b = o.arrow) == null ? void 0 : b.y) ?? 0) + l / 2;
    let h = "", g = "";
    return c === "bottom" ? (h = i ? f : `${p}px`, g = `${-l}px`) : c === "top" ? (h = i ? f : `${p}px`, g = `${r.floating.height + l}px`) : c === "right" ? (h = `${-l}px`, g = i ? f : `${m}px`) : c === "left" && (h = `${r.floating.width + l}px`, g = i ? f : `${m}px`), { data: { x: h, y: g } };
  }
});
function zv(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var N$ = Fv, k$ = _v, D$ = Iv, F$ = Bv, R$ = "Portal", Wv = Z.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = Z.useState(!1);
  wo(() => a(!0), []);
  const i = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? _a.createPortal(/* @__PURE__ */ u(Gr.div, { ...r, ref: t }), i) : null;
});
Wv.displayName = R$;
function _$(e, t) {
  return Z.useReducer((n, r) => t[n][r] ?? n, e);
}
var rf = (e) => {
  const { present: t, children: n } = e, r = I$(t), o = typeof n == "function" ? n({ present: r.isPresent }) : Z.Children.only(n), a = zo(r.ref, L$(o));
  return typeof n == "function" || r.isPresent ? Z.cloneElement(o, { ref: a }) : null;
};
rf.displayName = "Presence";
function I$(e) {
  const [t, n] = Z.useState(), r = Z.useRef({}), o = Z.useRef(e), a = Z.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = _$(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Z.useEffect(() => {
    const c = Ti(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [s]), wo(() => {
    const c = r.current, d = o.current;
    if (d !== e) {
      const p = a.current, m = Ti(c);
      e ? l("MOUNT") : m === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(d && p !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), wo(() => {
    if (t) {
      const c = (f) => {
        const m = Ti(r.current).includes(f.animationName);
        f.target === t && m && ud.flushSync(() => l("ANIMATION_END"));
      }, d = (f) => {
        f.target === t && (a.current = Ti(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: Z.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Ti(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function L$(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function B$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Bo(e);
  Z.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var z$ = "DismissableLayer", Jc = "dismissableLayer.update", W$ = "dismissableLayer.pointerDownOutside", j$ = "dismissableLayer.focusOutside", D1, jv = Z.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Vv = Z.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = Z.useContext(jv), [d, f] = Z.useState(null), p = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = Z.useState({}), h = zo(t, ($) => f($)), g = Array.from(c.layers), [x] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(x), b = d ? g.indexOf(d) : -1, v = c.layersWithOutsidePointerEventsDisabled.size > 0, A = b >= y, w = U$(($) => {
      const P = $.target, E = [...c.branches].some((T) => T.contains(P));
      !A || E || (o == null || o($), i == null || i($), $.defaultPrevented || s == null || s());
    }, p), M = Y$(($) => {
      const P = $.target;
      [...c.branches].some((T) => T.contains(P)) || (a == null || a($), i == null || i($), $.defaultPrevented || s == null || s());
    }, p);
    return B$(($) => {
      b === c.layers.size - 1 && (r == null || r($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, p), Z.useEffect(() => {
      if (d)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (D1 = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), F1(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = D1);
        };
    }, [d, p, n, c]), Z.useEffect(() => () => {
      d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), F1());
    }, [d, c]), Z.useEffect(() => {
      const $ = () => m({});
      return document.addEventListener(Jc, $), () => document.removeEventListener(Jc, $);
    }, []), /* @__PURE__ */ u(
      Gr.div,
      {
        ...l,
        ref: h,
        style: {
          pointerEvents: v ? A ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Zt(e.onFocusCapture, M.onFocusCapture),
        onBlurCapture: Zt(e.onBlurCapture, M.onBlurCapture),
        onPointerDownCapture: Zt(
          e.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
Vv.displayName = z$;
var V$ = "DismissableLayerBranch", H$ = Z.forwardRef((e, t) => {
  const n = Z.useContext(jv), r = Z.useRef(null), o = zo(t, r);
  return Z.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ u(Gr.div, { ...e, ref: o });
});
H$.displayName = V$;
function U$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Bo(e), r = Z.useRef(!1), o = Z.useRef(() => {
  });
  return Z.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Hv(
            W$,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Y$(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Bo(e), r = Z.useRef(!1);
  return Z.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Hv(j$, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function F1() {
  const e = new CustomEvent(Jc);
  document.dispatchEvent(e);
}
function Hv(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? w$(o, a) : o.dispatchEvent(a);
}
var ql, of = "HoverCard", [Uv, ZH] = $v(of, [
  kv
]), fl = kv(), [G$, pl] = Uv(of), Yv = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    openDelay: i = 700,
    closeDelay: s = 300
  } = e, l = fl(t), c = Z.useRef(0), d = Z.useRef(0), f = Z.useRef(!1), p = Z.useRef(!1), [m = !1, h] = p$({
    prop: r,
    defaultProp: o,
    onChange: a
  }), g = Z.useCallback(() => {
    clearTimeout(d.current), c.current = window.setTimeout(() => h(!0), i);
  }, [i, h]), x = Z.useCallback(() => {
    clearTimeout(c.current), !f.current && !p.current && (d.current = window.setTimeout(() => h(!1), s));
  }, [s, h]), y = Z.useCallback(() => h(!1), [h]);
  return Z.useEffect(() => () => {
    clearTimeout(c.current), clearTimeout(d.current);
  }, []), /* @__PURE__ */ u(
    G$,
    {
      scope: t,
      open: m,
      onOpenChange: h,
      onOpen: g,
      onClose: x,
      onDismiss: y,
      hasSelectionRef: f,
      isPointerDownOnContentRef: p,
      children: /* @__PURE__ */ u(N$, { ...l, children: n })
    }
  );
};
Yv.displayName = of;
var Gv = "HoverCardTrigger", Xv = Z.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = pl(Gv, n), a = fl(n);
    return /* @__PURE__ */ u(k$, { asChild: !0, ...a, children: /* @__PURE__ */ u(
      Gr.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...r,
        ref: t,
        onPointerEnter: Zt(e.onPointerEnter, gs(o.onOpen)),
        onPointerLeave: Zt(e.onPointerLeave, gs(o.onClose)),
        onFocus: Zt(e.onFocus, o.onOpen),
        onBlur: Zt(e.onBlur, o.onClose),
        onTouchStart: Zt(e.onTouchStart, (i) => i.preventDefault())
      }
    ) });
  }
);
Xv.displayName = Gv;
var af = "HoverCardPortal", [X$, q$] = Uv(af, {
  forceMount: void 0
}), qv = (e) => {
  const { __scopeHoverCard: t, forceMount: n, children: r, container: o } = e, a = pl(af, t);
  return /* @__PURE__ */ u(X$, { scope: t, forceMount: n, children: /* @__PURE__ */ u(rf, { present: n || a.open, children: /* @__PURE__ */ u(Wv, { asChild: !0, container: o, children: r }) }) });
};
qv.displayName = af;
var ms = "HoverCardContent", Kv = Z.forwardRef(
  (e, t) => {
    const n = q$(ms, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...o } = e, a = pl(ms, e.__scopeHoverCard);
    return /* @__PURE__ */ u(rf, { present: r || a.open, children: /* @__PURE__ */ u(
      K$,
      {
        "data-state": a.open ? "open" : "closed",
        ...o,
        onPointerEnter: Zt(e.onPointerEnter, gs(a.onOpen)),
        onPointerLeave: Zt(e.onPointerLeave, gs(a.onClose)),
        ref: t
      }
    ) });
  }
);
Kv.displayName = ms;
var K$ = Z.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: o,
    onFocusOutside: a,
    onInteractOutside: i,
    ...s
  } = e, l = pl(ms, n), c = fl(n), d = Z.useRef(null), f = zo(t, d), [p, m] = Z.useState(!1);
  return Z.useEffect(() => {
    if (p) {
      const h = document.body;
      return ql = h.style.userSelect || h.style.webkitUserSelect, h.style.userSelect = "none", h.style.webkitUserSelect = "none", () => {
        h.style.userSelect = ql, h.style.webkitUserSelect = ql;
      };
    }
  }, [p]), Z.useEffect(() => {
    if (d.current) {
      const h = () => {
        m(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var x;
          ((x = document.getSelection()) == null ? void 0 : x.toString()) !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", h), () => {
        document.removeEventListener("pointerup", h), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), Z.useEffect(() => {
    d.current && J$(d.current).forEach((g) => g.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ u(
    Vv,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: i,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: Zt(a, (h) => {
        h.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ u(
        D$,
        {
          ...c,
          ...s,
          onPointerDown: Zt(s.onPointerDown, (h) => {
            h.currentTarget.contains(h.target) && m(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: f,
          style: {
            ...s.style,
            userSelect: p ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: p ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), Q$ = "HoverCardArrow", Z$ = Z.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = fl(n);
    return /* @__PURE__ */ u(F$, { ...o, ...r, ref: t });
  }
);
Z$.displayName = Q$;
function gs(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function J$(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
var eP = Yv, tP = Xv, nP = qv, Qv = Kv;
const JH = eP, eU = tP, tU = nP, rP = Z.forwardRef(({ className: e, align: t = "start", sideOffset: n = 12, ...r }, o) => /* @__PURE__ */ u(
  Qv,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: le(
      "z-50 rounded-lg shadow bg-[#FDFDFD] p-2 border border-solid border-[#F3F5F8] outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
));
rP.displayName = Qv.displayName;
function nU({
  status: e = ut.ON_TRACK,
  startValue: t = 0,
  targetValue: n = 100,
  achievedValue: r = 0,
  percentageToDisplay: o = 0,
  metricName: a = "",
  measureBy: i = { isPrefix: !1, symbol: "" }
}) {
  const s = a.length > 35 ? `${a.slice(0, 35)}...` : a, l = Gi(r), c = Gi(t), d = Gi(n);
  return /* @__PURE__ */ I("div", { className: "rabbit-ds box-border inline-flex w-full min-w-[304px] flex-col items-start justify-center  px-3 py-2", children: [
    /* @__PURE__ */ u("div", { className: "inline-flex h-4 w-full items-center justify-start gap-1 py-0.5", children: /* @__PURE__ */ u("div", { className: "text-right  text-xs font-normal leading-3 text-font-secondary", children: s }) }),
    /* @__PURE__ */ I("div", { className: "inline-flex h-5 w-full items-start justify-start gap-1 self-stretch", children: [
      /* @__PURE__ */ u("div", { className: "flex h-5 w-9/12 items-start justify-start", children: /* @__PURE__ */ u(r7, { progressInPercentage: o, status: e }) }),
      /* @__PURE__ */ u("div", { className: "inline-flex h-[20px] grow items-center justify-start gap-1", children: /* @__PURE__ */ u("div", { className: "  w-full text-left text-sm font-[590] leading-5 text-font-primary ", children: i.isPrefix ? i.symbol + l : l + i.symbol }) })
    ] }),
    /* @__PURE__ */ I("div", { className: "inline-flex w-9/12 items-center justify-between", children: [
      /* @__PURE__ */ u("div", { className: "box-border inline-flex h-6 items-center justify-start gap-1 py-1", children: /* @__PURE__ */ u("div", { className: "inline-flex h-4  shrink grow basis-0 items-start justify-start gap-2.5", children: /* @__PURE__ */ u("div", { className: " text-[10px] font-[590] leading-4 text-font-secondary ", children: i.isPrefix ? i.symbol + c : c + i.symbol }) }) }),
      /* @__PURE__ */ u("div", { className: "box-border inline-flex h-6 items-center justify-start gap-1 py-1", children: /* @__PURE__ */ u("div", { className: "inline-flex h-4 shrink grow basis-0 items-start justify-end gap-2.5", children: /* @__PURE__ */ u("div", { className: "text-[10px] font-[590] leading-4 text-font-secondary ", children: i.isPrefix ? i.symbol + d : d + i.symbol }) }) })
    ] })
  ] });
}
function R1({ avatar: e, size: t }) {
  return /* @__PURE__ */ I(Hn, { size: t, children: [
    /* @__PURE__ */ u(Un, { src: e.src }),
    e.fallbackText ? /* @__PURE__ */ u(Pd, { children: e.fallbackText }) : null
  ] });
}
const oP = nt("font-semibold", {
  variants: {
    size: {
      xs: "text-xs",
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      profile: "text-6xl"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Zv = Y(({ limit: e = 4, data: t, size: n = "md", className: r }, o) => {
  const a = t.length - e;
  return /* @__PURE__ */ I("div", { className: le("rabbit-ds inline-flex items-center gap-1", r), ref: o, children: [
    t.map(
      (i) => i.tooltipText ? /* @__PURE__ */ u(Av, { children: /* @__PURE__ */ I(Cv, { children: [
        /* @__PURE__ */ u(Sv, { asChild: !0, children: /* @__PURE__ */ u("button", { type: "button", className: "cursor-auto bg-transparent", children: /* @__PURE__ */ u(R1, { size: n, avatar: i }) }) }),
        /* @__PURE__ */ u(Ev, { children: /* @__PURE__ */ u(ef, { children: /* @__PURE__ */ u("p", { children: i.tooltipText }) }) })
      ] }) }, i.src) : /* @__PURE__ */ u(R1, { size: n, avatar: i }, i.src)
    ).slice(0, e),
    a > 0 ? /* @__PURE__ */ I("div", { className: le(oP({ size: n })), children: [
      "+",
      a
    ] }) : null
  ] });
});
Zv.displayName = "AvatarGroup";
Zv.defaultProps = {
  limit: 4,
  size: "md"
};
function rU({ count: e, totalCount: t, title: n, subTitle: r, className: o, unstyledDimension: a = !1, style: i }) {
  return /* @__PURE__ */ I(
    "div",
    {
      className: le(
        "rabbit-ds box-border px-2 py-4 bg-white rounded-lg shadow-card flex-col justify-center items-start gap-1 inline-flex",
        o,
        !a && "max-w-[336px] min-h-[96px] min-w-[200px]"
      ),
      style: i,
      children: [
        /* @__PURE__ */ I("div", { className: "flex items-baseline self-stretch px-3 py-1", children: [
          /* @__PURE__ */ u("div", { className: "text-3xl font-semibold text-zinc-800", children: e }),
          t && t > 0 ? /* @__PURE__ */ I("div", { className: "text-xs font-normal text-stone-500", children: [
            "/",
            t
          ] }) : null
        ] }),
        /* @__PURE__ */ u("div", { className: "inline-flex items-center justify-start gap-2 self-stretch px-3", children: /* @__PURE__ */ I("div", { className: "inline-flex shrink grow basis-0 flex-col items-start justify-start gap-0.5", children: [
          /* @__PURE__ */ u("div", { className: "inline-flex items-start justify-start gap-2.5 self-stretch", children: /* @__PURE__ */ u("div", { className: "shrink grow basis-0 text-xs font-semibold leading-none text-zinc-800", children: n }) }),
          r && /* @__PURE__ */ u("div", { className: "inline-flex items-center justify-start gap-1 self-stretch py-2", children: /* @__PURE__ */ u("div", { className: "shrink grow basis-0 text-xs font-normal leading-none text-stone-500", children: r }) })
        ] }) })
      ]
    }
  );
}
const sf = ({ bold: e = !1, color: t = "text-font-primary" }) => le("rabbit-ds-text", e ? "font-semibold" : "font-normal", t), aP = ({ children: e, className: t, ...n }) => /* @__PURE__ */ u("h3", { className: le("text-2xs ", sf(n), t), ...n, children: e }), Jv = ({ children: e, className: t, ...n }) => /* @__PURE__ */ u("h3", { className: le("text-xs ", sf(n), t), ...n, children: e }), iP = ({ children: e, className: t, ...n }) => /* @__PURE__ */ u("h1", { className: le("text-2xl ", sf(n), t), ...n, children: e }), sP = Y(
  ({ className: e, children: t, filterLabel: n, filterActive: r, onFilterClick: o, onFilterActiveClick: a, ...i }, s) => {
    const l = !r && o || r && a;
    function c() {
      !r && o ? o() : r && a && a();
    }
    function d(f) {
      ["Enter", " "].includes(f.key) && l && c();
    }
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ I(
        "div",
        {
          ref: s,
          onClick: c,
          role: l ? "button" : void 0,
          onKeyDown: d,
          tabIndex: l ? 0 : void 0,
          className: le(
            "rabbit-ds box-border inline-flex w-full flex-col items-start justify-start rounded-lg  bg-white shadow-card ",
            "group",
            "border border-solid  border-transparent",
            l ? "cursor-pointer" : "",
            r ? " border-[#004F67] bg-metric-card-bg-focus" : "",
            l && "hover:bg-metric-card-bg-hover",
            e
          ),
          ...i,
          children: [
            /* @__PURE__ */ u("div", { className: "inline-flex w-full flex-col items-start justify-start  p-3", children: t }),
            n ? /* @__PURE__ */ I(
              "button",
              {
                tabIndex: -1,
                type: "button",
                className: le(
                  "inline-flex w-full flex-row items-center rounded-b-lg border-t bg-[#FDFDFD]  px-2 py-1 font-sans text-xs font-medium text-primary",
                  l && "group-hover:bg-metric-card-bg-hover",
                  !l && "cursor-auto",
                  r ? "border-[#004F67] bg-card-bg-focus text-[#004F67]" : "border-accent"
                ),
                children: [
                  /* @__PURE__ */ u(Fe, { IconSVG: r ? E6 : zb, className: "mr-1" }),
                  n
                ]
              }
            ) : null
          ]
        }
      )
    );
  }
);
sP.displayName = "MetricCard";
const eu = nt("", {
  variants: {
    type: {
      default: "text-font-secondary",
      primary: "text-font-primary",
      success: "text-success-primary",
      warning: "text-warning-primary"
    }
  },
  defaultVariants: {
    type: "primary"
  }
}), lf = Y(({ className: e, type: t, children: n, ...r }) => /* @__PURE__ */ u(Jv, { className: le(eu({ type: t }), e), ...r, children: n }));
lf.displayName = "MetricCardText";
lf.defaultProps = {
  type: "default"
};
const lP = Y(({ className: e, ...t }) => /* @__PURE__ */ u(iP, { bold: !0, children: t.children }));
lP.displayName = "Metric";
const cP = ({ ...e }) => /* @__PURE__ */ u(lf, { bold: !0, type: "primary", ...e });
cP.displayName = "MetricCardTitle";
const e3 = Y(({ className: e, type: t, ...n }) => /* @__PURE__ */ I("div", { className: "flex flex-row gap-1", children: [
  /* @__PURE__ */ I("div", { className: "flex flex-row items-center gap-0.5 px-0.5", children: [
    /* @__PURE__ */ u(Fe, { IconSVG: t === "success" ? I6 : R6, size: "x-small" }),
    /* @__PURE__ */ u(Jv, { bold: !0, className: le(eu({ type: t }), "px-0.5"), children: n.statText })
  ] }),
  /* @__PURE__ */ u(aP, { className: le(eu({ type: t })), children: n.descriptionText })
] }));
e3.displayName = "MetricCardStatText";
e3.defaultProps = {
  type: "primary"
};
const uP = "data:image/png;base64,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", t3 = Y(
  ({
    userName: e,
    designation: t,
    profileImage: n,
    children: r,
    ctaCallback: o,
    ctaText: a,
    className: i,
    avatarImageClassName: s,
    onFileChange: l,
    showUpdateButton: c
  }, d) => /* @__PURE__ */ u("div", { ref: d, className: i, children: /* @__PURE__ */ I(Qs, { className: "relative flex min-h-80 w-80 items-center justify-between p-0", children: [
    /* @__PURE__ */ u("img", { src: uP, alt: "background", className: "absolute" }),
    /* @__PURE__ */ I("div", { children: [
      /* @__PURE__ */ u(
        Yd,
        {
          className: "mt-14",
          src: n,
          userName: e,
          badgeLabel: t,
          showDashedOutline: !0,
          size: "profile",
          avatarImageClassName: s,
          onFileChange: c ? l : void 0,
          showUpdateButton: c
        }
      ),
      /* @__PURE__ */ u("h2", { className: "w-full p-3 text-center text-3xl font-medium", children: e }),
      r
    ] }),
    a ? /* @__PURE__ */ I("div", { className: "flex w-full flex-col items-center", children: [
      /* @__PURE__ */ u(Mm, { className: "h-[1px] w-full bg-accent" }),
      /* @__PURE__ */ I(nn, { size: "small", variant: "text", className: "my-2", onClick: o, children: [
        a,
        /* @__PURE__ */ u(Fe, { IconSVG: Ia, className: "-rotate-90" })
      ] })
    ] }) : null
  ] }) })
);
t3.defaultProps = {
  profileImage: void 0,
  designation: void 0,
  ctaText: void 0,
  className: void 0,
  ctaCallback: void 0,
  avatarImageClassName: void 0,
  showUpdateButton: !1,
  onFileChange: () => {
  }
};
const dP = Y(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: "mb-3 grid grid-cols-[1fr_2fr] gap-2 px-8", children: e })), fP = Y(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: "inline-flex items-center text-sm text-font-secondary", children: e })), pP = Y(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: "inline-flex items-center text-sm", children: e }));
fP.displayName = "ProfileCardKey";
pP.displayName = "ProfileCardValue";
dP.displayName = "ProfileCardItem";
t3.displayName = "ProfileCard";
function hP(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function _1(e) {
  return hP(e) || Array.isArray(e);
}
function mP() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function cf(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), a = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== a ? !1 : n.every((i) => {
    const s = e[i], l = t[i];
    return typeof s == "function" ? `${s}` == `${l}` : !_1(s) || !_1(l) ? s === l : cf(s, l);
  });
}
function I1(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function gP(e, t) {
  if (e.length !== t.length)
    return !1;
  const n = I1(e), r = I1(t);
  return n.every((o, a) => {
    const i = r[a];
    return cf(o, i);
  });
}
function uf(e) {
  return typeof e == "number";
}
function tu(e) {
  return typeof e == "string";
}
function df(e) {
  return typeof e == "boolean";
}
function L1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function rt(e) {
  return Math.abs(e);
}
function ff(e) {
  return Math.sign(e);
}
function Zi(e, t) {
  return rt(e - t);
}
function vP(e, t) {
  if (e === 0 || t === 0 || rt(e) <= rt(t))
    return 0;
  const n = Zi(rt(e), rt(t));
  return rt(n / e);
}
function Ea(e) {
  return Ma(e).map(Number);
}
function mn(e) {
  return e[Ua(e)];
}
function Ua(e) {
  return Math.max(0, e.length - 1);
}
function pf(e, t) {
  return t === Ua(e);
}
function B1(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function Ma(e) {
  return Object.keys(e);
}
function n3(e, t) {
  return [e, t].reduce((n, r) => (Ma(r).forEach((o) => {
    const a = n[o], i = r[o], s = L1(a) && L1(i);
    n[o] = s ? n3(a, i) : i;
  }), n), {});
}
function r3(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function yP(e, t) {
  const n = {
    start: r,
    center: o,
    end: a
  };
  function r() {
    return 0;
  }
  function o(l) {
    return a(l) / 2;
  }
  function a(l) {
    return t - l;
  }
  function i(l, c) {
    return tu(e) ? n[e](l) : e(t, l, c);
  }
  return {
    measure: i
  };
}
function bP(e, t) {
  const n = e === "y" ? "y" : "x", r = e === "y" ? "x" : "y", o = s(), a = l();
  function i(d) {
    const {
      width: f,
      height: p
    } = d;
    return n === "x" ? f : p;
  }
  function s() {
    return n === "y" ? "top" : t === "rtl" ? "right" : "left";
  }
  function l() {
    return n === "y" ? "bottom" : t === "rtl" ? "left" : "right";
  }
  return {
    scroll: n,
    cross: r,
    startEdge: o,
    endEdge: a,
    measureSize: i
  };
}
function _r(e, t) {
  const n = rt(e - t);
  function r(c) {
    return c < e;
  }
  function o(c) {
    return c > t;
  }
  function a(c) {
    return r(c) || o(c);
  }
  function i(c) {
    return a(c) ? r(c) ? e : t : c;
  }
  function s(c) {
    return n ? c - n * Math.ceil((c - t) / n) : c;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: i,
    reachedAny: a,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function o3(e, t, n) {
  const {
    constrain: r
  } = _r(0, e), o = e + 1;
  let a = i(t);
  function i(p) {
    return n ? rt((o + p) % o) : r(p);
  }
  function s() {
    return a;
  }
  function l(p) {
    return a = i(p), f;
  }
  function c(p) {
    return d().set(s() + p);
  }
  function d() {
    return o3(e, s(), n);
  }
  const f = {
    get: s,
    set: l,
    add: c,
    clone: d
  };
  return f;
}
function xP(e) {
  const t = e === "rtl" ? -1 : 1;
  function n(o) {
    return o * t;
  }
  return {
    apply: n
  };
}
function $a() {
  let e = [];
  function t(o, a, i, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(a, i, s), l = () => o.removeEventListener(a, i, s);
    else {
      const c = o;
      c.addListener(i), l = () => c.removeListener(i);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function wP(e, t, n, r, o, a, i, s, l, c, d, f, p, m, h, g, x, y, b, v) {
  const {
    cross: A
  } = e, w = ["INPUT", "SELECT", "TEXTAREA"], M = {
    passive: !1
  }, $ = $a(), P = $a(), E = _r(50, 225).constrain(h.measure(20)), T = {
    mouse: 300,
    touch: 400
  }, B = {
    mouse: 500,
    touch: 600
  }, j = g ? 43 : 25;
  let V = !1, W = 0, S = 0, _ = !1, U = !1, z = !1, N = !1;
  function O(D) {
    if (!v)
      return;
    function ce(ye) {
      (df(v) || v(D, ye)) && oe(ye);
    }
    const he = n;
    $.add(he, "dragstart", (ye) => ye.preventDefault(), M).add(he, "touchmove", () => {
    }, M).add(he, "touchend", () => {
    }).add(he, "touchstart", ce).add(he, "mousedown", ce).add(he, "touchcancel", ie).add(he, "contextmenu", ie).add(he, "click", X, !0);
  }
  function k() {
    $.clear(), P.clear();
  }
  function Q() {
    const D = N ? r : n;
    P.add(D, "touchmove", ee, M).add(D, "touchend", ie).add(D, "mousemove", ee, M).add(D, "mouseup", ie);
  }
  function q(D) {
    const ce = D.nodeName || "";
    return w.includes(ce);
  }
  function re() {
    return (g ? B : T)[N ? "mouse" : "touch"];
  }
  function ae(D, ce) {
    const he = p.add(ff(D) * -1), ye = f.byDistance(D, !g).distance;
    return g || rt(D) < E ? ye : y && ce ? ye * 0.5 : f.byIndex(he.get(), 0).distance;
  }
  function oe(D) {
    const ce = r3(D, o);
    N = ce, !(ce && D.button !== 0) && (q(D.target) || (z = g && ce && !D.buttons && V, V = Zi(a.get(), s.get()) >= 2, _ = !0, i.pointerDown(D), d.useFriction(0).useDuration(0), a.set(s), Q(), W = i.readPoint(D), S = i.readPoint(D, A), m.emit("pointerDown")));
  }
  function ee(D) {
    const ce = i.readPoint(D), he = i.readPoint(D, A), ye = Zi(ce, W), Me = Zi(he, S);
    if (!U && !N && (!D.cancelable || (U = ye > Me, !U)))
      return ie(D);
    const Oe = i.pointerMove(D);
    ye > x && (z = !0), d.useFriction(0.3).useDuration(1), l.start(), a.add(t.apply(Oe)), D.preventDefault();
  }
  function ie(D) {
    const he = f.byDistance(0, !1).index !== p.get(), ye = i.pointerUp(D) * re(), Me = ae(t.apply(ye), he), Oe = vP(ye, Me), it = j - 10 * Oe, Qe = b + Oe / 50;
    U = !1, _ = !1, P.clear(), d.useDuration(it).useFriction(Qe), c.distance(Me, !g), N = !1, m.emit("pointerUp");
  }
  function X(D) {
    z && (D.stopPropagation(), D.preventDefault());
  }
  function J() {
    return _;
  }
  return {
    init: O,
    pointerDown: J,
    destroy: k
  };
}
function AP(e, t) {
  let r, o;
  function a(f) {
    return f.timeStamp;
  }
  function i(f, p) {
    const h = `client${(p || e.scroll) === "x" ? "X" : "Y"}`;
    return (r3(f, t) ? f : f.touches[0])[h];
  }
  function s(f) {
    return r = f, o = f, i(f);
  }
  function l(f) {
    const p = i(f) - i(o), m = a(f) - a(r) > 170;
    return o = f, m && (r = f), p;
  }
  function c(f) {
    if (!r || !o)
      return 0;
    const p = i(o) - i(r), m = a(f) - a(r), h = a(f) - a(o) > 170, g = p / m;
    return m && !h && rt(g) > 0.1 ? g : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: c,
    readPoint: i
  };
}
function CP() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: a,
      offsetHeight: i
    } = n;
    return {
      top: r,
      right: o + a,
      bottom: r + i,
      left: o,
      width: a,
      height: i
    };
  }
  return {
    measure: e
  };
}
function SP(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function EP(e, t, n, r, o, a, i) {
  let s, l, c = [], d = !1;
  function f(g) {
    return o.measureSize(i.measure(g));
  }
  function p(g) {
    if (!a)
      return;
    l = f(e), c = r.map(f);
    function x(b) {
      for (const v of b) {
        const A = v.target === e, w = r.indexOf(v.target), M = A ? l : c[w], $ = f(A ? e : r[w]);
        if (rt($ - M) >= 0.5) {
          n.requestAnimationFrame(() => {
            g.reInit(), t.emit("resize");
          });
          break;
        }
      }
    }
    s = new ResizeObserver((b) => {
      d || (df(a) || a(g, b)) && x(b);
    }), [e].concat(r).forEach((b) => s.observe(b));
  }
  function m() {
    s && s.disconnect(), d = !0;
  }
  return {
    init: p,
    destroy: m
  };
}
function MP(e, t, n, r, o) {
  let a = 0, i = 0, s = r, l = o, c = e.get(), d = 0;
  function f() {
    const w = n.get() - e.get(), M = !s;
    let $ = 0;
    return M ? (a = 0, e.set(n), $ = w) : (a += w / s, a *= l, c += a, e.add(a), $ = c - d), i = ff($), d = c, A;
  }
  function p() {
    const w = n.get() - t.get();
    return rt(w) < 1e-3;
  }
  function m() {
    return s;
  }
  function h() {
    return i;
  }
  function g() {
    return a;
  }
  function x() {
    return b(r);
  }
  function y() {
    return v(o);
  }
  function b(w) {
    return s = w, A;
  }
  function v(w) {
    return l = w, A;
  }
  const A = {
    direction: h,
    duration: m,
    velocity: g,
    seek: f,
    settled: p,
    useBaseFriction: y,
    useBaseDuration: x,
    useFriction: v,
    useDuration: b
  };
  return A;
}
function $P(e, t, n, r, o) {
  const a = o.measure(10), i = o.measure(50), s = _r(0.1, 0.99);
  let l = !1;
  function c() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function d(m) {
    if (!c())
      return;
    const h = e.reachedMin(t.get()) ? "min" : "max", g = rt(e[h] - t.get()), x = n.get() - t.get(), y = s.constrain(g / i);
    n.subtract(x * y), !m && rt(x) < a && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function f(m) {
    l = !m;
  }
  return {
    constrain: d,
    toggleActive: f
  };
}
function PP(e, t, n, r) {
  const o = _r(-t + e, 0), a = c(), i = l(), s = d();
  function l() {
    const p = a[0], m = mn(a), h = a.lastIndexOf(p), g = a.indexOf(m) + 1;
    return _r(h, g);
  }
  function c() {
    return n.map((p, m) => {
      const h = !m, g = pf(n, m);
      return h ? o.max : g ? o.min : o.constrain(p);
    }).map((p) => parseFloat(p.toFixed(3)));
  }
  function d() {
    if (t <= e)
      return [o.max];
    if (r === "keepSnaps")
      return a;
    const {
      min: p,
      max: m
    } = i;
    return a.slice(p, m);
  }
  return {
    snapsContained: s,
    scrollContainLimit: i
  };
}
function TP(e, t, n) {
  const r = t[0], o = n ? r - e : mn(t);
  return {
    limit: _r(o, r)
  };
}
function OP(e, t, n, r) {
  const a = t.min + 0.1, i = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = _r(a, i);
  function c(p) {
    return p === 1 ? l(n.get()) : p === -1 ? s(n.get()) : !1;
  }
  function d(p) {
    if (!c(p))
      return;
    const m = e * (p * -1);
    r.forEach((h) => h.add(m));
  }
  return {
    loop: d
  };
}
function NP(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(a) {
    const i = a - t;
    return n ? i / -n : 0;
  }
  return {
    get: r
  };
}
function kP(e, t, n, r, o) {
  const {
    startEdge: a,
    endEdge: i
  } = e, {
    groupSlides: s
  } = o, l = f().map(t.measure), c = p(), d = m();
  function f() {
    return s(r).map((g) => mn(g)[i] - g[0][a]).map(rt);
  }
  function p() {
    return r.map((g) => n[a] - g[a]).map((g) => -rt(g));
  }
  function m() {
    return s(c).map((g) => g[0]).map((g, x) => g + l[x]);
  }
  return {
    snaps: c,
    snapsAligned: d
  };
}
function DP(e, t, n, r, o, a, i) {
  const {
    groupSlides: s
  } = a, {
    min: l,
    max: c
  } = o, d = f();
  function f() {
    const m = s(i);
    return !n || r === "keepSnaps" || t <= e ? m : m.slice(l, c).map((g, x, y) => {
      const b = !x, v = pf(y, x);
      if (b) {
        const A = mn(y[0]) + 1;
        return B1(A);
      }
      if (v) {
        const A = Ua(i) - mn(y)[0] + 1;
        return B1(A, mn(y)[0]);
      }
      return g;
    });
  }
  return {
    slideRegistry: d
  };
}
function FP(e, t, n, r, o) {
  const {
    reachedAny: a,
    removeOffset: i,
    constrain: s
  } = r;
  function l(h) {
    return h.concat().sort((g, x) => rt(g) - rt(x))[0];
  }
  function c(h) {
    const g = e ? i(h) : s(h), x = t.map((b) => b - g).map((b) => d(b, 0)).map((b, v) => ({
      diff: b,
      index: v
    })).sort((b, v) => rt(b.diff) - rt(v.diff)), {
      index: y
    } = x[0];
    return {
      index: y,
      distance: g
    };
  }
  function d(h, g) {
    const x = [h, h + n, h - n];
    if (!e)
      return x[0];
    if (!g)
      return l(x);
    const y = x.filter((b) => ff(b) === g);
    return y.length ? l(y) : mn(x) - n;
  }
  function f(h, g) {
    const x = t[h] - o.get(), y = d(x, g);
    return {
      index: h,
      distance: y
    };
  }
  function p(h, g) {
    const x = o.get() + h, {
      index: y,
      distance: b
    } = c(x), v = !e && a(x);
    if (!g || v)
      return {
        index: y,
        distance: h
      };
    const A = t[y] - b, w = h + d(A, 0);
    return {
      index: y,
      distance: w
    };
  }
  return {
    byDistance: p,
    byIndex: f,
    shortcut: d
  };
}
function RP(e, t, n, r, o, a) {
  function i(d) {
    const f = d.distance, p = d.index !== t.get();
    o.add(f), f && e.start(), p && (n.set(t.get()), t.set(d.index), a.emit("select"));
  }
  function s(d, f) {
    const p = r.byDistance(d, f);
    i(p);
  }
  function l(d, f) {
    const p = t.clone().set(d), m = r.byIndex(p.get(), f);
    i(m);
  }
  return {
    distance: s,
    index: l
  };
}
function _P(e, t, n, r, o, a) {
  let i = 0;
  function s() {
    a.add(document, "keydown", l, !1), t.forEach(c);
  }
  function l(f) {
    f.code === "Tab" && (i = (/* @__PURE__ */ new Date()).getTime());
  }
  function c(f) {
    const p = () => {
      if ((/* @__PURE__ */ new Date()).getTime() - i > 10)
        return;
      e.scrollLeft = 0;
      const g = t.indexOf(f), x = n.findIndex((y) => y.includes(g));
      uf(x) && (o.useDuration(0), r.index(x, 0));
    };
    a.add(f, "focus", p, {
      passive: !0,
      capture: !0
    });
  }
  return {
    init: s
  };
}
function Ji(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = i(l);
  }
  function o(l) {
    t += i(l);
  }
  function a(l) {
    t -= i(l);
  }
  function i(l) {
    return uf(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: a
  };
}
function a3(e, t, n) {
  const r = e.scroll === "x" ? i : s, o = n.style;
  let a = !1;
  function i(p) {
    return `translate3d(${p}px,0px,0px)`;
  }
  function s(p) {
    return `translate3d(0px,${p}px,0px)`;
  }
  function l(p) {
    a || (o.transform = r(t.apply(p)));
  }
  function c(p) {
    a = !p;
  }
  function d() {
    a || (o.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: d,
    to: l,
    toggleActive: c
  };
}
function IP(e, t, n, r, o, a, i, s, l, c) {
  const f = Ea(a), p = Ea(a).reverse(), m = b().concat(v());
  function h(P, E) {
    return P.reduce((T, B) => T - a[B], E);
  }
  function g(P, E) {
    return P.reduce((T, B) => h(T, E) > 0 ? T.concat([B]) : T, []);
  }
  function x(P) {
    return i.map((E, T) => ({
      start: E - o[T] + 0.5 + P,
      end: E + n - 0.5 + P
    }));
  }
  function y(P, E, T) {
    const B = x(E);
    return P.map((j) => {
      const V = T ? 0 : -r, W = T ? r : 0, S = T ? "end" : "start", _ = B[j][S];
      return {
        index: j,
        loopPoint: _,
        slideLocation: Ji(-1),
        translate: a3(e, t, c[j]),
        target: () => l.get() > _ ? V : W
      };
    });
  }
  function b() {
    const P = s[0], E = g(p, P);
    return y(E, r, !1);
  }
  function v() {
    const P = n - s[0] - 1, E = g(f, P);
    return y(E, -r, !0);
  }
  function A() {
    return m.every(({
      index: P
    }) => {
      const E = f.filter((T) => T !== P);
      return h(E, n) <= 0.1;
    });
  }
  function w() {
    m.forEach((P) => {
      const {
        target: E,
        translate: T,
        slideLocation: B
      } = P, j = E();
      j !== B.get() && (T.to(j), B.set(j));
    });
  }
  function M() {
    m.forEach((P) => P.translate.clear());
  }
  return {
    canLoop: A,
    clear: M,
    loop: w,
    loopPoints: m
  };
}
function LP(e, t, n) {
  let r, o = !1;
  function a(l) {
    if (!n)
      return;
    function c(d) {
      for (const f of d)
        if (f.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((d) => {
      o || (df(n) || n(l, d)) && c(d);
    }), r.observe(e, {
      childList: !0
    });
  }
  function i() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: a,
    destroy: i
  };
}
function BP(e, t, n, r) {
  const o = {};
  let a = null, i = null, s, l = !1;
  function c() {
    s = new IntersectionObserver((h) => {
      l || (h.forEach((g) => {
        const x = t.indexOf(g.target);
        o[x] = g;
      }), a = null, i = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((h) => s.observe(h));
  }
  function d() {
    s && s.disconnect(), l = !0;
  }
  function f(h) {
    return Ma(o).reduce((g, x) => {
      const y = parseInt(x), {
        isIntersecting: b
      } = o[y];
      return (h && b || !h && !b) && g.push(y), g;
    }, []);
  }
  function p(h = !0) {
    if (h && a)
      return a;
    if (!h && i)
      return i;
    const g = f(h);
    return h && (a = g), h || (i = g), g;
  }
  return {
    init: c,
    destroy: d,
    get: p
  };
}
function zP(e, t, n, r, o, a) {
  const {
    measureSize: i,
    startEdge: s,
    endEdge: l
  } = e, c = n[0] && o, d = h(), f = g(), p = n.map(i), m = x();
  function h() {
    if (!c)
      return 0;
    const b = n[0];
    return rt(t[s] - b[s]);
  }
  function g() {
    if (!c)
      return 0;
    const b = a.getComputedStyle(mn(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function x() {
    return n.map((b, v, A) => {
      const w = !v, M = pf(A, v);
      return w ? p[v] + d : M ? p[v] + f : A[v + 1][s] - b[s];
    }).map(rt);
  }
  return {
    slideSizes: p,
    slideSizesWithGaps: m,
    startGap: d,
    endGap: f
  };
}
function WP(e, t, n, r, o, a, i, s, l) {
  const {
    startEdge: c,
    endEdge: d
  } = e, f = uf(r);
  function p(x, y) {
    return Ea(x).filter((b) => b % y === 0).map((b) => x.slice(b, b + y));
  }
  function m(x) {
    return x.length ? Ea(x).reduce((y, b) => {
      const v = mn(y) || 0, A = v === 0, w = b === Ua(x), M = a[c] - i[v][c], $ = a[c] - i[b][d], P = !o && A ? t.apply(s) : 0, E = !o && w ? t.apply(l) : 0;
      return rt($ - E - (M + P)) > n && y.push(b), w && y.push(x.length), y;
    }, []).map((y, b, v) => {
      const A = Math.max(v[b - 1] || 0);
      return x.slice(A, y);
    }) : [];
  }
  function h(x) {
    return f ? p(x, r) : m(x);
  }
  return {
    groupSlides: h
  };
}
function jP(e, t, n, r, o, a, i, s) {
  const {
    align: l,
    axis: c,
    direction: d,
    startIndex: f,
    loop: p,
    duration: m,
    dragFree: h,
    dragThreshold: g,
    inViewThreshold: x,
    slidesToScroll: y,
    skipSnaps: b,
    containScroll: v,
    watchResize: A,
    watchSlides: w,
    watchDrag: M
  } = a, $ = CP(), P = $.measure(t), E = n.map($.measure), T = xP(d), B = bP(c, d), j = B.measureSize(P), V = SP(j), W = yP(l, j), S = !p && !!v, _ = p || !!v, {
    slideSizes: U,
    slideSizesWithGaps: z,
    startGap: N,
    endGap: O
  } = zP(B, P, E, n, _, o), k = WP(B, T, j, y, p, P, E, N, O), {
    snaps: Q,
    snapsAligned: q
  } = kP(B, W, P, E, k), re = -mn(Q) + mn(z), {
    snapsContained: ae,
    scrollContainLimit: oe
  } = PP(j, re, q, v), ee = S ? ae : q, {
    limit: ie
  } = TP(re, ee, p), X = o3(Ua(ee), f, p), J = X.clone(), pe = Ea(n), D = ({
    dragHandler: ft,
    scrollBody: jt,
    scrollBounds: Vt,
    options: {
      loop: st
    }
  }) => {
    st || Vt.constrain(ft.pointerDown()), jt.seek();
  }, ce = ({
    scrollBody: ft,
    translate: jt,
    location: Vt,
    offsetLocation: st,
    scrollLooper: qn,
    slideLooper: Pe,
    dragHandler: ze,
    animation: qe,
    eventHandler: pt,
    options: {
      loop: ot
    }
  }, Ct) => {
    const xn = ft.velocity(), Kn = ft.settled();
    Kn && !ze.pointerDown() && (qe.stop(), pt.emit("settle")), Kn || pt.emit("scroll"), st.set(Vt.get() - xn + xn * Ct), ot && (qn.loop(ft.direction()), Pe.loop()), jt.to(st.get());
  }, he = {
    start: () => s.start(bt),
    stop: () => s.stop(bt),
    update: () => D(bt),
    render: (ft) => ce(bt, ft)
  }, ye = 0.68, Me = ee[X.get()], Oe = Ji(Me), it = Ji(Me), Qe = Ji(Me), yt = MP(Oe, it, Qe, m, ye), At = FP(p, ee, re, ie, Qe), It = RP(he, X, J, At, Qe, i), Be = NP(ie), bn = $a(), Wt = BP(t, n, i, x), {
    slideRegistry: an
  } = DP(j, re, S, v, oe, k, pe), dt = _P(e, n, an, It, yt, bn), bt = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: i,
    containerRect: P,
    slideRects: E,
    animation: he,
    axis: B,
    direction: T,
    dragHandler: wP(B, T, e, r, o, Qe, AP(B, o), Oe, he, It, yt, At, X, i, V, h, g, b, ye, M),
    eventStore: bn,
    percentOfView: V,
    index: X,
    indexPrevious: J,
    limit: ie,
    location: Oe,
    offsetLocation: it,
    options: a,
    resizeHandler: EP(t, i, o, n, B, A, $),
    scrollBody: yt,
    scrollBounds: $P(ie, Oe, Qe, yt, V),
    scrollLooper: OP(re, ie, it, [Oe, it, Qe]),
    scrollProgress: Be,
    scrollSnapList: ee.map(Be.get),
    scrollSnaps: ee,
    scrollTarget: At,
    scrollTo: It,
    slideLooper: IP(B, T, j, re, U, z, Q, ee, it, n),
    slideFocus: dt,
    slidesHandler: LP(t, i, w),
    slidesInView: Wt,
    slideIndexes: pe,
    slideRegistry: an,
    slidesToScroll: k,
    target: Qe,
    translate: a3(B, T, t)
  };
  return bt;
}
function VP(e) {
  const t = 16.666666666666668;
  let n = [], r = null, o = 0, a = 0;
  function i(f) {
    r || (r = f);
    const p = f - r;
    for (r = f, o += p; o >= t; )
      n.forEach(({
        animation: h
      }) => h.update()), o -= t;
    const m = rt(o / t);
    n.forEach(({
      animation: h
    }) => h.render(m)), a && e.requestAnimationFrame(i);
  }
  function s(f) {
    n.includes(f) || n.push(f), !a && (a = e.requestAnimationFrame(i));
  }
  function l(f) {
    n = n.filter((p) => p !== f), !n.length && (e.cancelAnimationFrame(a), r = null, o = 0, a = 0);
  }
  function c() {
    r = null, o = 0;
  }
  return {
    start: s,
    stop: l,
    reset: c,
    window: e
  };
}
function HP() {
  const e = {};
  let t;
  function n(l) {
    t = l;
  }
  function r(l) {
    return e[l] || [];
  }
  function o(l) {
    return r(l).forEach((c) => c(t, l)), s;
  }
  function a(l, c) {
    return e[l] = r(l).concat([c]), s;
  }
  function i(l, c) {
    return e[l] = r(l).filter((d) => d !== c), s;
  }
  const s = {
    init: n,
    emit: o,
    off: i,
    on: a
  };
  return s;
}
const UP = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0
};
function YP(e) {
  function t(a, i) {
    return n3(a, i || {});
  }
  function n(a) {
    const i = a.breakpoints || {}, s = Ma(i).filter((l) => e.matchMedia(l).matches).map((l) => i[l]).reduce((l, c) => t(l, c), {});
    return t(a, s);
  }
  function r(a) {
    return a.map((i) => Ma(i.breakpoints || {})).reduce((i, s) => i.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function GP(e) {
  let t = [];
  function n(a, i) {
    return t = i.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(a, e)), i.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Ao(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, a = YP(o), i = GP(a), s = $a(), l = $a(), c = HP(), {
    animationRealms: d
  } = Ao, {
    mergeOptions: f,
    optionsAtMedia: p,
    optionsMediaQueries: m
  } = a, {
    on: h,
    off: g,
    emit: x
  } = c, y = V;
  let b = !1, v, A = f(UP, Ao.globalOptions), w = f(A), M = [], $, P, E;
  function T() {
    const {
      container: ce,
      slides: he
    } = w;
    P = (tu(ce) ? e.querySelector(ce) : ce) || e.children[0];
    const Me = tu(he) ? P.querySelectorAll(he) : he;
    E = [].slice.call(Me || P.children);
  }
  function B(ce, he) {
    const ye = jP(e, P, E, r, o, ce, c, he);
    if (ce.loop && !ye.slideLooper.canLoop()) {
      const Me = Object.assign({}, ce, {
        loop: !1
      });
      return B(Me, he);
    }
    return ye;
  }
  function j(ce, he) {
    if (b)
      return;
    const ye = d.find((Oe) => Oe.window === o), Me = ye || VP(o);
    ye || d.push(Me), A = f(A, ce), w = p(A), M = he || M, T(), v = B(w, Me), m([A, ...M.map(({
      options: Oe
    }) => Oe)]).forEach((Oe) => s.add(Oe, "change", V)), w.active && (v.translate.to(v.location.get()), v.slidesInView.init(), v.slideFocus.init(), v.eventHandler.init(D), v.resizeHandler.init(D), v.slidesHandler.init(D), l.add(r, "visibilitychange", () => {
      r.hidden && Me.reset();
    }), v.options.loop && v.slideLooper.loop(), P.offsetParent && E.length && v.dragHandler.init(D), $ = i.init(D, M));
  }
  function V(ce, he) {
    const ye = q();
    W(), j(f({
      startIndex: ye
    }, ce), he), c.emit("reInit");
  }
  function W() {
    v.dragHandler.destroy(), v.animation.stop(), v.eventStore.clear(), v.translate.clear(), v.slideLooper.clear(), v.resizeHandler.destroy(), v.slidesHandler.destroy(), v.slidesInView.destroy(), i.destroy(), s.clear(), l.clear();
  }
  function S() {
    b || (b = !0, s.clear(), W(), c.emit("destroy"));
  }
  function _(ce, he, ye) {
    !w.active || b || (v.scrollBody.useBaseFriction().useDuration(he ? 0 : w.duration), v.scrollTo.index(ce, ye || 0));
  }
  function U(ce) {
    const he = v.index.add(1).get();
    _(he, ce === !0, -1);
  }
  function z(ce) {
    const he = v.index.add(-1).get();
    _(he, ce === !0, 1);
  }
  function N() {
    return v.index.add(1).get() !== q();
  }
  function O() {
    return v.index.add(-1).get() !== q();
  }
  function k() {
    return v.scrollSnapList;
  }
  function Q() {
    return v.scrollProgress.get(v.location.get());
  }
  function q() {
    return v.index.get();
  }
  function re() {
    return v.indexPrevious.get();
  }
  function ae() {
    return v.slidesInView.get();
  }
  function oe() {
    return v.slidesInView.get(!1);
  }
  function ee() {
    return $;
  }
  function ie() {
    return v;
  }
  function X() {
    return e;
  }
  function J() {
    return P;
  }
  function pe() {
    return E;
  }
  const D = {
    canScrollNext: N,
    canScrollPrev: O,
    containerNode: J,
    internalEngine: ie,
    destroy: S,
    off: g,
    on: h,
    emit: x,
    plugins: ee,
    previousScrollSnap: re,
    reInit: y,
    rootNode: X,
    scrollNext: U,
    scrollPrev: z,
    scrollProgress: Q,
    scrollSnapList: k,
    scrollTo: _,
    selectedScrollSnap: q,
    slideNodes: pe,
    slidesInView: ae,
    slidesNotInView: oe
  };
  return j(t, n), setTimeout(() => c.emit("init"), 0), D;
}
Ao.animationRealms = [];
Ao.globalOptions = void 0;
function hf(e = {}, t = []) {
  const n = de(e), r = de(t), [o, a] = we(), [i, s] = we(), l = me(() => {
    o && o.reInit(n.current, r.current);
  }, [o]);
  return Ce(() => {
    if (mP() && i) {
      Ao.globalOptions = hf.globalOptions;
      const c = Ao(i, n.current, r.current);
      return a(c), () => c.destroy();
    } else
      a(void 0);
  }, [i, a]), Ce(() => {
    cf(n.current, e) || (n.current = e, l());
  }, [e, l]), Ce(() => {
    gP(r.current, t) || (r.current = t, l());
  }, [t, l]), [s, o];
}
hf.globalOptions = void 0;
function kr() {
  return kr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kr.apply(this, arguments);
}
var XP = 0.996, qP = function(t, n) {
  return n === void 0 && (n = XP), t * n / (1 - n);
};
function KP(e) {
  return e[e.length - 1];
}
function QP(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var ZP = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function Kl(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function z1(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Co(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Co(t);
  }), e;
}
function JP() {
  var e = {};
  function t(o, a) {
    return e[o] = (e[o] || []).concat(a), function() {
      return n(o, a);
    };
  }
  function n(o, a) {
    e[o] = (e[o] || []).filter(function(i) {
      return i !== a;
    });
  }
  function r(o, a) {
    o in e && e[o].forEach(function(i) {
      return i(a);
    });
  }
  return Co({
    on: t,
    off: n,
    dispatch: r
  });
}
function eT(e) {
  var t = [], n = function(i) {
    return i.addEventListener("wheel", e, {
      passive: !1
    }), t.push(i), function() {
      return r(i);
    };
  }, r = function(i) {
    i.removeEventListener("wheel", e), t = t.filter(function(s) {
      return s !== i;
    });
  }, o = function() {
    t.forEach(r);
  };
  return Co({
    observe: n,
    unobserve: r,
    disconnect: o
  });
}
var tT = 16 * 1.125, nT = typeof window < "u" && window.innerHeight || 800, Ql = [1, tT, nT];
function rT(e) {
  var t = e.deltaX * Ql[e.deltaMode], n = e.deltaY * Ql[e.deltaMode], r = (e.deltaZ || 0) * Ql[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var oT = [-1, -1, -1];
function aT(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? oT : t.map(function(r) {
    return r ? -1 : 1;
  });
  return kr({}, e, {
    axisDelta: e.axisDelta.map(function(r, o) {
      return r * n[o];
    })
  });
}
var W1 = 700, iT = function(t) {
  return kr({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return ZP(n, -W1, W1);
    })
  });
}, Zl = process.env.NODE_ENV !== "production", sT = 0.6, lT = 0.96, cT = 2, j1 = 5, V1 = /* @__PURE__ */ Co({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), uT = 400;
function H1() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: uT
  };
}
function dT(e) {
  e === void 0 && (e = {});
  var t = JP(), n = t.on, r = t.off, o = t.dispatch, a = V1, i = H1(), s, l = !1, c, d = function(W) {
    Array.isArray(W) ? W.forEach(function(S) {
      return h(S);
    }) : h(W);
  }, f = function(W) {
    return W === void 0 && (W = {}), Object.values(W).some(function(S) {
      return S == null;
    }) ? (Zl && console.error("updateOptions ignored! undefined & null options not allowed"), a) : a = Co(kr({}, V1, a, W));
  }, p = function(W) {
    var S = kr({
      event: s,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: i.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: i.axisVelocity,
      axisMovement: i.axisMovement,
      get axisMovementProjection() {
        return Kl(S.axisMovement, S.axisVelocity.map(function(_) {
          return qP(_);
        }));
      }
    }, W);
    o("wheel", kr({}, S, {
      previous: c
    })), c = S;
  }, m = function(W, S) {
    var _ = a, U = _.preventWheelAction, z = S[0], N = S[1], O = S[2];
    if (typeof U == "boolean")
      return U;
    switch (U) {
      case "x":
        return Math.abs(z) >= W;
      case "y":
        return Math.abs(N) >= W;
      case "z":
        return Math.abs(O) >= W;
      default:
        return Zl && console.warn("unsupported preventWheelAction value: " + U, "warn"), !1;
    }
  }, h = function(W) {
    var S = iT(aT(rT(W), a.reverseSign)), _ = S.axisDelta, U = S.timeStamp, z = z1(_);
    if (W.preventDefault && m(z, _) && W.preventDefault(), i.isStarted ? i.isMomentum && z > Math.max(2, i.lastAbsDelta * 2) && (P(!0), M()) : M(), z === 0 && Object.is && Object.is(W.deltaX, -0)) {
      l = !0;
      return;
    }
    s = W, i.axisMovement = Kl(i.axisMovement, _), i.lastAbsDelta = z, i.scrollPointsToMerge.push({
      axisDelta: _,
      timeStamp: U
    }), g(), p({
      axisDelta: _,
      isStart: !i.isStartPublished
    }), i.isStartPublished = !0, $();
  }, g = function() {
    i.scrollPointsToMerge.length === cT ? (i.scrollPoints.unshift({
      axisDeltaSum: i.scrollPointsToMerge.map(function(W) {
        return W.axisDelta;
      }).reduce(Kl),
      timeStamp: QP(i.scrollPointsToMerge.map(function(W) {
        return W.timeStamp;
      }))
    }), y(), i.scrollPointsToMerge.length = 0, i.scrollPoints.length = 1, i.isMomentum || A()) : i.isStartPublished || x();
  }, x = function() {
    i.axisVelocity = KP(i.scrollPointsToMerge).axisDelta.map(function(W) {
      return W / i.willEndTimeout;
    });
  }, y = function() {
    var W = i.scrollPoints, S = W[0], _ = W[1];
    if (!(!_ || !S)) {
      var U = S.timeStamp - _.timeStamp;
      if (U <= 0) {
        Zl && console.warn("invalid deltaTime");
        return;
      }
      var z = S.axisDeltaSum.map(function(O) {
        return O / U;
      }), N = z.map(function(O, k) {
        return O / (i.axisVelocity[k] || 1);
      });
      i.axisVelocity = z, i.accelerationFactors.push(N), b(U);
    }
  }, b = function(W) {
    var S = Math.ceil(W / 10) * 10 * 1.2;
    i.isMomentum || (S = Math.max(100, S * 2)), i.willEndTimeout = Math.min(1e3, Math.round(S));
  }, v = function(W) {
    return W === 0 ? !0 : W <= lT && W >= sT;
  }, A = function() {
    if (i.accelerationFactors.length >= j1) {
      if (l && (l = !1, z1(i.axisVelocity) >= 0.2)) {
        w();
        return;
      }
      var W = i.accelerationFactors.slice(j1 * -1), S = W.every(function(_) {
        var U = !!_.reduce(function(N, O) {
          return N && N < 1 && N === O ? 1 : 0;
        }), z = _.filter(v).length === _.length;
        return U || z;
      });
      S && w(), i.accelerationFactors = W;
    }
  }, w = function() {
    i.isMomentum = !0;
  }, M = function() {
    i = H1(), i.isStarted = !0, i.startTime = Date.now(), c = void 0, l = !1;
  }, $ = function() {
    var V;
    return function() {
      clearTimeout(V), V = setTimeout(P, i.willEndTimeout);
    };
  }(), P = function(W) {
    W === void 0 && (W = !1), i.isStarted && (i.isMomentum && W ? p({
      isEnding: !0,
      isMomentumCancel: !0
    }) : p({
      isEnding: !0
    }), i.isMomentum = !1, i.isStarted = !1);
  }, E = eT(d), T = E.observe, B = E.unobserve, j = E.disconnect;
  return f(e), Co({
    on: n,
    off: r,
    observe: T,
    unobserve: B,
    disconnect: j,
    feedWheel: d,
    updateOptions: f
  });
}
var fT = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
mf.globalOptions = void 0;
var pT = process.env.NODE_ENV !== "production";
function mf(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(a, i) {
    var s, l, c = i.mergeOptions, d = i.optionsAtMedia, f = c(fT, mf.globalOptions), p = c(f, e);
    t = d(p);
    var m = a.internalEngine(), h = (s = t.target) != null ? s : a.containerNode().parentNode, g = (l = t.forceWheelAxis) != null ? l : m.options.axis, x = dT({
      preventWheelAction: g,
      reverseSign: [!0, !0, !1]
    }), y = x.observe(h), b = x.on("wheel", j), v = !1, A;
    function w(V) {
      try {
        A = new MouseEvent("mousedown", V.event), B(A);
      } catch {
        return pT && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      v = !0, $(), t.wheelDraggingClass && h.classList.add(t.wheelDraggingClass);
    }
    function M(V) {
      v = !1, B(T("mouseup", V)), P(), t.wheelDraggingClass && h.classList.remove(t.wheelDraggingClass);
    }
    function $() {
      document.documentElement.addEventListener("mousemove", E, !0), document.documentElement.addEventListener("mouseup", E, !0), document.documentElement.addEventListener("mousedown", E, !0);
    }
    function P() {
      document.documentElement.removeEventListener("mousemove", E, !0), document.documentElement.removeEventListener("mouseup", E, !0), document.documentElement.removeEventListener("mousedown", E, !0);
    }
    function E(V) {
      v && V.isTrusted && V.stopImmediatePropagation();
    }
    function T(V, W) {
      var S, _;
      if (g === m.options.axis) {
        var U = W.axisMovement;
        S = U[0], _ = U[1];
      } else {
        var z = W.axisMovement;
        _ = z[0], S = z[1];
      }
      return new MouseEvent(V, {
        clientX: A.clientX + S,
        clientY: A.clientY + _,
        screenX: A.screenX + S,
        screenY: A.screenY + _,
        movementX: S,
        movementY: _,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function B(V) {
      a.containerNode().dispatchEvent(V);
    }
    function j(V) {
      var W = V.axisDelta, S = W[0], _ = W[1], U = g === "x" ? S : _, z = g === "x" ? _ : S, N = V.isMomentum && V.previous && !V.previous.isMomentum, O = V.isEnding && !V.isMomentum || N, k = Math.abs(U) > Math.abs(z);
      k && !v && !V.isMomentum && w(V), v && (O ? M(V) : B(T("mousemove", V)));
    }
    n = function() {
      y(), b(), P();
    };
  }
  var o = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return o;
}
const i3 = tn({}), hT = (e) => {
  const [t, n] = we(!0), [r, o] = we(!0), a = me(() => {
    e && e.scrollPrev();
  }, [e]), i = me(() => {
    e && e.scrollNext();
  }, [e]), s = me((l) => {
    n(!l.canScrollPrev()), o(!l.canScrollNext());
  }, []);
  return Ce(() => {
    e && (s(e), e.on("reInit", s), e.on("select", s));
  }, [e, s]), {
    prevBtnDisabled: t,
    nextBtnDisabled: r,
    onPrevButtonClick: a,
    onNextButtonClick: i
  };
};
function mT({ children: e, options: t }) {
  const [n, r] = hf({ align: "center", dragFree: !0, ...t }, [
    mf()
  ]), { prevBtnDisabled: o, nextBtnDisabled: a, onPrevButtonClick: i, onNextButtonClick: s } = hT(r), l = Se(() => ({
    emblaRef: n,
    emblaApi: r,
    prevBtnDisabled: o,
    nextBtnDisabled: a,
    onPrevButtonClick: i,
    onNextButtonClick: s
  }), [n, r, o, a, i, s]);
  return /* @__PURE__ */ u(i3.Provider, { value: l, children: e });
}
const gf = () => Xe(i3);
function oU({ children: e, ...t }) {
  return /* @__PURE__ */ u(mT, { options: t, children: e });
}
function aU({ children: e, prevButton: t, nextButton: n, className: r }) {
  const { emblaRef: o } = gf();
  return /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ I("div", { className: "relative", children: [
    /* @__PURE__ */ u("div", { className: "overflow-hidden", ref: o, children: /* @__PURE__ */ u("div", { className: le("flex touch-pan-y gap-3", r), children: e }) }),
    /* @__PURE__ */ u("div", { className: "absolute top-1/2 flex h-full -translate-y-1/2", children: t }),
    /* @__PURE__ */ u("div", { className: "absolute right-0 top-1/2 flex h-full -translate-y-1/2", children: n })
  ] }) });
}
function iU({
  children: e = /* @__PURE__ */ u(Fe, { IconSVG: Tb }),
  className: t,
  containerClassName: n,
  ...r
}) {
  const { prevBtnDisabled: o, onPrevButtonClick: a } = gf();
  return o ? /* @__PURE__ */ u("span", {}) : /* @__PURE__ */ u(
    "div",
    {
      className: le("w-[100px] flex items-center justify-start pl-2 bg-gradient-to-r from-white", n),
      children: /* @__PURE__ */ u(
        nn,
        {
          size: "icon",
          variant: "text",
          className: le("bg-transparent", t),
          onClick: a,
          ...r,
          children: e
        }
      )
    }
  );
}
function sU({
  children: e = /* @__PURE__ */ u(Fe, { IconSVG: kb }),
  className: t,
  containerClassName: n,
  ...r
}) {
  const { nextBtnDisabled: o, onNextButtonClick: a } = gf();
  return o ? /* @__PURE__ */ u("span", {}) : /* @__PURE__ */ u("div", { className: le("w-[100px] flex items-center justify-end pr-2 bg-gradient-to-l from-white", n), children: /* @__PURE__ */ u(
    nn,
    {
      size: "icon",
      variant: "text",
      className: le("bg-transparent", t),
      onClick: a,
      ...r,
      children: e
    }
  ) });
}
function gT(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function vs(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function So(e) {
  return e = vs(Math.abs(e)), e ? e[1] : NaN;
}
function vT(e, t) {
  return function(n, r) {
    for (var o = n.length, a = [], i = 0, s = e[0], l = 0; o > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), a.push(n.substring(o -= s, o + s)), !((l += s + 1) > r)); )
      s = e[i = (i + 1) % e.length];
    return a.reverse().join(t);
  };
}
function yT(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var bT = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Pa(e) {
  if (!(t = bT.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new vf({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Pa.prototype = vf.prototype;
function vf(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
vf.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function xT(e) {
  e:
    for (var t = e.length, n = 1, r = -1, o; n < t; ++n)
      switch (e[n]) {
        case ".":
          r = o = n;
          break;
        case "0":
          r === 0 && (r = n), o = n;
          break;
        default:
          if (!+e[n])
            break e;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? e.slice(0, r) + e.slice(o + 1) : e;
}
var s3;
function wT(e, t) {
  var n = vs(e, t);
  if (!n)
    return e + "";
  var r = n[0], o = n[1], a = o - (s3 = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, i = r.length;
  return a === i ? r : a > i ? r + new Array(a - i + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + vs(e, Math.max(0, t + a - 1))[0];
}
function U1(e, t) {
  var n = vs(e, t);
  if (!n)
    return e + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const Y1 = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: gT,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => U1(e * 100, t),
  r: U1,
  s: wT,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function G1(e) {
  return e;
}
var X1 = Array.prototype.map, q1 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function AT(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? G1 : vT(X1.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? G1 : yT(X1.call(e.numerals, String)), i = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f) {
    f = Pa(f);
    var p = f.fill, m = f.align, h = f.sign, g = f.symbol, x = f.zero, y = f.width, b = f.comma, v = f.precision, A = f.trim, w = f.type;
    w === "n" ? (b = !0, w = "g") : Y1[w] || (v === void 0 && (v = 12), A = !0, w = "g"), (x || p === "0" && m === "=") && (x = !0, p = "0", m = "=");
    var M = g === "$" ? n : g === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", $ = g === "$" ? r : /[%p]/.test(w) ? i : "", P = Y1[w], E = /[defgprs%]/.test(w);
    v = v === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function T(B) {
      var j = M, V = $, W, S, _;
      if (w === "c")
        V = P(B) + V, B = "";
      else {
        B = +B;
        var U = B < 0 || 1 / B < 0;
        if (B = isNaN(B) ? l : P(Math.abs(B), v), A && (B = xT(B)), U && +B == 0 && h !== "+" && (U = !1), j = (U ? h === "(" ? h : s : h === "-" || h === "(" ? "" : h) + j, V = (w === "s" ? q1[8 + s3 / 3] : "") + V + (U && h === "(" ? ")" : ""), E) {
          for (W = -1, S = B.length; ++W < S; )
            if (_ = B.charCodeAt(W), 48 > _ || _ > 57) {
              V = (_ === 46 ? o + B.slice(W + 1) : B.slice(W)) + V, B = B.slice(0, W);
              break;
            }
        }
      }
      b && !x && (B = t(B, 1 / 0));
      var z = j.length + B.length + V.length, N = z < y ? new Array(y - z + 1).join(p) : "";
      switch (b && x && (B = t(N + B, N.length ? y - V.length : 1 / 0), N = ""), m) {
        case "<":
          B = j + B + V + N;
          break;
        case "=":
          B = j + N + B + V;
          break;
        case "^":
          B = N.slice(0, z = N.length >> 1) + j + B + V + N.slice(z);
          break;
        default:
          B = N + j + B + V;
          break;
      }
      return a(B);
    }
    return T.toString = function() {
      return f + "";
    }, T;
  }
  function d(f, p) {
    var m = c((f = Pa(f), f.type = "f", f)), h = Math.max(-8, Math.min(8, Math.floor(So(p) / 3))) * 3, g = Math.pow(10, -h), x = q1[8 + h / 3];
    return function(y) {
      return m(g * y) + x;
    };
  }
  return {
    format: c,
    formatPrefix: d
  };
}
var Oi, Jt, l3;
CT({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function CT(e) {
  return Oi = AT(e), Jt = Oi.format, l3 = Oi.formatPrefix, Oi;
}
function ST(e) {
  return Math.max(0, -So(Math.abs(e)));
}
function ET(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(So(t) / 3))) * 3 - So(Math.abs(e)));
}
function MT(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, So(t) - So(e)) + 1;
}
var nu = { exports: {} }, Ni = { exports: {} }, He = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var K1;
function $T() {
  if (K1)
    return He;
  K1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function v(w) {
    if (typeof w == "object" && w !== null) {
      var M = w.$$typeof;
      switch (M) {
        case t:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case a:
            case o:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case d:
                case h:
                case m:
                case i:
                  return w;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function A(w) {
    return v(w) === c;
  }
  return He.AsyncMode = l, He.ConcurrentMode = c, He.ContextConsumer = s, He.ContextProvider = i, He.Element = t, He.ForwardRef = d, He.Fragment = r, He.Lazy = h, He.Memo = m, He.Portal = n, He.Profiler = a, He.StrictMode = o, He.Suspense = f, He.isAsyncMode = function(w) {
    return A(w) || v(w) === l;
  }, He.isConcurrentMode = A, He.isContextConsumer = function(w) {
    return v(w) === s;
  }, He.isContextProvider = function(w) {
    return v(w) === i;
  }, He.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, He.isForwardRef = function(w) {
    return v(w) === d;
  }, He.isFragment = function(w) {
    return v(w) === r;
  }, He.isLazy = function(w) {
    return v(w) === h;
  }, He.isMemo = function(w) {
    return v(w) === m;
  }, He.isPortal = function(w) {
    return v(w) === n;
  }, He.isProfiler = function(w) {
    return v(w) === a;
  }, He.isStrictMode = function(w) {
    return v(w) === o;
  }, He.isSuspense = function(w) {
    return v(w) === f;
  }, He.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === a || w === o || w === f || w === p || typeof w == "object" && w !== null && (w.$$typeof === h || w.$$typeof === m || w.$$typeof === i || w.$$typeof === s || w.$$typeof === d || w.$$typeof === x || w.$$typeof === y || w.$$typeof === b || w.$$typeof === g);
  }, He.typeOf = v, He;
}
var Ue = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Q1;
function PT() {
  return Q1 || (Q1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function v(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === r || D === c || D === a || D === o || D === f || D === p || typeof D == "object" && D !== null && (D.$$typeof === h || D.$$typeof === m || D.$$typeof === i || D.$$typeof === s || D.$$typeof === d || D.$$typeof === x || D.$$typeof === y || D.$$typeof === b || D.$$typeof === g);
    }
    function A(D) {
      if (typeof D == "object" && D !== null) {
        var ce = D.$$typeof;
        switch (ce) {
          case t:
            var he = D.type;
            switch (he) {
              case l:
              case c:
              case r:
              case a:
              case o:
              case f:
                return he;
              default:
                var ye = he && he.$$typeof;
                switch (ye) {
                  case s:
                  case d:
                  case h:
                  case m:
                  case i:
                    return ye;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var w = l, M = c, $ = s, P = i, E = t, T = d, B = r, j = h, V = m, W = n, S = a, _ = o, U = f, z = !1;
    function N(D) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(D) || A(D) === l;
    }
    function O(D) {
      return A(D) === c;
    }
    function k(D) {
      return A(D) === s;
    }
    function Q(D) {
      return A(D) === i;
    }
    function q(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function re(D) {
      return A(D) === d;
    }
    function ae(D) {
      return A(D) === r;
    }
    function oe(D) {
      return A(D) === h;
    }
    function ee(D) {
      return A(D) === m;
    }
    function ie(D) {
      return A(D) === n;
    }
    function X(D) {
      return A(D) === a;
    }
    function J(D) {
      return A(D) === o;
    }
    function pe(D) {
      return A(D) === f;
    }
    Ue.AsyncMode = w, Ue.ConcurrentMode = M, Ue.ContextConsumer = $, Ue.ContextProvider = P, Ue.Element = E, Ue.ForwardRef = T, Ue.Fragment = B, Ue.Lazy = j, Ue.Memo = V, Ue.Portal = W, Ue.Profiler = S, Ue.StrictMode = _, Ue.Suspense = U, Ue.isAsyncMode = N, Ue.isConcurrentMode = O, Ue.isContextConsumer = k, Ue.isContextProvider = Q, Ue.isElement = q, Ue.isForwardRef = re, Ue.isFragment = ae, Ue.isLazy = oe, Ue.isMemo = ee, Ue.isPortal = ie, Ue.isProfiler = X, Ue.isStrictMode = J, Ue.isSuspense = pe, Ue.isValidElementType = v, Ue.typeOf = A;
  }()), Ue;
}
var Z1;
function c3() {
  return Z1 || (Z1 = 1, process.env.NODE_ENV === "production" ? Ni.exports = $T() : Ni.exports = PT()), Ni.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Jl, J1;
function TT() {
  if (J1)
    return Jl;
  J1 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(d) {
        return i[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Jl = o() ? Object.assign : function(a, i) {
    for (var s, l = r(a), c, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          n.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, Jl;
}
var ec, ep;
function yf() {
  if (ep)
    return ec;
  ep = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ec = e, ec;
}
var tc, tp;
function u3() {
  return tp || (tp = 1, tc = Function.call.bind(Object.prototype.hasOwnProperty)), tc;
}
var nc, np;
function OT() {
  if (np)
    return nc;
  np = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = yf(), n = {}, r = u3();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (r(a, d)) {
          var f;
          try {
            if (typeof a[d] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = a[d](i, d, l, s, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + s + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, nc = o, nc;
}
var rc, rp;
function NT() {
  if (rp)
    return rc;
  rp = 1;
  var e = c3(), t = TT(), n = yf(), r = u3(), o = OT(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return rc = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(O) {
      var k = O && (c && O[c] || O[d]);
      if (typeof k == "function")
        return k;
    }
    var p = "<<anonymous>>", m = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: b(),
      arrayOf: v,
      element: A(),
      elementType: w(),
      instanceOf: M,
      node: T(),
      objectOf: P,
      oneOf: $,
      oneOfType: E,
      shape: j,
      exact: V
    };
    function h(O, k) {
      return O === k ? O !== 0 || 1 / O === 1 / k : O !== O && k !== k;
    }
    function g(O, k) {
      this.message = O, this.data = k && typeof k == "object" ? k : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function x(O) {
      if (process.env.NODE_ENV !== "production")
        var k = {}, Q = 0;
      function q(ae, oe, ee, ie, X, J, pe) {
        if (ie = ie || p, J = J || ee, pe !== n) {
          if (l) {
            var D = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D.name = "Invariant Violation", D;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = ie + ":" + ee;
            !k[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + J + "` prop on `" + ie + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), k[ce] = !0, Q++);
          }
        }
        return oe[ee] == null ? ae ? oe[ee] === null ? new g("The " + X + " `" + J + "` is marked as required " + ("in `" + ie + "`, but its value is `null`.")) : new g("The " + X + " `" + J + "` is marked as required in " + ("`" + ie + "`, but its value is `undefined`.")) : null : O(oe, ee, ie, X, J);
      }
      var re = q.bind(null, !1);
      return re.isRequired = q.bind(null, !0), re;
    }
    function y(O) {
      function k(Q, q, re, ae, oe, ee) {
        var ie = Q[q], X = _(ie);
        if (X !== O) {
          var J = U(ie);
          return new g(
            "Invalid " + ae + " `" + oe + "` of type " + ("`" + J + "` supplied to `" + re + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return x(k);
    }
    function b() {
      return x(i);
    }
    function v(O) {
      function k(Q, q, re, ae, oe) {
        if (typeof O != "function")
          return new g("Property `" + oe + "` of component `" + re + "` has invalid PropType notation inside arrayOf.");
        var ee = Q[q];
        if (!Array.isArray(ee)) {
          var ie = _(ee);
          return new g("Invalid " + ae + " `" + oe + "` of type " + ("`" + ie + "` supplied to `" + re + "`, expected an array."));
        }
        for (var X = 0; X < ee.length; X++) {
          var J = O(ee, X, re, ae, oe + "[" + X + "]", n);
          if (J instanceof Error)
            return J;
        }
        return null;
      }
      return x(k);
    }
    function A() {
      function O(k, Q, q, re, ae) {
        var oe = k[Q];
        if (!s(oe)) {
          var ee = _(oe);
          return new g("Invalid " + re + " `" + ae + "` of type " + ("`" + ee + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return x(O);
    }
    function w() {
      function O(k, Q, q, re, ae) {
        var oe = k[Q];
        if (!e.isValidElementType(oe)) {
          var ee = _(oe);
          return new g("Invalid " + re + " `" + ae + "` of type " + ("`" + ee + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return x(O);
    }
    function M(O) {
      function k(Q, q, re, ae, oe) {
        if (!(Q[q] instanceof O)) {
          var ee = O.name || p, ie = N(Q[q]);
          return new g("Invalid " + ae + " `" + oe + "` of type " + ("`" + ie + "` supplied to `" + re + "`, expected ") + ("instance of `" + ee + "`."));
        }
        return null;
      }
      return x(k);
    }
    function $(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function k(Q, q, re, ae, oe) {
        for (var ee = Q[q], ie = 0; ie < O.length; ie++)
          if (h(ee, O[ie]))
            return null;
        var X = JSON.stringify(O, function(pe, D) {
          var ce = U(D);
          return ce === "symbol" ? String(D) : D;
        });
        return new g("Invalid " + ae + " `" + oe + "` of value `" + String(ee) + "` " + ("supplied to `" + re + "`, expected one of " + X + "."));
      }
      return x(k);
    }
    function P(O) {
      function k(Q, q, re, ae, oe) {
        if (typeof O != "function")
          return new g("Property `" + oe + "` of component `" + re + "` has invalid PropType notation inside objectOf.");
        var ee = Q[q], ie = _(ee);
        if (ie !== "object")
          return new g("Invalid " + ae + " `" + oe + "` of type " + ("`" + ie + "` supplied to `" + re + "`, expected an object."));
        for (var X in ee)
          if (r(ee, X)) {
            var J = O(ee, X, re, ae, oe + "." + X, n);
            if (J instanceof Error)
              return J;
          }
        return null;
      }
      return x(k);
    }
    function E(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var k = 0; k < O.length; k++) {
        var Q = O[k];
        if (typeof Q != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + z(Q) + " at index " + k + "."
          ), i;
      }
      function q(re, ae, oe, ee, ie) {
        for (var X = [], J = 0; J < O.length; J++) {
          var pe = O[J], D = pe(re, ae, oe, ee, ie, n);
          if (D == null)
            return null;
          D.data && r(D.data, "expectedType") && X.push(D.data.expectedType);
        }
        var ce = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new g("Invalid " + ee + " `" + ie + "` supplied to " + ("`" + oe + "`" + ce + "."));
      }
      return x(q);
    }
    function T() {
      function O(k, Q, q, re, ae) {
        return W(k[Q]) ? null : new g("Invalid " + re + " `" + ae + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return x(O);
    }
    function B(O, k, Q, q, re) {
      return new g(
        (O || "React class") + ": " + k + " type `" + Q + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + re + "`."
      );
    }
    function j(O) {
      function k(Q, q, re, ae, oe) {
        var ee = Q[q], ie = _(ee);
        if (ie !== "object")
          return new g("Invalid " + ae + " `" + oe + "` of type `" + ie + "` " + ("supplied to `" + re + "`, expected `object`."));
        for (var X in O) {
          var J = O[X];
          if (typeof J != "function")
            return B(re, ae, oe, X, U(J));
          var pe = J(ee, X, re, ae, oe + "." + X, n);
          if (pe)
            return pe;
        }
        return null;
      }
      return x(k);
    }
    function V(O) {
      function k(Q, q, re, ae, oe) {
        var ee = Q[q], ie = _(ee);
        if (ie !== "object")
          return new g("Invalid " + ae + " `" + oe + "` of type `" + ie + "` " + ("supplied to `" + re + "`, expected `object`."));
        var X = t({}, Q[q], O);
        for (var J in X) {
          var pe = O[J];
          if (r(O, J) && typeof pe != "function")
            return B(re, ae, oe, J, U(pe));
          if (!pe)
            return new g(
              "Invalid " + ae + " `" + oe + "` key `" + J + "` supplied to `" + re + "`.\nBad object: " + JSON.stringify(Q[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var D = pe(ee, J, re, ae, oe + "." + J, n);
          if (D)
            return D;
        }
        return null;
      }
      return x(k);
    }
    function W(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every(W);
          if (O === null || s(O))
            return !0;
          var k = f(O);
          if (k) {
            var Q = k.call(O), q;
            if (k !== O.entries) {
              for (; !(q = Q.next()).done; )
                if (!W(q.value))
                  return !1;
            } else
              for (; !(q = Q.next()).done; ) {
                var re = q.value;
                if (re && !W(re[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function S(O, k) {
      return O === "symbol" ? !0 : k ? k["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && k instanceof Symbol : !1;
    }
    function _(O) {
      var k = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : S(k, O) ? "symbol" : k;
    }
    function U(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var k = _(O);
      if (k === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return k;
    }
    function z(O) {
      var k = U(O);
      switch (k) {
        case "array":
        case "object":
          return "an " + k;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + k;
        default:
          return k;
      }
    }
    function N(O) {
      return !O.constructor || !O.constructor.name ? p : O.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, rc;
}
var oc, op;
function kT() {
  if (op)
    return oc;
  op = 1;
  var e = yf();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, oc = function() {
    function r(i, s, l, c, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, oc;
}
if (process.env.NODE_ENV !== "production") {
  var DT = c3(), FT = !0;
  nu.exports = NT()(DT.isElement, FT);
} else
  nu.exports = kT()();
var hl = nu.exports;
const se = /* @__PURE__ */ Do(hl);
var d3 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], o = 0; o < arguments.length; o++) {
        var a = arguments[o];
        if (a) {
          var i = typeof a;
          if (i === "string" || i === "number")
            r.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var s = n.apply(null, a);
              s && r.push(s);
            }
          } else if (i === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              r.push(a.toString());
              continue;
            }
            for (var l in a)
              t.call(a, l) && a[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(d3);
var ml = d3.exports;
const $t = /* @__PURE__ */ Do(ml);
var RT = ["top", "left", "transform", "className", "children", "innerRef"];
function ru() {
  return ru = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ru.apply(this, arguments);
}
function _T(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Tn(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, o = r === void 0 ? 0 : r, a = e.transform, i = e.className, s = e.children, l = e.innerRef, c = _T(e, RT);
  return /* @__PURE__ */ R.createElement("g", ru({
    ref: l,
    className: $t("visx-group", i),
    transform: a || "translate(" + o + ", " + n + ")"
  }, c), s);
}
Tn.propTypes = {
  top: se.number,
  left: se.number,
  transform: se.string,
  className: se.string,
  children: se.node,
  innerRef: se.oneOfType([se.string, se.func, se.object])
};
const IT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Group: Tn
}, Symbol.toStringTag, { value: "Module" }));
function f3(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, o = r === void 0 ? 0 : r, a = e.className, i = e.children;
  return /* @__PURE__ */ R.createElement(Tn, {
    className: $t("visx-glyph", a),
    top: n,
    left: o
  }, i);
}
f3.propTypes = {
  top: se.number,
  left: se.number,
  className: se.string,
  children: se.node
};
var LT = ["top", "left", "className"];
function ou() {
  return ou = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ou.apply(this, arguments);
}
function BT(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Wo(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, o = r === void 0 ? 0 : r, a = e.className, i = BT(e, LT);
  return /* @__PURE__ */ R.createElement(f3, {
    top: n,
    left: o
  }, /* @__PURE__ */ R.createElement("circle", ou({
    className: $t("visx-glyph-dot", a)
  }, i)));
}
Wo.propTypes = {
  className: se.string,
  top: se.number,
  left: se.number,
  r: se.number,
  cx: se.number,
  cy: se.number
};
var au = Math.PI, iu = 2 * au, Pr = 1e-6, zT = iu - Pr;
function su() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function jo() {
  return new su();
}
su.prototype = jo.prototype = {
  constructor: su,
  moveTo: function(e, t) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(e, t) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function(e, t, n, r) {
    this._ += "Q" + +e + "," + +t + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(e, t, n, r, o, a) {
    this._ += "C" + +e + "," + +t + "," + +n + "," + +r + "," + (this._x1 = +o) + "," + (this._y1 = +a);
  },
  arcTo: function(e, t, n, r, o) {
    e = +e, t = +t, n = +n, r = +r, o = +o;
    var a = this._x1, i = this._y1, s = n - e, l = r - t, c = a - e, d = i - t, f = c * c + d * d;
    if (o < 0)
      throw new Error("negative radius: " + o);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);
    else if (f > Pr)
      if (!(Math.abs(d * s - l * c) > Pr) || !o)
        this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
      else {
        var p = n - a, m = r - i, h = s * s + l * l, g = p * p + m * m, x = Math.sqrt(h), y = Math.sqrt(f), b = o * Math.tan((au - Math.acos((h + f - g) / (2 * x * y))) / 2), v = b / y, A = b / x;
        Math.abs(v - 1) > Pr && (this._ += "L" + (e + v * c) + "," + (t + v * d)), this._ += "A" + o + "," + o + ",0,0," + +(d * p > c * m) + "," + (this._x1 = e + A * s) + "," + (this._y1 = t + A * l);
      }
  },
  arc: function(e, t, n, r, o, a) {
    e = +e, t = +t, n = +n, a = !!a;
    var i = n * Math.cos(r), s = n * Math.sin(r), l = e + i, c = t + s, d = 1 ^ a, f = a ? r - o : o - r;
    if (n < 0)
      throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + l + "," + c : (Math.abs(this._x1 - l) > Pr || Math.abs(this._y1 - c) > Pr) && (this._ += "L" + l + "," + c), n && (f < 0 && (f = f % iu + iu), f > zT ? this._ += "A" + n + "," + n + ",0,1," + d + "," + (e - i) + "," + (t - s) + "A" + n + "," + n + ",0,1," + d + "," + (this._x1 = l) + "," + (this._y1 = c) : f > Pr && (this._ += "A" + n + "," + n + ",0," + +(f >= au) + "," + d + "," + (this._x1 = e + n * Math.cos(o)) + "," + (this._y1 = t + n * Math.sin(o))));
  },
  rect: function(e, t, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function Re(e) {
  return function() {
    return e;
  };
}
var ap = Math.abs, St = Math.atan2, Mr = Math.cos, WT = Math.max, ac = Math.min, wn = Math.sin, co = Math.sqrt, Et = 1e-12, mr = Math.PI, ys = mr / 2, sr = 2 * mr;
function jT(e) {
  return e > 1 ? 0 : e < -1 ? mr : Math.acos(e);
}
function ip(e) {
  return e >= 1 ? ys : e <= -1 ? -ys : Math.asin(e);
}
function VT(e) {
  return e.innerRadius;
}
function HT(e) {
  return e.outerRadius;
}
function UT(e) {
  return e.startAngle;
}
function YT(e) {
  return e.endAngle;
}
function GT(e) {
  return e && e.padAngle;
}
function XT(e, t, n, r, o, a, i, s) {
  var l = n - e, c = r - t, d = i - o, f = s - a, p = f * l - d * c;
  if (!(p * p < Et))
    return p = (d * (t - a) - f * (e - o)) / p, [e + p * l, t + p * c];
}
function ki(e, t, n, r, o, a, i) {
  var s = e - n, l = t - r, c = (i ? a : -a) / co(s * s + l * l), d = c * l, f = -c * s, p = e + d, m = t + f, h = n + d, g = r + f, x = (p + h) / 2, y = (m + g) / 2, b = h - p, v = g - m, A = b * b + v * v, w = o - a, M = p * g - h * m, $ = (v < 0 ? -1 : 1) * co(WT(0, w * w * A - M * M)), P = (M * v - b * $) / A, E = (-M * b - v * $) / A, T = (M * v + b * $) / A, B = (-M * b + v * $) / A, j = P - x, V = E - y, W = T - x, S = B - y;
  return j * j + V * V > W * W + S * S && (P = T, E = B), {
    cx: P,
    cy: E,
    x01: -d,
    y01: -f,
    x11: P * (o / w - 1),
    y11: E * (o / w - 1)
  };
}
function p3() {
  var e = VT, t = HT, n = Re(0), r = null, o = UT, a = YT, i = GT, s = null;
  function l() {
    var c, d, f = +e.apply(this, arguments), p = +t.apply(this, arguments), m = o.apply(this, arguments) - ys, h = a.apply(this, arguments) - ys, g = ap(h - m), x = h > m;
    if (s || (s = c = jo()), p < f && (d = p, p = f, f = d), !(p > Et))
      s.moveTo(0, 0);
    else if (g > sr - Et)
      s.moveTo(p * Mr(m), p * wn(m)), s.arc(0, 0, p, m, h, !x), f > Et && (s.moveTo(f * Mr(h), f * wn(h)), s.arc(0, 0, f, h, m, x));
    else {
      var y = m, b = h, v = m, A = h, w = g, M = g, $ = i.apply(this, arguments) / 2, P = $ > Et && (r ? +r.apply(this, arguments) : co(f * f + p * p)), E = ac(ap(p - f) / 2, +n.apply(this, arguments)), T = E, B = E, j, V;
      if (P > Et) {
        var W = ip(P / f * wn($)), S = ip(P / p * wn($));
        (w -= W * 2) > Et ? (W *= x ? 1 : -1, v += W, A -= W) : (w = 0, v = A = (m + h) / 2), (M -= S * 2) > Et ? (S *= x ? 1 : -1, y += S, b -= S) : (M = 0, y = b = (m + h) / 2);
      }
      var _ = p * Mr(y), U = p * wn(y), z = f * Mr(A), N = f * wn(A);
      if (E > Et) {
        var O = p * Mr(b), k = p * wn(b), Q = f * Mr(v), q = f * wn(v), re;
        if (g < mr && (re = XT(_, U, Q, q, O, k, z, N))) {
          var ae = _ - re[0], oe = U - re[1], ee = O - re[0], ie = k - re[1], X = 1 / wn(jT((ae * ee + oe * ie) / (co(ae * ae + oe * oe) * co(ee * ee + ie * ie))) / 2), J = co(re[0] * re[0] + re[1] * re[1]);
          T = ac(E, (f - J) / (X - 1)), B = ac(E, (p - J) / (X + 1));
        }
      }
      M > Et ? B > Et ? (j = ki(Q, q, _, U, p, B, x), V = ki(O, k, z, N, p, B, x), s.moveTo(j.cx + j.x01, j.cy + j.y01), B < E ? s.arc(j.cx, j.cy, B, St(j.y01, j.x01), St(V.y01, V.x01), !x) : (s.arc(j.cx, j.cy, B, St(j.y01, j.x01), St(j.y11, j.x11), !x), s.arc(0, 0, p, St(j.cy + j.y11, j.cx + j.x11), St(V.cy + V.y11, V.cx + V.x11), !x), s.arc(V.cx, V.cy, B, St(V.y11, V.x11), St(V.y01, V.x01), !x))) : (s.moveTo(_, U), s.arc(0, 0, p, y, b, !x)) : s.moveTo(_, U), !(f > Et) || !(w > Et) ? s.lineTo(z, N) : T > Et ? (j = ki(z, N, O, k, f, -T, x), V = ki(_, U, Q, q, f, -T, x), s.lineTo(j.cx + j.x01, j.cy + j.y01), T < E ? s.arc(j.cx, j.cy, T, St(j.y01, j.x01), St(V.y01, V.x01), !x) : (s.arc(j.cx, j.cy, T, St(j.y01, j.x01), St(j.y11, j.x11), !x), s.arc(0, 0, f, St(j.cy + j.y11, j.cx + j.x11), St(V.cy + V.y11, V.cx + V.x11), x), s.arc(V.cx, V.cy, T, St(V.y11, V.x11), St(V.y01, V.x01), !x))) : s.arc(0, 0, f, A, v, x);
    }
    if (s.closePath(), c)
      return s = null, c + "" || null;
  }
  return l.centroid = function() {
    var c = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, d = (+o.apply(this, arguments) + +a.apply(this, arguments)) / 2 - mr / 2;
    return [Mr(d) * c, wn(d) * c];
  }, l.innerRadius = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Re(+c), l) : e;
  }, l.outerRadius = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Re(+c), l) : t;
  }, l.cornerRadius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Re(+c), l) : n;
  }, l.padRadius = function(c) {
    return arguments.length ? (r = c == null ? null : typeof c == "function" ? c : Re(+c), l) : r;
  }, l.startAngle = function(c) {
    return arguments.length ? (o = typeof c == "function" ? c : Re(+c), l) : o;
  }, l.endAngle = function(c) {
    return arguments.length ? (a = typeof c == "function" ? c : Re(+c), l) : a;
  }, l.padAngle = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : Re(+c), l) : i;
  }, l.context = function(c) {
    return arguments.length ? (s = c ?? null, l) : s;
  }, l;
}
function h3(e) {
  this._context = e;
}
h3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Ya(e) {
  return new h3(e);
}
function bf(e) {
  return e[0];
}
function xf(e) {
  return e[1];
}
function gl() {
  var e = bf, t = xf, n = Re(!0), r = null, o = Ya, a = null;
  function i(s) {
    var l, c = s.length, d, f = !1, p;
    for (r == null && (a = o(p = jo())), l = 0; l <= c; ++l)
      !(l < c && n(d = s[l], l, s)) === f && ((f = !f) ? a.lineStart() : a.lineEnd()), f && a.point(+e(d, l, s), +t(d, l, s));
    if (p)
      return a = null, p + "" || null;
  }
  return i.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Re(+s), i) : e;
  }, i.y = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Re(+s), i) : t;
  }, i.defined = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Re(!!s), i) : n;
  }, i.curve = function(s) {
    return arguments.length ? (o = s, r != null && (a = o(r)), i) : o;
  }, i.context = function(s) {
    return arguments.length ? (s == null ? r = a = null : a = o(r = s), i) : r;
  }, i;
}
function m3() {
  var e = bf, t = null, n = Re(0), r = xf, o = Re(!0), a = null, i = Ya, s = null;
  function l(d) {
    var f, p, m, h = d.length, g, x = !1, y, b = new Array(h), v = new Array(h);
    for (a == null && (s = i(y = jo())), f = 0; f <= h; ++f) {
      if (!(f < h && o(g = d[f], f, d)) === x)
        if (x = !x)
          p = f, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), m = f - 1; m >= p; --m)
            s.point(b[m], v[m]);
          s.lineEnd(), s.areaEnd();
        }
      x && (b[f] = +e(g, f, d), v[f] = +n(g, f, d), s.point(t ? +t(g, f, d) : b[f], r ? +r(g, f, d) : v[f]));
    }
    if (y)
      return s = null, y + "" || null;
  }
  function c() {
    return gl().defined(o).curve(i).context(a);
  }
  return l.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Re(+d), t = null, l) : e;
  }, l.x0 = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Re(+d), l) : e;
  }, l.x1 = function(d) {
    return arguments.length ? (t = d == null ? null : typeof d == "function" ? d : Re(+d), l) : t;
  }, l.y = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : Re(+d), r = null, l) : n;
  }, l.y0 = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : Re(+d), l) : n;
  }, l.y1 = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : Re(+d), l) : r;
  }, l.lineX0 = l.lineY0 = function() {
    return c().x(e).y(n);
  }, l.lineY1 = function() {
    return c().x(e).y(r);
  }, l.lineX1 = function() {
    return c().x(t).y(n);
  }, l.defined = function(d) {
    return arguments.length ? (o = typeof d == "function" ? d : Re(!!d), l) : o;
  }, l.curve = function(d) {
    return arguments.length ? (i = d, a != null && (s = i(a)), l) : i;
  }, l.context = function(d) {
    return arguments.length ? (d == null ? a = s = null : s = i(a = d), l) : a;
  }, l;
}
function qT(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function KT(e) {
  return e;
}
function g3() {
  var e = KT, t = qT, n = null, r = Re(0), o = Re(sr), a = Re(0);
  function i(s) {
    var l, c = s.length, d, f, p = 0, m = new Array(c), h = new Array(c), g = +r.apply(this, arguments), x = Math.min(sr, Math.max(-sr, o.apply(this, arguments) - g)), y, b = Math.min(Math.abs(x) / c, a.apply(this, arguments)), v = b * (x < 0 ? -1 : 1), A;
    for (l = 0; l < c; ++l)
      (A = h[m[l] = l] = +e(s[l], l, s)) > 0 && (p += A);
    for (t != null ? m.sort(function(w, M) {
      return t(h[w], h[M]);
    }) : n != null && m.sort(function(w, M) {
      return n(s[w], s[M]);
    }), l = 0, f = p ? (x - c * v) / p : 0; l < c; ++l, g = y)
      d = m[l], A = h[d], y = g + (A > 0 ? A * f : 0) + v, h[d] = {
        data: s[d],
        index: l,
        value: A,
        startAngle: g,
        endAngle: y,
        padAngle: b
      };
    return h;
  }
  return i.value = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Re(+s), i) : e;
  }, i.sortValues = function(s) {
    return arguments.length ? (t = s, n = null, i) : t;
  }, i.sort = function(s) {
    return arguments.length ? (n = s, t = null, i) : n;
  }, i.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Re(+s), i) : r;
  }, i.endAngle = function(s) {
    return arguments.length ? (o = typeof s == "function" ? s : Re(+s), i) : o;
  }, i.padAngle = function(s) {
    return arguments.length ? (a = typeof s == "function" ? s : Re(+s), i) : a;
  }, i;
}
var v3 = wf(Ya);
function y3(e) {
  this._curve = e;
}
y3.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(e, t) {
    this._curve.point(t * Math.sin(e), t * -Math.cos(e));
  }
};
function wf(e) {
  function t(n) {
    return new y3(e(n));
  }
  return t._curve = e, t;
}
function da(e) {
  var t = e.curve;
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e.curve = function(n) {
    return arguments.length ? t(wf(n)) : t()._curve;
  }, e;
}
function sp() {
  return da(gl().curve(v3));
}
function lp() {
  var e = m3().curve(v3), t = e.curve, n = e.lineX0, r = e.lineX1, o = e.lineY0, a = e.lineY1;
  return e.angle = e.x, delete e.x, e.startAngle = e.x0, delete e.x0, e.endAngle = e.x1, delete e.x1, e.radius = e.y, delete e.y, e.innerRadius = e.y0, delete e.y0, e.outerRadius = e.y1, delete e.y1, e.lineStartAngle = function() {
    return da(n());
  }, delete e.lineX0, e.lineEndAngle = function() {
    return da(r());
  }, delete e.lineX1, e.lineInnerRadius = function() {
    return da(o());
  }, delete e.lineY0, e.lineOuterRadius = function() {
    return da(a());
  }, delete e.lineY1, e.curve = function(i) {
    return arguments.length ? t(wf(i)) : t()._curve;
  }, e;
}
function fa(e, t) {
  return [(t = +t) * Math.cos(e -= Math.PI / 2), t * Math.sin(e)];
}
var lu = Array.prototype.slice;
function QT(e) {
  return e.source;
}
function ZT(e) {
  return e.target;
}
function Af(e) {
  var t = QT, n = ZT, r = bf, o = xf, a = null;
  function i() {
    var s, l = lu.call(arguments), c = t.apply(this, l), d = n.apply(this, l);
    if (a || (a = s = jo()), e(a, +r.apply(this, (l[0] = c, l)), +o.apply(this, l), +r.apply(this, (l[0] = d, l)), +o.apply(this, l)), s)
      return a = null, s + "" || null;
  }
  return i.source = function(s) {
    return arguments.length ? (t = s, i) : t;
  }, i.target = function(s) {
    return arguments.length ? (n = s, i) : n;
  }, i.x = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Re(+s), i) : r;
  }, i.y = function(s) {
    return arguments.length ? (o = typeof s == "function" ? s : Re(+s), i) : o;
  }, i.context = function(s) {
    return arguments.length ? (a = s ?? null, i) : a;
  }, i;
}
function JT(e, t, n, r, o) {
  e.moveTo(t, n), e.bezierCurveTo(t = (t + r) / 2, n, t, o, r, o);
}
function eO(e, t, n, r, o) {
  e.moveTo(t, n), e.bezierCurveTo(t, n = (n + o) / 2, r, n, r, o);
}
function tO(e, t, n, r, o) {
  var a = fa(t, n), i = fa(t, n = (n + o) / 2), s = fa(r, n), l = fa(r, o);
  e.moveTo(a[0], a[1]), e.bezierCurveTo(i[0], i[1], s[0], s[1], l[0], l[1]);
}
function b3() {
  return Af(JT);
}
function nO() {
  return Af(eO);
}
function rO() {
  var e = Af(tO);
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e;
}
const Cf = {
  draw: function(e, t) {
    var n = Math.sqrt(t / mr);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, sr);
  }
}, x3 = {
  draw: function(e, t) {
    var n = Math.sqrt(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
};
var w3 = Math.sqrt(1 / 3), oO = w3 * 2;
const A3 = {
  draw: function(e, t) {
    var n = Math.sqrt(t / oO), r = n * w3;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
};
var aO = 0.8908130915292852, C3 = Math.sin(mr / 10) / Math.sin(7 * mr / 10), iO = Math.sin(sr / 10) * C3, sO = -Math.cos(sr / 10) * C3;
const S3 = {
  draw: function(e, t) {
    var n = Math.sqrt(t * aO), r = iO * n, o = sO * n;
    e.moveTo(0, -n), e.lineTo(r, o);
    for (var a = 1; a < 5; ++a) {
      var i = sr * a / 5, s = Math.cos(i), l = Math.sin(i);
      e.lineTo(l * n, -s * n), e.lineTo(s * r - l * o, l * r + s * o);
    }
    e.closePath();
  }
}, E3 = {
  draw: function(e, t) {
    var n = Math.sqrt(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
};
var ic = Math.sqrt(3);
const M3 = {
  draw: function(e, t) {
    var n = -Math.sqrt(t / (ic * 3));
    e.moveTo(0, n * 2), e.lineTo(-ic * n, -n), e.lineTo(ic * n, -n), e.closePath();
  }
};
var qt = -0.5, Kt = Math.sqrt(3) / 2, cu = 1 / Math.sqrt(12), lO = (cu / 2 + 1) * 3;
const $3 = {
  draw: function(e, t) {
    var n = Math.sqrt(t / lO), r = n / 2, o = n * cu, a = r, i = n * cu + n, s = -a, l = i;
    e.moveTo(r, o), e.lineTo(a, i), e.lineTo(s, l), e.lineTo(qt * r - Kt * o, Kt * r + qt * o), e.lineTo(qt * a - Kt * i, Kt * a + qt * i), e.lineTo(qt * s - Kt * l, Kt * s + qt * l), e.lineTo(qt * r + Kt * o, qt * o - Kt * r), e.lineTo(qt * a + Kt * i, qt * i - Kt * a), e.lineTo(qt * s + Kt * l, qt * l - Kt * s), e.closePath();
  }
};
var cO = [
  Cf,
  x3,
  A3,
  E3,
  S3,
  M3,
  $3
];
function uO() {
  var e = Re(Cf), t = Re(64), n = null;
  function r() {
    var o;
    if (n || (n = o = jo()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), o)
      return n = null, o + "" || null;
  }
  return r.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : Re(o), r) : e;
  }, r.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : Re(+o), r) : t;
  }, r.context = function(o) {
    return arguments.length ? (n = o ?? null, r) : n;
  }, r;
}
function gr() {
}
function bs(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function vl(e) {
  this._context = e;
}
vl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        bs(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        bs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function dO(e) {
  return new vl(e);
}
function P3(e) {
  this._context = e;
}
P3.prototype = {
  areaStart: gr,
  areaEnd: gr,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        bs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function fO(e) {
  return new P3(e);
}
function T3(e) {
  this._context = e;
}
T3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        bs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function pO(e) {
  return new T3(e);
}
function O3(e, t) {
  this._basis = new vl(e), this._beta = t;
}
O3.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length - 1;
    if (n > 0)
      for (var r = e[0], o = t[0], a = e[n] - r, i = t[n] - o, s = -1, l; ++s <= n; )
        l = s / n, this._basis.point(
          this._beta * e[s] + (1 - this._beta) * (r + l * a),
          this._beta * t[s] + (1 - this._beta) * (o + l * i)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
const hO = function e(t) {
  function n(r) {
    return t === 1 ? new vl(r) : new O3(r, t);
  }
  return n.beta = function(r) {
    return e(+r);
  }, n;
}(0.85);
function xs(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function Sf(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
Sf.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        xs(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      default:
        xs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const mO = function e(t) {
  function n(r) {
    return new Sf(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function Ef(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
Ef.prototype = {
  areaStart: gr,
  areaEnd: gr,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        xs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const gO = function e(t) {
  function n(r) {
    return new Ef(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function Mf(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
Mf.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        xs(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const vO = function e(t) {
  function n(r) {
    return new Mf(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function $f(e, t, n) {
  var r = e._x1, o = e._y1, a = e._x2, i = e._y2;
  if (e._l01_a > Et) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, l = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / l, o = (o * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / l;
  }
  if (e._l23_a > Et) {
    var c = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, d = 3 * e._l23_a * (e._l23_a + e._l12_a);
    a = (a * c + e._x1 * e._l23_2a - t * e._l12_2a) / d, i = (i * c + e._y1 * e._l23_2a - n * e._l12_2a) / d;
  }
  e._context.bezierCurveTo(r, o, a, i, e._x2, e._y2);
}
function N3(e, t) {
  this._context = e, this._alpha = t;
}
N3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        $f(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const yO = function e(t) {
  function n(r) {
    return t ? new N3(r, t) : new Sf(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function k3(e, t) {
  this._context = e, this._alpha = t;
}
k3.prototype = {
  areaStart: gr,
  areaEnd: gr,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        $f(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const bO = function e(t) {
  function n(r) {
    return t ? new k3(r, t) : new Ef(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function D3(e, t) {
  this._context = e, this._alpha = t;
}
D3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        $f(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const xO = function e(t) {
  function n(r) {
    return t ? new D3(r, t) : new Mf(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function F3(e) {
  this._context = e;
}
F3.prototype = {
  areaStart: gr,
  areaEnd: gr,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function wO(e) {
  return new F3(e);
}
function cp(e) {
  return e < 0 ? -1 : 1;
}
function up(e, t, n) {
  var r = e._x1 - e._x0, o = t - e._x1, a = (e._y1 - e._y0) / (r || o < 0 && -0), i = (n - e._y1) / (o || r < 0 && -0), s = (a * o + i * r) / (r + o);
  return (cp(a) + cp(i)) * Math.min(Math.abs(a), Math.abs(i), 0.5 * Math.abs(s)) || 0;
}
function dp(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function sc(e, t, n) {
  var r = e._x0, o = e._y0, a = e._x1, i = e._y1, s = (a - r) / 3;
  e._context.bezierCurveTo(r + s, o + s * t, a - s, i - s * n, a, i);
}
function ws(e) {
  this._context = e;
}
ws.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        sc(this, this._t0, dp(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, sc(this, dp(this, n = up(this, e, t)), n);
          break;
        default:
          sc(this, this._t0, n = up(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function R3(e) {
  this._context = new _3(e);
}
(R3.prototype = Object.create(ws.prototype)).point = function(e, t) {
  ws.prototype.point.call(this, t, e);
};
function _3(e) {
  this._context = e;
}
_3.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, o, a) {
    this._context.bezierCurveTo(t, e, r, n, a, o);
  }
};
function AO(e) {
  return new ws(e);
}
function CO(e) {
  return new R3(e);
}
function I3(e) {
  this._context = e;
}
I3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = fp(e), o = fp(t), a = 0, i = 1; i < n; ++a, ++i)
          this._context.bezierCurveTo(r[0][a], o[0][a], r[1][a], o[1][a], e[i], t[i]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function fp(e) {
  var t, n = e.length - 1, r, o = new Array(n), a = new Array(n), i = new Array(n);
  for (o[0] = 0, a[0] = 2, i[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t)
    o[t] = 1, a[t] = 4, i[t] = 4 * e[t] + 2 * e[t + 1];
  for (o[n - 1] = 2, a[n - 1] = 7, i[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t)
    r = o[t] / a[t - 1], a[t] -= r, i[t] -= r * i[t - 1];
  for (o[n - 1] = i[n - 1] / a[n - 1], t = n - 2; t >= 0; --t)
    o[t] = (i[t] - o[t + 1]) / a[t];
  for (a[n - 1] = (e[n] + o[n - 1]) / 2, t = 0; t < n - 1; ++t)
    a[t] = 2 * e[t + 1] - o[t + 1];
  return [o, a];
}
function SO(e) {
  return new I3(e);
}
function yl(e, t) {
  this._context = e, this._t = t;
}
yl.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function EO(e) {
  return new yl(e, 0.5);
}
function MO(e) {
  return new yl(e, 0);
}
function $O(e) {
  return new yl(e, 1);
}
function Eo(e, t) {
  if ((i = e.length) > 1)
    for (var n = 1, r, o, a = e[t[0]], i, s = a.length; n < i; ++n)
      for (o = a, a = e[t[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(o[r][1]) ? o[r][0] : o[r][1];
}
function Mo(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; )
    n[t] = t;
  return n;
}
function PO(e, t) {
  return e[t];
}
function TO() {
  var e = Re([]), t = Mo, n = Eo, r = PO;
  function o(a) {
    var i = e.apply(this, arguments), s, l = a.length, c = i.length, d = new Array(c), f;
    for (s = 0; s < c; ++s) {
      for (var p = i[s], m = d[s] = new Array(l), h = 0, g; h < l; ++h)
        m[h] = g = [0, +r(a[h], p, h, a)], g.data = a[h];
      m.key = p;
    }
    for (s = 0, f = t(d); s < c; ++s)
      d[f[s]].index = s;
    return n(d, f), d;
  }
  return o.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Re(lu.call(a)), o) : e;
  }, o.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Re(+a), o) : r;
  }, o.order = function(a) {
    return arguments.length ? (t = a == null ? Mo : typeof a == "function" ? a : Re(lu.call(a)), o) : t;
  }, o.offset = function(a) {
    return arguments.length ? (n = a ?? Eo, o) : n;
  }, o;
}
function OO(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, o = 0, a = e[0].length, i; o < a; ++o) {
      for (i = n = 0; n < r; ++n)
        i += e[n][o][1] || 0;
      if (i)
        for (n = 0; n < r; ++n)
          e[n][o][1] /= i;
    }
    Eo(e, t);
  }
}
function NO(e, t) {
  if ((l = e.length) > 0)
    for (var n, r = 0, o, a, i, s, l, c = e[t[0]].length; r < c; ++r)
      for (i = s = 0, n = 0; n < l; ++n)
        (a = (o = e[t[n]][r])[1] - o[0]) > 0 ? (o[0] = i, o[1] = i += a) : a < 0 ? (o[1] = s, o[0] = s += a) : (o[0] = 0, o[1] = a);
}
function kO(e, t) {
  if ((o = e.length) > 0) {
    for (var n = 0, r = e[t[0]], o, a = r.length; n < a; ++n) {
      for (var i = 0, s = 0; i < o; ++i)
        s += e[i][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    Eo(e, t);
  }
}
function DO(e, t) {
  if (!(!((i = e.length) > 0) || !((a = (o = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, o, a, i; r < a; ++r) {
      for (var s = 0, l = 0, c = 0; s < i; ++s) {
        for (var d = e[t[s]], f = d[r][1] || 0, p = d[r - 1][1] || 0, m = (f - p) / 2, h = 0; h < s; ++h) {
          var g = e[t[h]], x = g[r][1] || 0, y = g[r - 1][1] || 0;
          m += x - y;
        }
        l += f, c += m * f;
      }
      o[r - 1][1] += o[r - 1][0] = n, l && (n -= c / l);
    }
    o[r - 1][1] += o[r - 1][0] = n, Eo(e, t);
  }
}
function L3(e) {
  var t = e.map(FO);
  return Mo(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function FO(e) {
  for (var t = -1, n = 0, r = e.length, o, a = -1 / 0; ++t < r; )
    (o = +e[t][1]) > a && (a = o, n = t);
  return n;
}
function B3(e) {
  var t = e.map(z3);
  return Mo(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function z3(e) {
  for (var t = 0, n = -1, r = e.length, o; ++n < r; )
    (o = +e[n][1]) && (t += o);
  return t;
}
function RO(e) {
  return B3(e).reverse();
}
function _O(e) {
  var t = e.length, n, r, o = e.map(z3), a = L3(e), i = 0, s = 0, l = [], c = [];
  for (n = 0; n < t; ++n)
    r = a[n], i < s ? (i += o[r], l.push(r)) : (s += o[r], c.push(r));
  return c.reverse().concat(l);
}
function IO(e) {
  return Mo(e).reverse();
}
const LO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arc: p3,
  area: m3,
  areaRadial: lp,
  curveBasis: dO,
  curveBasisClosed: fO,
  curveBasisOpen: pO,
  curveBundle: hO,
  curveCardinal: mO,
  curveCardinalClosed: gO,
  curveCardinalOpen: vO,
  curveCatmullRom: yO,
  curveCatmullRomClosed: bO,
  curveCatmullRomOpen: xO,
  curveLinear: Ya,
  curveLinearClosed: wO,
  curveMonotoneX: AO,
  curveMonotoneY: CO,
  curveNatural: SO,
  curveStep: EO,
  curveStepAfter: $O,
  curveStepBefore: MO,
  line: gl,
  lineRadial: sp,
  linkHorizontal: b3,
  linkRadial: rO,
  linkVertical: nO,
  pie: g3,
  pointRadial: fa,
  radialArea: lp,
  radialLine: sp,
  stack: TO,
  stackOffsetDiverging: NO,
  stackOffsetExpand: OO,
  stackOffsetNone: Eo,
  stackOffsetSilhouette: kO,
  stackOffsetWiggle: DO,
  stackOrderAppearance: L3,
  stackOrderAscending: B3,
  stackOrderDescending: RO,
  stackOrderInsideOut: _O,
  stackOrderNone: Mo,
  stackOrderReverse: IO,
  symbol: uO,
  symbolCircle: Cf,
  symbolCross: x3,
  symbolDiamond: A3,
  symbolSquare: E3,
  symbolStar: S3,
  symbolTriangle: M3,
  symbolWye: $3,
  symbols: cO
}, Symbol.toStringTag, { value: "Module" }));
function BO(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var bl = BO, zO = typeof ua == "object" && ua && ua.Object === Object && ua, WO = zO, jO = WO, VO = typeof self == "object" && self && self.Object === Object && self, HO = jO || VO || Function("return this")(), xl = HO, UO = xl, YO = function() {
  return UO.Date.now();
}, GO = YO, XO = /\s/;
function qO(e) {
  for (var t = e.length; t-- && XO.test(e.charAt(t)); )
    ;
  return t;
}
var KO = qO, QO = KO, ZO = /^\s+/;
function JO(e) {
  return e && e.slice(0, QO(e) + 1).replace(ZO, "");
}
var eN = JO, tN = xl, nN = tN.Symbol, W3 = nN, pp = W3, j3 = Object.prototype, rN = j3.hasOwnProperty, oN = j3.toString, ta = pp ? pp.toStringTag : void 0;
function aN(e) {
  var t = rN.call(e, ta), n = e[ta];
  try {
    e[ta] = void 0;
    var r = !0;
  } catch {
  }
  var o = oN.call(e);
  return r && (t ? e[ta] = n : delete e[ta]), o;
}
var iN = aN, sN = Object.prototype, lN = sN.toString;
function cN(e) {
  return lN.call(e);
}
var uN = cN, hp = W3, dN = iN, fN = uN, pN = "[object Null]", hN = "[object Undefined]", mp = hp ? hp.toStringTag : void 0;
function mN(e) {
  return e == null ? e === void 0 ? hN : pN : mp && mp in Object(e) ? dN(e) : fN(e);
}
var V3 = mN;
function gN(e) {
  return e != null && typeof e == "object";
}
var vN = gN, yN = V3, bN = vN, xN = "[object Symbol]";
function wN(e) {
  return typeof e == "symbol" || bN(e) && yN(e) == xN;
}
var AN = wN, CN = eN, gp = bl, SN = AN, vp = 0 / 0, EN = /^[-+]0x[0-9a-f]+$/i, MN = /^0b[01]+$/i, $N = /^0o[0-7]+$/i, PN = parseInt;
function TN(e) {
  if (typeof e == "number")
    return e;
  if (SN(e))
    return vp;
  if (gp(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = gp(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = CN(e);
  var n = MN.test(e);
  return n || $N.test(e) ? PN(e.slice(2), n ? 2 : 8) : EN.test(e) ? vp : +e;
}
var ON = TN, NN = bl, lc = GO, yp = ON, kN = "Expected a function", DN = Math.max, FN = Math.min;
function RN(e, t, n) {
  var r, o, a, i, s, l, c = 0, d = !1, f = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(kN);
  t = yp(t) || 0, NN(n) && (d = !!n.leading, f = "maxWait" in n, a = f ? DN(yp(n.maxWait) || 0, t) : a, p = "trailing" in n ? !!n.trailing : p);
  function m(M) {
    var $ = r, P = o;
    return r = o = void 0, c = M, i = e.apply(P, $), i;
  }
  function h(M) {
    return c = M, s = setTimeout(y, t), d ? m(M) : i;
  }
  function g(M) {
    var $ = M - l, P = M - c, E = t - $;
    return f ? FN(E, a - P) : E;
  }
  function x(M) {
    var $ = M - l, P = M - c;
    return l === void 0 || $ >= t || $ < 0 || f && P >= a;
  }
  function y() {
    var M = lc();
    if (x(M))
      return b(M);
    s = setTimeout(y, g(M));
  }
  function b(M) {
    return s = void 0, p && r ? m(M) : (r = o = void 0, i);
  }
  function v() {
    s !== void 0 && clearTimeout(s), c = 0, r = l = o = s = void 0;
  }
  function A() {
    return s === void 0 ? i : b(lc());
  }
  function w() {
    var M = lc(), $ = x(M);
    if (r = arguments, o = this, l = M, $) {
      if (s === void 0)
        return h(l);
      if (f)
        return clearTimeout(s), s = setTimeout(y, t), m(l);
    }
    return s === void 0 && (s = setTimeout(y, t)), i;
  }
  return w.cancel = v, w.flush = A, w;
}
var H3 = RN;
const U3 = /* @__PURE__ */ Do(H3);
var _N = ["className", "children", "debounceTime", "ignoreDimensions", "parentSizeStyles", "enableDebounceLeadingCall", "resizeObserverPolyfill"];
function As() {
  return As = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, As.apply(this, arguments);
}
function IN(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var LN = [], BN = {
  width: "100%",
  height: "100%"
};
function xr(e) {
  var t = e.className, n = e.children, r = e.debounceTime, o = r === void 0 ? 300 : r, a = e.ignoreDimensions, i = a === void 0 ? LN : a, s = e.parentSizeStyles, l = s === void 0 ? BN : s, c = e.enableDebounceLeadingCall, d = c === void 0 ? !0 : c, f = e.resizeObserverPolyfill, p = IN(e, _N), m = de(null), h = de(0), g = we({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), x = g[0], y = g[1], b = Se(function() {
    var v = Array.isArray(i) ? i : [i];
    return U3(function(A) {
      y(function(w) {
        var M = Object.keys(w), $ = M.filter(function(E) {
          return w[E] !== A[E];
        }), P = $.every(function(E) {
          return v.includes(E);
        });
        return P ? w : A;
      });
    }, o, {
      leading: d
    });
  }, [o, d, i]);
  return Ce(function() {
    var v = f || window.ResizeObserver, A = new v(function(w) {
      w.forEach(function(M) {
        var $, P = ($ = M == null ? void 0 : M.contentRect) != null ? $ : {}, E = P.left, T = P.top, B = P.width, j = P.height;
        h.current = window.requestAnimationFrame(function() {
          b({
            width: B,
            height: j,
            top: T,
            left: E
          });
        });
      });
    });
    return m.current && A.observe(m.current), function() {
      window.cancelAnimationFrame(h.current), A.disconnect(), b.cancel();
    };
  }, [b, f]), /* @__PURE__ */ R.createElement("div", As({
    style: l,
    ref: m,
    className: t
  }, p), n(As({}, x, {
    ref: m.current,
    resize: b
  })));
}
xr.propTypes = {
  className: se.string,
  debounceTime: se.number,
  enableDebounceLeadingCall: se.bool,
  ignoreDimensions: se.oneOfType([se.any, se.arrayOf(se.any)]),
  children: se.func.isRequired
};
var zN = Y3;
function Y3(e, t, n) {
  e instanceof RegExp && (e = bp(e, n)), t instanceof RegExp && (t = bp(t, n));
  var r = G3(e, t, n);
  return r && {
    start: r[0],
    end: r[1],
    pre: n.slice(0, r[0]),
    body: n.slice(r[0] + e.length, r[1]),
    post: n.slice(r[1] + t.length)
  };
}
function bp(e, t) {
  var n = t.match(e);
  return n ? n[0] : null;
}
Y3.range = G3;
function G3(e, t, n) {
  var r, o, a, i, s, l = n.indexOf(e), c = n.indexOf(t, l + 1), d = l;
  if (l >= 0 && c > 0) {
    for (r = [], a = n.length; d >= 0 && !s; )
      d == l ? (r.push(d), l = n.indexOf(e, d + 1)) : r.length == 1 ? s = [r.pop(), c] : (o = r.pop(), o < a && (a = o, i = c), c = n.indexOf(t, d + 1)), d = l < c && l >= 0 ? l : c;
    r.length && (s = [a, i]);
  }
  return s;
}
var WN = X3;
function X3(e, t, n) {
  e instanceof RegExp && (e = xp(e, n)), t instanceof RegExp && (t = xp(t, n));
  var r = q3(e, t, n);
  return r && {
    start: r[0],
    end: r[1],
    pre: n.slice(0, r[0]),
    body: n.slice(r[0] + e.length, r[1]),
    post: n.slice(r[1] + t.length)
  };
}
function xp(e, t) {
  var n = t.match(e);
  return n ? n[0] : null;
}
X3.range = q3;
function q3(e, t, n) {
  var r, o, a, i, s, l = n.indexOf(e), c = n.indexOf(t, l + 1), d = l;
  if (l >= 0 && c > 0) {
    if (e === t)
      return [l, c];
    for (r = [], a = n.length; d >= 0 && !s; )
      d == l ? (r.push(d), l = n.indexOf(e, d + 1)) : r.length == 1 ? s = [r.pop(), c] : (o = r.pop(), o < a && (a = o, i = c), c = n.indexOf(t, d + 1)), d = l < c && l >= 0 ? l : c;
    r.length && (s = [a, i]);
  }
  return s;
}
var jN = WN, VN = K3;
function K3(e, t, n) {
  var r = e;
  return HN(e, t).reduce(function(o, a) {
    return o.replace(a.functionIdentifier + "(" + a.matches.body + ")", UN(a.matches.body, a.functionIdentifier, n, r, t));
  }, e);
}
function HN(e, t) {
  var n = [], r = typeof t == "string" ? new RegExp("\\b(" + t + ")\\(") : t;
  do {
    var o = r.exec(e);
    if (!o)
      return n;
    if (o[1] === void 0)
      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + t);
    var a = o[1], i = o.index, s = jN("(", ")", e.substring(i));
    if (!s || s.start !== o[0].length - 1)
      throw new SyntaxError(a + "(): missing closing ')' in the value '" + e + "'");
    n.push({ matches: s, functionIdentifier: a }), e = s.post;
  } while (r.test(e));
  return n;
}
function UN(e, t, n, r, o) {
  return n(K3(e, o, n), t, r);
}
var kt = function(e) {
  this.value = e;
};
kt.math = {
  isDegree: !0,
  // mode of calculator
  acos: function(e) {
    return kt.math.isDegree ? 180 / Math.PI * Math.acos(e) : Math.acos(e);
  },
  add: function(e, t) {
    return e + t;
  },
  asin: function(e) {
    return kt.math.isDegree ? 180 / Math.PI * Math.asin(e) : Math.asin(e);
  },
  atan: function(e) {
    return kt.math.isDegree ? 180 / Math.PI * Math.atan(e) : Math.atan(e);
  },
  acosh: function(e) {
    return Math.log(e + Math.sqrt(e * e - 1));
  },
  asinh: function(e) {
    return Math.log(e + Math.sqrt(e * e + 1));
  },
  atanh: function(e) {
    return Math.log((1 + e) / (1 - e));
  },
  C: function(e, t) {
    var n = 1, r = e - t, o = t;
    o < r && (o = r, r = t);
    for (var a = o + 1; a <= e; a++)
      n *= a;
    return n / kt.math.fact(r);
  },
  changeSign: function(e) {
    return -e;
  },
  cos: function(e) {
    return kt.math.isDegree && (e = kt.math.toRadian(e)), Math.cos(e);
  },
  cosh: function(e) {
    return (Math.pow(Math.E, e) + Math.pow(Math.E, -1 * e)) / 2;
  },
  div: function(e, t) {
    return e / t;
  },
  fact: function(e) {
    if (e % 1 !== 0)
      return "NaN";
    for (var t = 1, n = 2; n <= e; n++)
      t *= n;
    return t;
  },
  inverse: function(e) {
    return 1 / e;
  },
  log: function(e) {
    return Math.log(e) / Math.log(10);
  },
  mod: function(e, t) {
    return e % t;
  },
  mul: function(e, t) {
    return e * t;
  },
  P: function(e, t) {
    for (var n = 1, r = Math.floor(e) - Math.floor(t) + 1; r <= Math.floor(e); r++)
      n *= r;
    return n;
  },
  Pi: function(e, t, n) {
    for (var r = 1, o = e; o <= t; o++)
      r *= Number(n.postfixEval({
        n: o
      }));
    return r;
  },
  pow10x: function(e) {
    for (var t = 1; e--; )
      t *= 10;
    return t;
  },
  sigma: function(e, t, n) {
    for (var r = 0, o = e; o <= t; o++)
      r += Number(n.postfixEval({
        n: o
      }));
    return r;
  },
  sin: function(e) {
    return kt.math.isDegree && (e = kt.math.toRadian(e)), Math.sin(e);
  },
  sinh: function(e) {
    return (Math.pow(Math.E, e) - Math.pow(Math.E, -1 * e)) / 2;
  },
  sub: function(e, t) {
    return e - t;
  },
  tan: function(e) {
    return kt.math.isDegree && (e = kt.math.toRadian(e)), Math.tan(e);
  },
  tanh: function(e) {
    return kt.sinha(e) / kt.cosha(e);
  },
  toRadian: function(e) {
    return e * Math.PI / 180;
  },
  and: function(e, t) {
    return e & t;
  }
};
kt.Exception = function(e) {
  this.message = e;
};
var YN = kt, Te = YN;
function Nt(e, t) {
  for (var n = 0; n < e.length; n++)
    e[n] += t;
  return e;
}
var lr = [
  { token: "sin", show: "sin", type: 0, value: Te.math.sin },
  { token: "cos", show: "cos", type: 0, value: Te.math.cos },
  { token: "tan", show: "tan", type: 0, value: Te.math.tan },
  { token: "pi", show: "&pi;", type: 3, value: "PI" },
  { token: "(", show: "(", type: 4, value: "(" },
  { token: ")", show: ")", type: 5, value: ")" },
  { token: "P", show: "P", type: 10, value: Te.math.P },
  { token: "C", show: "C", type: 10, value: Te.math.C },
  { token: " ", show: " ", type: 14, value: " ".anchor },
  { token: "asin", show: "asin", type: 0, value: Te.math.asin },
  { token: "acos", show: "acos", type: 0, value: Te.math.acos },
  { token: "atan", show: "atan", type: 0, value: Te.math.atan },
  { token: "7", show: "7", type: 1, value: "7" },
  { token: "8", show: "8", type: 1, value: "8" },
  { token: "9", show: "9", type: 1, value: "9" },
  { token: "int", show: "Int", type: 0, value: Math.floor },
  { token: "cosh", show: "cosh", type: 0, value: Te.math.cosh },
  { token: "acosh", show: "acosh", type: 0, value: Te.math.acosh },
  { token: "ln", show: " ln", type: 0, value: Math.log },
  { token: "^", show: "^", type: 10, value: Math.pow },
  { token: "root", show: "root", type: 0, value: Math.sqrt },
  { token: "4", show: "4", type: 1, value: "4" },
  { token: "5", show: "5", type: 1, value: "5" },
  { token: "6", show: "6", type: 1, value: "6" },
  { token: "/", show: "&divide;", type: 2, value: Te.math.div },
  { token: "!", show: "!", type: 7, value: Te.math.fact },
  { token: "tanh", show: "tanh", type: 0, value: Te.math.tanh },
  { token: "atanh", show: "atanh", type: 0, value: Te.math.atanh },
  { token: "Mod", show: " Mod ", type: 2, value: Te.math.mod },
  { token: "1", show: "1", type: 1, value: "1" },
  { token: "2", show: "2", type: 1, value: "2" },
  { token: "3", show: "3", type: 1, value: "3" },
  { token: "*", show: "&times;", type: 2, value: Te.math.mul },
  { token: "sinh", show: "sinh", type: 0, value: Te.math.sinh },
  { token: "asinh", show: "asinh", type: 0, value: Te.math.asinh },
  { token: "e", show: "e", type: 3, value: "E" },
  { token: "log", show: " log", type: 0, value: Te.math.log },
  { token: "0", show: "0", type: 1, value: "0" },
  { token: ".", show: ".", type: 6, value: "." },
  { token: "+", show: "+", type: 9, value: Te.math.add },
  { token: "-", show: "-", type: 9, value: Te.math.sub },
  { token: ",", show: ",", type: 11, value: "," },
  { token: "Sigma", show: "&Sigma;", type: 12, value: Te.math.sigma },
  { token: "n", show: "n", type: 13, value: "n" },
  { token: "Pi", show: "&Pi;", type: 12, value: Te.math.Pi },
  { token: "pow", show: "pow", type: 8, value: Math.pow, numberOfArguments: 2 },
  { token: "&", show: "&", type: 9, value: Te.math.and }
], uu = {
  0: 11,
  1: 0,
  2: 3,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 11,
  8: 11,
  9: 1,
  10: 10,
  11: 0,
  12: 11,
  13: 0,
  14: -1,
  15: 11
  // will be filtered after lexer
};
for (var Di = 0; Di < lr.length; Di++)
  lr[Di].precedence = uu[lr[Di].type];
var An = {
  0: !0,
  1: !0,
  3: !0,
  4: !0,
  6: !0,
  8: !0,
  9: !0,
  12: !0,
  13: !0,
  14: !0,
  15: !0
}, io = {
  0: !0,
  1: !0,
  2: !0,
  3: !0,
  4: !0,
  5: !0,
  6: !0,
  7: !0,
  8: !0,
  9: !0,
  10: !0,
  11: !0,
  12: !0,
  13: !0,
  15: !0
}, GN = {
  0: !0,
  3: !0,
  4: !0,
  8: !0,
  12: !0,
  13: !0,
  15: !0
}, ln = {}, na = {
  0: !0,
  1: !0,
  3: !0,
  4: !0,
  6: !0,
  8: !0,
  12: !0,
  13: !0,
  15: !0
}, XN = {
  1: !0
}, Dt = [
  [],
  [
    "1",
    "2",
    "3",
    "7",
    "8",
    "9",
    "4",
    "5",
    "6",
    "+",
    "-",
    "*",
    "/",
    "(",
    ")",
    "^",
    "!",
    "P",
    "C",
    "e",
    "0",
    ".",
    ",",
    "n",
    " ",
    "&"
  ],
  ["pi", "ln", "Pi"],
  ["sin", "cos", "tan", "Del", "int", "Mod", "log", "pow"],
  ["asin", "acos", "atan", "cosh", "root", "tanh", "sinh"],
  ["acosh", "atanh", "asinh", "Sigma"]
];
function qN(e, t, n, r) {
  for (var o = 0; o < r; o++)
    if (e[n + o] !== t[o])
      return !1;
  return !0;
}
Te.tokenTypes = {
  FUNCTION_WITH_ONE_ARG: 0,
  NUMBER: 1,
  BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
  CONSTANT: 3,
  OPENING_PARENTHESIS: 4,
  CLOSING_PARENTHESIS: 5,
  DECIMAL: 6,
  POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
  FUNCTION_WITH_N_ARGS: 8,
  BINARY_OPERATOR_LOW_PRECENDENCE: 9,
  BINARY_OPERATOR_PERMUTATION: 10,
  COMMA: 11,
  EVALUATED_FUNCTION: 12,
  EVALUATED_FUNCTION_PARAMETER: 13,
  SPACE: 14
};
Te.addToken = function(e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t].token.length, r = -1;
    e[t].type === Te.tokenTypes.FUNCTION_WITH_N_ARGS && e[t].numberOfArguments === void 0 && (e[t].numberOfArguments = 2), Dt[n] = Dt[n] || [];
    for (var o = 0; o < Dt[n].length; o++)
      if (e[t].token === Dt[n][o]) {
        r = Q3(Dt[n][o], lr);
        break;
      }
    r === -1 ? (lr.push(e[t]), e[t].precedence = uu[e[t].type], Dt.length <= e[t].token.length && (Dt[e[t].token.length] = []), Dt[e[t].token.length].push(e[t].token)) : (lr[r] = e[t], e[t].precedence = uu[e[t].type]);
  }
};
function Q3(e, t) {
  for (var n = 0; n < t.length; n++)
    if (t[n].token === e)
      return n;
  return -1;
}
function KN(e) {
  for (var t = [], n = e.length, r, o, a, i = 0; i < n; i++)
    if (!(i < n - 1 && e[i] === " " && e[i + 1] === " ")) {
      for (r = "", o = e.length - i > Dt.length - 2 ? Dt.length - 1 : e.length - i; o > 0; o--)
        if (Dt[o] !== void 0)
          for (a = 0; a < Dt[o].length; a++)
            qN(e, Dt[o][a], i, o) && (r = Dt[o][a], a = Dt[o].length, o = 0);
      if (i += r.length - 1, r === "")
        throw new Te.Exception("Can't understand after " + e.slice(i));
      t.push(lr[Q3(r, lr)]);
    }
  return t;
}
var QN = {
  value: Te.math.changeSign,
  type: 0,
  pre: 21,
  show: "-"
}, Fi = {
  value: ")",
  show: ")",
  type: 5,
  pre: 0
}, ra = {
  value: "(",
  type: 4,
  pre: 0,
  show: "("
};
Te.lex = function(e, t) {
  var n = [ra], r = [], o = e, a = An, i = 0, s = ln, l = "", c;
  typeof t < "u" && Te.addToken(t);
  var d = {}, f = KN(o);
  for (c = 0; c < f.length; c++) {
    var p = f[c];
    if (p.type === 14) {
      if (c > 0 && c < f.length - 1 && f[c + 1].type === 1 && (f[c - 1].type === 1 || f[c - 1].type === 6))
        throw new Te.Exception("Unexpected Space");
      continue;
    }
    var m = p.token, h = p.type, g = p.value, x = p.precedence, y = p.show, b = n[n.length - 1], v;
    for (v = r.length; v-- && r[v] === 0; )
      if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(h) !== -1) {
        if (a[h] !== !0)
          throw new Te.Exception(m + " is not allowed after " + l);
        n.push(Fi), a = io, s = na, r.pop();
      }
    if (a[h] !== !0)
      throw new Te.Exception(m + " is not allowed after " + l);
    if (s[h] === !0 && (h = 2, g = Te.math.mul, y = "&times;", x = 3, c = c - 1), d = {
      value: g,
      type: h,
      pre: x,
      show: y,
      numberOfArguments: p.numberOfArguments
    }, h === 0)
      a = An, s = ln, Nt(r, 2), n.push(d), f[c + 1].type !== 4 && (n.push(ra), r.push(2));
    else if (h === 1)
      b.type === 1 ? (b.value += g, Nt(r, 1)) : n.push(d), a = io, s = GN;
    else if (h === 2)
      a = An, s = ln, Nt(r, 2), n.push(d);
    else if (h === 3)
      n.push(d), a = io, s = na;
    else if (h === 4)
      Nt(r, 1), i++, a = An, s = ln, n.push(d);
    else if (h === 5) {
      if (!i)
        throw new Te.Exception("Closing parenthesis are more than opening one, wait What!!!");
      i--, a = io, s = na, n.push(d), Nt(r, 1);
    } else if (h === 6) {
      if (b.hasDec)
        throw new Te.Exception("Two decimals are not allowed in one number");
      b.type !== 1 && (b = {
        value: 0,
        type: 1,
        pre: 0
      }, n.push(b)), a = XN, Nt(r, 1), s = ln, b.value += g, b.hasDec = !0;
    } else
      h === 7 && (a = io, s = na, Nt(r, 1), n.push(d));
    h === 8 ? (a = An, s = ln, Nt(r, p.numberOfArguments + 2), n.push(d), f[c + 1].type !== 4 && (n.push(ra), r.push(p.numberOfArguments + 2))) : h === 9 ? (b.type === 9 ? b.value === Te.math.add ? (b.value = g, b.show = y, Nt(r, 1)) : b.value === Te.math.sub && y === "-" && (b.value = Te.math.add, b.show = "+", Nt(r, 1)) : b.type !== 5 && b.type !== 7 && b.type !== 1 && b.type !== 3 && b.type !== 13 ? m === "-" && (a = An, s = ln, Nt(r, 2).push(2), n.push(QN), n.push(ra)) : (n.push(d), Nt(r, 2)), a = An, s = ln) : h === 10 ? (a = An, s = ln, Nt(r, 2), n.push(d)) : h === 11 ? (a = An, s = ln, n.push(d)) : h === 12 ? (a = An, s = ln, Nt(r, 6), n.push(d), f[c + 1].type !== 4 && (n.push(ra), r.push(6))) : h === 13 && (a = io, s = na, n.push(d)), Nt(r, -1), l = m;
  }
  for (v = r.length; v--; )
    n.push(Fi);
  if (a[5] !== !0)
    throw new Te.Exception("complete the expression");
  for (; i--; )
    n.push(Fi);
  return n.push(Fi), new Te(n);
};
var ZN = Te, du = ZN;
du.prototype.toPostfix = function() {
  for (var e = [], t, n, r, o, a, i = [{ value: "(", type: 4, pre: 0 }], s = this.value, l = 1; l < s.length; l++)
    if (s[l].type === 1 || s[l].type === 3 || s[l].type === 13)
      s[l].type === 1 && (s[l].value = Number(s[l].value)), e.push(s[l]);
    else if (s[l].type === 4)
      i.push(s[l]);
    else if (s[l].type === 5)
      for (; (n = i.pop()).type !== 4; )
        e.push(n);
    else if (s[l].type === 11) {
      for (; (n = i.pop()).type !== 4; )
        e.push(n);
      i.push(n);
    } else {
      t = s[l], o = t.pre, a = i[i.length - 1], r = a.pre;
      var c = a.value == "Math.pow" && t.value == "Math.pow";
      if (o > r)
        i.push(t);
      else {
        for (; r >= o && !c || c && o < r; )
          n = i.pop(), a = i[i.length - 1], e.push(n), r = a.pre, c = t.value == "Math.pow" && a.value == "Math.pow";
        i.push(t);
      }
    }
  return new du(e);
};
var JN = du, ma = JN;
ma.prototype.postfixEval = function(e) {
  e = e || {}, e.PI = Math.PI, e.E = Math.E;
  for (var t = [], n, r, o, a = this.value, i = typeof e.n < "u", s = 0; s < a.length; s++)
    if (a[s].type === 1)
      t.push({ value: a[s].value, type: 1 });
    else if (a[s].type === 3)
      t.push({ value: e[a[s].value], type: 1 });
    else if (a[s].type === 0)
      typeof t[t.length - 1].type > "u" ? t[t.length - 1].value.push(a[s]) : t[t.length - 1].value = a[s].value(t[t.length - 1].value);
    else if (a[s].type === 7)
      typeof t[t.length - 1].type > "u" ? t[t.length - 1].value.push(a[s]) : t[t.length - 1].value = a[s].value(t[t.length - 1].value);
    else if (a[s].type === 8) {
      for (var l = [], c = 0; c < a[s].numberOfArguments; c++)
        l.push(t.pop().value);
      t.push({ type: 1, value: a[s].value.apply(a[s], l.reverse()) });
    } else
      a[s].type === 10 ? (n = t.pop(), r = t.pop(), typeof r.type > "u" ? (r.value = r.concat(n), r.value.push(a[s]), t.push(r)) : typeof n.type > "u" ? (n.unshift(r), n.push(a[s]), t.push(n)) : t.push({ type: 1, value: a[s].value(r.value, n.value) })) : a[s].type === 2 || a[s].type === 9 ? (n = t.pop(), r = t.pop(), typeof r.type > "u" ? (r = r.concat(n), r.push(a[s]), t.push(r)) : typeof n.type > "u" ? (n.unshift(r), n.push(a[s]), t.push(n)) : t.push({ type: 1, value: a[s].value(r.value, n.value) })) : a[s].type === 12 ? (n = t.pop(), typeof n.type < "u" && (n = [n]), r = t.pop(), o = t.pop(), t.push({ type: 1, value: a[s].value(o.value, r.value, new ma(n)) })) : a[s].type === 13 && (i ? t.push({ value: e[a[s].value], type: 3 }) : t.push([a[s]]));
  if (t.length > 1)
    throw new ma.Exception("Uncaught Syntax error");
  return t[0].value > 1e15 ? "Infinity" : parseFloat(t[0].value.toFixed(15));
};
ma.eval = function(e, t, n) {
  return typeof t > "u" ? this.lex(e).toPostfix().postfixEval() : typeof n > "u" ? typeof t.length < "u" ? this.lex(e, t).toPostfix().postfixEval() : this.lex(e).toPostfix().postfixEval(t) : this.lex(e, t).toPostfix().postfixEval(n);
};
var ek = ma, Z3 = ek;
Z3.prototype.formulaEval = function() {
  for (var e, t, n, r = [], o = this.value, a = 0; a < o.length; a++)
    o[a].type === 1 || o[a].type === 3 ? r.push({ value: o[a].type === 3 ? o[a].show : o[a].value, type: 1 }) : o[a].type === 13 ? r.push({ value: o[a].show, type: 1 }) : o[a].type === 0 ? r[r.length - 1] = { value: o[a].show + (o[a].show != "-" ? "(" : "") + r[r.length - 1].value + (o[a].show != "-" ? ")" : ""), type: 0 } : o[a].type === 7 ? r[r.length - 1] = { value: (r[r.length - 1].type != 1 ? "(" : "") + r[r.length - 1].value + (r[r.length - 1].type != 1 ? ")" : "") + o[a].show, type: 7 } : o[a].type === 10 ? (e = r.pop(), t = r.pop(), o[a].show === "P" || o[a].show === "C" ? r.push({ value: "<sup>" + t.value + "</sup>" + o[a].show + "<sub>" + e.value + "</sub>", type: 10 }) : r.push({ value: (t.type != 1 ? "(" : "") + t.value + (t.type != 1 ? ")" : "") + "<sup>" + e.value + "</sup>", type: 1 })) : o[a].type === 2 || o[a].type === 9 ? (e = r.pop(), t = r.pop(), r.push({ value: (t.type != 1 ? "(" : "") + t.value + (t.type != 1 ? ")" : "") + o[a].show + (e.type != 1 ? "(" : "") + e.value + (e.type != 1 ? ")" : ""), type: o[a].type })) : o[a].type === 12 && (e = r.pop(), t = r.pop(), n = r.pop(), r.push({ value: o[a].show + "(" + n.value + "," + t.value + "," + e.value + ")", type: 12 }));
  return r[0].value;
};
var tk = Z3, nk = zN, rk = VN, ok = tk, ak = 100, ik = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g, cc, sk = lk;
function lk(e, t) {
  cc = 0, t = Math.pow(10, t === void 0 ? 5 : t), e = e.replace(/\n+/g, " ");
  function n(o, a, i) {
    if (cc++ > ak)
      throw cc = 0, new Error("Call stack overflow for " + i);
    if (o === "")
      throw new Error(a + "(): '" + i + "' must contain a non-whitespace string");
    o = r(o, i);
    var s = ck(o);
    if (s.length > 1 || o.indexOf("var(") > -1)
      return a + "(" + o + ")";
    var l = s[0] || "";
    l === "%" && (o = o.replace(/\b[0-9\.]+%/g, function(f) {
      return parseFloat(f.slice(0, -1)) * 0.01;
    }));
    var c = o.replace(new RegExp(l, "gi"), ""), d;
    try {
      d = ok.eval(c);
    } catch {
      return a + "(" + o + ")";
    }
    return l === "%" && (d *= 100), (a.length || l === "%") && (d = Math.round(d * t) / t), d += l, d;
  }
  function r(o, a) {
    o = o.replace(/((?:\-[a-z]+\-)?calc)/g, "");
    for (var i = "", s = o, l; l = ik.exec(s); ) {
      l[0].index > 0 && (i += s.substring(0, l[0].index));
      var c = nk("(", ")", s.substring([0].index));
      if (c.body === "")
        throw new Error("'" + o + "' must contain a non-whitespace string");
      var d = n(c.body, "", a);
      i += c.pre + d, s = c.post;
    }
    return i + s;
  }
  return rk(e, /((?:\-[a-z]+\-)?calc)\(/, n);
}
function ck(e) {
  for (var t = [], n = [], r = /[\.0-9]([%a-z]+)/gi, o = r.exec(e); o; )
    !o || !o[1] || (n.indexOf(o[1].toLowerCase()) === -1 && (t.push(o[1]), n.push(o[1].toLowerCase())), o = r.exec(e));
  return t;
}
const uc = /* @__PURE__ */ Do(sk);
var uk = V3, dk = bl, fk = "[object AsyncFunction]", pk = "[object Function]", hk = "[object GeneratorFunction]", mk = "[object Proxy]";
function gk(e) {
  if (!dk(e))
    return !1;
  var t = uk(e);
  return t == pk || t == hk || t == fk || t == mk;
}
var vk = gk, yk = xl, bk = yk["__core-js_shared__"], xk = bk, dc = xk, wp = function() {
  var e = /[^.]+$/.exec(dc && dc.keys && dc.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function wk(e) {
  return !!wp && wp in e;
}
var Ak = wk, Ck = Function.prototype, Sk = Ck.toString;
function Ek(e) {
  if (e != null) {
    try {
      return Sk.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Mk = Ek, $k = vk, Pk = Ak, Tk = bl, Ok = Mk, Nk = /[\\^$.*+?()[\]{}|]/g, kk = /^\[object .+?Constructor\]$/, Dk = Function.prototype, Fk = Object.prototype, Rk = Dk.toString, _k = Fk.hasOwnProperty, Ik = RegExp(
  "^" + Rk.call(_k).replace(Nk, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Lk(e) {
  if (!Tk(e) || Pk(e))
    return !1;
  var t = $k(e) ? Ik : kk;
  return t.test(Ok(e));
}
var Bk = Lk;
function zk(e, t) {
  return e == null ? void 0 : e[t];
}
var Wk = zk, jk = Bk, Vk = Wk;
function Hk(e, t) {
  var n = Vk(e, t);
  return jk(n) ? n : void 0;
}
var J3 = Hk, Uk = J3, Yk = Uk(Object, "create"), wl = Yk, Ap = wl;
function Gk() {
  this.__data__ = Ap ? Ap(null) : {}, this.size = 0;
}
var Xk = Gk;
function qk(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Kk = qk, Qk = wl, Zk = "__lodash_hash_undefined__", Jk = Object.prototype, eD = Jk.hasOwnProperty;
function tD(e) {
  var t = this.__data__;
  if (Qk) {
    var n = t[e];
    return n === Zk ? void 0 : n;
  }
  return eD.call(t, e) ? t[e] : void 0;
}
var nD = tD, rD = wl, oD = Object.prototype, aD = oD.hasOwnProperty;
function iD(e) {
  var t = this.__data__;
  return rD ? t[e] !== void 0 : aD.call(t, e);
}
var sD = iD, lD = wl, cD = "__lodash_hash_undefined__";
function uD(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = lD && t === void 0 ? cD : t, this;
}
var dD = uD, fD = Xk, pD = Kk, hD = nD, mD = sD, gD = dD;
function Vo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Vo.prototype.clear = fD;
Vo.prototype.delete = pD;
Vo.prototype.get = hD;
Vo.prototype.has = mD;
Vo.prototype.set = gD;
var vD = Vo;
function yD() {
  this.__data__ = [], this.size = 0;
}
var bD = yD;
function xD(e, t) {
  return e === t || e !== e && t !== t;
}
var wD = xD, AD = wD;
function CD(e, t) {
  for (var n = e.length; n--; )
    if (AD(e[n][0], t))
      return n;
  return -1;
}
var Al = CD, SD = Al, ED = Array.prototype, MD = ED.splice;
function $D(e) {
  var t = this.__data__, n = SD(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : MD.call(t, n, 1), --this.size, !0;
}
var PD = $D, TD = Al;
function OD(e) {
  var t = this.__data__, n = TD(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var ND = OD, kD = Al;
function DD(e) {
  return kD(this.__data__, e) > -1;
}
var FD = DD, RD = Al;
function _D(e, t) {
  var n = this.__data__, r = RD(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var ID = _D, LD = bD, BD = PD, zD = ND, WD = FD, jD = ID;
function Ho(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ho.prototype.clear = LD;
Ho.prototype.delete = BD;
Ho.prototype.get = zD;
Ho.prototype.has = WD;
Ho.prototype.set = jD;
var VD = Ho, HD = J3, UD = xl, YD = HD(UD, "Map"), GD = YD, Cp = vD, XD = VD, qD = GD;
function KD() {
  this.size = 0, this.__data__ = {
    hash: new Cp(),
    map: new (qD || XD)(),
    string: new Cp()
  };
}
var QD = KD;
function ZD(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var JD = ZD, eF = JD;
function tF(e, t) {
  var n = e.__data__;
  return eF(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Cl = tF, nF = Cl;
function rF(e) {
  var t = nF(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var oF = rF, aF = Cl;
function iF(e) {
  return aF(this, e).get(e);
}
var sF = iF, lF = Cl;
function cF(e) {
  return lF(this, e).has(e);
}
var uF = cF, dF = Cl;
function fF(e, t) {
  var n = dF(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var pF = fF, hF = QD, mF = oF, gF = sF, vF = uF, yF = pF;
function Uo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Uo.prototype.clear = hF;
Uo.prototype.delete = mF;
Uo.prototype.get = gF;
Uo.prototype.has = vF;
Uo.prototype.set = yF;
var bF = Uo, e5 = bF, xF = "Expected a function";
function Pf(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(xF);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(o))
      return a.get(o);
    var i = e.apply(this, r);
    return n.cache = a.set(o, i) || a, i;
  };
  return n.cache = new (Pf.Cache || e5)(), n;
}
Pf.Cache = e5;
var wF = Pf;
const AF = /* @__PURE__ */ Do(wF);
var Sp = "__react_svg_text_measurement_id";
function CF(e, t) {
  try {
    var n = document.getElementById(Sp);
    if (!n) {
      var r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      r.setAttribute("aria-hidden", "true"), r.style.width = "0", r.style.height = "0", r.style.position = "absolute", r.style.top = "-100%", r.style.left = "-100%", n = document.createElementNS("http://www.w3.org/2000/svg", "text"), n.setAttribute("id", Sp), r.appendChild(n), document.body.appendChild(r);
    }
    return Object.assign(n.style, t), n.textContent = e, n.getComputedTextLength();
  } catch {
    return null;
  }
}
const Ep = AF(CF, function(e, t) {
  return e + "_" + JSON.stringify(t);
});
var SF = ["verticalAnchor", "scaleToFit", "angle", "width", "lineHeight", "capHeight", "children", "style"];
function EF(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function fc(e) {
  return typeof e == "number";
}
function Mp(e) {
  return (
    // number that is not NaN or Infinity
    typeof e == "number" && Number.isFinite(e) || // for percentage
    typeof e == "string"
  );
}
function MF(e) {
  var t = e.verticalAnchor, n = t === void 0 ? "end" : t, r = e.scaleToFit, o = r === void 0 ? !1 : r, a = e.angle, i = e.width, s = e.lineHeight, l = s === void 0 ? "1em" : s, c = e.capHeight, d = c === void 0 ? "0.71em" : c, f = e.children, p = e.style, m = EF(e, SF), h = m.x, g = h === void 0 ? 0 : h, x = m.y, y = x === void 0 ? 0 : x, b = !Mp(g) || !Mp(y), v = Se(function() {
    var E = f == null ? [] : f.toString().split(/(?:(?!\u00A0+)\s+)/);
    return {
      wordsWithWidth: E.map(function(T) {
        return {
          word: T,
          wordWidth: Ep(T, p) || 0
        };
      }),
      spaceWidth: Ep(" ", p) || 0
    };
  }, [f, p]), A = v.wordsWithWidth, w = v.spaceWidth, M = Se(function() {
    return b ? [] : i || o ? A.reduce(function(E, T) {
      var B = T.word, j = T.wordWidth, V = E[E.length - 1];
      if (V && (i == null || o || (V.width || 0) + j + w < i))
        V.words.push(B), V.width = V.width || 0, V.width += j + w;
      else {
        var W = {
          words: [B],
          width: j
        };
        E.push(W);
      }
      return E;
    }, []) : [{
      words: f == null ? [] : f.toString().split(/(?:(?!\u00A0+)\s+)/)
    }];
  }, [b, i, o, f, A, w]), $ = Se(function() {
    var E = b ? "" : uc(n === "start" ? "calc(" + d + ")" : n === "middle" ? "calc(" + (M.length - 1) / 2 + " * -" + l + " + (" + d + " / 2))" : "calc(" + (M.length - 1) + " * -" + l + ")");
    return E;
  }, [b, n, d, M.length, l]), P = Se(function() {
    var E = [];
    if (b)
      return "";
    if (fc(g) && fc(y) && fc(i) && o && M.length > 0) {
      var T = M[0].width || 1, B = o === "shrink-only" ? Math.min(i / T, 1) : i / T, j = B, V = g - B * g, W = y - j * y;
      E.push("matrix(" + B + ", 0, 0, " + j + ", " + V + ", " + W + ")");
    }
    return a && E.push("rotate(" + a + ", " + g + ", " + y + ")"), E.length > 0 ? E.join(" ") : "";
  }, [b, g, y, i, o, M, a]);
  return {
    wordsByLines: M,
    startDy: $,
    transform: P
  };
}
var $F = ["dx", "dy", "textAnchor", "innerRef", "innerTextRef", "verticalAnchor", "angle", "lineHeight", "scaleToFit", "capHeight", "width"];
function fu() {
  return fu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fu.apply(this, arguments);
}
function PF(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var TF = {
  overflow: "visible"
};
function Ga(e) {
  var t = e.dx, n = t === void 0 ? 0 : t, r = e.dy, o = r === void 0 ? 0 : r, a = e.textAnchor, i = a === void 0 ? "start" : a, s = e.innerRef, l = e.innerTextRef;
  e.verticalAnchor, e.angle;
  var c = e.lineHeight, d = c === void 0 ? "1em" : c;
  e.scaleToFit, e.capHeight, e.width;
  var f = PF(e, $F), p = f.x, m = p === void 0 ? 0 : p, h = f.fontSize, g = MF(e), x = g.wordsByLines, y = g.startDy, b = g.transform;
  return /* @__PURE__ */ R.createElement("svg", {
    ref: s,
    x: n,
    y: o,
    fontSize: h,
    style: TF
  }, x.length > 0 ? /* @__PURE__ */ R.createElement("text", fu({
    ref: l,
    transform: b
  }, f, {
    textAnchor: i
  }), x.map(function(v, A) {
    return /* @__PURE__ */ R.createElement("tspan", {
      key: A,
      x: m,
      dy: A === 0 ? y : d
    }, v.words.join(" "));
  })) : null);
}
function pu(e, t, n) {
  var r, o, a, i, s;
  t == null && (t = 100);
  function l() {
    var d = Date.now() - i;
    d < t && d >= 0 ? r = setTimeout(l, t - d) : (r = null, n || (s = e.apply(a, o), a = o = null));
  }
  var c = function() {
    a = this, o = arguments, i = Date.now();
    var d = n && !r;
    return r || (r = setTimeout(l, t)), d && (s = e.apply(a, o), a = o = null), s;
  };
  return c.clear = function() {
    r && (clearTimeout(r), r = null);
  }, c.flush = function() {
    r && (s = e.apply(a, o), a = o = null, clearTimeout(r), r = null);
  }, c;
}
pu.debounce = pu;
var OF = pu;
const $p = /* @__PURE__ */ Do(OF);
function NF(e) {
  let {
    debounce: t,
    scroll: n,
    polyfill: r,
    offsetSize: o
  } = e === void 0 ? {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
  } : e;
  const a = r || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!a)
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [i, s] = we({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  }), l = de({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: i
  }), c = t ? typeof t == "number" ? t : t.scroll : null, d = t ? typeof t == "number" ? t : t.resize : null, f = de(!1);
  Ce(() => (f.current = !0, () => void (f.current = !1)));
  const [p, m, h] = Se(() => {
    const b = () => {
      if (!l.current.element)
        return;
      const {
        left: v,
        top: A,
        width: w,
        height: M,
        bottom: $,
        right: P,
        x: E,
        y: T
      } = l.current.element.getBoundingClientRect(), B = {
        left: v,
        top: A,
        width: w,
        height: M,
        bottom: $,
        right: P,
        x: E,
        y: T
      };
      l.current.element instanceof HTMLElement && o && (B.height = l.current.element.offsetHeight, B.width = l.current.element.offsetWidth), Object.freeze(B), f.current && !RF(l.current.lastBounds, B) && s(l.current.lastBounds = B);
    };
    return [b, d ? $p(b, d) : b, c ? $p(b, c) : b];
  }, [s, o, c, d]);
  function g() {
    l.current.scrollContainers && (l.current.scrollContainers.forEach((b) => b.removeEventListener("scroll", h, !0)), l.current.scrollContainers = null), l.current.resizeObserver && (l.current.resizeObserver.disconnect(), l.current.resizeObserver = null);
  }
  function x() {
    l.current.element && (l.current.resizeObserver = new a(h), l.current.resizeObserver.observe(l.current.element), n && l.current.scrollContainers && l.current.scrollContainers.forEach((b) => b.addEventListener("scroll", h, {
      capture: !0,
      passive: !0
    })));
  }
  const y = (b) => {
    !b || b === l.current.element || (g(), l.current.element = b, l.current.scrollContainers = t5(b), x());
  };
  return DF(h, !!n), kF(m), Ce(() => {
    g(), x();
  }, [n, h, m]), Ce(() => g, []), [y, i, p];
}
function kF(e) {
  Ce(() => {
    const t = e;
    return window.addEventListener("resize", t), () => void window.removeEventListener("resize", t);
  }, [e]);
}
function DF(e, t) {
  Ce(() => {
    if (t) {
      const n = e;
      return window.addEventListener("scroll", n, {
        capture: !0,
        passive: !0
      }), () => void window.removeEventListener("scroll", n, !0);
    }
  }, [e, t]);
}
function t5(e) {
  const t = [];
  if (!e || e === document.body)
    return t;
  const {
    overflow: n,
    overflowX: r,
    overflowY: o
  } = window.getComputedStyle(e);
  return [n, r, o].some((a) => a === "auto" || a === "scroll") && t.push(e), [...t, ...t5(e.parentElement)];
}
const FF = ["x", "y", "top", "bottom", "left", "right", "width", "height"], RF = (e, t) => FF.every((n) => e[n] === t[n]);
var Wn = /* @__PURE__ */ function() {
  function e(n) {
    var r = n.x, o = r === void 0 ? 0 : r, a = n.y, i = a === void 0 ? 0 : a;
    this.x = 0, this.y = 0, this.x = o, this.y = i;
  }
  var t = e.prototype;
  return t.value = function() {
    return {
      x: this.x,
      y: this.y
    };
  }, t.toArray = function() {
    return [this.x, this.y];
  }, e;
}();
function _F(e, t) {
  return new Wn({
    x: e.x + t.x,
    y: e.y + t.y
  });
}
function IF(e, t) {
  return new Wn({
    x: e.x - t.x,
    y: e.y - t.y
  });
}
const LF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Point: Wn,
  subtractPoints: IF,
  sumPoints: _F
}, Symbol.toStringTag, { value: "Module" })), n5 = /* @__PURE__ */ Vr(LF);
function BF(e) {
  return !!e && e instanceof Element;
}
function zF(e) {
  return !!e && (e instanceof SVGElement || "ownerSVGElement" in e);
}
function WF(e) {
  return !!e && "createSVGPoint" in e;
}
function jF(e) {
  return !!e && "getScreenCTM" in e;
}
function VF(e) {
  return !!e && "changedTouches" in e;
}
function HF(e) {
  return !!e && "clientX" in e;
}
function UF(e) {
  return !!e && (e instanceof Event || "nativeEvent" in e && e.nativeEvent instanceof Event);
}
function ga() {
  return ga = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ga.apply(this, arguments);
}
var pc = {
  x: 0,
  y: 0
};
function YF(e) {
  if (!e)
    return ga({}, pc);
  if (VF(e))
    return e.changedTouches.length > 0 ? {
      x: e.changedTouches[0].clientX,
      y: e.changedTouches[0].clientY
    } : ga({}, pc);
  if (HF(e))
    return {
      x: e.clientX,
      y: e.clientY
    };
  var t = e == null ? void 0 : e.target, n = t && "getBoundingClientRect" in t ? t.getBoundingClientRect() : null;
  return n ? {
    x: n.x + n.width / 2,
    y: n.y + n.height / 2
  } : ga({}, pc);
}
function Pp(e, t) {
  if (!e || !t)
    return null;
  var n = YF(t), r = zF(e) ? e.ownerSVGElement : e, o = jF(r) ? r.getScreenCTM() : null;
  if (WF(r) && o) {
    var a = r.createSVGPoint();
    return a.x = n.x, a.y = n.y, a = a.matrixTransform(o.inverse()), new Wn({
      x: a.x,
      y: a.y
    });
  }
  var i = e.getBoundingClientRect();
  return new Wn({
    x: n.x - i.left - e.clientLeft,
    y: n.y - i.top - e.clientTop
  });
}
function GF(e, t) {
  if (BF(e) && t)
    return Pp(e, t);
  if (UF(e)) {
    var n = e, r = n.target;
    if (r)
      return Pp(r, n);
  }
  return null;
}
function cr(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function XF(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Tf(e) {
  let t, n, r;
  e.length !== 2 ? (t = cr, n = (s, l) => cr(e(s), l), r = (s, l) => e(s) - l) : (t = e === cr || e === XF ? e : qF, n = e, r = e);
  function o(s, l, c = 0, d = s.length) {
    if (c < d) {
      if (t(l, l) !== 0)
        return d;
      do {
        const f = c + d >>> 1;
        n(s[f], l) < 0 ? c = f + 1 : d = f;
      } while (c < d);
    }
    return c;
  }
  function a(s, l, c = 0, d = s.length) {
    if (c < d) {
      if (t(l, l) !== 0)
        return d;
      do {
        const f = c + d >>> 1;
        n(s[f], l) <= 0 ? c = f + 1 : d = f;
      } while (c < d);
    }
    return c;
  }
  function i(s, l, c = 0, d = s.length) {
    const f = o(s, l, c, d - 1);
    return f > c && r(s[f - 1], l) > -r(s[f], l) ? f - 1 : f;
  }
  return { left: o, center: i, right: a };
}
function qF() {
  return 0;
}
function r5(e) {
  return e === null ? NaN : +e;
}
function* KF(e, t) {
  if (t === void 0)
    for (let n of e)
      n != null && (n = +n) >= n && (yield n);
  else {
    let n = -1;
    for (let r of e)
      (r = t(r, ++n, e)) != null && (r = +r) >= r && (yield r);
  }
}
const QF = Tf(cr), ZF = QF.right;
Tf(r5).center;
const Yo = ZF;
function JF(e, t) {
  let n = 0;
  if (t === void 0)
    for (let r of e)
      r != null && (r = +r) >= r && ++n;
  else {
    let r = -1;
    for (let o of e)
      (o = t(o, ++r, e)) != null && (o = +o) >= o && ++n;
  }
  return n;
}
function es(e, t) {
  let n, r;
  if (t === void 0)
    for (const o of e)
      o != null && (n === void 0 ? o >= o && (n = r = o) : (n > o && (n = o), r < o && (r = o)));
  else {
    let o = -1;
    for (let a of e)
      (a = t(a, ++o, e)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  }
  return [n, r];
}
class Tp extends Map {
  constructor(t, n = nR) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null)
      for (const [r, o] of t)
        this.set(r, o);
  }
  get(t) {
    return super.get(Op(this, t));
  }
  has(t) {
    return super.has(Op(this, t));
  }
  set(t, n) {
    return super.set(eR(this, t), n);
  }
  delete(t) {
    return super.delete(tR(this, t));
  }
}
function Op({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function eR({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function tR({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function nR(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function rR(e) {
  return e;
}
function oR(e = cr) {
  if (e === cr)
    return o5;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function o5(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
var aR = Array.prototype, iR = aR.slice;
function hc(e) {
  return () => e;
}
const sR = Math.sqrt(50), lR = Math.sqrt(10), cR = Math.sqrt(2);
function Cs(e, t, n) {
  const r = (t - e) / Math.max(0, n), o = Math.floor(Math.log10(r)), a = r / Math.pow(10, o), i = a >= sR ? 10 : a >= lR ? 5 : a >= cR ? 2 : 1;
  let s, l, c;
  return o < 0 ? (c = Math.pow(10, -o) / i, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, o) * i, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= n && n < 2 ? Cs(e, t, n * 2) : [s, l, c];
}
function Ss(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0))
    return [];
  if (e === t)
    return [e];
  const r = t < e, [o, a, i] = r ? Cs(t, e, n) : Cs(e, t, n);
  if (!(a >= o))
    return [];
  const s = a - o + 1, l = new Array(s);
  if (r)
    if (i < 0)
      for (let c = 0; c < s; ++c)
        l[c] = (a - c) / -i;
    else
      for (let c = 0; c < s; ++c)
        l[c] = (a - c) * i;
  else if (i < 0)
    for (let c = 0; c < s; ++c)
      l[c] = (o + c) / -i;
  else
    for (let c = 0; c < s; ++c)
      l[c] = (o + c) * i;
  return l;
}
function $o(e, t, n) {
  return t = +t, e = +e, n = +n, Cs(e, t, n)[2];
}
function hu(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, o = r ? $o(t, e, n) : $o(e, t, n);
  return (r ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
function uR(e, t, n) {
  let r;
  for (; ; ) {
    const o = $o(e, t, n);
    if (o === r || o === 0 || !isFinite(o))
      return [e, t];
    o > 0 ? (e = Math.floor(e / o) * o, t = Math.ceil(t / o) * o) : o < 0 && (e = Math.ceil(e * o) / o, t = Math.floor(t * o) / o), r = o;
  }
}
function dR(e) {
  return Math.max(1, Math.ceil(Math.log(JF(e)) / Math.LN2) + 1);
}
function fR() {
  var e = rR, t = es, n = dR;
  function r(o) {
    Array.isArray(o) || (o = Array.from(o));
    var a, i = o.length, s, l, c = new Array(i);
    for (a = 0; a < i; ++a)
      c[a] = e(o[a], a, o);
    var d = t(c), f = d[0], p = d[1], m = n(c, f, p);
    if (!Array.isArray(m)) {
      const v = p, A = +m;
      if (t === es && ([f, p] = uR(f, p, A)), m = Ss(f, p, A), m[0] <= f && (l = $o(f, p, A)), m[m.length - 1] >= p)
        if (v >= p && t === es) {
          const w = $o(f, p, A);
          isFinite(w) && (w > 0 ? p = (Math.floor(p / w) + 1) * w : w < 0 && (p = (Math.ceil(p * -w) + 1) / -w));
        } else
          m.pop();
    }
    for (var h = m.length, g = 0, x = h; m[g] <= f; )
      ++g;
    for (; m[x - 1] > p; )
      --x;
    (g || x < h) && (m = m.slice(g, x), h = x - g);
    var y = new Array(h + 1), b;
    for (a = 0; a <= h; ++a)
      b = y[a] = [], b.x0 = a > 0 ? m[a - 1] : f, b.x1 = a < h ? m[a] : p;
    if (isFinite(l)) {
      if (l > 0)
        for (a = 0; a < i; ++a)
          (s = c[a]) != null && f <= s && s <= p && y[Math.min(h, Math.floor((s - f) / l))].push(o[a]);
      else if (l < 0) {
        for (a = 0; a < i; ++a)
          if ((s = c[a]) != null && f <= s && s <= p) {
            const v = Math.floor((f - s) * l);
            y[Math.min(h, v + (m[v] <= s))].push(o[a]);
          }
      }
    } else
      for (a = 0; a < i; ++a)
        (s = c[a]) != null && f <= s && s <= p && y[Yo(m, s, 0, h)].push(o[a]);
    return y;
  }
  return r.value = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : hc(o), r) : e;
  }, r.domain = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : hc([o[0], o[1]]), r) : t;
  }, r.thresholds = function(o) {
    return arguments.length ? (n = typeof o == "function" ? o : hc(Array.isArray(o) ? iR.call(o) : o), r) : n;
  }, r;
}
function mu(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let o of e)
      (o = t(o, ++r, e)) != null && (n < o || n === void 0 && o >= o) && (n = o);
  }
  return n;
}
function Np(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let o of e)
      (o = t(o, ++r, e)) != null && (n > o || n === void 0 && o >= o) && (n = o);
  }
  return n;
}
function a5(e, t, n = 0, r = 1 / 0, o) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r))
    return e;
  for (o = o === void 0 ? o5 : oR(o); r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, c = t - n + 1, d = Math.log(l), f = 0.5 * Math.exp(2 * d / 3), p = 0.5 * Math.sqrt(d * f * (l - f) / l) * (c - l / 2 < 0 ? -1 : 1), m = Math.max(n, Math.floor(t - c * f / l + p)), h = Math.min(r, Math.floor(t + (l - c) * f / l + p));
      a5(e, t, m, h, o);
    }
    const a = e[t];
    let i = n, s = r;
    for (oa(e, n, t), o(e[r], a) > 0 && oa(e, n, r); i < s; ) {
      for (oa(e, i, s), ++i, --s; o(e[i], a) < 0; )
        ++i;
      for (; o(e[s], a) > 0; )
        --s;
    }
    o(e[n], a) === 0 ? oa(e, n, s) : (++s, oa(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function oa(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function pR(e, t, n) {
  if (e = Float64Array.from(KF(e, n)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2)
      return Np(e);
    if (t >= 1)
      return mu(e);
    var r, o = (r - 1) * t, a = Math.floor(o), i = mu(a5(e, a).subarray(0, a + 1)), s = Np(e.subarray(a + 1));
    return i + (s - i) * (o - a);
  }
}
function hR(e, t, n = r5) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2)
      return +n(e[0], 0, e);
    if (t >= 1)
      return +n(e[r - 1], r - 1, e);
    var r, o = (r - 1) * t, a = Math.floor(o), i = +n(e[a], a, e), s = +n(e[a + 1], a + 1, e);
    return i + (s - i) * (o - a);
  }
}
function mR(e, t, n) {
  e = +e, t = +t, n = (o = arguments.length) < 2 ? (t = e, e = 0, 1) : o < 3 ? 1 : +n;
  for (var r = -1, o = Math.max(0, Math.ceil((t - e) / n)) | 0, a = new Array(o); ++r < o; )
    a[r] = e + r * n;
  return a;
}
function on(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Gn(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const gu = Symbol("implicit");
function Sl() {
  var e = new Tp(), t = [], n = [], r = gu;
  function o(a) {
    let i = e.get(a);
    if (i === void 0) {
      if (r !== gu)
        return r;
      e.set(a, i = t.push(a) - 1);
    }
    return n[i % n.length];
  }
  return o.domain = function(a) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new Tp();
    for (const i of a)
      e.has(i) || e.set(i, t.push(i) - 1);
    return o;
  }, o.range = function(a) {
    return arguments.length ? (n = Array.from(a), o) : n.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.copy = function() {
    return Sl(t, n).unknown(r);
  }, on.apply(o, arguments), o;
}
function El() {
  var e = Sl().unknown(void 0), t = e.domain, n = e.range, r = 0, o = 1, a, i, s = !1, l = 0, c = 0, d = 0.5;
  delete e.unknown;
  function f() {
    var p = t().length, m = o < r, h = m ? o : r, g = m ? r : o;
    a = (g - h) / Math.max(1, p - l + c * 2), s && (a = Math.floor(a)), h += (g - h - a * (p - l)) * d, i = a * (1 - l), s && (h = Math.round(h), i = Math.round(i));
    var x = mR(p).map(function(y) {
      return h + a * y;
    });
    return n(m ? x.reverse() : x);
  }
  return e.domain = function(p) {
    return arguments.length ? (t(p), f()) : t();
  }, e.range = function(p) {
    return arguments.length ? ([r, o] = p, r = +r, o = +o, f()) : [r, o];
  }, e.rangeRound = function(p) {
    return [r, o] = p, r = +r, o = +o, s = !0, f();
  }, e.bandwidth = function() {
    return i;
  }, e.step = function() {
    return a;
  }, e.round = function(p) {
    return arguments.length ? (s = !!p, f()) : s;
  }, e.padding = function(p) {
    return arguments.length ? (l = Math.min(1, c = +p), f()) : l;
  }, e.paddingInner = function(p) {
    return arguments.length ? (l = Math.min(1, p), f()) : l;
  }, e.paddingOuter = function(p) {
    return arguments.length ? (c = +p, f()) : c;
  }, e.align = function(p) {
    return arguments.length ? (d = Math.max(0, Math.min(1, p)), f()) : d;
  }, e.copy = function() {
    return El(t(), [r, o]).round(s).paddingInner(l).paddingOuter(c).align(d);
  }, on.apply(f(), arguments);
}
function i5(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return i5(t());
  }, e;
}
function s5() {
  return i5(El.apply(null, arguments).paddingInner(1));
}
function Go(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function Xa(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t)
    n[r] = t[r];
  return n;
}
function wr() {
}
var Ir = 0.7, Po = 1 / Ir, ho = "\\s*([+-]?\\d+)\\s*", Ta = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", En = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", gR = /^#([0-9a-f]{3,8})$/, vR = new RegExp(`^rgb\\(${ho},${ho},${ho}\\)$`), yR = new RegExp(`^rgb\\(${En},${En},${En}\\)$`), bR = new RegExp(`^rgba\\(${ho},${ho},${ho},${Ta}\\)$`), xR = new RegExp(`^rgba\\(${En},${En},${En},${Ta}\\)$`), wR = new RegExp(`^hsl\\(${Ta},${En},${En}\\)$`), AR = new RegExp(`^hsla\\(${Ta},${En},${En},${Ta}\\)$`), kp = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Go(wr, Oa, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Dp,
  // Deprecated! Use color.formatHex.
  formatHex: Dp,
  formatHex8: CR,
  formatHsl: SR,
  formatRgb: Fp,
  toString: Fp
});
function Dp() {
  return this.rgb().formatHex();
}
function CR() {
  return this.rgb().formatHex8();
}
function SR() {
  return l5(this).formatHsl();
}
function Fp() {
  return this.rgb().formatRgb();
}
function Oa(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = gR.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Rp(t) : n === 3 ? new ht(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Ri(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Ri(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = vR.exec(e)) ? new ht(t[1], t[2], t[3], 1) : (t = yR.exec(e)) ? new ht(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = bR.exec(e)) ? Ri(t[1], t[2], t[3], t[4]) : (t = xR.exec(e)) ? Ri(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = wR.exec(e)) ? Lp(t[1], t[2] / 100, t[3] / 100, 1) : (t = AR.exec(e)) ? Lp(t[1], t[2] / 100, t[3] / 100, t[4]) : kp.hasOwnProperty(e) ? Rp(kp[e]) : e === "transparent" ? new ht(NaN, NaN, NaN, 0) : null;
}
function Rp(e) {
  return new ht(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Ri(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new ht(e, t, n, r);
}
function Of(e) {
  return e instanceof wr || (e = Oa(e)), e ? (e = e.rgb(), new ht(e.r, e.g, e.b, e.opacity)) : new ht();
}
function Es(e, t, n, r) {
  return arguments.length === 1 ? Of(e) : new ht(e, t, n, r ?? 1);
}
function ht(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Go(ht, Es, Xa(wr, {
  brighter(e) {
    return e = e == null ? Po : Math.pow(Po, e), new ht(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ir : Math.pow(Ir, e), new ht(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new ht(Dr(this.r), Dr(this.g), Dr(this.b), Ms(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: _p,
  // Deprecated! Use color.formatHex.
  formatHex: _p,
  formatHex8: ER,
  formatRgb: Ip,
  toString: Ip
}));
function _p() {
  return `#${Or(this.r)}${Or(this.g)}${Or(this.b)}`;
}
function ER() {
  return `#${Or(this.r)}${Or(this.g)}${Or(this.b)}${Or((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Ip() {
  const e = Ms(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Dr(this.r)}, ${Dr(this.g)}, ${Dr(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Ms(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Dr(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Or(e) {
  return e = Dr(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Lp(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new dn(e, t, n, r);
}
function l5(e) {
  if (e instanceof dn)
    return new dn(e.h, e.s, e.l, e.opacity);
  if (e instanceof wr || (e = Oa(e)), !e)
    return new dn();
  if (e instanceof dn)
    return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = Math.min(t, n, r), a = Math.max(t, n, r), i = NaN, s = a - o, l = (a + o) / 2;
  return s ? (t === a ? i = (n - r) / s + (n < r) * 6 : n === a ? i = (r - t) / s + 2 : i = (t - n) / s + 4, s /= l < 0.5 ? a + o : 2 - a - o, i *= 60) : s = l > 0 && l < 1 ? 0 : i, new dn(i, s, l, e.opacity);
}
function vu(e, t, n, r) {
  return arguments.length === 1 ? l5(e) : new dn(e, t, n, r ?? 1);
}
function dn(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Go(dn, vu, Xa(wr, {
  brighter(e) {
    return e = e == null ? Po : Math.pow(Po, e), new dn(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ir : Math.pow(Ir, e), new dn(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, o = 2 * n - r;
    return new ht(
      mc(e >= 240 ? e - 240 : e + 120, o, r),
      mc(e, o, r),
      mc(e < 120 ? e + 240 : e - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new dn(Bp(this.h), _i(this.s), _i(this.l), Ms(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Ms(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Bp(this.h)}, ${_i(this.s) * 100}%, ${_i(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Bp(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function _i(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function mc(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const c5 = Math.PI / 180, u5 = 180 / Math.PI, $s = 18, d5 = 0.96422, f5 = 1, p5 = 0.82521, h5 = 4 / 29, mo = 6 / 29, m5 = 3 * mo * mo, MR = mo * mo * mo;
function g5(e) {
  if (e instanceof Mn)
    return new Mn(e.l, e.a, e.b, e.opacity);
  if (e instanceof Rn)
    return v5(e);
  e instanceof ht || (e = Of(e));
  var t = bc(e.r), n = bc(e.g), r = bc(e.b), o = gc((0.2225045 * t + 0.7168786 * n + 0.0606169 * r) / f5), a, i;
  return t === n && n === r ? a = i = o : (a = gc((0.4360747 * t + 0.3850649 * n + 0.1430804 * r) / d5), i = gc((0.0139322 * t + 0.0971045 * n + 0.7141733 * r) / p5)), new Mn(116 * o - 16, 500 * (a - o), 200 * (o - i), e.opacity);
}
function yu(e, t, n, r) {
  return arguments.length === 1 ? g5(e) : new Mn(e, t, n, r ?? 1);
}
function Mn(e, t, n, r) {
  this.l = +e, this.a = +t, this.b = +n, this.opacity = +r;
}
Go(Mn, yu, Xa(wr, {
  brighter(e) {
    return new Mn(this.l + $s * (e ?? 1), this.a, this.b, this.opacity);
  },
  darker(e) {
    return new Mn(this.l - $s * (e ?? 1), this.a, this.b, this.opacity);
  },
  rgb() {
    var e = (this.l + 16) / 116, t = isNaN(this.a) ? e : e + this.a / 500, n = isNaN(this.b) ? e : e - this.b / 200;
    return t = d5 * vc(t), e = f5 * vc(e), n = p5 * vc(n), new ht(
      yc(3.1338561 * t - 1.6168667 * e - 0.4906146 * n),
      yc(-0.9787684 * t + 1.9161415 * e + 0.033454 * n),
      yc(0.0719453 * t - 0.2289914 * e + 1.4052427 * n),
      this.opacity
    );
  }
}));
function gc(e) {
  return e > MR ? Math.pow(e, 1 / 3) : e / m5 + h5;
}
function vc(e) {
  return e > mo ? e * e * e : m5 * (e - h5);
}
function yc(e) {
  return 255 * (e <= 31308e-7 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055);
}
function bc(e) {
  return (e /= 255) <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
}
function $R(e) {
  if (e instanceof Rn)
    return new Rn(e.h, e.c, e.l, e.opacity);
  if (e instanceof Mn || (e = g5(e)), e.a === 0 && e.b === 0)
    return new Rn(NaN, 0 < e.l && e.l < 100 ? 0 : NaN, e.l, e.opacity);
  var t = Math.atan2(e.b, e.a) * u5;
  return new Rn(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
}
function bu(e, t, n, r) {
  return arguments.length === 1 ? $R(e) : new Rn(e, t, n, r ?? 1);
}
function Rn(e, t, n, r) {
  this.h = +e, this.c = +t, this.l = +n, this.opacity = +r;
}
function v5(e) {
  if (isNaN(e.h))
    return new Mn(e.l, 0, 0, e.opacity);
  var t = e.h * c5;
  return new Mn(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
}
Go(Rn, bu, Xa(wr, {
  brighter(e) {
    return new Rn(this.h, this.c, this.l + $s * (e ?? 1), this.opacity);
  },
  darker(e) {
    return new Rn(this.h, this.c, this.l - $s * (e ?? 1), this.opacity);
  },
  rgb() {
    return v5(this).rgb();
  }
}));
var y5 = -0.14861, Nf = 1.78277, kf = -0.29227, Ml = -0.90649, Na = 1.97294, zp = Na * Ml, Wp = Na * Nf, jp = Nf * kf - Ml * y5;
function PR(e) {
  if (e instanceof Fr)
    return new Fr(e.h, e.s, e.l, e.opacity);
  e instanceof ht || (e = Of(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = (jp * r + zp * t - Wp * n) / (jp + zp - Wp), a = r - o, i = (Na * (n - o) - kf * a) / Ml, s = Math.sqrt(i * i + a * a) / (Na * o * (1 - o)), l = s ? Math.atan2(i, a) * u5 - 120 : NaN;
  return new Fr(l < 0 ? l + 360 : l, s, o, e.opacity);
}
function xu(e, t, n, r) {
  return arguments.length === 1 ? PR(e) : new Fr(e, t, n, r ?? 1);
}
function Fr(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Go(Fr, xu, Xa(wr, {
  brighter(e) {
    return e = e == null ? Po : Math.pow(Po, e), new Fr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Ir : Math.pow(Ir, e), new Fr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * c5, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), o = Math.sin(e);
    return new ht(
      255 * (t + n * (y5 * r + Nf * o)),
      255 * (t + n * (kf * r + Ml * o)),
      255 * (t + n * (Na * r)),
      this.opacity
    );
  }
}));
function b5(e, t, n, r, o) {
  var a = e * e, i = a * e;
  return ((1 - 3 * e + 3 * a - i) * t + (4 - 6 * a + 3 * i) * n + (1 + 3 * e + 3 * a - 3 * i) * r + i * o) / 6;
}
function x5(e) {
  var t = e.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), o = e[r], a = e[r + 1], i = r > 0 ? e[r - 1] : 2 * o - a, s = r < t - 1 ? e[r + 2] : 2 * a - o;
    return b5((n - r / t) * t, i, o, a, s);
  };
}
function w5(e) {
  var t = e.length;
  return function(n) {
    var r = Math.floor(((n %= 1) < 0 ? ++n : n) * t), o = e[(r + t - 1) % t], a = e[r % t], i = e[(r + 1) % t], s = e[(r + 2) % t];
    return b5((n - r / t) * t, o, a, i, s);
  };
}
const $l = (e) => () => e;
function A5(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function TR(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Pl(e, t) {
  var n = t - e;
  return n ? A5(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : $l(isNaN(e) ? t : e);
}
function OR(e) {
  return (e = +e) == 1 ? mt : function(t, n) {
    return n - t ? TR(t, n, e) : $l(isNaN(t) ? n : t);
  };
}
function mt(e, t) {
  var n = t - e;
  return n ? A5(e, n) : $l(isNaN(e) ? t : e);
}
const Ps = function e(t) {
  var n = OR(t);
  function r(o, a) {
    var i = n((o = Es(o)).r, (a = Es(a)).r), s = n(o.g, a.g), l = n(o.b, a.b), c = mt(o.opacity, a.opacity);
    return function(d) {
      return o.r = i(d), o.g = s(d), o.b = l(d), o.opacity = c(d), o + "";
    };
  }
  return r.gamma = e, r;
}(1);
function C5(e) {
  return function(t) {
    var n = t.length, r = new Array(n), o = new Array(n), a = new Array(n), i, s;
    for (i = 0; i < n; ++i)
      s = Es(t[i]), r[i] = s.r || 0, o[i] = s.g || 0, a[i] = s.b || 0;
    return r = e(r), o = e(o), a = e(a), s.opacity = 1, function(l) {
      return s.r = r(l), s.g = o(l), s.b = a(l), s + "";
    };
  };
}
var NR = C5(x5), kR = C5(w5);
function Df(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), o;
  return function(a) {
    for (o = 0; o < n; ++o)
      r[o] = e[o] * (1 - a) + t[o] * a;
    return r;
  };
}
function S5(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function DR(e, t) {
  return (S5(t) ? Df : E5)(e, t);
}
function E5(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, o = new Array(r), a = new Array(n), i;
  for (i = 0; i < r; ++i)
    o[i] = Xr(e[i], t[i]);
  for (; i < n; ++i)
    a[i] = t[i];
  return function(s) {
    for (i = 0; i < r; ++i)
      a[i] = o[i](s);
    return a;
  };
}
function M5(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function un(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function $5(e, t) {
  var n = {}, r = {}, o;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (o in t)
    o in e ? n[o] = Xr(e[o], t[o]) : r[o] = t[o];
  return function(a) {
    for (o in n)
      r[o] = n[o](a);
    return r;
  };
}
var wu = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, xc = new RegExp(wu.source, "g");
function FR(e) {
  return function() {
    return e;
  };
}
function RR(e) {
  return function(t) {
    return e(t) + "";
  };
}
function P5(e, t) {
  var n = wu.lastIndex = xc.lastIndex = 0, r, o, a, i = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = wu.exec(e)) && (o = xc.exec(t)); )
    (a = o.index) > n && (a = t.slice(n, a), s[i] ? s[i] += a : s[++i] = a), (r = r[0]) === (o = o[0]) ? s[i] ? s[i] += o : s[++i] = o : (s[++i] = null, l.push({ i, x: un(r, o) })), n = xc.lastIndex;
  return n < t.length && (a = t.slice(n), s[i] ? s[i] += a : s[++i] = a), s.length < 2 ? l[0] ? RR(l[0].x) : FR(t) : (t = l.length, function(c) {
    for (var d = 0, f; d < t; ++d)
      s[(f = l[d]).i] = f.x(c);
    return s.join("");
  });
}
function Xr(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? $l(t) : (n === "number" ? un : n === "string" ? (r = Oa(t)) ? (t = r, Ps) : P5 : t instanceof Oa ? Ps : t instanceof Date ? M5 : S5(t) ? Df : Array.isArray(t) ? E5 : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? $5 : un)(e, t);
}
function _R(e) {
  var t = e.length;
  return function(n) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
  };
}
function IR(e, t) {
  var n = Pl(+e, +t);
  return function(r) {
    var o = n(r);
    return o - 360 * Math.floor(o / 360);
  };
}
function qa(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
var Vp = 180 / Math.PI, Au = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function T5(e, t, n, r, o, a) {
  var i, s, l;
  return (i = Math.sqrt(e * e + t * t)) && (e /= i, t /= i), (l = e * n + t * r) && (n -= e * l, r -= t * l), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, l /= s), e * r < t * n && (e = -e, t = -t, l = -l, i = -i), {
    translateX: o,
    translateY: a,
    rotate: Math.atan2(t, e) * Vp,
    skewX: Math.atan(l) * Vp,
    scaleX: i,
    scaleY: s
  };
}
var Ii;
function LR(e) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return t.isIdentity ? Au : T5(t.a, t.b, t.c, t.d, t.e, t.f);
}
function BR(e) {
  return e == null || (Ii || (Ii = document.createElementNS("http://www.w3.org/2000/svg", "g")), Ii.setAttribute("transform", e), !(e = Ii.transform.baseVal.consolidate())) ? Au : (e = e.matrix, T5(e.a, e.b, e.c, e.d, e.e, e.f));
}
function O5(e, t, n, r) {
  function o(c) {
    return c.length ? c.pop() + " " : "";
  }
  function a(c, d, f, p, m, h) {
    if (c !== f || d !== p) {
      var g = m.push("translate(", null, t, null, n);
      h.push({ i: g - 4, x: un(c, f) }, { i: g - 2, x: un(d, p) });
    } else
      (f || p) && m.push("translate(" + f + t + p + n);
  }
  function i(c, d, f, p) {
    c !== d ? (c - d > 180 ? d += 360 : d - c > 180 && (c += 360), p.push({ i: f.push(o(f) + "rotate(", null, r) - 2, x: un(c, d) })) : d && f.push(o(f) + "rotate(" + d + r);
  }
  function s(c, d, f, p) {
    c !== d ? p.push({ i: f.push(o(f) + "skewX(", null, r) - 2, x: un(c, d) }) : d && f.push(o(f) + "skewX(" + d + r);
  }
  function l(c, d, f, p, m, h) {
    if (c !== f || d !== p) {
      var g = m.push(o(m) + "scale(", null, ",", null, ")");
      h.push({ i: g - 4, x: un(c, f) }, { i: g - 2, x: un(d, p) });
    } else
      (f !== 1 || p !== 1) && m.push(o(m) + "scale(" + f + "," + p + ")");
  }
  return function(c, d) {
    var f = [], p = [];
    return c = e(c), d = e(d), a(c.translateX, c.translateY, d.translateX, d.translateY, f, p), i(c.rotate, d.rotate, f, p), s(c.skewX, d.skewX, f, p), l(c.scaleX, c.scaleY, d.scaleX, d.scaleY, f, p), c = d = null, function(m) {
      for (var h = -1, g = p.length, x; ++h < g; )
        f[(x = p[h]).i] = x.x(m);
      return f.join("");
    };
  };
}
var zR = O5(LR, "px, ", "px)", "deg)"), WR = O5(BR, ", ", ")", ")"), jR = 1e-12;
function Hp(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function VR(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function HR(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
const UR = function e(t, n, r) {
  function o(a, i) {
    var s = a[0], l = a[1], c = a[2], d = i[0], f = i[1], p = i[2], m = d - s, h = f - l, g = m * m + h * h, x, y;
    if (g < jR)
      y = Math.log(p / c) / t, x = function($) {
        return [
          s + $ * m,
          l + $ * h,
          c * Math.exp(t * $ * y)
        ];
      };
    else {
      var b = Math.sqrt(g), v = (p * p - c * c + r * g) / (2 * c * n * b), A = (p * p - c * c - r * g) / (2 * p * n * b), w = Math.log(Math.sqrt(v * v + 1) - v), M = Math.log(Math.sqrt(A * A + 1) - A);
      y = (M - w) / t, x = function($) {
        var P = $ * y, E = Hp(w), T = c / (n * b) * (E * HR(t * P + w) - VR(w));
        return [
          s + T * m,
          l + T * h,
          c * E / Hp(t * P + w)
        ];
      };
    }
    return x.duration = y * 1e3 * t / Math.SQRT2, x;
  }
  return o.rho = function(a) {
    var i = Math.max(1e-3, +a), s = i * i, l = s * s;
    return e(i, s, l);
  }, o;
}(Math.SQRT2, 2, 4);
function N5(e) {
  return function(t, n) {
    var r = e((t = vu(t)).h, (n = vu(n)).h), o = mt(t.s, n.s), a = mt(t.l, n.l), i = mt(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.s = o(s), t.l = a(s), t.opacity = i(s), t + "";
    };
  };
}
const k5 = N5(Pl);
var D5 = N5(mt);
function F5(e, t) {
  var n = mt((e = yu(e)).l, (t = yu(t)).l), r = mt(e.a, t.a), o = mt(e.b, t.b), a = mt(e.opacity, t.opacity);
  return function(i) {
    return e.l = n(i), e.a = r(i), e.b = o(i), e.opacity = a(i), e + "";
  };
}
function R5(e) {
  return function(t, n) {
    var r = e((t = bu(t)).h, (n = bu(n)).h), o = mt(t.c, n.c), a = mt(t.l, n.l), i = mt(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.c = o(s), t.l = a(s), t.opacity = i(s), t + "";
    };
  };
}
const _5 = R5(Pl);
var I5 = R5(mt);
function L5(e) {
  return function t(n) {
    n = +n;
    function r(o, a) {
      var i = e((o = xu(o)).h, (a = xu(a)).h), s = mt(o.s, a.s), l = mt(o.l, a.l), c = mt(o.opacity, a.opacity);
      return function(d) {
        return o.h = i(d), o.s = s(d), o.l = l(Math.pow(d, n)), o.opacity = c(d), o + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
const B5 = L5(Pl);
var z5 = L5(mt);
function W5(e, t) {
  t === void 0 && (t = e, e = Xr);
  for (var n = 0, r = t.length - 1, o = t[0], a = new Array(r < 0 ? 0 : r); n < r; )
    a[n] = e(o, o = t[++n]);
  return function(i) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(i *= r)));
    return a[s](i - s);
  };
}
function YR(e, t) {
  for (var n = new Array(t), r = 0; r < t; ++r)
    n[r] = e(r / (t - 1));
  return n;
}
function GR(e) {
  return function() {
    return e;
  };
}
function Ts(e) {
  return +e;
}
var Up = [0, 1];
function Ft(e) {
  return e;
}
function Cu(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : GR(isNaN(t) ? NaN : 0.5);
}
function XR(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function qR(e, t, n) {
  var r = e[0], o = e[1], a = t[0], i = t[1];
  return o < r ? (r = Cu(o, r), a = n(i, a)) : (r = Cu(r, o), a = n(a, i)), function(s) {
    return a(r(s));
  };
}
function KR(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, o = new Array(r), a = new Array(r), i = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++i < r; )
    o[i] = Cu(e[i], e[i + 1]), a[i] = n(t[i], t[i + 1]);
  return function(s) {
    var l = Yo(e, s, 1, r) - 1;
    return a[l](o[l](s));
  };
}
function Ka(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Tl() {
  var e = Up, t = Up, n = Xr, r, o, a, i = Ft, s, l, c;
  function d() {
    var p = Math.min(e.length, t.length);
    return i !== Ft && (i = XR(e[0], e[p - 1])), s = p > 2 ? KR : qR, l = c = null, f;
  }
  function f(p) {
    return p == null || isNaN(p = +p) ? a : (l || (l = s(e.map(r), t, n)))(r(i(p)));
  }
  return f.invert = function(p) {
    return i(o((c || (c = s(t, e.map(r), un)))(p)));
  }, f.domain = function(p) {
    return arguments.length ? (e = Array.from(p, Ts), d()) : e.slice();
  }, f.range = function(p) {
    return arguments.length ? (t = Array.from(p), d()) : t.slice();
  }, f.rangeRound = function(p) {
    return t = Array.from(p), n = qa, d();
  }, f.clamp = function(p) {
    return arguments.length ? (i = p ? !0 : Ft, d()) : i !== Ft;
  }, f.interpolate = function(p) {
    return arguments.length ? (n = p, d()) : n;
  }, f.unknown = function(p) {
    return arguments.length ? (a = p, f) : a;
  }, function(p, m) {
    return r = p, o = m, d();
  };
}
function Ff() {
  return Tl()(Ft, Ft);
}
function j5(e, t, n, r) {
  var o = hu(e, t, n), a;
  switch (r = Pa(r ?? ",f"), r.type) {
    case "s": {
      var i = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(a = ET(o, i)) && (r.precision = a), l3(r, i);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(a = MT(o, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = a - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(a = ST(o)) && (r.precision = a - (r.type === "%") * 2);
      break;
    }
  }
  return Jt(r);
}
function Ar(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return Ss(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var o = t();
    return j5(o[0], o[o.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), o = 0, a = r.length - 1, i = r[o], s = r[a], l, c, d = 10;
    for (s < i && (c = i, i = s, s = c, c = o, o = a, a = c); d-- > 0; ) {
      if (c = $o(i, s, n), c === l)
        return r[o] = i, r[a] = s, t(r);
      if (c > 0)
        i = Math.floor(i / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        i = Math.ceil(i * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function Rf() {
  var e = Ff();
  return e.copy = function() {
    return Ka(e, Rf());
  }, on.apply(e, arguments), Ar(e);
}
function V5(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, Ts), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return V5(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Ts) : [0, 1], Ar(n);
}
function H5(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, o = e[n], a = e[r], i;
  return a < o && (i = n, n = r, r = i, i = o, o = a, a = i), e[n] = t.floor(o), e[r] = t.ceil(a), e;
}
function Yp(e) {
  return Math.log(e);
}
function Gp(e) {
  return Math.exp(e);
}
function QR(e) {
  return -Math.log(-e);
}
function ZR(e) {
  return -Math.exp(-e);
}
function JR(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function e_(e) {
  return e === 10 ? JR : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function t_(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function Xp(e) {
  return (t, n) => -e(-t, n);
}
function _f(e) {
  const t = e(Yp, Gp), n = t.domain;
  let r = 10, o, a;
  function i() {
    return o = t_(r), a = e_(r), n()[0] < 0 ? (o = Xp(o), a = Xp(a), e(QR, ZR)) : e(Yp, Gp), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, i()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), i()) : n();
  }, t.ticks = (s) => {
    const l = n();
    let c = l[0], d = l[l.length - 1];
    const f = d < c;
    f && ([c, d] = [d, c]);
    let p = o(c), m = o(d), h, g;
    const x = s == null ? 10 : +s;
    let y = [];
    if (!(r % 1) && m - p < x) {
      if (p = Math.floor(p), m = Math.ceil(m), c > 0) {
        for (; p <= m; ++p)
          for (h = 1; h < r; ++h)
            if (g = p < 0 ? h / a(-p) : h * a(p), !(g < c)) {
              if (g > d)
                break;
              y.push(g);
            }
      } else
        for (; p <= m; ++p)
          for (h = r - 1; h >= 1; --h)
            if (g = p > 0 ? h / a(-p) : h * a(p), !(g < c)) {
              if (g > d)
                break;
              y.push(g);
            }
      y.length * 2 < x && (y = Ss(c, d, x));
    } else
      y = Ss(p, m, Math.min(m - p, x)).map(a);
    return f ? y.reverse() : y;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = Pa(l)).precision == null && (l.trim = !0), l = Jt(l)), s === 1 / 0)
      return l;
    const c = Math.max(1, r * s / t.ticks().length);
    return (d) => {
      let f = d / a(Math.round(o(d)));
      return f * r < r - 0.5 && (f *= r), f <= c ? l(d) : "";
    };
  }, t.nice = () => n(H5(n(), {
    floor: (s) => a(Math.floor(o(s))),
    ceil: (s) => a(Math.ceil(o(s)))
  })), t;
}
function If() {
  const e = _f(Tl()).domain([1, 10]);
  return e.copy = () => Ka(e, If()).base(e.base()), on.apply(e, arguments), e;
}
function qp(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function Kp(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function Lf(e) {
  var t = 1, n = e(qp(t), Kp(t));
  return n.constant = function(r) {
    return arguments.length ? e(qp(t = +r), Kp(t)) : t;
  }, Ar(n);
}
function Bf() {
  var e = Lf(Tl());
  return e.copy = function() {
    return Ka(e, Bf()).constant(e.constant());
  }, on.apply(e, arguments);
}
function Qp(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function n_(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function r_(e) {
  return e < 0 ? -e * e : e * e;
}
function zf(e) {
  var t = e(Ft, Ft), n = 1;
  function r() {
    return n === 1 ? e(Ft, Ft) : n === 0.5 ? e(n_, r_) : e(Qp(n), Qp(1 / n));
  }
  return t.exponent = function(o) {
    return arguments.length ? (n = +o, r()) : n;
  }, Ar(t);
}
function Ol() {
  var e = zf(Tl());
  return e.copy = function() {
    return Ka(e, Ol()).exponent(e.exponent());
  }, on.apply(e, arguments), e;
}
function U5() {
  return Ol.apply(null, arguments).exponent(0.5);
}
function Zp(e) {
  return Math.sign(e) * e * e;
}
function o_(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function Wf() {
  var e = Ff(), t = [0, 1], n = !1, r;
  function o(a) {
    var i = o_(e(a));
    return isNaN(i) ? r : n ? Math.round(i) : i;
  }
  return o.invert = function(a) {
    return e.invert(Zp(a));
  }, o.domain = function(a) {
    return arguments.length ? (e.domain(a), o) : e.domain();
  }, o.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, Ts)).map(Zp)), o) : t.slice();
  }, o.rangeRound = function(a) {
    return o.range(a).round(!0);
  }, o.round = function(a) {
    return arguments.length ? (n = !!a, o) : n;
  }, o.clamp = function(a) {
    return arguments.length ? (e.clamp(a), o) : e.clamp();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.copy = function() {
    return Wf(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, on.apply(o, arguments), Ar(o);
}
function jf() {
  var e = [], t = [], n = [], r;
  function o() {
    var i = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++i < s; )
      n[i - 1] = hR(e, i / s);
    return a;
  }
  function a(i) {
    return i == null || isNaN(i = +i) ? r : t[Yo(n, i)];
  }
  return a.invertExtent = function(i) {
    var s = t.indexOf(i);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, a.domain = function(i) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of i)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(cr), o();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), o()) : t.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.quantiles = function() {
    return n.slice();
  }, a.copy = function() {
    return jf().domain(e).range(t).unknown(r);
  }, on.apply(a, arguments);
}
function Vf() {
  var e = 0, t = 1, n = 1, r = [0.5], o = [0, 1], a;
  function i(l) {
    return l != null && l <= l ? o[Yo(r, l, 0, n)] : a;
  }
  function s() {
    var l = -1;
    for (r = new Array(n); ++l < n; )
      r[l] = ((l + 1) * t - (l - n) * e) / (n + 1);
    return i;
  }
  return i.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, s()) : [e, t];
  }, i.range = function(l) {
    return arguments.length ? (n = (o = Array.from(l)).length - 1, s()) : o.slice();
  }, i.invertExtent = function(l) {
    var c = o.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, r[0]] : c >= n ? [r[n - 1], t] : [r[c - 1], r[c]];
  }, i.unknown = function(l) {
    return arguments.length && (a = l), i;
  }, i.thresholds = function() {
    return r.slice();
  }, i.copy = function() {
    return Vf().domain([e, t]).range(o).unknown(a);
  }, on.apply(Ar(i), arguments);
}
function Hf() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function o(a) {
    return a != null && a <= a ? t[Yo(e, a, 0, r)] : n;
  }
  return o.domain = function(a) {
    return arguments.length ? (e = Array.from(a), r = Math.min(e.length, t.length - 1), o) : e.slice();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), r = Math.min(e.length, t.length - 1), o) : t.slice();
  }, o.invertExtent = function(a) {
    var i = t.indexOf(a);
    return [e[i - 1], e[i]];
  }, o.unknown = function(a) {
    return arguments.length ? (n = a, o) : n;
  }, o.copy = function() {
    return Hf().domain(e).range(t).unknown(n);
  }, on.apply(o, arguments);
}
const wc = /* @__PURE__ */ new Date(), Ac = /* @__PURE__ */ new Date();
function ct(e, t, n, r) {
  function o(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return o.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), o.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), o.round = (a) => {
    const i = o(a), s = o.ceil(a);
    return a - i < s - a ? i : s;
  }, o.offset = (a, i) => (t(a = /* @__PURE__ */ new Date(+a), i == null ? 1 : Math.floor(i)), a), o.range = (a, i, s) => {
    const l = [];
    if (a = o.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < i) || !(s > 0))
      return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (c < a && a < i);
    return l;
  }, o.filter = (a) => ct((i) => {
    if (i >= i)
      for (; e(i), !a(i); )
        i.setTime(i - 1);
  }, (i, s) => {
    if (i >= i)
      if (s < 0)
        for (; ++s <= 0; )
          for (; t(i, -1), !a(i); )
            ;
      else
        for (; --s >= 0; )
          for (; t(i, 1), !a(i); )
            ;
  }), n && (o.count = (a, i) => (wc.setTime(+a), Ac.setTime(+i), e(wc), e(Ac), Math.floor(n(wc, Ac))), o.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? o.filter(r ? (i) => r(i) % a === 0 : (i) => o.count(0, i) % a === 0) : o)), o;
}
const To = ct(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
To.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? ct((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : To);
const Jp = To.range, _n = 1e3, en = _n * 60, In = en * 60, jn = In * 24, Uf = jn * 7, eh = jn * 30, Cc = jn * 365, pn = ct((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * _n);
}, (e, t) => (t - e) / _n, (e) => e.getUTCSeconds()), th = pn.range, Qa = ct((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * _n);
}, (e, t) => {
  e.setTime(+e + t * en);
}, (e, t) => (t - e) / en, (e) => e.getMinutes()), a_ = Qa.range, Za = ct((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * en);
}, (e, t) => (t - e) / en, (e) => e.getUTCMinutes()), i_ = Za.range, Ja = ct((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * _n - e.getMinutes() * en);
}, (e, t) => {
  e.setTime(+e + t * In);
}, (e, t) => (t - e) / In, (e) => e.getHours()), s_ = Ja.range, ei = ct((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * In);
}, (e, t) => (t - e) / In, (e) => e.getUTCHours()), l_ = ei.range, qr = ct(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * en) / jn,
  (e) => e.getDate() - 1
), c_ = qr.range, Xo = ct((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / jn, (e) => e.getUTCDate() - 1), u_ = Xo.range, Yf = ct((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / jn, (e) => Math.floor(e / jn)), d_ = Yf.range;
function Kr(e) {
  return ct((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * en) / Uf);
}
const Lr = Kr(0), ka = Kr(1), Y5 = Kr(2), G5 = Kr(3), Br = Kr(4), X5 = Kr(5), q5 = Kr(6), nh = Lr.range, f_ = ka.range, p_ = Y5.range, h_ = G5.range, m_ = Br.range, g_ = X5.range, v_ = q5.range;
function Qr(e) {
  return ct((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / Uf);
}
const zr = Qr(0), Da = Qr(1), K5 = Qr(2), Q5 = Qr(3), Wr = Qr(4), Z5 = Qr(5), J5 = Qr(6), rh = zr.range, y_ = Da.range, b_ = K5.range, x_ = Q5.range, w_ = Wr.range, A_ = Z5.range, C_ = J5.range, ti = ct((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth()), S_ = ti.range, ni = ct((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth()), E_ = ni.range, gn = ct((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
gn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : ct((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
const M_ = gn.range, vn = ct((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
vn.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : ct((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
const $_ = vn.range;
function e4(e, t, n, r, o, a) {
  const i = [
    [pn, 1, _n],
    [pn, 5, 5 * _n],
    [pn, 15, 15 * _n],
    [pn, 30, 30 * _n],
    [a, 1, en],
    [a, 5, 5 * en],
    [a, 15, 15 * en],
    [a, 30, 30 * en],
    [o, 1, In],
    [o, 3, 3 * In],
    [o, 6, 6 * In],
    [o, 12, 12 * In],
    [r, 1, jn],
    [r, 2, 2 * jn],
    [n, 1, Uf],
    [t, 1, eh],
    [t, 3, 3 * eh],
    [e, 1, Cc]
  ];
  function s(c, d, f) {
    const p = d < c;
    p && ([c, d] = [d, c]);
    const m = f && typeof f.range == "function" ? f : l(c, d, f), h = m ? m.range(c, +d + 1) : [];
    return p ? h.reverse() : h;
  }
  function l(c, d, f) {
    const p = Math.abs(d - c) / f, m = Tf(([, , x]) => x).right(i, p);
    if (m === i.length)
      return e.every(hu(c / Cc, d / Cc, f));
    if (m === 0)
      return To.every(Math.max(hu(c, d, f), 1));
    const [h, g] = i[p / i[m - 1][2] < i[m][2] / p ? m - 1 : m];
    return h.every(g);
  }
  return [s, l];
}
const [t4, n4] = e4(vn, ni, zr, Yf, ei, Za), [r4, o4] = e4(gn, ti, Lr, qr, Ja, Qa);
function Sc(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Ec(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function aa(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function P_(e) {
  var t = e.dateTime, n = e.date, r = e.time, o = e.periods, a = e.days, i = e.shortDays, s = e.months, l = e.shortMonths, c = ia(o), d = sa(o), f = ia(a), p = sa(a), m = ia(i), h = sa(i), g = ia(s), x = sa(s), y = ia(l), b = sa(l), v = {
    a: U,
    A: z,
    b: N,
    B: O,
    c: null,
    d: ch,
    e: ch,
    f: Q_,
    g: sI,
    G: cI,
    H: X_,
    I: q_,
    j: K_,
    L: a4,
    m: Z_,
    M: J_,
    p: k,
    q: Q,
    Q: fh,
    s: ph,
    S: eI,
    u: tI,
    U: nI,
    V: rI,
    w: oI,
    W: aI,
    x: null,
    X: null,
    y: iI,
    Y: lI,
    Z: uI,
    "%": dh
  }, A = {
    a: q,
    A: re,
    b: ae,
    B: oe,
    c: null,
    d: uh,
    e: uh,
    f: hI,
    g: SI,
    G: MI,
    H: dI,
    I: fI,
    j: pI,
    L: s4,
    m: mI,
    M: gI,
    p: ee,
    q: ie,
    Q: fh,
    s: ph,
    S: vI,
    u: yI,
    U: bI,
    V: xI,
    w: wI,
    W: AI,
    x: null,
    X: null,
    y: CI,
    Y: EI,
    Z: $I,
    "%": dh
  }, w = {
    a: T,
    A: B,
    b: j,
    B: V,
    c: W,
    d: sh,
    e: sh,
    f: H_,
    g: ih,
    G: ah,
    H: lh,
    I: lh,
    j: z_,
    L: V_,
    m: B_,
    M: W_,
    p: E,
    q: L_,
    Q: Y_,
    s: G_,
    S: j_,
    u: D_,
    U: F_,
    V: R_,
    w: k_,
    W: __,
    x: S,
    X: _,
    y: ih,
    Y: ah,
    Z: I_,
    "%": U_
  };
  v.x = M(n, v), v.X = M(r, v), v.c = M(t, v), A.x = M(n, A), A.X = M(r, A), A.c = M(t, A);
  function M(X, J) {
    return function(pe) {
      var D = [], ce = -1, he = 0, ye = X.length, Me, Oe, it;
      for (pe instanceof Date || (pe = /* @__PURE__ */ new Date(+pe)); ++ce < ye; )
        X.charCodeAt(ce) === 37 && (D.push(X.slice(he, ce)), (Oe = oh[Me = X.charAt(++ce)]) != null ? Me = X.charAt(++ce) : Oe = Me === "e" ? " " : "0", (it = J[Me]) && (Me = it(pe, Oe)), D.push(Me), he = ce + 1);
      return D.push(X.slice(he, ce)), D.join("");
    };
  }
  function $(X, J) {
    return function(pe) {
      var D = aa(1900, void 0, 1), ce = P(D, X, pe += "", 0), he, ye;
      if (ce != pe.length)
        return null;
      if ("Q" in D)
        return new Date(D.Q);
      if ("s" in D)
        return new Date(D.s * 1e3 + ("L" in D ? D.L : 0));
      if (J && !("Z" in D) && (D.Z = 0), "p" in D && (D.H = D.H % 12 + D.p * 12), D.m === void 0 && (D.m = "q" in D ? D.q : 0), "V" in D) {
        if (D.V < 1 || D.V > 53)
          return null;
        "w" in D || (D.w = 1), "Z" in D ? (he = Ec(aa(D.y, 0, 1)), ye = he.getUTCDay(), he = ye > 4 || ye === 0 ? Da.ceil(he) : Da(he), he = Xo.offset(he, (D.V - 1) * 7), D.y = he.getUTCFullYear(), D.m = he.getUTCMonth(), D.d = he.getUTCDate() + (D.w + 6) % 7) : (he = Sc(aa(D.y, 0, 1)), ye = he.getDay(), he = ye > 4 || ye === 0 ? ka.ceil(he) : ka(he), he = qr.offset(he, (D.V - 1) * 7), D.y = he.getFullYear(), D.m = he.getMonth(), D.d = he.getDate() + (D.w + 6) % 7);
      } else
        ("W" in D || "U" in D) && ("w" in D || (D.w = "u" in D ? D.u % 7 : "W" in D ? 1 : 0), ye = "Z" in D ? Ec(aa(D.y, 0, 1)).getUTCDay() : Sc(aa(D.y, 0, 1)).getDay(), D.m = 0, D.d = "W" in D ? (D.w + 6) % 7 + D.W * 7 - (ye + 5) % 7 : D.w + D.U * 7 - (ye + 6) % 7);
      return "Z" in D ? (D.H += D.Z / 100 | 0, D.M += D.Z % 100, Ec(D)) : Sc(D);
    };
  }
  function P(X, J, pe, D) {
    for (var ce = 0, he = J.length, ye = pe.length, Me, Oe; ce < he; ) {
      if (D >= ye)
        return -1;
      if (Me = J.charCodeAt(ce++), Me === 37) {
        if (Me = J.charAt(ce++), Oe = w[Me in oh ? J.charAt(ce++) : Me], !Oe || (D = Oe(X, pe, D)) < 0)
          return -1;
      } else if (Me != pe.charCodeAt(D++))
        return -1;
    }
    return D;
  }
  function E(X, J, pe) {
    var D = c.exec(J.slice(pe));
    return D ? (X.p = d.get(D[0].toLowerCase()), pe + D[0].length) : -1;
  }
  function T(X, J, pe) {
    var D = m.exec(J.slice(pe));
    return D ? (X.w = h.get(D[0].toLowerCase()), pe + D[0].length) : -1;
  }
  function B(X, J, pe) {
    var D = f.exec(J.slice(pe));
    return D ? (X.w = p.get(D[0].toLowerCase()), pe + D[0].length) : -1;
  }
  function j(X, J, pe) {
    var D = y.exec(J.slice(pe));
    return D ? (X.m = b.get(D[0].toLowerCase()), pe + D[0].length) : -1;
  }
  function V(X, J, pe) {
    var D = g.exec(J.slice(pe));
    return D ? (X.m = x.get(D[0].toLowerCase()), pe + D[0].length) : -1;
  }
  function W(X, J, pe) {
    return P(X, t, J, pe);
  }
  function S(X, J, pe) {
    return P(X, n, J, pe);
  }
  function _(X, J, pe) {
    return P(X, r, J, pe);
  }
  function U(X) {
    return i[X.getDay()];
  }
  function z(X) {
    return a[X.getDay()];
  }
  function N(X) {
    return l[X.getMonth()];
  }
  function O(X) {
    return s[X.getMonth()];
  }
  function k(X) {
    return o[+(X.getHours() >= 12)];
  }
  function Q(X) {
    return 1 + ~~(X.getMonth() / 3);
  }
  function q(X) {
    return i[X.getUTCDay()];
  }
  function re(X) {
    return a[X.getUTCDay()];
  }
  function ae(X) {
    return l[X.getUTCMonth()];
  }
  function oe(X) {
    return s[X.getUTCMonth()];
  }
  function ee(X) {
    return o[+(X.getUTCHours() >= 12)];
  }
  function ie(X) {
    return 1 + ~~(X.getUTCMonth() / 3);
  }
  return {
    format: function(X) {
      var J = M(X += "", v);
      return J.toString = function() {
        return X;
      }, J;
    },
    parse: function(X) {
      var J = $(X += "", !1);
      return J.toString = function() {
        return X;
      }, J;
    },
    utcFormat: function(X) {
      var J = M(X += "", A);
      return J.toString = function() {
        return X;
      }, J;
    },
    utcParse: function(X) {
      var J = $(X += "", !0);
      return J.toString = function() {
        return X;
      }, J;
    }
  };
}
var oh = { "-": "", _: " ", 0: "0" }, vt = /^\s*\d+/, T_ = /^%/, O_ = /[\\^$*+?|[\]().{}]/g;
function Ve(e, t, n) {
  var r = e < 0 ? "-" : "", o = (r ? -e : e) + "", a = o.length;
  return r + (a < n ? new Array(n - a + 1).join(t) + o : o);
}
function N_(e) {
  return e.replace(O_, "\\$&");
}
function ia(e) {
  return new RegExp("^(?:" + e.map(N_).join("|") + ")", "i");
}
function sa(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function k_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function D_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function F_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function R_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function __(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function ah(e, t, n) {
  var r = vt.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function ih(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function I_(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function L_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function B_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function sh(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function z_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function lh(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function W_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function j_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function V_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function H_(e, t, n) {
  var r = vt.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function U_(e, t, n) {
  var r = T_.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function Y_(e, t, n) {
  var r = vt.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function G_(e, t, n) {
  var r = vt.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function ch(e, t) {
  return Ve(e.getDate(), t, 2);
}
function X_(e, t) {
  return Ve(e.getHours(), t, 2);
}
function q_(e, t) {
  return Ve(e.getHours() % 12 || 12, t, 2);
}
function K_(e, t) {
  return Ve(1 + qr.count(gn(e), e), t, 3);
}
function a4(e, t) {
  return Ve(e.getMilliseconds(), t, 3);
}
function Q_(e, t) {
  return a4(e, t) + "000";
}
function Z_(e, t) {
  return Ve(e.getMonth() + 1, t, 2);
}
function J_(e, t) {
  return Ve(e.getMinutes(), t, 2);
}
function eI(e, t) {
  return Ve(e.getSeconds(), t, 2);
}
function tI(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function nI(e, t) {
  return Ve(Lr.count(gn(e) - 1, e), t, 2);
}
function i4(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Br(e) : Br.ceil(e);
}
function rI(e, t) {
  return e = i4(e), Ve(Br.count(gn(e), e) + (gn(e).getDay() === 4), t, 2);
}
function oI(e) {
  return e.getDay();
}
function aI(e, t) {
  return Ve(ka.count(gn(e) - 1, e), t, 2);
}
function iI(e, t) {
  return Ve(e.getFullYear() % 100, t, 2);
}
function sI(e, t) {
  return e = i4(e), Ve(e.getFullYear() % 100, t, 2);
}
function lI(e, t) {
  return Ve(e.getFullYear() % 1e4, t, 4);
}
function cI(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Br(e) : Br.ceil(e), Ve(e.getFullYear() % 1e4, t, 4);
}
function uI(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Ve(t / 60 | 0, "0", 2) + Ve(t % 60, "0", 2);
}
function uh(e, t) {
  return Ve(e.getUTCDate(), t, 2);
}
function dI(e, t) {
  return Ve(e.getUTCHours(), t, 2);
}
function fI(e, t) {
  return Ve(e.getUTCHours() % 12 || 12, t, 2);
}
function pI(e, t) {
  return Ve(1 + Xo.count(vn(e), e), t, 3);
}
function s4(e, t) {
  return Ve(e.getUTCMilliseconds(), t, 3);
}
function hI(e, t) {
  return s4(e, t) + "000";
}
function mI(e, t) {
  return Ve(e.getUTCMonth() + 1, t, 2);
}
function gI(e, t) {
  return Ve(e.getUTCMinutes(), t, 2);
}
function vI(e, t) {
  return Ve(e.getUTCSeconds(), t, 2);
}
function yI(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function bI(e, t) {
  return Ve(zr.count(vn(e) - 1, e), t, 2);
}
function l4(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Wr(e) : Wr.ceil(e);
}
function xI(e, t) {
  return e = l4(e), Ve(Wr.count(vn(e), e) + (vn(e).getUTCDay() === 4), t, 2);
}
function wI(e) {
  return e.getUTCDay();
}
function AI(e, t) {
  return Ve(Da.count(vn(e) - 1, e), t, 2);
}
function CI(e, t) {
  return Ve(e.getUTCFullYear() % 100, t, 2);
}
function SI(e, t) {
  return e = l4(e), Ve(e.getUTCFullYear() % 100, t, 2);
}
function EI(e, t) {
  return Ve(e.getUTCFullYear() % 1e4, t, 4);
}
function MI(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Wr(e) : Wr.ceil(e), Ve(e.getUTCFullYear() % 1e4, t, 4);
}
function $I() {
  return "+0000";
}
function dh() {
  return "%";
}
function fh(e) {
  return +e;
}
function ph(e) {
  return Math.floor(+e / 1e3);
}
var so, c4, u4;
PI({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function PI(e) {
  return so = P_(e), c4 = so.format, so.parse, u4 = so.utcFormat, so.utcParse, so;
}
function TI(e) {
  return new Date(e);
}
function OI(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Gf(e, t, n, r, o, a, i, s, l, c) {
  var d = Ff(), f = d.invert, p = d.domain, m = c(".%L"), h = c(":%S"), g = c("%I:%M"), x = c("%I %p"), y = c("%a %d"), b = c("%b %d"), v = c("%B"), A = c("%Y");
  function w(M) {
    return (l(M) < M ? m : s(M) < M ? h : i(M) < M ? g : a(M) < M ? x : r(M) < M ? o(M) < M ? y : b : n(M) < M ? v : A)(M);
  }
  return d.invert = function(M) {
    return new Date(f(M));
  }, d.domain = function(M) {
    return arguments.length ? p(Array.from(M, OI)) : p().map(TI);
  }, d.ticks = function(M) {
    var $ = p();
    return e($[0], $[$.length - 1], M ?? 10);
  }, d.tickFormat = function(M, $) {
    return $ == null ? w : c($);
  }, d.nice = function(M) {
    var $ = p();
    return (!M || typeof M.range != "function") && (M = t($[0], $[$.length - 1], M ?? 10)), M ? p(H5($, M)) : d;
  }, d.copy = function() {
    return Ka(d, Gf(e, t, n, r, o, a, i, s, l, c));
  }, d;
}
function d4() {
  return on.apply(Gf(r4, o4, gn, ti, Lr, qr, Ja, Qa, pn, c4).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function f4() {
  return on.apply(Gf(t4, n4, vn, ni, zr, Xo, ei, Za, pn, u4).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Nl() {
  var e = 0, t = 1, n, r, o, a, i = Ft, s = !1, l;
  function c(f) {
    return f == null || isNaN(f = +f) ? l : i(o === 0 ? 0.5 : (f = (a(f) - n) * o, s ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, n = a(e = +e), r = a(t = +t), o = n === r ? 0 : 1 / (r - n), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (s = !!f, c) : s;
  }, c.interpolator = function(f) {
    return arguments.length ? (i = f, c) : i;
  };
  function d(f) {
    return function(p) {
      var m, h;
      return arguments.length ? ([m, h] = p, i = f(m, h), c) : [i(0), i(1)];
    };
  }
  return c.range = d(Xr), c.rangeRound = d(qa), c.unknown = function(f) {
    return arguments.length ? (l = f, c) : l;
  }, function(f) {
    return a = f, n = f(e), r = f(t), o = n === r ? 0 : 1 / (r - n), c;
  };
}
function Cr(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function p4() {
  var e = Ar(Nl()(Ft));
  return e.copy = function() {
    return Cr(e, p4());
  }, Gn.apply(e, arguments);
}
function h4() {
  var e = _f(Nl()).domain([1, 10]);
  return e.copy = function() {
    return Cr(e, h4()).base(e.base());
  }, Gn.apply(e, arguments);
}
function m4() {
  var e = Lf(Nl());
  return e.copy = function() {
    return Cr(e, m4()).constant(e.constant());
  }, Gn.apply(e, arguments);
}
function Xf() {
  var e = zf(Nl());
  return e.copy = function() {
    return Cr(e, Xf()).exponent(e.exponent());
  }, Gn.apply(e, arguments);
}
function NI() {
  return Xf.apply(null, arguments).exponent(0.5);
}
function g4() {
  var e = [], t = Ft;
  function n(r) {
    if (r != null && !isNaN(r = +r))
      return t((Yo(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let o of r)
      o != null && !isNaN(o = +o) && e.push(o);
    return e.sort(cr), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, o) => t(o / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (o, a) => pR(e, a / r));
  }, n.copy = function() {
    return g4(t).domain(e);
  }, Gn.apply(n, arguments);
}
function kl() {
  var e = 0, t = 0.5, n = 1, r = 1, o, a, i, s, l, c = Ft, d, f = !1, p;
  function m(g) {
    return isNaN(g = +g) ? p : (g = 0.5 + ((g = +d(g)) - a) * (r * g < r * a ? s : l), c(f ? Math.max(0, Math.min(1, g)) : g));
  }
  m.domain = function(g) {
    return arguments.length ? ([e, t, n] = g, o = d(e = +e), a = d(t = +t), i = d(n = +n), s = o === a ? 0 : 0.5 / (a - o), l = a === i ? 0 : 0.5 / (i - a), r = a < o ? -1 : 1, m) : [e, t, n];
  }, m.clamp = function(g) {
    return arguments.length ? (f = !!g, m) : f;
  }, m.interpolator = function(g) {
    return arguments.length ? (c = g, m) : c;
  };
  function h(g) {
    return function(x) {
      var y, b, v;
      return arguments.length ? ([y, b, v] = x, c = W5(g, [y, b, v]), m) : [c(0), c(0.5), c(1)];
    };
  }
  return m.range = h(Xr), m.rangeRound = h(qa), m.unknown = function(g) {
    return arguments.length ? (p = g, m) : p;
  }, function(g) {
    return d = g, o = g(e), a = g(t), i = g(n), s = o === a ? 0 : 0.5 / (a - o), l = a === i ? 0 : 0.5 / (i - a), r = a < o ? -1 : 1, m;
  };
}
function v4() {
  var e = Ar(kl()(Ft));
  return e.copy = function() {
    return Cr(e, v4());
  }, Gn.apply(e, arguments);
}
function y4() {
  var e = _f(kl()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return Cr(e, y4()).base(e.base());
  }, Gn.apply(e, arguments);
}
function b4() {
  var e = Lf(kl());
  return e.copy = function() {
    return Cr(e, b4()).constant(e.constant());
  }, Gn.apply(e, arguments);
}
function qf() {
  var e = zf(kl());
  return e.copy = function() {
    return Cr(e, qf()).exponent(e.exponent());
  }, Gn.apply(e, arguments);
}
function kI() {
  return qf.apply(null, arguments).exponent(0.5);
}
const DI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: El,
  scaleDiverging: v4,
  scaleDivergingLog: y4,
  scaleDivergingPow: qf,
  scaleDivergingSqrt: kI,
  scaleDivergingSymlog: b4,
  scaleIdentity: V5,
  scaleImplicit: gu,
  scaleLinear: Rf,
  scaleLog: If,
  scaleOrdinal: Sl,
  scalePoint: s5,
  scalePow: Ol,
  scaleQuantile: jf,
  scaleQuantize: Vf,
  scaleRadial: Wf,
  scaleSequential: p4,
  scaleSequentialLog: h4,
  scaleSequentialPow: Xf,
  scaleSequentialQuantile: g4,
  scaleSequentialSqrt: NI,
  scaleSequentialSymlog: m4,
  scaleSqrt: U5,
  scaleSymlog: Bf,
  scaleThreshold: Hf,
  scaleTime: d4,
  scaleUtc: f4,
  tickFormat: j5
}, Symbol.toStringTag, { value: "Module" }));
function FI(e, t) {
  t.domain && ("nice" in e || "quantiles" in e || "padding" in e, e.domain(t.domain));
}
function RI(e, t) {
  t.range && ("padding" in e, e.range(t.range));
}
function _I(e, t) {
  "align" in e && "align" in t && typeof t.align < "u" && e.align(t.align);
}
function II(e, t) {
  "base" in e && "base" in t && typeof t.base < "u" && e.base(t.base);
}
function LI(e, t) {
  "clamp" in e && "clamp" in t && typeof t.clamp < "u" && e.clamp(t.clamp);
}
function BI(e, t) {
  "constant" in e && "constant" in t && typeof t.constant < "u" && e.constant(t.constant);
}
function zI(e, t) {
  "exponent" in e && "exponent" in t && typeof t.exponent < "u" && e.exponent(t.exponent);
}
const WI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  interpolate: Xr,
  interpolateArray: DR,
  interpolateBasis: x5,
  interpolateBasisClosed: w5,
  interpolateCubehelix: B5,
  interpolateCubehelixLong: z5,
  interpolateDate: M5,
  interpolateDiscrete: _R,
  interpolateHcl: _5,
  interpolateHclLong: I5,
  interpolateHsl: k5,
  interpolateHslLong: D5,
  interpolateHue: IR,
  interpolateLab: F5,
  interpolateNumber: un,
  interpolateNumberArray: Df,
  interpolateObject: $5,
  interpolateRgb: Ps,
  interpolateRgbBasis: NR,
  interpolateRgbBasisClosed: kR,
  interpolateRound: qa,
  interpolateString: P5,
  interpolateTransformCss: zR,
  interpolateTransformSvg: WR,
  interpolateZoom: UR,
  piecewise: W5,
  quantize: YR
}, Symbol.toStringTag, { value: "Module" }));
var hh = {
  lab: F5,
  hcl: _5,
  "hcl-long": I5,
  hsl: k5,
  "hsl-long": D5,
  cubehelix: B5,
  "cubehelix-long": z5,
  rgb: Ps
};
function jI(e) {
  switch (e) {
    case "lab":
    case "hcl":
    case "hcl-long":
    case "hsl":
    case "hsl-long":
    case "cubehelix":
    case "cubehelix-long":
    case "rgb":
      return hh[e];
  }
  var t = e.type, n = e.gamma, r = hh[t];
  return typeof n > "u" ? r : r.gamma(n);
}
function VI(e, t) {
  if ("interpolate" in t && "interpolate" in e && typeof t.interpolate < "u") {
    var n = jI(t.interpolate);
    e.interpolate(n);
  }
}
const HI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  timeDay: qr,
  timeDays: c_,
  timeFriday: X5,
  timeFridays: g_,
  timeHour: Ja,
  timeHours: s_,
  timeInterval: ct,
  timeMillisecond: To,
  timeMilliseconds: Jp,
  timeMinute: Qa,
  timeMinutes: a_,
  timeMonday: ka,
  timeMondays: f_,
  timeMonth: ti,
  timeMonths: S_,
  timeSaturday: q5,
  timeSaturdays: v_,
  timeSecond: pn,
  timeSeconds: th,
  timeSunday: Lr,
  timeSundays: nh,
  timeThursday: Br,
  timeThursdays: m_,
  timeTickInterval: o4,
  timeTicks: r4,
  timeTuesday: Y5,
  timeTuesdays: p_,
  timeWednesday: G5,
  timeWednesdays: h_,
  timeWeek: Lr,
  timeWeeks: nh,
  timeYear: gn,
  timeYears: M_,
  unixDay: Yf,
  unixDays: d_,
  utcDay: Xo,
  utcDays: u_,
  utcFriday: Z5,
  utcFridays: A_,
  utcHour: ei,
  utcHours: l_,
  utcMillisecond: To,
  utcMilliseconds: Jp,
  utcMinute: Za,
  utcMinutes: i_,
  utcMonday: Da,
  utcMondays: y_,
  utcMonth: ni,
  utcMonths: E_,
  utcSaturday: J5,
  utcSaturdays: C_,
  utcSecond: pn,
  utcSeconds: th,
  utcSunday: zr,
  utcSundays: rh,
  utcThursday: Wr,
  utcThursdays: w_,
  utcTickInterval: n4,
  utcTicks: t4,
  utcTuesday: K5,
  utcTuesdays: b_,
  utcWednesday: Q5,
  utcWednesdays: x_,
  utcWeek: zr,
  utcWeeks: rh,
  utcYear: vn,
  utcYears: $_
}, Symbol.toStringTag, { value: "Module" }));
var UI = new Date(Date.UTC(2020, 1, 2, 3, 4, 5)), YI = "%Y-%m-%d %H:%M";
function x4(e) {
  var t = e.tickFormat(1, YI)(UI);
  return t === "2020-02-02 03:04";
}
var mh = {
  day: qr,
  hour: Ja,
  minute: Qa,
  month: ti,
  second: pn,
  week: Lr,
  year: gn
}, gh = {
  day: Xo,
  hour: ei,
  minute: Za,
  month: ni,
  second: pn,
  week: zr,
  year: vn
};
function GI(e, t) {
  if ("nice" in t && typeof t.nice < "u" && "nice" in e) {
    var n = t.nice;
    if (typeof n == "boolean")
      n && e.nice();
    else if (typeof n == "number")
      e.nice(n);
    else {
      var r = e, o = x4(r);
      if (typeof n == "string")
        r.nice(o ? gh[n] : mh[n]);
      else {
        var a = n.interval, i = n.step, s = (o ? gh[a] : mh[a]).every(i);
        s != null && r.nice(s);
      }
    }
  }
}
function XI(e, t) {
  "padding" in e && "padding" in t && typeof t.padding < "u" && e.padding(t.padding), "paddingInner" in e && "paddingInner" in t && typeof t.paddingInner < "u" && e.paddingInner(t.paddingInner), "paddingOuter" in e && "paddingOuter" in t && typeof t.paddingOuter < "u" && e.paddingOuter(t.paddingOuter);
}
function qI(e, t) {
  if (t.reverse) {
    var n = e.range().slice().reverse();
    "padding" in e, e.range(n);
  }
}
function KI(e, t) {
  "round" in t && typeof t.round < "u" && (t.round && "interpolate" in t && typeof t.interpolate < "u" ? console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", t) : "round" in e ? e.round(t.round) : "interpolate" in e && t.round && e.interpolate(qa));
}
function QI(e, t) {
  "unknown" in e && "unknown" in t && typeof t.unknown < "u" && e.unknown(t.unknown);
}
function ZI(e, t) {
  if ("zero" in t && t.zero === !0) {
    var n = e.domain(), r = n[0], o = n[1], a = o < r, i = a ? [o, r] : [r, o], s = i[0], l = i[1], c = [Math.min(0, s), Math.max(0, l)];
    e.domain(a ? c.reverse() : c);
  }
}
var w4 = [
  // domain => nice => zero
  "domain",
  "nice",
  "zero",
  // interpolate before round
  "interpolate",
  "round",
  // set range then reverse
  "range",
  "reverse",
  // Order does not matter for these operators
  "align",
  "base",
  "clamp",
  "constant",
  "exponent",
  "padding",
  "unknown"
], JI = {
  domain: FI,
  nice: GI,
  zero: ZI,
  interpolate: VI,
  round: KI,
  align: _I,
  base: II,
  clamp: LI,
  constant: BI,
  exponent: zI,
  padding: XI,
  range: RI,
  reverse: qI,
  unknown: QI
};
function _t() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = new Set(t), o = w4.filter(function(a) {
    return r.has(a);
  });
  return function(i, s) {
    return typeof s < "u" && o.forEach(function(l) {
      JI[l](i, s);
    }), i;
  };
}
var eL = _t("domain", "range", "reverse", "align", "padding", "round");
function A4(e) {
  return eL(El(), e);
}
var tL = _t("domain", "range", "reverse", "align", "padding", "round");
function C4(e) {
  return tL(s5(), e);
}
var nL = _t("domain", "range", "reverse", "clamp", "interpolate", "nice", "round", "zero");
function Oo(e) {
  return nL(Rf(), e);
}
var rL = _t("domain", "range", "clamp", "nice", "round", "unknown");
function oL(e) {
  return rL(Wf(), e);
}
var aL = _t("domain", "range", "reverse", "clamp", "interpolate", "nice", "round");
function S4(e) {
  return aL(d4(), e);
}
var iL = _t("domain", "range", "reverse", "clamp", "interpolate", "nice", "round");
function E4(e) {
  return iL(f4(), e);
}
var sL = _t("domain", "range", "reverse", "base", "clamp", "interpolate", "nice", "round");
function M4(e) {
  return sL(If(), e);
}
var lL = _t("domain", "range", "reverse", "clamp", "exponent", "interpolate", "nice", "round", "zero");
function $4(e) {
  return lL(Ol(), e);
}
var cL = _t("domain", "range", "reverse", "unknown");
function P4(e) {
  return cL(Sl(), e);
}
var uL = _t("domain", "range", "reverse", "nice", "zero");
function T4(e) {
  return uL(Vf(), e);
}
var dL = _t("domain", "range", "reverse");
function O4(e) {
  return dL(jf(), e);
}
var fL = _t("domain", "range", "reverse", "clamp", "constant", "nice", "zero", "round");
function N4(e) {
  return fL(Bf(), e);
}
var pL = _t("domain", "range", "reverse");
function k4(e) {
  return pL(Hf(), e);
}
var hL = _t("domain", "range", "reverse", "clamp", "interpolate", "nice", "round", "zero");
function D4(e) {
  return hL(U5(), e);
}
function pa(e) {
  if (typeof e < "u" && "type" in e)
    switch (e.type) {
      case "linear":
        return Oo(e);
      case "log":
        return M4(e);
      case "pow":
        return $4(e);
      case "sqrt":
        return D4(e);
      case "symlog":
        return N4(e);
      case "time":
        return S4(e);
      case "utc":
        return E4(e);
      case "quantile":
        return O4(e);
      case "quantize":
        return T4(e);
      case "threshold":
        return k4(e);
      case "ordinal":
        return P4(e);
      case "point":
        return C4(e);
      case "band":
        return A4(e);
    }
  return Oo(e);
}
var mL = _t.apply(void 0, w4);
function gL(e, t) {
  return mL(e.copy(), t);
}
function vL(e) {
  return "paddingInner" in e ? "band" : "padding" in e ? "point" : "quantiles" in e ? "quantile" : "base" in e ? "log" : "exponent" in e ? e.exponent() === 0.5 ? "sqrt" : "pow" : "constant" in e ? "symlog" : "clamp" in e ? e.ticks()[0] instanceof Date ? x4(e) ? "utc" : "time" : "linear" : "nice" in e ? "quantize" : "invertExtent" in e ? "threshold" : "ordinal";
}
function Dl(e) {
  if ((typeof e == "function" || typeof e == "object" && e) && "valueOf" in e) {
    var t = e.valueOf();
    if (typeof t == "number")
      return t;
  }
  return e;
}
function Kf(e, t) {
  var n = e;
  return "ticks" in n ? n.ticks(t) : n.domain().filter(function(r, o, a) {
    return t == null || a.length <= t || o % Math.round((a.length - 1) / t) === 0;
  });
}
function F4(e) {
  return e == null ? void 0 : e.toString();
}
var yL = /* @__PURE__ */ new Set(["linear", "pow", "quantize", "sqrt", "symlog"]);
function Su(e) {
  return yL.has(e.type);
}
const bL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  coerceNumber: Dl,
  createScale: pa,
  getTicks: Kf,
  inferScaleType: vL,
  scaleBand: A4,
  scaleCanBeZeroed: Su,
  scaleLinear: Oo,
  scaleLog: M4,
  scaleOrdinal: P4,
  scalePoint: C4,
  scalePower: $4,
  scaleQuantile: O4,
  scaleQuantize: T4,
  scaleRadial: oL,
  scaleSqrt: D4,
  scaleSymlog: N4,
  scaleThreshold: k4,
  scaleTime: S4,
  scaleUtc: E4,
  toString: F4,
  updateScale: gL
}, Symbol.toStringTag, { value: "Module" }));
var xL = /* @__PURE__ */ R.createContext({});
const Pt = xL;
function Os(e) {
  var t, n = e;
  return n && "bandwidth" in n && (t = n == null ? void 0 : n.bandwidth()) != null ? t : 0;
}
function at(e) {
  return e != null && typeof e == "number" && !Number.isNaN(e) && Number.isFinite(e);
}
const R4 = /* @__PURE__ */ Vr(IT), _4 = /* @__PURE__ */ Vr(bL);
function Qt(e, t) {
  e(t);
}
function wL(e) {
  var t = e === void 0 ? {} : e, n = t.innerRadius, r = t.outerRadius, o = t.cornerRadius, a = t.startAngle, i = t.endAngle, s = t.padAngle, l = t.padRadius, c = p3();
  return n != null && Qt(c.innerRadius, n), r != null && Qt(c.outerRadius, r), o != null && Qt(c.cornerRadius, o), a != null && Qt(c.startAngle, a), i != null && Qt(c.endAngle, i), s != null && Qt(c.padAngle, s), l != null && Qt(c.padRadius, l), c;
}
function AL(e) {
  var t = e === void 0 ? {} : e, n = t.x, r = t.y, o = t.defined, a = t.curve, i = gl();
  return n && Qt(i.x, n), r && Qt(i.y, r), o && i.defined(o), a && i.curve(a), i;
}
function CL(e) {
  var t = e === void 0 ? {} : e, n = t.startAngle, r = t.endAngle, o = t.padAngle, a = t.value, i = t.sort, s = t.sortValues, l = g3();
  return (i === null || i != null) && l.sort(i), (s === null || s != null) && l.sortValues(s), a != null && l.value(a), o != null && Qt(l.padAngle, o), n != null && Qt(l.startAngle, n), r != null && Qt(l.endAngle, r), l;
}
var SL = ["className", "top", "left", "data", "centroid", "innerRadius", "outerRadius", "cornerRadius", "startAngle", "endAngle", "padAngle", "padRadius", "pieSort", "pieSortValues", "pieValue", "children", "fill"];
function Eu() {
  return Eu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Eu.apply(this, arguments);
}
function EL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function ML(e) {
  var t = e.className, n = e.top, r = e.left, o = e.data, a = o === void 0 ? [] : o, i = e.centroid, s = e.innerRadius, l = s === void 0 ? 0 : s, c = e.outerRadius, d = e.cornerRadius, f = e.startAngle, p = e.endAngle, m = e.padAngle, h = e.padRadius, g = e.pieSort, x = e.pieSortValues, y = e.pieValue, b = e.children, v = e.fill, A = v === void 0 ? "" : v, w = EL(e, SL), M = wL({
    innerRadius: l,
    outerRadius: c,
    cornerRadius: d,
    padRadius: h
  }), $ = CL({
    startAngle: f,
    endAngle: p,
    padAngle: m,
    value: y,
    sort: g,
    sortValues: x
  }), P = $(a);
  return b ? /* @__PURE__ */ R.createElement(R.Fragment, null, b({
    arcs: P,
    path: M,
    pie: $
  })) : /* @__PURE__ */ R.createElement(Tn, {
    className: "visx-pie-arcs-group",
    top: n,
    left: r
  }, P.map(function(E, T) {
    return /* @__PURE__ */ R.createElement("g", {
      key: "pie-arc-" + T
    }, /* @__PURE__ */ R.createElement("path", Eu({
      className: $t("visx-pie-arc", t),
      d: M(E) || "",
      fill: A == null || typeof A == "string" ? A : A(E)
    }, w)), i == null ? void 0 : i(M.centroid(E), E));
  }));
}
var $L = ["from", "to", "fill", "className", "innerRef"];
function Mu() {
  return Mu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mu.apply(this, arguments);
}
function PL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Qf(e) {
  var t = e.from, n = t === void 0 ? {
    x: 0,
    y: 0
  } : t, r = e.to, o = r === void 0 ? {
    x: 1,
    y: 1
  } : r, a = e.fill, i = a === void 0 ? "transparent" : a, s = e.className, l = e.innerRef, c = PL(e, $L), d = n.x === o.x || n.y === o.y;
  return /* @__PURE__ */ R.createElement("line", Mu({
    ref: l,
    className: $t("visx-line", s),
    x1: n.x,
    y1: n.y,
    x2: o.x,
    y2: o.y,
    fill: i,
    shapeRendering: d ? "crispEdges" : "auto"
  }, c));
}
var TL = ["children", "data", "x", "y", "fill", "className", "curve", "innerRef", "defined"];
function $u() {
  return $u = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $u.apply(this, arguments);
}
function OL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function I4(e) {
  var t = e.children, n = e.data, r = n === void 0 ? [] : n, o = e.x, a = e.y, i = e.fill, s = i === void 0 ? "transparent" : i, l = e.className, c = e.curve, d = e.innerRef, f = e.defined, p = f === void 0 ? function() {
    return !0;
  } : f, m = OL(e, TL), h = AL({
    x: o,
    y: a,
    defined: p,
    curve: c
  });
  return t ? /* @__PURE__ */ R.createElement(R.Fragment, null, t({
    path: h
  })) : /* @__PURE__ */ R.createElement("path", $u({
    ref: d,
    className: $t("visx-linepath", l),
    d: h(r) || "",
    fill: s,
    strokeLinecap: "round"
  }, m));
}
var NL = ["className", "innerRef"];
function Pu() {
  return Pu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pu.apply(this, arguments);
}
function kL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function DL(e) {
  var t = e.className, n = e.innerRef, r = kL(e, NL);
  return /* @__PURE__ */ R.createElement("rect", Pu({
    ref: n,
    className: $t("visx-bar", t)
  }, r));
}
var FL = ["children", "className", "innerRef", "x", "y", "width", "height", "radius", "all", "top", "bottom", "left", "right", "topLeft", "topRight", "bottomLeft", "bottomRight"];
function Tu() {
  return Tu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tu.apply(this, arguments);
}
function RL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function _L(e) {
  var t = e.all, n = e.bottom, r = e.bottomLeft, o = e.bottomRight, a = e.height, i = e.left, s = e.radius, l = e.right, c = e.top, d = e.topLeft, f = e.topRight, p = e.width, m = e.x, h = e.y;
  f = t || c || l || f, o = t || n || l || o, r = t || n || i || r, d = t || c || i || d, s = Math.max(1, Math.min(s, Math.min(p, a) / 2));
  var g = 2 * s, x = ("M" + (m + s) + "," + h + " h" + (p - g) + `
 ` + (f ? "a" + s + "," + s + " 0 0 1 " + s + "," + s : "h" + s + "v" + s) + `
 v` + (a - g) + `
 ` + (o ? "a" + s + "," + s + " 0 0 1 " + -s + "," + s : "v" + s + "h" + -s) + `
 h` + (g - p) + `
 ` + (r ? "a" + s + "," + s + " 0 0 1 " + -s + "," + -s : "h" + -s + "v" + -s) + `
 v` + (g - a) + `
 ` + (d ? "a" + s + "," + s + " 0 0 1 " + s + "," + -s : "v" + -s + "h" + s) + `
z`).split(`
`).join("");
  return x;
}
function L4(e) {
  var t = e.children, n = e.className, r = e.innerRef, o = e.x, a = e.y, i = e.width, s = e.height, l = e.radius, c = e.all, d = c === void 0 ? !1 : c, f = e.top, p = f === void 0 ? !1 : f, m = e.bottom, h = m === void 0 ? !1 : m, g = e.left, x = g === void 0 ? !1 : g, y = e.right, b = y === void 0 ? !1 : y, v = e.topLeft, A = v === void 0 ? !1 : v, w = e.topRight, M = w === void 0 ? !1 : w, $ = e.bottomLeft, P = $ === void 0 ? !1 : $, E = e.bottomRight, T = E === void 0 ? !1 : E, B = RL(e, FL), j = _L({
    x: o,
    y: a,
    width: i,
    height: s,
    radius: l,
    all: d,
    top: p,
    bottom: h,
    left: x,
    right: b,
    topLeft: A,
    topRight: M,
    bottomLeft: P,
    bottomRight: T
  });
  return t ? /* @__PURE__ */ R.createElement(R.Fragment, null, t({
    path: j
  })) : /* @__PURE__ */ R.createElement("path", Tu({
    ref: r,
    className: $t("visx-bar-rounded", n),
    d: j
  }, B));
}
function IL(e) {
  return typeof (e == null ? void 0 : e.x) == "number" ? e == null ? void 0 : e.x : 0;
}
function LL(e) {
  return typeof (e == null ? void 0 : e.y) == "number" ? e == null ? void 0 : e.y : 0;
}
function BL(e) {
  return e == null ? void 0 : e.source;
}
function zL(e) {
  return e == null ? void 0 : e.target;
}
var WL = ["className", "children", "data", "innerRef", "path", "x", "y", "source", "target"];
function Ou() {
  return Ou = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ou.apply(this, arguments);
}
function jL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function VL(e) {
  var t = e.source, n = e.target, r = e.x, o = e.y;
  return function(a) {
    var i = b3();
    return i.x(r), i.y(o), i.source(t), i.target(n), i(a);
  };
}
function HL(e) {
  var t = e.className, n = e.children, r = e.data, o = e.innerRef, a = e.path, i = e.x, s = i === void 0 ? LL : i, l = e.y, c = l === void 0 ? IL : l, d = e.source, f = d === void 0 ? BL : d, p = e.target, m = p === void 0 ? zL : p, h = jL(e, WL), g = a || VL({
    source: f,
    target: m,
    x: s,
    y: c
  });
  return n ? /* @__PURE__ */ R.createElement(R.Fragment, null, n({
    path: g
  })) : /* @__PURE__ */ R.createElement("path", Ou({
    ref: o,
    className: $t("visx-link visx-link-horizontal-diagonal", t),
    d: g(r) || ""
  }, h));
}
var UL = ["className", "innerRef"];
function Nu() {
  return Nu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nu.apply(this, arguments);
}
function YL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function vh(e) {
  var t = e.className, n = e.innerRef, r = YL(e, UL);
  return /* @__PURE__ */ R.createElement("circle", Nu({
    ref: n,
    className: $t("visx-circle", t)
  }, r));
}
var GL = ["AxisComponent"];
function Ns() {
  return Ns = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ns.apply(this, arguments);
}
function XL(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function qL(e) {
  var t, n, r, o, a, i, s, l = e.AxisComponent, c = XL(e, GL), d = Xe(Pt), f = d.theme, p = d.xScale, m = d.yScale, h = d.margin, g = d.width, x = d.height, y = c.orientation, b = Se(function() {
    var P, E, T, B;
    return y === "left" || y === "right" ? f == null || (P = f.axisStyles) == null || (E = P.y) == null ? void 0 : E[y] : f == null || (T = f.axisStyles) == null || (B = T.x) == null ? void 0 : B[y];
  }, [f, y]), v = c.tickLabelProps, A = Se(function() {
    return v || b ? function(P, E, T) {
      return (
        // by default, wrap vertical-axis tick labels within the allotted margin space
        // this does not currently account for axis label
        Ns({}, b == null ? void 0 : b.tickLabel, {
          width: y === "left" || y === "right" ? h == null ? void 0 : h[y] : void 0
        }, typeof v == "function" ? v(P, E, T) : v)
      );
    } : void 0;
  }, [v, b, y, h]), w = y === "bottom" ? (x ?? 0) - ((t = h == null ? void 0 : h.bottom) != null ? t : 0) : y === "top" && (n = h == null ? void 0 : h.top) != null ? n : 0, M = y === "left" ? (r = h == null ? void 0 : h.left) != null ? r : 0 : y === "right" ? (g ?? 0) - ((o = h == null ? void 0 : h.right) != null ? o : 0) : 0, $ = y === "left" || y === "right" ? m : p;
  return $ ? /* @__PURE__ */ R.createElement(l, Ns({
    top: w,
    left: M,
    labelProps: b == null ? void 0 : b.axisLabel,
    stroke: b == null || (a = b.axisLine) == null ? void 0 : a.stroke,
    strokeWidth: b == null || (i = b.axisLine) == null ? void 0 : i.strokeWidth,
    tickLength: b == null ? void 0 : b.tickLength,
    tickStroke: b == null || (s = b.tickLine) == null ? void 0 : s.stroke
  }, c, {
    tickLabelProps: A,
    scale: $
  })) : null;
}
var Fl = {};
Fl.__esModule = !0;
var KL = Fl.default = tB, QL = B4(R), ZL = B4(ml), JL = ["from", "to", "fill", "className", "innerRef"];
function B4(e) {
  return e && e.__esModule ? e : { default: e };
}
function ku() {
  return ku = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ku.apply(this, arguments);
}
function eB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function tB(e) {
  var t = e.from, n = t === void 0 ? {
    x: 0,
    y: 0
  } : t, r = e.to, o = r === void 0 ? {
    x: 1,
    y: 1
  } : r, a = e.fill, i = a === void 0 ? "transparent" : a, s = e.className, l = e.innerRef, c = eB(e, JL), d = n.x === o.x || n.y === o.y;
  return /* @__PURE__ */ QL.default.createElement("line", ku({
    ref: l,
    className: (0, ZL.default)("visx-line", s),
    x1: n.x,
    y1: n.y,
    x2: o.x,
    y2: o.y,
    fill: i,
    shapeRendering: d ? "crispEdges" : "auto"
  }, c));
}
var Rl = {};
Rl.__esModule = !0;
Rl.default = nB;
function nB(e) {
  return "bandwidth" in e ? e.bandwidth() : 0;
}
var rB = z4, yh = ri(hl), bh = ri(R), oB = ri(ml), aB = ri(Fl), iB = R4, xh = n5, wh = _4, sB = ri(Rl), lB = ["top", "left", "scale", "width", "stroke", "strokeWidth", "strokeDasharray", "className", "children", "numTicks", "lineStyle", "offset", "tickValues"];
function ri(e) {
  return e && e.__esModule ? e : { default: e };
}
function Du() {
  return Du = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Du.apply(this, arguments);
}
function cB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function z4(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, o = r === void 0 ? 0 : r, a = e.scale, i = e.width, s = e.stroke, l = s === void 0 ? "#eaf0f6" : s, c = e.strokeWidth, d = c === void 0 ? 1 : c, f = e.strokeDasharray, p = e.className, m = e.children, h = e.numTicks, g = h === void 0 ? 10 : h, x = e.lineStyle, y = e.offset, b = e.tickValues, v = cB(e, lB), A = b ?? (0, wh.getTicks)(a, g), w = (y ?? 0) + (0, sB.default)(a) / 2, M = A.map(function($, P) {
    var E, T = ((E = (0, wh.coerceNumber)(a($))) != null ? E : 0) + w;
    return {
      index: P,
      from: new xh.Point({
        x: 0,
        y: T
      }),
      to: new xh.Point({
        x: i,
        y: T
      })
    };
  });
  return /* @__PURE__ */ bh.default.createElement(iB.Group, {
    className: (0, oB.default)("visx-rows", p),
    top: n,
    left: o
  }, m ? m({
    lines: M
  }) : M.map(function($) {
    var P = $.from, E = $.to, T = $.index;
    return /* @__PURE__ */ bh.default.createElement(aB.default, Du({
      key: "row-line-" + T,
      from: P,
      to: E,
      stroke: l,
      strokeWidth: d,
      strokeDasharray: f,
      style: x
    }, v));
  }));
}
z4.propTypes = {
  tickValues: yh.default.array,
  width: yh.default.number.isRequired
};
var uB = W4, Ah = oi(hl), Ch = oi(R), dB = oi(ml), fB = oi(Fl), pB = R4, Sh = n5, Eh = _4, hB = oi(Rl), mB = ["top", "left", "scale", "height", "stroke", "strokeWidth", "strokeDasharray", "className", "numTicks", "lineStyle", "offset", "tickValues", "children"];
function oi(e) {
  return e && e.__esModule ? e : { default: e };
}
function Fu() {
  return Fu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fu.apply(this, arguments);
}
function gB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function W4(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, o = r === void 0 ? 0 : r, a = e.scale, i = e.height, s = e.stroke, l = s === void 0 ? "#eaf0f6" : s, c = e.strokeWidth, d = c === void 0 ? 1 : c, f = e.strokeDasharray, p = e.className, m = e.numTicks, h = m === void 0 ? 10 : m, g = e.lineStyle, x = e.offset, y = e.tickValues, b = e.children, v = gB(e, mB), A = y ?? (0, Eh.getTicks)(a, h), w = (x ?? 0) + (0, hB.default)(a) / 2, M = A.map(function($, P) {
    var E, T = ((E = (0, Eh.coerceNumber)(a($))) != null ? E : 0) + w;
    return {
      index: P,
      from: new Sh.Point({
        x: T,
        y: 0
      }),
      to: new Sh.Point({
        x: T,
        y: i
      })
    };
  });
  return /* @__PURE__ */ Ch.default.createElement(pB.Group, {
    className: (0, dB.default)("visx-columns", p),
    top: n,
    left: o
  }, b ? b({
    lines: M
  }) : M.map(function($) {
    var P = $.from, E = $.to, T = $.index;
    return /* @__PURE__ */ Ch.default.createElement(fB.default, Fu({
      key: "column-line-" + T,
      from: P,
      to: E,
      stroke: l,
      strokeWidth: d,
      strokeDasharray: f,
      style: g
    }, v));
  }));
}
W4.propTypes = {
  tickValues: Ah.default.array,
  height: Ah.default.number.isRequired
};
var vB = ["rows", "columns", "GridRowsComponent", "GridColumnsComponent"];
function ks() {
  return ks = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ks.apply(this, arguments);
}
function yB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function j4(e) {
  var t = e.rows, n = t === void 0 ? !0 : t, r = e.columns, o = r === void 0 ? !0 : r, a = e.GridRowsComponent, i = e.GridColumnsComponent, s = yB(e, vB), l = Xe(Pt), c = l.theme, d = l.xScale, f = l.yScale, p = l.margin, m = l.innerWidth, h = l.innerHeight, g = c == null ? void 0 : c.gridStyles;
  return /* @__PURE__ */ R.createElement(R.Fragment, null, n && f && m != null && /* @__PURE__ */ R.createElement(a, ks({
    left: p == null ? void 0 : p.left,
    lineStyle: g,
    width: m,
    scale: f
  }, s)), o && d && h != null && /* @__PURE__ */ R.createElement(i, ks({
    top: p == null ? void 0 : p.top,
    lineStyle: g,
    height: h,
    scale: d
  }, s)));
}
j4.propTypes = {
  rows: se.bool,
  columns: se.bool
};
var bB = {
  top: "top",
  left: "left",
  right: "right",
  bottom: "bottom"
};
const fn = bB;
function xB(e) {
  var t = e.labelOffset, n = e.labelProps, r = e.orientation, o = e.range, a = e.tickLabelFontSize, i = e.tickLength, s = r === fn.left || r === fn.top ? -1 : 1, l, c, d;
  if (r === fn.top || r === fn.bottom) {
    var f = r === fn.bottom && typeof n.fontSize == "number" ? n.fontSize : 0;
    l = (Number(o[0]) + Number(o[o.length - 1])) / 2, c = s * (i + t + a + f);
  } else
    l = s * ((Number(o[0]) + Number(o[o.length - 1])) / 2), c = -(i + t), d = "rotate(" + s * 90 + ")";
  return {
    x: l,
    y: c,
    transform: d
  };
}
function va() {
  return va = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, va.apply(this, arguments);
}
function wB(e) {
  var t = e.hideTicks, n = e.horizontal, r = e.orientation, o = e.tickClassName, a = e.tickComponent, i = e.tickLabelProps, s = e.tickStroke, l = s === void 0 ? "#222" : s, c = e.tickTransform, d = e.ticks, f = e.strokeWidth, p = e.tickLineProps;
  return d.map(function(m) {
    var h, g = m.value, x = m.index, y = m.from, b = m.to, v = m.formattedValue, A = (h = i[x]) != null ? h : {}, w = Math.max(10, typeof A.fontSize == "number" && A.fontSize || 0), M = b.y + (n && r !== fn.top ? w : 0);
    return /* @__PURE__ */ R.createElement(Tn, {
      key: "visx-tick-" + g + "-" + x,
      className: $t("visx-axis-tick", o),
      transform: c
    }, !t && /* @__PURE__ */ R.createElement(Qf, va({
      from: y,
      to: b,
      stroke: l,
      strokeWidth: f,
      strokeLinecap: "square"
    }, p)), a ? a(va({}, A, {
      x: b.x,
      y: M,
      formattedValue: v
    })) : /* @__PURE__ */ R.createElement(Ga, va({
      x: b.x,
      y: M
    }, A), v));
  });
}
function Ds() {
  return Ds = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ds.apply(this, arguments);
}
var Mh = {
  textAnchor: "middle",
  fontFamily: "Arial",
  fontSize: 10,
  fill: "#222"
};
function AB(e) {
  var t = e.axisFromPoint, n = e.axisLineClassName, r = e.axisToPoint, o = e.hideAxisLine, a = e.hideTicks, i = e.horizontal, s = e.label, l = s === void 0 ? "" : s, c = e.labelClassName, d = e.labelOffset, f = d === void 0 ? 14 : d, p = e.labelProps, m = p === void 0 ? Mh : p, h = e.orientation, g = h === void 0 ? fn.bottom : h, x = e.scale, y = e.stroke, b = y === void 0 ? "#222" : y, v = e.strokeDasharray, A = e.strokeWidth, w = A === void 0 ? 1 : A, M = e.tickClassName, $ = e.tickComponent, P = e.tickLineProps, E = e.tickLabelProps, T = e.tickLength, B = T === void 0 ? 8 : T, j = e.tickStroke, V = j === void 0 ? "#222" : j, W = e.tickTransform, S = e.ticks, _ = e.ticksComponent, U = _ === void 0 ? wB : _, z = Ds({}, Mh, typeof E == "object" ? E : null), N = S.map(function(k) {
    var Q = k.value, q = k.index;
    return typeof E == "function" ? E(Q, q, S) : z;
  }), O = Math.max.apply(Math, [10].concat(N.map(function(k) {
    return typeof k.fontSize == "number" ? k.fontSize : 0;
  })));
  return /* @__PURE__ */ R.createElement(R.Fragment, null, U({
    hideTicks: a,
    horizontal: i,
    orientation: g,
    scale: x,
    tickClassName: M,
    tickComponent: $,
    tickLabelProps: N,
    tickStroke: V,
    tickTransform: W,
    ticks: S,
    strokeWidth: w,
    tickLineProps: P
  }), !o && /* @__PURE__ */ R.createElement(Qf, {
    className: $t("visx-axis-line", n),
    from: t,
    to: r,
    stroke: b,
    strokeWidth: w,
    strokeDasharray: v
  }), l && /* @__PURE__ */ R.createElement(Ga, Ds({
    className: $t("visx-axis-label", c)
  }, xB({
    labelOffset: f,
    labelProps: m,
    orientation: g,
    range: x.range(),
    tickLabelFontSize: O,
    tickLength: B
  }), m), l));
}
function CB(e, t) {
  t === void 0 && (t = "center");
  var n = e;
  if (t !== "start" && "bandwidth" in n) {
    var r = n.bandwidth();
    return t === "center" && (r /= 2), n.round() && (r = Math.round(r)), function(o) {
      var a = n(o);
      return typeof a == "number" ? a + r : a;
    };
  }
  return e;
}
function SB(e) {
  var t = e;
  return "tickFormat" in t ? t.tickFormat() : F4;
}
function Li(e, t) {
  var n = e.x, r = e.y;
  return new Wn(t ? {
    x: n,
    y: r
  } : {
    x: r,
    y: n
  });
}
function Ru() {
  return Ru = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ru.apply(this, arguments);
}
var Mc = 0;
function EB(e) {
  return e === void 0 && (e = Mc), typeof e == "number" ? {
    start: e,
    end: e
  } : Ru({
    start: Mc,
    end: Mc
  }, e);
}
var MB = ["children", "axisClassName", "hideAxisLine", "hideTicks", "hideZero", "innerRef", "left", "numTicks", "orientation", "rangePadding", "scale", "tickFormat", "tickLength", "tickValues", "top"];
function _u() {
  return _u = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _u.apply(this, arguments);
}
function $B(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Iu(e) {
  var t = e.children, n = t === void 0 ? AB : t, r = e.axisClassName, o = e.hideAxisLine, a = o === void 0 ? !1 : o, i = e.hideTicks, s = i === void 0 ? !1 : i, l = e.hideZero, c = l === void 0 ? !1 : l, d = e.innerRef, f = e.left, p = f === void 0 ? 0 : f, m = e.numTicks, h = m === void 0 ? 10 : m, g = e.orientation, x = g === void 0 ? fn.bottom : g, y = e.rangePadding, b = y === void 0 ? 0 : y, v = e.scale, A = e.tickFormat, w = e.tickLength, M = w === void 0 ? 8 : w, $ = e.tickValues, P = e.top, E = P === void 0 ? 0 : P, T = $B(e, MB), B = A ?? SB(v), j = x === fn.left, V = x === fn.top, W = V || x === fn.bottom, S = CB(v), _ = j || V ? -1 : 1, U = v.range(), z = EB(b), N = Li({
    x: Number(U[0]) + 0.5 - z.start,
    y: 0
  }, W), O = Li({
    x: Number(U[U.length - 1]) + 0.5 + z.end,
    y: 0
  }, W), k = ($ ?? Kf(v, h)).filter(function(q) {
    return !c || q !== 0 && q !== "0";
  }).map(function(q, re) {
    return {
      value: q,
      index: re
    };
  }), Q = k.map(function(q) {
    var re = q.value, ae = q.index, oe = Dl(S(re));
    return {
      value: re,
      index: ae,
      from: Li({
        x: oe,
        y: 0
      }, W),
      to: Li({
        x: oe,
        y: M * _
      }, W),
      formattedValue: B(re, ae, k)
    };
  });
  return /* @__PURE__ */ R.createElement(Tn, {
    className: $t("visx-axis", r),
    innerRef: d,
    top: E,
    left: p
  }, n(_u({}, T, {
    axisFromPoint: N,
    axisToPoint: O,
    hideAxisLine: a,
    hideTicks: s,
    hideZero: c,
    horizontal: W,
    numTicks: h,
    orientation: x,
    rangePadding: b,
    scale: v,
    tickFormat: B,
    tickLength: M,
    tickPosition: S,
    tickSign: _,
    ticks: Q
  })));
}
function Lu() {
  return Lu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lu.apply(this, arguments);
}
function No(e) {
  return /* @__PURE__ */ R.createElement(qL, Lu({
    AxisComponent: Iu
  }, e));
}
function Bu() {
  return Bu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bu.apply(this, arguments);
}
function V4(e) {
  return /* @__PURE__ */ R.createElement(j4, Bu({
    GridRowsComponent: rB,
    GridColumnsComponent: uB
  }, e));
}
var PB = ["tooltipOpen"];
function TB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Fs() {
  return Fs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fs.apply(this, arguments);
}
function ai(e) {
  var t = we(Fs({
    tooltipOpen: !1
  }, e)), n = t[0], r = t[1], o = me(function(i) {
    return r(typeof i == "function" ? function(s) {
      s.tooltipOpen;
      var l = TB(s, PB);
      return Fs({}, i(l), {
        tooltipOpen: !0
      });
    } : {
      tooltipOpen: !0,
      tooltipLeft: i.tooltipLeft,
      tooltipTop: i.tooltipTop,
      tooltipData: i.tooltipData
    });
  }, [r]), a = me(function() {
    return r({
      tooltipOpen: !1,
      tooltipLeft: void 0,
      tooltipTop: void 0,
      tooltipData: void 0
    });
  }, [r]);
  return {
    tooltipOpen: n.tooltipOpen,
    tooltipLeft: n.tooltipLeft,
    tooltipTop: n.tooltipTop,
    tooltipData: n.tooltipData,
    updateTooltip: r,
    showTooltip: o,
    hideTooltip: a
  };
}
function OB(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, zu(e, t);
}
function zu(e, t) {
  return zu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, zu(e, t);
}
var H4 = /* @__PURE__ */ function(e) {
  OB(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.componentWillUnmount = function() {
    this.node && document.body && (document.body.removeChild(this.node), delete this.node);
  }, n.render = function() {
    return !this.node && typeof document < "u" && (this.node = document.createElement("div"), this.props.zIndex != null && (this.node.style.zIndex = "" + this.props.zIndex), document.body.append(this.node)), this.node ? /* @__PURE__ */ _a.createPortal(this.props.children, this.node) : null;
  }, t;
}(R.PureComponent);
H4.propTypes = {
  zIndex: se.oneOfType([se.number, se.string])
};
var NB = ["className", "top", "left", "offsetLeft", "offsetTop", "style", "children", "unstyled", "applyPositionStyle"];
function Rs() {
  return Rs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rs.apply(this, arguments);
}
function kB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var Zf = {
  position: "absolute",
  backgroundColor: "white",
  color: "#666666",
  padding: ".3rem .5rem",
  borderRadius: "3px",
  fontSize: "14px",
  boxShadow: "0 1px 2px rgba(33,33,33,0.2)",
  lineHeight: "1em",
  pointerEvents: "none"
}, Jf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n = e.className, r = e.top, o = e.left, a = e.offsetLeft, i = a === void 0 ? 10 : a, s = e.offsetTop, l = s === void 0 ? 10 : s, c = e.style, d = c === void 0 ? Zf : c, f = e.children, p = e.unstyled, m = p === void 0 ? !1 : p, h = e.applyPositionStyle, g = h === void 0 ? !1 : h, x = kB(e, NB);
  return /* @__PURE__ */ R.createElement("div", Rs({
    ref: t,
    className: $t("visx-tooltip", n),
    style: Rs({
      top: r == null || l == null ? r : r + l,
      left: o == null || i == null ? o : o + i
    }, g && {
      position: "absolute"
    }, !m && d)
  }, x), f);
});
Jf.propTypes = {
  children: se.node,
  className: se.string,
  left: se.number,
  offsetLeft: se.number,
  offsetTop: se.number,
  top: se.number,
  applyPositionStyle: se.bool,
  unstyled: se.bool
};
Jf.displayName = "Tooltip";
const U4 = Jf;
function Wu() {
  return Wu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wu.apply(this, arguments);
}
function DB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FB(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ju(e, t);
}
function ju(e, t) {
  return ju = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, ju(e, t);
}
var $h = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
function RB(e) {
  var t;
  return t = /* @__PURE__ */ function(n) {
    FB(r, n);
    function r(a) {
      var i;
      return i = n.call(this, a) || this, i.state = {
        rect: void 0,
        parentRect: void 0
      }, i.nodeRef = /* @__PURE__ */ R.createRef(), i.getRects = i.getRects.bind(DB(i)), i;
    }
    var o = r.prototype;
    return o.componentDidMount = function() {
      var i, s = this;
      this.node = (i = this.nodeRef) != null && i.current ? this.nodeRef.current : _a.findDOMNode(this), this.setState(function() {
        return s.getRects();
      });
    }, o.getRects = function() {
      if (!this.node)
        return this.state;
      var i = this.node, s = i.parentNode, l = i.getBoundingClientRect ? i.getBoundingClientRect() : $h, c = s != null && s.getBoundingClientRect ? s.getBoundingClientRect() : $h;
      return {
        rect: l,
        parentRect: c
      };
    }, o.render = function() {
      return /* @__PURE__ */ R.createElement(e, Wu({
        nodeRef: this.nodeRef,
        getRects: this.getRects
      }, this.state, this.props));
    }, r;
  }(R.PureComponent), t.displayName = "withBoundingRects(" + (e.displayName || "") + ")", t;
}
var Y4 = /* @__PURE__ */ tn({
  isFlippedVertically: !1,
  isFlippedHorizontally: !1
}), _B = Y4.Provider;
Y4.Consumer;
var IB = ["children", "getRects", "left", "offsetLeft", "offsetTop", "parentRect", "rect", "style", "top", "unstyled", "nodeRef"];
function _s() {
  return _s = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _s.apply(this, arguments);
}
function LB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function G4(e) {
  var t = e.children;
  e.getRects;
  var n = e.left, r = n === void 0 ? 0 : n, o = e.offsetLeft, a = o === void 0 ? 10 : o, i = e.offsetTop, s = i === void 0 ? 10 : i, l = e.parentRect, c = e.rect, d = e.style, f = d === void 0 ? Zf : d, p = e.top, m = p === void 0 ? 0 : p, h = e.unstyled, g = h === void 0 ? !1 : h, x = e.nodeRef, y = LB(e, IB), b, v = !1, A = !1;
  if (c && l) {
    var w = r, M = m;
    if (l.width) {
      var $ = w + a + c.width - l.width, P = c.width - w - a;
      v = $ > 0 && $ > P;
    } else {
      var E = w + a + c.width - window.innerWidth, T = c.width - w - a;
      v = E > 0 && E > T;
    }
    if (l.height) {
      var B = M + s + c.height - l.height, j = c.height - M - s;
      A = B > 0 && B > j;
    } else
      A = M + s + c.height > window.innerHeight;
    w = v ? w - c.width - a : w + a, M = A ? M - c.height - s : M + s, w = Math.round(w), M = Math.round(M), b = "translate(" + w + "px, " + M + "px)";
  }
  return /* @__PURE__ */ R.createElement(U4, _s({
    ref: x,
    style: _s({
      left: 0,
      top: 0,
      transform: b
    }, !g && f)
  }, y), /* @__PURE__ */ R.createElement(_B, {
    value: {
      isFlippedVertically: !A,
      isFlippedHorizontally: !v
    }
  }, t));
}
G4.propTypes = {
  nodeRef: se.oneOfType([se.string, se.func, se.object])
};
const BB = RB(G4);
var zB = ["detectBounds", "zIndex"], WB = ["left", "top", "detectBounds", "zIndex"];
function Vu() {
  return Vu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vu.apply(this, arguments);
}
function Ph(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function ii(e) {
  var t = e === void 0 ? {} : e, n = t.detectBounds, r = n === void 0 ? !0 : n, o = t.zIndex, a = Ph(t, zB), i = NF(a), s = i[0], l = i[1], c = i[2], d = we(!1), f = d[0], p = d[1];
  Ce(function() {
    p(!1);
  }, []);
  var m = Se(function() {
    return function(h) {
      var g = h.left, x = g === void 0 ? 0 : g, y = h.top, b = y === void 0 ? 0 : y, v = h.detectBounds, A = h.zIndex, w = Ph(h, WB), M = v ?? r, $ = A ?? o, P = M ? BB : U4, E = f ? 0 : window.scrollX, T = f ? 0 : window.scrollY, B = x + (l.left || 0) + E, j = b + (l.top || 0) + T;
      return /* @__PURE__ */ R.createElement(H4, {
        zIndex: $
      }, /* @__PURE__ */ R.createElement(P, Vu({
        left: B,
        top: j
      }, w)));
    };
  }, [r, o, l.left, l.top, f]);
  return {
    containerRef: s,
    containerBounds: l,
    forceRefreshBounds: c,
    TooltipInPortal: m
  };
}
var jB = /* @__PURE__ */ tn(null);
const si = jB;
var VB = ["debounce", "detectBounds", "horizontalCrosshairStyle", "glyphStyle", "renderTooltip", "renderGlyph", "resizeObserverPolyfill", "scroll", "showDatumGlyph", "showHorizontalCrosshair", "showSeriesGlyphs", "showVerticalCrosshair", "snapTooltipToDatumX", "snapTooltipToDatumY", "verticalCrosshairStyle", "zIndex"], HB = ["x", "y"];
function Th(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Fn() {
  return Fn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fn.apply(this, arguments);
}
var $c = {
  position: "absolute",
  pointerEvents: "none",
  fontSize: 0,
  lineHeight: 0
}, UB = {
  position: "absolute",
  left: 0,
  top: 0,
  opacity: 0,
  width: 0,
  height: 0,
  pointerEvents: "none"
};
function X4(e) {
  var t = Xe(Pt) || {}, n = t.theme;
  return /* @__PURE__ */ R.createElement("circle", Fn({
    cx: e.x,
    cy: e.y,
    r: e.size,
    fill: e.color,
    stroke: n == null ? void 0 : n.backgroundColor,
    strokeWidth: 1.5,
    paintOrder: "fill"
  }, e.glyphStyle));
}
X4.propTypes = {
  isNearestDatum: se.bool.isRequired
};
function YB(e) {
  return /* @__PURE__ */ R.createElement(X4, e);
}
function q4(e) {
  var t, n, r, o, a, i, s, l, c, d, f, p, m, h = e.debounce, g = e.detectBounds, x = e.horizontalCrosshairStyle, y = e.glyphStyle, b = e.renderTooltip, v = e.renderGlyph, A = v === void 0 ? YB : v, w = e.resizeObserverPolyfill, M = e.scroll, $ = M === void 0 ? !0 : M, P = e.showDatumGlyph, E = P === void 0 ? !1 : P, T = e.showHorizontalCrosshair, B = T === void 0 ? !1 : T, j = e.showSeriesGlyphs, V = j === void 0 ? !1 : j, W = e.showVerticalCrosshair, S = W === void 0 ? !1 : W, _ = e.snapTooltipToDatumX, U = _ === void 0 ? !1 : _, z = e.snapTooltipToDatumY, N = z === void 0 ? !1 : z, O = e.verticalCrosshairStyle, k = e.zIndex, Q = Th(e, VB), q = Xe(Pt) || {}, re = q.colorScale, ae = q.theme, oe = q.innerHeight, ee = q.innerWidth, ie = q.margin, X = q.xScale, J = q.yScale, pe = q.dataRegistry, D = q.resizeObserverPolyfill, ce = Xe(si), he = ii({
    debounce: h,
    detectBounds: g,
    polyfill: D || w,
    scroll: $,
    zIndex: k
  }), ye = he.containerRef, Me = he.TooltipInPortal, Oe = he.forceRefreshBounds, it = me(function(Tt) {
    var Xt;
    ye((Xt = Tt == null ? void 0 : Tt.parentElement) != null ? Xt : null);
  }, [ye]), Qe = ce != null && ce.tooltipOpen ? b(Fn({}, ce, {
    colorScale: re
  })) : null, yt = (ce == null ? void 0 : ce.tooltipOpen) && Qe != null, At = de(!1);
  Ce(function() {
    yt && !At.current && Oe(), At.current = yt;
  }, [yt, Oe]);
  var It = ce == null ? void 0 : ce.tooltipLeft, Be = ce == null ? void 0 : ce.tooltipTop, bn = X ? Os(X) : 0, Wt = J ? Os(J) : 0, an = me(function(Tt, Xt) {
    var On, Nn, Ut = pe == null ? void 0 : pe.get(Tt), Sr = Ut == null ? void 0 : Ut.xAccessor, Er = Ut == null ? void 0 : Ut.yAccessor, Jr = X && Sr ? (On = Number(X(Sr(Xt))) + bn / 2) != null ? On : 0 : void 0, eo = J && Er ? (Nn = Number(J(Er(Xt))) + Wt / 2) != null ? Nn : 0 : void 0;
    return {
      left: Jr,
      top: eo
    };
  }, [pe, bn, Wt, X, J]), dt = ce == null || (t = ce.tooltipData) == null ? void 0 : t.nearestDatum, bt = (n = dt == null ? void 0 : dt.key) != null ? n : "";
  if (yt && dt && (U || N)) {
    var ft = an(bt, dt.datum), jt = ft.left, Vt = ft.top;
    It = U && at(jt) ? jt : It, Be = N && at(Vt) ? Vt : Be;
  }
  var st = [];
  if (yt && (E || V)) {
    var qn, Pe = Number((qn = y == null ? void 0 : y.radius) != null ? qn : 4);
    if (V) {
      var ze, qe;
      Object.values((ze = ce == null || (qe = ce.tooltipData) == null ? void 0 : qe.datumByKey) != null ? ze : {}).forEach(function(Tt) {
        var Xt, On, Nn, Ut = Tt.key, Sr = Tt.datum, Er = Tt.index, Jr = (Xt = (On = re == null ? void 0 : re(Ut)) != null ? On : ae == null || (Nn = ae.htmlLabel) == null ? void 0 : Nn.color) != null ? Xt : "#222", eo = an(Ut, Sr), hi = eo.left, mi = eo.top;
        !at(hi) || !at(mi) || st.push({
          key: Ut,
          color: Jr,
          datum: Sr,
          index: Er,
          size: Pe,
          x: hi,
          y: mi,
          glyphStyle: y,
          isNearestDatum: dt ? dt.key === Ut : !1
        });
      });
    } else if (dt) {
      var pt = an(bt, dt.datum), ot = pt.left, Ct = pt.top;
      if (at(ot) && at(Ct)) {
        var xn, Kn, qo, di, fi, Ht, pi = (xn = (Kn = (qo = (di = bt && (re == null ? void 0 : re(bt))) != null ? di : null) != null ? qo : ae == null || (fi = ae.gridStyles) == null ? void 0 : fi.stroke) != null ? Kn : ae == null || (Ht = ae.htmlLabel) == null ? void 0 : Ht.color) != null ? xn : "#222";
        st.push({
          key: bt,
          color: pi,
          datum: dt.datum,
          index: dt.index,
          size: Pe,
          x: ot,
          y: Ct,
          glyphStyle: y,
          isNearestDatum: !0
        });
      }
    }
  }
  return (
    // Tooltip can be rendered as a child of SVG or HTML since its output is rendered in a Portal.
    // So use svg element to find container ref because it's a valid child of SVG and HTML parents.
    /* @__PURE__ */ R.createElement(R.Fragment, null, /* @__PURE__ */ R.createElement("svg", {
      ref: it,
      style: UB
    }), yt && /* @__PURE__ */ R.createElement(R.Fragment, null, S && /* @__PURE__ */ R.createElement(Me, {
      className: "visx-crosshair visx-crosshair-vertical",
      left: It,
      top: ie == null ? void 0 : ie.top,
      offsetLeft: 0,
      offsetTop: 0,
      detectBounds: !1,
      style: $c
    }, /* @__PURE__ */ R.createElement("svg", {
      width: "1",
      height: oe,
      overflow: "visible"
    }, /* @__PURE__ */ R.createElement("line", Fn({
      x1: 0,
      x2: 0,
      y1: 0,
      y2: oe,
      strokeWidth: 1.5,
      stroke: (r = (o = ae == null || (a = ae.gridStyles) == null ? void 0 : a.stroke) != null ? o : ae == null || (i = ae.htmlLabel) == null ? void 0 : i.color) != null ? r : "#222"
    }, O)))), B && /* @__PURE__ */ R.createElement(Me, {
      className: "visx-crosshair visx-crosshair-horizontal",
      left: ie == null ? void 0 : ie.left,
      top: Be,
      offsetLeft: 0,
      offsetTop: 0,
      detectBounds: !1,
      style: $c
    }, /* @__PURE__ */ R.createElement("svg", {
      width: ee,
      height: "1",
      overflow: "visible"
    }, /* @__PURE__ */ R.createElement("line", Fn({
      x1: 0,
      x2: ee,
      y1: 0,
      y2: 0,
      strokeWidth: 1.5,
      stroke: (s = (l = ae == null || (c = ae.gridStyles) == null ? void 0 : c.stroke) != null ? l : ae == null || (d = ae.htmlLabel) == null ? void 0 : d.color) != null ? s : "#222"
    }, x)))), st.map(function(Tt, Xt) {
      var On = Tt.x, Nn = Tt.y, Ut = Th(Tt, HB);
      return (
        // We render glyps in a portal so that they can overflow the container if necessary
        /* @__PURE__ */ R.createElement(Me, {
          key: Xt,
          className: "visx-tooltip-glyph",
          left: On,
          top: Nn,
          offsetLeft: 0,
          offsetTop: 0,
          detectBounds: !1,
          style: $c
        }, /* @__PURE__ */ R.createElement("svg", {
          overflow: "visible"
        }, A(Fn({
          x: 0,
          y: 0
        }, Ut))))
      );
    }), /* @__PURE__ */ R.createElement(Me, Fn({
      left: It,
      top: Be,
      style: Fn({}, Zf, {
        background: (f = ae == null ? void 0 : ae.backgroundColor) != null ? f : "white",
        boxShadow: "0 1px 2px " + (ae != null && (p = ae.htmlLabel) != null && p.color ? (ae == null || (m = ae.htmlLabel) == null ? void 0 : m.color) + "55" : "#22222255")
      }, ae == null ? void 0 : ae.htmlLabel)
    }, Q), Qe)))
  );
}
q4.propTypes = {
  renderTooltip: se.func.isRequired,
  renderGlyph: se.func,
  snapTooltipToDatumX: se.bool,
  snapTooltipToDatumY: se.bool,
  showVerticalCrosshair: se.bool,
  showHorizontalCrosshair: se.bool,
  showDatumGlyph: se.bool,
  showSeriesGlyphs: se.bool
};
function _l(e) {
  var t = Xe(si);
  return t != null && t.tooltipOpen ? /* @__PURE__ */ R.createElement(q4, e) : null;
}
_l.propTypes = {
  renderTooltip: se.func.isRequired,
  renderGlyph: se.func,
  snapTooltipToDatumX: se.bool,
  snapTooltipToDatumY: se.bool,
  showVerticalCrosshair: se.bool,
  showHorizontalCrosshair: se.bool,
  showDatumGlyph: se.bool,
  showSeriesGlyphs: se.bool
};
var GB = Z4, er = Q4(hl), XB = Q4(H3), lo = KB(R), qB = ["className", "children", "debounceTime", "ignoreDimensions", "parentSizeStyles", "enableDebounceLeadingCall", "resizeObserverPolyfill"];
function K4(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (K4 = function(o) {
    return o ? n : t;
  })(e);
}
function KB(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = K4(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in e)
    if (a !== "default" && Object.prototype.hasOwnProperty.call(e, a)) {
      var i = o ? Object.getOwnPropertyDescriptor(e, a) : null;
      i && (i.get || i.set) ? Object.defineProperty(r, a, i) : r[a] = e[a];
    }
  return r.default = e, n && n.set(e, r), r;
}
function Q4(e) {
  return e && e.__esModule ? e : { default: e };
}
function Is() {
  return Is = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Is.apply(this, arguments);
}
function QB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var ZB = [], JB = {
  width: "100%",
  height: "100%"
};
function Z4(e) {
  var t = e.className, n = e.children, r = e.debounceTime, o = r === void 0 ? 300 : r, a = e.ignoreDimensions, i = a === void 0 ? ZB : a, s = e.parentSizeStyles, l = s === void 0 ? JB : s, c = e.enableDebounceLeadingCall, d = c === void 0 ? !0 : c, f = e.resizeObserverPolyfill, p = QB(e, qB), m = (0, lo.useRef)(null), h = (0, lo.useRef)(0), g = (0, lo.useState)({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), x = g[0], y = g[1], b = (0, lo.useMemo)(function() {
    var v = Array.isArray(i) ? i : [i];
    return (0, XB.default)(function(A) {
      y(function(w) {
        var M = Object.keys(w), $ = M.filter(function(E) {
          return w[E] !== A[E];
        }), P = $.every(function(E) {
          return v.includes(E);
        });
        return P ? w : A;
      });
    }, o, {
      leading: d
    });
  }, [o, d, i]);
  return (0, lo.useEffect)(function() {
    var v = f || window.ResizeObserver, A = new v(function(w) {
      w.forEach(function(M) {
        var $, P = ($ = M == null ? void 0 : M.contentRect) != null ? $ : {}, E = P.left, T = P.top, B = P.width, j = P.height;
        h.current = window.requestAnimationFrame(function() {
          b({
            width: B,
            height: j,
            top: T,
            left: E
          });
        });
      });
    });
    return m.current && A.observe(m.current), function() {
      window.cancelAnimationFrame(h.current), A.disconnect(), b.cancel();
    };
  }, [b, f]), /* @__PURE__ */ lo.default.createElement("div", Is({
    style: l,
    ref: m,
    className: t
  }, p), n(Is({}, x, {
    ref: m.current,
    resize: b
  })));
}
Z4.propTypes = {
  className: er.default.string,
  debounceTime: er.default.number,
  enableDebounceLeadingCall: er.default.bool,
  ignoreDimensions: er.default.oneOfType([er.default.any, er.default.arrayOf(er.default.any)]),
  children: er.default.func.isRequired
};
var ez = /* @__PURE__ */ tn(null);
const J4 = ez;
function or(e, t, n) {
  var r = Xe(J4), o = de();
  o.current = n;
  var a = me(function(i, s, l) {
    r && r.emit(i, {
      event: s,
      svgPoint: GF(s),
      source: l
    });
  }, [r]);
  return Ce(function() {
    if (r && e && t) {
      var i = function(l) {
        var c;
        (!o.current || l != null && l.source && (c = o.current) != null && c.includes(l.source)) && t(l);
      };
      return r.on(e, i), function() {
        return r == null ? void 0 : r.off(e, i);
      };
    }
  }, [r, e, t]), r ? a : null;
}
function tz(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var r = e.get(t);
    r && r.push(n) || e.set(t, [n]);
  }, off: function(t, n) {
    var r = e.get(t);
    r && r.splice(r.indexOf(n) >>> 0, 1);
  }, emit: function(t, n) {
    (e.get(t) || []).slice().map(function(r) {
      r(n);
    }), (e.get("*") || []).slice().map(function(r) {
      r(t, n);
    });
  } };
}
function nz(e) {
  var t = e.children, n = Se(function() {
    return tz();
  }, []);
  return /* @__PURE__ */ R.createElement(J4.Provider, {
    value: n
  }, t);
}
function Hu() {
  return Hu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hu.apply(this, arguments);
}
function e8(e) {
  var t = e.hideTooltipDebounceMs, n = t === void 0 ? 400 : t, r = e.children, o = ai(void 0), a = o.tooltipOpen, i = o.tooltipLeft, s = o.tooltipTop, l = o.tooltipData, c = o.updateTooltip, d = o.hideTooltip, f = de(null);
  function p() {
    f.current && (f.current.cancel(), f.current = null);
  }
  Ce(function() {
    return p;
  }, []);
  var m = de(function(x) {
    var y = x.svgPoint, b = x.index, v = x.key, A = x.datum, w = x.distanceX, M = x.distanceY;
    p();
    var $ = at(w) ? w : 1 / 0, P = at(M) ? M : 1 / 0, E = Math.sqrt(Math.pow($, 2) + Math.pow(P, 2));
    c(function(T) {
      var B, j, V, W = T.tooltipData, S = W != null && W.nearestDatum && at(W.nearestDatum.distance) ? W.nearestDatum.distance : 1 / 0;
      return {
        tooltipOpen: !0,
        tooltipLeft: y == null ? void 0 : y.x,
        tooltipTop: y == null ? void 0 : y.y,
        tooltipData: {
          nearestDatum: ((B = W == null || (j = W.nearestDatum) == null ? void 0 : j.key) != null ? B : "") !== v && S < E ? W == null ? void 0 : W.nearestDatum : {
            key: v,
            index: b,
            datum: A,
            distance: E
          },
          datumByKey: Hu({}, W == null ? void 0 : W.datumByKey, (V = {}, V[v] = {
            datum: A,
            index: b,
            key: v
          }, V))
        }
      };
    });
  }), h = me(function() {
    f.current = U3(d, n), f.current();
  }, [d, n]), g = Se(function() {
    return {
      tooltipOpen: a,
      tooltipLeft: i,
      tooltipTop: s,
      tooltipData: l,
      updateTooltip: c,
      showTooltip: m.current,
      hideTooltip: h
    };
  }, [h, l, i, a, s, c]);
  return /* @__PURE__ */ R.createElement(si.Provider, {
    value: g
  }, r);
}
e8.propTypes = {
  hideTooltipDebounceMs: se.number,
  children: se.node.isRequired
};
const rz = /* @__PURE__ */ Vr(DI);
var li = {}, e0 = {};
e0.__esModule = !0;
e0.default = oz;
function oz(e, t) {
  t.domain && ("nice" in e || "quantiles" in e || "padding" in e, e.domain(t.domain));
}
var t0 = {};
t0.__esModule = !0;
t0.default = az;
function az(e, t) {
  t.range && ("padding" in e, e.range(t.range));
}
var n0 = {};
n0.__esModule = !0;
n0.default = iz;
function iz(e, t) {
  "align" in e && "align" in t && typeof t.align < "u" && e.align(t.align);
}
var r0 = {};
r0.__esModule = !0;
r0.default = sz;
function sz(e, t) {
  "base" in e && "base" in t && typeof t.base < "u" && e.base(t.base);
}
var o0 = {};
o0.__esModule = !0;
o0.default = lz;
function lz(e, t) {
  "clamp" in e && "clamp" in t && typeof t.clamp < "u" && e.clamp(t.clamp);
}
var a0 = {};
a0.__esModule = !0;
a0.default = cz;
function cz(e, t) {
  "constant" in e && "constant" in t && typeof t.constant < "u" && e.constant(t.constant);
}
var i0 = {};
i0.__esModule = !0;
i0.default = uz;
function uz(e, t) {
  "exponent" in e && "exponent" in t && typeof t.exponent < "u" && e.exponent(t.exponent);
}
var s0 = {}, l0 = {};
const t8 = /* @__PURE__ */ Vr(WI);
l0.__esModule = !0;
l0.default = dz;
var tr = t8, Oh = {
  lab: tr.interpolateLab,
  hcl: tr.interpolateHcl,
  "hcl-long": tr.interpolateHclLong,
  hsl: tr.interpolateHsl,
  "hsl-long": tr.interpolateHslLong,
  cubehelix: tr.interpolateCubehelix,
  "cubehelix-long": tr.interpolateCubehelixLong,
  rgb: tr.interpolateRgb
};
function dz(e) {
  switch (e) {
    case "lab":
    case "hcl":
    case "hcl-long":
    case "hsl":
    case "hsl-long":
    case "cubehelix":
    case "cubehelix-long":
    case "rgb":
      return Oh[e];
  }
  var t = e.type, n = e.gamma, r = Oh[t];
  return typeof n > "u" ? r : r.gamma(n);
}
s0.__esModule = !0;
s0.default = hz;
var fz = pz(l0);
function pz(e) {
  return e && e.__esModule ? e : { default: e };
}
function hz(e, t) {
  if ("interpolate" in t && "interpolate" in e && typeof t.interpolate < "u") {
    var n = (0, fz.default)(t.interpolate);
    e.interpolate(n);
  }
}
var c0 = {};
const mz = /* @__PURE__ */ Vr(HI);
var u0 = {};
u0.__esModule = !0;
u0.default = yz;
var gz = new Date(Date.UTC(2020, 1, 2, 3, 4, 5)), vz = "%Y-%m-%d %H:%M";
function yz(e) {
  var t = e.tickFormat(1, vz)(gz);
  return t === "2020-02-02 03:04";
}
c0.__esModule = !0;
c0.default = wz;
var Lt = mz, bz = xz(u0);
function xz(e) {
  return e && e.__esModule ? e : { default: e };
}
var Nh = {
  day: Lt.timeDay,
  hour: Lt.timeHour,
  minute: Lt.timeMinute,
  month: Lt.timeMonth,
  second: Lt.timeSecond,
  week: Lt.timeWeek,
  year: Lt.timeYear
}, kh = {
  day: Lt.utcDay,
  hour: Lt.utcHour,
  minute: Lt.utcMinute,
  month: Lt.utcMonth,
  second: Lt.utcSecond,
  week: Lt.utcWeek,
  year: Lt.utcYear
};
function wz(e, t) {
  if ("nice" in t && typeof t.nice < "u" && "nice" in e) {
    var n = t.nice;
    if (typeof n == "boolean")
      n && e.nice();
    else if (typeof n == "number")
      e.nice(n);
    else {
      var r = e, o = (0, bz.default)(r);
      if (typeof n == "string")
        r.nice(o ? kh[n] : Nh[n]);
      else {
        var a = n.interval, i = n.step, s = (o ? kh[a] : Nh[a]).every(i);
        s != null && r.nice(s);
      }
    }
  }
}
var d0 = {};
d0.__esModule = !0;
d0.default = Az;
function Az(e, t) {
  "padding" in e && "padding" in t && typeof t.padding < "u" && e.padding(t.padding), "paddingInner" in e && "paddingInner" in t && typeof t.paddingInner < "u" && e.paddingInner(t.paddingInner), "paddingOuter" in e && "paddingOuter" in t && typeof t.paddingOuter < "u" && e.paddingOuter(t.paddingOuter);
}
var f0 = {};
f0.__esModule = !0;
f0.default = Cz;
function Cz(e, t) {
  if (t.reverse) {
    var n = e.range().slice().reverse();
    "padding" in e, e.range(n);
  }
}
var p0 = {};
p0.__esModule = !0;
p0.default = Ez;
var Sz = t8;
function Ez(e, t) {
  "round" in t && typeof t.round < "u" && (t.round && "interpolate" in t && typeof t.interpolate < "u" ? console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", t) : "round" in e ? e.round(t.round) : "interpolate" in e && t.round && e.interpolate(Sz.interpolateRound));
}
var h0 = {};
h0.__esModule = !0;
h0.default = Mz;
function Mz(e, t) {
  "unknown" in e && "unknown" in t && typeof t.unknown < "u" && e.unknown(t.unknown);
}
var m0 = {};
m0.__esModule = !0;
m0.default = $z;
function $z(e, t) {
  if ("zero" in t && t.zero === !0) {
    var n = e.domain(), r = n[0], o = n[1], a = o < r, i = a ? [o, r] : [r, o], s = i[0], l = i[1], c = [Math.min(0, s), Math.max(0, l)];
    e.domain(a ? c.reverse() : c);
  }
}
li.__esModule = !0;
li.ALL_OPERATORS = void 0;
li.default = Vz;
var Pz = zt(e0), Tz = zt(t0), Oz = zt(n0), Nz = zt(r0), kz = zt(o0), Dz = zt(a0), Fz = zt(i0), Rz = zt(s0), _z = zt(c0), Iz = zt(d0), Lz = zt(f0), Bz = zt(p0), zz = zt(h0), Wz = zt(m0);
function zt(e) {
  return e && e.__esModule ? e : { default: e };
}
var n8 = [
  // domain => nice => zero
  "domain",
  "nice",
  "zero",
  // interpolate before round
  "interpolate",
  "round",
  // set range then reverse
  "range",
  "reverse",
  // Order does not matter for these operators
  "align",
  "base",
  "clamp",
  "constant",
  "exponent",
  "padding",
  "unknown"
];
li.ALL_OPERATORS = n8;
var jz = {
  domain: Pz.default,
  nice: _z.default,
  zero: Wz.default,
  interpolate: Rz.default,
  round: Bz.default,
  align: Oz.default,
  base: Nz.default,
  clamp: kz.default,
  constant: Dz.default,
  exponent: Fz.default,
  padding: Iz.default,
  range: Tz.default,
  reverse: Lz.default,
  unknown: zz.default
};
function Vz() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = new Set(t), o = n8.filter(function(a) {
    return r.has(a);
  });
  return function(i, s) {
    return typeof s < "u" && o.forEach(function(l) {
      jz[l](i, s);
    }), i;
  };
}
var Hz = qz, Uz = rz, Yz = Gz(li);
function Gz(e) {
  return e && e.__esModule ? e : { default: e };
}
var Xz = (0, Yz.default)("domain", "range", "reverse", "unknown");
function qz(e) {
  return Xz((0, Uz.scaleOrdinal)(), e);
}
var rr = {
  red: ["#fff5f5", "#ffe3e3", "#ffc9c9", "#ffa8a8", "#ff8787", "#ff6b6b", "#fa5252", "#f03e3e", "#e03131", "#c92a2a"],
  pink: ["#fff0f6", "#ffdeeb", "#fcc2d7", "#faa2c1", "#f783ac", "#f06595", "#e64980", "#d6336c", "#c2255c", "#a61e4d"],
  grape: ["#f8f0fc", "#f3d9fa", "#eebefa", "#e599f7", "#da77f2", "#cc5de8", "#be4bdb", "#ae3ec9", "#9c36b5", "#862e9c"],
  violet: ["#f3f0ff", "#e5dbff", "#d0bfff", "#b197fc", "#9775fa", "#845ef7", "#7950f2", "#7048e8", "#6741d9", "#5f3dc4"],
  indigo: ["#edf2ff", "#dbe4ff", "#bac8ff", "#91a7ff", "#748ffc", "#5c7cfa", "#4c6ef5", "#4263eb", "#3b5bdb", "#364fc7"],
  blue: ["#e8f7ff", "#ccedff", "#a3daff", "#72c3fc", "#4dadf7", "#329af0", "#228ae6", "#1c7cd6", "#1b6ec2", "#1862ab"],
  cyan: ["#e3fafc", "#c5f6fa", "#99e9f2", "#66d9e8", "#3bc9db", "#22b8cf", "#15aabf", "#1098ad", "#0c8599", "#0b7285"],
  teal: ["#e6fcf5", "#c3fae8", "#96f2d7", "#63e6be", "#38d9a9", "#20c997", "#12b886", "#0ca678", "#099268", "#087f5b"],
  green: ["#ebfbee", "#d3f9d8", "#b2f2bb", "#8ce99a", "#69db7c", "#51cf66", "#40c057", "#37b24d", "#2f9e44", "#2b8a3e"],
  lime: ["#f4fce3", "#e9fac8", "#d8f5a2", "#c0eb75", "#a9e34b", "#94d82d", "#82c91e", "#74b816", "#66a80f", "#5c940d"],
  yellow: ["#fff9db", "#fff3bf", "#ffec99", "#ffe066", "#ffd43b", "#fcc419", "#fab005", "#f59f00", "#f08c00", "#e67700"],
  orange: ["#fff4e6", "#ffe8cc", "#ffd8a8", "#ffc078", "#ffa94d", "#ff922b", "#fd7e14", "#f76707", "#e8590c", "#d9480f"],
  gray: ["#f8f9fa", "#f1f3f5", "#e9ecef", "#dee2e6", "#ced4da", "#adb5bd", "#868e96", "#495057", "#343a40", "#212529"]
}, ha = rr.gray, Pc = ha[7], Kz = [rr.cyan[9], rr.cyan[3], rr.yellow[5], rr.red[4], rr.grape[8], rr.grape[5], rr.pink[9]];
function et() {
  return et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, et.apply(this, arguments);
}
var Tc = {
  fontFamily: "-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif",
  fontWeight: 700,
  fontSize: 12,
  textAnchor: "middle",
  pointerEvents: "none",
  letterSpacing: 0.4
};
function Qz(e) {
  var t, n, r, o, a, i, s = et({}, Tc, {
    fill: Pc,
    stroke: "none"
  }, e.svgLabelBig), l = et({}, Tc, {
    fontWeight: 200,
    fontSize: 11,
    fill: Pc,
    stroke: "none"
  }, e.svgLabelSmall), c = et({
    color: (t = (n = (r = (o = e.htmlLabel) == null ? void 0 : o.color) != null ? r : (a = e.svgLabelBig) == null ? void 0 : a.fill) != null ? n : (i = e.svgLabelSmall) == null ? void 0 : i.fill) != null ? t : Pc
  }, Tc, e.htmlLabel);
  return {
    backgroundColor: e.backgroundColor,
    colors: [].concat(e.colors),
    htmlLabel: et({}, c),
    svgLabelSmall: et({}, l),
    svgLabelBig: et({}, s),
    gridStyles: et({
      stroke: e.gridColor,
      strokeWidth: 1
    }, e.gridStyles),
    axisStyles: {
      x: {
        top: {
          axisLabel: et({}, s, {
            dy: "-0.25em"
            // needs to include font-size
          }),
          axisLine: et({
            stroke: e.gridColorDark,
            strokeWidth: 2
          }, e.xAxisLineStyles),
          tickLabel: et({}, l, {
            dy: "-0.25em"
            // needs to include font-size
          }),
          tickLength: e.tickLength,
          tickLine: et({
            strokeWidth: 1,
            stroke: e.gridColor
          }, e.xTickLineStyles)
        },
        bottom: {
          axisLabel: et({}, s, {
            dy: "-0.25em"
          }),
          axisLine: et({
            stroke: e.gridColorDark,
            strokeWidth: 2
          }, e.xAxisLineStyles),
          tickLabel: et({}, l, {
            dy: "0.125em"
          }),
          tickLength: e.tickLength,
          tickLine: et({
            strokeWidth: 1,
            stroke: e.gridColor
          }, e.xTickLineStyles)
        }
      },
      y: {
        left: {
          axisLabel: et({}, s, {
            dx: "-1.25em"
          }),
          axisLine: et({
            stroke: e.gridColor,
            strokeWidth: 1
          }, e.yAxisLineStyles),
          tickLabel: et({}, l, {
            textAnchor: "end",
            dx: "-0.25em",
            dy: "0.25em"
          }),
          tickLength: e.tickLength,
          tickLine: et({
            strokeWidth: 1,
            stroke: e.gridColor
          }, e.yTickLineStyles)
        },
        right: {
          axisLabel: et({}, s, {
            dx: "1.25em"
          }),
          axisLine: et({
            stroke: e.gridColor,
            strokeWidth: 1
          }, e.yAxisLineStyles),
          tickLabel: et({}, l, {
            textAnchor: "start",
            dx: "0.25em",
            dy: "0.25em"
          }),
          tickLength: e.tickLength,
          tickLine: et({
            strokeWidth: 1,
            stroke: e.gridColor
          }, e.yTickLineStyles)
        }
      }
    }
  };
}
const Zz = Qz({
  backgroundColor: "#fff",
  colors: Kz,
  tickLength: 4,
  svgLabelSmall: {
    fill: ha[7]
  },
  svgLabelBig: {
    fill: ha[9]
  },
  gridColor: ha[5],
  gridColorDark: ha[9]
});
var Jz = /* @__PURE__ */ R.createContext(Zz);
const eW = Jz;
var tW = /* @__PURE__ */ function() {
  function e() {
    this.registry = {}, this.registryKeys = [];
  }
  var t = e.prototype;
  return t.registerData = function(r) {
    var o = this, a = Array.isArray(r) ? r : [r];
    a.forEach(function(i) {
      i.key in o.registry && o.registry[i.key] != null && console.debug("Overriding data registry key", i.key), o.registry[i.key] = i, o.registryKeys = Object.keys(o.registry);
    });
  }, t.unregisterData = function(r) {
    var o = this, a = Array.isArray(r) ? r : [r];
    a.forEach(function(i) {
      delete o.registry[i], o.registryKeys = Object.keys(o.registry);
    });
  }, t.entries = function() {
    return Object.values(this.registry);
  }, t.get = function(r) {
    return this.registry[r];
  }, t.keys = function() {
    return this.registryKeys;
  }, e;
}();
function nW() {
  var e = we(Math.random()), t = e[1], n = Se(function() {
    return new tW();
  }, []);
  return Se(function() {
    return {
      registerData: function() {
        n.registerData.apply(n, arguments), t(Math.random());
      },
      unregisterData: function() {
        n.unregisterData.apply(n, arguments), t(Math.random());
      },
      entries: function() {
        return n.entries();
      },
      get: function(o) {
        return n.get(o);
      },
      keys: function() {
        return n.keys();
      }
    };
  }, [n]);
}
var Oc = {
  width: 0,
  height: 0,
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
};
function rW(e) {
  var t = we({
    width: (e == null ? void 0 : e.width) == null ? Oc.width : e.width,
    height: (e == null ? void 0 : e.height) == null ? Oc.height : e.height,
    margin: (e == null ? void 0 : e.margin) == null ? Oc.margin : e.margin
  }), n = t[0], r = t[1], o = me(function(a) {
    (a.width !== n.width || a.height !== n.height || a.margin.left !== n.margin.left || a.margin.right !== n.margin.right || a.margin.top !== n.margin.top || a.margin.bottom !== n.margin.bottom) && r(a);
  }, [n.width, n.height, n.margin.left, n.margin.right, n.margin.bottom, n.margin.top]);
  return [n, o];
}
function ts(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function oW(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function g0(e) {
  let t, n, r;
  e.length !== 2 ? (t = ts, n = (s, l) => ts(e(s), l), r = (s, l) => e(s) - l) : (t = e === ts || e === oW ? e : aW, n = e, r = e);
  function o(s, l, c = 0, d = s.length) {
    if (c < d) {
      if (t(l, l) !== 0)
        return d;
      do {
        const f = c + d >>> 1;
        n(s[f], l) < 0 ? c = f + 1 : d = f;
      } while (c < d);
    }
    return c;
  }
  function a(s, l, c = 0, d = s.length) {
    if (c < d) {
      if (t(l, l) !== 0)
        return d;
      do {
        const f = c + d >>> 1;
        n(s[f], l) <= 0 ? c = f + 1 : d = f;
      } while (c < d);
    }
    return c;
  }
  function i(s, l, c = 0, d = s.length) {
    const f = o(s, l, c, d - 1);
    return f > c && r(s[f - 1], l) > -r(s[f], l) ? f - 1 : f;
  }
  return { left: o, center: i, right: a };
}
function aW() {
  return 0;
}
function iW(e) {
  return e === null ? NaN : +e;
}
const sW = g0(ts), lW = sW.left;
g0(iW).center;
function Fa(e, t) {
  let n, r;
  if (t === void 0)
    for (const o of e)
      o != null && (n === void 0 ? o >= o && (n = r = o) : (n > o && (n = o), r < o && (r = o)));
  else {
    let o = -1;
    for (let a of e)
      (a = t(a, ++o, e)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  }
  return [n, r];
}
function cW(e, t, n) {
  e = +e, t = +t, n = (o = arguments.length) < 2 ? (t = e, e = 0, 1) : o < 3 ? 1 : +n;
  for (var r = -1, o = Math.max(0, Math.ceil((t - e) / n)) | 0, a = new Array(o); ++r < o; )
    a[r] = e + r * n;
  return a;
}
function Uu(e) {
  return (e == null ? void 0 : e.type) === "band" || (e == null ? void 0 : e.type) === "ordinal" || (e == null ? void 0 : e.type) === "point";
}
function uo() {
  return uo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, uo.apply(this, arguments);
}
function uW(e) {
  var t = e.dataRegistry, n = e.xRange, r = e.xScaleConfig, o = e.yRange, a = e.yScaleConfig, i = t.keys(), s = n[0], l = n[1], c = o[0], d = o[1], f = Se(function() {
    var m = i.map(function(y) {
      return t.get(y);
    }), h = m.reduce(function(y, b) {
      return b ? y.concat(b.data.map(function(v) {
        return b.xAccessor(v);
      })) : y;
    }, []);
    if (h.length !== 0) {
      var g = Uu(r) ? h : Fa(h), x = Su(r) ? pa(uo({
        range: [s, l],
        domain: g,
        zero: !0
      }, r)) : pa(uo({
        range: [s, l],
        domain: g
      }, r));
      return m.forEach(function(y) {
        y != null && y.xScale && (x = y.xScale(x));
      }), x;
    }
  }, [t, r, i, s, l]), p = Se(function() {
    var m = i.map(function(y) {
      return t.get(y);
    }), h = m.reduce(function(y, b) {
      return b ? y.concat(b.data.map(function(v) {
        return b.yAccessor(v);
      })) : y;
    }, []);
    if (h.length !== 0) {
      var g = Uu(a) ? h : Fa(h), x = Su(a) ? pa(uo({
        range: [c, d],
        domain: g,
        zero: !0
      }, a)) : pa(uo({
        range: [c, d],
        domain: g
      }, a));
      return m.forEach(function(y) {
        y != null && y.yScale && (x = y.yScale(x));
      }), x;
    }
  }, [t, a, i, c, d]);
  return {
    xScale: f,
    yScale: p
  };
}
function r8(e) {
  var t = e.initialDimensions, n = e.theme, r = e.xScale, o = e.yScale, a = e.children, i = e.horizontal, s = i === void 0 ? "auto" : i, l = e.resizeObserverPolyfill, c = Xe(eW), d = n || c, f = rW(t), p = f[0], m = p.width, h = p.height, g = p.margin, x = f[1], y = Math.max(0, m - g.left - g.right), b = Math.max(0, h - g.top - g.bottom), v = nW(), A = uW({
    dataRegistry: v,
    xScaleConfig: r,
    yScaleConfig: o,
    xRange: [g.left, Math.max(0, m - g.right)],
    yRange: [Math.max(0, h - g.bottom), g.top]
  }), w = A.xScale, M = A.yScale, $ = v.keys(), P = Se(function() {
    return Hz({
      domain: $,
      range: d.colors
    });
  }, [$, d.colors]), E = s === "auto" ? Uu(o) || o.type === "time" || o.type === "utc" : s, T = Se(
    function() {
      return {
        dataRegistry: v,
        registerData: v.registerData,
        unregisterData: v.unregisterData,
        xScale: w,
        yScale: M,
        colorScale: P,
        theme: d,
        width: m,
        height: h,
        margin: g,
        innerWidth: y,
        innerHeight: b,
        setDimensions: x,
        horizontal: E,
        resizeObserverPolyfill: l
      };
    },
    // everything here should be memoized between renders
    // to avoid child re-renders
    [P, v, h, E, b, y, g, x, d, m, w, M, l]
  );
  return /* @__PURE__ */ R.createElement(Pt.Provider, {
    value: T
  }, a);
}
r8.propTypes = {
  children: se.node.isRequired,
  horizontal: se.oneOfType([se.bool, se.oneOf(["auto"])])
};
function o8(e) {
  var t = e.source, n = e.onPointerOut, r = n === void 0 ? !0 : n, o = e.onPointerMove, a = o === void 0 ? !0 : o, i = e.onPointerUp, s = i === void 0 ? !0 : i, l = e.onPointerDown, c = l === void 0 ? !0 : l, d = e.onFocus, f = d === void 0 ? !1 : d, p = e.onBlur, m = p === void 0 ? !1 : p, h = or(), g = me(function(w) {
    return h == null ? void 0 : h("pointermove", w, t);
  }, [h, t]), x = me(function(w) {
    return h == null ? void 0 : h("pointerout", w, t);
  }, [h, t]), y = me(function(w) {
    return h == null ? void 0 : h("pointerup", w, t);
  }, [h, t]), b = me(function(w) {
    return h == null ? void 0 : h("pointerdown", w, t);
  }, [h, t]), v = me(function(w) {
    return h == null ? void 0 : h("focus", w, t);
  }, [h, t]), A = me(function(w) {
    return h == null ? void 0 : h("blur", w, t);
  }, [h, t]);
  return {
    onPointerMove: a ? g : void 0,
    onFocus: f ? v : void 0,
    onBlur: m ? A : void 0,
    onPointerOut: r ? x : void 0,
    onPointerUp: s ? y : void 0,
    onPointerDown: c ? b : void 0
  };
}
var dW = "BARSERIES_EVENT_SOURCE", fW = "BARSTACK_EVENT_SOURCE", pW = "GLYPHSERIES_EVENT_SOURCE", ci = "XYCHART_EVENT_SOURCE";
function a8(e) {
  return !!e && ("clientX" in e || "changedTouches" in e);
}
function hW(e) {
  return !!e && !a8(e);
}
function i8(e) {
  var t = e.scale, n = e.accessor, r = e.scaledValue, o = e.data, a = t, i, s;
  if ("invert" in a && typeof a.invert == "function") {
    var l = g0(n).left, c = Number(a.invert(r)), d = l(o, c), f = o[d - 1], p = o[d];
    i = !f || Math.abs(c - n(f)) > Math.abs(c - n(p)) ? p : f, s = i === f ? d - 1 : d;
  } else if ("step" in a && typeof a.step < "u") {
    var m = t.domain(), h = t.range().map(Number), g = [].concat(h).sort(function(M, $) {
      return M - $;
    }), x = cW(g[0], g[1], a.step()), y = lW(x, r), b = h[0] < h[1] ? m : m.reverse(), v = b[y - 1], A = o.findIndex(function(M) {
      return String(n(M)) === String(v);
    });
    i = o[A], s = A;
  } else
    return console.warn("[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing"), null;
  if (i == null || s == null)
    return null;
  var w = Math.abs(Number(a(n(i))) - r);
  return {
    datum: i,
    index: s,
    distance: w
  };
}
function s8(e) {
  var t = e.xScale, n = e.xAccessor, r = e.yScale, o = e.yAccessor, a = e.point, i = e.data;
  if (!a)
    return null;
  var s = i8({
    scale: t,
    accessor: n,
    scaledValue: a.x,
    data: i
  });
  return s ? {
    datum: s.datum,
    index: s.index,
    distanceX: s.distance,
    distanceY: Math.abs(Number(r(o(s.datum))) - a.y)
  } : null;
}
function l8(e) {
  var t = e.yScale, n = e.yAccessor, r = e.xScale, o = e.xAccessor, a = e.point, i = e.data;
  if (!a)
    return null;
  var s = i8({
    scale: t,
    accessor: n,
    scaledValue: a.y,
    data: i
  });
  return s ? {
    datum: s.datum,
    index: s.index,
    distanceY: s.distance,
    distanceX: Math.abs(Number(r(o(s.datum))) - a.x)
  } : null;
}
function Yu() {
  return Yu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yu.apply(this, arguments);
}
var Gu = "__POINTER_EVENTS_ALL", ns = "__POINTER_EVENTS_NEAREST";
function c8(e) {
  var t = e.dataKey, n = e.findNearestDatum, r = e.onBlur, o = e.onFocus, a = e.onPointerMove, i = e.onPointerOut, s = e.onPointerUp, l = e.onPointerDown, c = e.allowedSources, d = Xe(Pt), f = d.width, p = d.height, m = d.horizontal, h = d.dataRegistry, g = d.xScale, x = d.yScale, y = n || (m ? l8 : s8), b = me(function(E) {
    var T = E || {}, B = T.svgPoint, j = T.event, V = {}, W = null, S = 1 / 0;
    if (E && j && B && f && p && g && x) {
      var _, U = t === ns || t === Gu, z = U ? (_ = h == null ? void 0 : h.keys()) != null ? _ : [] : Array.isArray(t) ? t : [t];
      z.forEach(function(O) {
        var k = h == null ? void 0 : h.get(O);
        if (k) {
          var Q = y({
            dataKey: O,
            data: k.data,
            height: p,
            point: B,
            width: f,
            xAccessor: k.xAccessor,
            xScale: g,
            yAccessor: k.yAccessor,
            yScale: x
          });
          if (Q && (V[O] = Yu({
            key: O,
            svgPoint: B,
            event: j
          }, Q), t === ns)) {
            var q, re, ae = Math.sqrt(((q = Q.distanceX) != null ? q : Math.pow(1 / 0, 2)) + ((re = Q.distanceY) != null ? re : Math.pow(1 / 0, 2)));
            W = ae < S ? V[O] : W, S = Math.min(S, ae);
          }
        }
      });
      var N = t === ns ? [W] : t === Gu || Array.isArray(t) ? Object.values(V) : [V[t]];
      return N.filter(function(O) {
        return O;
      });
    }
    return [];
  }, [t, h, g, x, f, p, y]), v = me(function(E) {
    a && b(E).forEach(function(T) {
      return a(T);
    });
  }, [b, a]), A = me(function(E) {
    s && b(E).forEach(function(T) {
      return s(T);
    });
  }, [b, s]), w = me(function(E) {
    l && b(E).forEach(function(T) {
      return l(T);
    });
  }, [b, l]), M = me(function(E) {
    o && b(E).forEach(function(T) {
      return o(T);
    });
  }, [b, o]), $ = me(function(E) {
    var T = E == null ? void 0 : E.event;
    T && a8(T) && i && i(T);
  }, [i]), P = me(function(E) {
    var T = E == null ? void 0 : E.event;
    T && hW(T) && r && r(T);
  }, [r]);
  or("pointermove", a ? v : void 0, c), or("pointerout", i ? $ : void 0, c), or("pointerup", s ? A : void 0, c), or("pointerdown", l ? w : void 0, c), or("focus", o ? M : void 0, c), or("blur", r ? P : void 0, c);
}
function Ls() {
  return Ls = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ls.apply(this, arguments);
}
var mW = {
  top: 50,
  right: 50,
  bottom: 50,
  left: 50
}, gW = [ci];
function ar(e) {
  var t = e.accessibilityLabel, n = t === void 0 ? "XYChart" : t, r = e.captureEvents, o = r === void 0 ? !0 : r, a = e.children, i = e.height, s = e.horizontal, l = e.margin, c = l === void 0 ? mW : l, d = e.onPointerMove, f = e.onPointerOut, p = e.onPointerUp, m = e.onPointerDown, h = e.pointerEventsDataKey, g = h === void 0 ? "nearest" : h, x = e.theme, y = e.width, b = e.xScale, v = e.yScale, A = e.resizeObserverPolyfill, w = Xe(Pt), M = w.setDimensions, $ = w.resizeObserverPolyfill, P = Xe(si), E = or();
  Ce(function() {
    M && y != null && i != null && y > 0 && i > 0 && M({
      width: y,
      height: i,
      margin: c
    });
  }, [M, y, i, c]);
  var T = o8({
    source: ci
  });
  return c8({
    dataKey: g === "nearest" ? ns : Gu,
    onPointerMove: d,
    onPointerOut: f,
    onPointerUp: p,
    onPointerDown: m,
    allowedSources: gW
  }), M ? y == null || i == null ? /* @__PURE__ */ R.createElement(GB, {
    resizeObserverPolyfill: $
  }, function(B) {
    return /* @__PURE__ */ R.createElement(ar, Ls({}, e, {
      width: e.width == null ? B.width : e.width,
      height: e.height == null ? B.height : e.height
    }));
  }) : P == null ? /* @__PURE__ */ R.createElement(e8, null, /* @__PURE__ */ R.createElement(ar, e)) : E == null ? /* @__PURE__ */ R.createElement(nz, null, /* @__PURE__ */ R.createElement(ar, e)) : y <= 0 || i <= 0 ? (console.info("XYChart has a zero width or height, bailing", {
    width: y,
    height: i
  }), null) : /* @__PURE__ */ R.createElement("svg", {
    width: y,
    height: i,
    "aria-label": n
  }, a, o && /* @__PURE__ */ R.createElement("rect", Ls({
    x: c.left,
    y: c.top,
    width: y - c.left - c.right,
    height: i - c.top - c.bottom,
    fill: "transparent"
  }, T))) : !b || !v ? (console.warn("[@visx/xychart] XYChart: When no DataProvider is available in context, you must pass xScale & yScale config to XYChart."), null) : /* @__PURE__ */ R.createElement(r8, {
    xScale: b,
    yScale: v,
    theme: x,
    initialDimensions: {
      width: y,
      height: i,
      margin: c
    },
    horizontal: s,
    resizeObserverPolyfill: A
  }, /* @__PURE__ */ R.createElement(ar, e));
}
ar.propTypes = {
  accessibilityLabel: se.string,
  captureEvents: se.bool,
  width: se.number,
  height: se.number,
  children: se.node.isRequired,
  horizontal: se.oneOfType([se.bool, se.oneOf(["auto"])]),
  onPointerMove: se.func,
  onPointerOut: se.func,
  onPointerUp: se.func,
  onPointerDown: se.func,
  pointerEventsDataKey: se.oneOf(["all", "nearest"])
};
const u8 = /* @__PURE__ */ Vr(LO);
var vW = yW, la = u8, Dh = {
  ascending: la.stackOrderAscending,
  descending: la.stackOrderDescending,
  insideout: la.stackOrderInsideOut,
  none: la.stackOrderNone,
  reverse: la.stackOrderReverse
};
function yW(e) {
  return e && Dh[e] || Dh.none;
}
var bW = xW, ca = u8, Fh = {
  expand: ca.stackOffsetExpand,
  diverging: ca.stackOffsetDiverging,
  none: ca.stackOffsetNone,
  silhouette: ca.stackOffsetSilhouette,
  wiggle: ca.stackOffsetWiggle
};
function xW(e) {
  return e && Fh[e] || Fh.none;
}
function Xu() {
  return Xu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xu.apply(this, arguments);
}
function d8(e) {
  function t(n) {
    var r = n.dataKey, o = n.data, a = n.xAccessor, i = n.yAccessor, s = Xe(Pt), l = s.xScale, c = s.yScale, d = s.dataRegistry;
    Ce(function() {
      return d && d.registerData({
        key: r,
        data: o,
        xAccessor: a,
        yAccessor: i
      }), function() {
        return d == null ? void 0 : d.unregisterData(r);
      };
    }, [d, r, o, a, i]);
    var f = d == null ? void 0 : d.get(r);
    if (!l || !c || !f)
      return null;
    var p = e;
    return /* @__PURE__ */ R.createElement(p, Xu({}, n, {
      xScale: l,
      yScale: c,
      data: f.data,
      xAccessor: f.xAccessor,
      yAccessor: f.yAccessor
    }));
  }
  return t;
}
function Bs(e, t, n) {
  return n === void 0 && (n = "center"), function(r) {
    var o = e(t(r));
    if (at(o)) {
      var a = (n === "start" ? 0 : Os(e)) / (n === "center" ? 2 : 1);
      return o + a;
    }
    return NaN;
  };
}
function Rh(e) {
  var t = e.range().map(function(c) {
    var d;
    return (d = Dl(c)) != null ? d : 0;
  }), n = t[0], r = t[1], o = n != null && r != null && r < n, a = e(0), i = o ? [r, n] : [n, r], s = i[0], l = i[1];
  return o ? at(a) ? Math.min(Math.max(s, a), l) : l : at(a) ? Math.max(a, s) : s;
}
function v0(e) {
  var t, n = e.dataKey, r = e.enableEvents, o = e.findNearestDatum, a = e.onBlur, i = e.onFocus, s = e.onPointerMove, l = e.onPointerOut, c = e.onPointerUp, d = e.onPointerDown, f = e.source, p = e.allowedSources, m = (t = Xe(si)) != null ? t : {}, h = m.showTooltip, g = m.hideTooltip, x = me(function(w) {
    h(w), s && s(w);
  }, [h, s]), y = me(function(w) {
    h(w), i && i(w);
  }, [h, i]), b = me(function(w) {
    g(), w && l && l(w);
  }, [g, l]), v = me(function(w) {
    g(), w && a && a(w);
  }, [g, a]), A = me(function(w) {
    h(w), d && d(w);
  }, [h, d]);
  return c8({
    dataKey: n,
    findNearestDatum: o,
    onBlur: r ? v : void 0,
    onFocus: r ? y : void 0,
    onPointerMove: r ? x : void 0,
    onPointerOut: r ? b : void 0,
    onPointerUp: r ? c : void 0,
    onPointerDown: r ? A : void 0,
    allowedSources: p
  }), o8({
    source: f,
    onBlur: !!a && r,
    onFocus: !!i && r,
    onPointerMove: !!s && r,
    onPointerOut: !!l && r,
    onPointerUp: !!c && r,
    onPointerDown: !!d && r
  });
}
function qu() {
  return qu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qu.apply(this, arguments);
}
function f8(e) {
  var t, n, r, o = e.colorAccessor, a = e.data, i = e.dataKey, s = e.onBlur, l = e.onFocus, c = e.onPointerMove, d = e.onPointerOut, f = e.onPointerUp, p = e.onPointerDown, m = e.enableEvents, h = m === void 0 ? !0 : m, g = e.renderGlyphs, x = e.size, y = x === void 0 ? 8 : x, b = e.xAccessor, v = e.xScale, A = e.yAccessor, w = e.yScale, M = Xe(Pt), $ = M.colorScale, P = M.theme, E = M.horizontal, T = Se(function() {
    return Bs(v, b);
  }, [v, b]), B = Se(function() {
    return Bs(w, A);
  }, [w, A]), j = (t = (n = $ == null ? void 0 : $(i)) != null ? n : P == null || (r = P.colors) == null ? void 0 : r[0]) != null ? t : "#222", V = pW + "-" + i, W = v0({
    dataKey: i,
    enableEvents: h,
    onBlur: s,
    onFocus: l,
    onPointerMove: c,
    onPointerOut: d,
    onPointerUp: f,
    onPointerDown: p,
    source: V,
    allowedSources: [ci, V]
  }), S = Se(function() {
    return a.map(function(_, U) {
      var z, N = T(_);
      if (!at(N))
        return null;
      var O = B(_);
      return at(O) ? {
        key: "" + U,
        x: N,
        y: O,
        color: (z = o == null ? void 0 : o(_, U)) != null ? z : j,
        size: typeof y == "function" ? y(_) : y,
        datum: _
      } : null;
    }).filter(function(_) {
      return _;
    });
  }, [j, o, a, T, B, y]);
  return /* @__PURE__ */ R.createElement(R.Fragment, null, g(qu({
    glyphs: S,
    xScale: v,
    yScale: w,
    horizontal: E
  }, W)));
}
f8.propTypes = {
  colorAccessor: se.func,
  size: se.oneOfType([se.number, se.func]),
  renderGlyphs: se.func.isRequired
};
const wW = d8(f8);
function AW(e) {
  var t = e.key, n = e.color, r = e.x, o = e.y, a = e.size, i = e.onBlur, s = e.onFocus, l = e.onPointerMove, c = e.onPointerOut, d = e.onPointerUp;
  return /* @__PURE__ */ R.createElement("circle", {
    className: "visx-circle-glyph",
    key: t,
    tabIndex: i || s ? 0 : void 0,
    fill: n,
    r: a / 2,
    cx: r,
    cy: o,
    onBlur: i,
    onFocus: s,
    onPointerMove: l,
    onPointerOut: c,
    onPointerUp: d
  });
}
var go = CW, vo = SW;
function CW(e) {
  return e == null ? void 0 : e[0];
}
function SW(e) {
  return e == null ? void 0 : e[1];
}
function Bi(e) {
  return function() {
    return e;
  };
}
function EW(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function _h(e, t) {
  if ((i = e.length) > 1)
    for (var n = 1, r, o, a = e[t[0]], i, s = a.length; n < i; ++n)
      for (o = a, a = e[t[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(o[r][1]) ? o[r][0] : o[r][1];
}
function Ih(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; )
    n[t] = t;
  return n;
}
function MW(e, t) {
  return e[t];
}
function $W(e) {
  const t = [];
  return t.key = e, t;
}
function PW() {
  var e = Bi([]), t = Ih, n = _h, r = MW;
  function o(a) {
    var i = Array.from(e.apply(this, arguments), $W), s, l = i.length, c = -1, d;
    for (const f of a)
      for (s = 0, ++c; s < l; ++s)
        (i[s][c] = [0, +r(f, i[s].key, c, a)]).data = f;
    for (s = 0, d = EW(t(i)); s < l; ++s)
      i[d[s]].index = s;
    return n(i, d), i;
  }
  return o.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Bi(Array.from(a)), o) : e;
  }, o.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Bi(+a), o) : r;
  }, o.order = function(a) {
    return arguments.length ? (t = a == null ? Ih : typeof a == "function" ? a : Bi(Array.from(a)), o) : t;
  }, o.offset = function(a) {
    return arguments.length ? (n = a ?? _h, o) : n;
  }, o;
}
var Lh = function(t) {
  var n;
  return t == null || (n = t.data) == null ? void 0 : n.stack;
}, Bh = function(t) {
  return (go(t) + vo(t)) / 2;
};
function TW(e, t, n) {
  var r = n ? [Bh, Lh] : [Lh, Bh], o = r[0], a = r[1];
  return e.map(function(i, s) {
    var l = {
      key: i.key,
      data: i,
      xAccessor: o,
      yAccessor: a
    };
    return t.length > 0 && s === 0 && (n ? l.xScale = function(c) {
      return c.domain(Fa(c.domain().concat(t)));
    } : l.yScale = function(c) {
      return c.domain(Fa(c.domain().concat(t)));
    }), l;
  }).filter(function(i) {
    return i;
  });
}
var zi = function(t) {
  return t.stack;
};
function OW(e, t) {
  var n = {};
  return e.forEach(function(r) {
    var o = r.props, a = o.dataKey, i = o.data, s = o.xAccessor, l = o.yAccessor;
    if (!(!s || !l)) {
      var c = t ? [l, s] : [s, l], d = c[0], f = c[1];
      i.forEach(function(p) {
        var m = d(p), h = f(p), g = String(m);
        n[g] || (n[g] = {
          stack: m,
          positiveSum: 0,
          negativeSum: 0
        }), n[g][a] = h, n[g][h >= 0 ? "positiveSum" : "negativeSum"] += h;
      });
    }
  }), Object.values(n);
}
function NW(e) {
  return !!e && typeof e == "object" && "props" in e && e.props != null;
}
function kW(e) {
  return R.Children.toArray(e).flatMap(function(t) {
    return typeof t == "object" && "props" in t && t.props.children ? t.props.children : t;
  }).filter(function(t) {
    return NW(t);
  });
}
function DW(e) {
  var t = e.children, n = e.order, r = e.offset, o = Xe(Pt), a = o.horizontal, i = o.registerData, s = o.unregisterData, l = Se(function() {
    return kW(t);
  }, [t]), c = Se(function() {
    return l.filter(function(m) {
      return m.props.dataKey;
    }).map(function(m) {
      return m.props.dataKey;
    });
  }, [l]), d = Se(function() {
    return OW(l, a);
  }, [a, l]), f = Se(function() {
    var m = r ? null : d.some(function(g) {
      return g.negativeSum < 0;
    }), h = PW();
    return h.keys(c), n && h.order(vW(n)), (r || m) && h.offset(bW(r || "diverging")), h(d);
  }, [d, c, n, r]), p = Se(function() {
    return Fa(f.reduce(function(m, h) {
      return h.forEach(function(g) {
        var x = g[0], y = g[1];
        m.push(x), m.push(y);
      }), m;
    }, []));
  }, [f]);
  return Ce(function() {
    var m = TW(f, p, a);
    return i(m), function() {
      return s(c);
    };
  }, [c, p, a, f, i, s, l]), {
    seriesChildren: l,
    dataKeys: c,
    stackedData: f
  };
}
function FW(e, t, n) {
  var r, o, a, i, s = e.xScale, l = e.yScale, c = e.point, d = (n ? l8 : s8)(e), f = (d == null ? void 0 : d.index) == null ? null : t[d.index];
  return d && f && c ? {
    index: d.index,
    datum: f,
    distanceX: n && c.x >= ((r = s(go(d.datum))) != null ? r : 1 / 0) && c.x <= ((o = s(vo(d.datum))) != null ? o : -1 / 0) ? 0 : d.distanceX,
    distanceY: n ? d.distanceY : c.y <= ((a = l(go(d.datum))) != null ? a : -1 / 0) && c.y >= ((i = l(vo(d.datum))) != null ? i : 1 / 0) ? 0 : d.distanceY
  } : null;
}
var RW = ["bars", "horizontal", "xScale", "yScale", "radius", "radiusAll", "radiusTop", "radiusRight", "radiusBottom", "radiusLeft"], _W = ["key"];
function zs() {
  return zs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zs.apply(this, arguments);
}
function zh(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function p8(e) {
  var t = e.bars;
  e.horizontal, e.xScale, e.yScale;
  var n = e.radius, r = e.radiusAll, o = e.radiusTop, a = e.radiusRight, i = e.radiusBottom, s = e.radiusLeft, l = zh(e, RW), c = !!(l.onFocus || l.onBlur);
  return /* @__PURE__ */ R.createElement(R.Fragment, null, t.map(function(d) {
    var f = d.key, p = zh(d, _W);
    return n == null ? /* @__PURE__ */ R.createElement("rect", zs({
      key: f,
      className: "visx-bar",
      tabIndex: c ? 0 : void 0
    }, p, l)) : /* @__PURE__ */ R.createElement(L4, zs({
      key: f,
      className: "visx-bar",
      tabIndex: c ? 0 : void 0,
      radius: n,
      all: r,
      top: o,
      right: a,
      bottom: i,
      left: s
    }, p, l));
  }));
}
var IW = ["BarsComponent", "barPadding", "colorAccessor", "data", "dataKey", "onBlur", "onFocus", "onPointerMove", "onPointerOut", "onPointerUp", "onPointerDown", "enableEvents", "xAccessor", "xScale", "yAccessor", "yScale"];
function Ku() {
  return Ku = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ku.apply(this, arguments);
}
function LW(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var BW = function(t, n) {
  return (
    // clamp padding to [0, 1], bar thickness = (1-padding) * availableSpace
    t * (1 - Math.min(1, Math.max(0, n)))
  );
};
function h8(e) {
  var t, n, r, o = e.BarsComponent, a = e.barPadding, i = a === void 0 ? 0.1 : a, s = e.colorAccessor, l = e.data, c = e.dataKey, d = e.onBlur, f = e.onFocus, p = e.onPointerMove, m = e.onPointerOut, h = e.onPointerUp, g = e.onPointerDown, x = e.enableEvents, y = x === void 0 ? !0 : x, b = e.xAccessor, v = e.xScale, A = e.yAccessor, w = e.yScale, M = LW(e, IW), $ = Xe(Pt), P = $.colorScale, E = $.horizontal, T = $.theme, B = $.innerWidth, j = B === void 0 ? 0 : B, V = $.innerHeight, W = V === void 0 ? 0 : V, S = Se(function() {
    return Bs(v, b);
  }, [v, b]), _ = Se(function() {
    return Bs(w, A);
  }, [w, A]), U = Os(E ? w : v), z = U || BW((E ? W : j) / l.length, i), N = Se(function() {
    return v ? Rh(v) : 0;
  }, [v]), O = Se(function() {
    return w ? Rh(w) : 0;
  }, [w]), k = (t = (n = P == null ? void 0 : P(c)) != null ? n : T == null || (r = T.colors) == null ? void 0 : r[0]) != null ? t : "#222", Q = Se(function() {
    var ae = E ? 0 : -z / 2, oe = E ? -z / 2 : 0;
    return l.map(function(ee, ie) {
      var X, J = S(ee) + ae;
      if (!at(J))
        return null;
      var pe = _(ee) + oe;
      if (!at(pe))
        return null;
      var D = E ? J - N : pe - O;
      return at(D) ? {
        key: "" + ie,
        x: E ? N + Math.min(0, D) : J,
        y: E ? pe : O + Math.min(0, D),
        width: E ? Math.abs(D) : z,
        height: E ? z : Math.abs(D),
        fill: (X = s == null ? void 0 : s(ee, ie)) != null ? X : k
      } : null;
    }).filter(function(ee) {
      return ee;
    });
  }, [z, k, s, l, S, _, E, N, O]), q = dW + "-" + c, re = v0({
    dataKey: c,
    enableEvents: y,
    onBlur: d,
    onFocus: f,
    onPointerMove: p,
    onPointerOut: m,
    onPointerUp: h,
    onPointerDown: g,
    source: q,
    allowedSources: [ci, q]
  });
  return /* @__PURE__ */ R.createElement("g", {
    className: "vx-bar-series"
  }, /* @__PURE__ */ R.createElement(o, Ku({
    bars: Q,
    horizontal: E,
    xScale: v,
    yScale: w
  }, re, M)));
}
h8.propTypes = {
  barPadding: se.number,
  colorAccessor: se.func
};
const zW = d8(h8);
var WW = ["colorAccessor"];
function Qu() {
  return Qu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qu.apply(this, arguments);
}
function jW(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function VW(e) {
  var t = e.colorAccessor, n = jW(e, WW);
  return /* @__PURE__ */ R.createElement(zW, Qu({}, n, {
    // @TODO currently generics for non-SeriesProps are not passed correctly in
    // withRegisteredData HOC
    colorAccessor: t,
    BarsComponent: p8
  }));
}
var HW = UW;
function UW(e) {
  if ("bandwidth" in e)
    return e.bandwidth();
  var t = e.range(), n = e.domain();
  return Math.abs(t[t.length - 1] - t[0]) / n.length;
}
function Zu() {
  return Zu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zu.apply(this, arguments);
}
function m8(e) {
  var t = e.children, n = e.order, r = e.offset, o = e.BarsComponent, a = e.onBlur, i = e.onFocus, s = e.onPointerMove, l = e.onPointerOut, c = e.onPointerUp, d = e.onPointerDown, f = e.enableEvents, p = f === void 0 ? !0 : f, m = Xe(Pt), h = m.colorScale, g = m.dataRegistry, x = m.horizontal, y = m.xScale, b = m.yScale, v = DW({
    children: t,
    order: n,
    offset: r
  }), A = v.seriesChildren, w = v.dataKeys, M = v.stackedData, $ = me(function(z) {
    var N, O, k = (N = A.find(function(Q) {
      return Q.props.dataKey === z.dataKey;
    })) == null || (O = N.props) == null ? void 0 : O.data;
    return k ? FW(z, k, x) : null;
  }, [A, x]), P = fW + "-" + w.join("-"), E = v0({
    dataKey: w,
    enableEvents: p,
    // @ts-expect-error Datum input + return type are expected to be the same type but they differ for BarStack (registry data is StackedDatum, return type is user Datum)
    findNearestDatum: $,
    onBlur: a,
    onFocus: i,
    onPointerMove: s,
    onPointerOut: l,
    onPointerUp: c,
    onPointerDown: d,
    source: P,
    allowedSources: [ci, P]
  }), T = w.map(function(z) {
    return g.get(z);
  });
  if (T.some(function(z) {
    return z == null;
  }) || !y || !b || !h)
    return null;
  var B = HW(x ? b : y), j = B / 2, V, W, S, _;
  x ? (V = function(N) {
    var O, k;
    return ((O = y(vo(N))) != null ? O : NaN) - ((k = y(go(N))) != null ? k : NaN);
  }, W = function() {
    return B;
  }, S = function(N) {
    return y(go(N));
  }, _ = function(N) {
    var O;
    return "bandwidth" in b ? b(zi(N.data)) : Math.max(((O = b(zi(N.data))) != null ? O : NaN) - j);
  }) : (V = function() {
    return B;
  }, W = function(N) {
    var O, k;
    return ((O = b(go(N))) != null ? O : NaN) - ((k = b(vo(N))) != null ? k : NaN);
  }, S = function(N) {
    var O;
    return "bandwidth" in y ? y(zi(N.data)) : Math.max(((O = y(zi(N.data))) != null ? O : NaN) - j);
  }, _ = function(N) {
    return b(vo(N));
  });
  var U = M.map(function(z, N) {
    var O = g.get(z.key);
    if (!O)
      return null;
    var k = A.find(function(J) {
      return J.props.dataKey === z.key;
    }), Q = (k == null ? void 0 : k.props) || {}, q = Q.colorAccessor, re = Q.radius, ae = Q.radiusAll, oe = Q.radiusBottom, ee = Q.radiusLeft, ie = Q.radiusRight, X = Q.radiusTop;
    return {
      key: z.key,
      radius: re,
      radiusAll: ae,
      radiusBottom: oe,
      radiusLeft: ee,
      radiusRight: ie,
      radiusTop: X,
      bars: z.map(function(J, pe) {
        var D, ce = S(J);
        if (!at(ce))
          return null;
        var he = _(J);
        if (!at(he))
          return null;
        var ye = V(J);
        if (!at(ye))
          return null;
        var Me = W(J);
        if (!at(Me))
          return null;
        var Oe = q ? k == null || (D = k.props) == null ? void 0 : D.data[pe] : null;
        return {
          key: N + "-" + z.key + "-" + pe,
          x: ce,
          y: he,
          width: ye,
          height: Me,
          fill: Oe && q ? q(Oe, pe) : h(z.key)
        };
      }).filter(function(J) {
        return J;
      })
    };
  }).filter(function(z) {
    return z;
  });
  return /* @__PURE__ */ R.createElement("g", {
    className: "visx-bar-stack"
  }, U.map(function(z) {
    return z && /* @__PURE__ */ R.createElement(o, Zu({
      horizontal: x,
      xScale: y,
      yScale: b
    }, z, E, {
      key: z.key
    }));
  }));
}
m8.propTypes = {
  children: se.oneOfType([se.element, se.arrayOf(se.element)]).isRequired
};
function Ju() {
  return Ju = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ju.apply(this, arguments);
}
function YW(e) {
  return /* @__PURE__ */ R.createElement(m8, Ju({}, e, {
    BarsComponent: p8
  }));
}
var GW = ["renderGlyph"];
function Ws() {
  return Ws = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ws.apply(this, arguments);
}
function XW(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function g8(e) {
  var t = e.renderGlyph, n = t === void 0 ? AW : t, r = XW(e, GW), o = me(function(a) {
    var i = a.glyphs, s = a.onPointerMove, l = a.onPointerOut, c = a.onPointerUp, d = a.onFocus, f = a.onBlur;
    return i.map(function(p) {
      return /* @__PURE__ */ R.createElement(R.Fragment, {
        key: p.key
      }, n(Ws({}, p, {
        onPointerMove: s,
        onPointerOut: l,
        onPointerUp: c,
        onFocus: d,
        onBlur: f
      })));
    });
  }, [n]);
  return /* @__PURE__ */ R.createElement(wW, Ws({}, r, {
    // @TODO currently generics for non-SeriesProps are not passed correctly in
    // withRegisteredData HOC
    // @ts-expect-error
    renderGlyphs: o
  }));
}
function Ra({
  textLabel: e,
  axisCharLimit: t,
  x: n,
  y: r,
  textStyles: o
}) {
  return /* @__PURE__ */ u(Av, { children: /* @__PURE__ */ I(Cv, { children: [
    /* @__PURE__ */ u(Sv, { asChild: !0, children: /* @__PURE__ */ u("g", { children: /* @__PURE__ */ u(Ga, { className: "pointer-events-auto cursor-pointer", ...o, x: n, y: r, children: e && (e == null ? void 0 : e.length) > t ? `${e == null ? void 0 : e.substring(0, t)}...` : e }) }) }),
    /* @__PURE__ */ u(Ev, { children: /* @__PURE__ */ u(ef, { className: "rabbit-ds", children: /* @__PURE__ */ u("p", { children: e }) }) })
  ] }) });
}
var ed = { exports: {} };
(function(e, t) {
  (function(n, r) {
    r(t);
  })(ua, function(n) {
    var r, o = Object.defineProperty, a = Object.defineProperties, i = Object.getOwnPropertyDescriptors, s = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable, d = Math.pow, f = (C, L, H) => L in C ? o(C, L, { enumerable: !0, configurable: !0, writable: !0, value: H }) : C[L] = H, p = (C, L) => {
      for (var H in L || (L = {}))
        l.call(L, H) && f(C, H, L[H]);
      if (s)
        for (var H of s(L))
          c.call(L, H) && f(C, H, L[H]);
      return C;
    }, m = (C, L) => a(C, i(L)), h = (C, L) => {
      var H = {};
      for (var G in C)
        l.call(C, G) && L.indexOf(G) < 0 && (H[G] = C[G]);
      if (C != null && s)
        for (var G of s(C))
          L.indexOf(G) < 0 && c.call(C, G) && (H[G] = C[G]);
      return H;
    }, g = (C, L, H) => new Promise((G, ne) => {
      var fe = (ge) => {
        try {
          ue(H.next(ge));
        } catch (be) {
          ne(be);
        }
      }, te = (ge) => {
        try {
          ue(H.throw(ge));
        } catch (be) {
          ne(be);
        }
      }, ue = (ge) => ge.done ? G(ge.value) : Promise.resolve(ge.value).then(fe, te);
      ue((H = H.apply(C, L)).next());
    });
    function x(C, L) {
      return C[13] = 1, C[14] = L >> 8, C[15] = L & 255, C[16] = L >> 8, C[17] = L & 255, C;
    }
    const y = "p".charCodeAt(0), b = "H".charCodeAt(0), v = "Y".charCodeAt(0), A = "s".charCodeAt(0);
    let w;
    function M() {
      const C = new Int32Array(256);
      for (let L = 0; L < 256; L++) {
        let H = L;
        for (let G = 0; G < 8; G++)
          H = H & 1 ? 3988292384 ^ H >>> 1 : H >>> 1;
        C[L] = H;
      }
      return C;
    }
    function $(C) {
      let L = -1;
      w || (w = M());
      for (let H = 0; H < C.length; H++)
        L = w[(L ^ C[H]) & 255] ^ L >>> 8;
      return L ^ -1;
    }
    function P(C) {
      const L = C.length - 1;
      for (let H = L; H >= 4; H--)
        if (C[H - 4] === 9 && C[H - 3] === y && C[H - 2] === b && C[H - 1] === v && C[H] === A)
          return H - 3;
      return 0;
    }
    function E(C, L, H = !1) {
      const G = new Uint8Array(13);
      L *= 39.3701, G[0] = y, G[1] = b, G[2] = v, G[3] = A, G[4] = L >>> 24, G[5] = L >>> 16, G[6] = L >>> 8, G[7] = L & 255, G[8] = G[4], G[9] = G[5], G[10] = G[6], G[11] = G[7], G[12] = 1;
      const ne = $(G), fe = new Uint8Array(4);
      if (fe[0] = ne >>> 24, fe[1] = ne >>> 16, fe[2] = ne >>> 8, fe[3] = ne & 255, H) {
        const te = P(C);
        return C.set(G, te), C.set(fe, te + 13), C;
      } else {
        const te = new Uint8Array(4);
        te[0] = 0, te[1] = 0, te[2] = 0, te[3] = 9;
        const ue = new Uint8Array(54);
        return ue.set(C, 0), ue.set(te, 33), ue.set(G, 37), ue.set(fe, 50), ue;
      }
    }
    const T = "AAlwSFlz", B = "AAAJcEhZ", j = "AAAACXBI";
    function V(C) {
      let L = C.indexOf(T);
      return L === -1 && (L = C.indexOf(B)), L === -1 && (L = C.indexOf(j)), L;
    }
    const W = "[modern-screenshot]", S = typeof window < "u", _ = S && "Worker" in window, U = S && "atob" in window, z = S && "btoa" in window, N = S ? (r = window.navigator) == null ? void 0 : r.userAgent : "", O = N.includes("Chrome"), k = N.includes("AppleWebKit") && !O, Q = N.includes("Firefox"), q = (C) => C && "__CONTEXT__" in C, re = (C) => C.constructor.name === "CSSFontFaceRule", ae = (C) => C.constructor.name === "CSSImportRule", oe = (C) => C.nodeType === 1, ee = (C) => typeof C.className == "object", ie = (C) => C.tagName === "image", X = (C) => C.tagName === "use", J = (C) => oe(C) && typeof C.style < "u" && !ee(C), pe = (C) => C.nodeType === 8, D = (C) => C.nodeType === 3, ce = (C) => C.tagName === "IMG", he = (C) => C.tagName === "VIDEO", ye = (C) => C.tagName === "CANVAS", Me = (C) => C.tagName === "TEXTAREA", Oe = (C) => C.tagName === "INPUT", it = (C) => C.tagName === "STYLE", Qe = (C) => C.tagName === "SCRIPT", yt = (C) => C.tagName === "SELECT", At = (C) => C.tagName === "SLOT", It = (C) => C.tagName === "IFRAME", Be = (...C) => console.warn(W, ...C), bn = (C) => console.time(`${W} ${C}`), Wt = (C) => console.timeEnd(`${W} ${C}`), an = (C) => {
      var L;
      const H = (L = C == null ? void 0 : C.createElement) == null ? void 0 : L.call(C, "canvas");
      return H && (H.height = H.width = 1), H && "toDataURL" in H && !!H.toDataURL("image/webp").includes("image/webp");
    }, dt = (C) => C.startsWith("data:");
    function bt(C, L) {
      if (C.match(/^[a-z]+:\/\//i))
        return C;
      if (S && C.match(/^\/\//))
        return window.location.protocol + C;
      if (C.match(/^[a-z]+:/i) || !S)
        return C;
      const H = ft().implementation.createHTMLDocument(), G = H.createElement("base"), ne = H.createElement("a");
      return H.head.appendChild(G), H.body.appendChild(ne), L && (G.href = L), ne.href = C, ne.href;
    }
    function ft(C) {
      var L;
      return (L = C && oe(C) ? C == null ? void 0 : C.ownerDocument : C) != null ? L : window.document;
    }
    const jt = "http://www.w3.org/2000/svg";
    function Vt(C, L, H) {
      const G = ft(H).createElementNS(jt, "svg");
      return G.setAttributeNS(null, "width", C.toString()), G.setAttributeNS(null, "height", L.toString()), G.setAttributeNS(null, "viewBox", `0 0 ${C} ${L}`), G;
    }
    function st(C, L) {
      let H = new XMLSerializer().serializeToString(C);
      return L && (H = H.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE\uFFFF]/ug, "")), `data:image/svg+xml;charset=utf-8,${encodeURIComponent(H)}`;
    }
    function qn(C, L = "image/png", H = 1) {
      return g(this, null, function* () {
        try {
          return yield new Promise((G, ne) => {
            C.toBlob((fe) => {
              fe ? G(fe) : ne(new Error("Blob is null"));
            }, L, H);
          });
        } catch (G) {
          if (U)
            return Be("Failed canvas to blob", { type: L, quality: H }, G), Pe(C.toDataURL(L, H));
          throw G;
        }
      });
    }
    function Pe(C) {
      var L, H;
      const [G, ne] = C.split(","), fe = (H = (L = G.match(/data:(.+);/)) == null ? void 0 : L[1]) != null ? H : void 0, te = window.atob(ne), ue = te.length, ge = new Uint8Array(ue);
      for (let be = 0; be < ue; be += 1)
        ge[be] = te.charCodeAt(be);
      return new Blob([ge], { type: fe });
    }
    function ze(C, L) {
      return new Promise((H, G) => {
        const ne = new FileReader();
        ne.onload = () => H(ne.result), ne.onerror = () => G(ne.error), ne.onabort = () => G(new Error(`Failed read blob to ${L}`)), L === "dataUrl" ? ne.readAsDataURL(C) : L === "arrayBuffer" && ne.readAsArrayBuffer(C);
      });
    }
    const qe = (C) => ze(C, "dataUrl"), pt = (C) => ze(C, "arrayBuffer");
    function ot(C, L) {
      const H = ft(L).createElement("img");
      return H.decoding = "sync", H.loading = "eager", H.src = C, H;
    }
    function Ct(C, L) {
      return new Promise((H) => {
        const { timeout: G, ownerDocument: ne, onError: fe } = L ?? {}, te = typeof C == "string" ? ot(C, ft(ne)) : C;
        let ue = null, ge = null;
        function be() {
          H(te), ue && clearTimeout(ue), ge == null || ge();
        }
        if (G && (ue = setTimeout(be, G)), he(te)) {
          const xe = te.currentSrc || te.src;
          if (!xe)
            return te.poster ? Ct(te.poster, L).then(H) : be();
          if (te.readyState >= 2)
            return be();
          const $e = be, Ae = (ke) => {
            Be("Failed video load", xe, ke), fe == null || fe(ke), be();
          };
          ge = () => {
            te.removeEventListener("loadeddata", $e), te.removeEventListener("error", Ae);
          }, te.addEventListener("loadeddata", $e, { once: !0 }), te.addEventListener("error", Ae, { once: !0 });
        } else {
          const xe = ie(te) ? te.href.baseVal : te.currentSrc || te.src;
          if (!xe)
            return be();
          const $e = () => g(this, null, function* () {
            if (ce(te) && "decode" in te)
              try {
                yield te.decode();
              } catch (ke) {
                Be("Failed to decode image, trying to render anyway", te.dataset.originalSrc || xe, ke);
              }
            be();
          }), Ae = (ke) => {
            Be("Failed image load", te.dataset.originalSrc || xe, ke), be();
          };
          if (ce(te) && te.complete)
            return $e();
          ge = () => {
            te.removeEventListener("load", $e), te.removeEventListener("error", Ae);
          }, te.addEventListener("load", $e, { once: !0 }), te.addEventListener("error", Ae, { once: !0 });
        }
      });
    }
    function xn(C, L) {
      return g(this, null, function* () {
        J(C) && (ce(C) || he(C) ? yield Ct(C, { timeout: L }) : yield Promise.all(["img", "video"].flatMap((H) => Array.from(C.querySelectorAll(H)).map((G) => Ct(G, { timeout: L })))));
      });
    }
    const Kn = function() {
      let C = 0;
      const L = () => `0000${(Math.random() * d(36, 4) << 0).toString(36)}`.slice(-4);
      return () => (C += 1, `u${L()}${C}`);
    }();
    function qo(C) {
      return C == null ? void 0 : C.split(",").map((L) => L.trim().replace(/"|'/g, "").toLowerCase()).filter(Boolean);
    }
    function di(C) {
      return { time: (L) => C && bn(L), timeEnd: (L) => C && Wt(L), warn: (...L) => C && Be(...L) };
    }
    function fi(C) {
      return { cache: C ? "no-cache" : "force-cache" };
    }
    function Ht(C, L) {
      return g(this, null, function* () {
        return q(C) ? C : pi(C, m(p({}, L), { autoDestruct: !0 }));
      });
    }
    function pi(C, L) {
      return g(this, null, function* () {
        var H, G, ne, fe, te;
        const { scale: ue = 1, workerUrl: ge, workerNumber: be = 1 } = L || {}, xe = !!(L != null && L.debug), $e = (H = L == null ? void 0 : L.features) != null ? H : !0, Ae = (G = C.ownerDocument) != null ? G : S ? window.document : void 0, ke = (fe = (ne = C.ownerDocument) == null ? void 0 : ne.defaultView) != null ? fe : S ? window : void 0, Ne = /* @__PURE__ */ new Map(), Le = m(p({ width: 0, height: 0, quality: 1, type: "image/png", scale: ue, backgroundColor: null, style: null, filter: null, maximumCanvasSize: 0, timeout: 3e4, progress: null, debug: xe, fetch: p({ requestInit: fi((te = L == null ? void 0 : L.fetch) == null ? void 0 : te.bypassingCache), placeholderImage: "data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", bypassingCache: !1 }, L == null ? void 0 : L.fetch), font: {}, drawImageInterval: 100, workerUrl: null, workerNumber: be, onCloneNode: null, onEmbedNode: null, onCreateForeignObjectSvg: null, autoDestruct: !1 }, L), { __CONTEXT__: !0, log: di(xe), node: C, ownerDocument: Ae, ownerWindow: ke, dpi: ue === 1 ? null : 96 * ue, svgStyleElement: Tt(Ae), svgDefsElement: Ae == null ? void 0 : Ae.createElementNS(jt, "defs"), svgStyles: /* @__PURE__ */ new Map(), defaultComputedStyles: /* @__PURE__ */ new Map(), workers: [...new Array(_ && ge && be ? be : 0)].map(() => {
          try {
            const Ze = new Worker(ge);
            return Ze.onmessage = (Ke) => g(this, null, function* () {
              var Ot, kn, Qn, W0;
              const { url: Ll, result: j0 } = Ke.data;
              j0 ? (kn = (Ot = Ne.get(Ll)) == null ? void 0 : Ot.resolve) == null || kn.call(Ot, j0) : (W0 = (Qn = Ne.get(Ll)) == null ? void 0 : Qn.reject) == null || W0.call(Qn, new Error(`Error receiving message from worker: ${Ll}`));
            }), Ze.onmessageerror = (Ke) => {
              var Ot, kn;
              const { url: Qn } = Ke.data;
              (kn = (Ot = Ne.get(Qn)) == null ? void 0 : Ot.reject) == null || kn.call(Ot, new Error(`Error receiving message from worker: ${Qn}`));
            }, Ze;
          } catch (Ze) {
            return Be("Failed to new Worker", Ze), null;
          }
        }).filter(Boolean), fontFamilies: /* @__PURE__ */ new Set(), fontCssTexts: /* @__PURE__ */ new Map(), acceptOfImage: `${[an(Ae) && "image/webp", "image/svg+xml", "image/*", "*/*"].filter(Boolean).join(",")};q=0.8`, requests: Ne, drawImageCount: 0, tasks: [], features: $e, isEnable: (Ze) => {
          var Ke;
          return typeof $e == "boolean" ? $e : (Ke = $e[Ze]) != null ? Ke : !0;
        } });
        Le.log.time("wait until load"), yield xn(C, Le.timeout), Le.log.timeEnd("wait until load");
        const { width: We, height: je } = Xt(C, Le);
        return Le.width = We, Le.height = je, Le;
      });
    }
    function Tt(C) {
      if (!C)
        return;
      const L = C.createElement("style"), H = L.ownerDocument.createTextNode(`
.______background-clip--text {
  background-clip: text;
  -webkit-background-clip: text;
}
`);
      return L.appendChild(H), L;
    }
    function Xt(C, L) {
      let { width: H, height: G } = L;
      if (oe(C) && (!H || !G)) {
        const ne = C.getBoundingClientRect();
        H = H || ne.width || Number(C.getAttribute("width")) || 0, G = G || ne.height || Number(C.getAttribute("height")) || 0;
      }
      return { width: H, height: G };
    }
    function On(C, L) {
      return g(this, null, function* () {
        const { log: H, timeout: G, drawImageCount: ne, drawImageInterval: fe } = L;
        H.time("image to canvas");
        const te = yield Ct(C, { timeout: G }), { canvas: ue, context2d: ge } = Nn(C.ownerDocument, L), be = () => {
          try {
            ge == null || ge.drawImage(te, 0, 0, ue.width, ue.height);
          } catch (xe) {
            Be("Failed to drawImage", xe);
          }
        };
        if (be(), L.isEnable("fixSvgXmlDecode"))
          for (let xe = 0; xe < ne; xe++)
            yield new Promise(($e) => {
              setTimeout(() => {
                be(), $e();
              }, xe + fe);
            });
        return L.drawImageCount = 0, H.timeEnd("image to canvas"), ue;
      });
    }
    function Nn(C, L) {
      const { width: H, height: G, scale: ne, backgroundColor: fe, maximumCanvasSize: te } = L, ue = C.createElement("canvas");
      ue.width = Math.floor(H * ne), ue.height = Math.floor(G * ne), ue.style.width = `${H}px`, ue.style.height = `${G}px`, te && (ue.width > te || ue.height > te) && (ue.width > te && ue.height > te ? ue.width > ue.height ? (ue.height *= te / ue.width, ue.width = te) : (ue.width *= te / ue.height, ue.height = te) : ue.width > te ? (ue.height *= te / ue.width, ue.width = te) : (ue.width *= te / ue.height, ue.height = te));
      const ge = ue.getContext("2d");
      return ge && fe && (ge.fillStyle = fe, ge.fillRect(0, 0, ue.width, ue.height)), { canvas: ue, context2d: ge };
    }
    const Ut = ["width", "height"], Sr = ["stroke", "fill"];
    function Er(C, L, H) {
      var G;
      const { defaultComputedStyles: ne, ownerDocument: fe } = H, te = C.nodeName.toLowerCase(), ue = ee(C) && te !== "svg", ge = ue ? Sr.map((je) => [je, C.getAttribute(je)]).filter(([, je]) => je !== null) : [], be = [ue && "svg", te, ge.map((je, Ze) => `${je}=${Ze}`).join(","), L].filter(Boolean).join(":");
      if (ne.has(be))
        return ne.get(be);
      let xe = H.sandbox;
      if (!xe)
        try {
          fe && (xe = fe.createElement("iframe"), xe.id = `__SANDBOX__-${Kn()}`, xe.width = "0", xe.height = "0", xe.style.visibility = "hidden", xe.style.position = "fixed", fe.body.appendChild(xe), (G = xe.contentWindow) == null || G.document.write('<!DOCTYPE html><meta charset="UTF-8"><title></title><body>'), H.sandbox = xe);
        } catch (je) {
          Be("Failed to create iframe sandbox", je);
        }
      if (!xe)
        return /* @__PURE__ */ new Map();
      const $e = xe.contentWindow;
      if (!$e)
        return /* @__PURE__ */ new Map();
      const Ae = $e.document;
      let ke, Ne;
      ue ? (ke = Ae.createElementNS(jt, "svg"), Ne = ke.ownerDocument.createElementNS(ke.namespaceURI, te), ge.forEach(([je, Ze]) => {
        Ne.setAttributeNS(null, je, Ze);
      }), ke.appendChild(Ne)) : ke = Ne = Ae.createElement(te), Ne.textContent = " ", Ae.body.appendChild(ke);
      const Le = $e.getComputedStyle(Ne, L), We = /* @__PURE__ */ new Map();
      for (let je = Le.length, Ze = 0; Ze < je; Ze++) {
        const Ke = Le.item(Ze);
        Ut.includes(Ke) || We.set(Ke, Le.getPropertyValue(Ke));
      }
      return Ae.body.removeChild(ke), ne.set(be, We), We;
    }
    function Jr(C, L) {
      var H;
      const G = /* @__PURE__ */ new Map(), ne = [], fe = /* @__PURE__ */ new Map();
      for (let te = C.length, ue = 0; ue < te; ue++) {
        const ge = C.item(ue), be = C.getPropertyValue(ge), xe = C.getPropertyPriority(ge), $e = ge.lastIndexOf("-"), Ae = $e > -1 ? ge.substring(0, $e) : void 0;
        if (Ae) {
          let ke = fe.get(Ae);
          ke || (ke = /* @__PURE__ */ new Map(), fe.set(Ae, ke)), ke.set(ge, [be, xe]);
        }
        L.get(ge) === be && !xe || (Ae ? ne.push(Ae) : G.set(ge, [be, xe]));
      }
      for (let te = ne.length, ue = 0; ue < te; ue++)
        (H = fe.get(ne[ue])) == null || H.forEach((ge, be) => G.set(be, ge));
      return G;
    }
    const eo = [":before", ":after"], hi = [":-webkit-scrollbar", ":-webkit-scrollbar-button", ":-webkit-scrollbar-thumb", ":-webkit-scrollbar-track", ":-webkit-scrollbar-track-piece", ":-webkit-scrollbar-corner", ":-webkit-resizer"];
    function mi(C, L, H, G) {
      const { ownerWindow: ne, svgStyleElement: fe, svgStyles: te } = G;
      if (!fe || !ne)
        return;
      function ue(ge) {
        var be;
        const xe = ne.getComputedStyle(C, ge);
        let $e = xe.getPropertyValue("content");
        if (!$e || $e === "none")
          return;
        $e = $e.replace(/(')|(")|(counter\(.+\))/g, "");
        const Ae = [Kn()], ke = Er(C, ge, G), Ne = [`content: '${$e}';`], Le = Jr(xe, ke);
        if (Le.delete("content"), Le.delete("-webkit-locale"), ((be = Le.get("background-clip")) == null ? void 0 : be[0]) === "text" && L.classList.add("______background-clip--text"), Le.forEach(([Ze, Ke], Ot) => {
          Ne.push(`${Ot}: ${Ze}${Ke ? " !important" : ""};`);
        }), Ne.length === 1)
          return;
        try {
          L.className = [L.className, ...Ae].join(" ");
        } catch {
          return;
        }
        const We = Ne.join(`
  `);
        let je = te.get(We);
        je || (je = [], te.set(We, je)), je.push(`.${Ae[0]}:${ge}`);
      }
      eo.forEach(ue), H && hi.forEach(ue);
    }
    function J8(C, L) {
      Me(C) && (L.innerHTML = C.value), (Me(C) || Oe(C) || yt(C)) && L.setAttribute("value", C.value);
    }
    function ey(C, L, H, G) {
      var ne, fe, te, ue;
      const { ownerWindow: ge } = G, be = L.style, xe = ge.getComputedStyle(C), $e = Er(C, null, G), Ae = Jr(xe, $e);
      return Ae.delete("transition-property"), Ae.delete("all"), Ae.delete("d"), Ae.delete("content"), H && (Ae.delete("margin-top"), Ae.delete("margin-right"), Ae.delete("margin-bottom"), Ae.delete("margin-left"), Ae.delete("margin-block-start"), Ae.delete("margin-block-end"), Ae.delete("margin-inline-start"), Ae.delete("margin-inline-end"), Ae.set("box-sizing", ["border-box", ""])), ((ne = Ae.get("background-clip")) == null ? void 0 : ne[0]) === "text" && L.classList.add("______background-clip--text"), O && (Ae.has("font-kerning") || Ae.set("font-kerning", ["normal", ""]), (((fe = Ae.get("overflow-x")) == null ? void 0 : fe[0]) === "hidden" || ((te = Ae.get("overflow-y")) == null ? void 0 : te[0]) === "hidden") && ((ue = Ae.get("text-overflow")) == null ? void 0 : ue[0]) === "ellipsis" && C.scrollWidth === C.clientWidth && Ae.set("text-overflow", ["clip", ""])), Ae.forEach(([ke, Ne], Le) => {
        be.setProperty(Le, ke, Ne);
      }), Ae;
    }
    function ty(C, L) {
      var H;
      try {
        if ((H = C == null ? void 0 : C.contentDocument) != null && H.body)
          return gi(C.contentDocument.body, L);
      } catch (G) {
        Be("Failed to clone iframe", G);
      }
      return C.cloneNode(!1);
    }
    function T0(C) {
      if (C.ownerDocument)
        try {
          const ne = C.toDataURL();
          if (ne !== "data:,")
            return ot(ne, C.ownerDocument);
        } catch {
        }
      const L = C.cloneNode(!1), H = C.getContext("2d"), G = L.getContext("2d");
      try {
        return H && G && G.putImageData(H.getImageData(0, 0, C.width, C.height), 0, 0), L;
      } catch (ne) {
        Be("Failed to clone canvas", ne);
      }
      return L;
    }
    function ny(C) {
      return g(this, null, function* () {
        if (C.ownerDocument && !C.currentSrc && C.poster)
          return ot(C.poster, C.ownerDocument);
        const L = C.cloneNode(!1);
        L.crossOrigin = "anonymous", C.currentSrc && C.currentSrc !== C.src && (L.src = C.currentSrc);
        const H = L.ownerDocument;
        if (H) {
          let G = !0;
          if (yield Ct(L, { onError: () => G = !1 }), !G)
            return C.poster ? ot(C.poster, C.ownerDocument) : L;
          L.currentTime = C.currentTime, yield new Promise((fe) => {
            L.addEventListener("seeked", fe, { once: !0 });
          });
          const ne = H.createElement("canvas");
          ne.width = C.offsetWidth, ne.height = C.offsetHeight;
          try {
            const fe = ne.getContext("2d");
            fe && fe.drawImage(L, 0, 0, ne.width, ne.height);
          } catch (fe) {
            return Be("Failed to clone video", fe), C.poster ? ot(C.poster, C.ownerDocument) : L;
          }
          return T0(ne);
        }
        return L;
      });
    }
    function ry(C) {
      const L = C.cloneNode(!1);
      return C.currentSrc && C.currentSrc !== C.src && (L.src = C.currentSrc, L.srcset = ""), L.loading === "lazy" && (L.loading = "eager"), L;
    }
    function oy(C, L) {
      return ye(C) ? T0(C) : It(C) ? ty(C, L) : ce(C) ? ry(C) : he(C) ? ny(C) : C.cloneNode(!1);
    }
    function O0(C, L, H) {
      return g(this, null, function* () {
        oe(L) && (it(L) || Qe(L)) || H.filter && !H.filter(L) || C.appendChild(yield gi(L, H));
      });
    }
    function N0(C, L, H) {
      return g(this, null, function* () {
        var G, ne;
        const fe = (ne = oe(C) ? (G = C.shadowRoot) == null ? void 0 : G.firstChild : void 0) != null ? ne : C.firstChild;
        for (let te = fe; te; te = te.nextSibling)
          if (!pe(te))
            if (oe(te) && At(te) && typeof te.assignedNodes == "function") {
              const ue = te.assignedNodes();
              for (let ge = 0; ge < ue.length; ge++)
                yield O0(L, ue[ge], H);
            } else
              yield O0(L, te, H);
      });
    }
    function ay(C, L) {
      const { backgroundColor: H, width: G, height: ne, style: fe } = L, te = C.style;
      if (H && te.setProperty("background-color", H, "important"), G && te.setProperty("width", `${G}px`, "important"), ne && te.setProperty("height", `${ne}px`, "important"), fe)
        for (const ue in fe)
          te[ue] = fe[ue];
    }
    const iy = /^[\w-:]+$/;
    function gi(C, L, H = !1) {
      return g(this, null, function* () {
        var G, ne, fe, te;
        const { ownerDocument: ue, ownerWindow: ge, fontFamilies: be } = L;
        if (ue && D(C))
          return ue.createTextNode(C.data);
        if (ue && ge && oe(C) && (J(C) || ee(C))) {
          const $e = yield oy(C, L);
          if (L.isEnable("removeAbnormalAttributes")) {
            const Ne = $e.getAttributeNames();
            for (let Le = Ne.length, We = 0; We < Le; We++) {
              const je = Ne[We];
              iy.test(je) || $e.removeAttribute(je);
            }
          }
          const Ae = ey(C, $e, H, L);
          H && ay($e, L);
          let ke = !1;
          if (L.isEnable("copyScrollbar")) {
            const Ne = [(G = Ae.get("overflow-x")) == null ? void 0 : G[0], (ne = Ae.get("overflow-y")) == null ? void 0 : ne[1]];
            ke = Ne.includes("scroll") || (Ne.includes("auto") || Ne.includes("overlay")) && (C.scrollHeight > C.clientHeight || C.scrollWidth > C.clientWidth);
          }
          return mi(C, $e, ke, L), J8(C, $e), (te = qo((fe = Ae.get("font-family")) == null ? void 0 : fe[0])) == null || te.forEach((Ne) => be.add(Ne)), he(C) || (yield N0(C, $e, L)), $e;
        }
        const xe = C.cloneNode(!1);
        return yield N0(C, xe, L), xe;
      });
    }
    function k0(C) {
      if (C.ownerDocument = void 0, C.ownerWindow = void 0, C.svgStyleElement = void 0, C.svgDefsElement = void 0, C.svgStyles.clear(), C.defaultComputedStyles.clear(), C.sandbox) {
        try {
          C.sandbox.remove();
        } catch {
        }
        C.sandbox = void 0;
      }
      C.workers = [], C.fontFamilies.clear(), C.fontCssTexts.clear(), C.requests.clear(), C.tasks = [];
    }
    function sy(C) {
      const L = C, { url: H, timeout: G, responseType: ne } = L, fe = h(L, ["url", "timeout", "responseType"]), te = new AbortController(), ue = G ? setTimeout(() => te.abort(), G) : void 0;
      return fetch(H, p({ signal: te.signal }, fe)).then((ge) => {
        if (!ge.ok)
          throw new Error("Failed fetch, not 2xx response", { cause: ge });
        switch (ne) {
          case "dataUrl":
            return ge.blob().then(qe);
          case "text":
          default:
            return ge.text();
        }
      }).finally(() => clearTimeout(ue));
    }
    function Ko(C, L) {
      const { url: H, requestType: G = "text", responseType: ne = "text", imageDom: fe } = L;
      let te = H;
      const { timeout: ue, acceptOfImage: ge, requests: be, fetch: { requestInit: xe, bypassingCache: $e, placeholderImage: Ae }, workers: ke } = C;
      G === "image" && (k || Q) && C.drawImageCount++;
      let Ne = be.get(H);
      if (!Ne) {
        $e && $e instanceof RegExp && $e.test(te) && (te += (/\?/.test(te) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
        const Le = p({ url: te, timeout: ue, responseType: ne, headers: G === "image" ? { accept: ge } : void 0 }, xe);
        Ne = { type: G, resolve: void 0, reject: void 0, response: null }, Ne.response = (!k && H.startsWith("http") && ke.length ? new Promise((We, je) => {
          ke[be.size & ke.length - 1].postMessage(p({ rawUrl: H }, Le)), Ne.resolve = We, Ne.reject = je;
        }) : sy(Le)).catch((We) => {
          if (be.delete(H), G === "image" && Ae)
            return Be("Failed to fetch image base64, trying to use placeholder image", te), typeof Ae == "string" ? Ae : Ae(fe);
          throw We;
        }), be.set(H, Ne);
      }
      return Ne.response;
    }
    function D0(C, L, H, G) {
      return g(this, null, function* () {
        if (!F0(C))
          return C;
        for (const [ne, fe] of ly(C, L))
          try {
            const te = yield Ko(H, { url: fe, requestType: G ? "image" : "text", responseType: "dataUrl" });
            C = C.replace(cy(ne), `$1${te}$3`);
          } catch (te) {
            Be("Failed to fetch css data url", ne, te);
          }
        return C;
      });
    }
    function F0(C) {
      return /url\((['"]?)([^'"]+?)\1\)/.test(C);
    }
    const R0 = /url\((['"]?)([^'"]+?)\1\)/g;
    function ly(C, L) {
      const H = [];
      return C.replace(R0, (G, ne, fe) => (H.push([fe, bt(fe, L)]), G)), H.filter(([G]) => !dt(G));
    }
    function cy(C) {
      const L = C.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
      return new RegExp(`(url\\(['"]?)(${L})(['"]?\\))`, "g");
    }
    function uy(C, L) {
      return g(this, null, function* () {
        const { ownerDocument: H, svgStyleElement: G, fontFamilies: ne, fontCssTexts: fe, tasks: te, font: ue } = L;
        if (!(!H || !G || !ne.size))
          if (ue && ue.cssText) {
            const ge = I0(ue.cssText, L);
            G.appendChild(H.createTextNode(`${ge}
`));
          } else {
            const ge = Array.from(H.styleSheets).filter((be) => {
              try {
                return "cssRules" in be && !!be.cssRules.length;
              } catch (xe) {
                return Be(`Error while reading CSS rules from ${be.href}`, xe), !1;
              }
            });
            yield Promise.all(ge.flatMap((be) => Array.from(be.cssRules).map((xe, $e) => g(this, null, function* () {
              if (ae(xe)) {
                let Ae = $e + 1;
                const ke = xe.href;
                let Ne = "";
                try {
                  Ne = yield Ko(L, { url: ke, requestType: "text", responseType: "text" });
                } catch (We) {
                  Be(`Error fetch remote css import from ${ke}`, We);
                }
                const Le = Ne.replace(R0, (We, je, Ze) => We.replace(Ze, bt(Ze, ke)));
                for (const We of fy(Le))
                  try {
                    be.insertRule(We, We.startsWith("@import") ? Ae += 1 : be.cssRules.length);
                  } catch (je) {
                    Be("Error inserting rule from remote css import", { rule: We, error: je });
                  }
              }
            })))), ge.flatMap((be) => Array.from(be.cssRules)).filter((be) => {
              var xe;
              return re(be) && F0(be.style.getPropertyValue("src")) && ((xe = qo(be.style.getPropertyValue("font-family"))) == null ? void 0 : xe.some(($e) => ne.has($e)));
            }).forEach((be) => {
              const xe = be, $e = fe.get(xe.cssText);
              $e ? G.appendChild(H.createTextNode(`${$e}
`)) : te.push(D0(xe.cssText, xe.parentStyleSheet ? xe.parentStyleSheet.href : null, L).then((Ae) => {
                Ae = I0(Ae, L), fe.set(xe.cssText, Ae), G.appendChild(H.createTextNode(`${Ae}
`));
              }));
            });
          }
      });
    }
    const dy = /(\/\*[\s\S]*?\*\/)/gi, _0 = /((@.*?keyframes [\s\S]*?){([\s\S]*?}\s*?)})/gi;
    function fy(C) {
      if (C == null)
        return [];
      const L = [];
      let H = C.replace(dy, "");
      for (; ; ) {
        const fe = _0.exec(H);
        if (!fe)
          break;
        L.push(fe[0]);
      }
      H = H.replace(_0, "");
      const G = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, ne = new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})", "gi");
      for (; ; ) {
        let fe = G.exec(H);
        if (fe)
          ne.lastIndex = G.lastIndex;
        else if (fe = ne.exec(H), fe)
          G.lastIndex = ne.lastIndex;
        else
          break;
        L.push(fe[0]);
      }
      return L;
    }
    const py = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g, hy = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
    function I0(C, L) {
      const { font: H } = L, G = H ? H == null ? void 0 : H.preferredFormat : void 0;
      return G ? C.replace(hy, (ne) => {
        for (; ; ) {
          const [fe, , te] = py.exec(ne) || [];
          if (!te)
            return "";
          if (te === G)
            return `src: ${fe};`;
        }
      }) : C;
    }
    function my(C, L) {
      if (ce(C)) {
        const H = C.currentSrc || C.src;
        if (!dt(H))
          return [Ko(L, { url: H, imageDom: C, requestType: "image", responseType: "dataUrl" }).then((G) => {
            G && (C.srcset = "", C.dataset.originalSrc = H, C.src = G || "");
          })];
        (k || Q) && L.drawImageCount++;
      } else if (ee(C) && !dt(C.href.baseVal)) {
        const H = C.href.baseVal;
        return [Ko(L, { url: H, imageDom: C, requestType: "image", responseType: "dataUrl" }).then((G) => {
          G && (C.dataset.originalSrc = H, C.href.baseVal = G || "");
        })];
      }
      return [];
    }
    const gy = ["background-image", "border-image-source", "-webkit-border-image", "-webkit-mask-image", "list-style-image"];
    function vy(C, L) {
      return gy.map((H) => {
        const G = C.getPropertyValue(H);
        return !G || G === "none" ? null : ((k || Q) && L.drawImageCount++, D0(G, null, L, !0).then((ne) => {
          !ne || G === ne || C.setProperty(H, ne, C.getPropertyPriority(H));
        }));
      }).filter(Boolean);
    }
    function yy(C, L) {
      var H;
      const { ownerDocument: G, svgDefsElement: ne } = L, fe = (H = C.getAttribute("href")) != null ? H : C.getAttribute("xlink:href");
      if (!fe)
        return [];
      const [te, ue] = fe.split("#");
      if (ue) {
        const ge = `#${ue}`, be = G == null ? void 0 : G.querySelector(`svg ${ge}`);
        if (te && C.setAttribute("href", ge), ne != null && ne.querySelector(ge))
          return [];
        if (be)
          return [gi(be, L).then((xe) => {
            ne != null && ne.querySelector(ge) || ne == null || ne.appendChild(xe);
          })];
        if (te)
          return [Ko(L, { url: te, responseType: "text" }).then((xe) => {
            ne == null || ne.insertAdjacentHTML("beforeend", xe);
          })];
      }
      return [];
    }
    function L0(C, L) {
      const { tasks: H } = L;
      oe(C) && ((ce(C) || ie(C)) && H.push(...my(C, L)), X(C) && H.push(...yy(C, L))), J(C) && H.push(...vy(C.style, L)), C.childNodes.forEach((G) => {
        L0(G, L);
      });
    }
    function B0(C, L) {
      return g(this, null, function* () {
        const H = yield Ht(C, L);
        if (oe(H.node) && ee(H.node))
          return H.node;
        const { ownerDocument: G, log: ne, tasks: fe, svgStyleElement: te, svgDefsElement: ue, svgStyles: ge, font: be, progress: xe, autoDestruct: $e, onCloneNode: Ae, onEmbedNode: ke, onCreateForeignObjectSvg: Ne } = H;
        ne.time("clone node");
        const Le = yield gi(H.node, H, !0);
        if (te && G) {
          let Ot = "";
          ge.forEach((kn, Qn) => {
            Ot += `${kn.join(`,
`)} {
  ${Qn}
}
`;
          }), te.appendChild(G.createTextNode(Ot));
        }
        ne.timeEnd("clone node"), Ae == null || Ae(Le), be !== !1 && oe(Le) && (ne.time("embed web font"), yield uy(Le, H), ne.timeEnd("embed web font")), ne.time("embed node"), L0(Le, H);
        const We = fe.length;
        let je = 0;
        const Ze = () => g(this, null, function* () {
          for (; ; ) {
            const Ot = fe.pop();
            if (!Ot)
              break;
            try {
              yield Ot;
            } catch (kn) {
              Be("Failed to run task", kn);
            }
            xe == null || xe(++je, We);
          }
        });
        xe == null || xe(je, We), yield Promise.all([...Array(4)].map(Ze)), ne.timeEnd("embed node"), ke == null || ke(Le);
        const Ke = by(Le, H);
        return ue && Ke.insertBefore(ue, Ke.children[0]), te && Ke.insertBefore(te, Ke.children[0]), $e && k0(H), Ne == null || Ne(Ke), Ke;
      });
    }
    function by(C, L) {
      const { width: H, height: G } = L, ne = Vt(H, G, C.ownerDocument), fe = ne.ownerDocument.createElementNS(ne.namespaceURI, "foreignObject");
      return fe.setAttributeNS(null, "x", "0%"), fe.setAttributeNS(null, "y", "0%"), fe.setAttributeNS(null, "width", "100%"), fe.setAttributeNS(null, "height", "100%"), fe.append(C), ne.appendChild(fe), ne;
    }
    function vi(C, L) {
      return g(this, null, function* () {
        var H;
        const G = yield Ht(C, L), ne = yield B0(G), fe = st(ne, G.isEnable("removeControlCharacter"));
        G.autoDestruct || (G.svgStyleElement = Tt(G.ownerDocument), G.svgDefsElement = (H = G.ownerDocument) == null ? void 0 : H.createElementNS(jt, "defs"), G.svgStyles.clear());
        const te = ot(fe, ne.ownerDocument);
        return yield On(te, G);
      });
    }
    function xy(C, L) {
      return g(this, null, function* () {
        const H = yield Ht(C, L), { log: G, type: ne, quality: fe, dpi: te } = H, ue = yield vi(H);
        G.time("canvas to blob");
        const ge = yield qn(ue, ne, fe);
        if (["image/png", "image/jpeg"].includes(ne) && te) {
          const be = yield pt(ge.slice(0, 33));
          let xe = new Uint8Array(be);
          return ne === "image/png" ? xe = E(xe, te) : ne === "image/jpeg" && (xe = x(xe, te)), G.timeEnd("canvas to blob"), new Blob([xe, ge.slice(33)], { type: ne });
        }
        return G.timeEnd("canvas to blob"), ge;
      });
    }
    function to(C, L) {
      return g(this, null, function* () {
        const H = yield Ht(C, L), { log: G, quality: ne, type: fe, dpi: te } = H, ue = yield vi(H);
        G.time("canvas to data url");
        let ge = ue.toDataURL(fe, ne);
        if (["image/png", "image/jpeg"].includes(fe) && te && U && z) {
          const [be, xe] = ge.split(",");
          let $e = 0, Ae = !1;
          if (fe === "image/png") {
            const Ke = V(xe);
            Ke >= 0 ? ($e = Math.ceil((Ke + 28) / 3) * 4, Ae = !0) : $e = 33 / 3 * 4;
          } else
            fe === "image/jpeg" && ($e = 18 / 3 * 4);
          const ke = xe.substring(0, $e), Ne = xe.substring($e), Le = window.atob(ke), We = new Uint8Array(Le.length);
          for (let Ke = 0; Ke < We.length; Ke++)
            We[Ke] = Le.charCodeAt(Ke);
          const je = fe === "image/png" ? E(We, te, Ae) : x(We, te), Ze = window.btoa(String.fromCharCode(...je));
          ge = [be, ",", Ze, Ne].join("");
        }
        return G.timeEnd("canvas to data url"), ge;
      });
    }
    function z0(C, L) {
      return g(this, null, function* () {
        const H = yield Ht(C, L), { width: G, height: ne, ownerDocument: fe } = H, te = yield to(H), ue = Vt(G, ne, fe), ge = ue.ownerDocument.createElementNS(ue.namespaceURI, "image");
        return ge.setAttributeNS(null, "href", te), ge.setAttributeNS(null, "height", "100%"), ge.setAttributeNS(null, "width", "100%"), ue.appendChild(ge), st(ue, H.isEnable("removeControlCharacter"));
      });
    }
    function wy(C, L) {
      return g(this, null, function* () {
        const H = yield Ht(C, L), { ownerDocument: G, width: ne, height: fe, scale: te, type: ue } = H, ge = ue === "image/svg+xml" ? yield z0(H) : yield to(H), be = ot(ge, G);
        return be.width = Math.floor(ne * te), be.height = Math.floor(fe * te), be.style.width = `${ne}px`, be.style.height = `${fe}px`, be;
      });
    }
    function Ay(C, L) {
      return g(this, null, function* () {
        return to(yield Ht(C, m(p({}, L), { type: "image/jpeg" })));
      });
    }
    function Cy(C, L) {
      return g(this, null, function* () {
        const H = yield Ht(C, L), G = yield vi(H);
        return G.getContext("2d").getImageData(0, 0, G.width, G.height).data;
      });
    }
    function Sy(C, L) {
      return g(this, null, function* () {
        return to(yield Ht(C, m(p({}, L), { type: "image/png" })));
      });
    }
    function Ey(C, L) {
      return g(this, null, function* () {
        return to(yield Ht(C, m(p({}, L), { type: "image/webp" })));
      });
    }
    n.createContext = pi, n.destroyContext = k0, n.domToBlob = xy, n.domToCanvas = vi, n.domToDataUrl = to, n.domToForeignObjectSvg = B0, n.domToImage = wy, n.domToJpeg = Ay, n.domToPixel = Cy, n.domToPng = Sy, n.domToSvg = z0, n.domToWebp = Ey, n.loadMedia = Ct, n.waitUntilLoad = xn, Object.defineProperty(n, Symbol.toStringTag, { value: "Module" });
  });
})(ed, ed.exports);
var qW = ed.exports;
const Xn = (e, t, n) => {
  $y(t, () => ({
    download() {
      e.current && qW.domToPng(e.current, { scale: 5 }).then((r) => {
        const o = document.createElement("a");
        o.download = `${n}.png`, o.href = r, o.click();
      });
    }
  }));
}, Wh = [
  { name: "default", dark: "var(--chart-default-dark, #1565BC)", light: "var(--chart-default-light, #99D2F9)" },
  { name: "green", dark: "#1A6400", light: "#B1E39F" },
  { name: "purple", dark: "#734DBB", light: "#E7DAFF" },
  { name: "bronze_yellow", dark: "#7E6000", light: "#FFCEFB" },
  { name: "plum", dark: "#7D1779", light: "#E1AADD" },
  { name: "indigo", dark: "#4657AE", light: "#CDD5FF" },
  { name: "brown", dark: "#8A4A00", light: "#FCC88B" },
  { name: "cardinal", dark: "#BE1442", light: "#FFD0D0" },
  { name: "dark_green", dark: "#00675E", light: "#A1DFD5" },
  { name: "maroon", dark: "#891E01", light: "#FFAE99" },
  { name: "golden_brown", dark: "#90591A", light: "#FFDEB6" },
  { name: "maroon", dark: "#800000", light: "#F2CECE" },
  { name: "green_yellow", dark: "#6A6A00", light: "#FFFFC7" },
  { name: "blue", dark: "#000075", light: "#CFCFFF" },
  { name: "black", dark: "#000000", light: "#E3E1E1" },
  { name: "grey", dark: "#323846", light: "#D0DFFF" },
  { name: "pink", dark: "#BE012F", light: "#FFD9E2" },
  { name: "royal_blue", dark: "#002FDC", light: "#D7DFFF" },
  { name: "magenta", dark: "#B402AA", light: "#FFCEFB" }
];
function tt(e) {
  return Wh[e % Wh.length];
}
const Wi = (e, t) => ir.map(e, (n) => ya(n) && typeof n.type == "function" && n.type.displayName === t.displayName ? n : null);
function y0({ value: e, darkColor: t, lightColor: n }) {
  return /* @__PURE__ */ I("div", { className: "inline-flex items-center justify-start gap-2 px-2 py-1", children: [
    /* @__PURE__ */ u(
      "div",
      {
        style: {
          backgroundColor: n,
          borderColor: t
        },
        className: "relative h-3 w-3 rounded-3xl border"
      }
    ),
    /* @__PURE__ */ u("div", { className: "flex items-start justify-start", children: /* @__PURE__ */ u("div", { className: "text-xs font-normal leading-none text-zinc-800", children: e }) })
  ] });
}
function b0({ label: e, value: t }) {
  return /* @__PURE__ */ I("div", { className: "inline-flex max-w-sm basis-full flex-col items-start justify-start px-1 py-0.5", children: [
    /* @__PURE__ */ u("div", { className: " text-[10px] font-normal leading-none text-stone-500", children: e }),
    /* @__PURE__ */ u("div", { className: "flex items-start justify-start text-sm font-medium", children: t || "-" })
  ] });
}
function x0({ label: e, value: t }) {
  return /* @__PURE__ */ I("div", { className: "inline-flex max-w-sm flex-col items-start justify-start px-2 py-0.5", children: [
    /* @__PURE__ */ u("div", { className: " text-[10px] font-normal leading-none text-stone-500", children: e }),
    /* @__PURE__ */ u("div", { className: "flex items-start justify-start text-sm font-medium", children: t || "-" })
  ] });
}
function w0({ nodeData: e }) {
  const { employee: t } = e, { name: n, imageUrl: r } = t;
  return /* @__PURE__ */ I("div", { className: "inline-flex max-w-sm  items-center justify-start px-2 py-0.5", children: [
    /* @__PURE__ */ u(Hn, { size: "md", children: /* @__PURE__ */ u(Un, { src: r, alt: "Avatar" }) }),
    /* @__PURE__ */ u("div", { className: "flex items-start justify-start px-2 text-sm font-medium", children: n || "-" })
  ] });
}
function Ie({
  children: e,
  showSideBySide: t,
  tooltipTitle: n
}) {
  const r = Wi(e, y0), o = Wi(e, b0), a = Wi(e, x0), i = Wi(e, w0);
  return /* @__PURE__ */ I("div", { className: "rabbit-ds relative z-[1500] inline-flex h-auto w-auto min-w-[200px] max-w-[400px] flex-col items-start justify-start gap-2 rounded-lg bg-white p-2 shadow", children: [
    /* @__PURE__ */ u("div", { className: "px-2 py-1 text-xs font-medium leading-none text-zinc-800", children: n }),
    a,
    /* @__PURE__ */ I("div", { className: "flex w-full flex-col items-start justify-start rounded-lg p-2", children: [
      t && /* @__PURE__ */ I("div", { className: le("flex w-full justify-between"), children: [
        o && o[0],
        !!(o != null && o[1]) && /* @__PURE__ */ u("div", { className: "mx-3 w-0 border-r" }),
        o && o[1]
      ] }),
      t && (o == null ? void 0 : o[2]) && /* @__PURE__ */ I("div", { className: le("flex w-full mt-3 justify-between"), children: [
        o && o[2],
        !!(o != null && o[3]) && /* @__PURE__ */ u("div", { className: "mx-3 w-0 border-r" }),
        o && o[3]
      ] }),
      !t && /* @__PURE__ */ u("div", { className: le("grid w-full auto-rows-auto gap-3"), children: o })
    ] }),
    r && r.length > 0 ? /* @__PURE__ */ u("div", { className: "h-px w-full bg-gray-100 px-2" }) : null,
    r,
    i
  ] });
}
y0.displayName = "Legend";
b0.displayName = "Item";
x0.displayName = "Header";
w0.displayName = "Footer";
Ie.Legend = y0;
Ie.Item = b0;
Ie.Header = x0;
Ie.Footer = w0;
Ie.defaultProps = {
  showSideBySide: !1
};
function v8({
  xValue: e,
  yValue: t,
  tooltipTitle: n,
  xAxisLabel: r,
  yAxisLabel: o,
  showSideBySide: a,
  legendValue: i,
  legendDarkColor: s,
  legendLightColor: l
}) {
  const c = e == null ? void 0 : e.toString(), d = t == null ? void 0 : t.toString();
  return /* @__PURE__ */ I(Ie, { tooltipTitle: n, showSideBySide: a, children: [
    /* @__PURE__ */ u(Ie.Item, { label: r, value: c }),
    /* @__PURE__ */ u(Ie.Item, { label: o, value: d }),
    /* @__PURE__ */ u(Ie.Legend, { value: i, darkColor: s, lightColor: l })
  ] });
}
v8.defaultProps = {
  xValue: void 0,
  yValue: void 0
};
function KW({
  data: e,
  xAccessor: t,
  yAccessor: n,
  connectNulls: r = !1
}) {
  const o = Xe(Pt), a = r ? e.filter((i) => i.y !== null) : e;
  return a.length === 0 ? null : /* @__PURE__ */ u(
    I4,
    {
      data: a,
      stroke: a[0].color.dark,
      strokeWidth: 1,
      x: (i) => {
        var s, l;
        return ((s = o == null ? void 0 : o.xScale) == null ? void 0 : s.call(o, t(i))) + ((l = o == null ? void 0 : o.xScale) == null ? void 0 : l.bandwidth()) / 2;
      },
      y: (i) => {
        var s;
        return (s = o == null ? void 0 : o.yScale) == null ? void 0 : s.call(o, n(i));
      }
    }
  );
}
const QW = ({ x: e, y: t, datum: n, size: r }) => /* @__PURE__ */ u(Wo, { cx: e, cy: t, stroke: n.color.dark, strokeWidth: 1, fill: n.color.light, r: r / 2 }), ZW = ({
  tickData: e,
  xAxisCharLimit: t
}) => {
  var a;
  const n = Xe(Pt), r = (a = n == null ? void 0 : n.xScale) == null ? void 0 : a.bandwidth(), o = Math.floor(r / 5);
  return /* @__PURE__ */ u(
    Ra,
    {
      textLabel: e.formattedValue || "",
      x: e.x,
      y: e.y,
      textStyles: {
        fontFamily: "system-ui",
        fontSize: "10px",
        fontWeight: 600,
        fill: "#666666",
        textAnchor: "middle",
        angle: r && r < 25 ? -45 : 0
      },
      axisCharLimit: t ?? o
    }
  );
}, JW = ({ x: e, y: t, datum: n }) => /* @__PURE__ */ u(
  Wo,
  {
    cx: e,
    cy: t,
    stroke: n.color.dark,
    strokeWidth: 1,
    fill: n.color.dark,
    r: 5,
    style: { zIndex: 1500 }
  }
), ji = {
  xAccessor: (e) => e.x,
  yAccessor: (e) => e.y
}, jh = (e, t, n) => n === "pre" ? `${t}${e}` : `${e}${t}`, y8 = 10, ej = 5, A0 = Y(
  ({
    nodes: e,
    height: t,
    width: n,
    xAxisValues: r,
    series: o,
    xAxisLabel: a,
    yAxisLabel: i,
    xAxisDomain: s,
    yAxisDomain: l,
    xAxisUnitSymbol: c,
    yAxisUnitSymbol: d,
    tooltipTitle: f,
    mode: p,
    xAxisCharLimit: m,
    connectNulls: h = !1,
    maxNodesInMiniMode: g = ej,
    tooltipStackCharLimit: x = y8,
    seriesSelectorTitle: y,
    preselectedNodes: b
  }, v) => {
    const [A, w] = we(() => (b && b <= e.length ? e.slice(0, b) : e).map((T) => T.id)), M = de(null);
    Xn(M, v, `${a}-${i}-LineChart`);
    const $ = Se(() => o.map((E, T) => {
      const B = e.find((j) => j.id === E.id);
      return {
        points: E.data.map((j, V) => ({
          x: r[V],
          y: Number(j),
          nodeId: E.id,
          color: (B == null ? void 0 : B.color) ?? tt(T)
        }))
      };
    }).slice(0, p === "mini" ? g : o.length), [o, p, g, e, r]), P = Se(() => p === "full" ? $.filter((E) => A.includes(E.points[0].nodeId)) : $, [$, A, p]);
    return /* @__PURE__ */ I(
      "div",
      {
        ref: M,
        id: "line-chart",
        className: "rabbit-ds flex flex-col bg-white",
        style: {
          width: n,
          height: t
        },
        children: [
          /* @__PURE__ */ I("div", { className: "flex h-full min-h-0 w-full min-w-0 flex-row", children: [
            /* @__PURE__ */ u("div", { className: "h-full min-h-0 w-full min-w-0", children: /* @__PURE__ */ I(
              ar,
              {
                margin: { top: 10, left: 70, right: 50, bottom: 50 },
                xScale: { type: "band", nice: !0, ...s && { domain: s } },
                yScale: { type: "linear", nice: !0, ...l && { domain: l } },
                children: [
                  /* @__PURE__ */ u(
                    V4,
                    {
                      columns: !1,
                      numTicks: 6,
                      lineStyle: {
                        stroke: "#EBEFF3",
                        strokeWidth: 1
                      }
                    }
                  ),
                  /* @__PURE__ */ u(
                    No,
                    {
                      hideTicks: !0,
                      orientation: "bottom",
                      stroke: "#CFD7DF",
                      strokeWidth: 1,
                      numTicks: 30,
                      tickFormat: (E) => c ? jh(E, c.symbol, c.position) : E,
                      rangePadding: { end: 10 },
                      tickComponent: (E) => /* @__PURE__ */ u(ZW, { tickData: E, xAxisCharLimit: m }),
                      label: `${a} ➔`,
                      labelProps: {
                        fontFamily: "system-ui",
                        fontSize: "10px",
                        fontWeight: 600,
                        dy: 10,
                        fill: "#666666",
                        textAnchor: "middle",
                        verticalAnchor: "middle"
                      }
                    }
                  ),
                  /* @__PURE__ */ u(
                    No,
                    {
                      hideTicks: !0,
                      numTicks: 6,
                      strokeWidth: 1,
                      orientation: "left",
                      stroke: "#CFD7DF",
                      label: `${i} ➔`,
                      tickFormat: (E) => d ? jh(
                        Jt(E >= 1e3 ? "~s" : "")(E),
                        d.symbol,
                        d.position
                      ) : Jt(E >= 1e3 ? "~s" : "")(E),
                      tickLabelProps: {
                        fontFamily: "system-ui",
                        fontSize: "10px",
                        fontWeight: 600,
                        fill: "#666666"
                      },
                      labelProps: {
                        fontFamily: "system-ui",
                        fontSize: "10px",
                        fontWeight: 600,
                        dx: -35,
                        fill: "#666666",
                        textAnchor: "middle",
                        verticalAnchor: "middle"
                      }
                    }
                  ),
                  P.map((E, T) => /* @__PURE__ */ I(ko, { children: [
                    /* @__PURE__ */ u(
                      KW,
                      {
                        data: E.points,
                        xAccessor: ji.xAccessor,
                        yAccessor: ji.yAccessor,
                        connectNulls: h
                      }
                    ),
                    /* @__PURE__ */ u(
                      g8,
                      {
                        dataKey: `Performance Management ${T}`,
                        data: E.points,
                        size: 8,
                        renderGlyph: QW,
                        xAccessor: ji.xAccessor,
                        yAccessor: ji.yAccessor
                      }
                    )
                  ] })),
                  /* @__PURE__ */ u(
                    _l,
                    {
                      showDatumGlyph: !0,
                      scroll: !0,
                      debounce: 500,
                      snapTooltipToDatumX: !0,
                      snapTooltipToDatumY: !0,
                      detectBounds: !0,
                      unstyled: !0,
                      applyPositionStyle: !0,
                      renderGlyph: JW,
                      renderTooltip: ({ tooltipData: E }) => {
                        var j, V, W, S, _, U;
                        const T = e.find((z) => {
                          var N;
                          return z.id === ((N = E == null ? void 0 : E.nearestDatum) == null ? void 0 : N.datum.nodeId);
                        }), B = ((j = E == null ? void 0 : E.nearestDatum) == null ? void 0 : j.datum) && ((V = E == null ? void 0 : E.nearestDatum) == null ? void 0 : V.datum.x.length) < x;
                        return /* @__PURE__ */ u(
                          v8,
                          {
                            xValue: (W = E == null ? void 0 : E.nearestDatum) == null ? void 0 : W.datum.x,
                            yValue: (S = E == null ? void 0 : E.nearestDatum) == null ? void 0 : S.datum.y,
                            xAxisLabel: a,
                            yAxisLabel: i,
                            showSideBySide: !!B,
                            tooltipTitle: f,
                            legendValue: (T == null ? void 0 : T.name) || "",
                            legendDarkColor: ((_ = E == null ? void 0 : E.nearestDatum) == null ? void 0 : _.datum.color.dark) || tt(0).dark,
                            legendLightColor: ((U = E == null ? void 0 : E.nearestDatum) == null ? void 0 : U.datum.color.light) || tt(0).light
                          }
                        );
                      }
                    }
                  )
                ]
              }
            ) }),
            p === "full" && /* @__PURE__ */ I("div", { className: "inline-flex w-64 shrink-0 grow-0 basis-auto flex-col items-start justify-start gap-0.5 rounded border border-solid border-[color:var(--Accent,#EBEFF3)] bg-[#FDFDFD] p-4 pr-0 text-xs", children: [
              /* @__PURE__ */ I("div", { className: "pb-1 text-xs font-semibold", children: [
                /* @__PURE__ */ u("span", { className: "pr-1", children: y ?? a }),
                "(",
                P.length ?? 0,
                "/",
                $.length,
                ")"
              ] }),
              /* @__PURE__ */ u("div", { className: "inline-flex h-[95%] w-full shrink-0 grow-0 flex-col items-start justify-start gap-1 overflow-scroll pr-4", children: $.map((E) => {
                const T = e.find((B) => B.id === E.points[0].nodeId);
                return T && /* @__PURE__ */ I("div", { className: "flex w-full items-center justify-between gap-1 py-1", children: [
                  /* @__PURE__ */ I("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          backgroundColor: E.points[0].color.light,
                          borderColor: E.points[0].color.dark
                        },
                        className: "mr-1 h-3 w-3 rounded-full border"
                      }
                    ),
                    T.name
                  ] }),
                  /* @__PURE__ */ u("div", { className: "flex items-center", children: /* @__PURE__ */ u(
                    md,
                    {
                      checked: A.includes(T.id),
                      onCheckedChange: (B) => {
                        let j = [...A];
                        B ? j = [...A, T.id] : j.splice(A.indexOf(T.id), 1), w(j);
                      }
                    }
                  ) })
                ] }, T.id);
              }) })
            ] })
          ] }),
          p === "mini" && /* @__PURE__ */ u("div", { className: "flex flex-row flex-wrap justify-center gap-4 text-[10px] font-semibold text-font-secondary", children: $.map((E) => {
            const T = e.find((B) => B.id === E.points[0].nodeId);
            return /* @__PURE__ */ I("div", { className: "flex items-center justify-center gap-1", children: [
              /* @__PURE__ */ u(
                "div",
                {
                  style: { backgroundColor: E.points[0].color.light, borderColor: E.points[0].color.dark },
                  className: "h-3 w-3 rounded-full border"
                }
              ),
              T == null ? void 0 : T.name
            ] }, T == null ? void 0 : T.id);
          }) })
        ]
      }
    );
  }
), tj = {
  xAxisUnitSymbol: void 0,
  yAxisUnitSymbol: void 0,
  mode: "mini",
  xAxisCharLimit: void 0,
  tooltipStackCharLimit: y8,
  xAxisDomain: void 0,
  yAxisDomain: void 0,
  connectNulls: !1
};
A0.defaultProps = tj;
A0.displayName = "LineBase";
const b8 = Y((e, t) => /* @__PURE__ */ u(xr, { debounceTime: 10, children: ({ width: n, height: r }) => /* @__PURE__ */ u(A0, { ref: t, width: n, height: r, ...e }) }));
b8.displayName = "LineChart";
const cU = b8;
function Vh(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let o of e)
      (o = t(o, ++r, e)) != null && (n < o || n === void 0 && o >= o) && (n = o);
  }
  return n;
}
function nj(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let o of e)
      (o = t(o, ++r, e)) != null && (n > o || n === void 0 && o >= o) && (n = o);
  }
  return n;
}
function Nc(e, t) {
  let n = 0;
  if (t === void 0)
    for (let r of e)
      (r = +r) && (n += r);
  else {
    let r = -1;
    for (let o of e)
      (o = +t(o, ++r, e)) && (n += o);
  }
  return n;
}
function rj(e, t) {
  return e.sourceLinks.length ? e.depth : t - 1;
}
function Vi(e) {
  return function() {
    return e;
  };
}
function Hh(e, t) {
  return js(e.source, t.source) || e.index - t.index;
}
function Uh(e, t) {
  return js(e.target, t.target) || e.index - t.index;
}
function js(e, t) {
  return e.y0 - t.y0;
}
function kc(e) {
  return e.value;
}
function oj(e) {
  return e.index;
}
function aj(e) {
  return e.nodes;
}
function ij(e) {
  return e.links;
}
function Yh(e, t) {
  const n = e.get(t);
  if (!n)
    throw new Error("missing: " + t);
  return n;
}
function Gh({ nodes: e }) {
  for (const t of e) {
    let n = t.y0, r = n;
    for (const o of t.sourceLinks)
      o.y0 = n + o.width / 2, n += o.width;
    for (const o of t.targetLinks)
      o.y1 = r + o.width / 2, r += o.width;
  }
}
function sj() {
  let e = 0, t = 0, n = 1, r = 1, o = 24, a = 8, i, s = oj, l = rj, c, d, f = aj, p = ij, m = 6;
  function h() {
    const S = { nodes: f.apply(null, arguments), links: p.apply(null, arguments) };
    return g(S), x(S), y(S), b(S), w(S), Gh(S), S;
  }
  h.update = function(S) {
    return Gh(S), S;
  }, h.nodeId = function(S) {
    return arguments.length ? (s = typeof S == "function" ? S : Vi(S), h) : s;
  }, h.nodeAlign = function(S) {
    return arguments.length ? (l = typeof S == "function" ? S : Vi(S), h) : l;
  }, h.nodeSort = function(S) {
    return arguments.length ? (c = S, h) : c;
  }, h.nodeWidth = function(S) {
    return arguments.length ? (o = +S, h) : o;
  }, h.nodePadding = function(S) {
    return arguments.length ? (a = i = +S, h) : a;
  }, h.nodes = function(S) {
    return arguments.length ? (f = typeof S == "function" ? S : Vi(S), h) : f;
  }, h.links = function(S) {
    return arguments.length ? (p = typeof S == "function" ? S : Vi(S), h) : p;
  }, h.linkSort = function(S) {
    return arguments.length ? (d = S, h) : d;
  }, h.size = function(S) {
    return arguments.length ? (e = t = 0, n = +S[0], r = +S[1], h) : [n - e, r - t];
  }, h.extent = function(S) {
    return arguments.length ? (e = +S[0][0], n = +S[1][0], t = +S[0][1], r = +S[1][1], h) : [[e, t], [n, r]];
  }, h.iterations = function(S) {
    return arguments.length ? (m = +S, h) : m;
  };
  function g({ nodes: S, links: _ }) {
    for (const [z, N] of S.entries())
      N.index = z, N.sourceLinks = [], N.targetLinks = [];
    const U = new Map(S.map((z, N) => [s(z, N, S), z]));
    for (const [z, N] of _.entries()) {
      N.index = z;
      let { source: O, target: k } = N;
      typeof O != "object" && (O = N.source = Yh(U, O)), typeof k != "object" && (k = N.target = Yh(U, k)), O.sourceLinks.push(N), k.targetLinks.push(N);
    }
    if (d != null)
      for (const { sourceLinks: z, targetLinks: N } of S)
        z.sort(d), N.sort(d);
  }
  function x({ nodes: S }) {
    for (const _ of S)
      _.value = _.fixedValue === void 0 ? Math.max(Nc(_.sourceLinks, kc), Nc(_.targetLinks, kc)) : _.fixedValue;
  }
  function y({ nodes: S }) {
    const _ = S.length;
    let U = new Set(S), z = /* @__PURE__ */ new Set(), N = 0;
    for (; U.size; ) {
      for (const O of U) {
        O.depth = N;
        for (const { target: k } of O.sourceLinks)
          z.add(k);
      }
      if (++N > _)
        throw new Error("circular link");
      U = z, z = /* @__PURE__ */ new Set();
    }
  }
  function b({ nodes: S }) {
    const _ = S.length;
    let U = new Set(S), z = /* @__PURE__ */ new Set(), N = 0;
    for (; U.size; ) {
      for (const O of U) {
        O.height = N;
        for (const { source: k } of O.targetLinks)
          z.add(k);
      }
      if (++N > _)
        throw new Error("circular link");
      U = z, z = /* @__PURE__ */ new Set();
    }
  }
  function v({ nodes: S }) {
    const _ = Vh(S, (N) => N.depth) + 1, U = (n - e - o) / (_ - 1), z = new Array(_);
    for (const N of S) {
      const O = Math.max(0, Math.min(_ - 1, Math.floor(l.call(null, N, _))));
      N.layer = O, N.x0 = e + O * U, N.x1 = N.x0 + o, z[O] ? z[O].push(N) : z[O] = [N];
    }
    if (c)
      for (const N of z)
        N.sort(c);
    return z;
  }
  function A(S) {
    const _ = nj(S, (U) => (r - t - (U.length - 1) * i) / Nc(U, kc));
    for (const U of S) {
      let z = t;
      for (const N of U) {
        N.y0 = z, N.y1 = z + N.value * _, z = N.y1 + i;
        for (const O of N.sourceLinks)
          O.width = O.value * _;
      }
      z = (r - z + i) / (U.length + 1);
      for (let N = 0; N < U.length; ++N) {
        const O = U[N];
        O.y0 += z * (N + 1), O.y1 += z * (N + 1);
      }
      j(U);
    }
  }
  function w(S) {
    const _ = v(S);
    i = Math.min(a, (r - t) / (Vh(_, (U) => U.length) - 1)), A(_);
    for (let U = 0; U < m; ++U) {
      const z = Math.pow(0.99, U), N = Math.max(1 - z, (U + 1) / m);
      $(_, z, N), M(_, z, N);
    }
  }
  function M(S, _, U) {
    for (let z = 1, N = S.length; z < N; ++z) {
      const O = S[z];
      for (const k of O) {
        let Q = 0, q = 0;
        for (const { source: ae, value: oe } of k.targetLinks) {
          let ee = oe * (k.layer - ae.layer);
          Q += V(ae, k) * ee, q += ee;
        }
        if (!(q > 0))
          continue;
        let re = (Q / q - k.y0) * _;
        k.y0 += re, k.y1 += re, B(k);
      }
      c === void 0 && O.sort(js), P(O, U);
    }
  }
  function $(S, _, U) {
    for (let z = S.length, N = z - 2; N >= 0; --N) {
      const O = S[N];
      for (const k of O) {
        let Q = 0, q = 0;
        for (const { target: ae, value: oe } of k.sourceLinks) {
          let ee = oe * (ae.layer - k.layer);
          Q += W(k, ae) * ee, q += ee;
        }
        if (!(q > 0))
          continue;
        let re = (Q / q - k.y0) * _;
        k.y0 += re, k.y1 += re, B(k);
      }
      c === void 0 && O.sort(js), P(O, U);
    }
  }
  function P(S, _) {
    const U = S.length >> 1, z = S[U];
    T(S, z.y0 - i, U - 1, _), E(S, z.y1 + i, U + 1, _), T(S, r, S.length - 1, _), E(S, t, 0, _);
  }
  function E(S, _, U, z) {
    for (; U < S.length; ++U) {
      const N = S[U], O = (_ - N.y0) * z;
      O > 1e-6 && (N.y0 += O, N.y1 += O), _ = N.y1 + i;
    }
  }
  function T(S, _, U, z) {
    for (; U >= 0; --U) {
      const N = S[U], O = (N.y1 - _) * z;
      O > 1e-6 && (N.y0 -= O, N.y1 -= O), _ = N.y0 - i;
    }
  }
  function B({ sourceLinks: S, targetLinks: _ }) {
    if (d === void 0) {
      for (const { source: { sourceLinks: U } } of _)
        U.sort(Uh);
      for (const { target: { targetLinks: U } } of S)
        U.sort(Hh);
    }
  }
  function j(S) {
    if (d === void 0)
      for (const { sourceLinks: _, targetLinks: U } of S)
        _.sort(Uh), U.sort(Hh);
  }
  function V(S, _) {
    let U = S.y0 - (S.sourceLinks.length - 1) * i / 2;
    for (const { target: z, width: N } of S.sourceLinks) {
      if (z === _)
        break;
      U += N + i;
    }
    for (const { source: z, width: N } of _.targetLinks) {
      if (z === S)
        break;
      U -= N;
    }
    return U;
  }
  function W(S, _) {
    let U = _.y0 - (_.targetLinks.length - 1) * i / 2;
    for (const { source: z, width: N } of _.targetLinks) {
      if (z === S)
        break;
      U += N + i;
    }
    for (const { target: z, width: N } of S.sourceLinks) {
      if (z === _)
        break;
      U -= N;
    }
    return U;
  }
  return h;
}
function lj({
  tooltipData: e,
  fromLabel: t,
  toLabel: n,
  weightLabel: r,
  tooltipTitle: o
}) {
  var s, l, c, d;
  const a = e.source, i = e.target;
  return /* @__PURE__ */ I(Ie, { tooltipTitle: o, children: [
    /* @__PURE__ */ u(Ie.Item, { label: t, value: a.name }),
    /* @__PURE__ */ u(Ie.Item, { label: n, value: i.name }),
    /* @__PURE__ */ u(Ie.Item, { label: r, value: e.weight.toString() }),
    /* @__PURE__ */ u(
      Ie.Legend,
      {
        value: a.name,
        darkColor: (s = tt((a.index || 0) + 1)) == null ? void 0 : s.dark,
        lightColor: (l = tt((a.index || 0) + 1)) == null ? void 0 : l.light
      }
    ),
    /* @__PURE__ */ u(
      Ie.Legend,
      {
        value: i.name,
        darkColor: (c = tt((i.index || 0) + 1)) == null ? void 0 : c.dark,
        lightColor: (d = tt((i.index || 0) + 1)) == null ? void 0 : d.light
      }
    )
  ] });
}
const Xh = 80, qh = 20, cj = 30, uj = 12, x8 = Y(
  ({ height: e, width: t, tooltipTitle: n, nodes: r, links: o, groups: a, weightLabel: i }, s) => {
    const l = Se(
      () => sj().nodeId((S) => S.id).nodeWidth(uj).nodePadding(cj).nodeAlign((S) => S.group),
      []
    ), c = de(null);
    Xn(c, s, `${n}-SankeyChart`);
    const [d, f] = we(""), [p, m] = we(null), { tooltipData: h, tooltipLeft: g, tooltipTop: x, tooltipOpen: y, showTooltip: b, hideTooltip: v } = ai(), { containerBounds: A, containerRef: w, TooltipInPortal: M } = ii({
      detectBounds: !0,
      debounce: 500,
      scroll: !0,
      zIndex: 1500
    }), $ = Se(
      () => l.extent([
        [Xh, qh],
        [t - Xh, e - qh - 50]
      ])({ nodes: r, links: o.map((S) => ({ ...S, value: Number(S.weight) })) }),
      [e, t, l, r, o]
    ), P = Se(() => Math.max(...$.nodes.map((S) => S.depth ?? 0)), [$]), E = Se(() => {
      const S = {};
      let _ = -1 / 0;
      return $.nodes.forEach((U) => {
        const { group: z } = U;
        S[z] ? (S[z].x = Math.max(S[z].x ?? -1 / 0, U.x0 ?? -1 / 0), S[z].y = Math.max(S[z].y ?? -1 / 0, U.y1 ?? -1 / 0)) : (S[z] = {}, S[z].x = U.x0, S[z].y = U.y1), _ = Math.max(_, S[z].y ?? -1 / 0), S[z].y = _;
      }), Object.keys(S).forEach((U) => {
        S[U].y = _;
      }), S;
    }, [$]), T = me(
      (S) => {
        const _ = l.nodeId()(S);
        f(d === _ ? "" : _);
      },
      [d, l]
    ), B = me(() => {
      f(""), m(null);
    }, []), j = Se(() => d === "" && p === null ? /* @__PURE__ */ new Set() : new Set(
      $.links.filter(
        (S) => l.nodeId()(S.source) === d || l.nodeId()(S.target) === d || (p == null ? void 0 : p.source) === S.source && (p == null ? void 0 : p.target) === S.target
      )
    ), [d, $, p, l]), V = me(
      (S, _) => {
        const U = ("clientX" in S ? S.clientX : 0) - A.left, z = ("clientY" in S ? S.clientY : 0) - A.top;
        m(_), U && z && b({
          tooltipLeft: U,
          tooltipTop: z,
          tooltipData: _
        });
      },
      [b, A]
    ), W = me(() => {
      B(), v();
    }, [B, v]);
    return /* @__PURE__ */ I("div", { ref: c, className: "rabbit-ds h-min w-min bg-white", id: "sankey-chart", children: [
      /* @__PURE__ */ I("svg", { height: e, width: t, ref: w, children: [
        /* @__PURE__ */ u("g", { children: $.links.map((S) => /* @__PURE__ */ u(
          HL,
          {
            data: S,
            source: (_) => ({ x: _.source.x1, y: _.y0 }),
            target: (_) => ({ x: _.target.x0, y: _.y1 }),
            x: (_) => _.x ?? 0,
            y: (_) => _.y ?? 0,
            fill: "none",
            pointerEvents: "stroke",
            onMouseLeave: () => W(),
            onMouseMove: (_) => V(_, S),
            stroke: tt((S.source.index || 0) + 1).light,
            strokeWidth: S.width,
            strokeOpacity: j.has(S) ? 0.7 : 0.4
          },
          S.index
        )) }),
        /* @__PURE__ */ u("g", { children: $.nodes.map((S) => {
          var _, U, z;
          return /* @__PURE__ */ u("g", { children: /* @__PURE__ */ u(
            L4,
            {
              x: S.x0 ?? 0,
              height: (S.y1 ?? 0) - (S.y0 ?? 0) + 10,
              width: (S.x1 ?? 0) - (S.x0 ?? 0),
              y: (S.y0 ?? 0) - 5,
              onMouseEnter: () => T(S),
              onMouseLeave: () => B(),
              radius: 2,
              fill: d === S.id ? (_ = tt((S.index || 0) + 1)) == null ? void 0 : _.dark : (U = tt((S.index || 0) + 1)) == null ? void 0 : U.light,
              stroke: (z = tt((S.index || 0) + 1)) == null ? void 0 : z.dark,
              all: !0
            }
          ) }, S.index);
        }) }),
        /* @__PURE__ */ u("g", { children: a.map((S) => /* @__PURE__ */ u(
          Ra,
          {
            axisCharLimit: 20,
            x: E[S.id].x ?? 0,
            y: (E[S.id].y ?? 0) + 40,
            textLabel: S.name,
            textStyles: {
              fontSize: 10,
              fontWeight: 600,
              textAnchor: "middle",
              fill: "#666666"
            }
          },
          S.id
        )) }),
        /* @__PURE__ */ I("g", { children: [
          $.nodes.map((S) => /* @__PURE__ */ u(
            Ra,
            {
              axisCharLimit: 8,
              x: S.depth === P ? (S.x1 ?? 0) + 10 : (S.x0 ?? 0) - 10,
              y: (S.y0 ?? 0) + ((S.y1 ?? 0) - (S.y0 ?? 0)) / 2,
              textLabel: S.name,
              textStyles: {
                fontSize: 10,
                fontWeight: 600,
                textAnchor: S.depth === P ? "start" : "end",
                fill: "#666666"
              }
            },
            S.index
          )),
          $.nodes.map(
            (S) => S.value && /* @__PURE__ */ u(
              Ga,
              {
                x: S.depth === P ? (S.x1 ?? 0) + 10 : (S.x0 ?? 0) - 10,
                y: (S.y0 ?? 0) + ((S.y1 ?? 0) - (S.y0 ?? 0)) / 2 + 16,
                style: {
                  fontSize: 10,
                  fontWeight: 400,
                  textAnchor: S.depth === P ? "start" : "end",
                  fill: "#666666"
                },
                children: `(${S.value.toString()})`
              },
              S.index
            )
          )
        ] })
      ] }),
      y && h && /* @__PURE__ */ u(
        M,
        {
          top: x,
          left: g,
          unstyled: !0,
          applyPositionStyle: !0,
          children: /* @__PURE__ */ u(
            lj,
            {
              tooltipData: h,
              fromLabel: `From: ${a[h.source.group].name}`,
              toLabel: `To: ${a[h.target.group].name}`,
              weightLabel: i,
              tooltipTitle: n
            }
          )
        },
        Math.random()
      )
    ] });
  }
);
x8.displayName = "Sankey";
const w8 = Y((e, t) => /* @__PURE__ */ u(xr, { debounceTime: 10, children: ({ width: n, height: r }) => n && r && /* @__PURE__ */ u(x8, { ref: t, width: n, height: r, ...e }) }));
w8.displayName = "SankeyChart";
const uU = w8;
function dj(e) {
  return "bandwidth" in e ? e.bandwidth() : 0;
}
var fj = ["top", "left", "scale", "width", "stroke", "strokeWidth", "strokeDasharray", "className", "children", "numTicks", "lineStyle", "offset", "tickValues"];
function td() {
  return td = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, td.apply(this, arguments);
}
function pj(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function A8(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, o = r === void 0 ? 0 : r, a = e.scale, i = e.width, s = e.stroke, l = s === void 0 ? "#eaf0f6" : s, c = e.strokeWidth, d = c === void 0 ? 1 : c, f = e.strokeDasharray, p = e.className, m = e.children, h = e.numTicks, g = h === void 0 ? 10 : h, x = e.lineStyle, y = e.offset, b = e.tickValues, v = pj(e, fj), A = b ?? Kf(a, g), w = (y ?? 0) + dj(a) / 2, M = A.map(function($, P) {
    var E, T = ((E = Dl(a($))) != null ? E : 0) + w;
    return {
      index: P,
      from: new Wn({
        x: 0,
        y: T
      }),
      to: new Wn({
        x: i,
        y: T
      })
    };
  });
  return /* @__PURE__ */ R.createElement(Tn, {
    className: $t("visx-rows", p),
    top: n,
    left: o
  }, m ? m({
    lines: M
  }) : M.map(function($) {
    var P = $.from, E = $.to, T = $.index;
    return /* @__PURE__ */ R.createElement(KL, td({
      key: "row-line-" + T,
      from: P,
      to: E,
      stroke: l,
      strokeWidth: d,
      strokeDasharray: f,
      style: x
    }, v));
  }));
}
A8.propTypes = {
  tickValues: se.array,
  width: se.number.isRequired
};
function C8({
  xValue: e,
  yValue: t,
  tooltipTitle: n,
  xAxisLabel: r,
  yAxisLabel: o,
  legendValue: a,
  legendDarkColor: i,
  legendLightColor: s
}) {
  const l = e == null ? void 0 : e.toString(), c = t == null ? void 0 : t.toString();
  return /* @__PURE__ */ I(Ie, { tooltipTitle: n, showSideBySide: !0, children: [
    /* @__PURE__ */ u(Ie.Item, { label: r, value: l }),
    /* @__PURE__ */ u(Ie.Item, { label: o, value: c }),
    /* @__PURE__ */ u(Ie.Legend, { value: a, darkColor: i, lightColor: s })
  ] });
}
C8.defaultProps = {
  xValue: void 0,
  yValue: void 0
};
const Kh = 20, Qh = 50, Dc = 80, Hi = 50, hj = 10, mj = 25, C0 = Y(
  ({
    tooltipTitle: e,
    xAxisLabel: t,
    yAxisLabel: n,
    domain: r,
    binCount: o,
    data: a,
    width: i,
    height: s,
    maxBinCount: l = mj,
    minBinCount: c = hj,
    integerBins: d = !1,
    integerYAxis: f = !1
  }, p) => {
    const m = Se(() => es(a), [a]), { histogramDomain: h, threshold: g, thresholdInteger: x } = Se(() => {
      const N = m[0] ?? 0, O = N === m[1] ? c + N : m[1] ?? 0, k = O - N > c ? O : c + N, Q = Math.min(Math.max(O - N, c), l), q = Math.floor(m[0] ?? 0), re = Math.ceil(k);
      return {
        histogramDomain: r || (d ? [q, re] : [N, O]),
        threshold: Q,
        thresholdInteger: Math.ceil(Q)
      };
    }, [m, r, d, l, c]), y = Se(
      () => Oo({
        domain: h,
        range: [Hi, i - Qh],
        round: !0,
        nice: !0
      }),
      [h, i]
    ), b = Se(() => fR().domain(y.domain()).thresholds(o || (d ? x : g))(a), [y, o, a, g, x, d]), v = Se(
      () => Oo({
        domain: [0, mu(b, (N) => N.length) ?? 0],
        range: [s - Dc, Kh],
        round: !0,
        nice: !0
      }),
      [b, s]
    ), A = Se(
      () => v.ticks().filter((N) => f ? Number.isInteger(N) : N),
      [f, v]
    ), w = de(null);
    Xn(w, p, `${t}-${n}-Histogram`);
    const { tooltipData: M, tooltipLeft: $, tooltipTop: P, tooltipOpen: E, showTooltip: T, hideTooltip: B } = ai(), { containerBounds: j, containerRef: V, TooltipInPortal: W } = ii({
      detectBounds: !0,
      debounce: 500,
      scroll: !0,
      zIndex: 1500
    }), S = i - Hi - Qh, _ = s - Kh - Dc - 100, U = me(
      (N, O) => {
        const k = ("clientX" in N ? N.clientX : 0) - j.left, Q = ("clientY" in N ? N.clientY : 0) - j.top;
        k && Q && T({
          tooltipLeft: k,
          tooltipTop: Q,
          tooltipData: O
        });
      },
      [T, j]
    ), z = me(() => {
      B();
    }, [B]);
    return /* @__PURE__ */ I(
      "div",
      {
        className: "rabbit-ds flex flex-col bg-white",
        style: {
          width: i,
          height: s
        },
        ref: w,
        children: [
          /* @__PURE__ */ I("svg", { width: i, height: s, ref: V, children: [
            /* @__PURE__ */ u(
              Iu,
              {
                orientation: "bottom",
                scale: y,
                top: s - Dc,
                hideTicks: !0,
                numTicks: 6,
                stroke: "#CFD7DF",
                strokeWidth: 1,
                rangePadding: { end: 10 },
                label: `${t} ➔`,
                tickLabelProps: {
                  fontFamily: "system-ui",
                  fontSize: "10px",
                  fontWeight: 600,
                  fill: "#666666",
                  textAnchor: "middle"
                },
                labelProps: {
                  fontFamily: "system-ui",
                  fontSize: "10px",
                  fontWeight: 600,
                  dy: 10,
                  fill: "#666666",
                  textAnchor: "middle",
                  verticalAnchor: "middle"
                }
              }
            ),
            /* @__PURE__ */ u(
              Iu,
              {
                orientation: "left",
                scale: v,
                left: Hi,
                hideTicks: !0,
                strokeWidth: 1,
                stroke: "#CFD7DF",
                tickFormat: (N) => f ? Number(N) >= 1e3 ? Jt("~s")(Number(Jt("d")(N))) : Jt("d")(N) : Number(N) >= 1e3 ? Jt("~s")(N) : Jt("")(N),
                tickValues: A,
                label: `${n} ➔`,
                tickLabelProps: {
                  fontFamily: "system-ui",
                  fontSize: "10px",
                  fontWeight: 600,
                  fill: "#666666",
                  textAnchor: "end"
                },
                labelProps: {
                  fontFamily: "system-ui",
                  fontSize: "10px",
                  fontWeight: 600,
                  dx: -20,
                  fill: "#666666",
                  textAnchor: "middle",
                  verticalAnchor: "middle"
                }
              }
            ),
            /* @__PURE__ */ I(Tn, { children: [
              /* @__PURE__ */ u(
                A8,
                {
                  scale: v,
                  width: S,
                  height: _,
                  left: Hi,
                  top: 0,
                  lineStyle: {
                    stroke: "#EBEFF3",
                    strokeWidth: 1
                  }
                }
              ),
              b.map((N) => {
                const O = Math.abs(v(0) - v(N.length)), k = Math.abs(y(N.x1 ?? 0) - y(N.x0 ?? 0));
                return /* @__PURE__ */ u("g", { children: /* @__PURE__ */ u(
                  DL,
                  {
                    x: y(N.x0 ?? 0),
                    y: v(N.length),
                    width: k,
                    height: O && O - 1,
                    fill: tt(0).light,
                    stroke: tt(0).dark,
                    strokeWidth: 1,
                    onMouseMove: (Q) => U(Q, N),
                    onMouseLeave: () => z()
                  }
                ) }, Math.random());
              })
            ] })
          ] }),
          E && M && /* @__PURE__ */ u(
            W,
            {
              top: P,
              left: $,
              unstyled: !0,
              applyPositionStyle: !0,
              children: /* @__PURE__ */ u(
                C8,
                {
                  xAxisLabel: t,
                  xValue: `${M.x0} to ${M.x1}`,
                  yAxisLabel: n,
                  yValue: M.length,
                  tooltipTitle: e,
                  legendValue: n,
                  legendDarkColor: tt(0).dark,
                  legendLightColor: tt(0).light
                }
              )
            },
            Math.random()
          ),
          v.domain()[2]
        ]
      }
    );
  }
), S8 = Y((e, t) => /* @__PURE__ */ u(xr, { debounceTime: 10, children: ({ width: n, height: r }) => /* @__PURE__ */ u(C0, { ref: t, width: n, height: r, ...e }) }));
C0.defaultProps = {
  domain: void 0,
  binCount: void 0,
  integerBins: !1,
  integerYAxis: !1
};
C0.displayName = "HistogramBase";
S8.displayName = "HistogramChart";
const dU = S8;
function E8({
  tooltipTitle: e,
  label: t,
  value: n,
  unit: r,
  legendValue: o,
  legendDarkColor: a,
  legendLightColor: i
}) {
  return /* @__PURE__ */ I(Ie, { tooltipTitle: e, children: [
    /* @__PURE__ */ u(Ie.Item, { label: t, value: `${n} ${r}` }),
    /* @__PURE__ */ u(
      Ie.Legend,
      {
        value: o,
        darkColor: a || "",
        lightColor: i || ""
      }
    )
  ] });
}
E8.defaultProps = {};
const gj = (e) => e.value, vj = (e) => e.label, M8 = Y(
  ({ width: e, height: t, unit: n = "%", data: r, tooltipTitle: o, legendTitle: a }, i) => {
    const s = e / 2, l = t / 2, c = Se(() => Math.min(e - 0.35 * e, t - 50) / 2, [e, t]), { tooltipData: d, tooltipLeft: f, tooltipTop: p, tooltipOpen: m, showTooltip: h, hideTooltip: g } = ai(), { containerBounds: x, containerRef: y, TooltipInPortal: b } = ii({
      detectBounds: !0,
      debounce: 500,
      scroll: !0,
      zIndex: 1500
    }), v = de(null), A = me(
      (M, $) => {
        const P = ("clientX" in M ? M.clientX : 0) - x.left, E = ("clientY" in M ? M.clientY : 0) - x.top;
        P && E && h({
          tooltipLeft: P,
          tooltipTop: E,
          tooltipData: $
        });
      },
      [h, x]
    ), w = me(() => {
      g();
    }, [g]);
    return Xn(v, i, "DonutChart"), /* @__PURE__ */ I(
      "div",
      {
        className: "rabbit-ds flex flex-col bg-white",
        style: {
          width: e,
          height: t
        },
        ref: v,
        children: [
          /* @__PURE__ */ u("svg", { width: e, height: t, className: "rabbit-ds", ref: y, children: /* @__PURE__ */ u(Tn, { top: l - 20, left: s, children: /* @__PURE__ */ u(
            ML,
            {
              data: r,
              pieValue: gj,
              outerRadius: c - 10,
              innerRadius: c - Math.min(e * 0.07, 22) - 10,
              cornerRadius: 2,
              padAngle: 0.025,
              children: (M) => /* @__PURE__ */ u(ko, { children: M.arcs.map(($) => {
                const P = vj($.data);
                return /* @__PURE__ */ u("g", { children: /* @__PURE__ */ u(
                  "path",
                  {
                    d: M.path($) ?? void 0,
                    fill: $.data.color,
                    onMouseLeave: w,
                    onMouseMove: (E) => A(E, {
                      label: a,
                      value: $.value,
                      tooltipTitle: o,
                      unit: n,
                      legendValue: P,
                      legendDarkColor: $.data.labelColor,
                      legendLightColor: $.data.color
                    })
                  }
                ) }, `arc-${P}`);
              }) })
            }
          ) }) }),
          m && d && /* @__PURE__ */ u(
            b,
            {
              top: p,
              left: f,
              unstyled: !0,
              applyPositionStyle: !0,
              children: /* @__PURE__ */ u(
                E8,
                {
                  unit: d.unit,
                  label: d.label,
                  value: d.value,
                  tooltipTitle: o,
                  legendValue: d.legendValue ?? "",
                  legendDarkColor: d.legendDarkColor,
                  legendLightColor: d.legendLightColor
                }
              )
            },
            Math.random()
          ),
          /* @__PURE__ */ u(
            "div",
            {
              className: "flex flex-row flex-wrap justify-center gap-2 text-[10px] font-semibold text-font-secondary",
              style: { fontSize: Math.min(e * 0.04, 10) },
              children: r.map((M) => /* @__PURE__ */ I("div", { className: "flex items-center justify-center gap-1", children: [
                /* @__PURE__ */ u(
                  "div",
                  {
                    style: {
                      backgroundColor: M.color,
                      borderColor: M.labelColor,
                      color: M.labelColor,
                      width: Math.min(e * 0.04, 10),
                      height: Math.min(e * 0.04, 10)
                    },
                    className: "h-3 w-3 rounded-full border"
                  }
                ),
                `${M.label}: ${M.value}${n}`
              ] }, M.label))
            }
          )
        ]
      }
    );
  }
);
M8.displayName = "DonutChartBase";
const $8 = Y((e, t) => /* @__PURE__ */ u(xr, { debounceTime: 10, children: ({ width: n, height: r }) => /* @__PURE__ */ u(M8, { ref: t, width: n, height: r, ...e }) }));
$8.displayName = "DonutChart";
const fU = $8;
function P8({
  xValue: e,
  yValue: t,
  tooltipTitle: n,
  xAxisLabel: r,
  yAxisLabel: o,
  showSideBySide: a,
  legendValue: i,
  legendDarkColor: s,
  legendLightColor: l
}) {
  const c = e == null ? void 0 : e.toString(), d = t == null ? void 0 : t.toString();
  return /* @__PURE__ */ I(Ie, { tooltipTitle: n, showSideBySide: a, children: [
    /* @__PURE__ */ u(Ie.Item, { label: r, value: c }),
    /* @__PURE__ */ u(Ie.Item, { label: o, value: d }),
    /* @__PURE__ */ u(Ie.Legend, { value: i, darkColor: s, lightColor: l })
  ] });
}
P8.defaultProps = {
  xValue: void 0,
  yValue: void 0
};
const Ui = { top: 60, left: 20, right: 20, bottom: 20 }, Zh = {
  start: 10,
  end: -10,
  middle: 0
}, T8 = Y(
  ({
    width: e,
    height: t,
    levels: n = 5,
    nodes: r,
    xAxisLabel: o,
    xAxisCharLimit: a,
    tooltipTitle: i,
    xAxisUnitSymbol: s,
    yAxisDomain: l,
    series: c = [],
    xAxisValues: d
  }, f) => {
    const p = de(null);
    Xn(p, f, "RadarChart");
    const { tooltipData: m, tooltipLeft: h, tooltipTop: g, tooltipOpen: x, showTooltip: y, hideTooltip: b } = ai(), { containerBounds: v, containerRef: A, TooltipInPortal: w } = ii({
      detectBounds: !0,
      debounce: 500,
      scroll: !0,
      zIndex: 1500
    }), M = me((O, k) => {
      const Q = Math.PI * 2 / O;
      return [...new Array(O)].map((q, re) => ({
        x: k * Math.sin(re * Q),
        y: k * Math.cos(re * Q)
      }));
    }, []), $ = me((O, k, Q) => Q === "pre" ? `${k}${O}` : `${O}${k}`, []), P = me(
      (O, k, Q) => {
        const q = Math.PI * 2 / O.length, re = new Array(O.length).fill({
          x: 0,
          y: 0,
          data: null
        }), ae = new Array(O.length + 1).fill("").reduce((oe, ee, ie) => {
          if (ie > O.length)
            return oe;
          const X = k(Q(O[ie - 1])) * Math.sin(ie * q), J = k(Q(O[ie - 1])) * Math.cos(ie * q);
          return re[ie - 1] = { x: X, y: J, data: O[ie - 1] }, `${oe}${X},${J} `;
        });
        return { points: re, pointString: ae };
      },
      []
    ), E = Se(() => new Wn({ x: 0, y: 0 }), []), T = me((O) => Math.round(O) === 0 ? "middle" : O > 0 ? "start" : "end", []), B = me(
      (O, k) => {
        const Q = ("clientX" in O ? O.clientX : 0) - v.left, q = ("clientY" in O ? O.clientY : 0) - v.top;
        Q && q && y({
          tooltipLeft: Q,
          tooltipTop: q,
          tooltipData: k
        });
      },
      [y, v]
    ), j = me(() => {
      b();
    }, [b]), V = Se(() => e - Ui.left - Ui.right, [e]), W = Se(() => t - Ui.top - Ui.bottom, [t]), S = Se(() => Math.min(V, W) / 2, [V, W]), _ = c.length ? c.reduce((O, k) => {
      const Q = k.data.filter((q) => q);
      return Math.max(O, ...Q);
    }, -1 / 0) : 0, U = Oo({
      range: [0, S],
      domain: l ?? [0, _]
    }), z = M(d.length, S), N = (O) => P(
      O,
      (k) => U(k) ?? 0,
      (k) => k
    );
    return /* @__PURE__ */ I(
      "div",
      {
        className: "rabbit-ds flex flex-col bg-white",
        style: {
          width: e,
          height: t
        },
        ref: p,
        children: [
          /* @__PURE__ */ I("svg", { width: e, height: t, ref: A, pointerEvents: "all", onMouseLeave: j, children: [
            /* @__PURE__ */ u("rect", { fill: "transparent", width: e, height: t, rx: 14 }),
            /* @__PURE__ */ I(Tn, { top: t / 2, left: e / 2, children: [
              [...new Array(n)].map((O, k) => /* @__PURE__ */ u(
                vh,
                {
                  x: e / 2,
                  y: t / 2,
                  fill: "none",
                  stroke: "#CFD7DF",
                  strokeWidth: 1,
                  strokeDasharray: 4,
                  r: S * (k + 1) / n
                },
                `web1-${Math.random()}`
              )),
              d.map((O, k) => /* @__PURE__ */ I(ko, { children: [
                /* @__PURE__ */ u(
                  Qf,
                  {
                    from: E,
                    to: z[k],
                    stroke: d.length === 1 ? tt(0).dark : "#CFD7DF",
                    strokeWidth: 1
                  },
                  `radar-line-${Math.random()}`
                ),
                /* @__PURE__ */ u(
                  Ga,
                  {
                    x: z[k].x,
                    y: z[k].y,
                    textAnchor: T(z[k].x),
                    verticalAnchor: T(z[k].y),
                    dx: Zh[T(z[k].x)],
                    dy: Zh[T(z[k].y)],
                    fontSize: 10,
                    fill: "#666666",
                    width: a ?? 100,
                    children: `${s ? $(
                      d[(k + d.length - 1) % d.length],
                      s.symbol,
                      s.position
                    ) : d[(k + d.length - 1) % d.length]}`
                  }
                )
              ] })),
              c.map((O, k) => /* @__PURE__ */ u(
                "polygon",
                {
                  points: N(O.data).pointString,
                  fill: tt(k).light,
                  fillOpacity: 0.2,
                  stroke: tt(k).dark,
                  strokeWidth: 1
                },
                `polypath-${Math.random()}`
              )),
              c.map(
                (O, k) => N(O.data).points.map((Q, q) => /* @__PURE__ */ u(
                  vh,
                  {
                    cx: Q.x,
                    cy: Q.y,
                    r: 5,
                    fill: "transparent",
                    onMouseMove: (re) => {
                      var ae;
                      return B(re, {
                        yAxisLabel: ((ae = r.find((oe) => oe.id === O.id)) == null ? void 0 : ae.name) ?? "",
                        xAxisValue: d[q],
                        yAxisValue: O.data[q],
                        xAxisLabel: o ?? "Category",
                        legendDarkColor: tt(k).dark,
                        legendLightColor: tt(k).light
                      });
                    },
                    onMouseOut: j
                  },
                  `radar-point-${Math.random()}`
                ))
              )
            ] })
          ] }),
          x && m && /* @__PURE__ */ u(
            w,
            {
              top: g,
              left: h,
              unstyled: !0,
              applyPositionStyle: !0,
              children: /* @__PURE__ */ u(
                P8,
                {
                  xAxisLabel: m.xAxisLabel ?? "",
                  xValue: m.xAxisValue,
                  yAxisLabel: m.yAxisLabel ?? "",
                  yValue: m.yAxisValue,
                  tooltipTitle: i,
                  showSideBySide: !0,
                  legendValue: m.yAxisLabel ?? "",
                  legendDarkColor: m.legendDarkColor,
                  legendLightColor: m.legendLightColor
                }
              )
            },
            Math.random()
          )
        ]
      }
    );
  }
);
T8.displayName = "RadarChartBase";
const O8 = Y((e, t) => /* @__PURE__ */ u(xr, { debounceTime: 10, children: ({ width: n, height: r }) => /* @__PURE__ */ u(T8, { ref: t, width: n, height: r, ...e }) }));
O8.displayName = "RadarChart";
const pU = O8;
function N8({
  xValue: e,
  yValue: t,
  tooltipTitle: n,
  xAxisLabel: r,
  yAxisLabel: o,
  showSideBySide: a,
  legendValue: i,
  legendDarkColor: s,
  legendLightColor: l
}) {
  const c = e == null ? void 0 : e.toString(), d = t == null ? void 0 : t.toString();
  return /* @__PURE__ */ I(Ie, { tooltipTitle: n, showSideBySide: a, children: [
    /* @__PURE__ */ u(Ie.Item, { label: r, value: c }),
    /* @__PURE__ */ u(Ie.Item, { label: o, value: d }),
    /* @__PURE__ */ u(Ie.Legend, { value: i, darkColor: s, lightColor: l })
  ] });
}
N8.defaultProps = {
  xValue: void 0,
  yValue: void 0
};
const yj = ({ x: e, y: t, datum: n }) => /* @__PURE__ */ u(
  Wo,
  {
    cx: e,
    cy: t,
    stroke: n.color.dark,
    strokeWidth: 1,
    fill: n.color.dark,
    r: 5,
    style: { zIndex: 1500 }
  }
), bj = ({
  tickData: e,
  xAxisCharLimit: t
}) => {
  var a;
  const n = Xe(Pt), r = (a = n == null ? void 0 : n.xScale) == null ? void 0 : a.bandwidth(), o = Math.floor(r / 5);
  return /* @__PURE__ */ u(
    Ra,
    {
      textLabel: e.formattedValue || "",
      x: e.x,
      y: e.y,
      textStyles: {
        fontFamily: "system-ui",
        fontSize: "10px",
        fontWeight: 600,
        fill: "#666666",
        textAnchor: "middle",
        angle: r && r < 25 ? -45 : 0
      },
      axisCharLimit: t ?? o
    }
  );
}, Jh = {
  xAccessor: (e) => e.x,
  yAccessor: (e) => e.y
}, e2 = (e, t, n) => n === "pre" ? `${t}${e}` : `${e}${t}`, k8 = 10, xj = 5, S0 = Y(
  ({
    nodes: e,
    height: t,
    width: n,
    xAxisValues: r,
    series: o,
    xAxisLabel: a,
    yAxisLabel: i,
    xAxisDomain: s,
    yAxisDomain: l,
    xAxisUnitSymbol: c,
    yAxisUnitSymbol: d,
    tooltipTitle: f,
    mode: p,
    xAxisCharLimit: m,
    maxNodesInMiniMode: h = xj,
    tooltipStackCharLimit: g = k8,
    seriesSelectorTitle: x,
    preselectedNodes: y
  }, b) => {
    const [v, A] = we(() => (y && y <= e.length ? e.slice(0, y) : e).map((E) => E.id)), w = de(null);
    Xn(w, b, `${a}-${i}-StackedBarChart`);
    const M = Se(() => o.map((P, E) => {
      const T = e.find((B) => B.id === P.id);
      return {
        points: P.data.map((B, j) => ({
          x: r[j],
          y: Number(B),
          nodeId: P.id,
          color: (T == null ? void 0 : T.color) ?? tt(E)
        }))
      };
    }).slice(0, p === "mini" ? h : o.length), [o, p, h, e, r]), $ = Se(() => p === "full" ? M.filter((P) => v.includes(P.points[0].nodeId)) : M, [M, v, p]);
    return /* @__PURE__ */ I(
      "div",
      {
        ref: w,
        id: "line-chart",
        className: "rabbit-ds flex flex-col bg-white",
        style: {
          width: n,
          height: t
        },
        children: [
          /* @__PURE__ */ I("div", { className: "flex h-full min-h-0 w-full min-w-0 flex-row", children: [
            /* @__PURE__ */ u("div", { className: "h-full min-h-0 w-full min-w-0", children: /* @__PURE__ */ I(
              ar,
              {
                margin: { top: 10, left: 70, right: 50, bottom: 50 },
                xScale: {
                  type: "band",
                  nice: !0,
                  padding: 0.5,
                  ...s && { domain: s }
                },
                yScale: { type: "linear", nice: !0, ...l && { domain: l } },
                children: [
                  /* @__PURE__ */ u(
                    V4,
                    {
                      columns: !1,
                      numTicks: 6,
                      lineStyle: {
                        stroke: "#EBEFF3",
                        strokeWidth: 1
                      }
                    }
                  ),
                  /* @__PURE__ */ u(
                    No,
                    {
                      hideTicks: !0,
                      orientation: "bottom",
                      stroke: "#CFD7DF",
                      strokeWidth: 1,
                      numTicks: 30,
                      tickFormat: (P) => c ? e2(P, c.symbol, c.position) : P,
                      rangePadding: { end: 10 },
                      tickComponent: (P) => /* @__PURE__ */ u(bj, { tickData: P, xAxisCharLimit: m }),
                      label: `${a} ➔`,
                      labelProps: {
                        fontFamily: "system-ui",
                        fontSize: "10px",
                        fontWeight: 600,
                        dy: 10,
                        fill: "#666666",
                        textAnchor: "middle",
                        verticalAnchor: "middle"
                      }
                    }
                  ),
                  /* @__PURE__ */ u(
                    No,
                    {
                      hideTicks: !0,
                      numTicks: 6,
                      strokeWidth: 1,
                      orientation: "left",
                      stroke: "#CFD7DF",
                      label: `${i} ➔`,
                      tickFormat: (P) => d ? e2(
                        Jt(P >= 1e3 ? "~s" : "")(P),
                        d.symbol,
                        d.position
                      ) : Jt(P >= 1e3 ? "~s" : "")(P),
                      tickLabelProps: {
                        fontFamily: "system-ui",
                        fontSize: "10px",
                        fontWeight: 600,
                        fill: "#666666"
                      },
                      labelProps: {
                        fontFamily: "system-ui",
                        fontSize: "10px",
                        fontWeight: 600,
                        dx: -35,
                        fill: "#666666",
                        textAnchor: "middle",
                        verticalAnchor: "middle"
                      }
                    }
                  ),
                  /* @__PURE__ */ u(YW, { children: $.map((P) => /* @__PURE__ */ u(
                    VW,
                    {
                      data: P.points,
                      dataKey: P.points[0].nodeId,
                      xAccessor: Jh.xAccessor,
                      yAccessor: Jh.yAccessor,
                      colorAccessor: (E) => E.color.light,
                      radiusTop: !0,
                      radius: 2
                    },
                    P.points[0].nodeId
                  )) }),
                  /* @__PURE__ */ u(
                    _l,
                    {
                      showDatumGlyph: !0,
                      scroll: !0,
                      debounce: 500,
                      snapTooltipToDatumX: !0,
                      snapTooltipToDatumY: !0,
                      detectBounds: !0,
                      unstyled: !0,
                      applyPositionStyle: !0,
                      renderGlyph: yj,
                      renderTooltip: ({ tooltipData: P }) => {
                        var B, j, V, W, S, _;
                        const E = e.find((U) => {
                          var z;
                          return U.id === ((z = P == null ? void 0 : P.nearestDatum) == null ? void 0 : z.datum.nodeId);
                        }), T = ((B = P == null ? void 0 : P.nearestDatum) == null ? void 0 : B.datum) && ((j = P == null ? void 0 : P.nearestDatum) == null ? void 0 : j.datum.x.length) < g;
                        return /* @__PURE__ */ u(
                          N8,
                          {
                            xValue: (V = P == null ? void 0 : P.nearestDatum) == null ? void 0 : V.datum.x,
                            yValue: (W = P == null ? void 0 : P.nearestDatum) == null ? void 0 : W.datum.y,
                            xAxisLabel: a,
                            yAxisLabel: i,
                            showSideBySide: !!T,
                            tooltipTitle: f,
                            legendValue: (E == null ? void 0 : E.name) || "",
                            legendDarkColor: ((S = P == null ? void 0 : P.nearestDatum) == null ? void 0 : S.datum.color.dark) || tt(0).dark,
                            legendLightColor: ((_ = P == null ? void 0 : P.nearestDatum) == null ? void 0 : _.datum.color.light) || tt(0).light
                          }
                        );
                      }
                    }
                  )
                ]
              }
            ) }),
            p === "full" && /* @__PURE__ */ I("div", { className: "inline-flex w-64 shrink-0 grow-0 basis-auto flex-col items-start justify-start gap-0.5 rounded border border-solid border-[color:var(--Accent,#EBEFF3)] bg-[#FDFDFD] p-4 pr-0 text-xs", children: [
              /* @__PURE__ */ I("div", { className: "pb-1 text-xs font-semibold", children: [
                /* @__PURE__ */ u("span", { className: "pr-1", children: x ?? a }),
                "(",
                $.length ?? 0,
                "/",
                M.length,
                ")"
              ] }),
              /* @__PURE__ */ u("div", { className: "inline-flex h-[95%] w-full shrink-0 grow-0 flex-col items-start justify-start gap-1 overflow-scroll pr-4", children: M.map((P) => {
                const E = e.find((T) => T.id === P.points[0].nodeId);
                return E && /* @__PURE__ */ I("div", { className: "flex w-full items-center justify-between gap-1 py-1", children: [
                  /* @__PURE__ */ I("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          backgroundColor: P.points[0].color.light,
                          borderColor: P.points[0].color.dark
                        },
                        className: "mr-1 h-3 w-3 rounded-full border"
                      }
                    ),
                    E.name
                  ] }),
                  /* @__PURE__ */ u("div", { className: "flex items-center", children: /* @__PURE__ */ u(
                    md,
                    {
                      checked: v.includes(E.id),
                      onCheckedChange: (T) => {
                        let B = [...v];
                        T ? B = [...v, E.id] : B.splice(v.indexOf(E.id), 1), A(B);
                      }
                    }
                  ) })
                ] }, E.id);
              }) })
            ] })
          ] }),
          p === "mini" && /* @__PURE__ */ u("div", { className: "flex flex-row flex-wrap justify-center gap-4 text-[10px] font-semibold text-font-secondary", children: M.map((P) => {
            const E = e.find((T) => T.id === P.points[0].nodeId);
            return /* @__PURE__ */ I("div", { className: "flex items-center justify-center gap-1", children: [
              /* @__PURE__ */ u(
                "div",
                {
                  style: { backgroundColor: P.points[0].color.light, borderColor: P.points[0].color.dark },
                  className: "h-3 w-3 rounded-full border"
                }
              ),
              E == null ? void 0 : E.name
            ] }, E == null ? void 0 : E.id);
          }) })
        ]
      }
    );
  }
), wj = {
  xAxisUnitSymbol: void 0,
  yAxisUnitSymbol: void 0,
  mode: "mini",
  xAxisCharLimit: void 0,
  tooltipStackCharLimit: k8,
  xAxisDomain: void 0,
  yAxisDomain: void 0,
  connectNulls: !1
};
S0.defaultProps = wj;
S0.displayName = "StackedBarChartBase";
const D8 = Y((e, t) => /* @__PURE__ */ u(xr, { debounceTime: 10, children: ({ width: n, height: r }) => /* @__PURE__ */ u(S0, { ref: t, width: n, height: r, ...e }) }));
D8.displayName = "StackedBarChart";
const hU = D8, Aj = ({
  nodes: e,
  selectedNodeIds: t,
  setSelectedNodeIds: n,
  seriesSelectorTitle: r
}) => /* @__PURE__ */ I("div", { className: "rabbit-ds inline-flex w-64 shrink-0 grow-0 basis-auto flex-col items-start justify-start gap-0.5 rounded border border-solid border-[color:var(--Accent,#EBEFF3)] bg-[#FDFDFD] p-4 pr-0 text-xs", children: [
  /* @__PURE__ */ I("div", { className: "pb-1 text-xs font-semibold", children: [
    /* @__PURE__ */ u("span", { className: "pr-1", children: r }),
    "(",
    t.length ?? 0,
    "/",
    e.length,
    ")"
  ] }),
  /* @__PURE__ */ u("div", { className: "inline-flex h-[95%] w-full shrink-0 grow-0 flex-col items-start justify-start gap-1 overflow-scroll pr-4", children: e.map(({ id: o, name: a, color: i }) => /* @__PURE__ */ I("div", { className: "flex w-full items-center justify-between gap-1 py-1", children: [
    /* @__PURE__ */ I("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            backgroundColor: i.light,
            borderColor: i.dark
          },
          className: "mr-1 h-3 w-3 rounded-full border"
        }
      ),
      a
    ] }),
    /* @__PURE__ */ u("div", { className: "flex items-center", children: /* @__PURE__ */ u(
      md,
      {
        checked: t.includes(o),
        onCheckedChange: (s) => {
          let l = [...t];
          s ? l = [...t, o] : l.splice(t.indexOf(o), 1), n(l);
        }
      }
    ) })
  ] }, o)) })
] }), Cj = Aj;
function F8({
  xValue: e,
  yValue: t,
  tooltipTitle: n,
  xAxisLabel: r,
  yAxisLabel: o,
  showSideBySide: a,
  otherDataPoints: i = [],
  pointMetaData: s,
  seriesMetaData: l
}) {
  var f;
  const c = e == null ? void 0 : e.toString(), d = t == null ? void 0 : t.toString();
  return /* @__PURE__ */ I(Ie, { tooltipTitle: n, showSideBySide: a, children: [
    /* @__PURE__ */ u(Ie.Header, { label: "Review Cycle", value: (f = s == null ? void 0 : s.reviewCycle) == null ? void 0 : f.name }),
    /* @__PURE__ */ u(Ie.Item, { label: r, value: c }),
    /* @__PURE__ */ u(Ie.Item, { label: o, value: d }),
    i.map(({ label: p, value: m }) => /* @__PURE__ */ u(Ie.Item, { label: p, value: m }, p)),
    /* @__PURE__ */ u(Ie.Footer, { nodeData: l })
  ] });
}
F8.defaultProps = {
  xValue: void 0,
  yValue: void 0
};
var Sj = ["id", "markerWidth", "markerHeight", "markerUnits", "children"];
function nd() {
  return nd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nd.apply(this, arguments);
}
function Ej(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function E0(e) {
  var t = e.id, n = e.markerWidth, r = n === void 0 ? 3 : n, o = e.markerHeight, a = o === void 0 ? 3 : o, i = e.markerUnits, s = i === void 0 ? "userSpaceOnUse" : i, l = e.children, c = Ej(e, Sj);
  return /* @__PURE__ */ R.createElement("defs", null, /* @__PURE__ */ R.createElement("marker", nd({
    id: t,
    markerWidth: r,
    markerHeight: a,
    markerUnits: s
  }, c), l));
}
E0.propTypes = {
  id: se.string.isRequired,
  size: se.number,
  markerWidth: se.oneOfType([se.string, se.number]),
  markerHeight: se.oneOfType([se.string, se.number]),
  markerUnits: se.string,
  refX: se.oneOfType([se.string, se.number]),
  refY: se.oneOfType([se.string, se.number]),
  strokeWidth: se.number,
  children: se.node.isRequired
};
var Mj = ["id", "size", "strokeWidth"];
function rd() {
  return rd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rd.apply(this, arguments);
}
function $j(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Pj(e) {
  var t = e.id, n = e.size, r = n === void 0 ? 9 : n, o = e.strokeWidth, a = o === void 0 ? 1 : o, i = $j(e, Mj), s = r + a * 2, l = r, c = s / 2, d = "0 0, " + r + " " + r / 2 + ", 0 " + r;
  return /* @__PURE__ */ R.createElement(E0, rd({
    id: t,
    markerWidth: s,
    markerHeight: s,
    refX: l,
    refY: c,
    orient: "auto",
    markerUnits: "strokeWidth",
    fill: "none",
    strokeWidth: a
  }, i), /* @__PURE__ */ R.createElement("g", {
    transform: "translate(" + a + ", " + a + ")"
  }, /* @__PURE__ */ R.createElement("polyline", {
    points: d
  })));
}
var Tj = ["id", "size", "strokeWidth"];
function od() {
  return od = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, od.apply(this, arguments);
}
function Oj(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Nj(e) {
  var t = e.id, n = e.size, r = n === void 0 ? 9 : n, o = e.strokeWidth, a = o === void 0 ? 1 : o, i = Oj(e, Tj), s = r * 2, l = s + a, c = l / 2;
  return /* @__PURE__ */ R.createElement(E0, od({
    id: t,
    markerWidth: l,
    markerHeight: l,
    refX: 0,
    refY: c,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth",
    strokeWidth: a
  }, i), /* @__PURE__ */ R.createElement("circle", {
    r,
    cx: c,
    cy: c
  }));
}
function kj({
  data: e,
  xAccessor: t,
  yAccessor: n,
  connectNulls: r = !1
}) {
  const o = Xe(Pt), a = r ? e.filter((i) => i.y !== null) : e;
  return a.length === 0 ? null : /* @__PURE__ */ I(ko, { children: [
    /* @__PURE__ */ u(Nj, { id: "marker-circle", stroke: "#666", size: 6, refX: 7, fill: "transparent", strokeWidth: 2 }),
    /* @__PURE__ */ u(
      Pj,
      {
        id: "marker-arrow",
        stroke: "#666",
        size: 14,
        strokeWidth: 2,
        markerUnits: "userSpaceOnUse"
      }
    ),
    /* @__PURE__ */ u(
      I4,
      {
        data: a,
        stroke: a[0].color.dark,
        strokeWidth: 1,
        x: (i) => {
          var s;
          return ((s = o == null ? void 0 : o.xScale) == null ? void 0 : s.call(o, t(i))) ?? 0;
        },
        y: (i) => {
          var s;
          return ((s = o == null ? void 0 : o.yScale) == null ? void 0 : s.call(o, n(i))) ?? 0;
        },
        curve: Ya,
        shapeRendering: "geometricPrecision",
        markerStart: "url(#marker-circle)",
        markerEnd: "url(#marker-arrow)"
      }
    )
  ] });
}
const Dj = ({ x: e, y: t, datum: n, size: r }) => /* @__PURE__ */ u(Wo, { cx: e, cy: t, stroke: n.color.dark, strokeWidth: 1, fill: n.color.light, r: r / 2 }), Fj = ({ x: e, y: t, datum: n }) => /* @__PURE__ */ u(
  Wo,
  {
    cx: e,
    cy: t,
    stroke: n.color.dark,
    strokeWidth: 1,
    fill: n.color.dark,
    r: 5,
    style: { zIndex: 1500 }
  }
), Yi = {
  // @todo this shouldn't be needed. check why the nearestDatum is not working properly
  xAccessor: (e) => e == null ? void 0 : e.x,
  yAccessor: (e) => e == null ? void 0 : e.y
}, t2 = (e, t, n) => n === "pre" ? `${t}${e}` : `${e}${t}`, Rj = 10, _j = 5, R8 = Y(
  ({
    rowsCount: e = 3,
    nodes: t,
    height: n,
    width: r,
    xAxisLabel: o,
    yAxisLabel: a,
    xAxisDomain: i,
    yAxisDomain: s,
    xAxisUnitSymbol: l,
    yAxisUnitSymbol: c,
    tooltipTitle: d,
    mode: f = "mini",
    xAxisCharLimit: p,
    connectNulls: m = !1,
    maxNodesInMiniMode: h = _j,
    tooltipStackCharLimit: g = Rj,
    withBackground: x = !0
    // chartLevelMetaData,
  }, y) => {
    const b = de(null), v = e === 1;
    Xn(b, y, `${o}-${a}-DirectedLineChart`);
    const A = Se(() => t.map(({ seriesMetaData: T }, B) => {
      const { employee: j } = T;
      return {
        id: j.id,
        name: j.name,
        color: tt(B)
      };
    }).slice(0, f === "mini" ? h : t.length), [t, f, h]), [w, M] = we(
      () => A.filter((T, B) => f === "full" || B < h).map((T) => T.id)
    ), $ = Se(() => t.map((T, B) => ({
      nodeId: T.seriesMetaData.employee.id,
      points: T.xValues.map((j, V) => {
        var S;
        let W = null;
        return v ? W = 1 / t.length * (B + 1) + // to spread the point in a line in the y-axis in case of 1D
        1 / (t.length * 10) * (V + 1) : W = ((S = T == null ? void 0 : T.yValues) == null ? void 0 : S[V]) ?? null, {
          x: T.xValues[V],
          y: W,
          pointMetaData: T.pointsMetaData[V],
          nodeId: T.seriesMetaData.employee.id,
          color: tt(B)
        };
      })
    })).slice(0, f === "mini" ? h : t.length), [t, f, h, v]), P = Se(() => f === "full" ? $.filter(({ nodeId: T }) => w.includes(T)) : $, [$, f, w]), E = Se(() => Math.floor((r - (f === "mini" ? 0 : 150)) / (t[0].xValues.length * 8)), [r, f, t]);
    return /* @__PURE__ */ u(
      "div",
      {
        ref: b,
        id: "directed-line-chart",
        className: le("rabbit-ds flex flex-col ", x ? "bg-[white]" : ""),
        style: {
          width: r,
          height: n
        },
        children: /* @__PURE__ */ I("div", { className: "flex h-full min-h-0 w-full min-w-0 flex-row", children: [
          /* @__PURE__ */ u("div", { className: "h-full min-h-0 w-full min-w-0", children: /* @__PURE__ */ I(
            ar,
            {
              margin: { top: 10, left: 50, right: 50, bottom: 50 },
              xScale: typeof i[0] == "string" ? { type: "band", domain: i, padding: 1 } : { type: "linear", domain: i },
              yScale: typeof s[0] == "string" ? { type: "band", domain: s, padding: 1 } : { type: "linear", domain: s },
              children: [
                /* @__PURE__ */ u(
                  No,
                  {
                    hideTicks: !0,
                    orientation: "bottom",
                    stroke: "#CFD7DF",
                    strokeWidth: 1,
                    numTicks: 6,
                    tickFormat: (T) => l ? t2(T, l.symbol, l.position) : T,
                    tickComponent: (T) => /* @__PURE__ */ u(
                      Ra,
                      {
                        textLabel: T.formattedValue || "",
                        x: T.x,
                        y: T.y,
                        textStyles: {
                          fontFamily: "system-ui",
                          fontSize: "10px",
                          fontWeight: 600,
                          fill: "#666666",
                          textAnchor: "middle"
                        },
                        axisCharLimit: p ?? E
                      }
                    ),
                    label: `${o} ➔`,
                    labelProps: {
                      fontFamily: "system-ui",
                      fontSize: "10px",
                      fontWeight: 600,
                      dy: 10,
                      fill: "#666666",
                      textAnchor: "middle",
                      verticalAnchor: "middle"
                    }
                  }
                ),
                /* @__PURE__ */ u(
                  No,
                  {
                    hideTicks: !0,
                    numTicks: v ? 0 : 6,
                    strokeWidth: v ? 0 : 1,
                    orientation: "left",
                    stroke: "#CFD7DF",
                    label: a ? `${a} ➔` : "",
                    tickFormat: (T) => c ? t2(T, c.symbol, c.position) : T,
                    tickLabelProps: {
                      fontFamily: "system-ui",
                      fontSize: "10px",
                      fontWeight: 600,
                      fill: "#666666"
                    },
                    labelProps: {
                      fontFamily: "system-ui",
                      fontSize: "10px",
                      fontWeight: 600,
                      dx: -20,
                      fill: "#666666",
                      textAnchor: "middle",
                      verticalAnchor: "middle"
                    }
                  }
                ),
                P.map((T, B) => /* @__PURE__ */ I(ko, { children: [
                  /* @__PURE__ */ u(
                    kj,
                    {
                      data: T.points,
                      xAccessor: Yi.xAccessor,
                      yAccessor: Yi.yAccessor,
                      connectNulls: m
                    }
                  ),
                  /* @__PURE__ */ u(
                    g8,
                    {
                      dataKey: `Performance Management ${B}`,
                      data: T.points,
                      size: 8,
                      renderGlyph: Dj,
                      xAccessor: Yi.xAccessor,
                      yAccessor: Yi.yAccessor
                    }
                  )
                ] })),
                /* @__PURE__ */ u(
                  _l,
                  {
                    showDatumGlyph: !0,
                    scroll: !0,
                    showVerticalCrosshair: !0,
                    showHorizontalCrosshair: !0,
                    debounce: 500,
                    snapTooltipToDatumX: !0,
                    snapTooltipToDatumY: !0,
                    detectBounds: !0,
                    unstyled: !0,
                    applyPositionStyle: !0,
                    renderGlyph: Fj,
                    renderTooltip: ({ tooltipData: T }) => {
                      var V, W, S, _, U, z, N, O, k;
                      const B = t.find((Q) => {
                        var q;
                        return Q.id === ((q = T == null ? void 0 : T.nearestDatum) == null ? void 0 : q.datum.nodeId);
                      }), j = ((V = T == null ? void 0 : T.nearestDatum) == null ? void 0 : V.datum) && String((W = T == null ? void 0 : T.nearestDatum) == null ? void 0 : W.datum.x).length < g;
                      return /* @__PURE__ */ u(
                        F8,
                        {
                          xValue: (S = T == null ? void 0 : T.nearestDatum) == null ? void 0 : S.datum.x,
                          yValue: (_ = T == null ? void 0 : T.nearestDatum) == null ? void 0 : _.datum.y,
                          xAxisLabel: o,
                          yAxisLabel: a,
                          showSideBySide: !!j,
                          tooltipTitle: d,
                          otherDataPoints: ((N = (z = (U = T == null ? void 0 : T.nearestDatum) == null ? void 0 : U.datum) == null ? void 0 : z.pointMetaData) == null ? void 0 : N.otherDataPoints) ?? [],
                          seriesMetaData: B == null ? void 0 : B.seriesMetaData,
                          pointMetaData: (k = (O = T == null ? void 0 : T.nearestDatum) == null ? void 0 : O.datum) == null ? void 0 : k.pointMetaData
                        }
                      );
                    }
                  }
                )
              ]
            }
          ) }),
          f === "full" && /* @__PURE__ */ u(
            Cj,
            {
              nodes: A,
              seriesSelectorTitle: "Team members",
              selectedNodeIds: w,
              setSelectedNodeIds: M
            }
          )
        ] })
      }
    );
  }
);
R8.displayName = "LineBase";
const _8 = Y((e, t) => /* @__PURE__ */ u(xr, { debounceTime: 10, children: ({ width: n, height: r }) => /* @__PURE__ */ u(R8, { ref: t, width: n, height: r, ...e }) }));
_8.displayName = "DirectedLineChart";
const Ij = _8, Lj = [
  {
    "#FFEFD4": "#AF5C20"
  },
  {
    "#DBF2D3": "#44812F"
  },
  {
    "#BFE8C6": "#1A5724"
  },
  {
    "#FFE7C5": "#8C6A00"
  },
  // not in design
  {
    "#FAD4D4": "#C62C02"
  },
  {
    "#EAEAEA": "#333333"
  },
  {
    "#E6F1FD": "#1565BC"
  },
  // @todo new added in deer design, confirm with BE
  {
    "#FFE1D9": "#C62C02"
  }
];
function Bj({ box: e, showCountData: t = !1 }) {
  function n(r) {
    if (!r)
      return "#333";
    const o = Lj.find((a) => a[r]);
    return o ? o[r] : r;
  }
  return /* @__PURE__ */ I("div", { className: "flex items-center  gap-2", children: [
    /* @__PURE__ */ I("div", { className: "flex shrink grow basis-0 flex-col items-start ", children: [
      /* @__PURE__ */ u("div", { className: "flex items-start  gap-2.5", children: /* @__PURE__ */ I("span", { className: "text-3xs", style: { color: n(n(e == null ? void 0 : e.color)) }, children: [
        " ",
        e == null ? void 0 : e.label
      ] }) }),
      t && /* @__PURE__ */ I("span", { className: " text-3xs   text-stone-500", children: [
        e == null ? void 0 : e.count,
        " Member",
        xb(e == null ? void 0 : e.count)
      ] })
    ] }),
    t && /* @__PURE__ */ u("div", { className: "flex items-start ", children: /* @__PURE__ */ u("div", { className: "flex items-center justify-center rounded-3xl bg-neutral-50/40 px-0.5", children: /* @__PURE__ */ I("span", { className: "  text-2xs leading-4 text-stone-500", children: [
      e == null ? void 0 : e.percentage,
      "%"
    ] }) }) })
  ] });
}
const zj = ({ rows: e, columns: t, boxData: n = [] }) => {
  let r = "";
  return !n || (n == null ? void 0 : n.length) === 0 || (r = n.slice(0, t).reduce((a, i) => {
    var d, f, p, m;
    const s = e === 1 ? "OVERALL" : "PERFORMANCE", l = ((f = (d = i == null ? void 0 : i.scoreRange) == null ? void 0 : d[s]) == null ? void 0 : f.maxScore) ?? 0, c = ((m = (p = i == null ? void 0 : i.scoreRange) == null ? void 0 : p[s]) == null ? void 0 : m.minScore) ?? 0;
    return `${a} minmax(20px, ${l - c}fr)`;
  }, "")), r;
}, Wj = ({ rows: e, columns: t, boxData: n = [] }) => {
  if (e === 1)
    return "1fr";
  let r = "";
  return !n || (n == null ? void 0 : n.length) === 0 || (r = n.filter((a, i) => i % t === 0).reduce((a, i) => {
    var d, f, p, m;
    const s = "POTENTIAL", l = ((f = (d = i == null ? void 0 : i.scoreRange) == null ? void 0 : d[s]) == null ? void 0 : f.maxScore) ?? 0, c = ((m = (p = i == null ? void 0 : i.scoreRange) == null ? void 0 : p[s]) == null ? void 0 : m.minScore) ?? 0;
    return `${a} minmax(20px, ${l - c}fr)`;
  }, "")), r;
}, I8 = Y(
  ({
    rows: e = 3,
    columns: t = 3,
    spacing: n = "1px",
    // boxHeight = '72 px',
    boxData: r = [],
    position: o = "relative",
    margin: a = "0",
    width: i = "100%",
    left: s = 0,
    top: l = 0,
    mode: c = "mini",
    showCountData: d = !1
  }, f) => {
    const p = de(null);
    return Xn(p, f, "GridChart"), /* @__PURE__ */ I(
      "div",
      {
        ref: p,
        className: "flex flex-row",
        style: {
          position: o,
          top: l,
          left: s,
          width: i,
          margin: a,
          height: "100%"
        },
        children: [
          /* @__PURE__ */ u(
            "div",
            {
              style: {
                flexGrow: 1,
                display: "grid",
                gridTemplateRows: Wj({ rows: e, columns: t, boxData: r }),
                gridTemplateColumns: zj({ rows: e, columns: t, boxData: r }),
                gap: n,
                height: "100%"
              },
              children: r == null ? void 0 : r.map((m, h) => /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    // height: boxHeight,
                    padding: "8px",
                    backgroundColor: (m == null ? void 0 : m.color) ?? "#CFD7DF"
                  },
                  children: /* @__PURE__ */ u(Bj, { box: m, showCountData: d })
                },
                m.label + m.color + h
              ))
            }
          ),
          c === "full" && /* @__PURE__ */ u("div", { className: "inline-flex w-64 shrink-0 grow-0" })
        ]
      }
    );
  }
);
I8.displayName = "GridChart";
const jj = I8, L8 = Y(
  ({ directedLineChartProps: e, gridChartProps: t, mode: n = "mini" }, r) => {
    const o = de(null);
    return Xn(
      o,
      r,
      `${e.xAxisLabel}-${e.yAxisLabel}-GridDirectedLineChart`
    ), /* @__PURE__ */ I("div", { ref: o, className: "relative h-full w-full", children: [
      /* @__PURE__ */ u("div", { className: "absolute mx-[50px] mb-[50px] mt-[10px] h-[calc(100%-60px)] w-[calc(100%-100px)]", children: /* @__PURE__ */ u(jj, { ...t, mode: n }) }),
      /* @__PURE__ */ I("div", { className: "absolute h-full w-full", children: [
        /* @__PURE__ */ u(Ij, { ...e, mode: n }),
        /* @__PURE__ */ u("div", {})
      ] })
    ] });
  }
);
L8.displayName = "GridDirectedLineChart";
const mU = L8, Il = "ToggleGroup", [B8, gU] = gt(Il, [
  Io
]), z8 = Io(), Vj = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single") {
    const o = r;
    return /* @__PURE__ */ R.createElement(Hj, K({}, o, {
      ref: t
    }));
  }
  if (n === "multiple") {
    const o = r;
    return /* @__PURE__ */ R.createElement(Uj, K({}, o, {
      ref: t
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${Il}\``);
}), [W8, j8] = B8(Il), Hj = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...a } = e, [i, s] = wt({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ R.createElement(W8, {
    scope: e.__scopeToggleGroup,
    type: "single",
    value: i ? [
      i
    ] : [],
    onItemActivate: s,
    onItemDeactivate: R.useCallback(
      () => s(""),
      [
        s
      ]
    )
  }, /* @__PURE__ */ R.createElement(V8, K({}, a, {
    ref: t
  })));
}), Uj = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...a } = e, [i = [], s] = wt({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = R.useCallback(
    (d) => s(
      (f = []) => [
        ...f,
        d
      ]
    ),
    [
      s
    ]
  ), c = R.useCallback(
    (d) => s(
      (f = []) => f.filter(
        (p) => p !== d
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ R.createElement(W8, {
    scope: e.__scopeToggleGroup,
    type: "multiple",
    value: i,
    onItemActivate: l,
    onItemDeactivate: c
  }, /* @__PURE__ */ R.createElement(V8, K({}, a, {
    ref: t
  })));
}), [Yj, Gj] = B8(Il), V8 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: o = !0, orientation: a, dir: i, loop: s = !0, ...l } = e, c = z8(n), d = vr(i), f = {
    role: "group",
    dir: d,
    ...l
  };
  return /* @__PURE__ */ R.createElement(Yj, {
    scope: n,
    rovingFocus: o,
    disabled: r
  }, o ? /* @__PURE__ */ R.createElement(Ld, K({
    asChild: !0
  }, c, {
    orientation: a,
    dir: d,
    loop: s
  }), /* @__PURE__ */ R.createElement(Ee.div, K({}, f, {
    ref: t
  }))) : /* @__PURE__ */ R.createElement(Ee.div, K({}, f, {
    ref: t
  })));
}), ad = "ToggleGroupItem", Xj = /* @__PURE__ */ R.forwardRef((e, t) => {
  const n = j8(ad, e.__scopeToggleGroup), r = Gj(ad, e.__scopeToggleGroup), o = z8(e.__scopeToggleGroup), a = n.value.includes(e.value), i = r.disabled || e.disabled, s = {
    ...e,
    pressed: a,
    disabled: i
  }, l = R.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ R.createElement(Bd, K({
    asChild: !0
  }, o, {
    focusable: !i,
    active: a,
    ref: l
  }), /* @__PURE__ */ R.createElement(n2, K({}, s, {
    ref: t
  }))) : /* @__PURE__ */ R.createElement(n2, K({}, s, {
    ref: t
  }));
}), n2 = /* @__PURE__ */ R.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, value: r, ...o } = e, a = j8(ad, n), i = {
    role: "radio",
    "aria-checked": e.pressed,
    "aria-pressed": void 0
  }, s = a.type === "single" ? i : void 0;
  return /* @__PURE__ */ R.createElement(x2, K({}, s, o, {
    ref: t,
    onPressedChange: (l) => {
      l ? a.onItemActivate(r) : a.onItemDeactivate(r);
    }
  }));
}), qj = Vj, Kj = Xj;
function vU({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ u(qj, { className: "flex gap-2", ...t, children: e });
}
function yU({
  value: e,
  disabled: t,
  selected: n,
  icon: r,
  label: o,
  count: a,
  ...i
}) {
  return /* @__PURE__ */ u(Kj, { asChild: !0, value: e, ...i, children: /* @__PURE__ */ u(
    "button",
    {
      "data-deer-btn": !0,
      type: "button",
      className: le(
        "rabbit-ds h-7 flex-col w-auto p-0 border border-solid rounded-full justify-center items-center inline-flex hover:cursor-pointer",
        "data-[state=off]:border-gray-100 data-[state=off]:bg-gray-100 data-[state=off]:text-font-secondary",
        "data-[state=on]:border-primary-hover data-[state=on]:bg-primary/10 data-[state=on]:text-primary-hover",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
      ),
      children: /* @__PURE__ */ I("div", { className: "flex flex-row items-center justify-center gap-1 rounded-full px-4 py-1", children: [
        r ? /* @__PURE__ */ u(Fe, { IconSVG: r, size: "small" }) : null,
        /* @__PURE__ */ I("div", { className: "text-sm font-semibold", children: [
          o ? /* @__PURE__ */ u("span", { children: o }) : null,
          " ",
          a ? /* @__PURE__ */ I("span", { children: [
            "(",
            a,
            ")"
          ] }) : null
        ] })
      ] })
    }
  ) });
}
const ui = "NavigationMenu", [M0, Qj, Zj] = Hr(ui), [id, Jj, eV] = Hr(ui), [$0, bU] = gt(ui, [
  Zj,
  eV
]), [tV, Zr] = $0(ui), [nV, xU] = $0(ui), rV = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, value: r, onValueChange: o, defaultValue: a, delayDuration: i = 200, skipDelayDuration: s = 300, orientation: l = "horizontal", dir: c, ...d } = e, [f, p] = we(null), m = De(
    t,
    (E) => p(E)
  ), h = vr(c), g = de(0), x = de(0), y = de(0), [b, v] = we(!0), [A = "", w] = wt({
    prop: r,
    onChange: (E) => {
      const T = E !== "", B = s > 0;
      T ? (window.clearTimeout(y.current), B && v(!1)) : (window.clearTimeout(y.current), y.current = window.setTimeout(
        () => v(!0),
        s
      )), o == null || o(E);
    },
    defaultProp: a
  }), M = me(() => {
    window.clearTimeout(x.current), x.current = window.setTimeout(
      () => w(""),
      150
    );
  }, [
    w
  ]), $ = me((E) => {
    window.clearTimeout(x.current), w(E);
  }, [
    w
  ]), P = me((E) => {
    A === E ? window.clearTimeout(x.current) : g.current = window.setTimeout(() => {
      window.clearTimeout(x.current), w(E);
    }, i);
  }, [
    A,
    w,
    i
  ]);
  return Ce(() => () => {
    window.clearTimeout(g.current), window.clearTimeout(x.current), window.clearTimeout(y.current);
  }, []), /* @__PURE__ */ F(oV, {
    scope: n,
    isRootMenu: !0,
    value: A,
    dir: h,
    orientation: l,
    rootNavigationMenu: f,
    onTriggerEnter: (E) => {
      window.clearTimeout(g.current), b ? P(E) : $(E);
    },
    onTriggerLeave: () => {
      window.clearTimeout(g.current), M();
    },
    onContentEnter: () => window.clearTimeout(x.current),
    onContentLeave: M,
    onItemSelect: (E) => {
      w(
        (T) => T === E ? "" : E
      );
    },
    onItemDismiss: () => w("")
  }, /* @__PURE__ */ F(Ee.nav, K({
    "aria-label": "Main",
    "data-orientation": l,
    dir: h
  }, d, {
    ref: m
  })));
}), oV = (e) => {
  const { scope: t, isRootMenu: n, rootNavigationMenu: r, dir: o, orientation: a, children: i, value: s, onItemSelect: l, onItemDismiss: c, onTriggerEnter: d, onTriggerLeave: f, onContentEnter: p, onContentLeave: m } = e, [h, g] = we(null), [x, y] = we(/* @__PURE__ */ new Map()), [b, v] = we(null);
  return /* @__PURE__ */ F(tV, {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    value: s,
    previousValue: Us(s),
    baseId: xt(),
    dir: o,
    orientation: a,
    viewport: h,
    onViewportChange: g,
    indicatorTrack: b,
    onIndicatorTrackChange: v,
    onTriggerEnter: lt(d),
    onTriggerLeave: lt(f),
    onContentEnter: lt(p),
    onContentLeave: lt(m),
    onItemSelect: lt(l),
    onItemDismiss: lt(c),
    onViewportContentChange: me((A, w) => {
      y((M) => (M.set(A, w), new Map(M)));
    }, []),
    onViewportContentRemove: me((A) => {
      y((w) => w.has(A) ? (w.delete(A), new Map(w)) : w);
    }, [])
  }, /* @__PURE__ */ F(M0.Provider, {
    scope: t
  }, /* @__PURE__ */ F(nV, {
    scope: t,
    items: x
  }, i)));
}, aV = "NavigationMenuList", iV = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, o = Zr(aV, n), a = /* @__PURE__ */ F(Ee.ul, K({
    "data-orientation": o.orientation
  }, r, {
    ref: t
  }));
  return /* @__PURE__ */ F(Ee.div, {
    style: {
      position: "relative"
    },
    ref: o.onIndicatorTrackChange
  }, /* @__PURE__ */ F(M0.Slot, {
    scope: n
  }, o.isRootMenu ? /* @__PURE__ */ F(U8, {
    asChild: !0
  }, a) : a));
}), sV = "NavigationMenuItem", [lV, H8] = $0(sV), cV = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, value: r, ...o } = e, a = xt(), i = r || a || "LEGACY_REACT_AUTO_VALUE", s = de(null), l = de(null), c = de(null), d = de(() => {
  }), f = de(!1), p = me((h = "start") => {
    if (s.current) {
      d.current();
      const g = sd(s.current);
      g.length && P0(h === "start" ? g : g.reverse());
    }
  }, []), m = me(() => {
    if (s.current) {
      const h = sd(s.current);
      h.length && (d.current = vV(h));
    }
  }, []);
  return /* @__PURE__ */ F(lV, {
    scope: n,
    value: i,
    triggerRef: l,
    contentRef: s,
    focusProxyRef: c,
    wasEscapeCloseRef: f,
    onEntryKeyDown: p,
    onFocusProxyEnter: p,
    onRootContentClose: m,
    onContentFocusOutside: m
  }, /* @__PURE__ */ F(Ee.li, K({}, o, {
    ref: t
  })));
}), r2 = "NavigationMenuTrigger", uV = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...o } = e, a = Zr(r2, e.__scopeNavigationMenu), i = H8(r2, e.__scopeNavigationMenu), s = de(null), l = De(s, i.triggerRef, t), c = X8(a.baseId, i.value), d = q8(a.baseId, i.value), f = de(!1), p = de(!1), m = i.value === a.value;
  return /* @__PURE__ */ F(ur, null, /* @__PURE__ */ F(M0.ItemSlot, {
    scope: n,
    value: i.value
  }, /* @__PURE__ */ F(Y8, {
    asChild: !0
  }, /* @__PURE__ */ F(Ee.button, K({
    id: c,
    disabled: r,
    "data-disabled": r ? "" : void 0,
    "data-state": G8(m),
    "aria-expanded": m,
    "aria-controls": d
  }, o, {
    ref: l,
    onPointerEnter: ve(e.onPointerEnter, () => {
      p.current = !1, i.wasEscapeCloseRef.current = !1;
    }),
    onPointerMove: ve(e.onPointerMove, ld(() => {
      r || p.current || i.wasEscapeCloseRef.current || f.current || (a.onTriggerEnter(i.value), f.current = !0);
    })),
    onPointerLeave: ve(e.onPointerLeave, ld(() => {
      r || (a.onTriggerLeave(), f.current = !1);
    })),
    onClick: ve(e.onClick, () => {
      a.onItemSelect(i.value), p.current = m;
    }),
    onKeyDown: ve(e.onKeyDown, (h) => {
      const x = {
        horizontal: "ArrowDown",
        vertical: a.dir === "rtl" ? "ArrowLeft" : "ArrowRight"
      }[a.orientation];
      m && h.key === x && (i.onEntryKeyDown(), h.preventDefault());
    })
  })))), m && /* @__PURE__ */ F(ur, null, /* @__PURE__ */ F(Zg, {
    "aria-hidden": !0,
    tabIndex: 0,
    ref: i.focusProxyRef,
    onFocus: (h) => {
      const g = i.contentRef.current, x = h.relatedTarget, y = x === s.current, b = g == null ? void 0 : g.contains(x);
      (y || !b) && i.onFocusProxyEnter(y ? "start" : "end");
    }
  }), a.viewport && /* @__PURE__ */ F("span", {
    "aria-owns": d
  })));
}), o2 = "navigationMenu.linkSelect", dV = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, active: r, onSelect: o, ...a } = e;
  return /* @__PURE__ */ F(Y8, {
    asChild: !0
  }, /* @__PURE__ */ F(Ee.a, K({
    "data-active": r ? "" : void 0,
    "aria-current": r ? "page" : void 0
  }, a, {
    ref: t,
    onClick: ve(e.onClick, (i) => {
      const s = i.target, l = new CustomEvent(o2, {
        bubbles: !0,
        cancelable: !0
      });
      if (s.addEventListener(
        o2,
        (c) => o == null ? void 0 : o(c),
        {
          once: !0
        }
      ), os(s, l), !l.defaultPrevented && !i.metaKey) {
        const c = new CustomEvent(rs, {
          bubbles: !0,
          cancelable: !0
        });
        os(s, c);
      }
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), Vs = "NavigationMenuContent", fV = /* @__PURE__ */ Y((e, t) => {
  const { forceMount: n, ...r } = e, o = Zr(Vs, e.__scopeNavigationMenu), a = H8(Vs, e.__scopeNavigationMenu), i = De(a.contentRef, t), s = a.value === o.value, l = {
    value: a.value,
    triggerRef: a.triggerRef,
    focusProxyRef: a.focusProxyRef,
    wasEscapeCloseRef: a.wasEscapeCloseRef,
    onContentFocusOutside: a.onContentFocusOutside,
    onRootContentClose: a.onRootContentClose,
    ...r
  };
  return o.viewport ? /* @__PURE__ */ F(pV, K({
    forceMount: n
  }, l, {
    ref: i
  })) : /* @__PURE__ */ F(Bt, {
    present: n || s
  }, /* @__PURE__ */ F(hV, K({
    "data-state": G8(s)
  }, l, {
    ref: i,
    onPointerEnter: ve(e.onPointerEnter, o.onContentEnter),
    onPointerLeave: ve(e.onPointerLeave, ld(o.onContentLeave)),
    style: {
      // Prevent interaction when animating out
      pointerEvents: !s && o.isRootMenu ? "none" : void 0,
      ...l.style
    }
  })));
}), pV = /* @__PURE__ */ Y((e, t) => {
  const n = Zr(Vs, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: o } = n;
  return Mt(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [
    e,
    t,
    r
  ]), Mt(() => () => o(e.value), [
    e.value,
    o
  ]), null;
}), rs = "navigationMenu.rootContentDismiss", hV = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, value: r, triggerRef: o, focusProxyRef: a, wasEscapeCloseRef: i, onRootContentClose: s, onContentFocusOutside: l, ...c } = e, d = Zr(Vs, n), f = de(null), p = De(f, t), m = X8(d.baseId, r), h = q8(d.baseId, r), g = Qj(n), x = de(null), { onItemDismiss: y } = d;
  Ce(() => {
    const v = f.current;
    if (d.isRootMenu && v) {
      const A = () => {
        var w;
        y(), s(), v.contains(document.activeElement) && ((w = o.current) === null || w === void 0 || w.focus());
      };
      return v.addEventListener(rs, A), () => v.removeEventListener(rs, A);
    }
  }, [
    d.isRootMenu,
    e.value,
    o,
    y,
    s
  ]);
  const b = Se(() => {
    const A = g().map(
      (T) => T.value
    );
    d.dir === "rtl" && A.reverse();
    const w = A.indexOf(d.value), M = A.indexOf(d.previousValue), $ = r === d.value, P = M === A.indexOf(r);
    if (!$ && !P)
      return x.current;
    const E = (() => {
      if (w !== M) {
        if ($ && M !== -1)
          return w > M ? "from-end" : "from-start";
        if (P && w !== -1)
          return w > M ? "to-start" : "to-end";
      }
      return null;
    })();
    return x.current = E, E;
  }, [
    d.previousValue,
    d.value,
    d.dir,
    g,
    r
  ]);
  return /* @__PURE__ */ F(U8, {
    asChild: !0
  }, /* @__PURE__ */ F(za, K({
    id: h,
    "aria-labelledby": m,
    "data-motion": b,
    "data-orientation": d.orientation
  }, c, {
    ref: p,
    onDismiss: () => {
      var v;
      const A = new Event(rs, {
        bubbles: !0,
        cancelable: !0
      });
      (v = f.current) === null || v === void 0 || v.dispatchEvent(A);
    },
    onFocusOutside: ve(e.onFocusOutside, (v) => {
      var A;
      l();
      const w = v.target;
      (A = d.rootNavigationMenu) !== null && A !== void 0 && A.contains(w) && v.preventDefault();
    }),
    onPointerDownOutside: ve(e.onPointerDownOutside, (v) => {
      var A;
      const w = v.target, M = g().some((P) => {
        var E;
        return (E = P.ref.current) === null || E === void 0 ? void 0 : E.contains(w);
      }), $ = d.isRootMenu && ((A = d.viewport) === null || A === void 0 ? void 0 : A.contains(w));
      (M || $ || !d.isRootMenu) && v.preventDefault();
    }),
    onKeyDown: ve(e.onKeyDown, (v) => {
      const A = v.altKey || v.ctrlKey || v.metaKey;
      if (v.key === "Tab" && !A) {
        const $ = sd(v.currentTarget), P = document.activeElement, E = $.findIndex(
          (j) => j === P
        ), B = v.shiftKey ? $.slice(0, E).reverse() : $.slice(E + 1, $.length);
        if (P0(B))
          v.preventDefault();
        else {
          var M;
          (M = a.current) === null || M === void 0 || M.focus();
        }
      }
    }),
    onEscapeKeyDown: ve(e.onEscapeKeyDown, (v) => {
      i.current = !0;
    })
  })));
}), mV = "FocusGroup", U8 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, o = Zr(mV, n);
  return /* @__PURE__ */ F(id.Provider, {
    scope: n
  }, /* @__PURE__ */ F(id.Slot, {
    scope: n
  }, /* @__PURE__ */ F(Ee.div, K({
    dir: o.dir
  }, r, {
    ref: t
  }))));
}), a2 = [
  "ArrowRight",
  "ArrowLeft",
  "ArrowUp",
  "ArrowDown"
], gV = "FocusGroupItem", Y8 = /* @__PURE__ */ Y((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, o = Jj(n), a = Zr(gV, n);
  return /* @__PURE__ */ F(id.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ F(Ee.button, K({}, r, {
    ref: t,
    onKeyDown: ve(e.onKeyDown, (i) => {
      if ([
        "Home",
        "End",
        ...a2
      ].includes(i.key)) {
        let l = o().map(
          (f) => f.ref.current
        );
        if ([
          a.dir === "rtl" ? "ArrowRight" : "ArrowLeft",
          "ArrowUp",
          "End"
        ].includes(i.key) && l.reverse(), a2.includes(i.key)) {
          const f = l.indexOf(i.currentTarget);
          l = l.slice(f + 1);
        }
        setTimeout(
          () => P0(l)
        ), i.preventDefault();
      }
    })
  })));
});
function sd(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function P0(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function vV(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function G8(e) {
  return e ? "open" : "closed";
}
function X8(e, t) {
  return `${e}-trigger-${t}`;
}
function q8(e, t) {
  return `${e}-content-${t}`;
}
function ld(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const yV = rV, bV = iV, xV = cV, wU = uV, K8 = dV, AU = fV, wV = nt(["rabbit-ds h-full w-full px-3 py-2 [&>*:first-child]:h-full"], {
  variants: {
    variant: {
      default: ""
    },
    defaultVariant: {
      variant: "default"
    }
  }
});
function AV() {
  return /* @__PURE__ */ u("div", { className: "relative h-full w-full", children: /* @__PURE__ */ I("div", { className: "absolute left-0 top-0 h-full w-full bg-gradient-to-b from-[#E9F5F8] via-[#F7F7F7] to-[#A1E7FC] shadow-[-4px_0px_4px_0px_rgba(0,0,0.05)_inset]", children: [
    /* @__PURE__ */ u(
      "div",
      {
        className: "absolute inset-0 h-full w-full",
        style: {
          background: "linear-gradient(180deg, rgba(231, 244, 247, 0.80) 0%, rgba(185, 239, 254, 0.80) 40%, rgba(136, 226, 252, 0.80) 100%)",
          boxShadow: "-2px 0px 4px rgba(0, 0, 0, 0.05) inset"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        className: "absolute inset-0 h-full w-full mix-blend-darken",
        style: {
          background: "linear-gradient(180deg, #DEEAED 0%, #F6F6F6 40%, #F5F7F7 100%)",
          boxShadow: "-2px 0px 4px rgba(0, 0, 0, 0.05) inset"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        className: "absolute inset-0 h-full w-full mix-blend-hard-light",
        style: {
          background: "linear-gradient(180deg, #DEEAED 0%, #F6F6F6 40%, #F5F7F7 100%)",
          boxShadow: "-4px 0px 4px rgba(0, 0, 0, 0.05) inset"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        className: "absolute inset-0 h-full w-full opacity-60 mix-blend-multiply",
        style: {
          background: "linear-gradient(89deg, #A0E7FC 0%, #A4E8FC 19%, #F5F7F7 100%)",
          boxShadow: "-4px 0px 4px rgba(0, 0, 0, 0.05) inset"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        className: "absolute inset-0 h-full w-full opacity-90 mix-blend-darken",
        style: {
          background: "linear-gradient(180deg, #AAE9FC 0%, #D7F1F8 40%, #F4FDFF 100%)",
          backdropFilter: "blur(4px)"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        className: "absolute inset-0 h-full w-full mix-blend-hard-light",
        style: {
          background: "linear-gradient(87deg, rgba(233, 245, 248, 0.60) 0%, rgba(247, 247, 247, 0.60) 19%, rgba(247, 247, 247, 0.60) 38%, rgba(161, 231, 252, 0.60) 100%)",
          boxShadow: "-4px 0px 4px rgba(0, 0, 0, 0.05) inset"
        }
      }
    )
  ] }) });
}
const CV = Y(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ I("div", { className: "rabbit-ds relative h-screen w-20", children: [
  /* @__PURE__ */ u("div", { className: "absolute h-full w-full", children: /* @__PURE__ */ u(AV, {}) }),
  /* @__PURE__ */ u(yV, { className: le(wV({ className: e })), orientation: "vertical", ref: r, ...n, children: /* @__PURE__ */ u(bV, { className: "m-0 flex h-full flex-col p-0", children: t }) })
] }));
CV.displayName = "LeftNav";
const Q8 = Y(({ children: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ u(xV, { asChild: !0, children: /* @__PURE__ */ u(t ? $n : "div", { ref: r, className: "rabbit-ds", ...n, children: e }) }));
Q8.displayName = "LeftNavItem";
Q8.defaultProps = {
  asChild: !1
};
const SV = nt(["inline-flex w-full flex-col items-center justify-start gap-1"], {
  variants: {
    variant: {
      top: "order-1 mb-auto",
      bottom: "order-2 mt-auto"
    },
    defaultVariant: {
      variant: "top"
    }
  }
}), EV = Y(({ children: e, align: t, ...n }, r) => /* @__PURE__ */ u("div", { ref: r, className: le(SV({ variant: t })), ...n, children: e }));
EV.displayName = "LeftNavItem";
const MV = Y((e, t) => /* @__PURE__ */ u(
  K8,
  {
    ref: t,
    ...e,
    className: "rabbit-ds z-20 flex size-14 h-14 w-14 cursor-pointer items-center justify-center rounded border-none bg-transparent focus:text-primary-focus focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
    children: /* @__PURE__ */ I(
      "svg",
      {
        className: "z-20 h-6 w-6",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ u("g", { clipPath: "url(#clip0_1397_29183)", children: /* @__PURE__ */ I("g", { clipPath: "url(#clip1_1397_29183)", filter: "url(#filter0_d_1397_29183)", children: [
            /* @__PURE__ */ u(
              "path",
              {
                d: "M22.1654 14.8101C22.1654 15.8326 21.3386 16.6614 20.3187 16.6614C19.2988 16.6614 18.472 15.8326 18.472 14.8101C18.472 13.7877 19.2988 12.9589 20.3187 12.9589C21.3386 12.9589 22.1654 13.7877 22.1654 14.8101Z",
                fill: "#008EF0"
              }
            ),
            /* @__PURE__ */ u(
              "path",
              {
                d: "M9.50932 5.28316C9.14769 5.45665 8.74267 5.5538 8.315 5.5538C6.78513 5.5538 5.54492 4.31054 5.54492 2.7769C5.54492 1.24326 6.78513 0 8.315 0C9.84488 0 11.0851 1.24326 11.0851 2.7769C11.0851 3.20559 10.9882 3.6116 10.8151 3.9741L14.3002 7.46776C14.4528 7.42686 14.6131 7.40506 14.7785 7.40506C15.7984 7.40506 16.6253 8.2339 16.6253 9.25633C16.6253 10.2788 15.7984 11.1076 14.7785 11.1076C13.7586 11.1076 12.9318 10.2788 12.9318 9.25633C12.9318 9.09048 12.9536 8.92973 12.9944 8.77678L9.50932 5.28316Z",
                fill: "#008EF0"
              }
            ),
            /* @__PURE__ */ u(
              "path",
              {
                d: "M5.53426 9.24775C5.53426 10.2702 4.70745 11.099 3.68754 11.099C2.66762 11.099 1.84082 10.2702 1.84082 9.24775C1.84082 8.22532 2.66762 7.39648 3.68754 7.39648C4.70745 7.39648 5.53426 8.22532 5.53426 9.24775Z",
                fill: "#FFC200"
              }
            ),
            /* @__PURE__ */ u(
              "path",
              {
                d: "M9.99463 16.5323C9.84207 16.5732 9.68173 16.595 9.5163 16.595C8.49639 16.595 7.66958 15.7661 7.66958 14.7437C7.66958 13.7213 8.49639 12.8924 9.5163 12.8924C10.5362 12.8924 11.363 13.7213 11.363 14.7437C11.363 14.9095 11.3413 15.0703 11.3005 15.2232L14.7855 18.7169C15.1471 18.5434 15.5521 18.4462 15.9798 18.4462C17.5097 18.4462 18.7499 19.6895 18.7499 21.2231C18.7499 22.7568 17.5097 24 15.9798 24C14.4499 24 13.2097 22.7568 13.2097 21.2231C13.2097 20.7944 13.3066 20.3884 13.4797 20.0259L9.99463 16.5323Z",
                fill: "#FFC200"
              }
            ),
            /* @__PURE__ */ u(
              "path",
              {
                d: "M11.087 20.3604C11.087 21.3828 10.2602 22.2117 9.24028 22.2117C8.22036 22.2117 7.39355 21.3828 7.39355 20.3604C7.39355 19.338 8.22036 18.5092 9.24028 18.5092C10.2602 18.5092 11.087 19.338 11.087 20.3604Z",
                fill: "#EC3B64"
              }
            ),
            /* @__PURE__ */ u(
              "path",
              {
                d: "M24.014 8.32719C24.014 9.86083 22.7738 11.1041 21.2439 11.1041C20.8197 11.1041 20.4178 11.0085 20.0584 10.8377L16.5673 14.3374C16.6063 14.4873 16.6271 14.6445 16.6271 14.8066C16.6271 15.8291 15.8003 16.6579 14.7804 16.6579C13.7605 16.6579 12.9337 15.8291 12.9337 14.8066C12.9337 13.7842 13.7605 12.9554 14.7804 12.9554C14.9495 12.9554 15.1134 12.9782 15.269 13.0208L18.748 9.53324C18.5723 9.1685 18.4738 8.75938 18.4738 8.32719C18.4738 6.79355 19.714 5.55029 21.2439 5.55029C22.7738 5.55029 24.014 6.79355 24.014 8.32719Z",
                fill: "#EC3B64"
              }
            ),
            /* @__PURE__ */ u(
              "path",
              {
                d: "M16.6205 3.69746C16.6205 4.71988 15.7937 5.54872 14.7737 5.54872C13.7538 5.54872 12.927 4.71988 12.927 3.69746C12.927 2.67503 13.7538 1.84619 14.7737 1.84619C15.7937 1.84619 16.6205 2.67503 16.6205 3.69746Z",
                fill: "#5CC461"
              }
            ),
            /* @__PURE__ */ u(
              "path",
              {
                d: "M11.0803 9.25125C11.0803 10.2737 10.2535 11.1025 9.23361 11.1025C9.07191 11.1025 8.91506 11.0817 8.7656 11.0425L5.27441 14.5423C5.44482 14.9026 5.54016 15.3055 5.54016 15.7307C5.54016 17.2643 4.29995 18.5076 2.77008 18.5076C1.24021 18.5076 0 17.2643 0 15.7307C0 14.197 1.24021 12.9538 2.77008 12.9538C3.20121 12.9538 3.60934 13.0525 3.97319 13.2287L7.45222 9.74107C7.40963 9.58505 7.38689 9.42081 7.38689 9.25125C7.38689 8.22883 8.21369 7.39999 9.23361 7.39999C10.2535 7.39999 11.0803 8.22883 11.0803 9.25125Z",
                fill: "#5CC461"
              }
            )
          ] }) }),
          /* @__PURE__ */ I("defs", { children: [
            /* @__PURE__ */ I(
              "filter",
              {
                id: "filter0_d_1397_29183",
                x: "-8",
                y: "-6",
                width: "40",
                height: "40",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                  /* @__PURE__ */ u("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                  /* @__PURE__ */ u(
                    "feColorMatrix",
                    {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha"
                    }
                  ),
                  /* @__PURE__ */ u("feOffset", { dy: "2" }),
                  /* @__PURE__ */ u("feGaussianBlur", { stdDeviation: "4" }),
                  /* @__PURE__ */ u("feComposite", { in2: "hardAlpha", operator: "out" }),
                  /* @__PURE__ */ u("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                  /* @__PURE__ */ u("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1397_29183" }),
                  /* @__PURE__ */ u("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_1397_29183", result: "shape" })
                ]
              }
            ),
            /* @__PURE__ */ u("clipPath", { id: "clip0_1397_29183", children: /* @__PURE__ */ u("rect", { width: "24", height: "24", rx: "8", fill: "white" }) }),
            /* @__PURE__ */ u("clipPath", { id: "clip1_1397_29183", children: /* @__PURE__ */ u("rect", { width: "24", height: "24", fill: "white" }) })
          ] })
        ]
      }
    )
  }
));
MV.displayName = "LeftNavHome";
const $V = nt(
  [
    "rabbit-ds relative flex h-14 w-14 items-center justify-center rounded-lg font-sans text-[10px] text-font-secondary transition-colors disabled:pointer-events-none",
    "hover:bg-card-bg-hover hover:font-semibold hover:text-primary-hover",
    "focus:bg-card-bg-focus focus:font-semibold focus:text-primary-focus focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
    "active:bg-card-bg-focus active:font-semibold active:text-primary-focus",
    "is-active:bg-card-bg-focus is-active:font-semibold is-active:text-primary-focus"
  ],
  {
    variants: {
      variant: {
        default: "",
        withNotification: "",
        withMenu: "",
        gradient: ""
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), PV = nt("", {
  variants: {
    variant: {
      default: "",
      gradient: "bg-[linear-gradient(90deg,#038EEF_9.05%,#ED3C65_86.39%)] text-transparent [-webkit-background-clip:text] [background-clip:text]"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), TV = Y(
  ({ className: e, variant: t, badgeText: n, icon: r, iconSize: o, isActive: a = !1, children: i, ...s }, l) => /* @__PURE__ */ u("div", { className: "rabbit-ds", children: /* @__PURE__ */ I(
    K8,
    {
      "data-deer-btn": !0,
      className: le($V({ variant: t, className: e })),
      ref: l,
      "data-active": a,
      ...s,
      children: [
        /* @__PURE__ */ I("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ I("div", { className: "relative flex items-center justify-center", children: [
            /* @__PURE__ */ u(Fe, { IconSVG: r, size: "large" }),
            t === "withNotification" && /* @__PURE__ */ I("div", { className: "absolute left-3 flex h-5 w-6 items-center justify-center rounded-xl bg-functional-warn px-2 text-xs text-white", children: [
              /* @__PURE__ */ u("span", { className: "sr-only", children: "Notification" }),
              n
            ] })
          ] }),
          /* @__PURE__ */ u("div", { className: le(PV({ variant: t === "gradient" ? t : "default" }), "text-xs"), children: i })
        ] }),
        t === "withMenu" && /* @__PURE__ */ u("div", { className: "absolute right-0 flex h-14 w-3 items-center justify-center", children: /* @__PURE__ */ u(Fe, { IconSVG: u6, size: "large" }) })
      ]
    }
  ) })
);
TV.displayName = "LeftNavButton";
const OV = nt(
  "cursor-pointer border border-solid border-[#CFD7DF] bg-[#F5F7F9] px-1 py-[2px] text-primary transition-all hover:border-primary-hover hover:bg-primary-hover hover:text-white",
  {
    variants: {
      variant: {
        default: "rounded-l-full border-r-0",
        collapsed: "rounded-r-full border-l-0"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function NV({ className: e, isCollapsed: t, ...n }) {
  return /* @__PURE__ */ u(
    "button",
    {
      "data-deer-btn": !0,
      type: "button",
      className: le(OV({ variant: t ? "collapsed" : "default" }), e),
      ...n,
      children: /* @__PURE__ */ u(Fe, { IconSVG: Lb, className: t ? "rotate-180" : "" })
    }
  );
}
const Z8 = tn({
  isOpen: !1,
  toggleOpen: () => {
  }
}), kV = () => Xe(Z8);
function DV({ ...e }) {
  const { isOpen: t, toggleOpen: n } = kV();
  return /* @__PURE__ */ u(
    NV,
    {
      className: `absolute right-0 top-5 z-20 ${t ? "" : "translate-x-full"}`,
      isCollapsed: !t,
      onClick: n,
      ...e
    }
  );
}
function CU(e) {
  const { children: t, defaultOpen: n = !1 } = e, r = e.open !== void 0, [o, a] = we(n), i = me(() => {
    a((d) => !d);
  }, []), s = r ? e.open : o, l = r ? e.onToggle : i, c = Se(
    () => ({ isOpen: s, toggleOpen: l }),
    [s, l]
  );
  return /* @__PURE__ */ u(Z8.Provider, { value: c, children: /* @__PURE__ */ I(
    "div",
    {
      className: le(
        "rabbit-ds relative h-screen transition-all",
        s ? "w-full" : "w-0",
        "shadow-[-8px_-2px_8px_0px_rgba(0,0,0,0.08)_inset]"
      ),
      style: {
        background: "linear-gradient(273deg, #E7EFF1 0%, #EEF5F8 11%, #EFFAFE 100%)"
      },
      children: [
        /* @__PURE__ */ u(DV, {}),
        /* @__PURE__ */ u("div", { className: s ? "h-full p-5" : "invisible h-0 w-0 scale-0 overflow-hidden opacity-0", children: t })
      ]
    }
  ) });
}
function SU({ children: e }) {
  return /* @__PURE__ */ u(
    "div",
    {
      className: le(
        "nav-group flex flex-col gap-1",
        "after:h-[1px] after:bg-accent after:w-full after:my-4 last:after:hidden"
      ),
      children: e
    }
  );
}
function EU({ children: e }) {
  return /* @__PURE__ */ u("div", { className: "p-2 text-xs font-semibold text-font-secondary", children: e });
}
function MU({ children: e, ...t }) {
  return /* @__PURE__ */ u(QS, { ...t, children: e });
}
const FV = nt("max-w-[28%] shrink-0", {
  variants: {
    orientation: {
      horizontal: "ml-2",
      vertical: "mt-2 w-full [&>div]:w-full [&_button]:w-full"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
});
function $U({ className: e, orientation: t, ...n }) {
  return /* @__PURE__ */ u("div", { className: FV({ orientation: t }), children: /* @__PURE__ */ u(nn, { className: le(e, "min-h-10 h-auto"), variant: "transparentOutline", ...n }) });
}
const RV = {
  ON_TRACK: {
    label: "On-track",
    colorScheme: "tag-green"
  },
  OFF_TRACK: {
    label: "Off-track",
    colorScheme: "tag-yellow"
  },
  AT_RISK: {
    label: "At-risk",
    colorScheme: "tag-red"
  },
  CLOSED: {
    label: "Closed",
    colorScheme: "tag-darkGray"
  },
  NOT_STARTED: {
    label: "Not started",
    colorScheme: "tag-lightGray"
  }
}, _V = RV, PU = Y(function({ title: t, achieved: n, status: r, explanation: o, truncateExplanation: a = !0 }, i) {
  const s = _V[r];
  return /* @__PURE__ */ u("div", { ref: i, className: le("rabbit-ds", "mr-auto", a ? "w-[70%]" : ""), children: /* @__PURE__ */ I("div", { className: "flex w-full flex-col gap-1", children: [
    /* @__PURE__ */ I("div", { className: "mt-1 flex items-center ", children: [
      /* @__PURE__ */ u(Fe, { "aria-hidden": !0, size: "small", className: "text-font-secondary", IconSVG: l6 }),
      /* @__PURE__ */ u("div", { className: "ml-1 text-sm", children: t })
    ] }),
    /* @__PURE__ */ I("div", { className: "my-1 flex items-end gap-[18px]", children: [
      /* @__PURE__ */ I("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ u("span", { className: "text-xs text-font-secondary", children: "Achieved" }),
        /* @__PURE__ */ I("span", { className: le(s.colorScheme, "font-semibold text-3xl !bg-transparent"), children: [
          n,
          "%"
        ] })
      ] }),
      /* @__PURE__ */ u(uM, { colorScheme: s.colorScheme, className: "mb-1", children: s.label })
    ] }),
    o && /* @__PURE__ */ I("div", { className: le("flex w-full gap-1", a ? "items-center" : "items-start"), children: [
      /* @__PURE__ */ u(Fe, { "aria-hidden": !0, size: "small", className: "text-font-secondary", IconSVG: La }),
      /* @__PURE__ */ u("span", { className: le("w-full text-xs text-font-secondary", a ? "truncate" : ""), children: o })
    ] })
  ] }) });
});
function TU({
  employeeName: e,
  employeeProfilePhoto: t,
  reviewCycleName: n,
  reviewType: r,
  dueBy: o
}) {
  return /* @__PURE__ */ u("div", { className: "rabbit-ds mr-auto", children: /* @__PURE__ */ I("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ u(Hn, { size: "xl", children: /* @__PURE__ */ u(Un, { src: t, alt: "Avatar" }) }),
    /* @__PURE__ */ I("div", { className: "flex flex-col items-start text-sm", children: [
      /* @__PURE__ */ I("div", { className: "flex w-full gap-1", children: [
        /* @__PURE__ */ I("span", { className: "font-semibold", children: [
          e,
          " • "
        ] }),
        /* @__PURE__ */ u("span", { className: "text-sm text-font-secondary", children: r })
      ] }),
      /* @__PURE__ */ I("div", { className: "flex w-full gap-1", children: [
        /* @__PURE__ */ I("span", { className: "text-font-secondary", children: [
          n,
          " • "
        ] }),
        /* @__PURE__ */ I("span", { className: "text-font-secondary", children: [
          "Due by ",
          o
        ] })
      ] })
    ] })
  ] }) });
}
function OU({ employeeName: e, employeeProfilePhoto: t, designation: n }) {
  return /* @__PURE__ */ u("div", { className: "rabbit-ds mr-auto", children: /* @__PURE__ */ I("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ u(Hn, { size: "xl", children: /* @__PURE__ */ u(Un, { src: t, alt: "Avatar" }) }),
    /* @__PURE__ */ I("div", { className: "flex flex-col items-start text-sm", children: [
      /* @__PURE__ */ u("span", { className: "font-semibold", children: e }),
      /* @__PURE__ */ u("span", { className: "text-font-secondary", children: n })
    ] })
  ] }) });
}
const IV = Y(
  ({ employeeName: e, employeeProfilePhoto: t, designation: n, requestReason: r, truncateExplanation: o = !0 }, a) => /* @__PURE__ */ u("div", { ref: a, className: le("rabbit-ds mr-auto", o ? "w-[65%]" : ""), children: /* @__PURE__ */ I("div", { className: "flex w-full gap-2", children: [
    /* @__PURE__ */ u(Hn, { size: "xl", children: /* @__PURE__ */ u(Un, { src: t, alt: "Avatar" }) }),
    /* @__PURE__ */ I("div", { className: "flex w-full flex-col items-start text-sm", children: [
      /* @__PURE__ */ I("div", { className: "flex w-full gap-1", children: [
        /* @__PURE__ */ I("span", { className: "font-semibold", children: [
          e,
          " • "
        ] }),
        /* @__PURE__ */ u("span", { className: "text-sm text-font-secondary", children: n })
      ] }),
      /* @__PURE__ */ I("div", { className: le("mt-1 flex w-full gap-1", o ? "items-center" : "items-start"), children: [
        /* @__PURE__ */ u(Fe, { "aria-hidden": !0, size: "small", className: "text-font-secondary", IconSVG: La }),
        /* @__PURE__ */ u("span", { className: le("w-full text-xs text-font-secondary", o ? "truncate" : ""), children: r })
      ] })
    ] })
  ] }) })
);
IV.displayName = "RequestedFeedbackNudgeData";
const LV = nt("", {
  variants: {
    orientation: {
      horizontal: "flex-row",
      vertical: "min-w-max flex-col"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
});
function NU({ className: e, children: t, orientation: n }) {
  return /* @__PURE__ */ u(
    "div",
    {
      className: le(
        "rabbit-ds",
        "w-full flex items-center rounded-lg p-2 bg-[#FDFDFD] border border-solid border-[#F3F5F8]",
        LV({ orientation: n }),
        e
      ),
      children: t
    }
  );
}
function kU({
  nudgeCardList: e,
  title: t,
  imgSrc: n,
  description: r,
  pageSize: o = 3,
  kebabMenu: a,
  variant: i = "default"
}) {
  const [s, l] = we(1), c = e.slice(0, o * s), d = e.length > o, f = e.length === c.length, p = i === "informational", m = () => {
    l((h) => f ? 1 : h + 1);
  };
  return /* @__PURE__ */ I(
    "div",
    {
      className: le(
        "rabbit-ds",
        "w-full flex flex-col items-start rounded-lg px-4 py-3 gap-[7px] bg-white shadow-[0px_0px_2px_0px_rgba(0,0,0,0.24)]"
      ),
      children: [
        /* @__PURE__ */ I("div", { className: "flex w-full items-start justify-between", children: [
          /* @__PURE__ */ I("div", { className: "mt-1 flex items-center gap-4", children: [
            n ? /* @__PURE__ */ u(Hn, { className: "h-16 w-16", children: /* @__PURE__ */ u(Un, { src: n, alt: t }) }) : null,
            p ? /* @__PURE__ */ u("div", { className: "flex flex-col gap-[7px]", children: c }) : /* @__PURE__ */ I("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ u("span", { className: "text-sm font-semibold", children: t }),
              /* @__PURE__ */ u("span", { className: "text-sm", children: r })
            ] })
          ] }),
          a
        ] }),
        !p && c,
        d && /* @__PURE__ */ u("div", { className: "mx-auto", children: /* @__PURE__ */ I(nn, { variant: "text", onClick: m, iconRight: f ? Fb : Ia, children: [
          "View ",
          f ? "less" : "more"
        ] }) })
      ]
    }
  );
}
function DU({ surveyName: e, date: t }) {
  return /* @__PURE__ */ u("div", { className: "rabbit-ds mr-auto", children: /* @__PURE__ */ I("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ u(Fe, { IconSVG: A6 }),
    /* @__PURE__ */ I("div", { className: "flex flex-col items-start text-sm", children: [
      /* @__PURE__ */ u("span", { className: "font-semibold", children: e }),
      /* @__PURE__ */ u(jm, { date: t, showRelativeTime: !0 })
    ] })
  ] }) });
}
const BV = Y(function({
  employeeProfilePhoto: t,
  employeeName: n,
  scheduleDate: r,
  duration: o,
  subTitle: a,
  explanation: i,
  truncateExplanation: s = !0
}, l) {
  return /* @__PURE__ */ u("div", { ref: l, className: le("rabbit-ds", "mr-auto", s ? "w-[70%]" : ""), children: /* @__PURE__ */ I("div", { className: le("flex items-center text-sm gap-2", "flex-row [&>div]:items-start"), children: [
    /* @__PURE__ */ u(Hn, { size: "xl", children: /* @__PURE__ */ u(Un, { src: t, alt: n }) }),
    /* @__PURE__ */ I("div", { className: "flex w-full flex-col items-center gap-1", children: [
      /* @__PURE__ */ I("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ I("span", { className: "font-semibold", children: [
          n,
          " • "
        ] }),
        r ? /* @__PURE__ */ u(
          jm,
          {
            date: r,
            duration: o,
            timeFormat: "HH:mm a",
            showTime: !0,
            className: "text-font-secondary"
          }
        ) : /* @__PURE__ */ u("span", { className: "font-semibold", style: { color: "#C62C02" }, children: a })
      ] }),
      i && /* @__PURE__ */ I("div", { className: le("flex w-[90%] gap-1", s ? "items-center" : "items-start"), children: [
        /* @__PURE__ */ u(Fe, { "aria-hidden": !0, size: "small", className: "text-font-secondary", IconSVG: La }),
        /* @__PURE__ */ u("span", { className: le("w-full text-xs text-font-secondary", s ? "truncate" : ""), children: i })
      ] })
    ] })
  ] }) });
});
BV.defaultProps = {
  subTitle: void 0,
  scheduleDate: void 0
};
function zV({ label: e, onClick: t, customCompProps: n }) {
  const [r, o] = we(1);
  return /* @__PURE__ */ I(GS, { children: [
    /* @__PURE__ */ u(Ug, { children: /* @__PURE__ */ u("span", { children: e }) }),
    /* @__PURE__ */ u(YS, { children: /* @__PURE__ */ u(Yg, { children: /* @__PURE__ */ u(sl, { children: /* @__PURE__ */ I("div", { className: "flex flex-col p-2", children: [
      /* @__PURE__ */ u(j6, { htmlFor: n == null ? void 0 : n.label, className: "text-xs", children: n == null ? void 0 : n.label }),
      /* @__PURE__ */ u(
        B6,
        {
          id: n == null ? void 0 : n.label,
          className: "mt-2 !min-w-[160px]",
          type: "number",
          value: r,
          onChange: (a) => o(a.target.valueAsNumber),
          min: 1
        }
      ),
      /* @__PURE__ */ u("div", { className: "flex justify-end", children: /* @__PURE__ */ u(nn, { className: "mt-2", onClick: () => t(r), disabled: r < 1 || Number.isNaN(r), children: n == null ? void 0 : n.buttonText }) })
    ] }) }) }) })
  ] });
}
function FU({ options: e }) {
  const [t, n] = we(!1), r = (o, a) => {
    o(a), n(!1);
  };
  return /* @__PURE__ */ I(jg, { open: t, children: [
    /* @__PURE__ */ u(Vg, { asChild: !0, onClick: () => n(!0), children: /* @__PURE__ */ u(nn, { variant: "text", size: "smallIcon", children: /* @__PURE__ */ u(Fe, { IconSVG: r6 }) }) }),
    /* @__PURE__ */ u(
      Hd,
      {
        className: "w-56",
        onFocusOutside: () => n(!1),
        onPointerDownOutside: () => n(!1),
        children: /* @__PURE__ */ u(sl, { children: e.map(
          ({ type: o, onClick: a, label: i, customCompProps: s }) => !o || o === "default" ? /* @__PURE__ */ u(Ud, { onClick: () => r(a), children: /* @__PURE__ */ u("span", { children: i }) }, i) : /* @__PURE__ */ u(
            zV,
            {
              onClick: (l) => r(a, l),
              label: i,
              customCompProps: s
            },
            i
          )
        ) })
      }
    )
  ] });
}
const WV = Ud, jV = sl, VV = Hg, HV = qg, UV = Gg, YV = Xg, GV = Y(({ className: e, children: t, align: n = "end", ...r }, o) => /* @__PURE__ */ u(Hd, { ref: o, align: n, ...r, children: t }));
GV.displayName = "SplitButtonDropdownContent";
const XV = nt("", {
  variants: {
    size: {
      normal: "icon",
      small: "smallIcon",
      icon: "icon",
      smallIcon: "smallIcon",
      nav: "icon"
    }
  },
  defaultVariants: {
    size: "normal"
  }
});
function RU({ children: e, size: t, status: n, variant: r, ...o }) {
  return /* @__PURE__ */ u("div", { className: "rabbit-ds flex flex-row", children: /* @__PURE__ */ I(jg, { children: [
    /* @__PURE__ */ u(nn, { variant: r, status: n, size: t, ...o, className: "rounded-r-none", children: e }),
    /* @__PURE__ */ u(Vg, { asChild: !0, children: /* @__PURE__ */ u(
      nn,
      {
        variant: r,
        status: n,
        className: "rounded-l-none border-l-0",
        size: XV({ size: t }),
        iconLeft: Ia
      }
    ) })
  ] }) });
}
WV.displayName = "SplitButtonDropdownItem";
jV.displayName = "SplitButtonDropdownGroup";
VV.displayName = "SplitButtonDropdownRadioGroup";
HV.displayName = "SplitButtonDropdownLabel";
UV.displayName = "SplitButtonDropdownCheckboxItem";
YV.displayName = "SplitButtonDropdownRadioItem";
export {
  r9 as Accordion,
  i9 as AccordionContent,
  o9 as AccordionItem,
  a9 as AccordionTrigger,
  JV as Add,
  l9 as Alert,
  u9 as AlertDescription,
  rw as AlertDialogAction,
  nw as AlertDialogCancel,
  IH as AlertDialogComponent,
  ew as AlertDialogContainer,
  Pm as AlertDialogContent,
  Om as AlertDialogDescription,
  $m as AlertDialogOverlay,
  tw as AlertDialogPortal,
  Tm as AlertDialogTitle,
  ow as AlertDialogTrigger,
  c9 as AlertIcon,
  Hn as Avatar,
  Yd as AvatarBadge,
  Pd as AvatarFallback,
  Zv as AvatarGroup,
  Un as AvatarImage,
  a$ as Breadcrumb,
  d$ as BreadcrumbEllipsis,
  s$ as BreadcrumbItem,
  l$ as BreadcrumbLink,
  i$ as BreadcrumbList,
  c$ as BreadcrumbPage,
  u$ as BreadcrumbSeparator,
  nn as Button,
  eH as Calendar,
  _m as Caption,
  Qs as Card,
  V2 as CardContent,
  z7 as CardDescription,
  B7 as CardHeader,
  rU as CardKPI,
  j2 as CardTitle,
  oU as Carousel,
  aU as CarouselContainer,
  sU as CarouselNextButton,
  iU as CarouselPrevButton,
  Ys as Check,
  Eb as CheckCircleOutline,
  md as Checkbox,
  Ia as ChevronDown,
  tH as ChevronLeft,
  Tb as ChevronLeftCircle,
  hd as ChevronRight,
  kb as ChevronRightCircle,
  Fb as ChevronUp,
  TH as Chip,
  vU as ChipGroup,
  yU as ChipGroupItem,
  _b as Close,
  Lb as CollapseNavigation,
  DH as CollapsibleCard,
  zb as ColumnFilter,
  E6 as ColumnFilterCheck,
  nH as Company,
  jm as DateTime,
  rH as Develop,
  Ij as DirectedLineChart,
  fU as DonutChart,
  oH as Download,
  jg as Dropdown,
  Gg as DropdownCheckboxItem,
  qS as DropdownChip,
  Hd as DropdownContent,
  sl as DropdownGroup,
  Ud as DropdownItem,
  qg as DropdownLabel,
  YS as DropdownPortal,
  Hg as DropdownRadioGroup,
  Xg as DropdownRadioItem,
  XS as DropdownSeparator,
  GS as DropdownSub,
  Yg as DropdownSubContent,
  Ug as DropdownSubTrigger,
  Vg as DropdownTrigger,
  aH as Engagement,
  DU as EngagementNudgeData,
  X0 as ErrorOutline,
  iH as ExpandDown,
  Xb as ExpandRight,
  sH as Feedback,
  lH as Gear,
  cH as Goal,
  PU as GoalsNudgeData,
  jj as GridChart,
  mU as GridDirectedLineChart,
  uH as Help,
  dU as HistogramChart,
  dH as Home,
  JH as HoverCard,
  rP as HoverCardContent,
  tU as HoverCardPortal,
  eU as HoverCardTrigger,
  Fe as Icon,
  La as InfoWorkZero,
  fH as Initiatives,
  B6 as Input,
  r6 as KebabMenu,
  BV as KnowTeamNudgeData,
  j6 as Label,
  CV as LeftNav,
  TV as LeftNavButton,
  EV as LeftNavGroup,
  MV as LeftNavHome,
  Q8 as LeftNavItem,
  AU as LeftNavItemContent,
  jg as LeftNavItemDropdown,
  Gg as LeftNavItemDropdownCheckboxItem,
  Hd as LeftNavItemDropdownContent,
  sl as LeftNavItemDropdownGroup,
  Ud as LeftNavItemDropdownItem,
  qg as LeftNavItemDropdownLabel,
  YS as LeftNavItemDropdownPortal,
  Hg as LeftNavItemDropdownRadioGroup,
  Xg as LeftNavItemDropdownRadioItem,
  XS as LeftNavItemDropdownSeparator,
  GS as LeftNavItemDropdownSub,
  Yg as LeftNavItemDropdownSubContent,
  Ug as LeftNavItemDropdownSubTrigger,
  Vg as LeftNavItemDropdownTrigger,
  wU as LeftNavItemTrigger,
  cU as LineChart,
  QS as ListItem,
  jH as ListItemIcon,
  WH as ListItemText,
  pH as Manager,
  hH as ManagerWithBorder,
  $6 as MeshLogo,
  CH as MeshMaven,
  SH as MeshMavenAsk,
  EH as MeshMavenDisabledThumbsUp,
  MH as MeshMavenWithHording,
  $H as MeshMavenWithOrangeBulb,
  PH as MeshMavenWithThumbsUp,
  lP as Metric,
  sP as MetricCard,
  e3 as MetricCardStatText,
  lf as MetricCardText,
  cP as MetricCardTitle,
  mH as MyOneOnOne,
  DV as NavCollapseButtonL2,
  SU as NavGroupL2,
  EU as NavGroupTitleL2,
  MU as NavItemL2,
  CU as NavL2,
  $U as NudgeAction,
  kU as NudgeCard,
  NU as NudgeCardItem,
  FU as NudgeKebabMenu,
  l6 as Objective,
  u6 as Overflow,
  gH as Person,
  vH as Product,
  t3 as ProfileCard,
  dP as ProfileCardItem,
  fP as ProfileCardKey,
  pP as ProfileCardValue,
  r7 as ProgressBar,
  nU as ProgressInfo,
  kH as ProgressSlider,
  pU as RadarChart,
  yH as RequestFeedback,
  IV as RequestedFeedbackNudgeData,
  bH as Reviews,
  TU as ReviewsNudgeData,
  xH as Role,
  uU as SankeyChart,
  v6 as Search,
  HH as Select,
  WE as SelectContent,
  UH as SelectGroup,
  VE as SelectItem,
  jE as SelectLabel,
  HE as SelectSeparator,
  zE as SelectTrigger,
  YH as SelectValue,
  wH as ShareFeedback,
  OU as SharePraiseNudgeData,
  x6 as SliderDrag,
  RU as SplitButton,
  UV as SplitButtonDropdownCheckboxItem,
  GV as SplitButtonDropdownContent,
  jV as SplitButtonDropdownGroup,
  WV as SplitButtonDropdownItem,
  HV as SplitButtonDropdownLabel,
  VV as SplitButtonDropdownRadioGroup,
  YV as SplitButtonDropdownRadioItem,
  hU as StackedBarChart,
  A6 as Survey,
  nM as Tabs,
  lM as TabsContent,
  oM as TabsList,
  iM as TabsTrigger,
  uM as Tag,
  AH as Team,
  QH as Toaster,
  Cv as Tooltip,
  ef as TooltipContent,
  Ev as TooltipPortal,
  Av as TooltipProvider,
  Sv as TooltipTrigger,
  R6 as TrendingDown,
  I6 as TrendingUp,
  hw as getInitialsFromName,
  KH as toast
};
